export const postalCodes = [
  {
    municipality: 'Aach',
    postalCode: '78267'
  },
  {
    municipality: 'Aach',
    postalCode: '54298'
  },
  {
    municipality: 'Aachen',
    postalCode: '52062'
  },
  {
    municipality: 'Aachen',
    postalCode: '52064'
  },
  {
    municipality: 'Aachen',
    postalCode: '52066'
  },
  {
    municipality: 'Aachen',
    postalCode: '52068'
  },
  {
    municipality: 'Aachen',
    postalCode: '52070'
  },
  {
    municipality: 'Aachen',
    postalCode: '52072'
  },
  {
    municipality: 'Aachen',
    postalCode: '52074'
  },
  {
    municipality: 'Aachen',
    postalCode: '52076'
  },
  {
    municipality: 'Aachen',
    postalCode: '52078'
  },
  {
    municipality: 'Aachen',
    postalCode: '52080'
  },
  {
    municipality: 'Aalen',
    postalCode: '73430'
  },
  {
    municipality: 'Aalen',
    postalCode: '73431'
  },
  {
    municipality: 'Aalen',
    postalCode: '73432'
  },
  {
    municipality: 'Aalen',
    postalCode: '73433'
  },
  {
    municipality: 'Aalen',
    postalCode: '73434'
  },
  {
    municipality: 'Aarbergen',
    postalCode: '65326'
  },
  {
    municipality: 'Aasbüttel',
    postalCode: '25560'
  },
  {
    municipality: 'Abenberg',
    postalCode: '91183'
  },
  {
    municipality: 'Abensberg',
    postalCode: '93326'
  },
  {
    municipality: 'Abentheuer',
    postalCode: '55767'
  },
  {
    municipality: 'Absberg',
    postalCode: '91720'
  },
  {
    municipality: 'Abstatt',
    postalCode: '74232'
  },
  {
    municipality: 'Abtsbessingen',
    postalCode: '99713'
  },
  {
    municipality: 'Abtsgmünd',
    postalCode: '73453'
  },
  {
    municipality: 'Abtsteinach',
    postalCode: '69518'
  },
  {
    municipality: 'Abtswind',
    postalCode: '97355'
  },
  {
    municipality: 'Abtweiler',
    postalCode: '55568'
  },
  {
    municipality: 'Achberg',
    postalCode: '88147'
  },
  {
    municipality: 'Achern',
    postalCode: '77855'
  },
  {
    municipality: 'Achim',
    postalCode: '28832'
  },
  {
    municipality: 'Achslach',
    postalCode: '94250'
  },
  {
    municipality: 'Achstetten',
    postalCode: '88480'
  },
  {
    municipality: 'Acht',
    postalCode: '56729'
  },
  {
    municipality: 'Achtelsbach',
    postalCode: '55767'
  },
  {
    municipality: 'Achterwehr',
    postalCode: '24239'
  },
  {
    municipality: 'Achtrup',
    postalCode: '25917'
  },
  {
    municipality: 'Adelberg',
    postalCode: '73099'
  },
  {
    municipality: 'Adelebsen',
    postalCode: '37139'
  },
  {
    municipality: 'Adelheidsdorf',
    postalCode: '29352'
  },
  {
    municipality: 'Adelmannsfelden',
    postalCode: '73486'
  },
  {
    municipality: 'Adelschlag',
    postalCode: '85111'
  },
  {
    municipality: 'Adelsdorf',
    postalCode: '91325'
  },
  {
    municipality: 'Adelsheim',
    postalCode: '74740'
  },
  {
    municipality: 'Adelshofen',
    postalCode: '91587'
  },
  {
    municipality: 'Adelshofen',
    postalCode: '82276'
  },
  {
    municipality: 'Adelsried',
    postalCode: '86477'
  },
  {
    municipality: 'Adelzhausen',
    postalCode: '86559'
  },
  {
    municipality: 'Adenau',
    postalCode: '53518'
  },
  {
    municipality: 'Adenbach',
    postalCode: '67742'
  },
  {
    municipality: 'Adenbüttel',
    postalCode: '38528'
  },
  {
    municipality: 'Adendorf',
    postalCode: '21365'
  },
  {
    municipality: 'Adlkofen',
    postalCode: '84166'
  },
  {
    municipality: 'Admannshagen-Bargeshagen',
    postalCode: '18211'
  },
  {
    municipality: 'Adorf/Vogtland',
    postalCode: '08626'
  },
  {
    municipality: 'Aebtissinwisch',
    postalCode: '25572'
  },
  {
    municipality: 'Aerzen',
    postalCode: '31855'
  },
  {
    municipality: 'Affalterbach',
    postalCode: '71563'
  },
  {
    municipality: 'Affing',
    postalCode: '86444'
  },
  {
    municipality: 'Affinghausen',
    postalCode: '27257'
  },
  {
    municipality: 'Affler',
    postalCode: '54689'
  },
  {
    municipality: 'Agathenburg',
    postalCode: '21684'
  },
  {
    municipality: 'Agethorst',
    postalCode: '25560'
  },
  {
    municipality: 'Aglasterhausen',
    postalCode: '74858'
  },
  {
    municipality: 'Aham',
    postalCode: '84168'
  },
  {
    municipality: 'Ahaus',
    postalCode: '48683'
  },
  {
    municipality: 'Ahausen',
    postalCode: '27367'
  },
  {
    municipality: 'Ahlbeck',
    postalCode: '17375'
  },
  {
    municipality: 'Ahlden',
    postalCode: '29693'
  },
  {
    municipality: 'Ahlefeld-Bistensee',
    postalCode: '24358'
  },
  {
    municipality: 'Ahlen',
    postalCode: '59227'
  },
  {
    municipality: 'Ahlen',
    postalCode: '59229'
  },
  {
    municipality: 'Ahlerstedt',
    postalCode: '21702'
  },
  {
    municipality: 'Ahlsdorf',
    postalCode: '06313'
  },
  {
    municipality: 'Ahlstädt',
    postalCode: '98553'
  },
  {
    municipality: 'Ahnatal',
    postalCode: '34292'
  },
  {
    municipality: 'Ahneby',
    postalCode: '24996'
  },
  {
    municipality: 'Ahnsbeck',
    postalCode: '29353'
  },
  {
    municipality: 'Ahnsen',
    postalCode: '31708'
  },
  {
    municipality: 'Aholfing',
    postalCode: '94345'
  },
  {
    municipality: 'Aholming',
    postalCode: '94527'
  },
  {
    municipality: 'Ahorn',
    postalCode: '74744'
  },
  {
    municipality: 'Ahorn',
    postalCode: '96482'
  },
  {
    municipality: 'Ahorntal',
    postalCode: '95491'
  },
  {
    municipality: 'Ahrbrück',
    postalCode: '53506'
  },
  {
    municipality: 'Ahrensbök',
    postalCode: '23623'
  },
  {
    municipality: 'Ahrensburg',
    postalCode: '22926'
  },
  {
    municipality: 'Ahrensfelde',
    postalCode: '16356'
  },
  {
    municipality: 'Ahrenshagen-Daskow',
    postalCode: '18320'
  },
  {
    municipality: 'Ahrenshöft',
    postalCode: '25853'
  },
  {
    municipality: 'Ahrenshoop',
    postalCode: '18347'
  },
  {
    municipality: 'Ahrenviöl',
    postalCode: '25885'
  },
  {
    municipality: 'Ahrenviölfeld',
    postalCode: '24896'
  },
  {
    municipality: 'Ahrenviölfeld',
    postalCode: '25885'
  },
  {
    municipality: 'Aichach',
    postalCode: '86551'
  },
  {
    municipality: 'Aicha vorm Wald',
    postalCode: '94529'
  },
  {
    municipality: 'Aichelberg',
    postalCode: '73101'
  },
  {
    municipality: 'Aichen',
    postalCode: '86479'
  },
  {
    municipality: 'Aichhalden',
    postalCode: '78733'
  },
  {
    municipality: 'Aichstetten',
    postalCode: '88317'
  },
  {
    municipality: 'Aichtal',
    postalCode: '72631'
  },
  {
    municipality: 'Aichwald',
    postalCode: '73773'
  },
  {
    municipality: 'Aidenbach',
    postalCode: '94501'
  },
  {
    municipality: 'Aidhausen',
    postalCode: '97491'
  },
  {
    municipality: 'Aidlingen',
    postalCode: '71134'
  },
  {
    municipality: 'Aiglsbach',
    postalCode: '84089'
  },
  {
    municipality: 'Ailertchen',
    postalCode: '56459'
  },
  {
    municipality: 'Aindling',
    postalCode: '86447'
  },
  {
    municipality: 'Ainring',
    postalCode: '83404'
  },
  {
    municipality: 'Aislingen',
    postalCode: '89344'
  },
  {
    municipality: 'Aiterhofen',
    postalCode: '94330'
  },
  {
    municipality: 'Aitern',
    postalCode: '79677'
  },
  {
    municipality: 'Aitrach',
    postalCode: '88319'
  },
  {
    municipality: 'Aitrang',
    postalCode: '87648'
  },
  {
    municipality: 'Aken (Elbe)',
    postalCode: '06385'
  },
  {
    municipality: 'Aken (Elbe)',
    postalCode: '06386'
  },
  {
    municipality: 'Aland',
    postalCode: '39615'
  },
  {
    municipality: 'Albaching',
    postalCode: '83544'
  },
  {
    municipality: 'Albbruck',
    postalCode: '79774'
  },
  {
    municipality: 'Albersdorf',
    postalCode: '25767'
  },
  {
    municipality: 'Albersdorf',
    postalCode: '07646'
  },
  {
    municipality: 'Albershausen',
    postalCode: '73095'
  },
  {
    municipality: 'Albersweiler',
    postalCode: '76857'
  },
  {
    municipality: 'Albertshofen',
    postalCode: '97320'
  },
  {
    municipality: 'Albessen',
    postalCode: '66871'
  },
  {
    municipality: 'Albig',
    postalCode: '55234'
  },
  {
    municipality: 'Albisheim (Pfrimm)',
    postalCode: '67308'
  },
  {
    municipality: 'Albsfelde',
    postalCode: '23909'
  },
  {
    municipality: 'Albstadt',
    postalCode: '72458'
  },
  {
    municipality: 'Albstadt',
    postalCode: '72459'
  },
  {
    municipality: 'Albstadt',
    postalCode: '72461'
  },
  {
    municipality: 'Aldenhoven',
    postalCode: '52457'
  },
  {
    municipality: 'Aldersbach',
    postalCode: '94501'
  },
  {
    municipality: 'Aldingen',
    postalCode: '78554'
  },
  {
    municipality: 'Alerheim',
    postalCode: '86733'
  },
  {
    municipality: 'Alesheim',
    postalCode: '91793'
  },
  {
    municipality: 'Aletshausen',
    postalCode: '86480'
  },
  {
    municipality: 'Alf',
    postalCode: '56859'
  },
  {
    municipality: 'Alfdorf',
    postalCode: '73553'
  },
  {
    municipality: 'Alfdorf',
    postalCode: '73655'
  },
  {
    municipality: 'Alfeld',
    postalCode: '91236'
  },
  {
    municipality: 'Alfeld (Leine)',
    postalCode: '31061'
  },
  {
    municipality: 'Alfhausen',
    postalCode: '49594'
  },
  {
    municipality: 'Alflen',
    postalCode: '56828'
  },
  {
    municipality: 'Alfstedt',
    postalCode: '27432'
  },
  {
    municipality: 'Alfter',
    postalCode: '53347'
  },
  {
    municipality: 'Algermissen',
    postalCode: '31191'
  },
  {
    municipality: 'Alheim',
    postalCode: '36211'
  },
  {
    municipality: 'Alken',
    postalCode: '56332'
  },
  {
    municipality: 'Alkersleben',
    postalCode: '99310'
  },
  {
    municipality: 'Alkersum',
    postalCode: '25938'
  },
  {
    municipality: 'Allenbach',
    postalCode: '55758'
  },
  {
    municipality: 'Allendorf',
    postalCode: '35469'
  },
  {
    municipality: 'Allendorf',
    postalCode: '56370'
  },
  {
    municipality: 'Allendorf',
    postalCode: '07426'
  },
  {
    municipality: 'Allendorf (Eder)',
    postalCode: '35108'
  },
  {
    municipality: 'Allenfeld',
    postalCode: '55595'
  },
  {
    municipality: 'Allensbach',
    postalCode: '78476'
  },
  {
    municipality: 'Allersberg',
    postalCode: '90584'
  },
  {
    municipality: 'Allershausen',
    postalCode: '85391'
  },
  {
    municipality: 'Alleshausen',
    postalCode: '88422'
  },
  {
    municipality: 'Alling',
    postalCode: '82239'
  },
  {
    municipality: 'Allmannshofen',
    postalCode: '86695'
  },
  {
    municipality: 'Allmannsweiler',
    postalCode: '88348'
  },
  {
    municipality: 'Allmendingen',
    postalCode: '89604'
  },
  {
    municipality: 'Allmersbach im Tal',
    postalCode: '71573'
  },
  {
    municipality: 'Allstedt',
    postalCode: '06542'
  },
  {
    municipality: 'Almdorf',
    postalCode: '25821'
  },
  {
    municipality: 'Almersbach',
    postalCode: '57610'
  },
  {
    municipality: 'Alpen',
    postalCode: '46519'
  },
  {
    municipality: 'Alpenrod',
    postalCode: '57642'
  },
  {
    municipality: 'Alpenrod',
    postalCode: '57647'
  },
  {
    municipality: 'Alperstedt',
    postalCode: '99195'
  },
  {
    municipality: 'Alpirsbach',
    postalCode: '72275'
  },
  {
    municipality: 'Alsbach',
    postalCode: '56237'
  },
  {
    municipality: 'Alsbach-Hähnlein',
    postalCode: '64665'
  },
  {
    municipality: 'Alsdorf',
    postalCode: '52477'
  },
  {
    municipality: 'Alsdorf',
    postalCode: '57518'
  },
  {
    municipality: 'Alsdorf',
    postalCode: '54668'
  },
  {
    municipality: 'Alsenz',
    postalCode: '67821'
  },
  {
    municipality: 'Alsfeld',
    postalCode: '36304'
  },
  {
    municipality: 'Alsheim',
    postalCode: '67577'
  },
  {
    municipality: 'Alsleben',
    postalCode: '06425'
  },
  {
    municipality: 'Altbach',
    postalCode: '73776'
  },
  {
    municipality: 'Alt Bennebek',
    postalCode: '24848'
  },
  {
    municipality: 'Alt Bukow',
    postalCode: '18233'
  },
  {
    municipality: 'Altdöbern',
    postalCode: '03229'
  },
  {
    municipality: 'Altdorf',
    postalCode: '84032'
  },
  {
    municipality: 'Altdorf',
    postalCode: '71155'
  },
  {
    municipality: 'Altdorf',
    postalCode: '72655'
  },
  {
    municipality: 'Altdorf',
    postalCode: '67482'
  },
  {
    municipality: 'Altdorf bei Nürnberg',
    postalCode: '90518'
  },
  {
    municipality: 'Alt Duvenstedt',
    postalCode: '24782'
  },
  {
    municipality: 'Alt Duvenstedt',
    postalCode: '24791'
  },
  {
    municipality: 'Alt Duvenstedt',
    postalCode: '24811'
  },
  {
    municipality: 'Altefähr',
    postalCode: '18573'
  },
  {
    municipality: 'Alteglofsheim',
    postalCode: '93087'
  },
  {
    municipality: 'Altena',
    postalCode: '58762'
  },
  {
    municipality: 'Altenahr',
    postalCode: '53505'
  },
  {
    municipality: 'Altenbamberg',
    postalCode: '55585'
  },
  {
    municipality: 'Altenbeken',
    postalCode: '33184'
  },
  {
    municipality: 'Altenberg',
    postalCode: '01773'
  },
  {
    municipality: 'Altenberg',
    postalCode: '01778'
  },
  {
    municipality: 'Altenberga',
    postalCode: '07768'
  },
  {
    municipality: 'Altenberge',
    postalCode: '48341'
  },
  {
    municipality: 'Altenbeuthen',
    postalCode: '07338'
  },
  {
    municipality: 'Altenbuch',
    postalCode: '97901'
  },
  {
    municipality: 'Altenburg',
    postalCode: '04600'
  },
  {
    municipality: 'Altendiez',
    postalCode: '65624'
  },
  {
    municipality: 'Altendorf',
    postalCode: '92540'
  },
  {
    municipality: 'Altendorf',
    postalCode: '96146'
  },
  {
    municipality: 'Altenglan',
    postalCode: '66885'
  },
  {
    municipality: 'Altenhagen',
    postalCode: '17091'
  },
  {
    municipality: 'Altenhausen',
    postalCode: '39343'
  },
  {
    municipality: 'Altenhof',
    postalCode: '24340'
  },
  {
    municipality: 'Altenhof',
    postalCode: '17209'
  },
  {
    municipality: 'Altenholz',
    postalCode: '24161'
  },
  {
    municipality: 'Altenkirchen',
    postalCode: '66903'
  },
  {
    municipality: 'Altenkirchen',
    postalCode: '18556'
  },
  {
    municipality: 'Altenkirchen (Westerwald)',
    postalCode: '57610'
  },
  {
    municipality: 'Altenkrempe',
    postalCode: '23730'
  },
  {
    municipality: 'Altenkunstadt',
    postalCode: '96264'
  },
  {
    municipality: 'Altenmarkt an der Alz',
    postalCode: '83352'
  },
  {
    municipality: 'Altenmedingen',
    postalCode: '29575'
  },
  {
    municipality: 'Altenmoor',
    postalCode: '25335'
  },
  {
    municipality: 'Altenmünster',
    postalCode: '86450'
  },
  {
    municipality: 'Altenpleen',
    postalCode: '18445'
  },
  {
    municipality: 'Altenriet',
    postalCode: '72657'
  },
  {
    municipality: 'Altenstadt',
    postalCode: '63674'
  },
  {
    municipality: 'Altenstadt',
    postalCode: '86972'
  },
  {
    municipality: 'Altenstadt',
    postalCode: '89281'
  },
  {
    municipality: 'Altenstadt an der Waldnaab',
    postalCode: '92665'
  },
  {
    municipality: 'Altensteig',
    postalCode: '72213'
  },
  {
    municipality: 'Altenthann',
    postalCode: '93177'
  },
  {
    municipality: 'Altentreptow',
    postalCode: '17087'
  },
  {
    municipality: 'Alterkülz',
    postalCode: '56288'
  },
  {
    municipality: 'Altertheim',
    postalCode: '97237'
  },
  {
    municipality: 'Altfraunhofen',
    postalCode: '84169'
  },
  {
    municipality: 'Althegnenberg',
    postalCode: '82278'
  },
  {
    municipality: 'Altheim',
    postalCode: '88499'
  },
  {
    municipality: 'Altheim',
    postalCode: '89605'
  },
  {
    municipality: 'Altheim (Alb)',
    postalCode: '89174'
  },
  {
    municipality: 'Althengstett',
    postalCode: '75382'
  },
  {
    municipality: 'Althornbach',
    postalCode: '66484'
  },
  {
    municipality: 'Althütte',
    postalCode: '71566'
  },
  {
    municipality: 'Althüttendorf',
    postalCode: '16247'
  },
  {
    municipality: 'Altkalen',
    postalCode: '17179'
  },
  {
    municipality: 'Alt Krenzlin',
    postalCode: '19288'
  },
  {
    municipality: 'Altlandsberg',
    postalCode: '15345'
  },
  {
    municipality: 'Altlay',
    postalCode: '56858'
  },
  {
    municipality: 'Altleiningen',
    postalCode: '67316'
  },
  {
    municipality: 'Altleiningen',
    postalCode: '67317'
  },
  {
    municipality: 'Altlußheim',
    postalCode: '68804'
  },
  {
    municipality: 'Altmannstein',
    postalCode: '93336'
  },
  {
    municipality: 'Altmärkische Höhe',
    postalCode: '39606'
  },
  {
    municipality: 'Altmärkische Höhe',
    postalCode: '39615'
  },
  {
    municipality: 'Altmärkische Wische',
    postalCode: '39615'
  },
  {
    municipality: 'Alt Meteln',
    postalCode: '19069'
  },
  {
    municipality: 'Altmittweida',
    postalCode: '09648'
  },
  {
    municipality: 'Alt Mölln',
    postalCode: '23881'
  },
  {
    municipality: 'Altomünster',
    postalCode: '85250'
  },
  {
    municipality: 'Altötting',
    postalCode: '84503'
  },
  {
    municipality: 'Altrich',
    postalCode: '54518'
  },
  {
    municipality: 'Altrip',
    postalCode: '67122'
  },
  {
    municipality: 'Altscheid',
    postalCode: '54636'
  },
  {
    municipality: 'Alt Schwerin',
    postalCode: '17214'
  },
  {
    municipality: 'Altshausen',
    postalCode: '88361'
  },
  {
    municipality: 'Altstrimmig',
    postalCode: '56858'
  },
  {
    municipality: 'Alt Sührkow',
    postalCode: '17166'
  },
  {
    municipality: 'Alt Tellin',
    postalCode: '17129'
  },
  {
    municipality: 'Alt Tucheband',
    postalCode: '15328'
  },
  {
    municipality: 'Altusried',
    postalCode: '87452'
  },
  {
    municipality: 'Altwarp',
    postalCode: '17375'
  },
  {
    municipality: 'Altweidelbach',
    postalCode: '55469'
  },
  {
    municipality: 'Altwigshagen',
    postalCode: '17379'
  },
  {
    municipality: 'Alt Zachun',
    postalCode: '19230'
  },
  {
    municipality: 'Alt Zauche-Wußwerk',
    postalCode: '15913'
  },
  {
    municipality: 'Alveslohe',
    postalCode: '25486'
  },
  {
    municipality: 'Alzenau',
    postalCode: '63755'
  },
  {
    municipality: 'Alzey',
    postalCode: '55232'
  },
  {
    municipality: 'Amberg',
    postalCode: '92224'
  },
  {
    municipality: 'Amberg',
    postalCode: '86854'
  },
  {
    municipality: 'Amelinghausen',
    postalCode: '21385'
  },
  {
    municipality: 'Amerang',
    postalCode: '83123'
  },
  {
    municipality: 'Amerdingen',
    postalCode: '86735'
  },
  {
    municipality: 'Am Ettersberg',
    postalCode: '99439'
  },
  {
    municipality: 'Am Großen Bruch',
    postalCode: '39393'
  },
  {
    municipality: 'Ammeldingen an der Our',
    postalCode: '54675'
  },
  {
    municipality: 'Ammeldingen bei Neuerburg',
    postalCode: '54673'
  },
  {
    municipality: 'Am Mellensee',
    postalCode: '15838'
  },
  {
    municipality: 'Ammerbuch',
    postalCode: '72119'
  },
  {
    municipality: 'Ammerndorf',
    postalCode: '90614'
  },
  {
    municipality: 'Ammersbek',
    postalCode: '22949'
  },
  {
    municipality: 'Ammerthal',
    postalCode: '92260'
  },
  {
    municipality: 'Am Ohmberg',
    postalCode: '37345'
  },
  {
    municipality: 'Amöneburg',
    postalCode: '35287'
  },
  {
    municipality: 'Amorbach',
    postalCode: '63916'
  },
  {
    municipality: 'Ampfing',
    postalCode: '84539'
  },
  {
    municipality: 'Am Salzhaff',
    postalCode: '18233'
  },
  {
    municipality: 'Amstetten',
    postalCode: '73340'
  },
  {
    municipality: 'Amt Creuzburg',
    postalCode: '99831'
  },
  {
    municipality: 'Amt Neuhaus',
    postalCode: '19273'
  },
  {
    municipality: 'Amtsberg',
    postalCode: '09439'
  },
  {
    municipality: 'Amt Wachsenburg',
    postalCode: '99334'
  },
  {
    municipality: 'Amtzell',
    postalCode: '88279'
  },
  {
    municipality: 'Andechs',
    postalCode: '82346'
  },
  {
    municipality: 'Anderlingen',
    postalCode: '27446'
  },
  {
    municipality: 'Andernach',
    postalCode: '56626'
  },
  {
    municipality: 'An der Poststraße',
    postalCode: '06647'
  },
  {
    municipality: 'An der Schmücke',
    postalCode: '06577'
  },
  {
    municipality: 'Andervenne',
    postalCode: '49832'
  },
  {
    municipality: 'Andisleben',
    postalCode: '99189'
  },
  {
    municipality: 'Angelbachtal',
    postalCode: '74918'
  },
  {
    municipality: 'Angelburg',
    postalCode: '35719'
  },
  {
    municipality: 'Anger',
    postalCode: '83454'
  },
  {
    municipality: 'Angermünde',
    postalCode: '16278'
  },
  {
    municipality: 'Angern',
    postalCode: '39326'
  },
  {
    municipality: 'Angern',
    postalCode: '39517'
  },
  {
    municipality: 'Anhausen',
    postalCode: '56584'
  },
  {
    municipality: 'Ankershagen',
    postalCode: '17219'
  },
  {
    municipality: 'Anklam',
    postalCode: '17389'
  },
  {
    municipality: 'Ankum',
    postalCode: '49577'
  },
  {
    municipality: 'Annaberg-Buchholz',
    postalCode: '09456'
  },
  {
    municipality: 'Annaburg',
    postalCode: '06925'
  },
  {
    municipality: 'Annweiler am Trifels',
    postalCode: '76855'
  },
  {
    municipality: 'Anröchte',
    postalCode: '59609'
  },
  {
    municipality: 'Anrode',
    postalCode: '99976'
  },
  {
    municipality: 'Ansbach',
    postalCode: '91522'
  },
  {
    municipality: 'Anschau',
    postalCode: '56729'
  },
  {
    municipality: 'Antdorf',
    postalCode: '82387'
  },
  {
    municipality: 'Antrifttal',
    postalCode: '36326'
  },
  {
    municipality: 'Antweiler',
    postalCode: '53533'
  },
  {
    municipality: 'Anzing',
    postalCode: '85646'
  },
  {
    municipality: 'Apelern',
    postalCode: '31552'
  },
  {
    municipality: 'Apen',
    postalCode: '26689'
  },
  {
    municipality: 'Apenburg-Winterfeld',
    postalCode: '38486'
  },
  {
    municipality: 'Apensen',
    postalCode: '21641'
  },
  {
    municipality: 'Apfeldorf',
    postalCode: '86974'
  },
  {
    municipality: 'Apfeltrach',
    postalCode: '87742'
  },
  {
    municipality: 'Apolda',
    postalCode: '99510'
  },
  {
    municipality: 'Appel',
    postalCode: '21279'
  },
  {
    municipality: 'Appen',
    postalCode: '25482'
  },
  {
    municipality: 'Appenheim',
    postalCode: '55437'
  },
  {
    municipality: 'Appenweier',
    postalCode: '77767'
  },
  {
    municipality: 'Arbach',
    postalCode: '56769'
  },
  {
    municipality: 'Arberg',
    postalCode: '91722'
  },
  {
    municipality: 'Aremberg',
    postalCode: '53533'
  },
  {
    municipality: 'Arendsee (Altmark)',
    postalCode: '39619'
  },
  {
    municipality: 'Arenrath',
    postalCode: '54518'
  },
  {
    municipality: 'Arenshausen',
    postalCode: '37318'
  },
  {
    municipality: 'Aresing',
    postalCode: '86561'
  },
  {
    municipality: 'Arft',
    postalCode: '56729'
  },
  {
    municipality: 'Argenbühl',
    postalCode: '88260'
  },
  {
    municipality: 'Argenschwang',
    postalCode: '55595'
  },
  {
    municipality: 'Argenthal',
    postalCode: '55496'
  },
  {
    municipality: 'Arholzen',
    postalCode: '37627'
  },
  {
    municipality: 'Arkebek',
    postalCode: '25767'
  },
  {
    municipality: 'Arlewatt',
    postalCode: '25860'
  },
  {
    municipality: 'Armsheim',
    postalCode: '55288'
  },
  {
    municipality: 'Armstedt',
    postalCode: '24616'
  },
  {
    municipality: 'Armstorf',
    postalCode: '21769'
  },
  {
    municipality: 'Arnbruck',
    postalCode: '93471'
  },
  {
    municipality: 'Arneburg',
    postalCode: '39596'
  },
  {
    municipality: 'Arnis',
    postalCode: '24399'
  },
  {
    municipality: 'Arnsberg',
    postalCode: '59755'
  },
  {
    municipality: 'Arnsberg',
    postalCode: '59757'
  },
  {
    municipality: 'Arnsberg',
    postalCode: '59759'
  },
  {
    municipality: 'Arnsberg',
    postalCode: '59821'
  },
  {
    municipality: 'Arnsberg',
    postalCode: '59823'
  },
  {
    municipality: 'Arnschwang',
    postalCode: '93473'
  },
  {
    municipality: 'Arnsdorf',
    postalCode: '01477'
  },
  {
    municipality: 'Arnshöfen',
    postalCode: '56244'
  },
  {
    municipality: 'Arnstadt',
    postalCode: '99310'
  },
  {
    municipality: 'Arnstein',
    postalCode: '97450'
  },
  {
    municipality: 'Arnstein',
    postalCode: '06456'
  },
  {
    municipality: 'Arnstorf',
    postalCode: '94424'
  },
  {
    municipality: 'Arpsdorf',
    postalCode: '24634'
  },
  {
    municipality: 'Arrach',
    postalCode: '93474'
  },
  {
    municipality: 'Artern',
    postalCode: '06556'
  },
  {
    municipality: 'Artlenburg',
    postalCode: '21380'
  },
  {
    municipality: 'Arzbach',
    postalCode: '56337'
  },
  {
    municipality: 'Arzberg',
    postalCode: '04886'
  },
  {
    municipality: 'Arzberg',
    postalCode: '95659'
  },
  {
    municipality: 'Arzfeld',
    postalCode: '54687'
  },
  {
    municipality: 'Asbach',
    postalCode: '53567'
  },
  {
    municipality: 'Asbach',
    postalCode: '55758'
  },
  {
    municipality: 'Asbach-Bäumenheim',
    postalCode: '86663'
  },
  {
    municipality: 'Asbach-Sickenberg',
    postalCode: '37318'
  },
  {
    municipality: 'Ascha',
    postalCode: '94347'
  },
  {
    municipality: 'Aschaffenburg',
    postalCode: '63739'
  },
  {
    municipality: 'Aschaffenburg',
    postalCode: '63741'
  },
  {
    municipality: 'Aschaffenburg',
    postalCode: '63743'
  },
  {
    municipality: 'Aschau am Inn',
    postalCode: '84544'
  },
  {
    municipality: 'Aschau im Chiemgau',
    postalCode: '83229'
  },
  {
    municipality: 'Aschbach',
    postalCode: '67753'
  },
  {
    municipality: 'Ascheberg',
    postalCode: '59387'
  },
  {
    municipality: 'Ascheberg',
    postalCode: '24326'
  },
  {
    municipality: 'Ascheffel',
    postalCode: '24358'
  },
  {
    municipality: 'Aschersleben',
    postalCode: '06449'
  },
  {
    municipality: 'Aschheim',
    postalCode: '85609'
  },
  {
    municipality: 'Asendorf',
    postalCode: '21271'
  },
  {
    municipality: 'Asendorf',
    postalCode: '27330'
  },
  {
    municipality: 'Aspach',
    postalCode: '71546'
  },
  {
    municipality: 'Asperg',
    postalCode: '71679'
  },
  {
    municipality: 'Aspisheim',
    postalCode: '55459'
  },
  {
    municipality: 'Assamstadt',
    postalCode: '97959'
  },
  {
    municipality: 'Asselfingen',
    postalCode: '89176'
  },
  {
    municipality: 'Aßlar',
    postalCode: '35614'
  },
  {
    municipality: 'Aßling',
    postalCode: '85617'
  },
  {
    municipality: 'Astert',
    postalCode: '57627'
  },
  {
    municipality: 'Attendorn',
    postalCode: '57439'
  },
  {
    municipality: 'Attenhausen',
    postalCode: '56370'
  },
  {
    municipality: 'Attenhofen',
    postalCode: '84091'
  },
  {
    municipality: 'Attenkirchen',
    postalCode: '85395'
  },
  {
    municipality: 'Attenweiler',
    postalCode: '88448'
  },
  {
    municipality: 'Atting',
    postalCode: '94348'
  },
  {
    municipality: 'Atzelgift',
    postalCode: '57629'
  },
  {
    municipality: 'Au',
    postalCode: '79280'
  },
  {
    municipality: 'Au am Rhein',
    postalCode: '76474'
  },
  {
    municipality: 'Aub',
    postalCode: '97239'
  },
  {
    municipality: 'Aubstadt',
    postalCode: '97633'
  },
  {
    municipality: 'Auderath',
    postalCode: '56766'
  },
  {
    municipality: 'Aue-Bad Schlema',
    postalCode: '08280'
  },
  {
    municipality: 'Aue-Bad Schlema',
    postalCode: '08301'
  },
  {
    municipality: 'Auel',
    postalCode: '56357'
  },
  {
    municipality: 'Auen',
    postalCode: '55569'
  },
  {
    municipality: 'Auengrund',
    postalCode: '98673'
  },
  {
    municipality: 'Auenwald',
    postalCode: '71549'
  },
  {
    municipality: 'Auerbach',
    postalCode: '09392'
  },
  {
    municipality: 'Auerbach',
    postalCode: '94530'
  },
  {
    municipality: 'Auerbach in der Oberpfalz',
    postalCode: '91275'
  },
  {
    municipality: 'Auerbach/Vogtland',
    postalCode: '08209'
  },
  {
    municipality: 'Auetal',
    postalCode: '31749'
  },
  {
    municipality: 'Aufhausen',
    postalCode: '93089'
  },
  {
    municipality: 'Aufseß',
    postalCode: '91347'
  },
  {
    municipality: 'Auggen',
    postalCode: '79424'
  },
  {
    municipality: 'Augsburg',
    postalCode: '86150'
  },
  {
    municipality: 'Augsburg',
    postalCode: '86152'
  },
  {
    municipality: 'Augsburg',
    postalCode: '86153'
  },
  {
    municipality: 'Augsburg',
    postalCode: '86154'
  },
  {
    municipality: 'Augsburg',
    postalCode: '86156'
  },
  {
    municipality: 'Augsburg',
    postalCode: '86157'
  },
  {
    municipality: 'Augsburg',
    postalCode: '86159'
  },
  {
    municipality: 'Augsburg',
    postalCode: '86161'
  },
  {
    municipality: 'Augsburg',
    postalCode: '86163'
  },
  {
    municipality: 'Augsburg',
    postalCode: '86165'
  },
  {
    municipality: 'Augsburg',
    postalCode: '86167'
  },
  {
    municipality: 'Augsburg',
    postalCode: '86169'
  },
  {
    municipality: 'Augsburg',
    postalCode: '86179'
  },
  {
    municipality: 'Augsburg',
    postalCode: '86199'
  },
  {
    municipality: 'Augustdorf',
    postalCode: '32832'
  },
  {
    municipality: 'Augustusburg',
    postalCode: '09573'
  },
  {
    municipality: 'Auhagen',
    postalCode: '31553'
  },
  {
    municipality: 'Auhausen',
    postalCode: '86736'
  },
  {
    municipality: 'Au in der Hallertau',
    postalCode: '84072'
  },
  {
    municipality: 'Aukrug',
    postalCode: '24613'
  },
  {
    municipality: 'Aulendorf',
    postalCode: '88326'
  },
  {
    municipality: 'Aull',
    postalCode: '65582'
  },
  {
    municipality: 'Auma-Weidatal',
    postalCode: '07955'
  },
  {
    municipality: 'Aumühle',
    postalCode: '21521'
  },
  {
    municipality: 'Aura a.d.Saale',
    postalCode: '97717'
  },
  {
    municipality: 'Aurach',
    postalCode: '91589'
  },
  {
    municipality: 'Aurachtal',
    postalCode: '91086'
  },
  {
    municipality: 'Aura im Sinngrund',
    postalCode: '97773'
  },
  {
    municipality: 'Aurich',
    postalCode: '26603'
  },
  {
    municipality: 'Aurich',
    postalCode: '26605'
  },
  {
    municipality: 'Aurich',
    postalCode: '26607'
  },
  {
    municipality: 'Ausacker',
    postalCode: '24975'
  },
  {
    municipality: 'Ausleben',
    postalCode: '39393'
  },
  {
    municipality: 'Außernzell',
    postalCode: '94532'
  },
  {
    municipality: 'Auufer',
    postalCode: '25548'
  },
  {
    municipality: 'Auw an der Kyll',
    postalCode: '54664'
  },
  {
    municipality: 'Auw bei Prüm',
    postalCode: '54597'
  },
  {
    municipality: 'Aventoft',
    postalCode: '25927'
  },
  {
    municipality: 'Averlak',
    postalCode: '25715'
  },
  {
    municipality: 'Axstedt',
    postalCode: '27729'
  },
  {
    municipality: 'Aying',
    postalCode: '85653'
  },
  {
    municipality: 'Ayl',
    postalCode: '54441'
  },
  {
    municipality: 'Aystetten',
    postalCode: '86482'
  },
  {
    municipality: 'Baabe',
    postalCode: '18586'
  },
  {
    municipality: 'Baar',
    postalCode: '86674'
  },
  {
    municipality: 'Baar',
    postalCode: '56729'
  },
  {
    municipality: 'Baar-Ebenhausen',
    postalCode: '85107'
  },
  {
    municipality: 'Babenhausen',
    postalCode: '64832'
  },
  {
    municipality: 'Babenhausen',
    postalCode: '87727'
  },
  {
    municipality: 'Babensham',
    postalCode: '83547'
  },
  {
    municipality: 'Bach an der Donau',
    postalCode: '93090'
  },
  {
    municipality: 'Bacharach',
    postalCode: '55422'
  },
  {
    municipality: 'Bachenberg',
    postalCode: '57610'
  },
  {
    municipality: 'Bachhagel',
    postalCode: '89429'
  },
  {
    municipality: 'Bächingen a.d.Brenz',
    postalCode: '89431'
  },
  {
    municipality: 'Backnang',
    postalCode: '71522'
  },
  {
    municipality: 'Bad Abbach',
    postalCode: '93077'
  },
  {
    municipality: 'Bad Aibling',
    postalCode: '83043'
  },
  {
    municipality: 'Bad Alexandersbad',
    postalCode: '95680'
  },
  {
    municipality: 'Bad Arolsen',
    postalCode: '34454'
  },
  {
    municipality: 'Bad Bayersoien',
    postalCode: '82435'
  },
  {
    municipality: 'Bad Bellingen',
    postalCode: '79415'
  },
  {
    municipality: 'Bad Belzig',
    postalCode: '14806'
  },
  {
    municipality: 'Bad Bentheim',
    postalCode: '48455'
  },
  {
    municipality: 'Badbergen',
    postalCode: '49635'
  },
  {
    municipality: 'Bad Bergzabern',
    postalCode: '76887'
  },
  {
    municipality: 'Bad Berka',
    postalCode: '99438'
  },
  {
    municipality: 'Bad Berleburg',
    postalCode: '57319'
  },
  {
    municipality: 'Bad Berneck im Fichtelgebirge',
    postalCode: '95460'
  },
  {
    municipality: 'Bad Bertrich',
    postalCode: '56864'
  },
  {
    municipality: 'Bad Bevensen',
    postalCode: '29549'
  },
  {
    municipality: 'Bad Bibra',
    postalCode: '06647'
  },
  {
    municipality: 'Bad Birnbach',
    postalCode: '84364'
  },
  {
    municipality: 'Bad Blankenburg',
    postalCode: '07422'
  },
  {
    municipality: 'Bad Bocklet',
    postalCode: '97708'
  },
  {
    municipality: 'Bad Bodenteich',
    postalCode: '29389'
  },
  {
    municipality: 'Bad Boll',
    postalCode: '73087'
  },
  {
    municipality: 'Bad Brambach',
    postalCode: '08648'
  },
  {
    municipality: 'Bad Bramstedt',
    postalCode: '24576'
  },
  {
    municipality: 'Bad Breisig',
    postalCode: '53498'
  },
  {
    municipality: 'Bad Brückenau',
    postalCode: '97769'
  },
  {
    municipality: 'Bad Buchau',
    postalCode: '88422'
  },
  {
    municipality: 'Bad Camberg',
    postalCode: '65520'
  },
  {
    municipality: 'Baddeckenstedt',
    postalCode: '38271'
  },
  {
    municipality: 'Bad Ditzenbach',
    postalCode: '73312'
  },
  {
    municipality: 'Bad Ditzenbach',
    postalCode: '73342'
  },
  {
    municipality: 'Bad Ditzenbach',
    postalCode: '73345'
  },
  {
    municipality: 'Bad Doberan',
    postalCode: '18209'
  },
  {
    municipality: 'Bad Driburg',
    postalCode: '33014'
  },
  {
    municipality: 'Bad Düben',
    postalCode: '04849'
  },
  {
    municipality: 'Bad Dürkheim',
    postalCode: '67098'
  },
  {
    municipality: 'Bad Dürrenberg',
    postalCode: '06231'
  },
  {
    municipality: 'Bad Dürrheim',
    postalCode: '78073'
  },
  {
    municipality: 'Bad Eilsen',
    postalCode: '31707'
  },
  {
    municipality: 'Bad Elster',
    postalCode: '08645'
  },
  {
    municipality: 'Badem',
    postalCode: '54657'
  },
  {
    municipality: 'Bad Ems',
    postalCode: '56130'
  },
  {
    municipality: 'Bad Emstal',
    postalCode: '34308'
  },
  {
    municipality: 'Baden-Baden',
    postalCode: '76530'
  },
  {
    municipality: 'Baden-Baden',
    postalCode: '76532'
  },
  {
    municipality: 'Baden-Baden',
    postalCode: '76534'
  },
  {
    municipality: 'Bad Endbach',
    postalCode: '35080'
  },
  {
    municipality: 'Badendorf',
    postalCode: '23619'
  },
  {
    municipality: 'Bad Endorf',
    postalCode: '83093'
  },
  {
    municipality: 'Badenhard',
    postalCode: '56291'
  },
  {
    municipality: 'Badenheim',
    postalCode: '55576'
  },
  {
    municipality: 'Badenweiler',
    postalCode: '79410'
  },
  {
    municipality: 'Bad Essen',
    postalCode: '49152'
  },
  {
    municipality: 'Bad Fallingbostel',
    postalCode: '29683'
  },
  {
    municipality: 'Bad Feilnbach',
    postalCode: '83075'
  },
  {
    municipality: 'Bad Frankenhausen/Kyffhäuser',
    postalCode: '06567'
  },
  {
    municipality: 'Bad Freienwalde (Oder)',
    postalCode: '16259'
  },
  {
    municipality: 'Bad Friedrichshall',
    postalCode: '74177'
  },
  {
    municipality: 'Bad Füssing',
    postalCode: '94072'
  },
  {
    municipality: 'Bad Gandersheim',
    postalCode: '37581'
  },
  {
    municipality: 'Bad Gottleuba-Berggießhübel',
    postalCode: '01816'
  },
  {
    municipality: 'Bad Griesbach i.Rottal',
    postalCode: '94086'
  },
  {
    municipality: 'Bad Grönenbach',
    postalCode: '87730'
  },
  {
    municipality: 'Bad Grund',
    postalCode: '37539'
  },
  {
    municipality: 'Bad Harzburg',
    postalCode: '38667'
  },
  {
    municipality: 'Bad Heilbrunn',
    postalCode: '83670'
  },
  {
    municipality: 'Bad Herrenalb',
    postalCode: '76332'
  },
  {
    municipality: 'Bad Hersfeld',
    postalCode: '36251'
  },
  {
    municipality: 'Bad Hindelang',
    postalCode: '87541'
  },
  {
    municipality: 'Bad Homburg vor der Höhe',
    postalCode: '61348'
  },
  {
    municipality: 'Bad Homburg vor der Höhe',
    postalCode: '61350'
  },
  {
    municipality: 'Bad Homburg vor der Höhe',
    postalCode: '61352'
  },
  {
    municipality: 'Bad Honnef',
    postalCode: '53604'
  },
  {
    municipality: 'Bad Hönningen',
    postalCode: '53547'
  },
  {
    municipality: 'Bad Hönningen',
    postalCode: '53557'
  },
  {
    municipality: 'Bad Iburg',
    postalCode: '49186'
  },
  {
    municipality: 'Bad Karlshafen',
    postalCode: '34385'
  },
  {
    municipality: 'Bad Kissingen',
    postalCode: '97688'
  },
  {
    municipality: 'Bad Kleinen',
    postalCode: '23996'
  },
  {
    municipality: 'Bad Klosterlausnitz',
    postalCode: '07639'
  },
  {
    municipality: 'Bad Kohlgrub',
    postalCode: '82433'
  },
  {
    municipality: 'Bad König',
    postalCode: '64732'
  },
  {
    municipality: 'Bad Königshofen im Grabfeld',
    postalCode: '97631'
  },
  {
    municipality: 'Bad Köstritz',
    postalCode: '07586'
  },
  {
    municipality: 'Bad Kötzting',
    postalCode: '93444'
  },
  {
    municipality: 'Bad Kreuznach',
    postalCode: '55543'
  },
  {
    municipality: 'Bad Kreuznach',
    postalCode: '55545'
  },
  {
    municipality: 'Bad Kreuznach',
    postalCode: '55583'
  },
  {
    municipality: 'Bad Krozingen',
    postalCode: '79189'
  },
  {
    municipality: 'Bad Laasphe',
    postalCode: '57334'
  },
  {
    municipality: 'Bad Laer',
    postalCode: '49196'
  },
  {
    municipality: 'Bad Langensalza',
    postalCode: '99947'
  },
  {
    municipality: 'Bad Lausick',
    postalCode: '04651'
  },
  {
    municipality: 'Bad Lauterberg im Harz',
    postalCode: '37431'
  },
  {
    municipality: 'Bad Liebenstein',
    postalCode: '36448'
  },
  {
    municipality: 'Bad Liebenwerda',
    postalCode: '04895'
  },
  {
    municipality: 'Bad Liebenwerda',
    postalCode: '04924'
  },
  {
    municipality: 'Bad Liebenwerda',
    postalCode: '04931'
  },
  {
    municipality: 'Bad Liebenzell',
    postalCode: '75378'
  },
  {
    municipality: 'Bad Lippspringe',
    postalCode: '33175'
  },
  {
    municipality: 'Bad Lobenstein',
    postalCode: '07356'
  },
  {
    municipality: 'Bad Marienberg (Westerwald)',
    postalCode: '56470'
  },
  {
    municipality: 'Bad Mergentheim',
    postalCode: '97980'
  },
  {
    municipality: 'Bad Münder am Deister',
    postalCode: '31848'
  },
  {
    municipality: 'Bad Münstereifel',
    postalCode: '53902'
  },
  {
    municipality: 'Bad Muskau - Mužakow',
    postalCode: '02953'
  },
  {
    municipality: 'Bad Nauheim',
    postalCode: '61231'
  },
  {
    municipality: 'Bad Nenndorf',
    postalCode: '31542'
  },
  {
    municipality: 'Bad Neualbenreuth',
    postalCode: '95698'
  },
  {
    municipality: 'Bad Neuenahr-Ahrweiler',
    postalCode: '53474'
  },
  {
    municipality: 'Bad Neustadt an der Saale',
    postalCode: '97616'
  },
  {
    municipality: 'Bad Oeynhausen',
    postalCode: '32545'
  },
  {
    municipality: 'Bad Oeynhausen',
    postalCode: '32547'
  },
  {
    municipality: 'Bad Oeynhausen',
    postalCode: '32549'
  },
  {
    municipality: 'Bad Oldesloe',
    postalCode: '23843'
  },
  {
    municipality: 'Bad Orb',
    postalCode: '63619'
  },
  {
    municipality: 'Bad Peterstal-Griesbach',
    postalCode: '72250'
  },
  {
    municipality: 'Bad Peterstal-Griesbach',
    postalCode: '77740'
  },
  {
    municipality: 'Bad Pyrmont',
    postalCode: '31812'
  },
  {
    municipality: 'Bad Rappenau',
    postalCode: '74906'
  },
  {
    municipality: 'Bad Reichenhall',
    postalCode: '83435'
  },
  {
    municipality: 'Bad Rippoldsau-Schapbach',
    postalCode: '77776'
  },
  {
    municipality: 'Bad Rodach',
    postalCode: '96476'
  },
  {
    municipality: 'Bad Rothenfelde',
    postalCode: '49214'
  },
  {
    municipality: 'Bad Saarow',
    postalCode: '15526'
  },
  {
    municipality: 'Bad Sachsa',
    postalCode: '37441'
  },
  {
    municipality: 'Bad Säckingen',
    postalCode: '79713'
  },
  {
    municipality: 'Bad Salzdetfurth',
    postalCode: '31162'
  },
  {
    municipality: 'Bad Salzschlirf',
    postalCode: '36364'
  },
  {
    municipality: 'Bad Salzuflen',
    postalCode: '32105'
  },
  {
    municipality: 'Bad Salzuflen',
    postalCode: '32107'
  },
  {
    municipality: 'Bad Salzuflen',
    postalCode: '32108'
  },
  {
    municipality: 'Bad Salzungen',
    postalCode: '36433'
  },
  {
    municipality: 'Bad Salzungen',
    postalCode: '36469'
  },
  {
    municipality: 'Bad Sassendorf',
    postalCode: '59505'
  },
  {
    municipality: 'Bad Saulgau',
    postalCode: '88348'
  },
  {
    municipality: 'Bad Schandau',
    postalCode: '01814'
  },
  {
    municipality: 'Bad Schmiedeberg',
    postalCode: '06905'
  },
  {
    municipality: 'Bad Schönborn',
    postalCode: '76669'
  },
  {
    municipality: 'Bad Schussenried',
    postalCode: '88427'
  },
  {
    municipality: 'Bad Schwalbach',
    postalCode: '65307'
  },
  {
    municipality: 'Bad Schwartau',
    postalCode: '23611'
  },
  {
    municipality: 'Bad Segeberg',
    postalCode: '23795'
  },
  {
    municipality: 'Bad Sobernheim',
    postalCode: '55566'
  },
  {
    municipality: 'Bad Soden',
    postalCode: '65812'
  },
  {
    municipality: 'Bad Soden-Salmünster',
    postalCode: '63628'
  },
  {
    municipality: 'Bad Sooden-Allendorf',
    postalCode: '37242'
  },
  {
    municipality: 'Bad Staffelstein',
    postalCode: '96231'
  },
  {
    municipality: 'Bad Steben',
    postalCode: '95138'
  },
  {
    municipality: 'Bad Sulza',
    postalCode: '99518'
  },
  {
    municipality: 'Bad Sülze',
    postalCode: '18334'
  },
  {
    municipality: 'Bad Tabarz',
    postalCode: '99891'
  },
  {
    municipality: 'Bad Teinach-Zavelstein',
    postalCode: '75385'
  },
  {
    municipality: 'Bad Tennstedt',
    postalCode: '99955'
  },
  {
    municipality: 'Bad Tölz',
    postalCode: '83646'
  },
  {
    municipality: 'Bad Überkingen',
    postalCode: '73337'
  },
  {
    municipality: 'Bad Urach',
    postalCode: '72574'
  },
  {
    municipality: 'Bad Vilbel',
    postalCode: '61118'
  },
  {
    municipality: 'Bad Waldsee',
    postalCode: '88339'
  },
  {
    municipality: 'Bad Wiessee',
    postalCode: '83707'
  },
  {
    municipality: 'Bad Wildbad',
    postalCode: '75323'
  },
  {
    municipality: 'Bad Wildungen',
    postalCode: '34537'
  },
  {
    municipality: 'Bad Wilsnack',
    postalCode: '19336'
  },
  {
    municipality: 'Bad Wimpfen',
    postalCode: '74206'
  },
  {
    municipality: 'Bad Windsheim',
    postalCode: '91438'
  },
  {
    municipality: 'Bad Wörishofen',
    postalCode: '86825'
  },
  {
    municipality: 'Bad Wünnenberg',
    postalCode: '33181'
  },
  {
    municipality: 'Bad Wurzach',
    postalCode: '88410'
  },
  {
    municipality: 'Bad Zwesten',
    postalCode: '34596'
  },
  {
    municipality: 'Bad Zwischenahn',
    postalCode: '26160'
  },
  {
    municipality: 'Baesweiler',
    postalCode: '52499'
  },
  {
    municipality: 'Bahlingen',
    postalCode: '79353'
  },
  {
    municipality: 'Bahrdorf',
    postalCode: '38459'
  },
  {
    municipality: 'Bahrenborstel',
    postalCode: '27245'
  },
  {
    municipality: 'Bahrenfleth',
    postalCode: '25569'
  },
  {
    municipality: 'Bahrenhof',
    postalCode: '23845'
  },
  {
    municipality: 'Bahretal',
    postalCode: '01819'
  },
  {
    municipality: 'Baienfurt',
    postalCode: '88255'
  },
  {
    municipality: 'Baierbach',
    postalCode: '84171'
  },
  {
    municipality: 'Baierbrunn',
    postalCode: '82065'
  },
  {
    municipality: 'Baiern',
    postalCode: '85625'
  },
  {
    municipality: 'Baiersbronn',
    postalCode: '72270'
  },
  {
    municipality: 'Baiersdorf',
    postalCode: '91083'
  },
  {
    municipality: 'Baindt',
    postalCode: '88255'
  },
  {
    municipality: 'Baisweil',
    postalCode: '87650'
  },
  {
    municipality: 'Bäk',
    postalCode: '23909'
  },
  {
    municipality: 'Bakum',
    postalCode: '49456'
  },
  {
    municipality: 'Bälau',
    postalCode: '23881'
  },
  {
    municipality: 'Balderschwang',
    postalCode: '87538'
  },
  {
    municipality: 'Baldringen',
    postalCode: '54314'
  },
  {
    municipality: 'Balduinstein',
    postalCode: '65558'
  },
  {
    municipality: 'Balesfeld',
    postalCode: '54597'
  },
  {
    municipality: 'Balge',
    postalCode: '31609'
  },
  {
    municipality: 'Balgheim',
    postalCode: '78582'
  },
  {
    municipality: 'Balgstädt',
    postalCode: '06632'
  },
  {
    municipality: 'Balingen',
    postalCode: '72336'
  },
  {
    municipality: 'Balje',
    postalCode: '21730'
  },
  {
    municipality: 'Ballendorf',
    postalCode: '89177'
  },
  {
    municipality: 'Ballenstedt',
    postalCode: '06493'
  },
  {
    municipality: 'Ballhausen',
    postalCode: '99955'
  },
  {
    municipality: 'Ballrechten-Dottingen',
    postalCode: '79282'
  },
  {
    municipality: 'Ballstedt',
    postalCode: '99439'
  },
  {
    municipality: 'Balow',
    postalCode: '19300'
  },
  {
    municipality: 'Baltmannsweiler',
    postalCode: '73666'
  },
  {
    municipality: 'Baltrum',
    postalCode: '26579'
  },
  {
    municipality: 'Balve',
    postalCode: '58802'
  },
  {
    municipality: 'Balzhausen',
    postalCode: '86483'
  },
  {
    municipality: 'Balzheim',
    postalCode: '88481'
  },
  {
    municipality: 'Bamberg',
    postalCode: '96047'
  },
  {
    municipality: 'Bamberg',
    postalCode: '96049'
  },
  {
    municipality: 'Bamberg',
    postalCode: '96050'
  },
  {
    municipality: 'Bamberg',
    postalCode: '96052'
  },
  {
    municipality: 'Bammental',
    postalCode: '69245'
  },
  {
    municipality: 'Bandelin',
    postalCode: '17506'
  },
  {
    municipality: 'Bandenitz',
    postalCode: '19230'
  },
  {
    municipality: 'Bann',
    postalCode: '66851'
  },
  {
    municipality: 'Bannberscheid',
    postalCode: '56424'
  },
  {
    municipality: 'Bannewitz',
    postalCode: '01728'
  },
  {
    municipality: 'Banzkow',
    postalCode: '19079'
  },
  {
    municipality: 'Barbelroth',
    postalCode: '76889'
  },
  {
    municipality: 'Barbing',
    postalCode: '93092'
  },
  {
    municipality: 'Barby',
    postalCode: '39240'
  },
  {
    municipality: 'Barby',
    postalCode: '39249'
  },
  {
    municipality: 'Barchfeld-Immelborn',
    postalCode: '36456'
  },
  {
    municipality: 'Bardowick',
    postalCode: '21357'
  },
  {
    municipality: 'Bärenbach',
    postalCode: '55483'
  },
  {
    municipality: 'Bärenbach',
    postalCode: '55758'
  },
  {
    municipality: 'Barenburg',
    postalCode: '27245'
  },
  {
    municipality: 'Barendorf',
    postalCode: '21397'
  },
  {
    municipality: 'Bärenstein',
    postalCode: '09471'
  },
  {
    municipality: 'Bärenthal',
    postalCode: '78580'
  },
  {
    municipality: 'Bargenstedt',
    postalCode: '25704'
  },
  {
    municipality: 'Bargfeld-Stegen',
    postalCode: '23863'
  },
  {
    municipality: 'Bargischow',
    postalCode: '17398'
  },
  {
    municipality: 'Bargstall',
    postalCode: '24806'
  },
  {
    municipality: 'Bargstedt',
    postalCode: '21698'
  },
  {
    municipality: 'Bargstedt',
    postalCode: '24793'
  },
  {
    municipality: 'Bargteheide',
    postalCode: '22941'
  },
  {
    municipality: 'Bargum',
    postalCode: '25842'
  },
  {
    municipality: 'Bark',
    postalCode: '23826'
  },
  {
    municipality: 'Barkelsby',
    postalCode: '24360'
  },
  {
    municipality: 'Barkenholm',
    postalCode: '25791'
  },
  {
    municipality: 'Barkhagen',
    postalCode: '19395'
  },
  {
    municipality: 'Barleben',
    postalCode: '39179'
  },
  {
    municipality: 'Barlt',
    postalCode: '25719'
  },
  {
    municipality: 'Barmissen',
    postalCode: '24245'
  },
  {
    municipality: 'Barmstedt',
    postalCode: '25355'
  },
  {
    municipality: 'Bärnau',
    postalCode: '95671'
  },
  {
    municipality: 'Barnekow',
    postalCode: '23968'
  },
  {
    municipality: 'Barnin',
    postalCode: '19089'
  },
  {
    municipality: 'Barnitz',
    postalCode: '23858'
  },
  {
    municipality: 'Barnstädt',
    postalCode: '06268'
  },
  {
    municipality: 'Barnstedt',
    postalCode: '21406'
  },
  {
    municipality: 'Barnstorf',
    postalCode: '49406'
  },
  {
    municipality: 'Barntrup',
    postalCode: '32683'
  },
  {
    municipality: 'Barsbek',
    postalCode: '24217'
  },
  {
    municipality: 'Barsbüttel',
    postalCode: '22885'
  },
  {
    municipality: 'Barsinghausen',
    postalCode: '30890'
  },
  {
    municipality: 'Barßel',
    postalCode: '26676'
  },
  {
    municipality: 'Bartenshagen-Parkentin',
    postalCode: '18209'
  },
  {
    municipality: 'Barth',
    postalCode: '18356'
  },
  {
    municipality: 'Bartholomä',
    postalCode: '73566'
  },
  {
    municipality: 'Bartow',
    postalCode: '17089'
  },
  {
    municipality: 'Barum',
    postalCode: '29576'
  },
  {
    municipality: 'Barum',
    postalCode: '21357'
  },
  {
    municipality: 'Baruth/Mark',
    postalCode: '15837'
  },
  {
    municipality: 'Barver',
    postalCode: '49453'
  },
  {
    municipality: 'Barwedel',
    postalCode: '38476'
  },
  {
    municipality: 'Barweiler',
    postalCode: '53534'
  },
  {
    municipality: 'Bärweiler',
    postalCode: '55606'
  },
  {
    municipality: 'Basberg',
    postalCode: '54578'
  },
  {
    municipality: 'Basdahl',
    postalCode: '27432'
  },
  {
    municipality: 'Basedow',
    postalCode: '17139'
  },
  {
    municipality: 'Basedow',
    postalCode: '21483'
  },
  {
    municipality: 'Bassenheim',
    postalCode: '56220'
  },
  {
    municipality: 'Bassum',
    postalCode: '27211'
  },
  {
    municipality: 'Bastheim',
    postalCode: '97654'
  },
  {
    municipality: 'Basthorst',
    postalCode: '21493'
  },
  {
    municipality: 'Bastorf',
    postalCode: '18230'
  },
  {
    municipality: 'Battenberg (Eder)',
    postalCode: '35088'
  },
  {
    municipality: 'Battenberg (Pfalz)',
    postalCode: '67271'
  },
  {
    municipality: 'Battweiler',
    postalCode: '66484'
  },
  {
    municipality: 'Baudenbach',
    postalCode: '91460'
  },
  {
    municipality: 'Bauler',
    postalCode: '53534'
  },
  {
    municipality: 'Bauler',
    postalCode: '54673'
  },
  {
    municipality: 'Baumgarten',
    postalCode: '18246'
  },
  {
    municipality: 'Baumholder',
    postalCode: '55774'
  },
  {
    municipality: 'Baunach',
    postalCode: '96148'
  },
  {
    municipality: 'Baunatal',
    postalCode: '34225'
  },
  {
    municipality: 'Bausendorf',
    postalCode: '54538'
  },
  {
    municipality: 'Baustert',
    postalCode: '54636'
  },
  {
    municipality: 'Bautzen - Budyšin',
    postalCode: '02625'
  },
  {
    municipality: 'Bawinkel',
    postalCode: '49844'
  },
  {
    municipality: 'Bayerbach',
    postalCode: '94137'
  },
  {
    municipality: 'Bayerbach b. Ergoldsbach',
    postalCode: '84092'
  },
  {
    municipality: 'Bayerfeld-Steckweiler',
    postalCode: '67808'
  },
  {
    municipality: 'Bayerfeld-Steckweiler',
    postalCode: '67822'
  },
  {
    municipality: 'Bayerisch Eisenstein',
    postalCode: '94252'
  },
  {
    municipality: 'Bayerisch Gmain',
    postalCode: '83457'
  },
  {
    municipality: 'Bayreuth',
    postalCode: '95444'
  },
  {
    municipality: 'Bayreuth',
    postalCode: '95445'
  },
  {
    municipality: 'Bayreuth',
    postalCode: '95447'
  },
  {
    municipality: 'Bayreuth',
    postalCode: '95448'
  },
  {
    municipality: 'Bayrischzell',
    postalCode: '83735'
  },
  {
    municipality: 'Bebensee',
    postalCode: '23816'
  },
  {
    municipality: 'Bebra',
    postalCode: '36179'
  },
  {
    municipality: 'Becheln',
    postalCode: '56132'
  },
  {
    municipality: 'Bechenheim',
    postalCode: '55234'
  },
  {
    municipality: 'Becherbach',
    postalCode: '67827'
  },
  {
    municipality: 'Becherbach bei Kirn',
    postalCode: '55608'
  },
  {
    municipality: 'Bechhofen',
    postalCode: '91572'
  },
  {
    municipality: 'Bechhofen',
    postalCode: '66894'
  },
  {
    municipality: 'Bechstedt',
    postalCode: '07426'
  },
  {
    municipality: 'Bechtheim',
    postalCode: '67595'
  },
  {
    municipality: 'Bechtolsheim',
    postalCode: '55234'
  },
  {
    municipality: 'Bechtsrieth',
    postalCode: '92699'
  },
  {
    municipality: 'Beckdorf',
    postalCode: '21643'
  },
  {
    municipality: 'Beckedorf',
    postalCode: '31699'
  },
  {
    municipality: 'Beckeln',
    postalCode: '27243'
  },
  {
    municipality: 'Beckingen',
    postalCode: '66701'
  },
  {
    municipality: 'Beckum',
    postalCode: '59269'
  },
  {
    municipality: 'Bedburg',
    postalCode: '50181'
  },
  {
    municipality: 'Bedburg-Hau',
    postalCode: '47551'
  },
  {
    municipality: 'Bedesbach',
    postalCode: '66885'
  },
  {
    municipality: 'Beedenbostel',
    postalCode: '29355'
  },
  {
    municipality: 'Beelen',
    postalCode: '48361'
  },
  {
    municipality: 'Beelitz',
    postalCode: '14547'
  },
  {
    municipality: 'Beendorf',
    postalCode: '39343'
  },
  {
    municipality: 'Beeskow',
    postalCode: '15848'
  },
  {
    municipality: 'Beesten',
    postalCode: '49832'
  },
  {
    municipality: 'Beetzendorf',
    postalCode: '38489'
  },
  {
    municipality: 'Beetzsee',
    postalCode: '14778'
  },
  {
    municipality: 'Beetzseeheide',
    postalCode: '14778'
  },
  {
    municipality: 'Beggerow',
    postalCode: '17111'
  },
  {
    municipality: 'Behlendorf',
    postalCode: '23919'
  },
  {
    municipality: 'Behrendorf',
    postalCode: '25850'
  },
  {
    municipality: 'Behrenhoff',
    postalCode: '17498'
  },
  {
    municipality: 'Behren-Lübchin',
    postalCode: '17179'
  },
  {
    municipality: 'Behrensdorf',
    postalCode: '24321'
  },
  {
    municipality: 'Beidenfleth',
    postalCode: '25573'
  },
  {
    municipality: 'Beiersdorf',
    postalCode: '02736'
  },
  {
    municipality: 'Beiersdorf-Freudenberg',
    postalCode: '16259'
  },
  {
    municipality: 'Beierstedt',
    postalCode: '38382'
  },
  {
    municipality: 'Beilingen',
    postalCode: '54662'
  },
  {
    municipality: 'Beilngries',
    postalCode: '92339'
  },
  {
    municipality: 'Beilrode',
    postalCode: '04886'
  },
  {
    municipality: 'Beilstein',
    postalCode: '71543'
  },
  {
    municipality: 'Beilstein',
    postalCode: '71717'
  },
  {
    municipality: 'Beilstein',
    postalCode: '56814'
  },
  {
    municipality: 'Beimerstetten',
    postalCode: '89179'
  },
  {
    municipality: 'Beindersheim',
    postalCode: '67259'
  },
  {
    municipality: 'Beinerstadt',
    postalCode: '98660'
  },
  {
    municipality: 'Beinhausen',
    postalCode: '54552'
  },
  {
    municipality: 'Bekdorf',
    postalCode: '25554'
  },
  {
    municipality: 'Bekmünde',
    postalCode: '25524'
  },
  {
    municipality: 'Bekond',
    postalCode: '54340'
  },
  {
    municipality: 'Belau',
    postalCode: '24601'
  },
  {
    municipality: 'Beldorf',
    postalCode: '25557'
  },
  {
    municipality: 'Beldorf',
    postalCode: '25767'
  },
  {
    municipality: 'Belg',
    postalCode: '56858'
  },
  {
    municipality: 'Belgern-Schildau',
    postalCode: '04874'
  },
  {
    municipality: 'Belgern-Schildau',
    postalCode: '04889'
  },
  {
    municipality: 'Belgershain',
    postalCode: '04683'
  },
  {
    municipality: 'Belgweiler',
    postalCode: '55469'
  },
  {
    municipality: 'Bell',
    postalCode: '56745'
  },
  {
    municipality: 'Bellenberg',
    postalCode: '89287'
  },
  {
    municipality: 'Bellheim',
    postalCode: '76756'
  },
  {
    municipality: 'Bell (Hunsrück)',
    postalCode: '56288'
  },
  {
    municipality: 'Bellingen',
    postalCode: '56459'
  },
  {
    municipality: 'Bellstedt',
    postalCode: '99713'
  },
  {
    municipality: 'Belm',
    postalCode: '49191'
  },
  {
    municipality: 'Belrieth',
    postalCode: '98617'
  },
  {
    municipality: 'Belsch',
    postalCode: '19230'
  },
  {
    municipality: 'Beltheim',
    postalCode: '56290'
  },
  {
    municipality: 'Belum',
    postalCode: '21785'
  },
  {
    municipality: 'Bempflingen',
    postalCode: '72658'
  },
  {
    municipality: 'Bendestorf',
    postalCode: '21227'
  },
  {
    municipality: 'Bendfeld',
    postalCode: '24217'
  },
  {
    municipality: 'Bendorf',
    postalCode: '56170'
  },
  {
    municipality: 'Bendorf',
    postalCode: '25557'
  },
  {
    municipality: 'Benediktbeuern',
    postalCode: '83671'
  },
  {
    municipality: 'Bengel',
    postalCode: '54538'
  },
  {
    municipality: 'Bengerstorf',
    postalCode: '19258'
  },
  {
    municipality: 'Benitz',
    postalCode: '18258'
  },
  {
    municipality: 'Benndorf',
    postalCode: '06308'
  },
  {
    municipality: 'Bennewitz',
    postalCode: '04828'
  },
  {
    municipality: 'Bennhausen',
    postalCode: '67808'
  },
  {
    municipality: 'Benningen',
    postalCode: '87734'
  },
  {
    municipality: 'Benningen am Neckar',
    postalCode: '71726'
  },
  {
    municipality: 'Bensdorf',
    postalCode: '14789'
  },
  {
    municipality: 'Bensheim',
    postalCode: '64625'
  },
  {
    municipality: 'Bentwisch',
    postalCode: '18182'
  },
  {
    municipality: 'Bentzin',
    postalCode: '17129'
  },
  {
    municipality: 'Benz',
    postalCode: '17429'
  },
  {
    municipality: 'Benz',
    postalCode: '23970'
  },
  {
    municipality: 'Benzweiler',
    postalCode: '55494'
  },
  {
    municipality: 'Beratzhausen',
    postalCode: '93176'
  },
  {
    municipality: 'Berching',
    postalCode: '92334'
  },
  {
    municipality: 'Berchtesgaden',
    postalCode: '83471'
  },
  {
    municipality: 'Bereborn',
    postalCode: '56769'
  },
  {
    municipality: 'Berenbach',
    postalCode: '56766'
  },
  {
    municipality: 'Berg',
    postalCode: '56357'
  },
  {
    municipality: 'Berg',
    postalCode: '82335'
  },
  {
    municipality: 'Berg',
    postalCode: '95180'
  },
  {
    municipality: 'Berg',
    postalCode: '53505'
  },
  {
    municipality: 'Berg',
    postalCode: '88276'
  },
  {
    municipality: 'Berga',
    postalCode: '06536'
  },
  {
    municipality: 'Berga/Elster',
    postalCode: '07980'
  },
  {
    municipality: 'Bergatreute',
    postalCode: '88368'
  },
  {
    municipality: 'Berg b.Neumarkt i.d.OPf.',
    postalCode: '92348'
  },
  {
    municipality: 'Berge',
    postalCode: '19348'
  },
  {
    municipality: 'Berge',
    postalCode: '49626'
  },
  {
    municipality: 'Bergen',
    postalCode: '08239'
  },
  {
    municipality: 'Bergen',
    postalCode: '83346'
  },
  {
    municipality: 'Bergen',
    postalCode: '91790'
  },
  {
    municipality: 'Bergen',
    postalCode: '55608'
  },
  {
    municipality: 'Bergen',
    postalCode: '29303'
  },
  {
    municipality: 'Bergen an der Dumme',
    postalCode: '29468'
  },
  {
    municipality: 'Bergen auf Rügen',
    postalCode: '18528'
  },
  {
    municipality: 'Bergenhausen',
    postalCode: '55469'
  },
  {
    municipality: 'Bergenhusen',
    postalCode: '24861'
  },
  {
    municipality: 'Bergewöhrden',
    postalCode: '25779'
  },
  {
    municipality: 'Bergfeld',
    postalCode: '38467'
  },
  {
    municipality: 'Berghaupten',
    postalCode: '77791'
  },
  {
    municipality: 'Berghausen',
    postalCode: '56368'
  },
  {
    municipality: 'Bergheim',
    postalCode: '50126'
  },
  {
    municipality: 'Bergheim',
    postalCode: '50127'
  },
  {
    municipality: 'Bergheim',
    postalCode: '50129'
  },
  {
    municipality: 'Bergheim',
    postalCode: '86673'
  },
  {
    municipality: 'Bergholz',
    postalCode: '17321'
  },
  {
    municipality: 'Berghülen',
    postalCode: '89180'
  },
  {
    municipality: 'Berg im Gau',
    postalCode: '86562'
  },
  {
    municipality: 'Bergisch Gladbach',
    postalCode: '51427'
  },
  {
    municipality: 'Bergisch Gladbach',
    postalCode: '51429'
  },
  {
    municipality: 'Bergisch Gladbach',
    postalCode: '51465'
  },
  {
    municipality: 'Bergisch Gladbach',
    postalCode: '51467'
  },
  {
    municipality: 'Bergisch Gladbach',
    postalCode: '51469'
  },
  {
    municipality: 'Bergkamen',
    postalCode: '59192'
  },
  {
    municipality: 'Bergkirchen',
    postalCode: '85232'
  },
  {
    municipality: 'Berglangenbach',
    postalCode: '55776'
  },
  {
    municipality: 'Berglen',
    postalCode: '73663'
  },
  {
    municipality: 'Berglern',
    postalCode: '85459'
  },
  {
    municipality: 'Berglicht',
    postalCode: '54426'
  },
  {
    municipality: 'Bergneustadt',
    postalCode: '51702'
  },
  {
    municipality: 'Berg (Pfalz)',
    postalCode: '76768'
  },
  {
    municipality: 'Bergrheinfeld',
    postalCode: '97493'
  },
  {
    municipality: 'Bergtheim',
    postalCode: '97241'
  },
  {
    municipality: 'Bergweiler',
    postalCode: '54518'
  },
  {
    municipality: 'Beringstedt',
    postalCode: '25575'
  },
  {
    municipality: 'Berkatal',
    postalCode: '37297'
  },
  {
    municipality: 'Berka vor dem Hainich',
    postalCode: '99826'
  },
  {
    municipality: 'Berkenbrück',
    postalCode: '15518'
  },
  {
    municipality: 'Berkenthin',
    postalCode: '23919'
  },
  {
    municipality: 'Berkheim',
    postalCode: '88450'
  },
  {
    municipality: 'Berkholz-Meyenburg',
    postalCode: '16306'
  },
  {
    municipality: 'Berkoth',
    postalCode: '54673'
  },
  {
    municipality: 'Berlin',
    postalCode: '10115'
  },
  {
    municipality: 'Berlin',
    postalCode: '10117'
  },
  {
    municipality: 'Berlin',
    postalCode: '10119'
  },
  {
    municipality: 'Berlin',
    postalCode: '10178'
  },
  {
    municipality: 'Berlin',
    postalCode: '10179'
  },
  {
    municipality: 'Berlin',
    postalCode: '10243'
  },
  {
    municipality: 'Berlin',
    postalCode: '10245'
  },
  {
    municipality: 'Berlin',
    postalCode: '10247'
  },
  {
    municipality: 'Berlin',
    postalCode: '10249'
  },
  {
    municipality: 'Berlin',
    postalCode: '10315'
  },
  {
    municipality: 'Berlin',
    postalCode: '10317'
  },
  {
    municipality: 'Berlin',
    postalCode: '10318'
  },
  {
    municipality: 'Berlin',
    postalCode: '10319'
  },
  {
    municipality: 'Berlin',
    postalCode: '10365'
  },
  {
    municipality: 'Berlin',
    postalCode: '10367'
  },
  {
    municipality: 'Berlin',
    postalCode: '10369'
  },
  {
    municipality: 'Berlin',
    postalCode: '10405'
  },
  {
    municipality: 'Berlin',
    postalCode: '10407'
  },
  {
    municipality: 'Berlin',
    postalCode: '10409'
  },
  {
    municipality: 'Berlin',
    postalCode: '10435'
  },
  {
    municipality: 'Berlin',
    postalCode: '10437'
  },
  {
    municipality: 'Berlin',
    postalCode: '10439'
  },
  {
    municipality: 'Berlin',
    postalCode: '10551'
  },
  {
    municipality: 'Berlin',
    postalCode: '10553'
  },
  {
    municipality: 'Berlin',
    postalCode: '10555'
  },
  {
    municipality: 'Berlin',
    postalCode: '10557'
  },
  {
    municipality: 'Berlin',
    postalCode: '10559'
  },
  {
    municipality: 'Berlin',
    postalCode: '10585'
  },
  {
    municipality: 'Berlin',
    postalCode: '10587'
  },
  {
    municipality: 'Berlin',
    postalCode: '10589'
  },
  {
    municipality: 'Berlin',
    postalCode: '10623'
  },
  {
    municipality: 'Berlin',
    postalCode: '10625'
  },
  {
    municipality: 'Berlin',
    postalCode: '10627'
  },
  {
    municipality: 'Berlin',
    postalCode: '10629'
  },
  {
    municipality: 'Berlin',
    postalCode: '10707'
  },
  {
    municipality: 'Berlin',
    postalCode: '10709'
  },
  {
    municipality: 'Berlin',
    postalCode: '10711'
  },
  {
    municipality: 'Berlin',
    postalCode: '10713'
  },
  {
    municipality: 'Berlin',
    postalCode: '10715'
  },
  {
    municipality: 'Berlin',
    postalCode: '10717'
  },
  {
    municipality: 'Berlin',
    postalCode: '10719'
  },
  {
    municipality: 'Berlin',
    postalCode: '10777'
  },
  {
    municipality: 'Berlin',
    postalCode: '10779'
  },
  {
    municipality: 'Berlin',
    postalCode: '10781'
  },
  {
    municipality: 'Berlin',
    postalCode: '10783'
  },
  {
    municipality: 'Berlin',
    postalCode: '10785'
  },
  {
    municipality: 'Berlin',
    postalCode: '10787'
  },
  {
    municipality: 'Berlin',
    postalCode: '10789'
  },
  {
    municipality: 'Berlin',
    postalCode: '10823'
  },
  {
    municipality: 'Berlin',
    postalCode: '10825'
  },
  {
    municipality: 'Berlin',
    postalCode: '10827'
  },
  {
    municipality: 'Berlin',
    postalCode: '10829'
  },
  {
    municipality: 'Berlin',
    postalCode: '10961'
  },
  {
    municipality: 'Berlin',
    postalCode: '10963'
  },
  {
    municipality: 'Berlin',
    postalCode: '10965'
  },
  {
    municipality: 'Berlin',
    postalCode: '10967'
  },
  {
    municipality: 'Berlin',
    postalCode: '10969'
  },
  {
    municipality: 'Berlin',
    postalCode: '10997'
  },
  {
    municipality: 'Berlin',
    postalCode: '10999'
  },
  {
    municipality: 'Berlin',
    postalCode: '12043'
  },
  {
    municipality: 'Berlin',
    postalCode: '12045'
  },
  {
    municipality: 'Berlin',
    postalCode: '12047'
  },
  {
    municipality: 'Berlin',
    postalCode: '12049'
  },
  {
    municipality: 'Berlin',
    postalCode: '12051'
  },
  {
    municipality: 'Berlin',
    postalCode: '12053'
  },
  {
    municipality: 'Berlin',
    postalCode: '12055'
  },
  {
    municipality: 'Berlin',
    postalCode: '12057'
  },
  {
    municipality: 'Berlin',
    postalCode: '12059'
  },
  {
    municipality: 'Berlin',
    postalCode: '12099'
  },
  {
    municipality: 'Berlin',
    postalCode: '12101'
  },
  {
    municipality: 'Berlin',
    postalCode: '12103'
  },
  {
    municipality: 'Berlin',
    postalCode: '12105'
  },
  {
    municipality: 'Berlin',
    postalCode: '12107'
  },
  {
    municipality: 'Berlin',
    postalCode: '12109'
  },
  {
    municipality: 'Berlin',
    postalCode: '12157'
  },
  {
    municipality: 'Berlin',
    postalCode: '12159'
  },
  {
    municipality: 'Berlin',
    postalCode: '12161'
  },
  {
    municipality: 'Berlin',
    postalCode: '12163'
  },
  {
    municipality: 'Berlin',
    postalCode: '12165'
  },
  {
    municipality: 'Berlin',
    postalCode: '12167'
  },
  {
    municipality: 'Berlin',
    postalCode: '12169'
  },
  {
    municipality: 'Berlin',
    postalCode: '12203'
  },
  {
    municipality: 'Berlin',
    postalCode: '12205'
  },
  {
    municipality: 'Berlin',
    postalCode: '12207'
  },
  {
    municipality: 'Berlin',
    postalCode: '12209'
  },
  {
    municipality: 'Berlin',
    postalCode: '12247'
  },
  {
    municipality: 'Berlin',
    postalCode: '12249'
  },
  {
    municipality: 'Berlin',
    postalCode: '12277'
  },
  {
    municipality: 'Berlin',
    postalCode: '12279'
  },
  {
    municipality: 'Berlin',
    postalCode: '12305'
  },
  {
    municipality: 'Berlin',
    postalCode: '12307'
  },
  {
    municipality: 'Berlin',
    postalCode: '12309'
  },
  {
    municipality: 'Berlin',
    postalCode: '12347'
  },
  {
    municipality: 'Berlin',
    postalCode: '12349'
  },
  {
    municipality: 'Berlin',
    postalCode: '12351'
  },
  {
    municipality: 'Berlin',
    postalCode: '12353'
  },
  {
    municipality: 'Berlin',
    postalCode: '12355'
  },
  {
    municipality: 'Berlin',
    postalCode: '12357'
  },
  {
    municipality: 'Berlin',
    postalCode: '12359'
  },
  {
    municipality: 'Berlin',
    postalCode: '12435'
  },
  {
    municipality: 'Berlin',
    postalCode: '12437'
  },
  {
    municipality: 'Berlin',
    postalCode: '12439'
  },
  {
    municipality: 'Berlin',
    postalCode: '12459'
  },
  {
    municipality: 'Berlin',
    postalCode: '12487'
  },
  {
    municipality: 'Berlin',
    postalCode: '12489'
  },
  {
    municipality: 'Berlin',
    postalCode: '12524'
  },
  {
    municipality: 'Berlin',
    postalCode: '12526'
  },
  {
    municipality: 'Berlin',
    postalCode: '12527'
  },
  {
    municipality: 'Berlin',
    postalCode: '12555'
  },
  {
    municipality: 'Berlin',
    postalCode: '12557'
  },
  {
    municipality: 'Berlin',
    postalCode: '12559'
  },
  {
    municipality: 'Berlin',
    postalCode: '12587'
  },
  {
    municipality: 'Berlin',
    postalCode: '12589'
  },
  {
    municipality: 'Berlin',
    postalCode: '12619'
  },
  {
    municipality: 'Berlin',
    postalCode: '12621'
  },
  {
    municipality: 'Berlin',
    postalCode: '12623'
  },
  {
    municipality: 'Berlin',
    postalCode: '12627'
  },
  {
    municipality: 'Berlin',
    postalCode: '12629'
  },
  {
    municipality: 'Berlin',
    postalCode: '12679'
  },
  {
    municipality: 'Berlin',
    postalCode: '12681'
  },
  {
    municipality: 'Berlin',
    postalCode: '12683'
  },
  {
    municipality: 'Berlin',
    postalCode: '12685'
  },
  {
    municipality: 'Berlin',
    postalCode: '12687'
  },
  {
    municipality: 'Berlin',
    postalCode: '12689'
  },
  {
    municipality: 'Berlin',
    postalCode: '13051'
  },
  {
    municipality: 'Berlin',
    postalCode: '13053'
  },
  {
    municipality: 'Berlin',
    postalCode: '13055'
  },
  {
    municipality: 'Berlin',
    postalCode: '13057'
  },
  {
    municipality: 'Berlin',
    postalCode: '13059'
  },
  {
    municipality: 'Berlin',
    postalCode: '13086'
  },
  {
    municipality: 'Berlin',
    postalCode: '13088'
  },
  {
    municipality: 'Berlin',
    postalCode: '13089'
  },
  {
    municipality: 'Berlin',
    postalCode: '13125'
  },
  {
    municipality: 'Berlin',
    postalCode: '13127'
  },
  {
    municipality: 'Berlin',
    postalCode: '13129'
  },
  {
    municipality: 'Berlin',
    postalCode: '13156'
  },
  {
    municipality: 'Berlin',
    postalCode: '13158'
  },
  {
    municipality: 'Berlin',
    postalCode: '13159'
  },
  {
    municipality: 'Berlin',
    postalCode: '13187'
  },
  {
    municipality: 'Berlin',
    postalCode: '13189'
  },
  {
    municipality: 'Berlin',
    postalCode: '13347'
  },
  {
    municipality: 'Berlin',
    postalCode: '13349'
  },
  {
    municipality: 'Berlin',
    postalCode: '13351'
  },
  {
    municipality: 'Berlin',
    postalCode: '13353'
  },
  {
    municipality: 'Berlin',
    postalCode: '13355'
  },
  {
    municipality: 'Berlin',
    postalCode: '13357'
  },
  {
    municipality: 'Berlin',
    postalCode: '13359'
  },
  {
    municipality: 'Berlin',
    postalCode: '13403'
  },
  {
    municipality: 'Berlin',
    postalCode: '13405'
  },
  {
    municipality: 'Berlin',
    postalCode: '13407'
  },
  {
    municipality: 'Berlin',
    postalCode: '13409'
  },
  {
    municipality: 'Berlin',
    postalCode: '13435'
  },
  {
    municipality: 'Berlin',
    postalCode: '13437'
  },
  {
    municipality: 'Berlin',
    postalCode: '13439'
  },
  {
    municipality: 'Berlin',
    postalCode: '13465'
  },
  {
    municipality: 'Berlin',
    postalCode: '13467'
  },
  {
    municipality: 'Berlin',
    postalCode: '13469'
  },
  {
    municipality: 'Berlin',
    postalCode: '13503'
  },
  {
    municipality: 'Berlin',
    postalCode: '13505'
  },
  {
    municipality: 'Berlin',
    postalCode: '13507'
  },
  {
    municipality: 'Berlin',
    postalCode: '13509'
  },
  {
    municipality: 'Berlin',
    postalCode: '13581'
  },
  {
    municipality: 'Berlin',
    postalCode: '13583'
  },
  {
    municipality: 'Berlin',
    postalCode: '13585'
  },
  {
    municipality: 'Berlin',
    postalCode: '13587'
  },
  {
    municipality: 'Berlin',
    postalCode: '13589'
  },
  {
    municipality: 'Berlin',
    postalCode: '13591'
  },
  {
    municipality: 'Berlin',
    postalCode: '13593'
  },
  {
    municipality: 'Berlin',
    postalCode: '13595'
  },
  {
    municipality: 'Berlin',
    postalCode: '13597'
  },
  {
    municipality: 'Berlin',
    postalCode: '13599'
  },
  {
    municipality: 'Berlin',
    postalCode: '13627'
  },
  {
    municipality: 'Berlin',
    postalCode: '13629'
  },
  {
    municipality: 'Berlin',
    postalCode: '14050'
  },
  {
    municipality: 'Berlin',
    postalCode: '14052'
  },
  {
    municipality: 'Berlin',
    postalCode: '14053'
  },
  {
    municipality: 'Berlin',
    postalCode: '14055'
  },
  {
    municipality: 'Berlin',
    postalCode: '14057'
  },
  {
    municipality: 'Berlin',
    postalCode: '14059'
  },
  {
    municipality: 'Berlin',
    postalCode: '14089'
  },
  {
    municipality: 'Berlin',
    postalCode: '14109'
  },
  {
    municipality: 'Berlin',
    postalCode: '14129'
  },
  {
    municipality: 'Berlin',
    postalCode: '14163'
  },
  {
    municipality: 'Berlin',
    postalCode: '14165'
  },
  {
    municipality: 'Berlin',
    postalCode: '14167'
  },
  {
    municipality: 'Berlin',
    postalCode: '14169'
  },
  {
    municipality: 'Berlin',
    postalCode: '14193'
  },
  {
    municipality: 'Berlin',
    postalCode: '14195'
  },
  {
    municipality: 'Berlin',
    postalCode: '14197'
  },
  {
    municipality: 'Berlin',
    postalCode: '14199'
  },
  {
    municipality: 'Berlingen',
    postalCode: '54570'
  },
  {
    municipality: 'Berlingerode',
    postalCode: '37339'
  },
  {
    municipality: 'Bermatingen',
    postalCode: '88697'
  },
  {
    municipality: 'Bermel',
    postalCode: '56729'
  },
  {
    municipality: 'Bermersheim',
    postalCode: '67593'
  },
  {
    municipality: 'Bermersheim vor der Höhe',
    postalCode: '55234'
  },
  {
    municipality: 'Bernau',
    postalCode: '16321'
  },
  {
    municipality: 'Bernau am Chiemsee',
    postalCode: '83233'
  },
  {
    municipality: 'Bernau im Schwarzwald',
    postalCode: '79872'
  },
  {
    municipality: 'Bernbeuren',
    postalCode: '86975'
  },
  {
    municipality: 'Bernburg',
    postalCode: '06406'
  },
  {
    municipality: 'Berndorf',
    postalCode: '54578'
  },
  {
    municipality: 'Berndroth',
    postalCode: '56370'
  },
  {
    municipality: 'Berne',
    postalCode: '27804'
  },
  {
    municipality: 'Berngau',
    postalCode: '92361'
  },
  {
    municipality: 'Bernhardswald',
    postalCode: '93170'
  },
  {
    municipality: 'Bernitt',
    postalCode: '18246'
  },
  {
    municipality: 'Bernitt',
    postalCode: '18249'
  },
  {
    municipality: 'Bernkastel-Kues',
    postalCode: '54470'
  },
  {
    municipality: 'Bernkastel-Kues',
    postalCode: '54492'
  },
  {
    municipality: 'Bernried',
    postalCode: '94505'
  },
  {
    municipality: 'Bernried am Starnberger See',
    postalCode: '82347'
  },
  {
    municipality: 'Bernsdorf',
    postalCode: '09337'
  },
  {
    municipality: 'Bernsdorf',
    postalCode: '02994'
  },
  {
    municipality: 'Bernstadt',
    postalCode: '89182'
  },
  {
    municipality: 'Bernstadt auf dem Eigen',
    postalCode: '02748'
  },
  {
    municipality: 'Bernstorf',
    postalCode: '23936'
  },
  {
    municipality: 'Berod bei Hachenburg',
    postalCode: '57614'
  },
  {
    municipality: 'Berod bei Wallmerod',
    postalCode: '56414'
  },
  {
    municipality: 'Berscheid',
    postalCode: '54673'
  },
  {
    municipality: 'Berschweiler bei Baumholder',
    postalCode: '55777'
  },
  {
    municipality: 'Berschweiler bei Kirn',
    postalCode: '55608'
  },
  {
    municipality: 'Bersenbrück',
    postalCode: '49593'
  },
  {
    municipality: 'Bersteland',
    postalCode: '15910'
  },
  {
    municipality: 'Bertsdorf-Hörnitz',
    postalCode: '02763'
  },
  {
    municipality: 'Berumbur',
    postalCode: '26524'
  },
  {
    municipality: 'Berzhahn',
    postalCode: '56459'
  },
  {
    municipality: 'Berzhausen',
    postalCode: '57632'
  },
  {
    municipality: 'Bescheid',
    postalCode: '54413'
  },
  {
    municipality: 'Beschendorf',
    postalCode: '23738'
  },
  {
    municipality: 'Besdorf',
    postalCode: '25584'
  },
  {
    municipality: 'Beselich',
    postalCode: '65614'
  },
  {
    municipality: 'Besenthal',
    postalCode: '23899'
  },
  {
    municipality: 'Beseritz',
    postalCode: '17039'
  },
  {
    municipality: 'Besigheim',
    postalCode: '74354'
  },
  {
    municipality: 'Besitz',
    postalCode: '19258'
  },
  {
    municipality: 'Bessenbach',
    postalCode: '63856'
  },
  {
    municipality: 'Bestensee',
    postalCode: '15741'
  },
  {
    municipality: 'Bestwig',
    postalCode: '59909'
  },
  {
    municipality: 'Bethenhausen',
    postalCode: '07554'
  },
  {
    municipality: 'Betteldorf',
    postalCode: '54570'
  },
  {
    municipality: 'Bettendorf',
    postalCode: '56355'
  },
  {
    municipality: 'Bettenfeld',
    postalCode: '54533'
  },
  {
    municipality: 'Bettingen',
    postalCode: '54646'
  },
  {
    municipality: 'Betzdorf',
    postalCode: '57518'
  },
  {
    municipality: 'Betzendorf',
    postalCode: '21386'
  },
  {
    municipality: 'Betzenstein',
    postalCode: '91282'
  },
  {
    municipality: 'Betzenweiler',
    postalCode: '88422'
  },
  {
    municipality: 'Betzigau',
    postalCode: '87488'
  },
  {
    municipality: 'Beulich',
    postalCode: '56283'
  },
  {
    municipality: 'Beuren',
    postalCode: '56825'
  },
  {
    municipality: 'Beuren',
    postalCode: '72660'
  },
  {
    municipality: 'Beuren (Hochwald)',
    postalCode: '54413'
  },
  {
    municipality: 'Beuron',
    postalCode: '88631'
  },
  {
    municipality: 'Beutelsbach',
    postalCode: '94501'
  },
  {
    municipality: 'Bevern',
    postalCode: '25355'
  },
  {
    municipality: 'Bevern',
    postalCode: '37639'
  },
  {
    municipality: 'Beverstedt',
    postalCode: '27616'
  },
  {
    municipality: 'Beverungen',
    postalCode: '37688'
  },
  {
    municipality: 'Bexbach',
    postalCode: '66450'
  },
  {
    municipality: 'Biberach',
    postalCode: '77781'
  },
  {
    municipality: 'Biberach an der Riß',
    postalCode: '88400'
  },
  {
    municipality: 'Biberbach',
    postalCode: '86485'
  },
  {
    municipality: 'Bibertal',
    postalCode: '89346'
  },
  {
    municipality: 'Biblis',
    postalCode: '68647'
  },
  {
    municipality: 'Bibow',
    postalCode: '19417'
  },
  {
    municipality: 'Bibra',
    postalCode: '07768'
  },
  {
    municipality: 'Biburg',
    postalCode: '93354'
  },
  {
    municipality: 'Bichl',
    postalCode: '83673'
  },
  {
    municipality: 'Bickenbach',
    postalCode: '64404'
  },
  {
    municipality: 'Bickenbach',
    postalCode: '56291'
  },
  {
    municipality: 'Bickendorf',
    postalCode: '54636'
  },
  {
    municipality: 'Bidingen',
    postalCode: '87651'
  },
  {
    municipality: 'Biebelnheim',
    postalCode: '55234'
  },
  {
    municipality: 'Biebelried',
    postalCode: '97318'
  },
  {
    municipality: 'Biebelsheim',
    postalCode: '55546'
  },
  {
    municipality: 'Bieberehren',
    postalCode: '97243'
  },
  {
    municipality: 'Biebergemünd',
    postalCode: '63599'
  },
  {
    municipality: 'Biebern',
    postalCode: '55471'
  },
  {
    municipality: 'Biebertal',
    postalCode: '35444'
  },
  {
    municipality: 'Biebesheim',
    postalCode: '64584'
  },
  {
    municipality: 'Biebrich',
    postalCode: '56370'
  },
  {
    municipality: 'Biedenkopf',
    postalCode: '35216'
  },
  {
    municipality: 'Biederbach',
    postalCode: '79215'
  },
  {
    municipality: 'Biederitz',
    postalCode: '39175'
  },
  {
    municipality: 'Biedershausen',
    postalCode: '66917'
  },
  {
    municipality: 'Biedesheim',
    postalCode: '67308'
  },
  {
    municipality: 'Bielefeld',
    postalCode: '33602'
  },
  {
    municipality: 'Bielefeld',
    postalCode: '33604'
  },
  {
    municipality: 'Bielefeld',
    postalCode: '33605'
  },
  {
    municipality: 'Bielefeld',
    postalCode: '33607'
  },
  {
    municipality: 'Bielefeld',
    postalCode: '33609'
  },
  {
    municipality: 'Bielefeld',
    postalCode: '33611'
  },
  {
    municipality: 'Bielefeld',
    postalCode: '33613'
  },
  {
    municipality: 'Bielefeld',
    postalCode: '33615'
  },
  {
    municipality: 'Bielefeld',
    postalCode: '33617'
  },
  {
    municipality: 'Bielefeld',
    postalCode: '33619'
  },
  {
    municipality: 'Bielefeld',
    postalCode: '33647'
  },
  {
    municipality: 'Bielefeld',
    postalCode: '33649'
  },
  {
    municipality: 'Bielefeld',
    postalCode: '33659'
  },
  {
    municipality: 'Bielefeld',
    postalCode: '33689'
  },
  {
    municipality: 'Bielefeld',
    postalCode: '33699'
  },
  {
    municipality: 'Bielefeld',
    postalCode: '33719'
  },
  {
    municipality: 'Bielefeld',
    postalCode: '33729'
  },
  {
    municipality: 'Bielefeld',
    postalCode: '33739'
  },
  {
    municipality: 'Biendorf',
    postalCode: '18230'
  },
  {
    municipality: 'Bienenbüttel',
    postalCode: '29553'
  },
  {
    municipality: 'Bienstädt',
    postalCode: '99100'
  },
  {
    municipality: 'Biersdorf am See',
    postalCode: '54636'
  },
  {
    municipality: 'Biesdorf',
    postalCode: '54675'
  },
  {
    municipality: 'Biesenthal',
    postalCode: '16359'
  },
  {
    municipality: 'Biessenhofen',
    postalCode: '87640'
  },
  {
    municipality: 'Bietigheim',
    postalCode: '76467'
  },
  {
    municipality: 'Bietigheim-Bissingen',
    postalCode: '74321'
  },
  {
    municipality: 'Bilkheim',
    postalCode: '56414'
  },
  {
    municipality: 'Billerbeck',
    postalCode: '48727'
  },
  {
    municipality: 'Billigheim',
    postalCode: '74842'
  },
  {
    municipality: 'Billigheim-Ingenheim',
    postalCode: '76831'
  },
  {
    municipality: 'Bilsen',
    postalCode: '25485'
  },
  {
    municipality: 'Bilshausen',
    postalCode: '37434'
  },
  {
    municipality: 'Bimöhlen',
    postalCode: '24576'
  },
  {
    municipality: 'Binau',
    postalCode: '74862'
  },
  {
    municipality: 'Bindlach',
    postalCode: '95463'
  },
  {
    municipality: 'Bingen',
    postalCode: '72511'
  },
  {
    municipality: 'Bingen am Rhein',
    postalCode: '55411'
  },
  {
    municipality: 'Binnen',
    postalCode: '31619'
  },
  {
    municipality: 'Binningen',
    postalCode: '56754'
  },
  {
    municipality: 'Binsfeld',
    postalCode: '54518'
  },
  {
    municipality: 'Binswangen',
    postalCode: '86637'
  },
  {
    municipality: 'Binz',
    postalCode: '18609'
  },
  {
    municipality: 'Binzen',
    postalCode: '79589'
  },
  {
    municipality: 'Bippen',
    postalCode: '49626'
  },
  {
    municipality: 'Birenbach',
    postalCode: '73102'
  },
  {
    municipality: 'Birgel',
    postalCode: '54587'
  },
  {
    municipality: 'Birgland',
    postalCode: '92262'
  },
  {
    municipality: 'Birkenau',
    postalCode: '69488'
  },
  {
    municipality: 'Birkenbeul',
    postalCode: '57589'
  },
  {
    municipality: 'Birkenfeld',
    postalCode: '75217'
  },
  {
    municipality: 'Birkenfeld',
    postalCode: '97834'
  },
  {
    municipality: 'Birkenfeld',
    postalCode: '55765'
  },
  {
    municipality: 'Birkenfelde',
    postalCode: '37318'
  },
  {
    municipality: 'Birkenheide',
    postalCode: '67134'
  },
  {
    municipality: 'Birken-Honigsessen',
    postalCode: '57587'
  },
  {
    municipality: 'Birkenhördt',
    postalCode: '76889'
  },
  {
    municipality: 'Birkenwerder',
    postalCode: '16547'
  },
  {
    municipality: 'Birkheim',
    postalCode: '56291'
  },
  {
    municipality: 'Birkweiler',
    postalCode: '76831'
  },
  {
    municipality: 'Birlenbach',
    postalCode: '65626'
  },
  {
    municipality: 'Birnbach',
    postalCode: '57612'
  },
  {
    municipality: 'Birresborn',
    postalCode: '54574'
  },
  {
    municipality: 'Birstein',
    postalCode: '63633'
  },
  {
    municipality: 'Birtlingen',
    postalCode: '54634'
  },
  {
    municipality: 'Birx',
    postalCode: '98634'
  },
  {
    municipality: 'Bischberg',
    postalCode: '96120'
  },
  {
    municipality: 'Bischbrunn',
    postalCode: '97836'
  },
  {
    municipality: 'Bischbrunn',
    postalCode: '97852'
  },
  {
    municipality: 'Bischheim',
    postalCode: '67294'
  },
  {
    municipality: 'Bischoffen',
    postalCode: '35649'
  },
  {
    municipality: 'Bischofrod',
    postalCode: '98553'
  },
  {
    municipality: 'Bischofroda',
    postalCode: '99826'
  },
  {
    municipality: 'Bischofsgrün',
    postalCode: '95493'
  },
  {
    municipality: 'Bischofsheim',
    postalCode: '65474'
  },
  {
    municipality: 'Bischofsheim i.d.Rhön',
    postalCode: '97653'
  },
  {
    municipality: 'Bischofsmais',
    postalCode: '94253'
  },
  {
    municipality: 'Bischofswerda',
    postalCode: '01877'
  },
  {
    municipality: 'Bischofswiesen',
    postalCode: '83483'
  },
  {
    municipality: 'Bischweier',
    postalCode: '76476'
  },
  {
    municipality: 'Bisingen',
    postalCode: '72406'
  },
  {
    municipality: 'Bismark (Altmark)',
    postalCode: '39628'
  },
  {
    municipality: 'Bismark (Altmark)',
    postalCode: '39629'
  },
  {
    municipality: 'Bispingen',
    postalCode: '29646'
  },
  {
    municipality: 'Bissee',
    postalCode: '24582'
  },
  {
    municipality: 'Bissendorf',
    postalCode: '49143'
  },
  {
    municipality: 'Bissersheim',
    postalCode: '67281'
  },
  {
    municipality: 'Bissingen',
    postalCode: '86657'
  },
  {
    municipality: 'Bissingen an der Teck',
    postalCode: '73266'
  },
  {
    municipality: 'Bisterschied',
    postalCode: '67806'
  },
  {
    municipality: 'Bitburg',
    postalCode: '54634'
  },
  {
    municipality: 'Bitterfeld-Wolfen',
    postalCode: '06749'
  },
  {
    municipality: 'Bitterfeld-Wolfen',
    postalCode: '06766'
  },
  {
    municipality: 'Bitterfeld-Wolfen',
    postalCode: '06803'
  },
  {
    municipality: 'Bitterfeld-Wolfen',
    postalCode: '06808'
  },
  {
    municipality: 'Bitz',
    postalCode: '72475'
  },
  {
    municipality: 'Bitzen',
    postalCode: '57539'
  },
  {
    municipality: 'Blaibach',
    postalCode: '93476'
  },
  {
    municipality: 'Blaichach',
    postalCode: '87544'
  },
  {
    municipality: 'Blankenbach',
    postalCode: '63825'
  },
  {
    municipality: 'Blankenberg',
    postalCode: '19412'
  },
  {
    municipality: 'Blankenburg',
    postalCode: '06502'
  },
  {
    municipality: 'Blankenburg',
    postalCode: '38889'
  },
  {
    municipality: 'Blankenburg',
    postalCode: '38895'
  },
  {
    municipality: 'Blankenburg',
    postalCode: '99955'
  },
  {
    municipality: 'Blankenfelde-Mahlow',
    postalCode: '15827'
  },
  {
    municipality: 'Blankenfelde-Mahlow',
    postalCode: '15831'
  },
  {
    municipality: 'Blankenhagen',
    postalCode: '18182'
  },
  {
    municipality: 'Blankenhain',
    postalCode: '99444'
  },
  {
    municipality: 'Blankenheim',
    postalCode: '53945'
  },
  {
    municipality: 'Blankenheim',
    postalCode: '06528'
  },
  {
    municipality: 'Blankenhof',
    postalCode: '17039'
  },
  {
    municipality: 'Blankenrath',
    postalCode: '56865'
  },
  {
    municipality: 'Blankensee',
    postalCode: '17322'
  },
  {
    municipality: 'Blankensee',
    postalCode: '17237'
  },
  {
    municipality: 'Blaubach',
    postalCode: '66869'
  },
  {
    municipality: 'Blaubeuren',
    postalCode: '89143'
  },
  {
    municipality: 'Blaufelden',
    postalCode: '74572'
  },
  {
    municipality: 'Blaustein',
    postalCode: '89134'
  },
  {
    municipality: 'Bleckede',
    postalCode: '19273'
  },
  {
    municipality: 'Bleckede',
    postalCode: '21354'
  },
  {
    municipality: 'Bleckhausen',
    postalCode: '54570'
  },
  {
    municipality: 'Bleialf',
    postalCode: '54608'
  },
  {
    municipality: 'Bleicherode',
    postalCode: '99752'
  },
  {
    municipality: 'Blekendorf',
    postalCode: '24327'
  },
  {
    municipality: 'Blender',
    postalCode: '27337'
  },
  {
    municipality: 'Blesewitz',
    postalCode: '17392'
  },
  {
    municipality: 'Bleyen-Genschmar',
    postalCode: '15328'
  },
  {
    municipality: 'Bliedersdorf',
    postalCode: '21640'
  },
  {
    municipality: 'Bliesdorf',
    postalCode: '16269'
  },
  {
    municipality: 'Blieskastel',
    postalCode: '66440'
  },
  {
    municipality: 'Bliestorf',
    postalCode: '23847'
  },
  {
    municipality: 'Blievenstorf',
    postalCode: '19306'
  },
  {
    municipality: 'Blindheim',
    postalCode: '89434'
  },
  {
    municipality: 'Blomberg',
    postalCode: '32825'
  },
  {
    municipality: 'Blomberg',
    postalCode: '26487'
  },
  {
    municipality: 'Blomesche Wildnis',
    postalCode: '25348'
  },
  {
    municipality: 'Blowatz',
    postalCode: '23974'
  },
  {
    municipality: 'Blumberg',
    postalCode: '78176'
  },
  {
    municipality: 'Blumenholz',
    postalCode: '17237'
  },
  {
    municipality: 'Blumenthal',
    postalCode: '24241'
  },
  {
    municipality: 'Blunk',
    postalCode: '23813'
  },
  {
    municipality: 'Bobeck',
    postalCode: '07646'
  },
  {
    municipality: 'Bobenheim am Berg',
    postalCode: '67273'
  },
  {
    municipality: 'Bobenheim-Roxheim',
    postalCode: '67240'
  },
  {
    municipality: 'Bobenthal',
    postalCode: '76891'
  },
  {
    municipality: 'Böbing',
    postalCode: '82389'
  },
  {
    municipality: 'Bobingen',
    postalCode: '86399'
  },
  {
    municipality: 'Böbingen',
    postalCode: '67482'
  },
  {
    municipality: 'Böbingen an der Rems',
    postalCode: '73560'
  },
  {
    municipality: 'Bobitz',
    postalCode: '23966'
  },
  {
    municipality: 'Bobitz',
    postalCode: '23996'
  },
  {
    municipality: 'Böblingen',
    postalCode: '71032'
  },
  {
    municipality: 'Böblingen',
    postalCode: '71034'
  },
  {
    municipality: 'Böbrach',
    postalCode: '94255'
  },
  {
    municipality: 'Bobritzsch-Hilbersdorf',
    postalCode: '09627'
  },
  {
    municipality: 'Bobzin',
    postalCode: '19230'
  },
  {
    municipality: 'Böchingen',
    postalCode: '76833'
  },
  {
    municipality: 'Bocholt',
    postalCode: '46395'
  },
  {
    municipality: 'Bocholt',
    postalCode: '46397'
  },
  {
    municipality: 'Bocholt',
    postalCode: '46399'
  },
  {
    municipality: 'Bochum',
    postalCode: '44787'
  },
  {
    municipality: 'Bochum',
    postalCode: '44789'
  },
  {
    municipality: 'Bochum',
    postalCode: '44791'
  },
  {
    municipality: 'Bochum',
    postalCode: '44793'
  },
  {
    municipality: 'Bochum',
    postalCode: '44795'
  },
  {
    municipality: 'Bochum',
    postalCode: '44797'
  },
  {
    municipality: 'Bochum',
    postalCode: '44799'
  },
  {
    municipality: 'Bochum',
    postalCode: '44801'
  },
  {
    municipality: 'Bochum',
    postalCode: '44803'
  },
  {
    municipality: 'Bochum',
    postalCode: '44805'
  },
  {
    municipality: 'Bochum',
    postalCode: '44807'
  },
  {
    municipality: 'Bochum',
    postalCode: '44809'
  },
  {
    municipality: 'Bochum',
    postalCode: '44866'
  },
  {
    municipality: 'Bochum',
    postalCode: '44867'
  },
  {
    municipality: 'Bochum',
    postalCode: '44869'
  },
  {
    municipality: 'Bochum',
    postalCode: '44879'
  },
  {
    municipality: 'Bochum',
    postalCode: '44892'
  },
  {
    municipality: 'Bochum',
    postalCode: '44894'
  },
  {
    municipality: 'Bocka',
    postalCode: '07589'
  },
  {
    municipality: 'Bockau',
    postalCode: '08324'
  },
  {
    municipality: 'Bockenau',
    postalCode: '55595'
  },
  {
    municipality: 'Bockenem',
    postalCode: '31167'
  },
  {
    municipality: 'Bockenheim an der Weinstraße',
    postalCode: '67278'
  },
  {
    municipality: 'Bockhorn',
    postalCode: '85461'
  },
  {
    municipality: 'Bockhorn',
    postalCode: '26345'
  },
  {
    municipality: 'Bockhorst',
    postalCode: '26897'
  },
  {
    municipality: 'Bodelshausen',
    postalCode: '72411'
  },
  {
    municipality: 'Bodelwitz',
    postalCode: '07381'
  },
  {
    municipality: 'Boden',
    postalCode: '56412'
  },
  {
    municipality: 'Bodenbach',
    postalCode: '53539'
  },
  {
    municipality: 'Bodenfelde',
    postalCode: '37194'
  },
  {
    municipality: 'Bodenheim',
    postalCode: '55294'
  },
  {
    municipality: 'Bodenkirchen',
    postalCode: '84155'
  },
  {
    municipality: 'Bodenmais',
    postalCode: '94249'
  },
  {
    municipality: 'Bodenrode-Westhausen',
    postalCode: '37308'
  },
  {
    municipality: 'Bodensee',
    postalCode: '37434'
  },
  {
    municipality: 'Bodenwerder',
    postalCode: '37619'
  },
  {
    municipality: 'Bodenwöhr',
    postalCode: '92439'
  },
  {
    municipality: 'Bodman-Ludwigshafen',
    postalCode: '78351'
  },
  {
    municipality: 'Bodnegg',
    postalCode: '88285'
  },
  {
    municipality: 'Bodolz',
    postalCode: '88131'
  },
  {
    municipality: 'Böel',
    postalCode: '24401'
  },
  {
    municipality: 'Böel',
    postalCode: '24405'
  },
  {
    municipality: 'Böel',
    postalCode: '24891'
  },
  {
    municipality: 'Boffzen',
    postalCode: '37691'
  },
  {
    municipality: 'Bogel',
    postalCode: '56357'
  },
  {
    municipality: 'Bogen',
    postalCode: '94327'
  },
  {
    municipality: 'Böhen',
    postalCode: '87736'
  },
  {
    municipality: 'Böhlen',
    postalCode: '04564'
  },
  {
    municipality: 'Böhl-Iggelheim',
    postalCode: '67459'
  },
  {
    municipality: 'Böhme',
    postalCode: '29693'
  },
  {
    municipality: 'Böhmenkirch',
    postalCode: '89558'
  },
  {
    municipality: 'Böhmfeld',
    postalCode: '85113'
  },
  {
    municipality: 'Bohmstedt',
    postalCode: '25853'
  },
  {
    municipality: 'Bohmte',
    postalCode: '49163'
  },
  {
    municipality: 'Böhnhusen',
    postalCode: '24220'
  },
  {
    municipality: 'Boiensdorf',
    postalCode: '23974'
  },
  {
    municipality: 'Boitze',
    postalCode: '21368'
  },
  {
    municipality: 'Boitzenburger Land',
    postalCode: '17268'
  },
  {
    municipality: 'Boizenburg/Elbe',
    postalCode: '19258'
  },
  {
    municipality: 'Bokel',
    postalCode: '25364'
  },
  {
    municipality: 'Bokel',
    postalCode: '24802'
  },
  {
    municipality: 'Bokelrehm',
    postalCode: '25596'
  },
  {
    municipality: 'Bokensdorf',
    postalCode: '38556'
  },
  {
    municipality: 'Bokholt-Hanredder',
    postalCode: '25335'
  },
  {
    municipality: 'Bokhorst',
    postalCode: '25560'
  },
  {
    municipality: 'Bokhorst',
    postalCode: '25572'
  },
  {
    municipality: 'Böklund',
    postalCode: '24860'
  },
  {
    municipality: 'Boksee',
    postalCode: '24220'
  },
  {
    municipality: 'Bolanden',
    postalCode: '67295'
  },
  {
    municipality: 'Boldekow',
    postalCode: '17392'
  },
  {
    municipality: 'Böllen',
    postalCode: '79677'
  },
  {
    municipality: 'Bollenbach',
    postalCode: '55624'
  },
  {
    municipality: 'Böllenborn',
    postalCode: '76887'
  },
  {
    municipality: 'Bollendorf',
    postalCode: '54669'
  },
  {
    municipality: 'Bollewick',
    postalCode: '17207'
  },
  {
    municipality: 'Bollingstedt',
    postalCode: '24855'
  },
  {
    municipality: 'Bollschweil',
    postalCode: '79283'
  },
  {
    municipality: 'Bölsberg',
    postalCode: '57648'
  },
  {
    municipality: 'Bolsterlang',
    postalCode: '87538'
  },
  {
    municipality: 'Boltenhagen',
    postalCode: '23946'
  },
  {
    municipality: 'Boms',
    postalCode: '88361'
  },
  {
    municipality: 'Bondelum',
    postalCode: '25850'
  },
  {
    municipality: 'Bondorf',
    postalCode: '71149'
  },
  {
    municipality: 'Bönebüttel',
    postalCode: '24620'
  },
  {
    municipality: 'Bonefeld',
    postalCode: '56579'
  },
  {
    municipality: 'Bönen',
    postalCode: '59199'
  },
  {
    municipality: 'Bonerath',
    postalCode: '54316'
  },
  {
    municipality: 'Bongard',
    postalCode: '53539'
  },
  {
    municipality: 'Bonn',
    postalCode: '53111'
  },
  {
    municipality: 'Bonn',
    postalCode: '53113'
  },
  {
    municipality: 'Bonn',
    postalCode: '53115'
  },
  {
    municipality: 'Bonn',
    postalCode: '53117'
  },
  {
    municipality: 'Bonn',
    postalCode: '53119'
  },
  {
    municipality: 'Bonn',
    postalCode: '53121'
  },
  {
    municipality: 'Bonn',
    postalCode: '53123'
  },
  {
    municipality: 'Bonn',
    postalCode: '53125'
  },
  {
    municipality: 'Bonn',
    postalCode: '53127'
  },
  {
    municipality: 'Bonn',
    postalCode: '53129'
  },
  {
    municipality: 'Bonn',
    postalCode: '53173'
  },
  {
    municipality: 'Bonn',
    postalCode: '53175'
  },
  {
    municipality: 'Bonn',
    postalCode: '53177'
  },
  {
    municipality: 'Bonn',
    postalCode: '53179'
  },
  {
    municipality: 'Bonn',
    postalCode: '53225'
  },
  {
    municipality: 'Bonn',
    postalCode: '53227'
  },
  {
    municipality: 'Bonn',
    postalCode: '53229'
  },
  {
    municipality: 'Bonndorf im Schwarzwald',
    postalCode: '79848'
  },
  {
    municipality: 'Bönnigheim',
    postalCode: '74357'
  },
  {
    municipality: 'Bönningstedt',
    postalCode: '25474'
  },
  {
    municipality: 'Bonstetten',
    postalCode: '86486'
  },
  {
    municipality: 'Boock',
    postalCode: '17322'
  },
  {
    municipality: 'Boos',
    postalCode: '56729'
  },
  {
    municipality: 'Boos',
    postalCode: '87737'
  },
  {
    municipality: 'Boos',
    postalCode: '55595'
  },
  {
    municipality: 'Boostedt',
    postalCode: '24598'
  },
  {
    municipality: 'Bopfingen',
    postalCode: '73441'
  },
  {
    municipality: 'Boppard',
    postalCode: '56154'
  },
  {
    municipality: 'Borchen',
    postalCode: '33178'
  },
  {
    municipality: 'Bördeaue',
    postalCode: '39435'
  },
  {
    municipality: 'Börde-Hakel',
    postalCode: '39448'
  },
  {
    municipality: 'Bördeland',
    postalCode: '39221'
  },
  {
    municipality: 'Bordelum',
    postalCode: '25821'
  },
  {
    municipality: 'Bordelum',
    postalCode: '25842'
  },
  {
    municipality: 'Bordelum',
    postalCode: '25852'
  },
  {
    municipality: 'Bordesholm',
    postalCode: '24582'
  },
  {
    municipality: 'Boren',
    postalCode: '24392'
  },
  {
    municipality: 'Börfink',
    postalCode: '54422'
  },
  {
    municipality: 'Borgdorf-Seedorf',
    postalCode: '24589'
  },
  {
    municipality: 'Borgentreich',
    postalCode: '34434'
  },
  {
    municipality: 'Börger',
    postalCode: '26904'
  },
  {
    municipality: 'Börgerende-Rethwisch',
    postalCode: '18211'
  },
  {
    municipality: 'Borgholzhausen',
    postalCode: '33829'
  },
  {
    municipality: 'Borgstedt',
    postalCode: '24794'
  },
  {
    municipality: 'Borgsum',
    postalCode: '25938'
  },
  {
    municipality: 'Borgwedel',
    postalCode: '24857'
  },
  {
    municipality: 'Borken',
    postalCode: '46325'
  },
  {
    municipality: 'Borken (Hessen)',
    postalCode: '34582'
  },
  {
    municipality: 'Borkheide',
    postalCode: '14822'
  },
  {
    municipality: 'Borkow',
    postalCode: '19406'
  },
  {
    municipality: 'Borkum',
    postalCode: '26757'
  },
  {
    municipality: 'Borkwalde',
    postalCode: '14822'
  },
  {
    municipality: 'Borler',
    postalCode: '53539'
  },
  {
    municipality: 'Börm',
    postalCode: '24863'
  },
  {
    municipality: 'Borna',
    postalCode: '04552'
  },
  {
    municipality: 'Born a. Darß',
    postalCode: '18375'
  },
  {
    municipality: 'Borne',
    postalCode: '39435'
  },
  {
    municipality: 'Bornhagen',
    postalCode: '37318'
  },
  {
    municipality: 'Bornheim',
    postalCode: '53332'
  },
  {
    municipality: 'Bornheim',
    postalCode: '55237'
  },
  {
    municipality: 'Bornheim',
    postalCode: '76879'
  },
  {
    municipality: 'Bornholt',
    postalCode: '25557'
  },
  {
    municipality: 'Bornholt',
    postalCode: '25725'
  },
  {
    municipality: 'Bornhöved',
    postalCode: '24619'
  },
  {
    municipality: 'Bornich',
    postalCode: '56348'
  },
  {
    municipality: 'Börnichen',
    postalCode: '09437'
  },
  {
    municipality: 'Börnsen',
    postalCode: '21039'
  },
  {
    municipality: 'Bornstedt',
    postalCode: '06295'
  },
  {
    municipality: 'Borod',
    postalCode: '57614'
  },
  {
    municipality: 'Borrentin',
    postalCode: '17111'
  },
  {
    municipality: 'Börrstadt',
    postalCode: '67725'
  },
  {
    municipality: 'Börsborn',
    postalCode: '66904'
  },
  {
    municipality: 'Borsdorf',
    postalCode: '04451'
  },
  {
    municipality: 'Borsfleth',
    postalCode: '25376'
  },
  {
    municipality: 'Börslingen',
    postalCode: '89177'
  },
  {
    municipality: 'Börßum',
    postalCode: '38312'
  },
  {
    municipality: 'Borstel',
    postalCode: '24616'
  },
  {
    municipality: 'Borstel',
    postalCode: '27246'
  },
  {
    municipality: 'Borstel-Hohenraden',
    postalCode: '25494'
  },
  {
    municipality: 'Borstorf',
    postalCode: '23881'
  },
  {
    municipality: 'Börtlingen',
    postalCode: '73104'
  },
  {
    municipality: 'Borxleben',
    postalCode: '06556'
  },
  {
    municipality: 'Bosau',
    postalCode: '23715'
  },
  {
    municipality: 'Bosbüll',
    postalCode: '25899'
  },
  {
    municipality: 'Bösdorf',
    postalCode: '24306'
  },
  {
    municipality: 'Bösel',
    postalCode: '26219'
  },
  {
    municipality: 'Bosenbach',
    postalCode: '66887'
  },
  {
    municipality: 'Bösenbrunn',
    postalCode: '08606'
  },
  {
    municipality: 'Bösingen',
    postalCode: '78662'
  },
  {
    municipality: 'Bösleben-Wüllersleben',
    postalCode: '99310'
  },
  {
    municipality: 'Bötersen',
    postalCode: '27367'
  },
  {
    municipality: 'Bothel',
    postalCode: '27386'
  },
  {
    municipality: 'Bothkamp',
    postalCode: '24250'
  },
  {
    municipality: 'Bottenbach',
    postalCode: '66504'
  },
  {
    municipality: 'Böttingen',
    postalCode: '78583'
  },
  {
    municipality: 'Bottrop',
    postalCode: '46236'
  },
  {
    municipality: 'Bottrop',
    postalCode: '46238'
  },
  {
    municipality: 'Bottrop',
    postalCode: '46240'
  },
  {
    municipality: 'Bottrop',
    postalCode: '46242'
  },
  {
    municipality: 'Bottrop',
    postalCode: '46244'
  },
  {
    municipality: 'Bötzingen',
    postalCode: '79268'
  },
  {
    municipality: 'Bous',
    postalCode: '66359'
  },
  {
    municipality: 'Bovenau',
    postalCode: '24796'
  },
  {
    municipality: 'Bovenden',
    postalCode: '37120'
  },
  {
    municipality: 'Boxberg',
    postalCode: '97944'
  },
  {
    municipality: 'Boxberg',
    postalCode: '54552'
  },
  {
    municipality: 'Boxberg/O.L. - Hamor',
    postalCode: '02943'
  },
  {
    municipality: 'Böxlund',
    postalCode: '24994'
  },
  {
    municipality: 'Braak',
    postalCode: '22145'
  },
  {
    municipality: 'Brachbach',
    postalCode: '57555'
  },
  {
    municipality: 'Brachtendorf',
    postalCode: '56761'
  },
  {
    municipality: 'Brachttal',
    postalCode: '63636'
  },
  {
    municipality: 'Brackel',
    postalCode: '21438'
  },
  {
    municipality: 'Brackenheim',
    postalCode: '74336'
  },
  {
    municipality: 'Braderup',
    postalCode: '25923'
  },
  {
    municipality: 'Brahlstorf',
    postalCode: '19273'
  },
  {
    municipality: 'Brahmenau',
    postalCode: '07554'
  },
  {
    municipality: 'Brake',
    postalCode: '26919'
  },
  {
    municipality: 'Brakel',
    postalCode: '33034'
  },
  {
    municipality: 'Brammer',
    postalCode: '24793'
  },
  {
    municipality: 'Bramsche',
    postalCode: '49565'
  },
  {
    municipality: 'Bramstedtlund',
    postalCode: '25926'
  },
  {
    municipality: 'Brand',
    postalCode: '95682'
  },
  {
    municipality: 'Brande-Hörnerkirchen',
    postalCode: '25364'
  },
  {
    municipality: 'Brandenburg an der Havel',
    postalCode: '14770'
  },
  {
    municipality: 'Brandenburg an der Havel',
    postalCode: '14772'
  },
  {
    municipality: 'Brandenburg an der Havel',
    postalCode: '14774'
  },
  {
    municipality: 'Brandenburg an der Havel',
    postalCode: '14776'
  },
  {
    municipality: 'Brand-Erbisdorf',
    postalCode: '09618'
  },
  {
    municipality: 'Brandis',
    postalCode: '04821'
  },
  {
    municipality: 'Brandis',
    postalCode: '04824'
  },
  {
    municipality: 'Brandscheid',
    postalCode: '56459'
  },
  {
    municipality: 'Brandscheid',
    postalCode: '54608'
  },
  {
    municipality: 'Brannenburg',
    postalCode: '83098'
  },
  {
    municipality: 'Braubach',
    postalCode: '56338'
  },
  {
    municipality: 'Brauneberg',
    postalCode: '54470'
  },
  {
    municipality: 'Brauneberg',
    postalCode: '54472'
  },
  {
    municipality: 'Braunfels',
    postalCode: '35619'
  },
  {
    municipality: 'Braunichswalde',
    postalCode: '07580'
  },
  {
    municipality: 'Braunlage',
    postalCode: '37444'
  },
  {
    municipality: 'Braunlage',
    postalCode: '38700'
  },
  {
    municipality: 'Bräunlingen',
    postalCode: '78199'
  },
  {
    municipality: 'Braunsbach',
    postalCode: '74542'
  },
  {
    municipality: 'Braunsbedra',
    postalCode: '06242'
  },
  {
    municipality: 'Braunsbedra',
    postalCode: '06259'
  },
  {
    municipality: 'Braunschweig',
    postalCode: '38100'
  },
  {
    municipality: 'Braunschweig',
    postalCode: '38102'
  },
  {
    municipality: 'Braunschweig',
    postalCode: '38104'
  },
  {
    municipality: 'Braunschweig',
    postalCode: '38106'
  },
  {
    municipality: 'Braunschweig',
    postalCode: '38108'
  },
  {
    municipality: 'Braunschweig',
    postalCode: '38110'
  },
  {
    municipality: 'Braunschweig',
    postalCode: '38112'
  },
  {
    municipality: 'Braunschweig',
    postalCode: '38114'
  },
  {
    municipality: 'Braunschweig',
    postalCode: '38116'
  },
  {
    municipality: 'Braunschweig',
    postalCode: '38118'
  },
  {
    municipality: 'Braunschweig',
    postalCode: '38120'
  },
  {
    municipality: 'Braunschweig',
    postalCode: '38122'
  },
  {
    municipality: 'Braunschweig',
    postalCode: '38124'
  },
  {
    municipality: 'Braunschweig',
    postalCode: '38126'
  },
  {
    municipality: 'Braunshorn',
    postalCode: '56288'
  },
  {
    municipality: 'Braunweiler',
    postalCode: '55595'
  },
  {
    municipality: 'Brauweiler',
    postalCode: '55606'
  },
  {
    municipality: 'Brechen',
    postalCode: '65611'
  },
  {
    municipality: 'Brecht',
    postalCode: '54636'
  },
  {
    municipality: 'Breckerfeld',
    postalCode: '58339'
  },
  {
    municipality: 'Breddenberg',
    postalCode: '26897'
  },
  {
    municipality: 'Breddin',
    postalCode: '16845'
  },
  {
    municipality: 'Breddorf',
    postalCode: '27412'
  },
  {
    municipality: 'Breddorf',
    postalCode: '27726'
  },
  {
    municipality: 'Bredenbek',
    postalCode: '24796'
  },
  {
    municipality: 'Bredenfelde',
    postalCode: '17153'
  },
  {
    municipality: 'Bredstedt',
    postalCode: '25821'
  },
  {
    municipality: 'Breege',
    postalCode: '18556'
  },
  {
    municipality: 'Breese',
    postalCode: '19322'
  },
  {
    municipality: 'Breesen',
    postalCode: '17091'
  },
  {
    municipality: 'Breest',
    postalCode: '17089'
  },
  {
    municipality: 'Brehme',
    postalCode: '37339'
  },
  {
    municipality: 'Breidenbach',
    postalCode: '35236'
  },
  {
    municipality: 'Breiholz',
    postalCode: '24797'
  },
  {
    municipality: 'Breisach am Rhein',
    postalCode: '79206'
  },
  {
    municipality: 'Breit',
    postalCode: '54426'
  },
  {
    municipality: 'Breitbrunn',
    postalCode: '96151'
  },
  {
    municipality: 'Breitbrunn am Chiemsee',
    postalCode: '83254'
  },
  {
    municipality: 'Breitenau',
    postalCode: '56237'
  },
  {
    municipality: 'Breitenbach',
    postalCode: '66916'
  },
  {
    municipality: 'Breitenbach am Herzberg',
    postalCode: '36287'
  },
  {
    municipality: 'Breitenberg',
    postalCode: '25597'
  },
  {
    municipality: 'Breitenberg',
    postalCode: '94139'
  },
  {
    municipality: 'Breitenbrunn',
    postalCode: '87739'
  },
  {
    municipality: 'Breitenbrunn',
    postalCode: '92363'
  },
  {
    municipality: 'Breitenbrunn/Erzgebirge',
    postalCode: '08359'
  },
  {
    municipality: 'Breitenburg',
    postalCode: '25524'
  },
  {
    municipality: 'Breitenfelde',
    postalCode: '23881'
  },
  {
    municipality: 'Breitengüßbach',
    postalCode: '96149'
  },
  {
    municipality: 'Breitenheim',
    postalCode: '55592'
  },
  {
    municipality: 'Breitenthal',
    postalCode: '86488'
  },
  {
    municipality: 'Breitenthal',
    postalCode: '55758'
  },
  {
    municipality: 'Breitenworbis',
    postalCode: '37339'
  },
  {
    municipality: 'Breitingen',
    postalCode: '89183'
  },
  {
    municipality: 'Breitnau',
    postalCode: '79874'
  },
  {
    municipality: 'Breitscheid',
    postalCode: '35767'
  },
  {
    municipality: 'Breitscheid',
    postalCode: '53547'
  },
  {
    municipality: 'Breitscheid',
    postalCode: '55422'
  },
  {
    municipality: 'Breitscheidt',
    postalCode: '57539'
  },
  {
    municipality: 'Breitungen/Werra',
    postalCode: '98597'
  },
  {
    municipality: 'Brekendorf',
    postalCode: '24811'
  },
  {
    municipality: 'Breklum',
    postalCode: '25821'
  },
  {
    municipality: 'Bremberg',
    postalCode: '56370'
  },
  {
    municipality: 'Bremen',
    postalCode: '27568'
  },
  {
    municipality: 'Bremen',
    postalCode: '28195'
  },
  {
    municipality: 'Bremen',
    postalCode: '28197'
  },
  {
    municipality: 'Bremen',
    postalCode: '28199'
  },
  {
    municipality: 'Bremen',
    postalCode: '28201'
  },
  {
    municipality: 'Bremen',
    postalCode: '28203'
  },
  {
    municipality: 'Bremen',
    postalCode: '28205'
  },
  {
    municipality: 'Bremen',
    postalCode: '28207'
  },
  {
    municipality: 'Bremen',
    postalCode: '28209'
  },
  {
    municipality: 'Bremen',
    postalCode: '28211'
  },
  {
    municipality: 'Bremen',
    postalCode: '28213'
  },
  {
    municipality: 'Bremen',
    postalCode: '28215'
  },
  {
    municipality: 'Bremen',
    postalCode: '28217'
  },
  {
    municipality: 'Bremen',
    postalCode: '28219'
  },
  {
    municipality: 'Bremen',
    postalCode: '28237'
  },
  {
    municipality: 'Bremen',
    postalCode: '28239'
  },
  {
    municipality: 'Bremen',
    postalCode: '28259'
  },
  {
    municipality: 'Bremen',
    postalCode: '28277'
  },
  {
    municipality: 'Bremen',
    postalCode: '28279'
  },
  {
    municipality: 'Bremen',
    postalCode: '28307'
  },
  {
    municipality: 'Bremen',
    postalCode: '28309'
  },
  {
    municipality: 'Bremen',
    postalCode: '28325'
  },
  {
    municipality: 'Bremen',
    postalCode: '28327'
  },
  {
    municipality: 'Bremen',
    postalCode: '28329'
  },
  {
    municipality: 'Bremen',
    postalCode: '28355'
  },
  {
    municipality: 'Bremen',
    postalCode: '28357'
  },
  {
    municipality: 'Bremen',
    postalCode: '28359'
  },
  {
    municipality: 'Bremen',
    postalCode: '28717'
  },
  {
    municipality: 'Bremen',
    postalCode: '28719'
  },
  {
    municipality: 'Bremen',
    postalCode: '28755'
  },
  {
    municipality: 'Bremen',
    postalCode: '28757'
  },
  {
    municipality: 'Bremen',
    postalCode: '28759'
  },
  {
    municipality: 'Bremen',
    postalCode: '28777'
  },
  {
    municipality: 'Bremen',
    postalCode: '28779'
  },
  {
    municipality: 'Bremerhaven',
    postalCode: '27568'
  },
  {
    municipality: 'Bremerhaven',
    postalCode: '27570'
  },
  {
    municipality: 'Bremerhaven',
    postalCode: '27572'
  },
  {
    municipality: 'Bremerhaven',
    postalCode: '27574'
  },
  {
    municipality: 'Bremerhaven',
    postalCode: '27576'
  },
  {
    municipality: 'Bremerhaven',
    postalCode: '27578'
  },
  {
    municipality: 'Bremerhaven',
    postalCode: '27580'
  },
  {
    municipality: 'Bremervörde',
    postalCode: '27432'
  },
  {
    municipality: 'Bremm',
    postalCode: '56814'
  },
  {
    municipality: 'Bremsnitz',
    postalCode: '07646'
  },
  {
    municipality: 'Brenk',
    postalCode: '56651'
  },
  {
    municipality: 'Brennberg',
    postalCode: '93179'
  },
  {
    municipality: 'Brensbach',
    postalCode: '64395'
  },
  {
    municipality: 'Brenz',
    postalCode: '19306'
  },
  {
    municipality: 'Bresegard bei Eldena',
    postalCode: '19294'
  },
  {
    municipality: 'Bresegard bei Picher',
    postalCode: '19230'
  },
  {
    municipality: 'Brest',
    postalCode: '21698'
  },
  {
    municipality: 'Bretten',
    postalCode: '75015'
  },
  {
    municipality: 'Bretthausen',
    postalCode: '56479'
  },
  {
    municipality: 'Bretzenheim',
    postalCode: '55559'
  },
  {
    municipality: 'Bretzfeld',
    postalCode: '74626'
  },
  {
    municipality: 'Breuberg',
    postalCode: '64747'
  },
  {
    municipality: 'Breuna',
    postalCode: '34479'
  },
  {
    municipality: 'Breunigweiler',
    postalCode: '67725'
  },
  {
    municipality: 'Brevörde',
    postalCode: '37647'
  },
  {
    municipality: 'Brey',
    postalCode: '56321'
  },
  {
    municipality: 'Breydin',
    postalCode: '16230'
  },
  {
    municipality: 'Brickeln',
    postalCode: '25712'
  },
  {
    municipality: 'Briedel',
    postalCode: '56850'
  },
  {
    municipality: 'Briedel',
    postalCode: '56867'
  },
  {
    municipality: 'Brieden',
    postalCode: '56829'
  },
  {
    municipality: 'Briedern',
    postalCode: '56820'
  },
  {
    municipality: 'Brieselang',
    postalCode: '14656'
  },
  {
    municipality: 'Briesen',
    postalCode: '03096'
  },
  {
    municipality: 'Briesen (Mark)',
    postalCode: '15518'
  },
  {
    municipality: 'Brieskow-Finkenheerd',
    postalCode: '15295'
  },
  {
    municipality: 'Brietlingen',
    postalCode: '21382'
  },
  {
    municipality: 'Brietzig',
    postalCode: '17309'
  },
  {
    municipality: 'Brigachtal',
    postalCode: '78086'
  },
  {
    municipality: 'Briggow',
    postalCode: '17153'
  },
  {
    municipality: 'Brilon',
    postalCode: '59929'
  },
  {
    municipality: 'Brimingen',
    postalCode: '54646'
  },
  {
    municipality: 'Brinjahe',
    postalCode: '24816'
  },
  {
    municipality: 'Brinkum',
    postalCode: '26835'
  },
  {
    municipality: 'Britz',
    postalCode: '16230'
  },
  {
    municipality: 'Bröbberow',
    postalCode: '18258'
  },
  {
    municipality: 'Brockel',
    postalCode: '27386'
  },
  {
    municipality: 'Bröckel',
    postalCode: '29356'
  },
  {
    municipality: 'Brockscheid',
    postalCode: '54552'
  },
  {
    municipality: 'Brockum',
    postalCode: '49448'
  },
  {
    municipality: 'Brodenbach',
    postalCode: '56332'
  },
  {
    municipality: 'Brodersby',
    postalCode: '24398'
  },
  {
    municipality: 'Brodersby-Goltoft',
    postalCode: '24864'
  },
  {
    municipality: 'Brodersdorf',
    postalCode: '24235'
  },
  {
    municipality: 'Broderstorf',
    postalCode: '18184'
  },
  {
    municipality: 'Brohl',
    postalCode: '56754'
  },
  {
    municipality: 'Brohl-Lützing',
    postalCode: '56656'
  },
  {
    municipality: 'Brokdorf',
    postalCode: '25554'
  },
  {
    municipality: 'Brokdorf',
    postalCode: '25576'
  },
  {
    municipality: 'Brokstedt',
    postalCode: '24616'
  },
  {
    municipality: 'Brombachtal',
    postalCode: '64753'
  },
  {
    municipality: 'Brome',
    postalCode: '38465'
  },
  {
    municipality: 'Bromskirchen',
    postalCode: '59969'
  },
  {
    municipality: 'Bronkow',
    postalCode: '03205'
  },
  {
    municipality: 'Bröthen',
    postalCode: '21514'
  },
  {
    municipality: 'Brotterode-Trusetal',
    postalCode: '98596'
  },
  {
    municipality: 'Bruch',
    postalCode: '54518'
  },
  {
    municipality: 'Bruchertseifen',
    postalCode: '57539'
  },
  {
    municipality: 'Bruchhausen',
    postalCode: '53572'
  },
  {
    municipality: 'Bruchhausen-Vilsen',
    postalCode: '27305'
  },
  {
    municipality: 'Bruchköbel',
    postalCode: '63486'
  },
  {
    municipality: 'Bruchmühlbach-Miesau',
    postalCode: '66892'
  },
  {
    municipality: 'Bruchsal',
    postalCode: '76646'
  },
  {
    municipality: 'Bruchstedt',
    postalCode: '99955'
  },
  {
    municipality: 'Bruchweiler',
    postalCode: '55758'
  },
  {
    municipality: 'Bruchweiler-Bärenbach',
    postalCode: '76891'
  },
  {
    municipality: 'Bruck',
    postalCode: '85567'
  },
  {
    municipality: 'Brück',
    postalCode: '14822'
  },
  {
    municipality: 'Bruckberg',
    postalCode: '84079'
  },
  {
    municipality: 'Bruckberg',
    postalCode: '91590'
  },
  {
    municipality: 'Brücken',
    postalCode: '55767'
  },
  {
    municipality: 'Brücken-Hackpfüffel',
    postalCode: '06528'
  },
  {
    municipality: 'Brücken (Pfalz)',
    postalCode: '66904'
  },
  {
    municipality: 'Bruck i.d.OPf.',
    postalCode: '92436'
  },
  {
    municipality: 'Bruckmühl',
    postalCode: '83052'
  },
  {
    municipality: 'Brücktal',
    postalCode: '53539'
  },
  {
    municipality: 'Brüel',
    postalCode: '19412'
  },
  {
    municipality: 'Brügge',
    postalCode: '24582'
  },
  {
    municipality: 'Brüggen',
    postalCode: '41379'
  },
  {
    municipality: 'Brühl',
    postalCode: '50321'
  },
  {
    municipality: 'Brühl',
    postalCode: '68782'
  },
  {
    municipality: 'Brunn',
    postalCode: '93164'
  },
  {
    municipality: 'Brunn',
    postalCode: '17039'
  },
  {
    municipality: 'Brunnen',
    postalCode: '86564'
  },
  {
    municipality: 'Brunnthal',
    postalCode: '85649'
  },
  {
    municipality: 'Brünn/Thür.',
    postalCode: '98673'
  },
  {
    municipality: 'Brunow',
    postalCode: '19357'
  },
  {
    municipality: 'Brunow',
    postalCode: '19372'
  },
  {
    municipality: 'Brunsbek',
    postalCode: '22946'
  },
  {
    municipality: 'Brunsbüttel',
    postalCode: '25541'
  },
  {
    municipality: 'Brunsmark',
    postalCode: '23883'
  },
  {
    municipality: 'Brunstorf',
    postalCode: '21524'
  },
  {
    municipality: 'Brünzow',
    postalCode: '17509'
  },
  {
    municipality: 'Bruschied',
    postalCode: '55606'
  },
  {
    municipality: 'Brüsewitz',
    postalCode: '19071'
  },
  {
    municipality: 'Brüssow',
    postalCode: '17326'
  },
  {
    municipality: 'Bruttig-Fankel',
    postalCode: '56814'
  },
  {
    municipality: 'Bubach',
    postalCode: '56288'
  },
  {
    municipality: 'Bubenheim',
    postalCode: '55270'
  },
  {
    municipality: 'Bubenheim',
    postalCode: '67308'
  },
  {
    municipality: 'Bubenreuth',
    postalCode: '91088'
  },
  {
    municipality: 'Bubesheim',
    postalCode: '89347'
  },
  {
    municipality: 'Buborn',
    postalCode: '67742'
  },
  {
    municipality: 'Bubsheim',
    postalCode: '78585'
  },
  {
    municipality: 'Buch',
    postalCode: '56357'
  },
  {
    municipality: 'Buch',
    postalCode: '89290'
  },
  {
    municipality: 'Buch',
    postalCode: '56290'
  },
  {
    municipality: 'Bucha',
    postalCode: '07751'
  },
  {
    municipality: 'Buch am Buchrain',
    postalCode: '85656'
  },
  {
    municipality: 'Buch am Erlbach',
    postalCode: '84172'
  },
  {
    municipality: 'Buch am Wald',
    postalCode: '91592'
  },
  {
    municipality: 'Buchbach',
    postalCode: '84428'
  },
  {
    municipality: 'Buchbrunn',
    postalCode: '97320'
  },
  {
    municipality: 'Buchdorf',
    postalCode: '86675'
  },
  {
    municipality: 'Büchel',
    postalCode: '56823'
  },
  {
    municipality: 'Büchel',
    postalCode: '99638'
  },
  {
    municipality: 'Büchen',
    postalCode: '21514'
  },
  {
    municipality: 'Buchenbach',
    postalCode: '79256'
  },
  {
    municipality: 'Büchenbach',
    postalCode: '91186'
  },
  {
    municipality: 'Buchenberg',
    postalCode: '87474'
  },
  {
    municipality: 'Büchenbeuren',
    postalCode: '55491'
  },
  {
    municipality: 'Buchen (Odenwald)',
    postalCode: '74722'
  },
  {
    municipality: 'Buchet',
    postalCode: '54608'
  },
  {
    municipality: 'Buchfart',
    postalCode: '99438'
  },
  {
    municipality: 'Buchheim',
    postalCode: '78567'
  },
  {
    municipality: 'Buchheim',
    postalCode: '88637'
  },
  {
    municipality: 'Buchhofen',
    postalCode: '94533'
  },
  {
    municipality: 'Buchholz',
    postalCode: '25712'
  },
  {
    municipality: 'Buchholz',
    postalCode: '31710'
  },
  {
    municipality: 'Buchholz',
    postalCode: '23911'
  },
  {
    municipality: 'Buchholz',
    postalCode: '17209'
  },
  {
    municipality: 'Buchholz (Aller)',
    postalCode: '29690'
  },
  {
    municipality: 'Buchholz in der Nordheide',
    postalCode: '21244'
  },
  {
    municipality: 'Buchholz (Westerwald)',
    postalCode: '53567'
  },
  {
    municipality: 'Buchhorst',
    postalCode: '21481'
  },
  {
    municipality: 'Büchlberg',
    postalCode: '94124'
  },
  {
    municipality: 'Buchloe',
    postalCode: '86807'
  },
  {
    municipality: 'Buckautal',
    postalCode: '14793'
  },
  {
    municipality: 'Bückeburg',
    postalCode: '31675'
  },
  {
    municipality: 'Bücken',
    postalCode: '27333'
  },
  {
    municipality: 'Buckenhof',
    postalCode: '91054'
  },
  {
    municipality: 'Buckow',
    postalCode: '15377'
  },
  {
    municipality: 'Büdelsdorf',
    postalCode: '24782'
  },
  {
    municipality: 'Budenbach',
    postalCode: '55469'
  },
  {
    municipality: 'Budenheim',
    postalCode: '55257'
  },
  {
    municipality: 'Büdesheim',
    postalCode: '54610'
  },
  {
    municipality: 'Büdingen',
    postalCode: '63654'
  },
  {
    municipality: 'Büdlich',
    postalCode: '54426'
  },
  {
    municipality: 'Bugewitz',
    postalCode: '17398'
  },
  {
    municipality: 'Buggenhagen',
    postalCode: '17440'
  },
  {
    municipality: 'Buggingen',
    postalCode: '79426'
  },
  {
    municipality: 'Bühl',
    postalCode: '77815'
  },
  {
    municipality: 'Buhla',
    postalCode: '37339'
  },
  {
    municipality: 'Buhlenberg',
    postalCode: '55767'
  },
  {
    municipality: 'Bühlertal',
    postalCode: '77830'
  },
  {
    municipality: 'Bühlertann',
    postalCode: '74424'
  },
  {
    municipality: 'Bühlerzell',
    postalCode: '74426'
  },
  {
    municipality: 'Bühnsdorf',
    postalCode: '23845'
  },
  {
    municipality: 'Bühren',
    postalCode: '37127'
  },
  {
    municipality: 'Bülkau',
    postalCode: '21782'
  },
  {
    municipality: 'Bullay',
    postalCode: '56859'
  },
  {
    municipality: 'Bullenkuhlen',
    postalCode: '25355'
  },
  {
    municipality: 'Bülow',
    postalCode: '19089'
  },
  {
    municipality: 'Bülstedt',
    postalCode: '27412'
  },
  {
    municipality: 'Bülstringen',
    postalCode: '39345'
  },
  {
    municipality: 'Bunde',
    postalCode: '26831'
  },
  {
    municipality: 'Bünde',
    postalCode: '32257'
  },
  {
    municipality: 'Bundenbach',
    postalCode: '55626'
  },
  {
    municipality: 'Bundenthal',
    postalCode: '76891'
  },
  {
    municipality: 'Bundorf',
    postalCode: '97494'
  },
  {
    municipality: 'Bünsdorf',
    postalCode: '24794'
  },
  {
    municipality: 'Bunsoh',
    postalCode: '25767'
  },
  {
    municipality: 'Burbach',
    postalCode: '57299'
  },
  {
    municipality: 'Burbach',
    postalCode: '54597'
  },
  {
    municipality: 'Bürdenbach',
    postalCode: '56593'
  },
  {
    municipality: 'Büren',
    postalCode: '33142'
  },
  {
    municipality: 'Burg',
    postalCode: '39288'
  },
  {
    municipality: 'Burg',
    postalCode: '54646'
  },
  {
    municipality: 'Burgau',
    postalCode: '89331'
  },
  {
    municipality: 'Burgberg i.Allgäu',
    postalCode: '87545'
  },
  {
    municipality: 'Burgbernheim',
    postalCode: '91593'
  },
  {
    municipality: 'Burgbrohl',
    postalCode: '56659'
  },
  {
    municipality: 'Burg (Dithmarschen)',
    postalCode: '25712'
  },
  {
    municipality: 'Burgdorf',
    postalCode: '31303'
  },
  {
    municipality: 'Burgdorf',
    postalCode: '38272'
  },
  {
    municipality: 'Burgebrach',
    postalCode: '96138'
  },
  {
    municipality: 'Bürgel',
    postalCode: '07616'
  },
  {
    municipality: 'Burgen',
    postalCode: '56332'
  },
  {
    municipality: 'Burgen',
    postalCode: '54472'
  },
  {
    municipality: 'Burggen',
    postalCode: '86977'
  },
  {
    municipality: 'Burghaslach',
    postalCode: '96152'
  },
  {
    municipality: 'Burghaun',
    postalCode: '36151'
  },
  {
    municipality: 'Burghausen',
    postalCode: '84489'
  },
  {
    municipality: 'Burgheim',
    postalCode: '86666'
  },
  {
    municipality: 'Burgkirchen an der Alz',
    postalCode: '84508'
  },
  {
    municipality: 'Burgkunstadt',
    postalCode: '96224'
  },
  {
    municipality: 'Burglahr',
    postalCode: '57632'
  },
  {
    municipality: 'Burglauer',
    postalCode: '97724'
  },
  {
    municipality: 'Burglengenfeld',
    postalCode: '93133'
  },
  {
    municipality: 'Burg (Mosel)',
    postalCode: '56843'
  },
  {
    municipality: 'Burgoberbach',
    postalCode: '91595'
  },
  {
    municipality: 'Burgpreppach',
    postalCode: '97496'
  },
  {
    municipality: 'Burgrieden',
    postalCode: '88483'
  },
  {
    municipality: 'Burgsalach',
    postalCode: '91790'
  },
  {
    municipality: 'Burgschwalbach',
    postalCode: '65558'
  },
  {
    municipality: 'Burgsinn',
    postalCode: '97775'
  },
  {
    municipality: 'Burgsponheim',
    postalCode: '55595'
  },
  {
    municipality: 'Burg (Spreewald)',
    postalCode: '03096'
  },
  {
    municipality: 'Burgstädt',
    postalCode: '09217'
  },
  {
    municipality: 'Bürgstadt',
    postalCode: '63927'
  },
  {
    municipality: 'Burgstall',
    postalCode: '39517'
  },
  {
    municipality: 'Burg Stargard',
    postalCode: '17094'
  },
  {
    municipality: 'Burgstetten',
    postalCode: '71576'
  },
  {
    municipality: 'Burgthann',
    postalCode: '90559'
  },
  {
    municipality: 'Burgwald',
    postalCode: '35099'
  },
  {
    municipality: 'Burgwalde',
    postalCode: '37318'
  },
  {
    municipality: 'Burgwedel',
    postalCode: '30938'
  },
  {
    municipality: 'Burgwindheim',
    postalCode: '96154'
  },
  {
    municipality: 'Burk',
    postalCode: '91596'
  },
  {
    municipality: 'Burkardroth',
    postalCode: '97705'
  },
  {
    municipality: 'Burkau - Porchow',
    postalCode: '01906'
  },
  {
    municipality: 'Burkhardtsdorf',
    postalCode: '09235'
  },
  {
    municipality: 'Burladingen',
    postalCode: '72393'
  },
  {
    municipality: 'Burow',
    postalCode: '17089'
  },
  {
    municipality: 'Burrweiler',
    postalCode: '76835'
  },
  {
    municipality: 'Burscheid',
    postalCode: '51399'
  },
  {
    municipality: 'Bürstadt',
    postalCode: '68642'
  },
  {
    municipality: 'Burtenbach',
    postalCode: '89349'
  },
  {
    municipality: 'Burtscheid',
    postalCode: '54424'
  },
  {
    municipality: 'Burweg',
    postalCode: '21709'
  },
  {
    municipality: 'Buschvitz',
    postalCode: '18528'
  },
  {
    municipality: 'Busdorf',
    postalCode: '24866'
  },
  {
    municipality: 'Buseck',
    postalCode: '35418'
  },
  {
    municipality: 'Busenberg',
    postalCode: '66996'
  },
  {
    municipality: 'Busenberg',
    postalCode: '76891'
  },
  {
    municipality: 'Busenhausen',
    postalCode: '57612'
  },
  {
    municipality: 'Busenwurth',
    postalCode: '25719'
  },
  {
    municipality: 'Büsingen am Hochrhein',
    postalCode: '78266'
  },
  {
    municipality: 'Büsum',
    postalCode: '25761'
  },
  {
    municipality: 'Büsumer Deichhausen',
    postalCode: '25761'
  },
  {
    municipality: 'Butjadingen',
    postalCode: '26969'
  },
  {
    municipality: 'Bütow',
    postalCode: '17209'
  },
  {
    municipality: 'Büttel',
    postalCode: '25572'
  },
  {
    municipality: 'Büttelborn',
    postalCode: '64572'
  },
  {
    municipality: 'Buttenheim',
    postalCode: '96155'
  },
  {
    municipality: 'Buttenwiesen',
    postalCode: '86647'
  },
  {
    municipality: 'Bütthard',
    postalCode: '97244'
  },
  {
    municipality: 'Buttlar',
    postalCode: '36419'
  },
  {
    municipality: 'Buttstädt',
    postalCode: '99628'
  },
  {
    municipality: 'Büttstedt',
    postalCode: '37359'
  },
  {
    municipality: 'Butzbach',
    postalCode: '35510'
  },
  {
    municipality: 'Butzow',
    postalCode: '17392'
  },
  {
    municipality: 'Bützow',
    postalCode: '18246'
  },
  {
    municipality: 'Buxheim',
    postalCode: '87740'
  },
  {
    municipality: 'Buxheim',
    postalCode: '85114'
  },
  {
    municipality: 'Buxtehude',
    postalCode: '21614'
  },
  {
    municipality: 'Byhleguhre-Byhlen',
    postalCode: '15913'
  },
  {
    municipality: 'Caan',
    postalCode: '56237'
  },
  {
    municipality: 'Caaschwitz',
    postalCode: '07586'
  },
  {
    municipality: 'Cadenberge',
    postalCode: '21781'
  },
  {
    municipality: 'Cadolzburg',
    postalCode: '90556'
  },
  {
    municipality: 'Calau',
    postalCode: '03205'
  },
  {
    municipality: 'Calberlah',
    postalCode: '38547'
  },
  {
    municipality: 'Calbe (Saale)',
    postalCode: '39240'
  },
  {
    municipality: 'Calden',
    postalCode: '34379'
  },
  {
    municipality: 'Callbach',
    postalCode: '67829'
  },
  {
    municipality: 'Callenberg',
    postalCode: '09337'
  },
  {
    municipality: 'Calvörde',
    postalCode: '39359'
  },
  {
    municipality: 'Calvörde',
    postalCode: '39638'
  },
  {
    municipality: 'Calw',
    postalCode: '75365'
  },
  {
    municipality: 'Cambs',
    postalCode: '19067'
  },
  {
    municipality: 'Cammin',
    postalCode: '18195'
  },
  {
    municipality: 'Cappeln (Oldenburg)',
    postalCode: '49692'
  },
  {
    municipality: 'Carinerland',
    postalCode: '18233'
  },
  {
    municipality: 'Carlow',
    postalCode: '19217'
  },
  {
    municipality: 'Carlsberg',
    postalCode: '67316'
  },
  {
    municipality: 'Carmzow-Wallmow',
    postalCode: '17291'
  },
  {
    municipality: 'Carpin',
    postalCode: '17237'
  },
  {
    municipality: 'Casekow',
    postalCode: '16306'
  },
  {
    municipality: 'Castell',
    postalCode: '97355'
  },
  {
    municipality: 'Castrop-Rauxel',
    postalCode: '44575'
  },
  {
    municipality: 'Castrop-Rauxel',
    postalCode: '44577'
  },
  {
    municipality: 'Castrop-Rauxel',
    postalCode: '44579'
  },
  {
    municipality: 'Castrop-Rauxel',
    postalCode: '44581'
  },
  {
    municipality: 'Cavertitz',
    postalCode: '04758'
  },
  {
    municipality: 'Celle',
    postalCode: '29221'
  },
  {
    municipality: 'Celle',
    postalCode: '29223'
  },
  {
    municipality: 'Celle',
    postalCode: '29225'
  },
  {
    municipality: 'Celle',
    postalCode: '29227'
  },
  {
    municipality: 'Celle',
    postalCode: '29229'
  },
  {
    municipality: 'Cham',
    postalCode: '93413'
  },
  {
    municipality: 'Chamerau',
    postalCode: '93466'
  },
  {
    municipality: 'Charlottenberg',
    postalCode: '56379'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09111'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09112'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09113'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09114'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09116'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09117'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09119'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09120'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09122'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09123'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09125'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09126'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09127'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09128'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09130'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09131'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09224'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09228'
  },
  {
    municipality: 'Chemnitz',
    postalCode: '09247'
  },
  {
    municipality: 'Chieming',
    postalCode: '83339'
  },
  {
    municipality: 'Chiemsee',
    postalCode: '83209'
  },
  {
    municipality: 'Chiemsee',
    postalCode: '83256'
  },
  {
    municipality: 'Chorin',
    postalCode: '16230'
  },
  {
    municipality: 'Christes',
    postalCode: '98547'
  },
  {
    municipality: 'Christiansholm',
    postalCode: '24799'
  },
  {
    municipality: 'Christinenthal',
    postalCode: '25593'
  },
  {
    municipality: 'Clausen',
    postalCode: '66978'
  },
  {
    municipality: 'Claußnitz',
    postalCode: '09236'
  },
  {
    municipality: 'Clausthal-Zellerfeld',
    postalCode: '38667'
  },
  {
    municipality: 'Clausthal-Zellerfeld',
    postalCode: '38678'
  },
  {
    municipality: 'Clausthal-Zellerfeld',
    postalCode: '38707'
  },
  {
    municipality: 'Clausthal-Zellerfeld',
    postalCode: '38709'
  },
  {
    municipality: 'Cleebronn',
    postalCode: '74389'
  },
  {
    municipality: 'Clenze',
    postalCode: '29459'
  },
  {
    municipality: 'Clingen',
    postalCode: '99718'
  },
  {
    municipality: 'Cloppenburg',
    postalCode: '49661'
  },
  {
    municipality: 'Coburg',
    postalCode: '96450'
  },
  {
    municipality: 'Cochem',
    postalCode: '56812'
  },
  {
    municipality: 'Coesfeld',
    postalCode: '48653'
  },
  {
    municipality: 'Cölbe',
    postalCode: '35091'
  },
  {
    municipality: 'Colbitz',
    postalCode: '39326'
  },
  {
    municipality: 'Colditz',
    postalCode: '04680'
  },
  {
    municipality: 'Collenberg',
    postalCode: '97896'
  },
  {
    municipality: 'Collenberg',
    postalCode: '97903'
  },
  {
    municipality: 'Colmberg',
    postalCode: '91598'
  },
  {
    municipality: 'Colnrade',
    postalCode: '27243'
  },
  {
    municipality: 'Cölpin',
    postalCode: '17094'
  },
  {
    municipality: 'Contwig',
    postalCode: '66497'
  },
  {
    municipality: 'Coppenbrügge',
    postalCode: '31863'
  },
  {
    municipality: 'Cornberg',
    postalCode: '36219'
  },
  {
    municipality: 'Coswig',
    postalCode: '01640'
  },
  {
    municipality: 'Coswig (Anhalt)',
    postalCode: '06868'
  },
  {
    municipality: 'Coswig (Anhalt)',
    postalCode: '06869'
  },
  {
    municipality: 'Cottbus - Chóśebuz',
    postalCode: '03042'
  },
  {
    municipality: 'Cottbus - Chóśebuz',
    postalCode: '03044'
  },
  {
    municipality: 'Cottbus - Chóśebuz',
    postalCode: '03046'
  },
  {
    municipality: 'Cottbus - Chóśebuz',
    postalCode: '03048'
  },
  {
    municipality: 'Cottbus - Chóśebuz',
    postalCode: '03050'
  },
  {
    municipality: 'Cottbus - Chóśebuz',
    postalCode: '03051'
  },
  {
    municipality: 'Cottbus - Chóśebuz',
    postalCode: '03052'
  },
  {
    municipality: 'Cottbus - Chóśebuz',
    postalCode: '03053'
  },
  {
    municipality: 'Cottbus - Chóśebuz',
    postalCode: '03054'
  },
  {
    municipality: 'Cottbus - Chóśebuz',
    postalCode: '03055'
  },
  {
    municipality: 'Crailsheim',
    postalCode: '74564'
  },
  {
    municipality: 'Crailsheim',
    postalCode: '74597'
  },
  {
    municipality: 'Cramberg',
    postalCode: '65558'
  },
  {
    municipality: 'Cramme',
    postalCode: '38312'
  },
  {
    municipality: 'Cramonshagen',
    postalCode: '19071'
  },
  {
    municipality: 'Creglingen',
    postalCode: '97993'
  },
  {
    municipality: 'Cremlingen',
    postalCode: '38162'
  },
  {
    municipality: 'Creußen',
    postalCode: '95473'
  },
  {
    municipality: 'Crimla',
    postalCode: '07557'
  },
  {
    municipality: 'Crimmitschau',
    postalCode: '08451'
  },
  {
    municipality: 'Crinitz',
    postalCode: '03246'
  },
  {
    municipality: 'Crinitzberg',
    postalCode: '08147'
  },
  {
    municipality: 'Crivitz',
    postalCode: '19089'
  },
  {
    municipality: 'Cronenberg',
    postalCode: '67744'
  },
  {
    municipality: 'Crossen an der Elster',
    postalCode: '07613'
  },
  {
    municipality: 'Crostwitz - Chrósćicy',
    postalCode: '01920'
  },
  {
    municipality: 'Crottendorf',
    postalCode: '09474'
  },
  {
    municipality: 'Cumlosen',
    postalCode: '19322'
  },
  {
    municipality: 'Cunewalde',
    postalCode: '02733'
  },
  {
    municipality: 'Cursdorf',
    postalCode: '98744'
  },
  {
    municipality: 'Cuxhaven',
    postalCode: '27472'
  },
  {
    municipality: 'Cuxhaven',
    postalCode: '27474'
  },
  {
    municipality: 'Cuxhaven',
    postalCode: '27476'
  },
  {
    municipality: 'Cuxhaven',
    postalCode: '27478'
  },
  {
    municipality: 'Daaden',
    postalCode: '57567'
  },
  {
    municipality: 'Dabel',
    postalCode: '19406'
  },
  {
    municipality: 'Dabergotz',
    postalCode: '16818'
  },
  {
    municipality: 'Daberkow',
    postalCode: '17129'
  },
  {
    municipality: 'Dachau',
    postalCode: '85221'
  },
  {
    municipality: 'Dachsbach',
    postalCode: '91462'
  },
  {
    municipality: 'Dachsberg (Südschwarzwald)',
    postalCode: '79837'
  },
  {
    municipality: 'Dachsberg (Südschwarzwald)',
    postalCode: '79875'
  },
  {
    municipality: 'Dachsenhausen',
    postalCode: '56340'
  },
  {
    municipality: 'Dachwig',
    postalCode: '99100'
  },
  {
    municipality: 'Dackenheim',
    postalCode: '67273'
  },
  {
    municipality: 'Dackscheid',
    postalCode: '54649'
  },
  {
    municipality: 'Dagebüll',
    postalCode: '25899'
  },
  {
    municipality: 'Dägeling',
    postalCode: '25578'
  },
  {
    municipality: 'Dahlem',
    postalCode: '53949'
  },
  {
    municipality: 'Dahlem',
    postalCode: '54636'
  },
  {
    municipality: 'Dahlem',
    postalCode: '21368'
  },
  {
    municipality: 'Dahlen',
    postalCode: '04774'
  },
  {
    municipality: 'Dahlenburg',
    postalCode: '21368'
  },
  {
    municipality: 'Dahlheim',
    postalCode: '56348'
  },
  {
    municipality: 'Dahlum',
    postalCode: '38170'
  },
  {
    municipality: 'Dahme',
    postalCode: '23747'
  },
  {
    municipality: 'Dahme/Mark',
    postalCode: '15936'
  },
  {
    municipality: 'Dahmen',
    postalCode: '17166'
  },
  {
    municipality: 'Dahmetal',
    postalCode: '15936'
  },
  {
    municipality: 'Dahmker',
    postalCode: '22946'
  },
  {
    municipality: 'Dahn',
    postalCode: '66994'
  },
  {
    municipality: 'Dahnen',
    postalCode: '54689'
  },
  {
    municipality: 'Dähre',
    postalCode: '29413'
  },
  {
    municipality: 'Daisendorf',
    postalCode: '88718'
  },
  {
    municipality: 'Daiting',
    postalCode: '86653'
  },
  {
    municipality: 'Dalberg',
    postalCode: '55595'
  },
  {
    municipality: 'Dalberg-Wendelstorf',
    postalCode: '19071'
  },
  {
    municipality: 'Daldorf',
    postalCode: '24635'
  },
  {
    municipality: 'Daleiden',
    postalCode: '54689'
  },
  {
    municipality: 'Dalheim',
    postalCode: '55278'
  },
  {
    municipality: 'Dalkendorf',
    postalCode: '17166'
  },
  {
    municipality: 'Dalldorf',
    postalCode: '21483'
  },
  {
    municipality: 'Dallgow-Döberitz',
    postalCode: '14624'
  },
  {
    municipality: 'Dambach',
    postalCode: '55765'
  },
  {
    municipality: 'Dambeck',
    postalCode: '19357'
  },
  {
    municipality: 'Damendorf',
    postalCode: '24361'
  },
  {
    municipality: 'Damflos',
    postalCode: '54413'
  },
  {
    municipality: 'Damlos',
    postalCode: '23738'
  },
  {
    municipality: 'Dammbach',
    postalCode: '63874'
  },
  {
    municipality: 'Damme',
    postalCode: '49401'
  },
  {
    municipality: 'Dammfleth',
    postalCode: '25554'
  },
  {
    municipality: 'Dammfleth',
    postalCode: '25573'
  },
  {
    municipality: 'Damnatz',
    postalCode: '29472'
  },
  {
    municipality: 'Damp',
    postalCode: '24351'
  },
  {
    municipality: 'Damscheid',
    postalCode: '55432'
  },
  {
    municipality: 'Damsdorf',
    postalCode: '23824'
  },
  {
    municipality: 'Damshagen',
    postalCode: '23936'
  },
  {
    municipality: 'Damshagen',
    postalCode: '23948'
  },
  {
    municipality: 'Dänischenhagen',
    postalCode: '24229'
  },
  {
    municipality: 'Dankerath',
    postalCode: '53520'
  },
  {
    municipality: 'Dannau',
    postalCode: '24329'
  },
  {
    municipality: 'Danndorf',
    postalCode: '38461'
  },
  {
    municipality: 'Dannenberg',
    postalCode: '29451'
  },
  {
    municipality: 'Dannenfels',
    postalCode: '67814'
  },
  {
    municipality: 'Dannewerk',
    postalCode: '24867'
  },
  {
    municipality: 'Dannstadt-Schauernheim',
    postalCode: '67125'
  },
  {
    municipality: 'Dargelin',
    postalCode: '17498'
  },
  {
    municipality: 'Dargen',
    postalCode: '17419'
  },
  {
    municipality: 'Dargen',
    postalCode: '17429'
  },
  {
    municipality: 'Dargun',
    postalCode: '17159'
  },
  {
    municipality: 'Darmstadt',
    postalCode: '64283'
  },
  {
    municipality: 'Darmstadt',
    postalCode: '64285'
  },
  {
    municipality: 'Darmstadt',
    postalCode: '64287'
  },
  {
    municipality: 'Darmstadt',
    postalCode: '64289'
  },
  {
    municipality: 'Darmstadt',
    postalCode: '64291'
  },
  {
    municipality: 'Darmstadt',
    postalCode: '64293'
  },
  {
    municipality: 'Darmstadt',
    postalCode: '64295'
  },
  {
    municipality: 'Darmstadt',
    postalCode: '64297'
  },
  {
    municipality: 'Darscheid',
    postalCode: '54552'
  },
  {
    municipality: 'Darstein',
    postalCode: '76848'
  },
  {
    municipality: 'Dasburg',
    postalCode: '54689'
  },
  {
    municipality: 'Dasing',
    postalCode: '86453'
  },
  {
    municipality: 'Dassel',
    postalCode: '37586'
  },
  {
    municipality: 'Dassendorf',
    postalCode: '21521'
  },
  {
    municipality: 'Dassow',
    postalCode: '23942'
  },
  {
    municipality: 'Dätgen',
    postalCode: '24589'
  },
  {
    municipality: 'Datteln',
    postalCode: '45711'
  },
  {
    municipality: 'Dattenberg',
    postalCode: '53547'
  },
  {
    municipality: 'Datzeroth',
    postalCode: '56589'
  },
  {
    municipality: 'Datzetal',
    postalCode: '17099'
  },
  {
    municipality: 'Daubach',
    postalCode: '56412'
  },
  {
    municipality: 'Daubach',
    postalCode: '55566'
  },
  {
    municipality: 'Dauchingen',
    postalCode: '78083'
  },
  {
    municipality: 'Daun',
    postalCode: '54550'
  },
  {
    municipality: 'Dausenau',
    postalCode: '56132'
  },
  {
    municipality: 'Dautmergen',
    postalCode: '72356'
  },
  {
    municipality: 'Dautphetal',
    postalCode: '35232'
  },
  {
    municipality: 'Dauwelshausen',
    postalCode: '54673'
  },
  {
    municipality: 'Daxweiler',
    postalCode: '55442'
  },
  {
    municipality: 'Dechow',
    postalCode: '19217'
  },
  {
    municipality: 'Deckenpfronn',
    postalCode: '75392'
  },
  {
    municipality: 'Dedelstorf',
    postalCode: '29386'
  },
  {
    municipality: 'Dedenbach',
    postalCode: '53426'
  },
  {
    municipality: 'Deensen',
    postalCode: '37627'
  },
  {
    municipality: 'Deesbach',
    postalCode: '98744'
  },
  {
    municipality: 'Deesen',
    postalCode: '56237'
  },
  {
    municipality: 'Deggendorf',
    postalCode: '94469'
  },
  {
    municipality: 'Deggenhausertal',
    postalCode: '88693'
  },
  {
    municipality: 'Deggingen',
    postalCode: '73312'
  },
  {
    municipality: 'Deggingen',
    postalCode: '73326'
  },
  {
    municipality: 'Deidesheim',
    postalCode: '67146'
  },
  {
    municipality: 'Deidesheim',
    postalCode: '67157'
  },
  {
    municipality: 'Deidesheim',
    postalCode: '67435'
  },
  {
    municipality: 'Deidesheim',
    postalCode: '67466'
  },
  {
    municipality: 'Deilingen',
    postalCode: '78586'
  },
  {
    municipality: 'Deimberg',
    postalCode: '67742'
  },
  {
    municipality: 'Deining',
    postalCode: '92364'
  },
  {
    municipality: 'Deiningen',
    postalCode: '86738'
  },
  {
    municipality: 'Deinste',
    postalCode: '21717'
  },
  {
    municipality: 'Deinstedt',
    postalCode: '27446'
  },
  {
    municipality: 'Deisenhausen',
    postalCode: '86489'
  },
  {
    municipality: 'Deißlingen',
    postalCode: '78652'
  },
  {
    municipality: 'Deizisau',
    postalCode: '73779'
  },
  {
    municipality: 'Delbrück',
    postalCode: '33129'
  },
  {
    municipality: 'Delingsdorf',
    postalCode: '22941'
  },
  {
    municipality: 'Delitzsch',
    postalCode: '04509'
  },
  {
    municipality: 'Dellfeld',
    postalCode: '66503'
  },
  {
    municipality: 'Delligsen',
    postalCode: '31073'
  },
  {
    municipality: 'Dellstedt',
    postalCode: '25786'
  },
  {
    municipality: 'Delmenhorst',
    postalCode: '27749'
  },
  {
    municipality: 'Delmenhorst',
    postalCode: '27751'
  },
  {
    municipality: 'Delmenhorst',
    postalCode: '27753'
  },
  {
    municipality: 'Delmenhorst',
    postalCode: '27755'
  },
  {
    municipality: 'Delve',
    postalCode: '25788'
  },
  {
    municipality: 'Demen',
    postalCode: '19089'
  },
  {
    municipality: 'Demerath',
    postalCode: '54552'
  },
  {
    municipality: 'Demitz-Thumitz',
    postalCode: '01877'
  },
  {
    municipality: 'Demmin',
    postalCode: '17109'
  },
  {
    municipality: 'Denkendorf',
    postalCode: '85095'
  },
  {
    municipality: 'Denkendorf',
    postalCode: '73770'
  },
  {
    municipality: 'Denkingen',
    postalCode: '78554'
  },
  {
    municipality: 'Denkingen',
    postalCode: '78588'
  },
  {
    municipality: 'Denklingen',
    postalCode: '86920'
  },
  {
    municipality: 'Denkte',
    postalCode: '38321'
  },
  {
    municipality: 'Dennheritz',
    postalCode: '08393'
  },
  {
    municipality: 'Dennweiler-Frohnbach',
    postalCode: '66871'
  },
  {
    municipality: 'Densborn',
    postalCode: '54570'
  },
  {
    municipality: 'Dentlein am Forst',
    postalCode: '91599'
  },
  {
    municipality: 'Denzlingen',
    postalCode: '79211'
  },
  {
    municipality: 'Derental',
    postalCode: '37691'
  },
  {
    municipality: 'Dermbach',
    postalCode: '36466'
  },
  {
    municipality: 'Dernau',
    postalCode: '53507'
  },
  {
    municipality: 'Dernbach',
    postalCode: '56307'
  },
  {
    municipality: 'Dernbach',
    postalCode: '76857'
  },
  {
    municipality: 'Dernbach (Westerwald)',
    postalCode: '56428'
  },
  {
    municipality: 'Dersau',
    postalCode: '24326'
  },
  {
    municipality: 'Derschen',
    postalCode: '57520'
  },
  {
    municipality: 'Dersekow',
    postalCode: '17498'
  },
  {
    municipality: 'Dersenow',
    postalCode: '19260'
  },
  {
    municipality: 'Dersum',
    postalCode: '26906'
  },
  {
    municipality: 'Desloch',
    postalCode: '55592'
  },
  {
    municipality: 'Dessau-Roßlau',
    postalCode: '06842'
  },
  {
    municipality: 'Dessau-Roßlau',
    postalCode: '06844'
  },
  {
    municipality: 'Dessau-Roßlau',
    postalCode: '06846'
  },
  {
    municipality: 'Dessau-Roßlau',
    postalCode: '06847'
  },
  {
    municipality: 'Dessau-Roßlau',
    postalCode: '06849'
  },
  {
    municipality: 'Dessau-Roßlau',
    postalCode: '06861'
  },
  {
    municipality: 'Dessau-Roßlau',
    postalCode: '06862'
  },
  {
    municipality: 'Dessighofen',
    postalCode: '56357'
  },
  {
    municipality: 'Detern',
    postalCode: '26847'
  },
  {
    municipality: 'Detmold',
    postalCode: '32756'
  },
  {
    municipality: 'Detmold',
    postalCode: '32758'
  },
  {
    municipality: 'Detmold',
    postalCode: '32760'
  },
  {
    municipality: 'Dettelbach',
    postalCode: '97337'
  },
  {
    municipality: 'Dettenhausen',
    postalCode: '72135'
  },
  {
    municipality: 'Dettenheim',
    postalCode: '76706'
  },
  {
    municipality: 'Dettighofen',
    postalCode: '79802'
  },
  {
    municipality: 'Dettingen an der Erms',
    postalCode: '72581'
  },
  {
    municipality: 'Dettingen an der Iller',
    postalCode: '88451'
  },
  {
    municipality: 'Dettingen unter Teck',
    postalCode: '73265'
  },
  {
    municipality: 'Dettmannsdorf',
    postalCode: '18334'
  },
  {
    municipality: 'Dettum',
    postalCode: '38173'
  },
  {
    municipality: 'Detzem',
    postalCode: '54340'
  },
  {
    municipality: 'Deudesfeld',
    postalCode: '54570'
  },
  {
    municipality: 'Deuerling',
    postalCode: '93180'
  },
  {
    municipality: 'Deuselbach',
    postalCode: '54411'
  },
  {
    municipality: 'Deutsch Evern',
    postalCode: '21407'
  },
  {
    municipality: 'Deutschneudorf',
    postalCode: '09548'
  },
  {
    municipality: 'Dexheim',
    postalCode: '55278'
  },
  {
    municipality: 'Deyelsdorf',
    postalCode: '18513'
  },
  {
    municipality: 'Dhronecken',
    postalCode: '54426'
  },
  {
    municipality: 'Dichtelbach',
    postalCode: '55494'
  },
  {
    municipality: 'Dickel',
    postalCode: '49453'
  },
  {
    municipality: 'Dickendorf',
    postalCode: '57520'
  },
  {
    municipality: 'Dickenschied',
    postalCode: '55483'
  },
  {
    municipality: 'Dickesbach',
    postalCode: '55758'
  },
  {
    municipality: 'Didderse',
    postalCode: '38530'
  },
  {
    municipality: 'Diebach',
    postalCode: '91583'
  },
  {
    municipality: 'Dieblich',
    postalCode: '56332'
  },
  {
    municipality: 'Dieburg',
    postalCode: '64807'
  },
  {
    municipality: 'Diedorf',
    postalCode: '86420'
  },
  {
    municipality: 'Diefenbach',
    postalCode: '54538'
  },
  {
    municipality: 'Diekholzen',
    postalCode: '31199'
  },
  {
    municipality: 'Diekhusen-Fahrstedt',
    postalCode: '25709'
  },
  {
    municipality: 'Dielheim',
    postalCode: '69234'
  },
  {
    municipality: 'Dielkirchen',
    postalCode: '67811'
  },
  {
    municipality: 'Dielmissen',
    postalCode: '37633'
  },
  {
    municipality: 'Diemelsee',
    postalCode: '34519'
  },
  {
    municipality: 'Diemelstadt',
    postalCode: '34474'
  },
  {
    municipality: 'Dienethal',
    postalCode: '56379'
  },
  {
    municipality: 'Dienheim',
    postalCode: '55276'
  },
  {
    municipality: 'Diensdorf-Radlow',
    postalCode: '15864'
  },
  {
    municipality: 'Dienstweiler',
    postalCode: '55765'
  },
  {
    municipality: 'Diepenau',
    postalCode: '31603'
  },
  {
    municipality: 'Diepholz',
    postalCode: '49356'
  },
  {
    municipality: 'Diera-Zehren',
    postalCode: '01665'
  },
  {
    municipality: 'Dierbach',
    postalCode: '76889'
  },
  {
    municipality: 'Dierdorf',
    postalCode: '56269'
  },
  {
    municipality: 'Dierfeld',
    postalCode: '54533'
  },
  {
    municipality: 'Dierhagen',
    postalCode: '18347'
  },
  {
    municipality: 'Dierscheid',
    postalCode: '54523'
  },
  {
    municipality: 'Diesdorf',
    postalCode: '29413'
  },
  {
    municipality: 'Diespeck',
    postalCode: '91456'
  },
  {
    municipality: 'Dießen am Ammersee',
    postalCode: '86911'
  },
  {
    municipality: 'Dietenheim',
    postalCode: '89165'
  },
  {
    municipality: 'Dietenhofen',
    postalCode: '90599'
  },
  {
    municipality: 'Dieterode',
    postalCode: '37318'
  },
  {
    municipality: 'Dietersburg',
    postalCode: '84378'
  },
  {
    municipality: 'Dietersheim',
    postalCode: '91463'
  },
  {
    municipality: 'Dieterskirchen',
    postalCode: '92542'
  },
  {
    municipality: 'Dietfurt an der Altmühl',
    postalCode: '92345'
  },
  {
    municipality: 'Diethardt',
    postalCode: '56355'
  },
  {
    municipality: 'Dietingen',
    postalCode: '78661'
  },
  {
    municipality: 'Dietmannsried',
    postalCode: '87463'
  },
  {
    municipality: 'Dietramszell',
    postalCode: '83623'
  },
  {
    municipality: 'Dietrichingen',
    postalCode: '66484'
  },
  {
    municipality: 'Dietzenbach',
    postalCode: '63128'
  },
  {
    municipality: 'Dietzenrode/Vatterode',
    postalCode: '37318'
  },
  {
    municipality: 'Dietzhölztal',
    postalCode: '35716'
  },
  {
    municipality: 'Diez',
    postalCode: '65582'
  },
  {
    municipality: 'Dill',
    postalCode: '55487'
  },
  {
    municipality: 'Dillenburg',
    postalCode: '35683'
  },
  {
    municipality: 'Dillenburg',
    postalCode: '35684'
  },
  {
    municipality: 'Dillenburg',
    postalCode: '35685'
  },
  {
    municipality: 'Dillenburg',
    postalCode: '35686'
  },
  {
    municipality: 'Dillenburg',
    postalCode: '35687'
  },
  {
    municipality: 'Dillenburg',
    postalCode: '35688'
  },
  {
    municipality: 'Dillenburg',
    postalCode: '35689'
  },
  {
    municipality: 'Dillenburg',
    postalCode: '35690'
  },
  {
    municipality: 'Dillendorf',
    postalCode: '55481'
  },
  {
    municipality: 'Dillingen a.d.Donau',
    postalCode: '89407'
  },
  {
    municipality: 'Dillingen/Saar',
    postalCode: '66763'
  },
  {
    municipality: 'Dillstädt',
    postalCode: '98530'
  },
  {
    municipality: 'Dimbach',
    postalCode: '76848'
  },
  {
    municipality: 'Dingdorf',
    postalCode: '54614'
  },
  {
    municipality: 'Dingelstädt',
    postalCode: '37351'
  },
  {
    municipality: 'Dingen',
    postalCode: '25715'
  },
  {
    municipality: 'Dingolfing',
    postalCode: '84130'
  },
  {
    municipality: 'Dingolshausen',
    postalCode: '97497'
  },
  {
    municipality: 'Dingsleben',
    postalCode: '98646'
  },
  {
    municipality: 'Dinkelsbühl',
    postalCode: '91550'
  },
  {
    municipality: 'Dinkelscherben',
    postalCode: '86424'
  },
  {
    municipality: 'Dinklage',
    postalCode: '49413'
  },
  {
    municipality: 'Dinslaken',
    postalCode: '46535'
  },
  {
    municipality: 'Dinslaken',
    postalCode: '46537'
  },
  {
    municipality: 'Dinslaken',
    postalCode: '46539'
  },
  {
    municipality: 'Dintesheim',
    postalCode: '55234'
  },
  {
    municipality: 'Dipperz',
    postalCode: '36160'
  },
  {
    municipality: 'Dippoldiswalde',
    postalCode: '01744'
  },
  {
    municipality: 'Dirlewang',
    postalCode: '87742'
  },
  {
    municipality: 'Dirlewang',
    postalCode: '87782'
  },
  {
    municipality: 'Dirmstein',
    postalCode: '67246'
  },
  {
    municipality: 'Dischingen',
    postalCode: '89561'
  },
  {
    municipality: 'Dissen',
    postalCode: '49201'
  },
  {
    municipality: 'Dissen-Striesow',
    postalCode: '03096'
  },
  {
    municipality: 'Ditfurt',
    postalCode: '06484'
  },
  {
    municipality: 'Ditscheid',
    postalCode: '56729'
  },
  {
    municipality: 'Dittelbrunn',
    postalCode: '97456'
  },
  {
    municipality: 'Dittelsheim-Heßloch',
    postalCode: '67596'
  },
  {
    municipality: 'Dittenheim',
    postalCode: '91723'
  },
  {
    municipality: 'Dittersdorf',
    postalCode: '07907'
  },
  {
    municipality: 'Dittweiler',
    postalCode: '66903'
  },
  {
    municipality: 'Ditzingen',
    postalCode: '71254'
  },
  {
    municipality: 'Divitz-Spoldershagen',
    postalCode: '18314'
  },
  {
    municipality: 'Dobbertin',
    postalCode: '19399'
  },
  {
    municipality: 'Dobbin-Linstow',
    postalCode: '18292'
  },
  {
    municipality: 'Dobel',
    postalCode: '75335'
  },
  {
    municipality: 'Döbeln',
    postalCode: '04720'
  },
  {
    municipality: 'Doberlug-Kirchhain',
    postalCode: '03253'
  },
  {
    municipality: 'Döbern',
    postalCode: '03159'
  },
  {
    municipality: 'Doberschau-Gaußig - Dobruša-Huska',
    postalCode: '01877'
  },
  {
    municipality: 'Doberschau-Gaußig - Dobruša-Huska',
    postalCode: '02633'
  },
  {
    municipality: 'Doberschau-Gaußig - Dobruša-Huska',
    postalCode: '02692'
  },
  {
    municipality: 'Doberschütz',
    postalCode: '04838'
  },
  {
    municipality: 'Dobersdorf',
    postalCode: '24232'
  },
  {
    municipality: 'Dobin am See',
    postalCode: '19067'
  },
  {
    municipality: 'Dobitschen',
    postalCode: '04626'
  },
  {
    municipality: 'Döbritschen',
    postalCode: '99441'
  },
  {
    municipality: 'Döbritz',
    postalCode: '07381'
  },
  {
    municipality: 'Dockendorf',
    postalCode: '54636'
  },
  {
    municipality: 'Dockweiler',
    postalCode: '54552'
  },
  {
    municipality: 'Dodenburg',
    postalCode: '54518'
  },
  {
    municipality: 'Dogern',
    postalCode: '79804'
  },
  {
    municipality: 'Döhlau',
    postalCode: '95182'
  },
  {
    municipality: 'Dohma',
    postalCode: '01796'
  },
  {
    municipality: 'Dohm-Lammersdorf',
    postalCode: '54576'
  },
  {
    municipality: 'Dohna',
    postalCode: '01809'
  },
  {
    municipality: 'Dohr',
    postalCode: '56812'
  },
  {
    municipality: 'Dohren',
    postalCode: '21255'
  },
  {
    municipality: 'Dohren',
    postalCode: '49770'
  },
  {
    municipality: 'Dolgen am See',
    postalCode: '18299'
  },
  {
    municipality: 'Dolgesheim',
    postalCode: '55278'
  },
  {
    municipality: 'Dollern',
    postalCode: '21739'
  },
  {
    municipality: 'Dollerup',
    postalCode: '24989'
  },
  {
    municipality: 'Dollnstein',
    postalCode: '91795'
  },
  {
    municipality: 'Döllstädt',
    postalCode: '99100'
  },
  {
    municipality: 'Dombühl',
    postalCode: '91601'
  },
  {
    municipality: 'Dömitz',
    postalCode: '19303'
  },
  {
    municipality: 'Dommershausen',
    postalCode: '56290'
  },
  {
    municipality: 'Dommitzsch',
    postalCode: '04880'
  },
  {
    municipality: 'Domsühl',
    postalCode: '19374'
  },
  {
    municipality: 'Donaueschingen',
    postalCode: '78166'
  },
  {
    municipality: 'Donaustauf',
    postalCode: '93093'
  },
  {
    municipality: 'Donauwörth',
    postalCode: '86609'
  },
  {
    municipality: 'Donnersdorf',
    postalCode: '97499'
  },
  {
    municipality: 'Donsieders',
    postalCode: '66978'
  },
  {
    municipality: 'Donzdorf',
    postalCode: '73072'
  },
  {
    municipality: 'Dörentrup',
    postalCode: '32694'
  },
  {
    municipality: 'Dorfchemnitz',
    postalCode: '09619'
  },
  {
    municipality: 'Dorfen',
    postalCode: '84405'
  },
  {
    municipality: 'Dorfhain',
    postalCode: '01738'
  },
  {
    municipality: 'Dörfles-Esbach',
    postalCode: '96487'
  },
  {
    municipality: 'Dorf Mecklenburg',
    postalCode: '23972'
  },
  {
    municipality: 'Dorfprozelten',
    postalCode: '97904'
  },
  {
    municipality: 'Dormagen',
    postalCode: '41539'
  },
  {
    municipality: 'Dormagen',
    postalCode: '41540'
  },
  {
    municipality: 'Dormagen',
    postalCode: '41541'
  },
  {
    municipality: 'Dormagen',
    postalCode: '41542'
  },
  {
    municipality: 'Dormettingen',
    postalCode: '72358'
  },
  {
    municipality: 'Dormitz',
    postalCode: '91077'
  },
  {
    municipality: 'Dörnberg',
    postalCode: '56377'
  },
  {
    municipality: 'Dörnberg',
    postalCode: '56379'
  },
  {
    municipality: 'Dornburg',
    postalCode: '65599'
  },
  {
    municipality: 'Dornburg-Camburg',
    postalCode: '07774'
  },
  {
    municipality: 'Dorn-Dürkheim',
    postalCode: '67585'
  },
  {
    municipality: 'Dornhan',
    postalCode: '72175'
  },
  {
    municipality: 'Dornheim',
    postalCode: '99310'
  },
  {
    municipality: 'Dornholzhausen',
    postalCode: '56357'
  },
  {
    municipality: 'Dörnick',
    postalCode: '24326'
  },
  {
    municipality: 'Dornstadt',
    postalCode: '89160'
  },
  {
    municipality: 'Dornstetten',
    postalCode: '72280'
  },
  {
    municipality: 'Dornum',
    postalCode: '26553'
  },
  {
    municipality: 'Dörpen',
    postalCode: '26892'
  },
  {
    municipality: 'Dörphof',
    postalCode: '24398'
  },
  {
    municipality: 'Dörpling',
    postalCode: '25794'
  },
  {
    municipality: 'Dörpstedt',
    postalCode: '24869'
  },
  {
    municipality: 'Dörrebach',
    postalCode: '55444'
  },
  {
    municipality: 'Dörrenbach',
    postalCode: '76889'
  },
  {
    municipality: 'Dörrmoschel',
    postalCode: '67806'
  },
  {
    municipality: 'Dörscheid',
    postalCode: '56348'
  },
  {
    municipality: 'Dörsdorf',
    postalCode: '56370'
  },
  {
    municipality: 'Dorsel',
    postalCode: '53533'
  },
  {
    municipality: 'Dorsheim',
    postalCode: '55452'
  },
  {
    municipality: 'Dorstadt',
    postalCode: '38312'
  },
  {
    municipality: 'Dorsten',
    postalCode: '46282'
  },
  {
    municipality: 'Dorsten',
    postalCode: '46284'
  },
  {
    municipality: 'Dorsten',
    postalCode: '46286'
  },
  {
    municipality: 'Dörth',
    postalCode: '56281'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44135'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44137'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44139'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44141'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44143'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44145'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44147'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44149'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44225'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44227'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44229'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44263'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44265'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44267'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44269'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44287'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44289'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44309'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44319'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44328'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44329'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44339'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44357'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44359'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44369'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44379'
  },
  {
    municipality: 'Dortmund',
    postalCode: '44388'
  },
  {
    municipality: 'Dörverden',
    postalCode: '27313'
  },
  {
    municipality: 'Dörzbach',
    postalCode: '74677'
  },
  {
    municipality: 'Döschnitz',
    postalCode: '07429'
  },
  {
    municipality: 'Dossenheim',
    postalCode: '69221'
  },
  {
    municipality: 'Dötlingen',
    postalCode: '27801'
  },
  {
    municipality: 'Dotternhausen',
    postalCode: '72359'
  },
  {
    municipality: 'Döttesfeld',
    postalCode: '56305'
  },
  {
    municipality: 'Drachhausen',
    postalCode: '03185'
  },
  {
    municipality: 'Drachselsried',
    postalCode: '94256'
  },
  {
    municipality: 'Drackenstein',
    postalCode: '73345'
  },
  {
    municipality: 'Drage',
    postalCode: '21423'
  },
  {
    municipality: 'Drage',
    postalCode: '25582'
  },
  {
    municipality: 'Drage',
    postalCode: '25840'
  },
  {
    municipality: 'Drage',
    postalCode: '25878'
  },
  {
    municipality: 'Dragun',
    postalCode: '19205'
  },
  {
    municipality: 'Drahnsdorf',
    postalCode: '15938'
  },
  {
    municipality: 'Drakenburg',
    postalCode: '31623'
  },
  {
    municipality: 'Dransfeld',
    postalCode: '37127'
  },
  {
    municipality: 'Dranske',
    postalCode: '18556'
  },
  {
    municipality: 'Drebach',
    postalCode: '09430'
  },
  {
    municipality: 'Drebber',
    postalCode: '49457'
  },
  {
    municipality: 'Drebkau',
    postalCode: '03116'
  },
  {
    municipality: 'Drechow',
    postalCode: '18465'
  },
  {
    municipality: 'Drees',
    postalCode: '53520'
  },
  {
    municipality: 'Dreetz',
    postalCode: '16845'
  },
  {
    municipality: 'Dreetz',
    postalCode: '18249'
  },
  {
    municipality: 'Dreggers',
    postalCode: '23845'
  },
  {
    municipality: 'Drehnow',
    postalCode: '03185'
  },
  {
    municipality: 'Dreieich',
    postalCode: '63303'
  },
  {
    municipality: 'Dreifelden',
    postalCode: '57629'
  },
  {
    municipality: 'Drei Gleichen',
    postalCode: '99869'
  },
  {
    municipality: 'Dreiheide',
    postalCode: '04860'
  },
  {
    municipality: 'Dreikirchen',
    postalCode: '56414'
  },
  {
    municipality: 'Dreis',
    postalCode: '54518'
  },
  {
    municipality: 'Dreisbach',
    postalCode: '56472'
  },
  {
    municipality: 'Dreis-Brück',
    postalCode: '54552'
  },
  {
    municipality: 'Dreisen',
    postalCode: '67816'
  },
  {
    municipality: 'Dreitzsch',
    postalCode: '07819'
  },
  {
    municipality: 'Drelsdorf',
    postalCode: '25853'
  },
  {
    municipality: 'Drensteinfurt',
    postalCode: '48317'
  },
  {
    municipality: 'Drentwede',
    postalCode: '49406'
  },
  {
    municipality: 'Dreschvitz',
    postalCode: '18573'
  },
  {
    municipality: 'Dresden',
    postalCode: '01067'
  },
  {
    municipality: 'Dresden',
    postalCode: '01069'
  },
  {
    municipality: 'Dresden',
    postalCode: '01097'
  },
  {
    municipality: 'Dresden',
    postalCode: '01099'
  },
  {
    municipality: 'Dresden',
    postalCode: '01108'
  },
  {
    municipality: 'Dresden',
    postalCode: '01109'
  },
  {
    municipality: 'Dresden',
    postalCode: '01127'
  },
  {
    municipality: 'Dresden',
    postalCode: '01129'
  },
  {
    municipality: 'Dresden',
    postalCode: '01139'
  },
  {
    municipality: 'Dresden',
    postalCode: '01156'
  },
  {
    municipality: 'Dresden',
    postalCode: '01157'
  },
  {
    municipality: 'Dresden',
    postalCode: '01159'
  },
  {
    municipality: 'Dresden',
    postalCode: '01169'
  },
  {
    municipality: 'Dresden',
    postalCode: '01187'
  },
  {
    municipality: 'Dresden',
    postalCode: '01189'
  },
  {
    municipality: 'Dresden',
    postalCode: '01217'
  },
  {
    municipality: 'Dresden',
    postalCode: '01219'
  },
  {
    municipality: 'Dresden',
    postalCode: '01237'
  },
  {
    municipality: 'Dresden',
    postalCode: '01239'
  },
  {
    municipality: 'Dresden',
    postalCode: '01257'
  },
  {
    municipality: 'Dresden',
    postalCode: '01259'
  },
  {
    municipality: 'Dresden',
    postalCode: '01277'
  },
  {
    municipality: 'Dresden',
    postalCode: '01279'
  },
  {
    municipality: 'Dresden',
    postalCode: '01307'
  },
  {
    municipality: 'Dresden',
    postalCode: '01309'
  },
  {
    municipality: 'Dresden',
    postalCode: '01324'
  },
  {
    municipality: 'Dresden',
    postalCode: '01326'
  },
  {
    municipality: 'Dresden',
    postalCode: '01328'
  },
  {
    municipality: 'Dresden',
    postalCode: '01465'
  },
  {
    municipality: 'Drestedt',
    postalCode: '21255'
  },
  {
    municipality: 'Drestedt',
    postalCode: '21279'
  },
  {
    municipality: 'Driedorf',
    postalCode: '35759'
  },
  {
    municipality: 'Drochtersen',
    postalCode: '21706'
  },
  {
    municipality: 'Drognitz',
    postalCode: '07338'
  },
  {
    municipality: 'Drolshagen',
    postalCode: '57489'
  },
  {
    municipality: 'Droyßig',
    postalCode: '06722'
  },
  {
    municipality: 'Düchelsdorf',
    postalCode: '23847'
  },
  {
    municipality: 'Ducherow',
    postalCode: '17398'
  },
  {
    municipality: 'Duchroth',
    postalCode: '55585'
  },
  {
    municipality: 'Duchroth',
    postalCode: '67826'
  },
  {
    municipality: 'Dudeldorf',
    postalCode: '54647'
  },
  {
    municipality: 'Düdenbüttel',
    postalCode: '21709'
  },
  {
    municipality: 'Dudenhofen',
    postalCode: '67373'
  },
  {
    municipality: 'Duderstadt',
    postalCode: '37115'
  },
  {
    municipality: 'Duggendorf',
    postalCode: '93182'
  },
  {
    municipality: 'Duggendorf',
    postalCode: '93195'
  },
  {
    municipality: 'Duingen',
    postalCode: '31089'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47051'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47053'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47055'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47057'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47058'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47059'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47119'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47137'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47138'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47139'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47166'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47167'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47169'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47178'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47179'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47198'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47199'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47226'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47228'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47229'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47239'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47249'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47259'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47269'
  },
  {
    municipality: 'Duisburg',
    postalCode: '47279'
  },
  {
    municipality: 'Dülmen',
    postalCode: '48249'
  },
  {
    municipality: 'Dümmer',
    postalCode: '19073'
  },
  {
    municipality: 'Dummerstorf',
    postalCode: '18196'
  },
  {
    municipality: 'Dümpelfeld',
    postalCode: '53520'
  },
  {
    municipality: 'Dünfus',
    postalCode: '56754'
  },
  {
    municipality: 'Düngenheim',
    postalCode: '56761'
  },
  {
    municipality: 'Dunningen',
    postalCode: '78655'
  },
  {
    municipality: 'Dunningen',
    postalCode: '78713'
  },
  {
    municipality: 'Dünsen',
    postalCode: '27243'
  },
  {
    municipality: 'Dunsum',
    postalCode: '25938'
  },
  {
    municipality: 'Dunum',
    postalCode: '26427'
  },
  {
    municipality: 'Dünwald',
    postalCode: '99976'
  },
  {
    municipality: 'Dunzweiler',
    postalCode: '66916'
  },
  {
    municipality: 'Duppach',
    postalCode: '54597'
  },
  {
    municipality: 'Durach',
    postalCode: '87471'
  },
  {
    municipality: 'Durbach',
    postalCode: '77770'
  },
  {
    municipality: 'Dürbheim',
    postalCode: '78589'
  },
  {
    municipality: 'Durchhausen',
    postalCode: '78591'
  },
  {
    municipality: 'Düren',
    postalCode: '52349'
  },
  {
    municipality: 'Düren',
    postalCode: '52351'
  },
  {
    municipality: 'Düren',
    postalCode: '52353'
  },
  {
    municipality: 'Düren',
    postalCode: '52355'
  },
  {
    municipality: 'Durlangen',
    postalCode: '73568'
  },
  {
    municipality: 'Dürmentingen',
    postalCode: '88525'
  },
  {
    municipality: 'Durmersheim',
    postalCode: '76448'
  },
  {
    municipality: 'Dürnau',
    postalCode: '73105'
  },
  {
    municipality: 'Dürnau',
    postalCode: '88422'
  },
  {
    municipality: 'Dürrhennersdorf',
    postalCode: '02708'
  },
  {
    municipality: 'Dürrholz',
    postalCode: '56307'
  },
  {
    municipality: 'Dürrlauingen',
    postalCode: '89350'
  },
  {
    municipality: 'Dürrröhrsdorf-Dittersbach',
    postalCode: '01833'
  },
  {
    municipality: 'Dürrwangen',
    postalCode: '91602'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40210'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40211'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40212'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40213'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40215'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40217'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40219'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40221'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40223'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40225'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40227'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40229'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40231'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40233'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40235'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40237'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40239'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40468'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40470'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40472'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40474'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40476'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40477'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40479'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40489'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40545'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40547'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40549'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40589'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40591'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40593'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40595'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40597'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40599'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40625'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40627'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40629'
  },
  {
    municipality: 'Düsseldorf',
    postalCode: '40721'
  },
  {
    municipality: 'Dußlingen',
    postalCode: '72144'
  },
  {
    municipality: 'Duvensee',
    postalCode: '23898'
  },
  {
    municipality: 'Ebeleben',
    postalCode: '99713'
  },
  {
    municipality: 'Ebelsbach',
    postalCode: '97500'
  },
  {
    municipality: 'Ebensfeld',
    postalCode: '96250'
  },
  {
    municipality: 'Ebenweiler',
    postalCode: '88370'
  },
  {
    municipality: 'Eberbach',
    postalCode: '64754'
  },
  {
    municipality: 'Eberbach',
    postalCode: '69412'
  },
  {
    municipality: 'Eberbach',
    postalCode: '69429'
  },
  {
    municipality: 'Eberbach',
    postalCode: '69434'
  },
  {
    municipality: 'Eberdingen',
    postalCode: '71735'
  },
  {
    municipality: 'Eberfing',
    postalCode: '82390'
  },
  {
    municipality: 'Ebergötzen',
    postalCode: '37136'
  },
  {
    municipality: 'Eberhardzell',
    postalCode: '88436'
  },
  {
    municipality: 'Ebermannsdorf',
    postalCode: '92263'
  },
  {
    municipality: 'Ebermannstadt',
    postalCode: '91320'
  },
  {
    municipality: 'Ebern',
    postalCode: '96106'
  },
  {
    municipality: 'Ebernhahn',
    postalCode: '56424'
  },
  {
    municipality: 'Ebersbach',
    postalCode: '01561'
  },
  {
    municipality: 'Ebersbach an der Fils',
    postalCode: '73061'
  },
  {
    municipality: 'Ebersbach-Musbach',
    postalCode: '88371'
  },
  {
    municipality: 'Ebersbach-Neugersdorf',
    postalCode: '02727'
  },
  {
    municipality: 'Ebersbach-Neugersdorf',
    postalCode: '02730'
  },
  {
    municipality: 'Ebersberg',
    postalCode: '85560'
  },
  {
    municipality: 'Ebersburg',
    postalCode: '36157'
  },
  {
    municipality: 'Ebersdorf',
    postalCode: '27432'
  },
  {
    municipality: 'Ebersdorf b.Coburg',
    postalCode: '96237'
  },
  {
    municipality: 'Ebershausen',
    postalCode: '86491'
  },
  {
    municipality: 'Eberstadt',
    postalCode: '74246'
  },
  {
    municipality: 'Eberstedt',
    postalCode: '99518'
  },
  {
    municipality: 'Eberswalde',
    postalCode: '16225'
  },
  {
    municipality: 'Eberswalde',
    postalCode: '16227'
  },
  {
    municipality: 'Ebertshausen',
    postalCode: '56370'
  },
  {
    municipality: 'Ebertsheim',
    postalCode: '67280'
  },
  {
    municipality: 'Ebhausen',
    postalCode: '72224'
  },
  {
    municipality: 'Ebnath',
    postalCode: '95683'
  },
  {
    municipality: 'Ebrach',
    postalCode: '96157'
  },
  {
    municipality: 'Ebringen',
    postalCode: '79285'
  },
  {
    municipality: 'Ebsdorfergrund',
    postalCode: '35085'
  },
  {
    municipality: 'Ebstorf',
    postalCode: '29574'
  },
  {
    municipality: 'Echem',
    postalCode: '21379'
  },
  {
    municipality: 'Eching',
    postalCode: '85386'
  },
  {
    municipality: 'Eching',
    postalCode: '84174'
  },
  {
    municipality: 'Eching am Ammersee',
    postalCode: '82279'
  },
  {
    municipality: 'Echternacherbrück',
    postalCode: '54668'
  },
  {
    municipality: 'Echtershausen',
    postalCode: '54636'
  },
  {
    municipality: 'Echzell',
    postalCode: '61200'
  },
  {
    municipality: 'Echzell',
    postalCode: '61209'
  },
  {
    municipality: 'Eckartsberga',
    postalCode: '06648'
  },
  {
    municipality: 'Eckelsheim',
    postalCode: '55599'
  },
  {
    municipality: 'Eckenroth',
    postalCode: '55444'
  },
  {
    municipality: 'Eckental',
    postalCode: '90542'
  },
  {
    municipality: 'Eckernförde',
    postalCode: '24340'
  },
  {
    municipality: 'Eckersdorf',
    postalCode: '95488'
  },
  {
    municipality: 'Eckersweiler',
    postalCode: '55777'
  },
  {
    municipality: 'Eckfeld',
    postalCode: '54531'
  },
  {
    municipality: 'Ecklak',
    postalCode: '25572'
  },
  {
    municipality: 'Ecklingerode',
    postalCode: '37339'
  },
  {
    municipality: 'Eckstedt',
    postalCode: '99195'
  },
  {
    municipality: 'Eddelak',
    postalCode: '25715'
  },
  {
    municipality: 'Edelsfeld',
    postalCode: '92265'
  },
  {
    municipality: 'Edemissen',
    postalCode: '31234'
  },
  {
    municipality: 'Edenkoben',
    postalCode: '67480'
  },
  {
    municipality: 'Ederheim',
    postalCode: '86739'
  },
  {
    municipality: 'Edermünde',
    postalCode: '34295'
  },
  {
    municipality: 'Edersleben',
    postalCode: '06528'
  },
  {
    municipality: 'Edertal',
    postalCode: '34549'
  },
  {
    municipality: 'Edesheim',
    postalCode: '67483'
  },
  {
    municipality: 'Edewecht',
    postalCode: '26188'
  },
  {
    municipality: 'Ediger-Eller',
    postalCode: '56814'
  },
  {
    municipality: 'Edingen-Neckarhausen',
    postalCode: '68535'
  },
  {
    municipality: 'Edling',
    postalCode: '83533'
  },
  {
    municipality: 'Effelder',
    postalCode: '37359'
  },
  {
    municipality: 'Effeltrich',
    postalCode: '91090'
  },
  {
    municipality: 'Efringen-Kirchen',
    postalCode: '79588'
  },
  {
    municipality: 'Egeln',
    postalCode: '39435'
  },
  {
    municipality: 'Egelsbach',
    postalCode: '63329'
  },
  {
    municipality: 'Egenhausen',
    postalCode: '72227'
  },
  {
    municipality: 'Egenhofen',
    postalCode: '82281'
  },
  {
    municipality: 'Egesheim',
    postalCode: '78592'
  },
  {
    municipality: 'Egestorf',
    postalCode: '21272'
  },
  {
    municipality: 'Egg an der Günz',
    postalCode: '87743'
  },
  {
    municipality: 'Eggebek',
    postalCode: '24852'
  },
  {
    municipality: 'Eggenfelden',
    postalCode: '84307'
  },
  {
    municipality: 'Eggenstein-Leopoldshafen',
    postalCode: '76344'
  },
  {
    municipality: 'Eggenthal',
    postalCode: '87653'
  },
  {
    municipality: 'Eggermühlen',
    postalCode: '49577'
  },
  {
    municipality: 'Eggesin',
    postalCode: '17367'
  },
  {
    municipality: 'Eggesin',
    postalCode: '17375'
  },
  {
    municipality: 'Eggingen',
    postalCode: '79805'
  },
  {
    municipality: 'Egglham',
    postalCode: '84385'
  },
  {
    municipality: 'Egglkofen',
    postalCode: '84546'
  },
  {
    municipality: 'Eggolsheim',
    postalCode: '91330'
  },
  {
    municipality: 'Eggstätt',
    postalCode: '83125'
  },
  {
    municipality: 'Eggstedt',
    postalCode: '25721'
  },
  {
    municipality: 'Eging a.See',
    postalCode: '94535'
  },
  {
    municipality: 'Eglfing',
    postalCode: '82436'
  },
  {
    municipality: 'Egling',
    postalCode: '82544'
  },
  {
    municipality: 'Egling an der Paar',
    postalCode: '86492'
  },
  {
    municipality: 'Egloffstein',
    postalCode: '91349'
  },
  {
    municipality: 'Egmating',
    postalCode: '85658'
  },
  {
    municipality: 'Egweil',
    postalCode: '85116'
  },
  {
    municipality: 'Ehekirchen',
    postalCode: '86676'
  },
  {
    municipality: 'Ehingen',
    postalCode: '86678'
  },
  {
    municipality: 'Ehingen',
    postalCode: '91725'
  },
  {
    municipality: 'Ehingen a.Ries',
    postalCode: '86741'
  },
  {
    municipality: 'Ehingen (Donau)',
    postalCode: '89584'
  },
  {
    municipality: 'Ehlenz',
    postalCode: '54636'
  },
  {
    municipality: 'Ehlscheid',
    postalCode: '56581'
  },
  {
    municipality: 'Ehndorf',
    postalCode: '24647'
  },
  {
    municipality: 'Ehningen',
    postalCode: '71139'
  },
  {
    municipality: 'Ehr',
    postalCode: '56357'
  },
  {
    municipality: 'Ehra-Lessien',
    postalCode: '38468'
  },
  {
    municipality: 'Ehrenberg',
    postalCode: '36115'
  },
  {
    municipality: 'Ehrenberg',
    postalCode: '98660'
  },
  {
    municipality: 'Ehrenburg',
    postalCode: '27248'
  },
  {
    municipality: 'Ehrenfriedersdorf',
    postalCode: '09427'
  },
  {
    municipality: 'Ehrenkirchen',
    postalCode: '79238'
  },
  {
    municipality: 'Ehringshausen',
    postalCode: '35630'
  },
  {
    municipality: 'Ehweiler',
    postalCode: '66871'
  },
  {
    municipality: 'Eibelstadt',
    postalCode: '97246'
  },
  {
    municipality: 'Eibenstock',
    postalCode: '08309'
  },
  {
    municipality: 'Eich',
    postalCode: '67575'
  },
  {
    municipality: 'Eichelhardt',
    postalCode: '57612'
  },
  {
    municipality: 'Eichen',
    postalCode: '57632'
  },
  {
    municipality: 'Eichenau',
    postalCode: '82223'
  },
  {
    municipality: 'Eichenbach',
    postalCode: '53533'
  },
  {
    municipality: 'Eichenberg',
    postalCode: '98553'
  },
  {
    municipality: 'Eichenberg',
    postalCode: '07768'
  },
  {
    municipality: 'Eichenbühl',
    postalCode: '63928'
  },
  {
    municipality: 'Eichenbühl',
    postalCode: '74731'
  },
  {
    municipality: 'Eichenbühl',
    postalCode: '97896'
  },
  {
    municipality: 'Eichendorf',
    postalCode: '94428'
  },
  {
    municipality: 'Eichenzell',
    postalCode: '36124'
  },
  {
    municipality: 'Eichigt',
    postalCode: '08626'
  },
  {
    municipality: 'Eichstätt',
    postalCode: '85072'
  },
  {
    municipality: 'Eichstedt (Altmark)',
    postalCode: '39596'
  },
  {
    municipality: 'Eichstegen',
    postalCode: '88361'
  },
  {
    municipality: 'Eichstetten',
    postalCode: '79356'
  },
  {
    municipality: 'Eichstruth',
    postalCode: '37318'
  },
  {
    municipality: 'Eichwalde',
    postalCode: '15732'
  },
  {
    municipality: 'Eickeloh',
    postalCode: '29693'
  },
  {
    municipality: 'Eicklingen',
    postalCode: '29358'
  },
  {
    municipality: 'Eigeltingen',
    postalCode: '78253'
  },
  {
    municipality: 'Eilenburg',
    postalCode: '04838'
  },
  {
    municipality: 'Eilscheid',
    postalCode: '54649'
  },
  {
    municipality: 'Eilsleben',
    postalCode: '39365'
  },
  {
    municipality: 'Eime',
    postalCode: '31036'
  },
  {
    municipality: 'Eimeldingen',
    postalCode: '79591'
  },
  {
    municipality: 'Eimen',
    postalCode: '37632'
  },
  {
    municipality: 'Eimke',
    postalCode: '29578'
  },
  {
    municipality: 'Eimsheim',
    postalCode: '55278'
  },
  {
    municipality: 'Einbeck',
    postalCode: '37574'
  },
  {
    municipality: 'Eineborn',
    postalCode: '07646'
  },
  {
    municipality: 'Einhaus',
    postalCode: '23911'
  },
  {
    municipality: 'Einhausen',
    postalCode: '64683'
  },
  {
    municipality: 'Einhausen',
    postalCode: '98617'
  },
  {
    municipality: 'Einig',
    postalCode: '56751'
  },
  {
    municipality: 'Einöllen',
    postalCode: '67753'
  },
  {
    municipality: 'Einselthum',
    postalCode: '67308'
  },
  {
    municipality: 'Eiselfing',
    postalCode: '83549'
  },
  {
    municipality: 'Eisenach',
    postalCode: '99817'
  },
  {
    municipality: 'Eisenach',
    postalCode: '54298'
  },
  {
    municipality: 'Eisenbach',
    postalCode: '79871'
  },
  {
    municipality: 'Eisenberg',
    postalCode: '87637'
  },
  {
    municipality: 'Eisenberg',
    postalCode: '07607'
  },
  {
    municipality: 'Eisenberg (Pfalz)',
    postalCode: '67304'
  },
  {
    municipality: 'Eisendorf',
    postalCode: '24589'
  },
  {
    municipality: 'Eisenheim',
    postalCode: '97247'
  },
  {
    municipality: 'Eisenhüttenstadt',
    postalCode: '15890'
  },
  {
    municipality: 'Eisenschmitt',
    postalCode: '54533'
  },
  {
    municipality: 'Eisfeld',
    postalCode: '98673'
  },
  {
    municipality: 'Eisighofen',
    postalCode: '56370'
  },
  {
    municipality: 'Eisingen',
    postalCode: '75239'
  },
  {
    municipality: 'Eisingen',
    postalCode: '97249'
  },
  {
    municipality: 'Eislingen/Fils',
    postalCode: '73054'
  },
  {
    municipality: 'Eitelborn',
    postalCode: '56337'
  },
  {
    municipality: 'Eitensheim',
    postalCode: '85117'
  },
  {
    municipality: 'Eiterfeld',
    postalCode: '36132'
  },
  {
    municipality: 'Eitorf',
    postalCode: '53783'
  },
  {
    municipality: 'Eitting',
    postalCode: '85462'
  },
  {
    municipality: 'Eixen',
    postalCode: '18334'
  },
  {
    municipality: 'Elbe',
    postalCode: '38274'
  },
  {
    municipality: 'Elben',
    postalCode: '57580'
  },
  {
    municipality: 'Elbe-Parey',
    postalCode: '39307'
  },
  {
    municipality: 'Elbe-Parey',
    postalCode: '39317'
  },
  {
    municipality: 'Elbingen',
    postalCode: '56459'
  },
  {
    municipality: 'Elbingerode',
    postalCode: '37412'
  },
  {
    municipality: 'Elbtal',
    postalCode: '65627'
  },
  {
    municipality: 'Elchesheim-Illingen',
    postalCode: '76477'
  },
  {
    municipality: 'Elchingen',
    postalCode: '89081'
  },
  {
    municipality: 'Elchingen',
    postalCode: '89275'
  },
  {
    municipality: 'Elchweiler',
    postalCode: '55765'
  },
  {
    municipality: 'Eldena',
    postalCode: '19294'
  },
  {
    municipality: 'Eldetal',
    postalCode: '17209'
  },
  {
    municipality: 'Eldingen',
    postalCode: '29351'
  },
  {
    municipality: 'Elfershausen',
    postalCode: '97725'
  },
  {
    municipality: 'Elgersburg',
    postalCode: '98716'
  },
  {
    municipality: 'Elisabeth-Sophien-Koog',
    postalCode: '25845'
  },
  {
    municipality: 'Elkenroth',
    postalCode: '57578'
  },
  {
    municipality: 'Elleben',
    postalCode: '99334'
  },
  {
    municipality: 'Ellefeld',
    postalCode: '08236'
  },
  {
    municipality: 'Ellenberg',
    postalCode: '73488'
  },
  {
    municipality: 'Ellenberg',
    postalCode: '55765'
  },
  {
    municipality: 'Ellenhausen',
    postalCode: '56242'
  },
  {
    municipality: 'Ellenz-Poltersdorf',
    postalCode: '56821'
  },
  {
    municipality: 'Ellerau',
    postalCode: '25479'
  },
  {
    municipality: 'Ellerbek',
    postalCode: '25474'
  },
  {
    municipality: 'Ellerdorf',
    postalCode: '24589'
  },
  {
    municipality: 'Ellerhoop',
    postalCode: '25373'
  },
  {
    municipality: 'Ellern (Hunsrück)',
    postalCode: '55497'
  },
  {
    municipality: 'Ellerstadt',
    postalCode: '67158'
  },
  {
    municipality: 'Ellgau',
    postalCode: '86679'
  },
  {
    municipality: 'Ellhofen',
    postalCode: '74248'
  },
  {
    municipality: 'Ellhöft',
    postalCode: '25923'
  },
  {
    municipality: 'Ellingen',
    postalCode: '91792'
  },
  {
    municipality: 'Ellingshausen',
    postalCode: '98617'
  },
  {
    municipality: 'Ellingstedt',
    postalCode: '24870'
  },
  {
    municipality: 'Ellrich',
    postalCode: '99755'
  },
  {
    municipality: 'Ellscheid',
    postalCode: '54552'
  },
  {
    municipality: 'Ellwangen (Jagst)',
    postalCode: '73479'
  },
  {
    municipality: 'Ellweiler',
    postalCode: '55765'
  },
  {
    municipality: 'Ellzee',
    postalCode: '89352'
  },
  {
    municipality: 'Elmenhorst',
    postalCode: '18510'
  },
  {
    municipality: 'Elmenhorst',
    postalCode: '23869'
  },
  {
    municipality: 'Elmenhorst',
    postalCode: '21493'
  },
  {
    municipality: 'Elmenhorst/Lichtenhagen',
    postalCode: '18107'
  },
  {
    municipality: 'Elmshorn',
    postalCode: '25335'
  },
  {
    municipality: 'Elmshorn',
    postalCode: '25336'
  },
  {
    municipality: 'Elmshorn',
    postalCode: '25337'
  },
  {
    municipality: 'Elmstein',
    postalCode: '67471'
  },
  {
    municipality: 'Elpersbüttel',
    postalCode: '25704'
  },
  {
    municipality: 'Elsdorf',
    postalCode: '50189'
  },
  {
    municipality: 'Elsdorf',
    postalCode: '27404'
  },
  {
    municipality: 'Elsdorf-Westermühlen',
    postalCode: '24800'
  },
  {
    municipality: 'Elsendorf',
    postalCode: '84094'
  },
  {
    municipality: 'Elsenfeld',
    postalCode: '63820'
  },
  {
    municipality: 'Elsfleth',
    postalCode: '26931'
  },
  {
    municipality: 'Elskop',
    postalCode: '25361'
  },
  {
    municipality: 'Elsnig',
    postalCode: '04880'
  },
  {
    municipality: 'Elsoff (Westerwald)',
    postalCode: '56479'
  },
  {
    municipality: 'Elsteraue',
    postalCode: '06729'
  },
  {
    municipality: 'Elsterberg',
    postalCode: '07985'
  },
  {
    municipality: 'Elsterheide - Halštrowska Hola',
    postalCode: '02979'
  },
  {
    municipality: 'Elstertrebnitz',
    postalCode: '04523'
  },
  {
    municipality: 'Elsterwerda',
    postalCode: '04910'
  },
  {
    municipality: 'Elstra - Halštrow',
    postalCode: '01920'
  },
  {
    municipality: 'Elterlein',
    postalCode: '09481'
  },
  {
    municipality: 'Eltmann',
    postalCode: '97483'
  },
  {
    municipality: 'Eltville am Rhein',
    postalCode: '65343'
  },
  {
    municipality: 'Eltville am Rhein',
    postalCode: '65344'
  },
  {
    municipality: 'Eltville am Rhein',
    postalCode: '65345'
  },
  {
    municipality: 'Eltville am Rhein',
    postalCode: '65346'
  },
  {
    municipality: 'Eltville am Rhein',
    postalCode: '65347'
  },
  {
    municipality: 'Elxleben',
    postalCode: '99334'
  },
  {
    municipality: 'Elxleben',
    postalCode: '99189'
  },
  {
    municipality: 'Elz',
    postalCode: '65604'
  },
  {
    municipality: 'Elzach',
    postalCode: '79215'
  },
  {
    municipality: 'Elze',
    postalCode: '31008'
  },
  {
    municipality: 'Elztal',
    postalCode: '74834'
  },
  {
    municipality: 'Elzweiler',
    postalCode: '66887'
  },
  {
    municipality: 'Embsen',
    postalCode: '21409'
  },
  {
    municipality: 'Embühren',
    postalCode: '24819'
  },
  {
    municipality: 'Emden',
    postalCode: '26721'
  },
  {
    municipality: 'Emden',
    postalCode: '26723'
  },
  {
    municipality: 'Emden',
    postalCode: '26725'
  },
  {
    municipality: 'Emeringen',
    postalCode: '88499'
  },
  {
    municipality: 'Emerkingen',
    postalCode: '89607'
  },
  {
    municipality: 'Emersacker',
    postalCode: '86494'
  },
  {
    municipality: 'Emkendorf',
    postalCode: '24802'
  },
  {
    municipality: 'Emleben',
    postalCode: '99869'
  },
  {
    municipality: 'Emlichheim',
    postalCode: '49824'
  },
  {
    municipality: 'Emmelbaum',
    postalCode: '54673'
  },
  {
    municipality: 'Emmelsbüll-Horsbüll',
    postalCode: '25924'
  },
  {
    municipality: 'Emmelshausen',
    postalCode: '56281'
  },
  {
    municipality: 'Emmendingen',
    postalCode: '79312'
  },
  {
    municipality: 'Emmendorf',
    postalCode: '29579'
  },
  {
    municipality: 'Emmerich am Rhein',
    postalCode: '46446'
  },
  {
    municipality: 'Emmering',
    postalCode: '83550'
  },
  {
    municipality: 'Emmering',
    postalCode: '82275'
  },
  {
    municipality: 'Emmerthal',
    postalCode: '31860'
  },
  {
    municipality: 'Emmerting',
    postalCode: '84547'
  },
  {
    municipality: 'Emmerzhausen',
    postalCode: '57520'
  },
  {
    municipality: 'Emmingen-Liptingen',
    postalCode: '78576'
  },
  {
    municipality: 'Empfertshausen',
    postalCode: '36452'
  },
  {
    municipality: 'Empfingen',
    postalCode: '72186'
  },
  {
    municipality: 'Emsbüren',
    postalCode: '48488'
  },
  {
    municipality: 'Emsdetten',
    postalCode: '48282'
  },
  {
    municipality: 'Emskirchen',
    postalCode: '91448'
  },
  {
    municipality: 'Emstek',
    postalCode: '49685'
  },
  {
    municipality: 'Emtinghausen',
    postalCode: '27321'
  },
  {
    municipality: 'Emtmannsberg',
    postalCode: '95517'
  },
  {
    municipality: 'Endingen',
    postalCode: '79346'
  },
  {
    municipality: 'Endlichhofen',
    postalCode: '56355'
  },
  {
    municipality: 'Endschütz',
    postalCode: '07570'
  },
  {
    municipality: 'Engden',
    postalCode: '48465'
  },
  {
    municipality: 'Engelbrechtsche Wildnis',
    postalCode: '25348'
  },
  {
    municipality: 'Engelsberg',
    postalCode: '84549'
  },
  {
    municipality: 'Engelsbrand',
    postalCode: '75331'
  },
  {
    municipality: 'Engelschoff',
    postalCode: '21710'
  },
  {
    municipality: 'Engelskirchen',
    postalCode: '51766'
  },
  {
    municipality: 'Engelstadt',
    postalCode: '55270'
  },
  {
    municipality: 'Engelthal',
    postalCode: '91238'
  },
  {
    municipality: 'Engen',
    postalCode: '78234'
  },
  {
    municipality: 'Enger',
    postalCode: '32130'
  },
  {
    municipality: 'Enge-Sande',
    postalCode: '25917'
  },
  {
    municipality: 'Engstingen',
    postalCode: '72829'
  },
  {
    municipality: 'Eningen unter Achalm',
    postalCode: '72800'
  },
  {
    municipality: 'Enkenbach-Alsenborn',
    postalCode: '67677'
  },
  {
    municipality: 'Enkirch',
    postalCode: '56850'
  },
  {
    municipality: 'Ennepetal',
    postalCode: '58256'
  },
  {
    municipality: 'Ennigerloh',
    postalCode: '59320'
  },
  {
    municipality: 'Ensch',
    postalCode: '54340'
  },
  {
    municipality: 'Ensdorf',
    postalCode: '92266'
  },
  {
    municipality: 'Ensdorf/Saar',
    postalCode: '66806'
  },
  {
    municipality: 'Ense',
    postalCode: '59469'
  },
  {
    municipality: 'Ensheim',
    postalCode: '55232'
  },
  {
    municipality: 'Enspel',
    postalCode: '57647'
  },
  {
    municipality: 'Enzen',
    postalCode: '54646'
  },
  {
    municipality: 'Enzklösterle',
    postalCode: '75337'
  },
  {
    municipality: 'Epenwöhrden',
    postalCode: '25704'
  },
  {
    municipality: 'Epfenbach',
    postalCode: '74925'
  },
  {
    municipality: 'Epfendorf',
    postalCode: '78736'
  },
  {
    municipality: 'Eppelborn',
    postalCode: '66571'
  },
  {
    municipality: 'Eppelheim',
    postalCode: '69214'
  },
  {
    municipality: 'Eppelsheim',
    postalCode: '55234'
  },
  {
    municipality: 'Eppenberg',
    postalCode: '56759'
  },
  {
    municipality: 'Eppenbrunn',
    postalCode: '66957'
  },
  {
    municipality: 'Eppendorf',
    postalCode: '09575'
  },
  {
    municipality: 'Eppenrod',
    postalCode: '65558'
  },
  {
    municipality: 'Eppenschlag',
    postalCode: '94536'
  },
  {
    municipality: 'Eppertshausen',
    postalCode: '64859'
  },
  {
    municipality: 'Eppingen',
    postalCode: '75031'
  },
  {
    municipality: 'Eppishausen',
    postalCode: '87745'
  },
  {
    municipality: 'Eppstein',
    postalCode: '65817'
  },
  {
    municipality: 'Erbach',
    postalCode: '64711'
  },
  {
    municipality: 'Erbach',
    postalCode: '55494'
  },
  {
    municipality: 'Erbach',
    postalCode: '89155'
  },
  {
    municipality: 'Erbendorf',
    postalCode: '92681'
  },
  {
    municipality: 'Erbenhausen',
    postalCode: '98634'
  },
  {
    municipality: 'Erbes-Büdesheim',
    postalCode: '55234'
  },
  {
    municipality: 'Erden',
    postalCode: '54492'
  },
  {
    municipality: 'Erdesbach',
    postalCode: '66887'
  },
  {
    municipality: 'Erding',
    postalCode: '85435'
  },
  {
    municipality: 'Erdmannhausen',
    postalCode: '71729'
  },
  {
    municipality: 'Erdweg',
    postalCode: '85253'
  },
  {
    municipality: 'Eresing',
    postalCode: '86922'
  },
  {
    municipality: 'Eresing',
    postalCode: '86926'
  },
  {
    municipality: 'Eresing',
    postalCode: '86941'
  },
  {
    municipality: 'Erfde',
    postalCode: '24803'
  },
  {
    municipality: 'Erftstadt',
    postalCode: '50374'
  },
  {
    municipality: 'Erfurt',
    postalCode: '99084'
  },
  {
    municipality: 'Erfurt',
    postalCode: '99085'
  },
  {
    municipality: 'Erfurt',
    postalCode: '99086'
  },
  {
    municipality: 'Erfurt',
    postalCode: '99087'
  },
  {
    municipality: 'Erfurt',
    postalCode: '99089'
  },
  {
    municipality: 'Erfurt',
    postalCode: '99090'
  },
  {
    municipality: 'Erfurt',
    postalCode: '99091'
  },
  {
    municipality: 'Erfurt',
    postalCode: '99092'
  },
  {
    municipality: 'Erfurt',
    postalCode: '99094'
  },
  {
    municipality: 'Erfurt',
    postalCode: '99095'
  },
  {
    municipality: 'Erfurt',
    postalCode: '99096'
  },
  {
    municipality: 'Erfurt',
    postalCode: '99097'
  },
  {
    municipality: 'Erfurt',
    postalCode: '99098'
  },
  {
    municipality: 'Erfurt',
    postalCode: '99099'
  },
  {
    municipality: 'Erfweiler',
    postalCode: '66996'
  },
  {
    municipality: 'Ergersheim',
    postalCode: '91465'
  },
  {
    municipality: 'Ergeshausen',
    postalCode: '56368'
  },
  {
    municipality: 'Ergolding',
    postalCode: '84030'
  },
  {
    municipality: 'Ergoldsbach',
    postalCode: '84061'
  },
  {
    municipality: 'Erharting',
    postalCode: '84513'
  },
  {
    municipality: 'Ering',
    postalCode: '94140'
  },
  {
    municipality: 'Eriskirch',
    postalCode: '88097'
  },
  {
    municipality: 'Erkelenz',
    postalCode: '41812'
  },
  {
    municipality: 'Erkenbrechtsweiler',
    postalCode: '73268'
  },
  {
    municipality: 'Erkerode',
    postalCode: '38173'
  },
  {
    municipality: 'Erkheim',
    postalCode: '87746'
  },
  {
    municipality: 'Erkner',
    postalCode: '15537'
  },
  {
    municipality: 'Erkrath',
    postalCode: '40699'
  },
  {
    municipality: 'Erlabrunn',
    postalCode: '97250'
  },
  {
    municipality: 'Erlangen',
    postalCode: '91052'
  },
  {
    municipality: 'Erlangen',
    postalCode: '91054'
  },
  {
    municipality: 'Erlangen',
    postalCode: '91056'
  },
  {
    municipality: 'Erlangen',
    postalCode: '91058'
  },
  {
    municipality: 'Erlau',
    postalCode: '09306'
  },
  {
    municipality: 'Erlbach',
    postalCode: '84567'
  },
  {
    municipality: 'Erlenbach',
    postalCode: '74235'
  },
  {
    municipality: 'Erlenbach am Main',
    postalCode: '63906'
  },
  {
    municipality: 'Erlenbach bei Dahn',
    postalCode: '76891'
  },
  {
    municipality: 'Erlenbach bei Kandel',
    postalCode: '76872'
  },
  {
    municipality: 'Erlenbach b.Marktheidenfeld',
    postalCode: '97837'
  },
  {
    municipality: 'Erlenmoos',
    postalCode: '88416'
  },
  {
    municipality: 'Erlensee',
    postalCode: '63526'
  },
  {
    municipality: 'Erligheim',
    postalCode: '74391'
  },
  {
    municipality: 'Ermershausen',
    postalCode: '96126'
  },
  {
    municipality: 'Erndtebrück',
    postalCode: '57339'
  },
  {
    municipality: 'Ernsgaden',
    postalCode: '85119'
  },
  {
    municipality: 'Ernst',
    postalCode: '56814'
  },
  {
    municipality: 'Ernzen',
    postalCode: '54668'
  },
  {
    municipality: 'Erolzheim',
    postalCode: '88453'
  },
  {
    municipality: 'Erpel',
    postalCode: '53579'
  },
  {
    municipality: 'Erpolzheim',
    postalCode: '67167'
  },
  {
    municipality: 'Ersfeld',
    postalCode: '57635'
  },
  {
    municipality: 'Ertingen',
    postalCode: '88521'
  },
  {
    municipality: 'Erwitte',
    postalCode: '59597'
  },
  {
    municipality: 'Erxleben',
    postalCode: '39343'
  },
  {
    municipality: 'Erzenhausen',
    postalCode: '67685'
  },
  {
    municipality: 'Erzhausen',
    postalCode: '64390'
  },
  {
    municipality: 'Esch',
    postalCode: '54585'
  },
  {
    municipality: 'Esch',
    postalCode: '54518'
  },
  {
    municipality: 'Eschach',
    postalCode: '73569'
  },
  {
    municipality: 'Eschau',
    postalCode: '63863'
  },
  {
    municipality: 'Eschbach',
    postalCode: '56357'
  },
  {
    municipality: 'Eschbach',
    postalCode: '76831'
  },
  {
    municipality: 'Eschbach',
    postalCode: '79427'
  },
  {
    municipality: 'Eschborn',
    postalCode: '65760'
  },
  {
    municipality: 'Eschbronn',
    postalCode: '78664'
  },
  {
    municipality: 'Esche',
    postalCode: '49828'
  },
  {
    municipality: 'Escheburg',
    postalCode: '21039'
  },
  {
    municipality: 'Eschede',
    postalCode: '29348'
  },
  {
    municipality: 'Eschede',
    postalCode: '29359'
  },
  {
    municipality: 'Eschede',
    postalCode: '29361'
  },
  {
    municipality: 'Eschelbronn',
    postalCode: '74927'
  },
  {
    municipality: 'Eschenbach',
    postalCode: '73037'
  },
  {
    municipality: 'Eschenbach',
    postalCode: '73107'
  },
  {
    municipality: 'Eschenbach i.d.OPf.',
    postalCode: '92676'
  },
  {
    municipality: 'Eschenbergen',
    postalCode: '99869'
  },
  {
    municipality: 'Eschenburg',
    postalCode: '35713'
  },
  {
    municipality: 'Eschenlohe',
    postalCode: '82438'
  },
  {
    municipality: 'Eschershausen',
    postalCode: '37632'
  },
  {
    municipality: 'Eschfeld',
    postalCode: '54619'
  },
  {
    municipality: 'Eschlkam',
    postalCode: '93458'
  },
  {
    municipality: 'Eschwege',
    postalCode: '37269'
  },
  {
    municipality: 'Eschweiler',
    postalCode: '52249'
  },
  {
    municipality: 'Esens',
    postalCode: '26427'
  },
  {
    municipality: 'Esgrus',
    postalCode: '24402'
  },
  {
    municipality: 'Eslarn',
    postalCode: '92693'
  },
  {
    municipality: 'Eslohe',
    postalCode: '59889'
  },
  {
    municipality: 'Espelkamp',
    postalCode: '32339'
  },
  {
    municipality: 'Espenau',
    postalCode: '34314'
  },
  {
    municipality: 'Eßbach',
    postalCode: '07924'
  },
  {
    municipality: 'Essel',
    postalCode: '29690'
  },
  {
    municipality: 'Esselbach',
    postalCode: '97839'
  },
  {
    municipality: 'Esselborn',
    postalCode: '55234'
  },
  {
    municipality: 'Essen',
    postalCode: '45127'
  },
  {
    municipality: 'Essen',
    postalCode: '45128'
  },
  {
    municipality: 'Essen',
    postalCode: '45130'
  },
  {
    municipality: 'Essen',
    postalCode: '45131'
  },
  {
    municipality: 'Essen',
    postalCode: '45133'
  },
  {
    municipality: 'Essen',
    postalCode: '45134'
  },
  {
    municipality: 'Essen',
    postalCode: '45136'
  },
  {
    municipality: 'Essen',
    postalCode: '45138'
  },
  {
    municipality: 'Essen',
    postalCode: '45139'
  },
  {
    municipality: 'Essen',
    postalCode: '45141'
  },
  {
    municipality: 'Essen',
    postalCode: '45143'
  },
  {
    municipality: 'Essen',
    postalCode: '45144'
  },
  {
    municipality: 'Essen',
    postalCode: '45145'
  },
  {
    municipality: 'Essen',
    postalCode: '45147'
  },
  {
    municipality: 'Essen',
    postalCode: '45149'
  },
  {
    municipality: 'Essen',
    postalCode: '45219'
  },
  {
    municipality: 'Essen',
    postalCode: '45239'
  },
  {
    municipality: 'Essen',
    postalCode: '45257'
  },
  {
    municipality: 'Essen',
    postalCode: '45259'
  },
  {
    municipality: 'Essen',
    postalCode: '45276'
  },
  {
    municipality: 'Essen',
    postalCode: '45277'
  },
  {
    municipality: 'Essen',
    postalCode: '45279'
  },
  {
    municipality: 'Essen',
    postalCode: '45289'
  },
  {
    municipality: 'Essen',
    postalCode: '45307'
  },
  {
    municipality: 'Essen',
    postalCode: '45309'
  },
  {
    municipality: 'Essen',
    postalCode: '45326'
  },
  {
    municipality: 'Essen',
    postalCode: '45327'
  },
  {
    municipality: 'Essen',
    postalCode: '45329'
  },
  {
    municipality: 'Essen',
    postalCode: '45355'
  },
  {
    municipality: 'Essen',
    postalCode: '45356'
  },
  {
    municipality: 'Essen',
    postalCode: '45357'
  },
  {
    municipality: 'Essen',
    postalCode: '45359'
  },
  {
    municipality: 'Essenbach',
    postalCode: '84051'
  },
  {
    municipality: 'Essenheim',
    postalCode: '55270'
  },
  {
    municipality: 'Essen (Oldenburg)',
    postalCode: '49632'
  },
  {
    municipality: 'Essing',
    postalCode: '93343'
  },
  {
    municipality: 'Essingen',
    postalCode: '76879'
  },
  {
    municipality: 'Essingen',
    postalCode: '73457'
  },
  {
    municipality: 'Essingen',
    postalCode: '73563'
  },
  {
    municipality: 'Essingen',
    postalCode: '73566'
  },
  {
    municipality: 'Eßlingen',
    postalCode: '54636'
  },
  {
    municipality: 'Esslingen am Neckar',
    postalCode: '73728'
  },
  {
    municipality: 'Esslingen am Neckar',
    postalCode: '73730'
  },
  {
    municipality: 'Esslingen am Neckar',
    postalCode: '73732'
  },
  {
    municipality: 'Esslingen am Neckar',
    postalCode: '73733'
  },
  {
    municipality: 'Esslingen am Neckar',
    postalCode: '73734'
  },
  {
    municipality: 'Eßweiler',
    postalCode: '67754'
  },
  {
    municipality: 'Estenfeld',
    postalCode: '97230'
  },
  {
    municipality: 'Esterwegen',
    postalCode: '26897'
  },
  {
    municipality: 'Esthal',
    postalCode: '67466'
  },
  {
    municipality: 'Esthal',
    postalCode: '67468'
  },
  {
    municipality: 'Esthal',
    postalCode: '67472'
  },
  {
    municipality: 'Estorf',
    postalCode: '21727'
  },
  {
    municipality: 'Estorf',
    postalCode: '31629'
  },
  {
    municipality: 'Etgert',
    postalCode: '54424'
  },
  {
    municipality: 'Etschberg',
    postalCode: '66871'
  },
  {
    municipality: 'Ettal',
    postalCode: '82488'
  },
  {
    municipality: 'Etteldorf',
    postalCode: '54655'
  },
  {
    municipality: 'Ettenheim',
    postalCode: '77955'
  },
  {
    municipality: 'Ettenstatt',
    postalCode: '91796'
  },
  {
    municipality: 'Ettersburg',
    postalCode: '99439'
  },
  {
    municipality: 'Ettinghausen',
    postalCode: '56244'
  },
  {
    municipality: 'Ettlingen',
    postalCode: '76275'
  },
  {
    municipality: 'Ettringen',
    postalCode: '56729'
  },
  {
    municipality: 'Ettringen',
    postalCode: '86833'
  },
  {
    municipality: 'Etzbach',
    postalCode: '57539'
  },
  {
    municipality: 'Etzelwang',
    postalCode: '92268'
  },
  {
    municipality: 'Etzenricht',
    postalCode: '92694'
  },
  {
    municipality: 'Etzleben',
    postalCode: '06577'
  },
  {
    municipality: 'Euerbach',
    postalCode: '97502'
  },
  {
    municipality: 'Euerdorf',
    postalCode: '97717'
  },
  {
    municipality: 'Eulenberg',
    postalCode: '57632'
  },
  {
    municipality: 'Eulenbis',
    postalCode: '67685'
  },
  {
    municipality: 'Eulgem',
    postalCode: '56761'
  },
  {
    municipality: 'Eurasburg',
    postalCode: '86495'
  },
  {
    municipality: 'Eurasburg',
    postalCode: '82547'
  },
  {
    municipality: 'Euscheid',
    postalCode: '54597'
  },
  {
    municipality: 'Euskirchen',
    postalCode: '53879'
  },
  {
    municipality: 'Euskirchen',
    postalCode: '53881'
  },
  {
    municipality: 'Eußenheim',
    postalCode: '97776'
  },
  {
    municipality: 'Eußerthal',
    postalCode: '76857'
  },
  {
    municipality: 'Eutin',
    postalCode: '23701'
  },
  {
    municipality: 'Eutingen im Gäu',
    postalCode: '72184'
  },
  {
    municipality: 'Eversmeer',
    postalCode: '26556'
  },
  {
    municipality: 'Everswinkel',
    postalCode: '48351'
  },
  {
    municipality: 'Evessen',
    postalCode: '38173'
  },
  {
    municipality: 'Ewighausen',
    postalCode: '56244'
  },
  {
    municipality: 'Extertal',
    postalCode: '32699'
  },
  {
    municipality: 'Eydelstedt',
    postalCode: '49406'
  },
  {
    municipality: 'Eyendorf',
    postalCode: '21376'
  },
  {
    municipality: 'Eystrup',
    postalCode: '27324'
  },
  {
    municipality: 'Fachbach',
    postalCode: '56133'
  },
  {
    municipality: 'Fahrdorf',
    postalCode: '24857'
  },
  {
    municipality: 'Fahren',
    postalCode: '24253'
  },
  {
    municipality: 'Fahrenbach',
    postalCode: '74864'
  },
  {
    municipality: 'Fahrenkrug',
    postalCode: '23795'
  },
  {
    municipality: 'Fahrenwalde',
    postalCode: '17309'
  },
  {
    municipality: 'Fahrenzhausen',
    postalCode: '85777'
  },
  {
    municipality: 'Faid',
    postalCode: '56814'
  },
  {
    municipality: 'Falkenberg',
    postalCode: '84326'
  },
  {
    municipality: 'Falkenberg',
    postalCode: '95685'
  },
  {
    municipality: 'Falkenberg',
    postalCode: '16259'
  },
  {
    municipality: 'Falkenberg/Elster',
    postalCode: '04895'
  },
  {
    municipality: 'Falkenfels',
    postalCode: '94350'
  },
  {
    municipality: 'Falkenhagen (Mark)',
    postalCode: '15306'
  },
  {
    municipality: 'Falkensee',
    postalCode: '14612'
  },
  {
    municipality: 'Falkenstein',
    postalCode: '93167'
  },
  {
    municipality: 'Falkenstein',
    postalCode: '67808'
  },
  {
    municipality: 'Falkenstein/Harz',
    postalCode: '06333'
  },
  {
    municipality: 'Falkenstein/Harz',
    postalCode: '06463'
  },
  {
    municipality: 'Falkenstein/Harz',
    postalCode: '06543'
  },
  {
    municipality: 'Falkenstein/Vogtland',
    postalCode: '08223'
  },
  {
    municipality: 'Falkenstein/Vogtland',
    postalCode: '08239'
  },
  {
    municipality: 'Fambach',
    postalCode: '98597'
  },
  {
    municipality: 'Farchant',
    postalCode: '82490'
  },
  {
    municipality: 'Fargau-Pratjau',
    postalCode: '24256'
  },
  {
    municipality: 'Farnstädt',
    postalCode: '06279'
  },
  {
    municipality: 'Farschweiler',
    postalCode: '54317'
  },
  {
    municipality: 'Farven',
    postalCode: '27446'
  },
  {
    municipality: 'Faßberg',
    postalCode: '29328'
  },
  {
    municipality: 'Faulbach',
    postalCode: '97906'
  },
  {
    municipality: 'Faulenrost',
    postalCode: '17139'
  },
  {
    municipality: 'Fedderingen',
    postalCode: '25779'
  },
  {
    municipality: 'Fehl-Ritzhausen',
    postalCode: '56472'
  },
  {
    municipality: 'Fehmarn',
    postalCode: '23769'
  },
  {
    municipality: 'Fehrbellin',
    postalCode: '16818'
  },
  {
    municipality: 'Fehrbellin',
    postalCode: '16833'
  },
  {
    municipality: 'Fehrbellin',
    postalCode: '16845'
  },
  {
    municipality: 'Feichten an der Alz',
    postalCode: '84550'
  },
  {
    municipality: 'Feilbingert',
    postalCode: '67824'
  },
  {
    municipality: 'Feilitzsch',
    postalCode: '95183'
  },
  {
    municipality: 'Feilsdorf',
    postalCode: '54636'
  },
  {
    municipality: 'Feldafing',
    postalCode: '82340'
  },
  {
    municipality: 'Feldatal',
    postalCode: '36325'
  },
  {
    municipality: 'Feldberg',
    postalCode: '79868'
  },
  {
    municipality: 'Feldberger Seenlandschaft',
    postalCode: '17258'
  },
  {
    municipality: 'Felde',
    postalCode: '24242'
  },
  {
    municipality: 'Feldhorst',
    postalCode: '23858'
  },
  {
    municipality: 'Feldkirchen',
    postalCode: '94351'
  },
  {
    municipality: 'Feldkirchen',
    postalCode: '85622'
  },
  {
    municipality: 'Feldkirchen-Westerham',
    postalCode: '83620'
  },
  {
    municipality: 'Felixsee',
    postalCode: '03130'
  },
  {
    municipality: 'Fell',
    postalCode: '54341'
  },
  {
    municipality: 'Fellbach',
    postalCode: '70734'
  },
  {
    municipality: 'Fellbach',
    postalCode: '70736'
  },
  {
    municipality: 'Fellen',
    postalCode: '97778'
  },
  {
    municipality: 'Fellheim',
    postalCode: '87748'
  },
  {
    municipality: 'Felm',
    postalCode: '24161'
  },
  {
    municipality: 'Felm',
    postalCode: '24214'
  },
  {
    municipality: 'Felm',
    postalCode: '24244'
  },
  {
    municipality: 'Felsberg',
    postalCode: '34587'
  },
  {
    municipality: 'Fensdorf',
    postalCode: '57580'
  },
  {
    municipality: 'Fensterbach',
    postalCode: '92269'
  },
  {
    municipality: 'Ferdinandshof',
    postalCode: '17379'
  },
  {
    municipality: 'Ferna',
    postalCode: '37339'
  },
  {
    municipality: 'Fernwald',
    postalCode: '35463'
  },
  {
    municipality: 'Ferschweiler',
    postalCode: '54668'
  },
  {
    municipality: 'Feucht',
    postalCode: '90537'
  },
  {
    municipality: 'Feuchtwangen',
    postalCode: '91555'
  },
  {
    municipality: 'Feuerscheid',
    postalCode: '54597'
  },
  {
    municipality: 'Feusdorf',
    postalCode: '54584'
  },
  {
    municipality: 'Fichtelberg',
    postalCode: '95686'
  },
  {
    municipality: 'Fichtenau',
    postalCode: '74579'
  },
  {
    municipality: 'Fichtenberg',
    postalCode: '74427'
  },
  {
    municipality: 'Fichtenhöhe',
    postalCode: '15306'
  },
  {
    municipality: 'Fichtwald',
    postalCode: '04936'
  },
  {
    municipality: 'Fiefbergen',
    postalCode: '24217'
  },
  {
    municipality: 'Fiersbach',
    postalCode: '57635'
  },
  {
    municipality: 'Filderstadt',
    postalCode: '70794'
  },
  {
    municipality: 'Filderstadt',
    postalCode: '71111'
  },
  {
    municipality: 'Filsen',
    postalCode: '56341'
  },
  {
    municipality: 'Filsum',
    postalCode: '26849'
  },
  {
    municipality: 'Filz',
    postalCode: '56766'
  },
  {
    municipality: 'Fincken',
    postalCode: '17209'
  },
  {
    municipality: 'Finkenbach-Gersweiler',
    postalCode: '67822'
  },
  {
    municipality: 'Finkenthal',
    postalCode: '17179'
  },
  {
    municipality: 'Finne',
    postalCode: '06647'
  },
  {
    municipality: 'Finneland',
    postalCode: '06647'
  },
  {
    municipality: 'Finnentrop',
    postalCode: '57413'
  },
  {
    municipality: 'Finning',
    postalCode: '86923'
  },
  {
    municipality: 'Finningen',
    postalCode: '89435'
  },
  {
    municipality: 'Finsing',
    postalCode: '85464'
  },
  {
    municipality: 'Finsterwalde',
    postalCode: '03238'
  },
  {
    municipality: 'Fintel',
    postalCode: '27389'
  },
  {
    municipality: 'Firrel',
    postalCode: '26835'
  },
  {
    municipality: 'Fisch',
    postalCode: '54439'
  },
  {
    municipality: 'Fischach',
    postalCode: '86850'
  },
  {
    municipality: 'Fischbach',
    postalCode: '55743'
  },
  {
    municipality: 'Fischbach',
    postalCode: '67693'
  },
  {
    municipality: 'Fischbachau',
    postalCode: '83730'
  },
  {
    municipality: 'Fischbach bei Dahn',
    postalCode: '66996'
  },
  {
    municipality: 'Fischbach-Oberraden',
    postalCode: '54675'
  },
  {
    municipality: 'Fischbachtal',
    postalCode: '64405'
  },
  {
    municipality: 'Fischen im Allgäu',
    postalCode: '87538'
  },
  {
    municipality: 'Fischerbach',
    postalCode: '77716'
  },
  {
    municipality: 'Fischingen',
    postalCode: '79592'
  },
  {
    municipality: 'Fitzbek',
    postalCode: '25579'
  },
  {
    municipality: 'Fitzen',
    postalCode: '21514'
  },
  {
    municipality: 'Flachslanden',
    postalCode: '91604'
  },
  {
    municipality: 'Flacht',
    postalCode: '65558'
  },
  {
    municipality: 'Fladungen',
    postalCode: '97650'
  },
  {
    municipality: 'Flammersfeld',
    postalCode: '57632'
  },
  {
    municipality: 'Flechtingen',
    postalCode: '39345'
  },
  {
    municipality: 'Flechtingen',
    postalCode: '39356'
  },
  {
    municipality: 'Flechtingen',
    postalCode: '39359'
  },
  {
    municipality: 'Fleckeby',
    postalCode: '24357'
  },
  {
    municipality: 'Flein',
    postalCode: '74223'
  },
  {
    municipality: 'Fleischwangen',
    postalCode: '88373'
  },
  {
    municipality: 'Flemlingen',
    postalCode: '76835'
  },
  {
    municipality: 'Flensburg',
    postalCode: '24937'
  },
  {
    municipality: 'Flensburg',
    postalCode: '24939'
  },
  {
    municipality: 'Flensburg',
    postalCode: '24941'
  },
  {
    municipality: 'Flensburg',
    postalCode: '24943'
  },
  {
    municipality: 'Flensburg',
    postalCode: '24944'
  },
  {
    municipality: 'Fleringen',
    postalCode: '54597'
  },
  {
    municipality: 'Flieden',
    postalCode: '36103'
  },
  {
    municipality: 'Fließem',
    postalCode: '54636'
  },
  {
    municipality: 'Flieth-Stegelitz',
    postalCode: '17268'
  },
  {
    municipality: 'Flintbek',
    postalCode: '24220'
  },
  {
    municipality: 'Flintsbach am Inn',
    postalCode: '83126'
  },
  {
    municipality: 'Flöha',
    postalCode: '09557'
  },
  {
    municipality: 'Floh-Seligenthal',
    postalCode: '98593'
  },
  {
    municipality: 'Flomborn',
    postalCode: '55234'
  },
  {
    municipality: 'Flonheim',
    postalCode: '55237'
  },
  {
    municipality: 'Flörsbachtal',
    postalCode: '63639'
  },
  {
    municipality: 'Flörsheim',
    postalCode: '65439'
  },
  {
    municipality: 'Flörsheim-Dalsheim',
    postalCode: '67592'
  },
  {
    municipality: 'Florstadt',
    postalCode: '61197'
  },
  {
    municipality: 'Floß',
    postalCode: '92685'
  },
  {
    municipality: 'Flossenbürg',
    postalCode: '92696'
  },
  {
    municipality: 'Flöthe',
    postalCode: '38312'
  },
  {
    municipality: 'Fluorn-Winzeln',
    postalCode: '78737'
  },
  {
    municipality: 'Flußbach',
    postalCode: '54516'
  },
  {
    municipality: 'Fluterschen',
    postalCode: '57614'
  },
  {
    municipality: 'Fockbek',
    postalCode: '24787'
  },
  {
    municipality: 'Föckelberg',
    postalCode: '66887'
  },
  {
    municipality: 'Fockendorf',
    postalCode: '04617'
  },
  {
    municipality: 'Föhrden-Barl',
    postalCode: '25563'
  },
  {
    municipality: 'Föhren',
    postalCode: '54343'
  },
  {
    municipality: 'Fohren-Linden',
    postalCode: '55777'
  },
  {
    municipality: 'Forbach',
    postalCode: '76596'
  },
  {
    municipality: 'Forchheim',
    postalCode: '91301'
  },
  {
    municipality: 'Forchheim',
    postalCode: '79362'
  },
  {
    municipality: 'Forchtenberg',
    postalCode: '74670'
  },
  {
    municipality: 'Forheim',
    postalCode: '86735'
  },
  {
    municipality: 'Föritztal',
    postalCode: '96524'
  },
  {
    municipality: 'Forst',
    postalCode: '57537'
  },
  {
    municipality: 'Forst',
    postalCode: '76694'
  },
  {
    municipality: 'Forst an der Weinstraße',
    postalCode: '67147'
  },
  {
    municipality: 'Forst (Eifel)',
    postalCode: '56754'
  },
  {
    municipality: 'Forstern',
    postalCode: '85659'
  },
  {
    municipality: 'Forst (Hunsrück)',
    postalCode: '56858'
  },
  {
    municipality: 'Forstinning',
    postalCode: '85661'
  },
  {
    municipality: 'Forst (Lausitz) - Baršć',
    postalCode: '03149'
  },
  {
    municipality: 'Forstmehren',
    postalCode: '57635'
  },
  {
    municipality: 'Framersheim',
    postalCode: '55234'
  },
  {
    municipality: 'Frammersbach',
    postalCode: '97833'
  },
  {
    municipality: 'Frankelbach',
    postalCode: '67737'
  },
  {
    municipality: 'Frankenau',
    postalCode: '35110'
  },
  {
    municipality: 'Frankenberg (Eder)',
    postalCode: '35066'
  },
  {
    municipality: 'Frankenberg/Sachsen',
    postalCode: '09669'
  },
  {
    municipality: 'Frankenblick',
    postalCode: '96528'
  },
  {
    municipality: 'Frankendorf',
    postalCode: '99441'
  },
  {
    municipality: 'Frankeneck',
    postalCode: '67468'
  },
  {
    municipality: 'Frankenfeld',
    postalCode: '27336'
  },
  {
    municipality: 'Frankenhardt',
    postalCode: '74586'
  },
  {
    municipality: 'Frankenheim/Rhön',
    postalCode: '98634'
  },
  {
    municipality: 'Frankenroda',
    postalCode: '99826'
  },
  {
    municipality: 'Frankenstein',
    postalCode: '67468'
  },
  {
    municipality: 'Frankenthal',
    postalCode: '01909'
  },
  {
    municipality: 'Frankenthal (Pfalz)',
    postalCode: '67227'
  },
  {
    municipality: 'Frankenwinheim',
    postalCode: '97447'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60306'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60308'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60310'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60311'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60312'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60313'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60314'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60315'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60316'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60318'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60320'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60322'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60323'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60325'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60326'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60327'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60329'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60385'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60386'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60388'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60389'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60431'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60433'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60435'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60437'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60438'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60439'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60486'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60487'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60488'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60489'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60528'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60529'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60549'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60594'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60596'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60598'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '60599'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '65929'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '65931'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '65933'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '65934'
  },
  {
    municipality: 'Frankfurt am Main',
    postalCode: '65936'
  },
  {
    municipality: 'Frankfurt (Oder)',
    postalCode: '15230'
  },
  {
    municipality: 'Frankfurt (Oder)',
    postalCode: '15232'
  },
  {
    municipality: 'Frankfurt (Oder)',
    postalCode: '15234'
  },
  {
    municipality: 'Frankfurt (Oder)',
    postalCode: '15236'
  },
  {
    municipality: 'Fränkisch-Crumbach',
    postalCode: '64407'
  },
  {
    municipality: 'Frankweiler',
    postalCode: '76833'
  },
  {
    municipality: 'Franzburg',
    postalCode: '18461'
  },
  {
    municipality: 'Franzenheim',
    postalCode: '54316'
  },
  {
    municipality: 'Frasdorf',
    postalCode: '83112'
  },
  {
    municipality: 'Frauenau',
    postalCode: '94258'
  },
  {
    municipality: 'Frauenberg',
    postalCode: '55776'
  },
  {
    municipality: 'Frauendorf',
    postalCode: '01945'
  },
  {
    municipality: 'Frauenneuharting',
    postalCode: '83553'
  },
  {
    municipality: 'Frauenprießnitz',
    postalCode: '07774'
  },
  {
    municipality: 'Frauenstein',
    postalCode: '09623'
  },
  {
    municipality: 'Fraunberg',
    postalCode: '85447'
  },
  {
    municipality: 'Fraureuth',
    postalCode: '08427'
  },
  {
    municipality: 'Frechen',
    postalCode: '50226'
  },
  {
    municipality: 'Freckenfeld',
    postalCode: '76872'
  },
  {
    municipality: 'Fredeburg',
    postalCode: '23909'
  },
  {
    municipality: 'Fredenbeck',
    postalCode: '21717'
  },
  {
    municipality: 'Freden (Leine)',
    postalCode: '31084'
  },
  {
    municipality: 'Fredersdorf-Vogelsdorf',
    postalCode: '15370'
  },
  {
    municipality: 'Fredesdorf',
    postalCode: '23826'
  },
  {
    municipality: 'Freiamt',
    postalCode: '79348'
  },
  {
    municipality: 'Freiberg',
    postalCode: '09599'
  },
  {
    municipality: 'Freiberg am Neckar',
    postalCode: '71691'
  },
  {
    municipality: 'Freiburg (Elbe)',
    postalCode: '21729'
  },
  {
    municipality: 'Freiburg im Breisgau',
    postalCode: '79098'
  },
  {
    municipality: 'Freiburg im Breisgau',
    postalCode: '79100'
  },
  {
    municipality: 'Freiburg im Breisgau',
    postalCode: '79102'
  },
  {
    municipality: 'Freiburg im Breisgau',
    postalCode: '79104'
  },
  {
    municipality: 'Freiburg im Breisgau',
    postalCode: '79106'
  },
  {
    municipality: 'Freiburg im Breisgau',
    postalCode: '79108'
  },
  {
    municipality: 'Freiburg im Breisgau',
    postalCode: '79110'
  },
  {
    municipality: 'Freiburg im Breisgau',
    postalCode: '79111'
  },
  {
    municipality: 'Freiburg im Breisgau',
    postalCode: '79112'
  },
  {
    municipality: 'Freiburg im Breisgau',
    postalCode: '79114'
  },
  {
    municipality: 'Freiburg im Breisgau',
    postalCode: '79115'
  },
  {
    municipality: 'Freiburg im Breisgau',
    postalCode: '79117'
  },
  {
    municipality: 'Freienbessingen',
    postalCode: '99713'
  },
  {
    municipality: 'Freienhagen',
    postalCode: '37318'
  },
  {
    municipality: 'Freienorla',
    postalCode: '07768'
  },
  {
    municipality: 'Freiensteinau',
    postalCode: '36399'
  },
  {
    municipality: 'Freienwill',
    postalCode: '24991'
  },
  {
    municipality: 'Freigericht',
    postalCode: '63579'
  },
  {
    municipality: 'Freihung',
    postalCode: '92271'
  },
  {
    municipality: 'Freilassing',
    postalCode: '83395'
  },
  {
    municipality: 'Frei-Laubersheim',
    postalCode: '55546'
  },
  {
    municipality: 'Freilingen',
    postalCode: '56244'
  },
  {
    municipality: 'Freimersheim',
    postalCode: '55234'
  },
  {
    municipality: 'Freimersheim (Pfalz)',
    postalCode: '67482'
  },
  {
    municipality: 'Freinsheim',
    postalCode: '67098'
  },
  {
    municipality: 'Freinsheim',
    postalCode: '67251'
  },
  {
    municipality: 'Freirachdorf',
    postalCode: '56244'
  },
  {
    municipality: 'Freisbach',
    postalCode: '67361'
  },
  {
    municipality: 'Freisen',
    postalCode: '66629'
  },
  {
    municipality: 'Freising',
    postalCode: '85354'
  },
  {
    municipality: 'Freising',
    postalCode: '85356'
  },
  {
    municipality: 'Freistatt',
    postalCode: '27259'
  },
  {
    municipality: 'Freital',
    postalCode: '01705'
  },
  {
    municipality: 'Frellstedt',
    postalCode: '38373'
  },
  {
    municipality: 'Fremdingen',
    postalCode: '86742'
  },
  {
    municipality: 'Frensdorf',
    postalCode: '96158'
  },
  {
    municipality: 'Freren',
    postalCode: '49832'
  },
  {
    municipality: 'Fresenburg',
    postalCode: '49762'
  },
  {
    municipality: 'Fresendelf',
    postalCode: '25876'
  },
  {
    municipality: 'Frestedt',
    postalCode: '25727'
  },
  {
    municipality: 'Frettenheim',
    postalCode: '67596'
  },
  {
    municipality: 'Fretterode',
    postalCode: '37318'
  },
  {
    municipality: 'Freudenberg',
    postalCode: '57258'
  },
  {
    municipality: 'Freudenberg',
    postalCode: '97896'
  },
  {
    municipality: 'Freudenberg',
    postalCode: '92272'
  },
  {
    municipality: 'Freudenburg',
    postalCode: '54450'
  },
  {
    municipality: 'Freudenstadt',
    postalCode: '72250'
  },
  {
    municipality: 'Freudental',
    postalCode: '74392'
  },
  {
    municipality: 'Freyburg (Unstrut)',
    postalCode: '06632'
  },
  {
    municipality: 'Freystadt',
    postalCode: '92342'
  },
  {
    municipality: 'Freyung',
    postalCode: '94078'
  },
  {
    municipality: 'Frickenhausen',
    postalCode: '72636'
  },
  {
    municipality: 'Frickenhausen a.Main',
    postalCode: '97252'
  },
  {
    municipality: 'Frickingen',
    postalCode: '88699'
  },
  {
    municipality: 'Fridingen an der Donau',
    postalCode: '78567'
  },
  {
    municipality: 'Fridolfing',
    postalCode: '83413'
  },
  {
    municipality: 'Friedberg',
    postalCode: '61169'
  },
  {
    municipality: 'Friedberg',
    postalCode: '86316'
  },
  {
    municipality: 'Friedeburg',
    postalCode: '26446'
  },
  {
    municipality: 'Friedelshausen',
    postalCode: '98634'
  },
  {
    municipality: 'Friedelsheim',
    postalCode: '67159'
  },
  {
    municipality: 'Friedenfels',
    postalCode: '95688'
  },
  {
    municipality: 'Friedenweiler',
    postalCode: '79877'
  },
  {
    municipality: 'Friedewald',
    postalCode: '36289'
  },
  {
    municipality: 'Friedewald',
    postalCode: '57520'
  },
  {
    municipality: 'Friedland',
    postalCode: '15848'
  },
  {
    municipality: 'Friedland',
    postalCode: '37133'
  },
  {
    municipality: 'Friedland',
    postalCode: '17098'
  },
  {
    municipality: 'Friedrichroda',
    postalCode: '99894'
  },
  {
    municipality: 'Friedrichsdorf',
    postalCode: '61273'
  },
  {
    municipality: 'Friedrichsdorf',
    postalCode: '61381'
  },
  {
    municipality: 'Friedrichsgabekoog',
    postalCode: '25764'
  },
  {
    municipality: 'Friedrichsgraben',
    postalCode: '24799'
  },
  {
    municipality: 'Friedrichshafen',
    postalCode: '88045'
  },
  {
    municipality: 'Friedrichshafen',
    postalCode: '88046'
  },
  {
    municipality: 'Friedrichshafen',
    postalCode: '88048'
  },
  {
    municipality: 'Friedrichsholm',
    postalCode: '24799'
  },
  {
    municipality: 'Friedrichskoog',
    postalCode: '25718'
  },
  {
    municipality: 'Friedrichsruhe',
    postalCode: '19089'
  },
  {
    municipality: 'Friedrichstadt',
    postalCode: '25840'
  },
  {
    municipality: 'Friedrichsthal',
    postalCode: '66299'
  },
  {
    municipality: 'Friedrichswalde',
    postalCode: '16247'
  },
  {
    municipality: 'Friedrich-Wilhelm-Lübke-Koog',
    postalCode: '25924'
  },
  {
    municipality: 'Frielendorf',
    postalCode: '34621'
  },
  {
    municipality: 'Friemar',
    postalCode: '99869'
  },
  {
    municipality: 'Friesack',
    postalCode: '14662'
  },
  {
    municipality: 'Friesenhagen',
    postalCode: '51598'
  },
  {
    municipality: 'Friesenheim',
    postalCode: '77948'
  },
  {
    municipality: 'Friesenheim',
    postalCode: '55278'
  },
  {
    municipality: 'Friesenried',
    postalCode: '87654'
  },
  {
    municipality: 'Friesoythe',
    postalCode: '26169'
  },
  {
    municipality: 'Friolzheim',
    postalCode: '71292'
  },
  {
    municipality: 'Frittlingen',
    postalCode: '78665'
  },
  {
    municipality: 'Fritzlar',
    postalCode: '34560'
  },
  {
    municipality: 'Frohburg',
    postalCode: '04654'
  },
  {
    municipality: 'Fröhnd',
    postalCode: '79677'
  },
  {
    municipality: 'Frohnhofen',
    postalCode: '66903'
  },
  {
    municipality: 'Fröndenberg/Ruhr',
    postalCode: '58730'
  },
  {
    municipality: 'Fronhausen',
    postalCode: '35112'
  },
  {
    municipality: 'Fronhofen',
    postalCode: '55471'
  },
  {
    municipality: 'Fronreute',
    postalCode: '88273'
  },
  {
    municipality: 'Frontenhausen',
    postalCode: '84160'
  },
  {
    municipality: 'Frücht',
    postalCode: '56132'
  },
  {
    municipality: 'Fuchshofen',
    postalCode: '53533'
  },
  {
    municipality: 'Fuchsmühl',
    postalCode: '95689'
  },
  {
    municipality: 'Fuchsstadt',
    postalCode: '97727'
  },
  {
    municipality: 'Fuchstal',
    postalCode: '86925'
  },
  {
    municipality: 'Fuhlendorf',
    postalCode: '18356'
  },
  {
    municipality: 'Fuhlendorf',
    postalCode: '24649'
  },
  {
    municipality: 'Fuhlenhagen',
    postalCode: '21493'
  },
  {
    municipality: 'Fulda',
    postalCode: '36037'
  },
  {
    municipality: 'Fulda',
    postalCode: '36039'
  },
  {
    municipality: 'Fulda',
    postalCode: '36041'
  },
  {
    municipality: 'Fulda',
    postalCode: '36043'
  },
  {
    municipality: 'Fuldabrück',
    postalCode: '34277'
  },
  {
    municipality: 'Fuldatal',
    postalCode: '34127'
  },
  {
    municipality: 'Fuldatal',
    postalCode: '34233'
  },
  {
    municipality: 'Fünfseen',
    postalCode: '17213'
  },
  {
    municipality: 'Fünfstetten',
    postalCode: '86681'
  },
  {
    municipality: 'Fürfeld',
    postalCode: '55546'
  },
  {
    municipality: 'Fürstenau',
    postalCode: '49584'
  },
  {
    municipality: 'Fürstenberg',
    postalCode: '37699'
  },
  {
    municipality: 'Fürstenberg/Havel',
    postalCode: '16798'
  },
  {
    municipality: 'Fürsteneck',
    postalCode: '94142'
  },
  {
    municipality: 'Fürstenfeldbruck',
    postalCode: '82256'
  },
  {
    municipality: 'Fürstenstein',
    postalCode: '94538'
  },
  {
    municipality: 'Fürstenwalde/Spree',
    postalCode: '15517'
  },
  {
    municipality: 'Fürstenzell',
    postalCode: '94081'
  },
  {
    municipality: 'Furth',
    postalCode: '84095'
  },
  {
    municipality: 'Fürth',
    postalCode: '90762'
  },
  {
    municipality: 'Fürth',
    postalCode: '90763'
  },
  {
    municipality: 'Fürth',
    postalCode: '90765'
  },
  {
    municipality: 'Fürth',
    postalCode: '90766'
  },
  {
    municipality: 'Fürth',
    postalCode: '90768'
  },
  {
    municipality: 'Fürth',
    postalCode: '64658'
  },
  {
    municipality: 'Fürthen',
    postalCode: '57539'
  },
  {
    municipality: 'Furth im Wald',
    postalCode: '93437'
  },
  {
    municipality: 'Furtwangen im Schwarzwald',
    postalCode: '78120'
  },
  {
    municipality: 'Füssen',
    postalCode: '87629'
  },
  {
    municipality: 'Fußgönheim',
    postalCode: '67136'
  },
  {
    municipality: 'Gablenz - Jabłońc',
    postalCode: '02953'
  },
  {
    municipality: 'Gablingen',
    postalCode: '86456'
  },
  {
    municipality: 'Gabsheim',
    postalCode: '55288'
  },
  {
    municipality: 'Gachenbach',
    postalCode: '86565'
  },
  {
    municipality: 'Gackenbach',
    postalCode: '56412'
  },
  {
    municipality: 'Gadebusch',
    postalCode: '19205'
  },
  {
    municipality: 'Gädheim',
    postalCode: '97503'
  },
  {
    municipality: 'Gägelow',
    postalCode: '23968'
  },
  {
    municipality: 'Gaggenau',
    postalCode: '76571'
  },
  {
    municipality: 'Gaiberg',
    postalCode: '69251'
  },
  {
    municipality: 'Gaienhofen',
    postalCode: '78343'
  },
  {
    municipality: 'Gaildorf',
    postalCode: '74405'
  },
  {
    municipality: 'Gailingen am Hochrhein',
    postalCode: '78262'
  },
  {
    municipality: 'Gaimersheim',
    postalCode: '85080'
  },
  {
    municipality: 'Gaißach',
    postalCode: '83674'
  },
  {
    municipality: 'Galenbeck',
    postalCode: '17099'
  },
  {
    municipality: 'Galenberg',
    postalCode: '56651'
  },
  {
    municipality: 'Gallin',
    postalCode: '19258'
  },
  {
    municipality: 'Gallin-Kuppentin',
    postalCode: '19386'
  },
  {
    municipality: 'Gallmersgarten',
    postalCode: '91605'
  },
  {
    municipality: 'Galmsbüll',
    postalCode: '25899'
  },
  {
    municipality: 'Gamlen',
    postalCode: '56761'
  },
  {
    municipality: 'Gammelby',
    postalCode: '24340'
  },
  {
    municipality: 'Gammelin',
    postalCode: '19230'
  },
  {
    municipality: 'Gammelsdorf',
    postalCode: '85408'
  },
  {
    municipality: 'Gammelshausen',
    postalCode: '73108'
  },
  {
    municipality: 'Gammertingen',
    postalCode: '72501'
  },
  {
    municipality: 'Ganderkesee',
    postalCode: '27777'
  },
  {
    municipality: 'Gandesbergen',
    postalCode: '27324'
  },
  {
    municipality: 'Gangelt',
    postalCode: '52538'
  },
  {
    municipality: 'Gangkofen',
    postalCode: '84140'
  },
  {
    municipality: 'Gangloffsömmern',
    postalCode: '99634'
  },
  {
    municipality: 'Ganzlin',
    postalCode: '19395'
  },
  {
    municipality: 'Gappenach',
    postalCode: '56294'
  },
  {
    municipality: 'Garbsen',
    postalCode: '30823'
  },
  {
    municipality: 'Garbsen',
    postalCode: '30826'
  },
  {
    municipality: 'Garbsen',
    postalCode: '30827'
  },
  {
    municipality: 'Garching an der Alz',
    postalCode: '84518'
  },
  {
    municipality: 'Garching bei München',
    postalCode: '85748'
  },
  {
    municipality: 'Gardelegen',
    postalCode: '39638'
  },
  {
    municipality: 'Gardelegen',
    postalCode: '39646'
  },
  {
    municipality: 'Gardelegen',
    postalCode: '39649'
  },
  {
    municipality: 'Garding',
    postalCode: '25836'
  },
  {
    municipality: 'Garlstorf',
    postalCode: '21376'
  },
  {
    municipality: 'Garmisch-Partenkirchen',
    postalCode: '82467'
  },
  {
    municipality: 'Garmisch-Partenkirchen',
    postalCode: '82475'
  },
  {
    municipality: 'Garrel',
    postalCode: '49681'
  },
  {
    municipality: 'Gars am Inn',
    postalCode: '83536'
  },
  {
    municipality: 'Gars am Inn',
    postalCode: '83546'
  },
  {
    municipality: 'Gars am Inn',
    postalCode: '83555'
  },
  {
    municipality: 'Gars am Inn',
    postalCode: '83559'
  },
  {
    municipality: 'Garstedt',
    postalCode: '21441'
  },
  {
    municipality: 'Gartow',
    postalCode: '29471'
  },
  {
    municipality: 'Gärtringen',
    postalCode: '71116'
  },
  {
    municipality: 'Gartz (Oder)',
    postalCode: '16307'
  },
  {
    municipality: 'Garz',
    postalCode: '17419'
  },
  {
    municipality: 'Garzau-Garzin',
    postalCode: '15345'
  },
  {
    municipality: 'Garz/Rügen',
    postalCode: '18574'
  },
  {
    municipality: 'Gattendorf',
    postalCode: '95185'
  },
  {
    municipality: 'Gau-Algesheim',
    postalCode: '55435'
  },
  {
    municipality: 'Gau-Bickelheim',
    postalCode: '55599'
  },
  {
    municipality: 'Gau-Bischofsheim',
    postalCode: '55296'
  },
  {
    municipality: 'Gauern',
    postalCode: '07580'
  },
  {
    municipality: 'Gauersheim',
    postalCode: '67294'
  },
  {
    municipality: 'Gäufelden',
    postalCode: '71126'
  },
  {
    municipality: 'Gaugrehweiler',
    postalCode: '67822'
  },
  {
    municipality: 'Gau-Heppenheim',
    postalCode: '55234'
  },
  {
    municipality: 'Gaukönigshofen',
    postalCode: '97253'
  },
  {
    municipality: 'Gau-Odernheim',
    postalCode: '55239'
  },
  {
    municipality: 'Gaushorn',
    postalCode: '25782'
  },
  {
    municipality: 'Gauting',
    postalCode: '82131'
  },
  {
    municipality: 'Gau-Weinheim',
    postalCode: '55578'
  },
  {
    municipality: 'Gebenbach',
    postalCode: '92274'
  },
  {
    municipality: 'Gebesee',
    postalCode: '99189'
  },
  {
    municipality: 'Gebhardshain',
    postalCode: '57580'
  },
  {
    municipality: 'Gebroth',
    postalCode: '55595'
  },
  {
    municipality: 'Gebsattel',
    postalCode: '91607'
  },
  {
    municipality: 'Gechingen',
    postalCode: '75391'
  },
  {
    municipality: 'Gedern',
    postalCode: '63688'
  },
  {
    municipality: 'Geeste',
    postalCode: '49744'
  },
  {
    municipality: 'Geesthacht',
    postalCode: '21502'
  },
  {
    municipality: 'Geestland',
    postalCode: '27607'
  },
  {
    municipality: 'Geestland',
    postalCode: '27624'
  },
  {
    municipality: 'Gefell',
    postalCode: '54552'
  },
  {
    municipality: 'Gefell',
    postalCode: '07926'
  },
  {
    municipality: 'Gefrees',
    postalCode: '95482'
  },
  {
    municipality: 'Gehlert',
    postalCode: '57627'
  },
  {
    municipality: 'Gehlsbach',
    postalCode: '19386'
  },
  {
    municipality: 'Gehlweiler',
    postalCode: '55490'
  },
  {
    municipality: 'Gehofen',
    postalCode: '06571'
  },
  {
    municipality: 'Gehrde',
    postalCode: '49596'
  },
  {
    municipality: 'Gehrden',
    postalCode: '30989'
  },
  {
    municipality: 'Gehrweiler',
    postalCode: '67724'
  },
  {
    municipality: 'Geichlingen',
    postalCode: '54675'
  },
  {
    municipality: 'Geiersthal',
    postalCode: '94244'
  },
  {
    municipality: 'Geilenkirchen',
    postalCode: '52511'
  },
  {
    municipality: 'Geilnau',
    postalCode: '56379'
  },
  {
    municipality: 'Geisa',
    postalCode: '36419'
  },
  {
    municipality: 'Geiselbach',
    postalCode: '63826'
  },
  {
    municipality: 'Geiselberg',
    postalCode: '67715'
  },
  {
    municipality: 'Geiselhöring',
    postalCode: '94333'
  },
  {
    municipality: 'Geiselwind',
    postalCode: '96160'
  },
  {
    municipality: 'Geisenfeld',
    postalCode: '85290'
  },
  {
    municipality: 'Geisenhain',
    postalCode: '07646'
  },
  {
    municipality: 'Geisenhausen',
    postalCode: '84144'
  },
  {
    municipality: 'Geisenheim',
    postalCode: '65366'
  },
  {
    municipality: 'Geisfeld',
    postalCode: '54413'
  },
  {
    municipality: 'Geisig',
    postalCode: '56357'
  },
  {
    municipality: 'Geisingen',
    postalCode: '78187'
  },
  {
    municipality: 'Geisleden',
    postalCode: '37308'
  },
  {
    municipality: 'Geislingen',
    postalCode: '72351'
  },
  {
    municipality: 'Geislingen an der Steige',
    postalCode: '73312'
  },
  {
    municipality: 'Geismar',
    postalCode: '37308'
  },
  {
    municipality: 'Geithain',
    postalCode: '04643'
  },
  {
    municipality: 'Gelbensande',
    postalCode: '18182'
  },
  {
    municipality: 'Gelchsheim',
    postalCode: '97255'
  },
  {
    municipality: 'Geldern',
    postalCode: '47608'
  },
  {
    municipality: 'Geldersheim',
    postalCode: '97505'
  },
  {
    municipality: 'Gelenau/Erzgebirge',
    postalCode: '09423'
  },
  {
    municipality: 'Gelenberg',
    postalCode: '53539'
  },
  {
    municipality: 'Gelnhausen',
    postalCode: '63571'
  },
  {
    municipality: 'Gelnhausen',
    postalCode: '63589'
  },
  {
    municipality: 'Gelsenkirchen',
    postalCode: '45879'
  },
  {
    municipality: 'Gelsenkirchen',
    postalCode: '45881'
  },
  {
    municipality: 'Gelsenkirchen',
    postalCode: '45883'
  },
  {
    municipality: 'Gelsenkirchen',
    postalCode: '45884'
  },
  {
    municipality: 'Gelsenkirchen',
    postalCode: '45886'
  },
  {
    municipality: 'Gelsenkirchen',
    postalCode: '45888'
  },
  {
    municipality: 'Gelsenkirchen',
    postalCode: '45889'
  },
  {
    municipality: 'Gelsenkirchen',
    postalCode: '45891'
  },
  {
    municipality: 'Gelsenkirchen',
    postalCode: '45892'
  },
  {
    municipality: 'Gelsenkirchen',
    postalCode: '45894'
  },
  {
    municipality: 'Gelsenkirchen',
    postalCode: '45896'
  },
  {
    municipality: 'Gelsenkirchen',
    postalCode: '45897'
  },
  {
    municipality: 'Gelsenkirchen',
    postalCode: '45899'
  },
  {
    municipality: 'Geltendorf',
    postalCode: '82269'
  },
  {
    municipality: 'Gelting',
    postalCode: '24395'
  },
  {
    municipality: 'Geltorf',
    postalCode: '24884'
  },
  {
    municipality: 'Gemmerich',
    postalCode: '56357'
  },
  {
    municipality: 'Gemmingen',
    postalCode: '75050'
  },
  {
    municipality: 'Gemmrigheim',
    postalCode: '74376'
  },
  {
    municipality: 'Gemünd',
    postalCode: '54673'
  },
  {
    municipality: 'Gemünden',
    postalCode: '56459'
  },
  {
    municipality: 'Gemünden',
    postalCode: '55490'
  },
  {
    municipality: 'Gemünden am Main',
    postalCode: '97737'
  },
  {
    municipality: 'Gemünden (Felda)',
    postalCode: '35329'
  },
  {
    municipality: 'Gemünden (Wohra)',
    postalCode: '35285'
  },
  {
    municipality: 'Genderkingen',
    postalCode: '86682'
  },
  {
    municipality: 'Gengenbach',
    postalCode: '77723'
  },
  {
    municipality: 'Gensingen',
    postalCode: '55457'
  },
  {
    municipality: 'Genthin',
    postalCode: '39291'
  },
  {
    municipality: 'Genthin',
    postalCode: '39307'
  },
  {
    municipality: 'Gentingen',
    postalCode: '54675'
  },
  {
    municipality: 'Georgenberg',
    postalCode: '92697'
  },
  {
    municipality: 'Georgensgmünd',
    postalCode: '91166'
  },
  {
    municipality: 'Georgenthal',
    postalCode: '99887'
  },
  {
    municipality: 'Georgsdorf',
    postalCode: '49828'
  },
  {
    municipality: 'Georgsmarienhütte',
    postalCode: '49124'
  },
  {
    municipality: 'Gera',
    postalCode: '07545'
  },
  {
    municipality: 'Gera',
    postalCode: '07546'
  },
  {
    municipality: 'Gera',
    postalCode: '07548'
  },
  {
    municipality: 'Gera',
    postalCode: '07549'
  },
  {
    municipality: 'Gera',
    postalCode: '07551'
  },
  {
    municipality: 'Gera',
    postalCode: '07552'
  },
  {
    municipality: 'Gera',
    postalCode: '07554'
  },
  {
    municipality: 'Gera',
    postalCode: '07557'
  },
  {
    municipality: 'Gerabronn',
    postalCode: '74582'
  },
  {
    municipality: 'Gerach',
    postalCode: '96161'
  },
  {
    municipality: 'Gerach',
    postalCode: '55743'
  },
  {
    municipality: 'Geratal',
    postalCode: '99330'
  },
  {
    municipality: 'Geratal',
    postalCode: '99331'
  },
  {
    municipality: 'Geratskirchen',
    postalCode: '84552'
  },
  {
    municipality: 'Gerbach',
    postalCode: '67813'
  },
  {
    municipality: 'Gerbershausen',
    postalCode: '37318'
  },
  {
    municipality: 'Gerbrunn',
    postalCode: '97218'
  },
  {
    municipality: 'Gerbstedt',
    postalCode: '06347'
  },
  {
    municipality: 'Gerdau',
    postalCode: '29581'
  },
  {
    municipality: 'Gerdshagen',
    postalCode: '16928'
  },
  {
    municipality: 'Geretsried',
    postalCode: '82538'
  },
  {
    municipality: 'Gerhardsbrunn',
    postalCode: '66851'
  },
  {
    municipality: 'Gerhardsbrunn',
    postalCode: '66894'
  },
  {
    municipality: 'Gerhardshofen',
    postalCode: '91466'
  },
  {
    municipality: 'Gering',
    postalCode: '56751'
  },
  {
    municipality: 'Geringswalde',
    postalCode: '09326'
  },
  {
    municipality: 'Gerlingen',
    postalCode: '70839'
  },
  {
    municipality: 'Germaringen',
    postalCode: '87656'
  },
  {
    municipality: 'Germering',
    postalCode: '82110'
  },
  {
    municipality: 'Germersheim',
    postalCode: '76726'
  },
  {
    municipality: 'Gernrode',
    postalCode: '37339'
  },
  {
    municipality: 'Gernsbach',
    postalCode: '76593'
  },
  {
    municipality: 'Gernsheim',
    postalCode: '64579'
  },
  {
    municipality: 'Geroda',
    postalCode: '97779'
  },
  {
    municipality: 'Geroda',
    postalCode: '07819'
  },
  {
    municipality: 'Geroldsgrün',
    postalCode: '95179'
  },
  {
    municipality: 'Geroldshausen',
    postalCode: '97256'
  },
  {
    municipality: 'Gerolfingen',
    postalCode: '91726'
  },
  {
    municipality: 'Gerolsbach',
    postalCode: '85302'
  },
  {
    municipality: 'Gerolsheim',
    postalCode: '67229'
  },
  {
    municipality: 'Gerolstein',
    postalCode: '54568'
  },
  {
    municipality: 'Gerolzhofen',
    postalCode: '97447'
  },
  {
    municipality: 'Gersdorf',
    postalCode: '09355'
  },
  {
    municipality: 'Gersfeld',
    postalCode: '36129'
  },
  {
    municipality: 'Gersheim',
    postalCode: '66453'
  },
  {
    municipality: 'Gersten',
    postalCode: '49838'
  },
  {
    municipality: 'Gerstenberg',
    postalCode: '04617'
  },
  {
    municipality: 'Gerstengrund',
    postalCode: '36419'
  },
  {
    municipality: 'Gerstetten',
    postalCode: '89547'
  },
  {
    municipality: 'Gersthofen',
    postalCode: '86368'
  },
  {
    municipality: 'Gerstungen',
    postalCode: '99834'
  },
  {
    municipality: 'Gerswalde',
    postalCode: '17268'
  },
  {
    municipality: 'Gertewitz',
    postalCode: '07389'
  },
  {
    municipality: 'Gerzen',
    postalCode: '84175'
  },
  {
    municipality: 'Geschendorf',
    postalCode: '23815'
  },
  {
    municipality: 'Gescher',
    postalCode: '48712'
  },
  {
    municipality: 'Gesees',
    postalCode: '95494'
  },
  {
    municipality: 'Geseke',
    postalCode: '59590'
  },
  {
    municipality: 'Geslau',
    postalCode: '91608'
  },
  {
    municipality: 'Gessertshausen',
    postalCode: '86459'
  },
  {
    municipality: 'Gestratz',
    postalCode: '88167'
  },
  {
    municipality: 'Getelo',
    postalCode: '49843'
  },
  {
    municipality: 'Gettorf',
    postalCode: '24214'
  },
  {
    municipality: 'Gevelsberg',
    postalCode: '58285'
  },
  {
    municipality: 'Gevenich',
    postalCode: '56825'
  },
  {
    municipality: 'Gevensleben',
    postalCode: '38384'
  },
  {
    municipality: 'Geyer',
    postalCode: '09468'
  },
  {
    municipality: 'Giebelstadt',
    postalCode: '97232'
  },
  {
    municipality: 'Gieboldehausen',
    postalCode: '37434'
  },
  {
    municipality: 'Giekau',
    postalCode: '24321'
  },
  {
    municipality: 'Gieleroth',
    postalCode: '57610'
  },
  {
    municipality: 'Gielert',
    postalCode: '54424'
  },
  {
    municipality: 'Gielow',
    postalCode: '17139'
  },
  {
    municipality: 'Giengen an der Brenz',
    postalCode: '89522'
  },
  {
    municipality: 'Giengen an der Brenz',
    postalCode: '89537'
  },
  {
    municipality: 'Gierschnach',
    postalCode: '56294'
  },
  {
    municipality: 'Giershausen',
    postalCode: '57632'
  },
  {
    municipality: 'Giersleben',
    postalCode: '06449'
  },
  {
    municipality: 'Gierstädt',
    postalCode: '99100'
  },
  {
    municipality: 'Giesdorf',
    postalCode: '54614'
  },
  {
    municipality: 'Giesen',
    postalCode: '31180'
  },
  {
    municipality: 'Giesenhausen',
    postalCode: '57612'
  },
  {
    municipality: 'Giesensdorf',
    postalCode: '23909'
  },
  {
    municipality: 'Gießen',
    postalCode: '35390'
  },
  {
    municipality: 'Gießen',
    postalCode: '35392'
  },
  {
    municipality: 'Gießen',
    postalCode: '35394'
  },
  {
    municipality: 'Gießen',
    postalCode: '35396'
  },
  {
    municipality: 'Gießen',
    postalCode: '35398'
  },
  {
    municipality: 'Gifhorn',
    postalCode: '38518'
  },
  {
    municipality: 'Gifhorn',
    postalCode: '38559'
  },
  {
    municipality: 'Gilching',
    postalCode: '82205'
  },
  {
    municipality: 'Gillenbeuren',
    postalCode: '56825'
  },
  {
    municipality: 'Gillenfeld',
    postalCode: '54558'
  },
  {
    municipality: 'Gilserberg',
    postalCode: '34630'
  },
  {
    municipality: 'Gilten',
    postalCode: '29690'
  },
  {
    municipality: 'Gilzem',
    postalCode: '54298'
  },
  {
    municipality: 'Gimbsheim',
    postalCode: '67578'
  },
  {
    municipality: 'Gimbweiler',
    postalCode: '55767'
  },
  {
    municipality: 'Gindorf',
    postalCode: '54657'
  },
  {
    municipality: 'Gingen an der Fils',
    postalCode: '73333'
  },
  {
    municipality: 'Gingst',
    postalCode: '18569'
  },
  {
    municipality: 'Ginsheim-Gustavsburg',
    postalCode: '65462'
  },
  {
    municipality: 'Ginsweiler',
    postalCode: '67742'
  },
  {
    municipality: 'Gipperath',
    postalCode: '54533'
  },
  {
    municipality: 'Girkenroth',
    postalCode: '56459'
  },
  {
    municipality: 'Girod',
    postalCode: '56412'
  },
  {
    municipality: 'Gladbach',
    postalCode: '54518'
  },
  {
    municipality: 'Gladbeck',
    postalCode: '45964'
  },
  {
    municipality: 'Gladbeck',
    postalCode: '45966'
  },
  {
    municipality: 'Gladbeck',
    postalCode: '45968'
  },
  {
    municipality: 'Gladenbach',
    postalCode: '35075'
  },
  {
    municipality: 'Glanbrücken',
    postalCode: '66887'
  },
  {
    municipality: 'Glandorf',
    postalCode: '49219'
  },
  {
    municipality: 'Glan-Münchweiler',
    postalCode: '66907'
  },
  {
    municipality: 'Glasau',
    postalCode: '23719'
  },
  {
    municipality: 'Glasehausen',
    postalCode: '37308'
  },
  {
    municipality: 'Glasewitz',
    postalCode: '18276'
  },
  {
    municipality: 'Glashütte',
    postalCode: '01768'
  },
  {
    municipality: 'Glashütten',
    postalCode: '61479'
  },
  {
    municipality: 'Glashütten',
    postalCode: '95496'
  },
  {
    municipality: 'Glasin',
    postalCode: '23992'
  },
  {
    municipality: 'Glasow',
    postalCode: '17322'
  },
  {
    municipality: 'Glattbach',
    postalCode: '63864'
  },
  {
    municipality: 'Glatten',
    postalCode: '72293'
  },
  {
    municipality: 'Glaubitz',
    postalCode: '01612'
  },
  {
    municipality: 'Glauburg',
    postalCode: '63695'
  },
  {
    municipality: 'Glauchau',
    postalCode: '08371'
  },
  {
    municipality: 'Glees',
    postalCode: '56653'
  },
  {
    municipality: 'Gleichen',
    postalCode: '37130'
  },
  {
    municipality: 'Gleina',
    postalCode: '06632'
  },
  {
    municipality: 'Gleiritsch',
    postalCode: '92723'
  },
  {
    municipality: 'Gleißenberg',
    postalCode: '93477'
  },
  {
    municipality: 'Gleisweiler',
    postalCode: '76835'
  },
  {
    municipality: 'Gleiszellen-Gleishorbach',
    postalCode: '76889'
  },
  {
    municipality: 'Glewitz',
    postalCode: '18513'
  },
  {
    municipality: 'Glienicke/Nordbahn',
    postalCode: '16548'
  },
  {
    municipality: 'Glinde',
    postalCode: '21509'
  },
  {
    municipality: 'Glonn',
    postalCode: '85625'
  },
  {
    municipality: 'Glött',
    postalCode: '89353'
  },
  {
    municipality: 'Glottertal',
    postalCode: '79286'
  },
  {
    municipality: 'Glowe',
    postalCode: '18551'
  },
  {
    municipality: 'Glücksburg',
    postalCode: '24960'
  },
  {
    municipality: 'Glückstadt',
    postalCode: '25348'
  },
  {
    municipality: 'Glüsing',
    postalCode: '25779'
  },
  {
    municipality: 'Gmund',
    postalCode: '83703'
  },
  {
    municipality: 'Gnarrenburg',
    postalCode: '27442'
  },
  {
    municipality: 'Gneus',
    postalCode: '07646'
  },
  {
    municipality: 'Gneven',
    postalCode: '19065'
  },
  {
    municipality: 'Gnevkow',
    postalCode: '17089'
  },
  {
    municipality: 'Gnewitz',
    postalCode: '18195'
  },
  {
    municipality: 'Gnoien',
    postalCode: '17179'
  },
  {
    municipality: 'Gnotzheim',
    postalCode: '91728'
  },
  {
    municipality: 'Gnutz',
    postalCode: '24622'
  },
  {
    municipality: 'Goch',
    postalCode: '47574'
  },
  {
    municipality: 'Gochsheim',
    postalCode: '97469'
  },
  {
    municipality: 'Göcklingen',
    postalCode: '76831'
  },
  {
    municipality: 'Göda - Hodźij',
    postalCode: '02633'
  },
  {
    municipality: 'Goddert',
    postalCode: '56244'
  },
  {
    municipality: 'Godendorf',
    postalCode: '17237'
  },
  {
    municipality: 'Gödenroth',
    postalCode: '56290'
  },
  {
    municipality: 'Gödenstorf',
    postalCode: '21376'
  },
  {
    municipality: 'Goethestadt Bad Lauchstädt',
    postalCode: '06246'
  },
  {
    municipality: 'Göggingen',
    postalCode: '73571'
  },
  {
    municipality: 'Göhl',
    postalCode: '23758'
  },
  {
    municipality: 'Göhlen',
    postalCode: '19288'
  },
  {
    municipality: 'Göhrde',
    postalCode: '29473'
  },
  {
    municipality: 'Göhren',
    postalCode: '18586'
  },
  {
    municipality: 'Göhren',
    postalCode: '04603'
  },
  {
    municipality: 'Göhren-Lebbin',
    postalCode: '17213'
  },
  {
    municipality: 'Gohrisch',
    postalCode: '01824'
  },
  {
    municipality: 'Gokels',
    postalCode: '25557'
  },
  {
    municipality: 'Golchen',
    postalCode: '17089'
  },
  {
    municipality: 'Goldbach',
    postalCode: '63773'
  },
  {
    municipality: 'Goldbeck',
    postalCode: '39596'
  },
  {
    municipality: 'Goldberg',
    postalCode: '19399'
  },
  {
    municipality: 'Goldebek',
    postalCode: '25862'
  },
  {
    municipality: 'Goldelund',
    postalCode: '25862'
  },
  {
    municipality: 'Göldenitz',
    postalCode: '23919'
  },
  {
    municipality: 'Goldenstedt',
    postalCode: '49424'
  },
  {
    municipality: 'Goldisthal',
    postalCode: '98746'
  },
  {
    municipality: 'Goldkronach',
    postalCode: '95497'
  },
  {
    municipality: 'Gölenkamp',
    postalCode: '49843'
  },
  {
    municipality: 'Gollenberg',
    postalCode: '55767'
  },
  {
    municipality: 'Gollenberg',
    postalCode: '14728'
  },
  {
    municipality: 'Göllheim',
    postalCode: '67307'
  },
  {
    municipality: 'Gollhofen',
    postalCode: '97258'
  },
  {
    municipality: 'Göllnitz',
    postalCode: '04626'
  },
  {
    municipality: 'Golmbach',
    postalCode: '37640'
  },
  {
    municipality: 'Golmsdorf',
    postalCode: '07751'
  },
  {
    municipality: 'Golßen',
    postalCode: '15938'
  },
  {
    municipality: 'Golzow',
    postalCode: '14778'
  },
  {
    municipality: 'Golzow',
    postalCode: '15328'
  },
  {
    municipality: 'Gomadingen',
    postalCode: '72532'
  },
  {
    municipality: 'Gomaringen',
    postalCode: '72810'
  },
  {
    municipality: 'Gommern',
    postalCode: '39175'
  },
  {
    municipality: 'Gommern',
    postalCode: '39245'
  },
  {
    municipality: 'Gommern',
    postalCode: '39264'
  },
  {
    municipality: 'Gommern',
    postalCode: '39279'
  },
  {
    municipality: 'Gommern',
    postalCode: '39291'
  },
  {
    municipality: 'Gommersheim',
    postalCode: '67377'
  },
  {
    municipality: 'Gonbach',
    postalCode: '67724'
  },
  {
    municipality: 'Gondelsheim',
    postalCode: '75053'
  },
  {
    municipality: 'Gondenbrett',
    postalCode: '54595'
  },
  {
    municipality: 'Gondershausen',
    postalCode: '56283'
  },
  {
    municipality: 'Gondorf',
    postalCode: '54647'
  },
  {
    municipality: 'Gönnebek',
    postalCode: '24610'
  },
  {
    municipality: 'Gönnersdorf',
    postalCode: '53498'
  },
  {
    municipality: 'Gönnersdorf',
    postalCode: '54584'
  },
  {
    municipality: 'Gönnheim',
    postalCode: '67161'
  },
  {
    municipality: 'Goosefeld',
    postalCode: '24340'
  },
  {
    municipality: 'Göpfersdorf',
    postalCode: '04618'
  },
  {
    municipality: 'Göppingen',
    postalCode: '73033'
  },
  {
    municipality: 'Göppingen',
    postalCode: '73035'
  },
  {
    municipality: 'Göppingen',
    postalCode: '73037'
  },
  {
    municipality: 'Göppingen',
    postalCode: '73116'
  },
  {
    municipality: 'Gorden-Staupitz',
    postalCode: '03238'
  },
  {
    municipality: 'Görgeshausen',
    postalCode: '56412'
  },
  {
    municipality: 'Görisried',
    postalCode: '87657'
  },
  {
    municipality: 'Göritz',
    postalCode: '17291'
  },
  {
    municipality: 'Görkwitz',
    postalCode: '07907'
  },
  {
    municipality: 'Gorleben',
    postalCode: '29475'
  },
  {
    municipality: 'Görlitz',
    postalCode: '02826'
  },
  {
    municipality: 'Görlitz',
    postalCode: '02827'
  },
  {
    municipality: 'Görlitz',
    postalCode: '02828'
  },
  {
    municipality: 'Gorlosen',
    postalCode: '19294'
  },
  {
    municipality: 'Görmin',
    postalCode: '17121'
  },
  {
    municipality: 'Gornau',
    postalCode: '09405'
  },
  {
    municipality: 'Gornau',
    postalCode: '09437'
  },
  {
    municipality: 'Gornau',
    postalCode: '09573'
  },
  {
    municipality: 'Gornhausen',
    postalCode: '54472'
  },
  {
    municipality: 'Gornsdorf',
    postalCode: '09390'
  },
  {
    municipality: 'Görsbach',
    postalCode: '99765'
  },
  {
    municipality: 'Görwihl',
    postalCode: '79733'
  },
  {
    municipality: 'Gorxheimertal',
    postalCode: '69517'
  },
  {
    municipality: 'Görzke',
    postalCode: '14828'
  },
  {
    municipality: 'Göschitz',
    postalCode: '07907'
  },
  {
    municipality: 'Goseck',
    postalCode: '06667'
  },
  {
    municipality: 'Gösen',
    postalCode: '07607'
  },
  {
    municipality: 'Gosen-Neu Zittau',
    postalCode: '15537'
  },
  {
    municipality: 'Gösenroth',
    postalCode: '55624'
  },
  {
    municipality: 'Gosheim',
    postalCode: '78559'
  },
  {
    municipality: 'Goslar',
    postalCode: '38640'
  },
  {
    municipality: 'Goslar',
    postalCode: '38642'
  },
  {
    municipality: 'Goslar',
    postalCode: '38644'
  },
  {
    municipality: 'Goslar',
    postalCode: '38690'
  },
  {
    municipality: 'Gössenheim',
    postalCode: '97780'
  },
  {
    municipality: 'Gossersweiler-Stein',
    postalCode: '76857'
  },
  {
    municipality: 'Gössitz',
    postalCode: '07389'
  },
  {
    municipality: 'Gößnitz',
    postalCode: '04639'
  },
  {
    municipality: 'Gößweinstein',
    postalCode: '91327'
  },
  {
    municipality: 'Gotha',
    postalCode: '99867'
  },
  {
    municipality: 'Gottenheim',
    postalCode: '79288'
  },
  {
    municipality: 'Gottesgabe',
    postalCode: '19209'
  },
  {
    municipality: 'Gotteszell',
    postalCode: '94239'
  },
  {
    municipality: 'Gottfrieding',
    postalCode: '84177'
  },
  {
    municipality: 'Gotthun',
    postalCode: '17207'
  },
  {
    municipality: 'Göttin',
    postalCode: '21514'
  },
  {
    municipality: 'Göttingen',
    postalCode: '37073'
  },
  {
    municipality: 'Göttingen',
    postalCode: '37075'
  },
  {
    municipality: 'Göttingen',
    postalCode: '37077'
  },
  {
    municipality: 'Göttingen',
    postalCode: '37079'
  },
  {
    municipality: 'Göttingen',
    postalCode: '37081'
  },
  {
    municipality: 'Göttingen',
    postalCode: '37083'
  },
  {
    municipality: 'Göttingen',
    postalCode: '37085'
  },
  {
    municipality: 'Gottmadingen',
    postalCode: '78244'
  },
  {
    municipality: 'Graach an der Mosel',
    postalCode: '54470'
  },
  {
    municipality: 'Graal-Müritz',
    postalCode: '18181'
  },
  {
    municipality: 'Grabau',
    postalCode: '23845'
  },
  {
    municipality: 'Grabau',
    postalCode: '21493'
  },
  {
    municipality: 'Graben',
    postalCode: '86836'
  },
  {
    municipality: 'Gräben',
    postalCode: '14793'
  },
  {
    municipality: 'Graben-Neudorf',
    postalCode: '76676'
  },
  {
    municipality: 'Grabenstätt',
    postalCode: '83355'
  },
  {
    municipality: 'Grabenstetten',
    postalCode: '72582'
  },
  {
    municipality: 'Grabfeld',
    postalCode: '98631'
  },
  {
    municipality: 'Grabow',
    postalCode: '19300'
  },
  {
    municipality: 'Grabowhöfe',
    postalCode: '17194'
  },
  {
    municipality: 'Gräfelfing',
    postalCode: '82166'
  },
  {
    municipality: 'Grafenau',
    postalCode: '71120'
  },
  {
    municipality: 'Grafenau',
    postalCode: '94481'
  },
  {
    municipality: 'Grafenberg',
    postalCode: '72661'
  },
  {
    municipality: 'Gräfenberg',
    postalCode: '91322'
  },
  {
    municipality: 'Gräfendhron',
    postalCode: '54426'
  },
  {
    municipality: 'Gräfendorf',
    postalCode: '97782'
  },
  {
    municipality: 'Grafengehaig',
    postalCode: '95356'
  },
  {
    municipality: 'Gräfenhainichen',
    postalCode: '06772'
  },
  {
    municipality: 'Gräfenhainichen',
    postalCode: '06773'
  },
  {
    municipality: 'Grafenhausen',
    postalCode: '79865'
  },
  {
    municipality: 'Grafenrheinfeld',
    postalCode: '97506'
  },
  {
    municipality: 'Gräfenthal',
    postalCode: '98743'
  },
  {
    municipality: 'Grafenwiesen',
    postalCode: '93479'
  },
  {
    municipality: 'Grafenwöhr',
    postalCode: '92655'
  },
  {
    municipality: 'Grafhorst',
    postalCode: '38462'
  },
  {
    municipality: 'Grafing bei München',
    postalCode: '85567'
  },
  {
    municipality: 'Grafling',
    postalCode: '94539'
  },
  {
    municipality: 'Grafrath',
    postalCode: '82284'
  },
  {
    municipality: 'Grafschaft',
    postalCode: '53501'
  },
  {
    municipality: 'Grainau',
    postalCode: '82491'
  },
  {
    municipality: 'Grainet',
    postalCode: '94143'
  },
  {
    municipality: 'Graitschen bei Bürgel',
    postalCode: '07616'
  },
  {
    municipality: 'Grambek',
    postalCode: '23883'
  },
  {
    municipality: 'Grambin',
    postalCode: '17375'
  },
  {
    municipality: 'Grambow',
    postalCode: '17322'
  },
  {
    municipality: 'Grambow',
    postalCode: '19071'
  },
  {
    municipality: 'Grambow',
    postalCode: '19073'
  },
  {
    municipality: 'Grammendorf',
    postalCode: '18513'
  },
  {
    municipality: 'Grammentin',
    postalCode: '17153'
  },
  {
    municipality: 'Grammetal',
    postalCode: '99428'
  },
  {
    municipality: 'Grammow',
    postalCode: '18195'
  },
  {
    municipality: 'Gramzow',
    postalCode: '17291'
  },
  {
    municipality: 'Grande',
    postalCode: '22946'
  },
  {
    municipality: 'Gransdorf',
    postalCode: '54533'
  },
  {
    municipality: 'Gransebieth',
    postalCode: '18513'
  },
  {
    municipality: 'Gransee',
    postalCode: '16775'
  },
  {
    municipality: 'Granzin',
    postalCode: '19386'
  },
  {
    municipality: 'Grapzow',
    postalCode: '17089'
  },
  {
    municipality: 'Grasberg',
    postalCode: '28879'
  },
  {
    municipality: 'Grasbrunn',
    postalCode: '85630'
  },
  {
    municipality: 'Grasellenbach',
    postalCode: '64689'
  },
  {
    municipality: 'Grasleben',
    postalCode: '38368'
  },
  {
    municipality: 'Grassau',
    postalCode: '83224'
  },
  {
    municipality: 'Grattersdorf',
    postalCode: '94541'
  },
  {
    municipality: 'Grauel',
    postalCode: '24594'
  },
  {
    municipality: 'Grävenwiesbach',
    postalCode: '61279'
  },
  {
    municipality: 'Grebenau',
    postalCode: '36323'
  },
  {
    municipality: 'Grebenhain',
    postalCode: '36355'
  },
  {
    municipality: 'Grebenstein',
    postalCode: '34393'
  },
  {
    municipality: 'Grebin',
    postalCode: '24329'
  },
  {
    municipality: 'Grebs-Niendorf',
    postalCode: '19294'
  },
  {
    municipality: 'Greding',
    postalCode: '91171'
  },
  {
    municipality: 'Grefrath',
    postalCode: '47929'
  },
  {
    municipality: 'Greifenberg',
    postalCode: '86926'
  },
  {
    municipality: 'Greifenstein',
    postalCode: '35753'
  },
  {
    municipality: 'Greifswald',
    postalCode: '17489'
  },
  {
    municipality: 'Greifswald',
    postalCode: '17491'
  },
  {
    municipality: 'Greifswald',
    postalCode: '17493'
  },
  {
    municipality: 'Greiling',
    postalCode: '83677'
  },
  {
    municipality: 'Greimerath',
    postalCode: '54314'
  },
  {
    municipality: 'Greimerath',
    postalCode: '54533'
  },
  {
    municipality: 'Greimersburg',
    postalCode: '56814'
  },
  {
    municipality: 'Greiz',
    postalCode: '07973'
  },
  {
    municipality: 'Gremersdorf',
    postalCode: '23758'
  },
  {
    municipality: 'Gremersdorf-Buchholz',
    postalCode: '18461'
  },
  {
    municipality: 'Gremsdorf',
    postalCode: '91350'
  },
  {
    municipality: 'Grenderich',
    postalCode: '56858'
  },
  {
    municipality: 'Grenzach-Wyhlen',
    postalCode: '79639'
  },
  {
    municipality: 'Gresse',
    postalCode: '19258'
  },
  {
    municipality: 'Grethem',
    postalCode: '29690'
  },
  {
    municipality: 'Grettstadt',
    postalCode: '97508'
  },
  {
    municipality: 'Greußen',
    postalCode: '99718'
  },
  {
    municipality: 'Greußenheim',
    postalCode: '97259'
  },
  {
    municipality: 'Greven',
    postalCode: '48268'
  },
  {
    municipality: 'Greven',
    postalCode: '19258'
  },
  {
    municipality: 'Grevenbroich',
    postalCode: '41515'
  },
  {
    municipality: 'Grevenbroich',
    postalCode: '41516'
  },
  {
    municipality: 'Grevenbroich',
    postalCode: '41517'
  },
  {
    municipality: 'Grevenkop',
    postalCode: '25361'
  },
  {
    municipality: 'Grevenkrug',
    postalCode: '24241'
  },
  {
    municipality: 'Grevesmühlen',
    postalCode: '23936'
  },
  {
    municipality: 'Gribbohm',
    postalCode: '25596'
  },
  {
    municipality: 'Gribow',
    postalCode: '17506'
  },
  {
    municipality: 'Griebelschied',
    postalCode: '55608'
  },
  {
    municipality: 'Grieben',
    postalCode: '23936'
  },
  {
    municipality: 'Griefstedt',
    postalCode: '99638'
  },
  {
    municipality: 'Gries',
    postalCode: '66903'
  },
  {
    municipality: 'Griesheim',
    postalCode: '64347'
  },
  {
    municipality: 'Griesingen',
    postalCode: '89608'
  },
  {
    municipality: 'Griesstätt',
    postalCode: '83556'
  },
  {
    municipality: 'Grimburg',
    postalCode: '54413'
  },
  {
    municipality: 'Grimma',
    postalCode: '04668'
  },
  {
    municipality: 'Grimmelshausen',
    postalCode: '98660'
  },
  {
    municipality: 'Grimmen',
    postalCode: '18507'
  },
  {
    municipality: 'Grinau',
    postalCode: '23847'
  },
  {
    municipality: 'Grischow',
    postalCode: '17089'
  },
  {
    municipality: 'Grobengereuth',
    postalCode: '07389'
  },
  {
    municipality: 'Gröbenzell',
    postalCode: '82194'
  },
  {
    municipality: 'Gröde',
    postalCode: '25869'
  },
  {
    municipality: 'Gröden',
    postalCode: '04932'
  },
  {
    municipality: 'Grödersby',
    postalCode: '24376'
  },
  {
    municipality: 'Grödersby',
    postalCode: '24399'
  },
  {
    municipality: 'Gröditz',
    postalCode: '01609'
  },
  {
    municipality: 'Groitzsch',
    postalCode: '04539'
  },
  {
    municipality: 'Grolsheim',
    postalCode: '55459'
  },
  {
    municipality: 'Grömbach',
    postalCode: '72294'
  },
  {
    municipality: 'Grömbach',
    postalCode: '72297'
  },
  {
    municipality: 'Grömitz',
    postalCode: '23743'
  },
  {
    municipality: 'Gronau',
    postalCode: '48599'
  },
  {
    municipality: 'Gronau',
    postalCode: '31028'
  },
  {
    municipality: 'Gröningen',
    postalCode: '39397'
  },
  {
    municipality: 'Grönwohld',
    postalCode: '22956'
  },
  {
    municipality: 'Großaitingen',
    postalCode: '86845'
  },
  {
    municipality: 'Großalmerode',
    postalCode: '37247'
  },
  {
    municipality: 'Großbardorf',
    postalCode: '97633'
  },
  {
    municipality: 'Großbarkau',
    postalCode: '24245'
  },
  {
    municipality: 'Großbartloff',
    postalCode: '37359'
  },
  {
    municipality: 'Großbeeren',
    postalCode: '14979'
  },
  {
    municipality: 'Groß Berßen',
    postalCode: '49777'
  },
  {
    municipality: 'Großbettlingen',
    postalCode: '72663'
  },
  {
    municipality: 'Groß-Bieberau',
    postalCode: '64395'
  },
  {
    municipality: 'Groß-Bieberau',
    postalCode: '64401'
  },
  {
    municipality: 'Großbockedra',
    postalCode: '07646'
  },
  {
    municipality: 'Groß Boden',
    postalCode: '23847'
  },
  {
    municipality: 'Großbottwar',
    postalCode: '71723'
  },
  {
    municipality: 'Großbreitenbach',
    postalCode: '98701'
  },
  {
    municipality: 'Groß Buchwald',
    postalCode: '24582'
  },
  {
    municipality: 'Großbundenbach',
    postalCode: '66501'
  },
  {
    municipality: 'Großderschau',
    postalCode: '16845'
  },
  {
    municipality: 'Groß Disnack',
    postalCode: '23911'
  },
  {
    municipality: 'Groß Düben - Dźěwin',
    postalCode: '02953'
  },
  {
    municipality: 'Groß Düben - Dźěwin',
    postalCode: '02959'
  },
  {
    municipality: 'Großdubrau - Wulka Dubrawa',
    postalCode: '02694'
  },
  {
    municipality: 'Großefehn',
    postalCode: '26629'
  },
  {
    municipality: 'Großeibstadt',
    postalCode: '97633'
  },
  {
    municipality: 'Grosselfingen',
    postalCode: '72415'
  },
  {
    municipality: 'Großenaspe',
    postalCode: '24623'
  },
  {
    municipality: 'Großenbrode',
    postalCode: '23775'
  },
  {
    municipality: 'Großenhain',
    postalCode: '01558'
  },
  {
    municipality: 'Großenhain',
    postalCode: '01561'
  },
  {
    municipality: 'Großenkneten',
    postalCode: '26197'
  },
  {
    municipality: 'Großenlüder',
    postalCode: '36137'
  },
  {
    municipality: 'Großenrade',
    postalCode: '25712'
  },
  {
    municipality: 'Großensee',
    postalCode: '22946'
  },
  {
    municipality: 'Großenseebach',
    postalCode: '91091'
  },
  {
    municipality: 'Großenstein',
    postalCode: '07580'
  },
  {
    municipality: 'Großenwiehe',
    postalCode: '24969'
  },
  {
    municipality: 'Großenwörden',
    postalCode: '21712'
  },
  {
    municipality: 'Großerlach',
    postalCode: '71577'
  },
  {
    municipality: 'Großeutersdorf',
    postalCode: '07768'
  },
  {
    municipality: 'Großfahner',
    postalCode: '99100'
  },
  {
    municipality: 'Großfischlingen',
    postalCode: '67483'
  },
  {
    municipality: 'Groß-Gerau',
    postalCode: '64521'
  },
  {
    municipality: 'Groß Godems',
    postalCode: '19372'
  },
  {
    municipality: 'Groß Grönau',
    postalCode: '23627'
  },
  {
    municipality: 'Großhabersdorf',
    postalCode: '90613'
  },
  {
    municipality: 'Großhansdorf',
    postalCode: '22927'
  },
  {
    municipality: 'Großharrie',
    postalCode: '24625'
  },
  {
    municipality: 'Großharthau',
    postalCode: '01909'
  },
  {
    municipality: 'Großhartmannsdorf',
    postalCode: '09618'
  },
  {
    municipality: 'Großheide',
    postalCode: '26532'
  },
  {
    municipality: 'Großheirath',
    postalCode: '96269'
  },
  {
    municipality: 'Großheringen',
    postalCode: '99518'
  },
  {
    municipality: 'Großheubach',
    postalCode: '63920'
  },
  {
    municipality: 'Großholbach',
    postalCode: '56412'
  },
  {
    municipality: 'Groß Ippener',
    postalCode: '27243'
  },
  {
    municipality: 'Großkampenberg',
    postalCode: '54619'
  },
  {
    municipality: 'Großkarlbach',
    postalCode: '67229'
  },
  {
    municipality: 'Großkarolinenfeld',
    postalCode: '83109'
  },
  {
    municipality: 'Groß Kelle',
    postalCode: '17207'
  },
  {
    municipality: 'Groß Kiesow',
    postalCode: '17495'
  },
  {
    municipality: 'Großkmehlen',
    postalCode: '01990'
  },
  {
    municipality: 'Groß Kordshagen',
    postalCode: '18442'
  },
  {
    municipality: 'Groß Köris',
    postalCode: '15746'
  },
  {
    municipality: 'Groß Krams',
    postalCode: '19230'
  },
  {
    municipality: 'Groß Kreutz (Havel)',
    postalCode: '14550'
  },
  {
    municipality: 'Großkrotzenburg',
    postalCode: '63538'
  },
  {
    municipality: 'Groß Kummerfeld',
    postalCode: '24626'
  },
  {
    municipality: 'Groß Laasch',
    postalCode: '19288'
  },
  {
    municipality: 'Großlangenfeld',
    postalCode: '54608'
  },
  {
    municipality: 'Großlangheim',
    postalCode: '97320'
  },
  {
    municipality: 'Groß Lindow',
    postalCode: '15295'
  },
  {
    municipality: 'Großlittgen',
    postalCode: '54534'
  },
  {
    municipality: 'Großlöbichau',
    postalCode: '07751'
  },
  {
    municipality: 'Großlohra',
    postalCode: '99759'
  },
  {
    municipality: 'Groß Luckow',
    postalCode: '17337'
  },
  {
    municipality: 'Großmaischeid',
    postalCode: '56276'
  },
  {
    municipality: 'Groß Meckelsen',
    postalCode: '27419'
  },
  {
    municipality: 'Großmehring',
    postalCode: '85098'
  },
  {
    municipality: 'Groß Miltzow',
    postalCode: '17349'
  },
  {
    municipality: 'Groß Mohrdorf',
    postalCode: '18445'
  },
  {
    municipality: 'Großmölsen',
    postalCode: '99198'
  },
  {
    municipality: 'Groß Molzahn',
    postalCode: '19217'
  },
  {
    municipality: 'Großnaundorf',
    postalCode: '01936'
  },
  {
    municipality: 'Groß Nemerow',
    postalCode: '17094'
  },
  {
    municipality: 'Großneuhausen',
    postalCode: '99625'
  },
  {
    municipality: 'Großniedesheim',
    postalCode: '67259'
  },
  {
    municipality: 'Groß Niendorf',
    postalCode: '23816'
  },
  {
    municipality: 'Groß Nordende',
    postalCode: '25436'
  },
  {
    municipality: 'Groß Oesingen',
    postalCode: '29393'
  },
  {
    municipality: 'Groß Offenseth-Aspern',
    postalCode: '25355'
  },
  {
    municipality: 'Großolbersdorf',
    postalCode: '09432'
  },
  {
    municipality: 'Großostheim',
    postalCode: '63762'
  },
  {
    municipality: 'Groß Pampau',
    postalCode: '21493'
  },
  {
    municipality: 'Groß Pankow (Prignitz)',
    postalCode: '16928'
  },
  {
    municipality: 'Groß Plasten',
    postalCode: '17192'
  },
  {
    municipality: 'Groß Polzin',
    postalCode: '17390'
  },
  {
    municipality: 'Großpösna',
    postalCode: '04463'
  },
  {
    municipality: 'Großpostwitz/O.L. - Budestecy',
    postalCode: '02692'
  },
  {
    municipality: 'Großpürschütz',
    postalCode: '07751'
  },
  {
    municipality: 'Groß Quenstedt',
    postalCode: '38822'
  },
  {
    municipality: 'Großräschen',
    postalCode: '01983'
  },
  {
    municipality: 'Groß Rheide',
    postalCode: '24872'
  },
  {
    municipality: 'Großrinderfeld',
    postalCode: '97950'
  },
  {
    municipality: 'Groß Roge',
    postalCode: '17166'
  },
  {
    municipality: 'Groß-Rohrheim',
    postalCode: '68649'
  },
  {
    municipality: 'Großröhrsdorf',
    postalCode: '01900'
  },
  {
    municipality: 'Groß Rönnau',
    postalCode: '23795'
  },
  {
    municipality: 'Großrosseln',
    postalCode: '66352'
  },
  {
    municipality: 'Großrückerswalde',
    postalCode: '09518'
  },
  {
    municipality: 'Großrudestedt',
    postalCode: '99195'
  },
  {
    municipality: 'Groß Sarau',
    postalCode: '23627'
  },
  {
    municipality: 'Groß Schacksdorf-Simmersdorf',
    postalCode: '03149'
  },
  {
    municipality: 'Groß Schenkenberg',
    postalCode: '23860'
  },
  {
    municipality: 'Großschirma',
    postalCode: '09603'
  },
  {
    municipality: 'Großschönau',
    postalCode: '02779'
  },
  {
    municipality: 'Großschönau',
    postalCode: '02799'
  },
  {
    municipality: 'Großschwabhausen',
    postalCode: '99441'
  },
  {
    municipality: 'Großschweidnitz',
    postalCode: '02708'
  },
  {
    municipality: 'Groß Schwiesow',
    postalCode: '18276'
  },
  {
    municipality: 'Großseifen',
    postalCode: '56472'
  },
  {
    municipality: 'Großsolt',
    postalCode: '24991'
  },
  {
    municipality: 'Großsteinhausen',
    postalCode: '66484'
  },
  {
    municipality: 'Groß Stieten',
    postalCode: '23972'
  },
  {
    municipality: 'Groß Teetzleben',
    postalCode: '17091'
  },
  {
    municipality: 'Großthiemig',
    postalCode: '04932'
  },
  {
    municipality: 'Groß Twülpstedt',
    postalCode: '38464'
  },
  {
    municipality: 'Groß-Umstadt',
    postalCode: '64823'
  },
  {
    municipality: 'Großvargula',
    postalCode: '99958'
  },
  {
    municipality: 'Groß Vollstedt',
    postalCode: '24802'
  },
  {
    municipality: 'Großwallstadt',
    postalCode: '63868'
  },
  {
    municipality: 'Großweil',
    postalCode: '82439'
  },
  {
    municipality: 'Großweitzschen',
    postalCode: '04720'
  },
  {
    municipality: 'Groß Wittensee',
    postalCode: '24361'
  },
  {
    municipality: 'Groß Wokern',
    postalCode: '17166'
  },
  {
    municipality: 'Großwoltersdorf',
    postalCode: '16775'
  },
  {
    municipality: 'Groß Wüstenfelde',
    postalCode: '17168'
  },
  {
    municipality: 'Groß-Zimmern',
    postalCode: '64846'
  },
  {
    municipality: 'Grothusenkoog',
    postalCode: '25836'
  },
  {
    municipality: 'Grove',
    postalCode: '21493'
  },
  {
    municipality: 'Groven',
    postalCode: '25774'
  },
  {
    municipality: 'Grub',
    postalCode: '98530'
  },
  {
    municipality: 'Grub a.Forst',
    postalCode: '96271'
  },
  {
    municipality: 'Grube',
    postalCode: '23749'
  },
  {
    municipality: 'Gruibingen',
    postalCode: '73344'
  },
  {
    municipality: 'Grumbach',
    postalCode: '67745'
  },
  {
    municipality: 'Grünbach',
    postalCode: '08223'
  },
  {
    municipality: 'Grünberg',
    postalCode: '35305'
  },
  {
    municipality: 'Gründau',
    postalCode: '63584'
  },
  {
    municipality: 'Grundhof',
    postalCode: '24977'
  },
  {
    municipality: 'Grundsheim',
    postalCode: '89613'
  },
  {
    municipality: 'Grünebach',
    postalCode: '57520'
  },
  {
    municipality: 'Grünenbach',
    postalCode: '88167'
  },
  {
    municipality: 'Grünendeich',
    postalCode: '21720'
  },
  {
    municipality: 'Grünewald',
    postalCode: '01945'
  },
  {
    municipality: 'Grünhain-Beierfeld',
    postalCode: '08344'
  },
  {
    municipality: 'Grünhainichen',
    postalCode: '09579'
  },
  {
    municipality: 'Grünheide (Mark)',
    postalCode: '15537'
  },
  {
    municipality: 'Grünkraut',
    postalCode: '88287'
  },
  {
    municipality: 'Grünow',
    postalCode: '17291'
  },
  {
    municipality: 'Grünow',
    postalCode: '17237'
  },
  {
    municipality: 'Grunow-Dammendorf',
    postalCode: '15299'
  },
  {
    municipality: 'Grünsfeld',
    postalCode: '97947'
  },
  {
    municipality: 'Grünstadt',
    postalCode: '67269'
  },
  {
    municipality: 'Grünwald',
    postalCode: '82031'
  },
  {
    municipality: 'Gschwend',
    postalCode: '74417'
  },
  {
    municipality: 'Gstadt am Chiemsee',
    postalCode: '83257'
  },
  {
    municipality: 'Guben',
    postalCode: '03172'
  },
  {
    municipality: 'Güby',
    postalCode: '24357'
  },
  {
    municipality: 'Guckheim',
    postalCode: '56459'
  },
  {
    municipality: 'Gückingen',
    postalCode: '65558'
  },
  {
    municipality: 'Gudendorf',
    postalCode: '25693'
  },
  {
    municipality: 'Gudensberg',
    postalCode: '34281'
  },
  {
    municipality: 'Guderhandviertel',
    postalCode: '21720'
  },
  {
    municipality: 'Gudow',
    postalCode: '23899'
  },
  {
    municipality: 'Guggenhausen',
    postalCode: '88379'
  },
  {
    municipality: 'Güglingen',
    postalCode: '74363'
  },
  {
    municipality: 'Guhrow',
    postalCode: '03096'
  },
  {
    municipality: 'Guldental',
    postalCode: '55452'
  },
  {
    municipality: 'Gülitz-Reetz',
    postalCode: '19348'
  },
  {
    municipality: 'Güllesheim',
    postalCode: '56593'
  },
  {
    municipality: 'Gültz',
    postalCode: '17089'
  },
  {
    municipality: 'Gülzow',
    postalCode: '17153'
  },
  {
    municipality: 'Gülzow',
    postalCode: '21483'
  },
  {
    municipality: 'Gülzow-Prüzen',
    postalCode: '18276'
  },
  {
    municipality: 'Gumbsheim',
    postalCode: '55597'
  },
  {
    municipality: 'Gummersbach',
    postalCode: '51643'
  },
  {
    municipality: 'Gummersbach',
    postalCode: '51645'
  },
  {
    municipality: 'Gummersbach',
    postalCode: '51647'
  },
  {
    municipality: 'Gumperda',
    postalCode: '07768'
  },
  {
    municipality: 'Gumtow',
    postalCode: '16866'
  },
  {
    municipality: 'Gundelfingen',
    postalCode: '79194'
  },
  {
    municipality: 'Gundelfingen a.d.Donau',
    postalCode: '89423'
  },
  {
    municipality: 'Gundelsheim',
    postalCode: '96163'
  },
  {
    municipality: 'Gundelsheim',
    postalCode: '74831'
  },
  {
    municipality: 'Gunderath',
    postalCode: '56767'
  },
  {
    municipality: 'Gundersheim',
    postalCode: '67598'
  },
  {
    municipality: 'Gundersweiler',
    postalCode: '67724'
  },
  {
    municipality: 'Gundheim',
    postalCode: '67599'
  },
  {
    municipality: 'Gundremmingen',
    postalCode: '89355'
  },
  {
    municipality: 'Gunningen',
    postalCode: '78594'
  },
  {
    municipality: 'Günstedt',
    postalCode: '99631'
  },
  {
    municipality: 'Guntersblum',
    postalCode: '67583'
  },
  {
    municipality: 'Güntersleben',
    postalCode: '97261'
  },
  {
    municipality: 'Günzach',
    postalCode: '87634'
  },
  {
    municipality: 'Günzburg',
    postalCode: '89312'
  },
  {
    municipality: 'Gunzenhausen',
    postalCode: '91710'
  },
  {
    municipality: 'Gusborn',
    postalCode: '29476'
  },
  {
    municipality: 'Gusenburg',
    postalCode: '54413'
  },
  {
    municipality: 'Gusow-Platkow',
    postalCode: '15306'
  },
  {
    municipality: 'Güsten',
    postalCode: '39439'
  },
  {
    municipality: 'Güster',
    postalCode: '21514'
  },
  {
    municipality: 'Gusterath',
    postalCode: '54317'
  },
  {
    municipality: 'Gustow',
    postalCode: '18574'
  },
  {
    municipality: 'Güstrow',
    postalCode: '18273'
  },
  {
    municipality: 'Gutach im Breisgau',
    postalCode: '79261'
  },
  {
    municipality: 'Gutach (Schwarzwaldbahn)',
    postalCode: '77793'
  },
  {
    municipality: 'Guteborn',
    postalCode: '01945'
  },
  {
    municipality: 'Gutenacker',
    postalCode: '56370'
  },
  {
    municipality: 'Gütenbach',
    postalCode: '78148'
  },
  {
    municipality: 'Gutenberg',
    postalCode: '55595'
  },
  {
    municipality: 'Gutenborn',
    postalCode: '06712'
  },
  {
    municipality: 'Guteneck',
    postalCode: '92543'
  },
  {
    municipality: 'Gutenstetten',
    postalCode: '91468'
  },
  {
    municipality: 'Gutenzell-Hürbel',
    postalCode: '88484'
  },
  {
    municipality: 'Gütersloh',
    postalCode: '33330'
  },
  {
    municipality: 'Gütersloh',
    postalCode: '33332'
  },
  {
    municipality: 'Gütersloh',
    postalCode: '33333'
  },
  {
    municipality: 'Gütersloh',
    postalCode: '33334'
  },
  {
    municipality: 'Gütersloh',
    postalCode: '33335'
  },
  {
    municipality: 'Gutow',
    postalCode: '18276'
  },
  {
    municipality: 'Guttenberg',
    postalCode: '95358'
  },
  {
    municipality: 'Gutweiler',
    postalCode: '54317'
  },
  {
    municipality: 'Gützkow',
    postalCode: '17506'
  },
  {
    municipality: 'Guxhagen',
    postalCode: '34302'
  },
  {
    municipality: 'Gyhum',
    postalCode: '27404'
  },
  {
    municipality: 'Haag',
    postalCode: '95473'
  },
  {
    municipality: 'Haag an der Amper',
    postalCode: '85410'
  },
  {
    municipality: 'Haag in Oberbayern',
    postalCode: '83527'
  },
  {
    municipality: 'Haale',
    postalCode: '24819'
  },
  {
    municipality: 'Haan',
    postalCode: '42781'
  },
  {
    municipality: 'Haar',
    postalCode: '85540'
  },
  {
    municipality: 'Haarbach',
    postalCode: '94501'
  },
  {
    municipality: 'Haarbach',
    postalCode: '94542'
  },
  {
    municipality: 'Habach',
    postalCode: '82392'
  },
  {
    municipality: 'Habichtswald',
    postalCode: '34317'
  },
  {
    municipality: 'Habscheid',
    postalCode: '54597'
  },
  {
    municipality: 'Haby',
    postalCode: '24361'
  },
  {
    municipality: 'Hachenburg',
    postalCode: '57627'
  },
  {
    municipality: 'Hackenheim',
    postalCode: '55546'
  },
  {
    municipality: 'Hadamar',
    postalCode: '65589'
  },
  {
    municipality: 'Hademstorf',
    postalCode: '29693'
  },
  {
    municipality: 'Hadenfeld',
    postalCode: '25560'
  },
  {
    municipality: 'Hafenlohr',
    postalCode: '97840'
  },
  {
    municipality: 'Hage',
    postalCode: '26524'
  },
  {
    municipality: 'Häg-Ehrsberg',
    postalCode: '79685'
  },
  {
    municipality: 'Hagelstadt',
    postalCode: '93095'
  },
  {
    municipality: 'Hagen',
    postalCode: '24576'
  },
  {
    municipality: 'Hagen',
    postalCode: '58089'
  },
  {
    municipality: 'Hagen',
    postalCode: '58091'
  },
  {
    municipality: 'Hagen',
    postalCode: '58093'
  },
  {
    municipality: 'Hagen',
    postalCode: '58095'
  },
  {
    municipality: 'Hagen',
    postalCode: '58097'
  },
  {
    municipality: 'Hagen',
    postalCode: '58099'
  },
  {
    municipality: 'Hagen',
    postalCode: '58119'
  },
  {
    municipality: 'Hagen',
    postalCode: '58135'
  },
  {
    municipality: 'Hagen am Teutoburger Wald',
    postalCode: '49170'
  },
  {
    municipality: 'Hagenbach',
    postalCode: '76767'
  },
  {
    municipality: 'Hagenbüchach',
    postalCode: '91469'
  },
  {
    municipality: 'Hagenburg',
    postalCode: '31558'
  },
  {
    municipality: 'Hagen im Bremischen',
    postalCode: '27628'
  },
  {
    municipality: 'Hagenow',
    postalCode: '19230'
  },
  {
    municipality: 'Hagermarsch',
    postalCode: '26524'
  },
  {
    municipality: 'Hagnau am Bodensee',
    postalCode: '88709'
  },
  {
    municipality: 'Hahn',
    postalCode: '56850'
  },
  {
    municipality: 'Hahn am See',
    postalCode: '56244'
  },
  {
    municipality: 'Hahnbach',
    postalCode: '92256'
  },
  {
    municipality: 'Hahn bei Marienberg',
    postalCode: '56472'
  },
  {
    municipality: 'Hahnenbach',
    postalCode: '55606'
  },
  {
    municipality: 'Hahnheim',
    postalCode: '55278'
  },
  {
    municipality: 'Hähnichen',
    postalCode: '02923'
  },
  {
    municipality: 'Hahnstätten',
    postalCode: '65623'
  },
  {
    municipality: 'Hahnweiler',
    postalCode: '55776'
  },
  {
    municipality: 'Haibach',
    postalCode: '63808'
  },
  {
    municipality: 'Haibach',
    postalCode: '94353'
  },
  {
    municipality: 'Haidmühle',
    postalCode: '94145'
  },
  {
    municipality: 'Haiger',
    postalCode: '35708'
  },
  {
    municipality: 'Haigerloch',
    postalCode: '72401'
  },
  {
    municipality: 'Haimhausen',
    postalCode: '85778'
  },
  {
    municipality: 'Haiming',
    postalCode: '84533'
  },
  {
    municipality: 'Haina (Kloster)',
    postalCode: '35114'
  },
  {
    municipality: 'Hainau',
    postalCode: '56357'
  },
  {
    municipality: 'Hainburg',
    postalCode: '63512'
  },
  {
    municipality: 'Hainewalde',
    postalCode: '02779'
  },
  {
    municipality: 'Hainfeld',
    postalCode: '76835'
  },
  {
    municipality: 'Hainichen',
    postalCode: '09661'
  },
  {
    municipality: 'Hainichen',
    postalCode: '07778'
  },
  {
    municipality: 'Hainsfarth',
    postalCode: '86744'
  },
  {
    municipality: 'Hainspitz',
    postalCode: '07607'
  },
  {
    municipality: 'Haiterbach',
    postalCode: '72221'
  },
  {
    municipality: 'Halbe',
    postalCode: '15757'
  },
  {
    municipality: 'Halbemond',
    postalCode: '26524'
  },
  {
    municipality: 'Halberstadt',
    postalCode: '38820'
  },
  {
    municipality: 'Halberstadt',
    postalCode: '38822'
  },
  {
    municipality: 'Halberstadt',
    postalCode: '38895'
  },
  {
    municipality: 'Halblech',
    postalCode: '87642'
  },
  {
    municipality: 'Halbs',
    postalCode: '56457'
  },
  {
    municipality: 'Haldensleben',
    postalCode: '39340'
  },
  {
    municipality: 'Haldensleben',
    postalCode: '39343'
  },
  {
    municipality: 'Haldensleben',
    postalCode: '39345'
  },
  {
    municipality: 'Haldenwang',
    postalCode: '87490'
  },
  {
    municipality: 'Haldenwang',
    postalCode: '89356'
  },
  {
    municipality: 'Halenbeck-Rohlsdorf',
    postalCode: '16945'
  },
  {
    municipality: 'Halfing',
    postalCode: '83128'
  },
  {
    municipality: 'Hallbergmoos',
    postalCode: '85399'
  },
  {
    municipality: 'Halle',
    postalCode: '37620'
  },
  {
    municipality: 'Halle',
    postalCode: '49843'
  },
  {
    municipality: 'Hallenberg',
    postalCode: '59969'
  },
  {
    municipality: 'Hallerndorf',
    postalCode: '91352'
  },
  {
    municipality: 'Halle (Saale)',
    postalCode: '06108'
  },
  {
    municipality: 'Halle (Saale)',
    postalCode: '06110'
  },
  {
    municipality: 'Halle (Saale)',
    postalCode: '06112'
  },
  {
    municipality: 'Halle (Saale)',
    postalCode: '06114'
  },
  {
    municipality: 'Halle (Saale)',
    postalCode: '06116'
  },
  {
    municipality: 'Halle (Saale)',
    postalCode: '06118'
  },
  {
    municipality: 'Halle (Saale)',
    postalCode: '06120'
  },
  {
    municipality: 'Halle (Saale)',
    postalCode: '06122'
  },
  {
    municipality: 'Halle (Saale)',
    postalCode: '06124'
  },
  {
    municipality: 'Halle (Saale)',
    postalCode: '06126'
  },
  {
    municipality: 'Halle (Saale)',
    postalCode: '06128'
  },
  {
    municipality: 'Halle (Saale)',
    postalCode: '06130'
  },
  {
    municipality: 'Halle (Saale)',
    postalCode: '06132'
  },
  {
    municipality: 'Halle (Westf.)',
    postalCode: '33790'
  },
  {
    municipality: 'Hallgarten',
    postalCode: '67826'
  },
  {
    municipality: 'Hallig Hooge',
    postalCode: '25859'
  },
  {
    municipality: 'Hallschlag',
    postalCode: '54611'
  },
  {
    municipality: 'Hallstadt',
    postalCode: '96103'
  },
  {
    municipality: 'Hallungen',
    postalCode: '99826'
  },
  {
    municipality: 'Halsbach',
    postalCode: '84553'
  },
  {
    municipality: 'Halsbrücke',
    postalCode: '09633'
  },
  {
    municipality: 'Halsdorf',
    postalCode: '54646'
  },
  {
    municipality: 'Halsenbach',
    postalCode: '56283'
  },
  {
    municipality: 'Halstenbek',
    postalCode: '25469'
  },
  {
    municipality: 'Haltern am See',
    postalCode: '45721'
  },
  {
    municipality: 'Halver',
    postalCode: '58553'
  },
  {
    municipality: 'Halvesbostel',
    postalCode: '21646'
  },
  {
    municipality: 'Hambach',
    postalCode: '65582'
  },
  {
    municipality: 'Hamberge',
    postalCode: '23619'
  },
  {
    municipality: 'Hambergen',
    postalCode: '27729'
  },
  {
    municipality: 'Hambrücken',
    postalCode: '76707'
  },
  {
    municipality: 'Hambuch',
    postalCode: '56761'
  },
  {
    municipality: 'Hambühren',
    postalCode: '29313'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20095'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20097'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20099'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20144'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20146'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20148'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20149'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20249'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20251'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20253'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20255'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20257'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20259'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20354'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20355'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20357'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20359'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20457'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20459'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20535'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20537'
  },
  {
    municipality: 'Hamburg',
    postalCode: '20539'
  },
  {
    municipality: 'Hamburg',
    postalCode: '21029'
  },
  {
    municipality: 'Hamburg',
    postalCode: '21031'
  },
  {
    municipality: 'Hamburg',
    postalCode: '21033'
  },
  {
    municipality: 'Hamburg',
    postalCode: '21035'
  },
  {
    municipality: 'Hamburg',
    postalCode: '21037'
  },
  {
    municipality: 'Hamburg',
    postalCode: '21039'
  },
  {
    municipality: 'Hamburg',
    postalCode: '21073'
  },
  {
    municipality: 'Hamburg',
    postalCode: '21075'
  },
  {
    municipality: 'Hamburg',
    postalCode: '21077'
  },
  {
    municipality: 'Hamburg',
    postalCode: '21079'
  },
  {
    municipality: 'Hamburg',
    postalCode: '21107'
  },
  {
    municipality: 'Hamburg',
    postalCode: '21109'
  },
  {
    municipality: 'Hamburg',
    postalCode: '21129'
  },
  {
    municipality: 'Hamburg',
    postalCode: '21147'
  },
  {
    municipality: 'Hamburg',
    postalCode: '21149'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22041'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22043'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22045'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22047'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22049'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22081'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22083'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22085'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22087'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22089'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22111'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22113'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22115'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22117'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22119'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22143'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22145'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22147'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22149'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22159'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22175'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22177'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22179'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22297'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22299'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22301'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22303'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22305'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22307'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22309'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22335'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22337'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22339'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22359'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22391'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22393'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22395'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22397'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22399'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22415'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22417'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22419'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22453'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22455'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22457'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22459'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22523'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22525'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22527'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22529'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22547'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22549'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22559'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22587'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22589'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22605'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22607'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22609'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22761'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22763'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22765'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22767'
  },
  {
    municipality: 'Hamburg',
    postalCode: '22769'
  },
  {
    municipality: 'Hamburg',
    postalCode: '27499'
  },
  {
    municipality: 'Hamdorf',
    postalCode: '24805'
  },
  {
    municipality: 'Hämelhausen',
    postalCode: '27324'
  },
  {
    municipality: 'Hameln',
    postalCode: '31785'
  },
  {
    municipality: 'Hameln',
    postalCode: '31787'
  },
  {
    municipality: 'Hameln',
    postalCode: '31789'
  },
  {
    municipality: 'Hamersen',
    postalCode: '27419'
  },
  {
    municipality: 'Hamfelde',
    postalCode: '22929'
  },
  {
    municipality: 'Hamfelde',
    postalCode: '22929'
  },
  {
    municipality: 'Hamm',
    postalCode: '59063'
  },
  {
    municipality: 'Hamm',
    postalCode: '59065'
  },
  {
    municipality: 'Hamm',
    postalCode: '59067'
  },
  {
    municipality: 'Hamm',
    postalCode: '59069'
  },
  {
    municipality: 'Hamm',
    postalCode: '59071'
  },
  {
    municipality: 'Hamm',
    postalCode: '59073'
  },
  {
    municipality: 'Hamm',
    postalCode: '59075'
  },
  {
    municipality: 'Hamm',
    postalCode: '59077'
  },
  {
    municipality: 'Hamm',
    postalCode: '54636'
  },
  {
    municipality: 'Hammah',
    postalCode: '21714'
  },
  {
    municipality: 'Hamm am Rhein',
    postalCode: '67580'
  },
  {
    municipality: 'Hammelburg',
    postalCode: '97762'
  },
  {
    municipality: 'Hammer a.d. Uecker',
    postalCode: '17358'
  },
  {
    municipality: 'Hammersbach',
    postalCode: '63546'
  },
  {
    municipality: 'Hammerstedt',
    postalCode: '99441'
  },
  {
    municipality: 'Hammerstein',
    postalCode: '56598'
  },
  {
    municipality: 'Hamminkeln',
    postalCode: '46499'
  },
  {
    municipality: 'Hammoor',
    postalCode: '22941'
  },
  {
    municipality: 'Hamm (Sieg)',
    postalCode: '57577'
  },
  {
    municipality: 'Hamwarde',
    postalCode: '21502'
  },
  {
    municipality: 'Hamweddel',
    postalCode: '24816'
  },
  {
    municipality: 'Hanau',
    postalCode: '63450'
  },
  {
    municipality: 'Hanau',
    postalCode: '63452'
  },
  {
    municipality: 'Hanau',
    postalCode: '63454'
  },
  {
    municipality: 'Hanau',
    postalCode: '63456'
  },
  {
    municipality: 'Hanau',
    postalCode: '63457'
  },
  {
    municipality: 'Handeloh',
    postalCode: '21256'
  },
  {
    municipality: 'Handewitt',
    postalCode: '24976'
  },
  {
    municipality: 'Handewitt',
    postalCode: '24983'
  },
  {
    municipality: 'Handorf',
    postalCode: '21447'
  },
  {
    municipality: 'Handrup',
    postalCode: '49838'
  },
  {
    municipality: 'Hanerau-Hademarschen',
    postalCode: '25557'
  },
  {
    municipality: 'Hangen-Weisheim',
    postalCode: '55234'
  },
  {
    municipality: 'Hanhofen',
    postalCode: '67374'
  },
  {
    municipality: 'Hankensbüttel',
    postalCode: '29386'
  },
  {
    municipality: 'Hann. Münden',
    postalCode: '34346'
  },
  {
    municipality: 'Hannover',
    postalCode: '30159'
  },
  {
    municipality: 'Hannover',
    postalCode: '30161'
  },
  {
    municipality: 'Hannover',
    postalCode: '30163'
  },
  {
    municipality: 'Hannover',
    postalCode: '30165'
  },
  {
    municipality: 'Hannover',
    postalCode: '30167'
  },
  {
    municipality: 'Hannover',
    postalCode: '30169'
  },
  {
    municipality: 'Hannover',
    postalCode: '30171'
  },
  {
    municipality: 'Hannover',
    postalCode: '30173'
  },
  {
    municipality: 'Hannover',
    postalCode: '30175'
  },
  {
    municipality: 'Hannover',
    postalCode: '30177'
  },
  {
    municipality: 'Hannover',
    postalCode: '30179'
  },
  {
    municipality: 'Hannover',
    postalCode: '30419'
  },
  {
    municipality: 'Hannover',
    postalCode: '30449'
  },
  {
    municipality: 'Hannover',
    postalCode: '30451'
  },
  {
    municipality: 'Hannover',
    postalCode: '30453'
  },
  {
    municipality: 'Hannover',
    postalCode: '30455'
  },
  {
    municipality: 'Hannover',
    postalCode: '30457'
  },
  {
    municipality: 'Hannover',
    postalCode: '30459'
  },
  {
    municipality: 'Hannover',
    postalCode: '30519'
  },
  {
    municipality: 'Hannover',
    postalCode: '30521'
  },
  {
    municipality: 'Hannover',
    postalCode: '30539'
  },
  {
    municipality: 'Hannover',
    postalCode: '30559'
  },
  {
    municipality: 'Hannover',
    postalCode: '30625'
  },
  {
    municipality: 'Hannover',
    postalCode: '30627'
  },
  {
    municipality: 'Hannover',
    postalCode: '30629'
  },
  {
    municipality: 'Hannover',
    postalCode: '30655'
  },
  {
    municipality: 'Hannover',
    postalCode: '30657'
  },
  {
    municipality: 'Hannover',
    postalCode: '30659'
  },
  {
    municipality: 'Hannover',
    postalCode: '30669'
  },
  {
    municipality: 'Hanroth',
    postalCode: '56316'
  },
  {
    municipality: 'Hanshagen',
    postalCode: '17509'
  },
  {
    municipality: 'Hanstedt',
    postalCode: '21271'
  },
  {
    municipality: 'Hanstedt',
    postalCode: '29582'
  },
  {
    municipality: 'Happurg',
    postalCode: '91230'
  },
  {
    municipality: 'Harbach',
    postalCode: '57572'
  },
  {
    municipality: 'Harbke',
    postalCode: '39365'
  },
  {
    municipality: 'Harburg (Schwaben)',
    postalCode: '86655'
  },
  {
    municipality: 'Hardebek',
    postalCode: '24616'
  },
  {
    municipality: 'Hardegsen',
    postalCode: '37181'
  },
  {
    municipality: 'Hardert',
    postalCode: '56579'
  },
  {
    municipality: 'Hardheim',
    postalCode: '74736'
  },
  {
    municipality: 'Hardt',
    postalCode: '56472'
  },
  {
    municipality: 'Hardt',
    postalCode: '78739'
  },
  {
    municipality: 'Hardthausen am Kocher',
    postalCode: '74239'
  },
  {
    municipality: 'Haren (Ems)',
    postalCode: '49733'
  },
  {
    municipality: 'Hargarten',
    postalCode: '54649'
  },
  {
    municipality: 'Hargesheim',
    postalCode: '55595'
  },
  {
    municipality: 'Harmsdorf',
    postalCode: '23738'
  },
  {
    municipality: 'Harmsdorf',
    postalCode: '23911'
  },
  {
    municipality: 'Harmstorf',
    postalCode: '21228'
  },
  {
    municipality: 'Harpstedt',
    postalCode: '27243'
  },
  {
    municipality: 'Harrislee',
    postalCode: '24955'
  },
  {
    municipality: 'Harschbach',
    postalCode: '56307'
  },
  {
    municipality: 'Harscheid',
    postalCode: '53520'
  },
  {
    municipality: 'Harsdorf',
    postalCode: '95499'
  },
  {
    municipality: 'Harsefeld',
    postalCode: '21698'
  },
  {
    municipality: 'Harsewinkel',
    postalCode: '33428'
  },
  {
    municipality: 'Harsleben',
    postalCode: '38829'
  },
  {
    municipality: 'Harspelt',
    postalCode: '54617'
  },
  {
    municipality: 'Harsum',
    postalCode: '31177'
  },
  {
    municipality: 'Hartenfels',
    postalCode: '56244'
  },
  {
    municipality: 'Hartenholm',
    postalCode: '24628'
  },
  {
    municipality: 'Hartenstein',
    postalCode: '08118'
  },
  {
    municipality: 'Hartenstein',
    postalCode: '91235'
  },
  {
    municipality: 'Hartha',
    postalCode: '04746'
  },
  {
    municipality: 'Harthausen',
    postalCode: '67376'
  },
  {
    municipality: 'Hartheim am Rhein',
    postalCode: '79258'
  },
  {
    municipality: 'Harth-Pöllnitz',
    postalCode: '07570'
  },
  {
    municipality: 'Härtlingen',
    postalCode: '56459'
  },
  {
    municipality: 'Hartmannsdorf',
    postalCode: '09232'
  },
  {
    municipality: 'Hartmannsdorf',
    postalCode: '07613'
  },
  {
    municipality: 'Hartmannsdorf',
    postalCode: '07586'
  },
  {
    municipality: 'Hartmannsdorf bei Kirchberg',
    postalCode: '08107'
  },
  {
    municipality: 'Hartmannsdorf-Reichenau',
    postalCode: '01762'
  },
  {
    municipality: 'Harxheim',
    postalCode: '55296'
  },
  {
    municipality: 'Harzgerode',
    postalCode: '06493'
  },
  {
    municipality: 'Harztor',
    postalCode: '99768'
  },
  {
    municipality: 'Hasbergen',
    postalCode: '49205'
  },
  {
    municipality: 'Hasborn',
    postalCode: '54533'
  },
  {
    municipality: 'Haschbach am Remigiusberg',
    postalCode: '66871'
  },
  {
    municipality: 'Hasel',
    postalCode: '79686'
  },
  {
    municipality: 'Haselau',
    postalCode: '25489'
  },
  {
    municipality: 'Haselbach',
    postalCode: '94354'
  },
  {
    municipality: 'Haselbach',
    postalCode: '04617'
  },
  {
    municipality: 'Haselbachtal',
    postalCode: '01920'
  },
  {
    municipality: 'Haseldorf',
    postalCode: '25489'
  },
  {
    municipality: 'Haselund',
    postalCode: '25855'
  },
  {
    municipality: 'Haselünne',
    postalCode: '49740'
  },
  {
    municipality: 'Hasenkrug',
    postalCode: '24616'
  },
  {
    municipality: 'Hasenmoor',
    postalCode: '24640'
  },
  {
    municipality: 'Haserich',
    postalCode: '56858'
  },
  {
    municipality: 'Haslach im Kinzigtal',
    postalCode: '77716'
  },
  {
    municipality: 'Hasloch',
    postalCode: '97907'
  },
  {
    municipality: 'Hasloh',
    postalCode: '25474'
  },
  {
    municipality: 'Haßbergen',
    postalCode: '31626'
  },
  {
    municipality: 'Hassel',
    postalCode: '39596'
  },
  {
    municipality: 'Hasselbach',
    postalCode: '57635'
  },
  {
    municipality: 'Hasselbach',
    postalCode: '56288'
  },
  {
    municipality: 'Hasselberg',
    postalCode: '24376'
  },
  {
    municipality: 'Hasselroth',
    postalCode: '63594'
  },
  {
    municipality: 'Hassel (Weser)',
    postalCode: '27324'
  },
  {
    municipality: 'Hassendorf',
    postalCode: '27367'
  },
  {
    municipality: 'Haßfurt',
    postalCode: '97437'
  },
  {
    municipality: 'Haßleben',
    postalCode: '99189'
  },
  {
    municipality: 'Haßloch',
    postalCode: '67454'
  },
  {
    municipality: 'Haßmersheim',
    postalCode: '74855'
  },
  {
    municipality: 'Haßmoor',
    postalCode: '24790'
  },
  {
    municipality: 'Haste',
    postalCode: '31559'
  },
  {
    municipality: 'Hatten',
    postalCode: '26209'
  },
  {
    municipality: 'Hattenhofen',
    postalCode: '82285'
  },
  {
    municipality: 'Hattenhofen',
    postalCode: '73110'
  },
  {
    municipality: 'Hattersheim',
    postalCode: '65795'
  },
  {
    municipality: 'Hattert',
    postalCode: '57644'
  },
  {
    municipality: 'Hattgenstein',
    postalCode: '55767'
  },
  {
    municipality: 'Hattingen',
    postalCode: '45525'
  },
  {
    municipality: 'Hattingen',
    postalCode: '45527'
  },
  {
    municipality: 'Hattingen',
    postalCode: '45529'
  },
  {
    municipality: 'Hattorf am Harz',
    postalCode: '37197'
  },
  {
    municipality: 'Hattstedt',
    postalCode: '25856'
  },
  {
    municipality: 'Hattstedtermarsch',
    postalCode: '25856'
  },
  {
    municipality: 'Hatzenbühl',
    postalCode: '76770'
  },
  {
    municipality: 'Hatzenport',
    postalCode: '56332'
  },
  {
    municipality: 'Hatzfeld (Eder)',
    postalCode: '35116'
  },
  {
    municipality: 'Hauenstein',
    postalCode: '76846'
  },
  {
    municipality: 'Haundorf',
    postalCode: '91729'
  },
  {
    municipality: 'Hauneck',
    postalCode: '36282'
  },
  {
    municipality: 'Haunetal',
    postalCode: '36166'
  },
  {
    municipality: 'Haunsheim',
    postalCode: '89437'
  },
  {
    municipality: 'Hauptstuhl',
    postalCode: '66851'
  },
  {
    municipality: 'Hauroth',
    postalCode: '56761'
  },
  {
    municipality: 'Hausach',
    postalCode: '77756'
  },
  {
    municipality: 'Hausbay',
    postalCode: '56291'
  },
  {
    municipality: 'Hausen',
    postalCode: '97647'
  },
  {
    municipality: 'Hausen',
    postalCode: '63840'
  },
  {
    municipality: 'Hausen',
    postalCode: '93345'
  },
  {
    municipality: 'Hausen',
    postalCode: '91353'
  },
  {
    municipality: 'Hausen',
    postalCode: '55608'
  },
  {
    municipality: 'Hausen am Bussen',
    postalCode: '89597'
  },
  {
    municipality: 'Hausen am Tann',
    postalCode: '72361'
  },
  {
    municipality: 'Hausen b. Würzburg',
    postalCode: '97262'
  },
  {
    municipality: 'Hausen im Wiesental',
    postalCode: '79688'
  },
  {
    municipality: 'Hausen ob Verena',
    postalCode: '78595'
  },
  {
    municipality: 'Hausen (Wied)',
    postalCode: '53547'
  },
  {
    municipality: 'Häusern',
    postalCode: '79837'
  },
  {
    municipality: 'Hausham',
    postalCode: '83734'
  },
  {
    municipality: 'Häuslingen',
    postalCode: '27336'
  },
  {
    municipality: 'Haussömmern',
    postalCode: '99955'
  },
  {
    municipality: 'Hausten',
    postalCode: '56745'
  },
  {
    municipality: 'Hausweiler',
    postalCode: '67742'
  },
  {
    municipality: 'Hauzenberg',
    postalCode: '94051'
  },
  {
    municipality: 'Havekost',
    postalCode: '21493'
  },
  {
    municipality: 'Havelaue',
    postalCode: '14715'
  },
  {
    municipality: 'Havelberg',
    postalCode: '39539'
  },
  {
    municipality: 'Havelsee',
    postalCode: '14798'
  },
  {
    municipality: 'Haverlah',
    postalCode: '38275'
  },
  {
    municipality: 'Havetoft',
    postalCode: '24873'
  },
  {
    municipality: 'Havixbeck',
    postalCode: '48329'
  },
  {
    municipality: 'Hawangen',
    postalCode: '87749'
  },
  {
    municipality: 'Hayingen',
    postalCode: '72534'
  },
  {
    municipality: 'Haynrode',
    postalCode: '37339'
  },
  {
    municipality: 'Hebertsfelden',
    postalCode: '84332'
  },
  {
    municipality: 'Hebertshausen',
    postalCode: '85241'
  },
  {
    municipality: 'Hebertshausen',
    postalCode: '85764'
  },
  {
    municipality: 'Hechingen',
    postalCode: '72379'
  },
  {
    municipality: 'Hechthausen',
    postalCode: '21755'
  },
  {
    municipality: 'Heckelberg-Brunow',
    postalCode: '16259'
  },
  {
    municipality: 'Hecken',
    postalCode: '55481'
  },
  {
    municipality: 'Heckenbach',
    postalCode: '53506'
  },
  {
    municipality: 'Heckenmünster',
    postalCode: '54518'
  },
  {
    municipality: 'Heckenmünster',
    postalCode: '54523'
  },
  {
    municipality: 'Heckhuscheid',
    postalCode: '54619'
  },
  {
    municipality: 'Hecklingen',
    postalCode: '39444'
  },
  {
    municipality: 'Heddert',
    postalCode: '54429'
  },
  {
    municipality: 'Heddesbach',
    postalCode: '69434'
  },
  {
    municipality: 'Heddesheim',
    postalCode: '68542'
  },
  {
    municipality: 'Hedeper',
    postalCode: '38322'
  },
  {
    municipality: 'Hedersleben',
    postalCode: '06458'
  },
  {
    municipality: 'Hedwigenkoog',
    postalCode: '25761'
  },
  {
    municipality: 'Heede',
    postalCode: '25355'
  },
  {
    municipality: 'Heede',
    postalCode: '26892'
  },
  {
    municipality: 'Heek',
    postalCode: '48619'
  },
  {
    municipality: 'Heemsen',
    postalCode: '31622'
  },
  {
    municipality: 'Heere',
    postalCode: '38277'
  },
  {
    municipality: 'Heeslingen',
    postalCode: '27404'
  },
  {
    municipality: 'Heeßen',
    postalCode: '31707'
  },
  {
    municipality: 'Hefersweiler',
    postalCode: '67753'
  },
  {
    municipality: 'Hehlen',
    postalCode: '37619'
  },
  {
    municipality: 'Heide',
    postalCode: '25746'
  },
  {
    municipality: 'Heideblick',
    postalCode: '15926'
  },
  {
    municipality: 'Heideck',
    postalCode: '91180'
  },
  {
    municipality: 'Heidekamp',
    postalCode: '23858'
  },
  {
    municipality: 'Heideland',
    postalCode: '03238'
  },
  {
    municipality: 'Heideland',
    postalCode: '07613'
  },
  {
    municipality: 'Heidelberg',
    postalCode: '69115'
  },
  {
    municipality: 'Heidelberg',
    postalCode: '69117'
  },
  {
    municipality: 'Heidelberg',
    postalCode: '69118'
  },
  {
    municipality: 'Heidelberg',
    postalCode: '69120'
  },
  {
    municipality: 'Heidelberg',
    postalCode: '69121'
  },
  {
    municipality: 'Heidelberg',
    postalCode: '69123'
  },
  {
    municipality: 'Heidelberg',
    postalCode: '69124'
  },
  {
    municipality: 'Heidelberg',
    postalCode: '69126'
  },
  {
    municipality: 'Heiden',
    postalCode: '46359'
  },
  {
    municipality: 'Heidenau',
    postalCode: '21258'
  },
  {
    municipality: 'Heidenau',
    postalCode: '01809'
  },
  {
    municipality: 'Heidenburg',
    postalCode: '54426'
  },
  {
    municipality: 'Heidenheim',
    postalCode: '91719'
  },
  {
    municipality: 'Heidenheim an der Brenz',
    postalCode: '89518'
  },
  {
    municipality: 'Heidenheim an der Brenz',
    postalCode: '89520'
  },
  {
    municipality: 'Heidenheim an der Brenz',
    postalCode: '89522'
  },
  {
    municipality: 'Heidenrod',
    postalCode: '65321'
  },
  {
    municipality: 'Heidersdorf',
    postalCode: '09526'
  },
  {
    municipality: 'Heidesee',
    postalCode: '15754'
  },
  {
    municipality: 'Heidgraben',
    postalCode: '25436'
  },
  {
    municipality: 'Heidmoor',
    postalCode: '24632'
  },
  {
    municipality: 'Heidmühlen',
    postalCode: '24598'
  },
  {
    municipality: 'Heidweiler',
    postalCode: '54518'
  },
  {
    municipality: 'Heigenbrücken',
    postalCode: '63869'
  },
  {
    municipality: 'Heikendorf',
    postalCode: '24226'
  },
  {
    municipality: 'Heilbach',
    postalCode: '54673'
  },
  {
    municipality: 'Heilbad Heiligenstadt',
    postalCode: '37308'
  },
  {
    municipality: 'Heilberscheid',
    postalCode: '56412'
  },
  {
    municipality: 'Heilbronn',
    postalCode: '74072'
  },
  {
    municipality: 'Heilbronn',
    postalCode: '74074'
  },
  {
    municipality: 'Heilbronn',
    postalCode: '74076'
  },
  {
    municipality: 'Heilbronn',
    postalCode: '74078'
  },
  {
    municipality: 'Heilbronn',
    postalCode: '74080'
  },
  {
    municipality: 'Heilbronn',
    postalCode: '74081'
  },
  {
    municipality: 'Heilenbach',
    postalCode: '54636'
  },
  {
    municipality: 'Heiligenberg',
    postalCode: '88633'
  },
  {
    municipality: 'Heiligengrabe',
    postalCode: '16909'
  },
  {
    municipality: 'Heiligenhafen',
    postalCode: '23774'
  },
  {
    municipality: 'Heiligenhaus',
    postalCode: '42579'
  },
  {
    municipality: 'Heiligenmoschel',
    postalCode: '67699'
  },
  {
    municipality: 'Heiligenroth',
    postalCode: '56412'
  },
  {
    municipality: 'Heiligenstadt',
    postalCode: '91332'
  },
  {
    municipality: 'Heiligenstedten',
    postalCode: '25524'
  },
  {
    municipality: 'Heiligenstedtenerkamp',
    postalCode: '25524'
  },
  {
    municipality: 'Heiligkreuzsteinach',
    postalCode: '69253'
  },
  {
    municipality: 'Heilsbronn',
    postalCode: '91560'
  },
  {
    municipality: 'Heilshoop',
    postalCode: '23619'
  },
  {
    municipality: 'Heimbach',
    postalCode: '52396'
  },
  {
    municipality: 'Heimbach',
    postalCode: '55779'
  },
  {
    municipality: 'Heimborn',
    postalCode: '57629'
  },
  {
    municipality: 'Heimbuchenthal',
    postalCode: '63872'
  },
  {
    municipality: 'Heimenkirch',
    postalCode: '88178'
  },
  {
    municipality: 'Heimertingen',
    postalCode: '87751'
  },
  {
    municipality: 'Heimsheim',
    postalCode: '71296'
  },
  {
    municipality: 'Heimweiler',
    postalCode: '55606'
  },
  {
    municipality: 'Heinade',
    postalCode: '37627'
  },
  {
    municipality: 'Heinbockel',
    postalCode: '21726'
  },
  {
    municipality: 'Heinersbrück',
    postalCode: '03185'
  },
  {
    municipality: 'Heinersreuth',
    postalCode: '95500'
  },
  {
    municipality: 'Heiningen',
    postalCode: '38312'
  },
  {
    municipality: 'Heiningen',
    postalCode: '73037'
  },
  {
    municipality: 'Heiningen',
    postalCode: '73092'
  },
  {
    municipality: 'Heiningen',
    postalCode: '73107'
  },
  {
    municipality: 'Heinkenborstel',
    postalCode: '24594'
  },
  {
    municipality: 'Heinrichsthal',
    postalCode: '63871'
  },
  {
    municipality: 'Heinrichswalde',
    postalCode: '17379'
  },
  {
    municipality: 'Heinsberg',
    postalCode: '52525'
  },
  {
    municipality: 'Heinsdorfergrund',
    postalCode: '08468'
  },
  {
    municipality: 'Heinsen',
    postalCode: '37649'
  },
  {
    municipality: 'Heinzenbach',
    postalCode: '55483'
  },
  {
    municipality: 'Heinzenberg',
    postalCode: '55606'
  },
  {
    municipality: 'Heinzenhausen',
    postalCode: '67742'
  },
  {
    municipality: 'Heisdorf',
    postalCode: '54614'
  },
  {
    municipality: 'Heist',
    postalCode: '25492'
  },
  {
    municipality: 'Heistenbach',
    postalCode: '65558'
  },
  {
    municipality: 'Heitersheim',
    postalCode: '79423'
  },
  {
    municipality: 'Helbedündorf',
    postalCode: '99713'
  },
  {
    municipality: 'Helbra',
    postalCode: '06311'
  },
  {
    municipality: 'Heldburg',
    postalCode: '98663'
  },
  {
    municipality: 'Heldenstein',
    postalCode: '84431'
  },
  {
    municipality: 'Helferskirchen',
    postalCode: '56244'
  },
  {
    municipality: 'Helgoland',
    postalCode: '27498'
  },
  {
    municipality: 'Hellenhahn-Schellenberg',
    postalCode: '56479'
  },
  {
    municipality: 'Hellenthal',
    postalCode: '53940'
  },
  {
    municipality: 'Hellertshausen',
    postalCode: '55758'
  },
  {
    municipality: 'Hellschen-Heringsand-Unterschaar',
    postalCode: '25764'
  },
  {
    municipality: 'Hellwege',
    postalCode: '27367'
  },
  {
    municipality: 'Helmbrechts',
    postalCode: '95233'
  },
  {
    municipality: 'Helmenzen',
    postalCode: '57612'
  },
  {
    municipality: 'Helmeroth',
    postalCode: '57612'
  },
  {
    municipality: 'Helmstadt',
    postalCode: '97264'
  },
  {
    municipality: 'Helmstadt-Bargen',
    postalCode: '74921'
  },
  {
    municipality: 'Helmstedt',
    postalCode: '38350'
  },
  {
    municipality: 'Helmstedt',
    postalCode: '38372'
  },
  {
    municipality: 'Helmstorf',
    postalCode: '24321'
  },
  {
    municipality: 'Helpsen',
    postalCode: '31691'
  },
  {
    municipality: 'Helsa',
    postalCode: '34298'
  },
  {
    municipality: 'Helse',
    postalCode: '25709'
  },
  {
    municipality: 'Heltersberg',
    postalCode: '67716'
  },
  {
    municipality: 'Helvesiek',
    postalCode: '27389'
  },
  {
    municipality: 'Hemau',
    postalCode: '93155'
  },
  {
    municipality: 'Hemdingen',
    postalCode: '25485'
  },
  {
    municipality: 'Hemer',
    postalCode: '58675'
  },
  {
    municipality: 'Hemhofen',
    postalCode: '91334'
  },
  {
    municipality: 'Hemme',
    postalCode: '25774'
  },
  {
    municipality: 'Hemmelzen',
    postalCode: '57612'
  },
  {
    municipality: 'Hemmersheim',
    postalCode: '97258'
  },
  {
    municipality: 'Hemmingen',
    postalCode: '71282'
  },
  {
    municipality: 'Hemmingen',
    postalCode: '30966'
  },
  {
    municipality: 'Hemmingstedt',
    postalCode: '25770'
  },
  {
    municipality: 'Hemmoor',
    postalCode: '21745'
  },
  {
    municipality: 'Hemsbach',
    postalCode: '69502'
  },
  {
    municipality: 'Hemsbünde',
    postalCode: '27386'
  },
  {
    municipality: 'Hemslingen',
    postalCode: '27386'
  },
  {
    municipality: 'Hemsloh',
    postalCode: '49453'
  },
  {
    municipality: 'Henau',
    postalCode: '55490'
  },
  {
    municipality: 'Hendungen',
    postalCode: '97640'
  },
  {
    municipality: 'Henfenfeld',
    postalCode: '91239'
  },
  {
    municipality: 'Henfstädt',
    postalCode: '98660'
  },
  {
    municipality: 'Hengersberg',
    postalCode: '94491'
  },
  {
    municipality: 'Hennef (Sieg)',
    postalCode: '53773'
  },
  {
    municipality: 'Hennigsdorf',
    postalCode: '16761'
  },
  {
    municipality: 'Hennstedt',
    postalCode: '25581'
  },
  {
    municipality: 'Hennstedt',
    postalCode: '25779'
  },
  {
    municipality: 'Hennweiler',
    postalCode: '55619'
  },
  {
    municipality: 'Henschtal',
    postalCode: '66909'
  },
  {
    municipality: 'Henstedt-Ulzburg',
    postalCode: '24558'
  },
  {
    municipality: 'Hentern',
    postalCode: '54314'
  },
  {
    municipality: 'Hepberg',
    postalCode: '85120'
  },
  {
    municipality: 'Heppenheim',
    postalCode: '64646'
  },
  {
    municipality: 'Hepstedt',
    postalCode: '27412'
  },
  {
    municipality: 'Herbertingen',
    postalCode: '88518'
  },
  {
    municipality: 'Herbolzheim',
    postalCode: '79336'
  },
  {
    municipality: 'Herborn',
    postalCode: '35745'
  },
  {
    municipality: 'Herborn',
    postalCode: '55758'
  },
  {
    municipality: 'Herbrechtingen',
    postalCode: '89542'
  },
  {
    municipality: 'Herbsleben',
    postalCode: '99955'
  },
  {
    municipality: 'Herbstadt',
    postalCode: '97633'
  },
  {
    municipality: 'Herbstein',
    postalCode: '36358'
  },
  {
    municipality: 'Herbstmühle',
    postalCode: '54673'
  },
  {
    municipality: 'Herchweiler',
    postalCode: '66871'
  },
  {
    municipality: 'Herdecke',
    postalCode: '58313'
  },
  {
    municipality: 'Herdorf',
    postalCode: '57562'
  },
  {
    municipality: 'Herdwangen-Schönach',
    postalCode: '88634'
  },
  {
    municipality: 'Heretsried',
    postalCode: '86465'
  },
  {
    municipality: 'Herford',
    postalCode: '32049'
  },
  {
    municipality: 'Herford',
    postalCode: '32051'
  },
  {
    municipality: 'Herford',
    postalCode: '32052'
  },
  {
    municipality: 'Herforst',
    postalCode: '54662'
  },
  {
    municipality: 'Hergatz',
    postalCode: '88145'
  },
  {
    municipality: 'Hergenfeld',
    postalCode: '55452'
  },
  {
    municipality: 'Hergenroth',
    postalCode: '56457'
  },
  {
    municipality: 'Hergensweiler',
    postalCode: '88138'
  },
  {
    municipality: 'Hergersweiler',
    postalCode: '76872'
  },
  {
    municipality: 'Hergisdorf',
    postalCode: '06313'
  },
  {
    municipality: 'Heringen/Helme',
    postalCode: '99765'
  },
  {
    municipality: 'Heringen (Werra)',
    postalCode: '36266'
  },
  {
    municipality: 'Heringsdorf',
    postalCode: '23777'
  },
  {
    municipality: 'Heringsdorf',
    postalCode: '17419'
  },
  {
    municipality: 'Heringsdorf',
    postalCode: '17424'
  },
  {
    municipality: 'Heringsdorf',
    postalCode: '17429'
  },
  {
    municipality: 'Herl',
    postalCode: '54317'
  },
  {
    municipality: 'Herleshausen',
    postalCode: '37293'
  },
  {
    municipality: 'Hermaringen',
    postalCode: '89537'
  },
  {
    municipality: 'Hermaringen',
    postalCode: '89568'
  },
  {
    municipality: 'Hermersberg',
    postalCode: '66919'
  },
  {
    municipality: 'Hermeskeil',
    postalCode: '54411'
  },
  {
    municipality: 'Hermsdorf',
    postalCode: '01945'
  },
  {
    municipality: 'Hermsdorf',
    postalCode: '07629'
  },
  {
    municipality: 'Hermsdorf/Erzgebirge',
    postalCode: '01776'
  },
  {
    municipality: 'Herne',
    postalCode: '44623'
  },
  {
    municipality: 'Herne',
    postalCode: '44625'
  },
  {
    municipality: 'Herne',
    postalCode: '44627'
  },
  {
    municipality: 'Herne',
    postalCode: '44628'
  },
  {
    municipality: 'Herne',
    postalCode: '44629'
  },
  {
    municipality: 'Herne',
    postalCode: '44649'
  },
  {
    municipality: 'Herne',
    postalCode: '44651'
  },
  {
    municipality: 'Herne',
    postalCode: '44652'
  },
  {
    municipality: 'Herne',
    postalCode: '44653'
  },
  {
    municipality: 'Herold',
    postalCode: '56368'
  },
  {
    municipality: 'Heroldsbach',
    postalCode: '91336'
  },
  {
    municipality: 'Heroldsberg',
    postalCode: '90562'
  },
  {
    municipality: 'Heroldstatt',
    postalCode: '72535'
  },
  {
    municipality: 'Herrenberg',
    postalCode: '71083'
  },
  {
    municipality: 'Herrenhof',
    postalCode: '99887'
  },
  {
    municipality: 'Herren-Sulzbach',
    postalCode: '67742'
  },
  {
    municipality: 'Herresbach',
    postalCode: '56729'
  },
  {
    municipality: 'Herrieden',
    postalCode: '91567'
  },
  {
    municipality: 'Herrischried',
    postalCode: '79737'
  },
  {
    municipality: 'Herrngiersdorf',
    postalCode: '84097'
  },
  {
    municipality: 'Herrnhut',
    postalCode: '02747'
  },
  {
    municipality: 'Herrsching am Ammersee',
    postalCode: '82211'
  },
  {
    municipality: 'Herrstein',
    postalCode: '55756'
  },
  {
    municipality: 'Hersbruck',
    postalCode: '91217'
  },
  {
    municipality: 'Herschbach',
    postalCode: '56249'
  },
  {
    municipality: 'Herschbach',
    postalCode: '56414'
  },
  {
    municipality: 'Herschberg',
    postalCode: '66917'
  },
  {
    municipality: 'Herschberg',
    postalCode: '66919'
  },
  {
    municipality: 'Herschberg',
    postalCode: '66987'
  },
  {
    municipality: 'Herschbroich',
    postalCode: '53518'
  },
  {
    municipality: 'Herscheid',
    postalCode: '58849'
  },
  {
    municipality: 'Herschweiler-Pettersheim',
    postalCode: '66909'
  },
  {
    municipality: 'Hersdorf',
    postalCode: '54597'
  },
  {
    municipality: 'Herten',
    postalCode: '45699'
  },
  {
    municipality: 'Herten',
    postalCode: '45701'
  },
  {
    municipality: 'Herxheim',
    postalCode: '76863'
  },
  {
    municipality: 'Herxheim am Berg',
    postalCode: '67273'
  },
  {
    municipality: 'Herxheimweyher',
    postalCode: '76863'
  },
  {
    municipality: 'Herzberg am Harz',
    postalCode: '37412'
  },
  {
    municipality: 'Herzberg am Harz',
    postalCode: '37434'
  },
  {
    municipality: 'Herzberg (Elster)',
    postalCode: '04916'
  },
  {
    municipality: 'Herzberg (Mark)',
    postalCode: '16835'
  },
  {
    municipality: 'Herzebrock-Clarholz',
    postalCode: '33442'
  },
  {
    municipality: 'Herzfeld',
    postalCode: '54619'
  },
  {
    municipality: 'Herzhorn',
    postalCode: '25379'
  },
  {
    municipality: 'Herzlake',
    postalCode: '49770'
  },
  {
    municipality: 'Herzogenaurach',
    postalCode: '91074'
  },
  {
    municipality: 'Herzogenrath',
    postalCode: '52134'
  },
  {
    municipality: 'Hesel',
    postalCode: '26835'
  },
  {
    municipality: 'Hespe',
    postalCode: '31693'
  },
  {
    municipality: 'Heßdorf',
    postalCode: '91093'
  },
  {
    municipality: 'Heßheim',
    postalCode: '67258'
  },
  {
    municipality: 'Hessigheim',
    postalCode: '74394'
  },
  {
    municipality: 'Hessisch Lichtenau',
    postalCode: '37235'
  },
  {
    municipality: 'Hessisch Oldendorf',
    postalCode: '31840'
  },
  {
    municipality: 'Hesweiler',
    postalCode: '56865'
  },
  {
    municipality: 'Hetlingen',
    postalCode: '25491'
  },
  {
    municipality: 'Hetschburg',
    postalCode: '99438'
  },
  {
    municipality: 'Hettenhausen',
    postalCode: '66919'
  },
  {
    municipality: 'Hettenleidelheim',
    postalCode: '67310'
  },
  {
    municipality: 'Hettenrodt',
    postalCode: '55758'
  },
  {
    municipality: 'Hettenshausen',
    postalCode: '85276'
  },
  {
    municipality: 'Hettenshausen',
    postalCode: '85304'
  },
  {
    municipality: 'Hettenshausen',
    postalCode: '85307'
  },
  {
    municipality: 'Hettingen',
    postalCode: '72513'
  },
  {
    municipality: 'Hettstadt',
    postalCode: '97265'
  },
  {
    municipality: 'Hettstedt',
    postalCode: '06333'
  },
  {
    municipality: 'Hetzerath',
    postalCode: '54523'
  },
  {
    municipality: 'Hetzles',
    postalCode: '91077'
  },
  {
    municipality: 'Heubach',
    postalCode: '73540'
  },
  {
    municipality: 'Heuchelheim',
    postalCode: '35452'
  },
  {
    municipality: 'Heuchelheim bei Frankenthal',
    postalCode: '67259'
  },
  {
    municipality: 'Heuchelheim-Klingen',
    postalCode: '76831'
  },
  {
    municipality: 'Heuchlingen',
    postalCode: '73572'
  },
  {
    municipality: 'Heuerßen',
    postalCode: '31700'
  },
  {
    municipality: 'Heukewalde',
    postalCode: '04626'
  },
  {
    municipality: 'Heupelzen',
    postalCode: '57612'
  },
  {
    municipality: 'Heusenstamm',
    postalCode: '63150'
  },
  {
    municipality: 'Heustreu',
    postalCode: '97618'
  },
  {
    municipality: 'Heusweiler',
    postalCode: '66265'
  },
  {
    municipality: 'Heuthen',
    postalCode: '37308'
  },
  {
    municipality: 'Heuweiler',
    postalCode: '79194'
  },
  {
    municipality: 'Heuzert',
    postalCode: '57627'
  },
  {
    municipality: 'Heyen',
    postalCode: '37619'
  },
  {
    municipality: 'Heyersdorf',
    postalCode: '04626'
  },
  {
    municipality: 'Hiddenhausen',
    postalCode: '32120'
  },
  {
    municipality: 'Hilbersdorf',
    postalCode: '07580'
  },
  {
    municipality: 'Hilchenbach',
    postalCode: '57271'
  },
  {
    municipality: 'Hildburghausen',
    postalCode: '98646'
  },
  {
    municipality: 'Hilden',
    postalCode: '40721'
  },
  {
    municipality: 'Hilden',
    postalCode: '40723'
  },
  {
    municipality: 'Hilden',
    postalCode: '40724'
  },
  {
    municipality: 'Hilders',
    postalCode: '36115'
  },
  {
    municipality: 'Hildesheim',
    postalCode: '31134'
  },
  {
    municipality: 'Hildesheim',
    postalCode: '31135'
  },
  {
    municipality: 'Hildesheim',
    postalCode: '31137'
  },
  {
    municipality: 'Hildesheim',
    postalCode: '31139'
  },
  {
    municipality: 'Hildesheim',
    postalCode: '31141'
  },
  {
    municipality: 'Hildrizhausen',
    postalCode: '71157'
  },
  {
    municipality: 'Hilgenroth',
    postalCode: '57612'
  },
  {
    municipality: 'Hilgermissen',
    postalCode: '27318'
  },
  {
    municipality: 'Hilgert',
    postalCode: '56206'
  },
  {
    municipality: 'Hilgertshausen-Tandern',
    postalCode: '86567'
  },
  {
    municipality: 'Hilkenbrook',
    postalCode: '26897'
  },
  {
    municipality: 'Hille',
    postalCode: '32479'
  },
  {
    municipality: 'Hillerse',
    postalCode: '38543'
  },
  {
    municipality: 'Hillesheim',
    postalCode: '54576'
  },
  {
    municipality: 'Hillesheim',
    postalCode: '67586'
  },
  {
    municipality: 'Hillgroven',
    postalCode: '25764'
  },
  {
    municipality: 'Hillscheid',
    postalCode: '56204'
  },
  {
    municipality: 'Hilpoltstein',
    postalCode: '91161'
  },
  {
    municipality: 'Hilscheid',
    postalCode: '54426'
  },
  {
    municipality: 'Hilst',
    postalCode: '66957'
  },
  {
    municipality: 'Hiltenfingen',
    postalCode: '86856'
  },
  {
    municipality: 'Hilter',
    postalCode: '49176'
  },
  {
    municipality: 'Hiltpoltstein',
    postalCode: '91355'
  },
  {
    municipality: 'Hilzingen',
    postalCode: '78247'
  },
  {
    municipality: 'Himbergen',
    postalCode: '29584'
  },
  {
    municipality: 'Himmelkron',
    postalCode: '95502'
  },
  {
    municipality: 'Himmelpforten',
    postalCode: '21709'
  },
  {
    municipality: 'Himmelstadt',
    postalCode: '97267'
  },
  {
    municipality: 'Himmighofen',
    postalCode: '56357'
  },
  {
    municipality: 'Hingstheide',
    postalCode: '25563'
  },
  {
    municipality: 'Hinrichshagen',
    postalCode: '17498'
  },
  {
    municipality: 'Hinte',
    postalCode: '26759'
  },
  {
    municipality: 'Hinterschmiding',
    postalCode: '94146'
  },
  {
    municipality: 'Hintersee',
    postalCode: '17375'
  },
  {
    municipality: 'Hintertiefenbach',
    postalCode: '55743'
  },
  {
    municipality: 'Hinterweidenthal',
    postalCode: '66999'
  },
  {
    municipality: 'Hinterweiler',
    postalCode: '54570'
  },
  {
    municipality: 'Hinterzarten',
    postalCode: '79856'
  },
  {
    municipality: 'Hinzenburg',
    postalCode: '54316'
  },
  {
    municipality: 'Hinzert-Pölert',
    postalCode: '54421'
  },
  {
    municipality: 'Hinzweiler',
    postalCode: '67756'
  },
  {
    municipality: 'Hipstedt',
    postalCode: '27432'
  },
  {
    municipality: 'Hirrlingen',
    postalCode: '72145'
  },
  {
    municipality: 'Hirschaid',
    postalCode: '96114'
  },
  {
    municipality: 'Hirschau',
    postalCode: '92242'
  },
  {
    municipality: 'Hirschbach',
    postalCode: '92275'
  },
  {
    municipality: 'Hirschberg',
    postalCode: '65558'
  },
  {
    municipality: 'Hirschberg',
    postalCode: '07927'
  },
  {
    municipality: 'Hirschberg an der Bergstraße',
    postalCode: '69493'
  },
  {
    municipality: 'Hirschfeld',
    postalCode: '08144'
  },
  {
    municipality: 'Hirschfeld',
    postalCode: '04932'
  },
  {
    municipality: 'Hirschfeld',
    postalCode: '07554'
  },
  {
    municipality: 'Hirschfeld (Hunsrück)',
    postalCode: '55483'
  },
  {
    municipality: 'Hirschhorn',
    postalCode: '64757'
  },
  {
    municipality: 'Hirschhorn',
    postalCode: '69412'
  },
  {
    municipality: 'Hirschhorn',
    postalCode: '69434'
  },
  {
    municipality: 'Hirschhorn/Pfalz',
    postalCode: '67732'
  },
  {
    municipality: 'Hirschstein',
    postalCode: '01594'
  },
  {
    municipality: 'Hirschthal',
    postalCode: '66996'
  },
  {
    municipality: 'Hirten',
    postalCode: '56729'
  },
  {
    municipality: 'Hirzenhain',
    postalCode: '63697'
  },
  {
    municipality: 'Hirz-Maulsbach',
    postalCode: '57635'
  },
  {
    municipality: 'Hittbergen',
    postalCode: '21522'
  },
  {
    municipality: 'Hitzacker',
    postalCode: '29456'
  },
  {
    municipality: 'Hitzhofen',
    postalCode: '85122'
  },
  {
    municipality: 'Hitzhusen',
    postalCode: '24576'
  },
  {
    municipality: 'Höchberg',
    postalCode: '97204'
  },
  {
    municipality: 'Hochborn',
    postalCode: '55234'
  },
  {
    municipality: 'Hochdonn',
    postalCode: '25712'
  },
  {
    municipality: 'Hochdorf',
    postalCode: '73269'
  },
  {
    municipality: 'Hochdorf',
    postalCode: '88436'
  },
  {
    municipality: 'Hochdorf',
    postalCode: '88454'
  },
  {
    municipality: 'Hochdorf-Assenheim',
    postalCode: '67126'
  },
  {
    municipality: 'Höchenschwand',
    postalCode: '79862'
  },
  {
    municipality: 'Hochheim',
    postalCode: '65239'
  },
  {
    municipality: 'Höchheim',
    postalCode: '97633'
  },
  {
    municipality: 'Hochkirch - Bukecy',
    postalCode: '02627'
  },
  {
    municipality: 'Hochscheid',
    postalCode: '54472'
  },
  {
    municipality: 'Hochspeyer',
    postalCode: '67691'
  },
  {
    municipality: 'Höchstadt a.d.Aisch',
    postalCode: '91315'
  },
  {
    municipality: 'Höchstädt a.d.Donau',
    postalCode: '89420'
  },
  {
    municipality: 'Hochstadt a.Main',
    postalCode: '96272'
  },
  {
    municipality: 'Höchstädt im Fichtelgebirge',
    postalCode: '95186'
  },
  {
    municipality: 'Hochstadt (Pfalz)',
    postalCode: '76879'
  },
  {
    municipality: 'Hochstätten',
    postalCode: '55585'
  },
  {
    municipality: 'Höchstberg',
    postalCode: '56767'
  },
  {
    municipality: 'Höchstenbach',
    postalCode: '57629'
  },
  {
    municipality: 'Hochstetten-Dhaun',
    postalCode: '55606'
  },
  {
    municipality: 'Höchst im Odenwald',
    postalCode: '64739'
  },
  {
    municipality: 'Hockenheim',
    postalCode: '68766'
  },
  {
    municipality: 'Hockweiler',
    postalCode: '54316'
  },
  {
    municipality: 'Hodenhagen',
    postalCode: '29693'
  },
  {
    municipality: 'Hodorf',
    postalCode: '25569'
  },
  {
    municipality: 'Hof',
    postalCode: '95028'
  },
  {
    municipality: 'Hof',
    postalCode: '95030'
  },
  {
    municipality: 'Hof',
    postalCode: '95032'
  },
  {
    municipality: 'Hof',
    postalCode: '56472'
  },
  {
    municipality: 'Hofbieber',
    postalCode: '36145'
  },
  {
    municipality: 'Höfen an der Enz',
    postalCode: '75339'
  },
  {
    municipality: 'Hoffeld',
    postalCode: '24582'
  },
  {
    municipality: 'Hoffeld',
    postalCode: '53534'
  },
  {
    municipality: 'Hofgeismar',
    postalCode: '34369'
  },
  {
    municipality: 'Hofheim am Taunus',
    postalCode: '65719'
  },
  {
    municipality: 'Hofheim in Unterfranken',
    postalCode: '97461'
  },
  {
    municipality: 'Hofkirchen',
    postalCode: '94544'
  },
  {
    municipality: 'Hofstetten',
    postalCode: '77716'
  },
  {
    municipality: 'Hofstetten',
    postalCode: '86928'
  },
  {
    municipality: 'Högel',
    postalCode: '25858'
  },
  {
    municipality: 'Högersdorf',
    postalCode: '23795'
  },
  {
    municipality: 'Högsdorf',
    postalCode: '24327'
  },
  {
    municipality: 'Höhbeck',
    postalCode: '29478'
  },
  {
    municipality: 'Hohberg',
    postalCode: '77749'
  },
  {
    municipality: 'Hohe Börde',
    postalCode: '39167'
  },
  {
    municipality: 'Hohe Börde',
    postalCode: '39326'
  },
  {
    municipality: 'Hohe Börde',
    postalCode: '39343'
  },
  {
    municipality: 'Höheinöd',
    postalCode: '66989'
  },
  {
    municipality: 'Höheischweiler',
    postalCode: '66989'
  },
  {
    municipality: 'Hohenahr',
    postalCode: '35644'
  },
  {
    municipality: 'Hohenaltheim',
    postalCode: '86745'
  },
  {
    municipality: 'Hohenaspe',
    postalCode: '25582'
  },
  {
    municipality: 'Hohenau',
    postalCode: '94545'
  },
  {
    municipality: 'Hohenberg an der Eger',
    postalCode: '95691'
  },
  {
    municipality: 'Hohenberg-Krusemark',
    postalCode: '39596'
  },
  {
    municipality: 'Hohenbocka',
    postalCode: '01945'
  },
  {
    municipality: 'Hohenbollentin',
    postalCode: '17111'
  },
  {
    municipality: 'Hohenbrunn',
    postalCode: '85521'
  },
  {
    municipality: 'Hohenbrunn',
    postalCode: '85662'
  },
  {
    municipality: 'Hohenbucko',
    postalCode: '04936'
  },
  {
    municipality: 'Hohenburg',
    postalCode: '92277'
  },
  {
    municipality: 'Hohen Demzin',
    postalCode: '17166'
  },
  {
    municipality: 'Hohendubrau - Wysoka Dubrawa',
    postalCode: '02906'
  },
  {
    municipality: 'Hohenfelde',
    postalCode: '24257'
  },
  {
    municipality: 'Hohenfelde',
    postalCode: '18209'
  },
  {
    municipality: 'Hohenfelde',
    postalCode: '18211'
  },
  {
    municipality: 'Hohenfelde',
    postalCode: '25358'
  },
  {
    municipality: 'Hohenfelde',
    postalCode: '22946'
  },
  {
    municipality: 'Hohenfelden',
    postalCode: '99448'
  },
  {
    municipality: 'Hohenfels',
    postalCode: '92366'
  },
  {
    municipality: 'Hohenfels',
    postalCode: '78355'
  },
  {
    municipality: 'Hohenfels-Essingen',
    postalCode: '54570'
  },
  {
    municipality: 'Hohenfinow',
    postalCode: '16248'
  },
  {
    municipality: 'Hohenfurch',
    postalCode: '86978'
  },
  {
    municipality: 'Hohengandern',
    postalCode: '37318'
  },
  {
    municipality: 'Hohenhameln',
    postalCode: '31249'
  },
  {
    municipality: 'Hohenhorn',
    postalCode: '21526'
  },
  {
    municipality: 'Hohenkammer',
    postalCode: '85411'
  },
  {
    municipality: 'Hohenkirchen',
    postalCode: '23968'
  },
  {
    municipality: 'Höhenkirchen-Siegertsbrunn',
    postalCode: '85635'
  },
  {
    municipality: 'Höhenland',
    postalCode: '16259'
  },
  {
    municipality: 'Hohenleimbach',
    postalCode: '56746'
  },
  {
    municipality: 'Hohenleipisch',
    postalCode: '04934'
  },
  {
    municipality: 'Hohenleuben',
    postalCode: '07958'
  },
  {
    municipality: 'Hohenlinden',
    postalCode: '85664'
  },
  {
    municipality: 'Hohenlockstedt',
    postalCode: '25551'
  },
  {
    municipality: 'Hohenmocker',
    postalCode: '17111'
  },
  {
    municipality: 'Hohenmölsen',
    postalCode: '06679'
  },
  {
    municipality: 'Hohen Neuendorf',
    postalCode: '16540'
  },
  {
    municipality: 'Hohen Neuendorf',
    postalCode: '16556'
  },
  {
    municipality: 'Hohen Neuendorf',
    postalCode: '16562'
  },
  {
    municipality: 'Hohenöllen',
    postalCode: '67744'
  },
  {
    municipality: 'Hohenpeißenberg',
    postalCode: '82383'
  },
  {
    municipality: 'Hohenpolding',
    postalCode: '84432'
  },
  {
    municipality: 'Hohen Pritz',
    postalCode: '19406'
  },
  {
    municipality: 'Hohenroda',
    postalCode: '36284'
  },
  {
    municipality: 'Hohenroth',
    postalCode: '97618'
  },
  {
    municipality: 'Hohenselchow-Groß Pinnow',
    postalCode: '16306'
  },
  {
    municipality: 'Hohen Sprenz',
    postalCode: '18299'
  },
  {
    municipality: 'Hohenstadt',
    postalCode: '73345'
  },
  {
    municipality: 'Hohenstein',
    postalCode: '65329'
  },
  {
    municipality: 'Hohenstein',
    postalCode: '99755'
  },
  {
    municipality: 'Hohenstein',
    postalCode: '72531'
  },
  {
    municipality: 'Hohenstein-Ernstthal',
    postalCode: '09337'
  },
  {
    municipality: 'Hohen-Sülzen',
    postalCode: '67591'
  },
  {
    municipality: 'Hohentengen',
    postalCode: '88367'
  },
  {
    municipality: 'Hohentengen am Hochrhein',
    postalCode: '79801'
  },
  {
    municipality: 'Hohenthann',
    postalCode: '84098'
  },
  {
    municipality: 'Hohen Viecheln',
    postalCode: '23996'
  },
  {
    municipality: 'Hohen Wangelin',
    postalCode: '17194'
  },
  {
    municipality: 'Hohenwart',
    postalCode: '86558'
  },
  {
    municipality: 'Hohenwarte',
    postalCode: '07338'
  },
  {
    municipality: 'Hohenwarth',
    postalCode: '93480'
  },
  {
    municipality: 'Hohenwestedt',
    postalCode: '24594'
  },
  {
    municipality: 'Hohenzieritz',
    postalCode: '17237'
  },
  {
    municipality: 'Hohes Kreuz',
    postalCode: '37308'
  },
  {
    municipality: 'Höhfröschen',
    postalCode: '66989'
  },
  {
    municipality: 'Hohn',
    postalCode: '24806'
  },
  {
    municipality: 'Höhn',
    postalCode: '56462'
  },
  {
    municipality: 'Hohndorf',
    postalCode: '09394'
  },
  {
    municipality: 'Höhndorf',
    postalCode: '24217'
  },
  {
    municipality: 'Hohne',
    postalCode: '29362'
  },
  {
    municipality: 'Hohnhorst',
    postalCode: '31559'
  },
  {
    municipality: 'Hohnstein',
    postalCode: '01848'
  },
  {
    municipality: 'Hohnstorf (Elbe)',
    postalCode: '21522'
  },
  {
    municipality: 'Höhr-Grenzhausen',
    postalCode: '56203'
  },
  {
    municipality: 'Hohwacht',
    postalCode: '24321'
  },
  {
    municipality: 'Hoisdorf',
    postalCode: '22955'
  },
  {
    municipality: 'Hoisdorf',
    postalCode: '22961'
  },
  {
    municipality: 'Holdorf',
    postalCode: '49451'
  },
  {
    municipality: 'Holdorf',
    postalCode: '19205'
  },
  {
    municipality: 'Holdorf',
    postalCode: '19217'
  },
  {
    municipality: 'Holenberg',
    postalCode: '37642'
  },
  {
    municipality: 'Holldorf',
    postalCode: '17094'
  },
  {
    municipality: 'Holle',
    postalCode: '31188'
  },
  {
    municipality: 'Hollenbach',
    postalCode: '86568'
  },
  {
    municipality: 'Hollenbek',
    postalCode: '23883'
  },
  {
    municipality: 'Hollenstedt',
    postalCode: '21279'
  },
  {
    municipality: 'Holler',
    postalCode: '56412'
  },
  {
    municipality: 'Hollern-Twielenfleth',
    postalCode: '21723'
  },
  {
    municipality: 'Hollfeld',
    postalCode: '96142'
  },
  {
    municipality: 'Hollingstedt',
    postalCode: '25788'
  },
  {
    municipality: 'Hollingstedt',
    postalCode: '24876'
  },
  {
    municipality: 'Hollnich',
    postalCode: '56288'
  },
  {
    municipality: 'Hollnseth',
    postalCode: '21769'
  },
  {
    municipality: 'Hollstadt',
    postalCode: '97618'
  },
  {
    municipality: 'Holm',
    postalCode: '25488'
  },
  {
    municipality: 'Holm',
    postalCode: '25923'
  },
  {
    municipality: 'Holste',
    postalCode: '27729'
  },
  {
    municipality: 'Holstenniendorf',
    postalCode: '25584'
  },
  {
    municipality: 'Holsthum',
    postalCode: '54668'
  },
  {
    municipality: 'Holt',
    postalCode: '24994'
  },
  {
    municipality: 'Holtgast',
    postalCode: '26427'
  },
  {
    municipality: 'Holthusen',
    postalCode: '19075'
  },
  {
    municipality: 'Holtland',
    postalCode: '26835'
  },
  {
    municipality: 'Holtsee',
    postalCode: '24363'
  },
  {
    municipality: 'Holzappel',
    postalCode: '56379'
  },
  {
    municipality: 'Holzbach',
    postalCode: '55469'
  },
  {
    municipality: 'Holzbunge',
    postalCode: '24361'
  },
  {
    municipality: 'Holzdorf',
    postalCode: '24364'
  },
  {
    municipality: 'Holzen',
    postalCode: '37632'
  },
  {
    municipality: 'Holzerath',
    postalCode: '54316'
  },
  {
    municipality: 'Holzgerlingen',
    postalCode: '71088'
  },
  {
    municipality: 'Holzgünz',
    postalCode: '87752'
  },
  {
    municipality: 'Holzhausen an der Haide',
    postalCode: '56357'
  },
  {
    municipality: 'Holzheim',
    postalCode: '65558'
  },
  {
    municipality: 'Holzheim',
    postalCode: '89291'
  },
  {
    municipality: 'Holzheim',
    postalCode: '89438'
  },
  {
    municipality: 'Holzheim',
    postalCode: '86684'
  },
  {
    municipality: 'Holzheim am Forst',
    postalCode: '93183'
  },
  {
    municipality: 'Holzkirch',
    postalCode: '89183'
  },
  {
    municipality: 'Holzkirchen',
    postalCode: '97292'
  },
  {
    municipality: 'Holzkirchen',
    postalCode: '83607'
  },
  {
    municipality: 'Holzmaden',
    postalCode: '73271'
  },
  {
    municipality: 'Holzminden',
    postalCode: '37603'
  },
  {
    municipality: 'Holzsußra',
    postalCode: '99713'
  },
  {
    municipality: 'Holzwickede',
    postalCode: '59439'
  },
  {
    municipality: 'Homberg',
    postalCode: '56479'
  },
  {
    municipality: 'Homberg',
    postalCode: '67742'
  },
  {
    municipality: 'Homberg',
    postalCode: '67744'
  },
  {
    municipality: 'Hömberg',
    postalCode: '56379'
  },
  {
    municipality: 'Homberg (Efze)',
    postalCode: '34576'
  },
  {
    municipality: 'Homberg (Ohm)',
    postalCode: '35315'
  },
  {
    municipality: 'Homburg',
    postalCode: '66424'
  },
  {
    municipality: 'Hommerdingen',
    postalCode: '54675'
  },
  {
    municipality: 'Honerath',
    postalCode: '53518'
  },
  {
    municipality: 'Honigsee',
    postalCode: '24211'
  },
  {
    municipality: 'Hönningen',
    postalCode: '53506'
  },
  {
    municipality: 'Hontheim',
    postalCode: '54538'
  },
  {
    municipality: 'Hoogstede',
    postalCode: '49846'
  },
  {
    municipality: 'Hoort',
    postalCode: '19230'
  },
  {
    municipality: 'Hopferau',
    postalCode: '87659'
  },
  {
    municipality: 'Höpfingen',
    postalCode: '74746'
  },
  {
    municipality: 'Hoppegarten',
    postalCode: '15366'
  },
  {
    municipality: 'Hoppenrade',
    postalCode: '18292'
  },
  {
    municipality: 'Hoppstädten',
    postalCode: '67744'
  },
  {
    municipality: 'Hoppstädten-Weiersbach',
    postalCode: '55768'
  },
  {
    municipality: 'Hopsten',
    postalCode: '48496'
  },
  {
    municipality: 'Horath',
    postalCode: '54497'
  },
  {
    municipality: 'Horbach',
    postalCode: '56412'
  },
  {
    municipality: 'Horbach',
    postalCode: '66851'
  },
  {
    municipality: 'Horbach',
    postalCode: '55606'
  },
  {
    municipality: 'Horb am Neckar',
    postalCode: '72160'
  },
  {
    municipality: 'Horben',
    postalCode: '79289'
  },
  {
    municipality: 'Horbruch',
    postalCode: '55483'
  },
  {
    municipality: 'Hörden am Harz',
    postalCode: '37412'
  },
  {
    municipality: 'Hördt',
    postalCode: '76771'
  },
  {
    municipality: 'Horgau',
    postalCode: '86497'
  },
  {
    municipality: 'Horgenzell',
    postalCode: '88263'
  },
  {
    municipality: 'Hörgertshausen',
    postalCode: '85413'
  },
  {
    municipality: 'Horhausen',
    postalCode: '56379'
  },
  {
    municipality: 'Horhausen (Westerwald)',
    postalCode: '56593'
  },
  {
    municipality: 'Höringen',
    postalCode: '67724'
  },
  {
    municipality: 'Horka',
    postalCode: '02923'
  },
  {
    municipality: 'Horn',
    postalCode: '55469'
  },
  {
    municipality: 'Hornbach',
    postalCode: '66500'
  },
  {
    municipality: 'Horn-Bad Meinberg',
    postalCode: '32805'
  },
  {
    municipality: 'Hornbek',
    postalCode: '21514'
  },
  {
    municipality: 'Hornberg',
    postalCode: '78132'
  },
  {
    municipality: 'Horneburg',
    postalCode: '21640'
  },
  {
    municipality: 'Hornsömmern',
    postalCode: '99955'
  },
  {
    municipality: 'Hornstorf',
    postalCode: '23970'
  },
  {
    municipality: 'Hornstorf',
    postalCode: '23974'
  },
  {
    municipality: 'Hörnum (Sylt)',
    postalCode: '25997'
  },
  {
    municipality: 'Horperath',
    postalCode: '56766'
  },
  {
    municipality: 'Horrweiler',
    postalCode: '55457'
  },
  {
    municipality: 'Horschbach',
    postalCode: '66887'
  },
  {
    municipality: 'Hörscheid',
    postalCode: '54552'
  },
  {
    municipality: 'Hörschhausen',
    postalCode: '54552'
  },
  {
    municipality: 'Hörsel',
    postalCode: '99869'
  },
  {
    municipality: 'Hörsel',
    postalCode: '99880'
  },
  {
    municipality: 'Hörselberg-Hainich',
    postalCode: '99820'
  },
  {
    municipality: 'Horst',
    postalCode: '25358'
  },
  {
    municipality: 'Horst',
    postalCode: '23883'
  },
  {
    municipality: 'Horstedt',
    postalCode: '27367'
  },
  {
    municipality: 'Horstedt',
    postalCode: '25860'
  },
  {
    municipality: 'Hörstel',
    postalCode: '48477'
  },
  {
    municipality: 'Hörsten',
    postalCode: '24797'
  },
  {
    municipality: 'Horstmar',
    postalCode: '48612'
  },
  {
    municipality: 'Hörup',
    postalCode: '24980'
  },
  {
    municipality: 'Hösbach',
    postalCode: '63768'
  },
  {
    municipality: 'Hosenfeld',
    postalCode: '36154'
  },
  {
    municipality: 'Höslwang',
    postalCode: '83129'
  },
  {
    municipality: 'Hoßkirch',
    postalCode: '88374'
  },
  {
    municipality: 'Hosten',
    postalCode: '54664'
  },
  {
    municipality: 'Hötensleben',
    postalCode: '39393'
  },
  {
    municipality: 'Hottenbach',
    postalCode: '55758'
  },
  {
    municipality: 'Höttingen',
    postalCode: '91798'
  },
  {
    municipality: 'Hövede',
    postalCode: '25782'
  },
  {
    municipality: 'Hövelhof',
    postalCode: '33161'
  },
  {
    municipality: 'Hövels',
    postalCode: '57537'
  },
  {
    municipality: 'Höxter',
    postalCode: '37671'
  },
  {
    municipality: 'Hoya',
    postalCode: '27318'
  },
  {
    municipality: 'Hoyerhagen',
    postalCode: '27318'
  },
  {
    municipality: 'Hoyerswerda - Wojerecy',
    postalCode: '02977'
  },
  {
    municipality: 'Hübingen',
    postalCode: '56412'
  },
  {
    municipality: 'Hüblingen',
    postalCode: '56479'
  },
  {
    municipality: 'Hückelhoven',
    postalCode: '41836'
  },
  {
    municipality: 'Hückeswagen',
    postalCode: '42499'
  },
  {
    municipality: 'Hude',
    postalCode: '25876'
  },
  {
    municipality: 'Hüde',
    postalCode: '49448'
  },
  {
    municipality: 'Hude (Oldenburg)',
    postalCode: '27798'
  },
  {
    municipality: 'Hüffelsheim',
    postalCode: '55595'
  },
  {
    municipality: 'Hüffenhardt',
    postalCode: '74928'
  },
  {
    municipality: 'Hüffler',
    postalCode: '66909'
  },
  {
    municipality: 'Hüfingen',
    postalCode: '78183'
  },
  {
    municipality: 'Hügelsheim',
    postalCode: '76549'
  },
  {
    municipality: 'Huglfing',
    postalCode: '82386'
  },
  {
    municipality: 'Hugoldsdorf',
    postalCode: '18465'
  },
  {
    municipality: 'Huisheim',
    postalCode: '86685'
  },
  {
    municipality: 'Huje',
    postalCode: '25588'
  },
  {
    municipality: 'Hülben',
    postalCode: '72584'
  },
  {
    municipality: 'Hüllhorst',
    postalCode: '32609'
  },
  {
    municipality: 'Hülseburg',
    postalCode: '19230'
  },
  {
    municipality: 'Hülsede',
    postalCode: '31867'
  },
  {
    municipality: 'Hümmel',
    postalCode: '53520'
  },
  {
    municipality: 'Hummelfeld',
    postalCode: '24357'
  },
  {
    municipality: 'Hummelshain',
    postalCode: '07768'
  },
  {
    municipality: 'Hummeltal',
    postalCode: '95503'
  },
  {
    municipality: 'Hümmerich',
    postalCode: '53547'
  },
  {
    municipality: 'Humptrup',
    postalCode: '25923'
  },
  {
    municipality: 'Hunderdorf',
    postalCode: '94336'
  },
  {
    municipality: 'Hundhaupten',
    postalCode: '07557'
  },
  {
    municipality: 'Hunding',
    postalCode: '94551'
  },
  {
    municipality: 'Hundsangen',
    postalCode: '56414'
  },
  {
    municipality: 'Hundsbach',
    postalCode: '55621'
  },
  {
    municipality: 'Hundsdorf',
    postalCode: '56235'
  },
  {
    municipality: 'Hünfeld',
    postalCode: '36088'
  },
  {
    municipality: 'Hünfelden',
    postalCode: '65597'
  },
  {
    municipality: 'Hungen',
    postalCode: '35410'
  },
  {
    municipality: 'Hungenroth',
    postalCode: '56281'
  },
  {
    municipality: 'Hünstetten',
    postalCode: '65510'
  },
  {
    municipality: 'Hünxe',
    postalCode: '46569'
  },
  {
    municipality: 'Hunzel',
    postalCode: '56355'
  },
  {
    municipality: 'Hupperath',
    postalCode: '54518'
  },
  {
    municipality: 'Hurlach',
    postalCode: '86857'
  },
  {
    municipality: 'Hürtgenwald',
    postalCode: '52393'
  },
  {
    municipality: 'Hürth',
    postalCode: '50354'
  },
  {
    municipality: 'Hürup',
    postalCode: '24975'
  },
  {
    municipality: 'Husby',
    postalCode: '24975'
  },
  {
    municipality: 'Hüsby',
    postalCode: '24850'
  },
  {
    municipality: 'Husum',
    postalCode: '31632'
  },
  {
    municipality: 'Husum',
    postalCode: '25813'
  },
  {
    municipality: 'Hütschenhausen',
    postalCode: '66882'
  },
  {
    municipality: 'Hüttblek',
    postalCode: '24641'
  },
  {
    municipality: 'Hütten',
    postalCode: '24358'
  },
  {
    municipality: 'Hütten',
    postalCode: '54673'
  },
  {
    municipality: 'Hüttenberg',
    postalCode: '35625'
  },
  {
    municipality: 'Hütterscheid',
    postalCode: '54636'
  },
  {
    municipality: 'Hutthurm',
    postalCode: '94116'
  },
  {
    municipality: 'Hüttingen an der Kyll',
    postalCode: '54636'
  },
  {
    municipality: 'Hüttingen bei Lahr',
    postalCode: '54675'
  },
  {
    municipality: 'Hüttisheim',
    postalCode: '89185'
  },
  {
    municipality: 'Hüttlingen',
    postalCode: '73434'
  },
  {
    municipality: 'Hüttlingen',
    postalCode: '73453'
  },
  {
    municipality: 'Hüttlingen',
    postalCode: '73460'
  },
  {
    municipality: 'Hüven',
    postalCode: '49751'
  },
  {
    municipality: 'Huy',
    postalCode: '38836'
  },
  {
    municipality: 'Huy',
    postalCode: '38838'
  },
  {
    municipality: 'Ibach',
    postalCode: '79837'
  },
  {
    municipality: 'Ibbenbüren',
    postalCode: '49477'
  },
  {
    municipality: 'Ibbenbüren',
    postalCode: '49479'
  },
  {
    municipality: 'Ichenhausen',
    postalCode: '89335'
  },
  {
    municipality: 'Icking',
    postalCode: '82057'
  },
  {
    municipality: 'Idar-Oberstein',
    postalCode: '55743'
  },
  {
    municipality: 'Idelberg',
    postalCode: '57612'
  },
  {
    municipality: 'Iden',
    postalCode: '39606'
  },
  {
    municipality: 'Idenheim',
    postalCode: '54636'
  },
  {
    municipality: 'Idesheim',
    postalCode: '54636'
  },
  {
    municipality: 'Idstedt',
    postalCode: '24879'
  },
  {
    municipality: 'Idstein',
    postalCode: '65510'
  },
  {
    municipality: 'Iffeldorf',
    postalCode: '82393'
  },
  {
    municipality: 'Iffezheim',
    postalCode: '76473'
  },
  {
    municipality: 'Igel',
    postalCode: '54298'
  },
  {
    municipality: 'Igensdorf',
    postalCode: '91338'
  },
  {
    municipality: 'Igersheim',
    postalCode: '97999'
  },
  {
    municipality: 'Iggensbach',
    postalCode: '94547'
  },
  {
    municipality: 'Iggingen',
    postalCode: '73574'
  },
  {
    municipality: 'Igling',
    postalCode: '86859'
  },
  {
    municipality: 'Ihlienworth',
    postalCode: '21775'
  },
  {
    municipality: 'Ihlow',
    postalCode: '15936'
  },
  {
    municipality: 'Ihlow',
    postalCode: '26632'
  },
  {
    municipality: 'Ihringen',
    postalCode: '79241'
  },
  {
    municipality: 'Ihrlerstein',
    postalCode: '93346'
  },
  {
    municipality: 'Ilberstedt',
    postalCode: '06408'
  },
  {
    municipality: 'Ilbesheim',
    postalCode: '67294'
  },
  {
    municipality: 'Ilbesheim bei Landau in der Pfalz',
    postalCode: '76831'
  },
  {
    municipality: 'Illerich',
    postalCode: '56814'
  },
  {
    municipality: 'Illerkirchberg',
    postalCode: '89171'
  },
  {
    municipality: 'Illerrieden',
    postalCode: '89186'
  },
  {
    municipality: 'Illertissen',
    postalCode: '89257'
  },
  {
    municipality: 'Illesheim',
    postalCode: '91471'
  },
  {
    municipality: 'Illingen',
    postalCode: '75428'
  },
  {
    municipality: 'Illingen',
    postalCode: '66557'
  },
  {
    municipality: 'Illmensee',
    postalCode: '88636'
  },
  {
    municipality: 'Illschwang',
    postalCode: '92278'
  },
  {
    municipality: 'Ilmenau',
    postalCode: '98693'
  },
  {
    municipality: 'Ilmenau',
    postalCode: '98694'
  },
  {
    municipality: 'Ilmmünster',
    postalCode: '85304'
  },
  {
    municipality: 'Ilmtal-Weinstraße',
    postalCode: '99510'
  },
  {
    municipality: 'Ilsede',
    postalCode: '31241'
  },
  {
    municipality: 'Ilsede',
    postalCode: '31246'
  },
  {
    municipality: 'Ilsenburg',
    postalCode: '38871'
  },
  {
    municipality: 'Ilsfeld',
    postalCode: '74360'
  },
  {
    municipality: 'Ilshofen',
    postalCode: '74532'
  },
  {
    municipality: 'Ilvesheim',
    postalCode: '68549'
  },
  {
    municipality: 'Immendingen',
    postalCode: '78194'
  },
  {
    municipality: 'Immenhausen',
    postalCode: '34376'
  },
  {
    municipality: 'Immenreuth',
    postalCode: '95505'
  },
  {
    municipality: 'Immenstaad am Bodensee',
    postalCode: '88090'
  },
  {
    municipality: 'Immenstadt im Allgäu',
    postalCode: '87509'
  },
  {
    municipality: 'Immenstedt',
    postalCode: '25767'
  },
  {
    municipality: 'Immenstedt',
    postalCode: '25885'
  },
  {
    municipality: 'Immerath',
    postalCode: '54552'
  },
  {
    municipality: 'Immert',
    postalCode: '54426'
  },
  {
    municipality: 'Immesheim',
    postalCode: '67308'
  },
  {
    municipality: 'Impflingen',
    postalCode: '76831'
  },
  {
    municipality: 'Imsbach',
    postalCode: '67725'
  },
  {
    municipality: 'Imsbach',
    postalCode: '67808'
  },
  {
    municipality: 'Imsbach',
    postalCode: '67817'
  },
  {
    municipality: 'Imsweiler',
    postalCode: '67806'
  },
  {
    municipality: 'Imsweiler',
    postalCode: '67808'
  },
  {
    municipality: 'Inchenhofen',
    postalCode: '86570'
  },
  {
    municipality: 'Inden',
    postalCode: '52459'
  },
  {
    municipality: 'Ingelbach',
    postalCode: '57610'
  },
  {
    municipality: 'Ingelfingen',
    postalCode: '74653'
  },
  {
    municipality: 'Ingelheim am Rhein',
    postalCode: '55218'
  },
  {
    municipality: 'Ingelheim am Rhein',
    postalCode: '55262'
  },
  {
    municipality: 'Ingelheim am Rhein',
    postalCode: '55263'
  },
  {
    municipality: 'Ingendorf',
    postalCode: '54636'
  },
  {
    municipality: 'Ingenried',
    postalCode: '86980'
  },
  {
    municipality: 'Ingersheim',
    postalCode: '74379'
  },
  {
    municipality: 'Ingersleben',
    postalCode: '39343'
  },
  {
    municipality: 'Ingoldingen',
    postalCode: '88456'
  },
  {
    municipality: 'Ingolstadt',
    postalCode: '85049'
  },
  {
    municipality: 'Ingolstadt',
    postalCode: '85051'
  },
  {
    municipality: 'Ingolstadt',
    postalCode: '85053'
  },
  {
    municipality: 'Ingolstadt',
    postalCode: '85055'
  },
  {
    municipality: 'Ingolstadt',
    postalCode: '85057'
  },
  {
    municipality: 'Innernzell',
    postalCode: '94548'
  },
  {
    municipality: 'Inning am Ammersee',
    postalCode: '82266'
  },
  {
    municipality: 'Inning am Holz',
    postalCode: '84416'
  },
  {
    municipality: 'Insel Hiddensee',
    postalCode: '18565'
  },
  {
    municipality: 'Insel Poel',
    postalCode: '23999'
  },
  {
    municipality: 'Insheim',
    postalCode: '76865'
  },
  {
    municipality: 'Insingen',
    postalCode: '91610'
  },
  {
    municipality: 'Insul',
    postalCode: '53520'
  },
  {
    municipality: 'Inzell',
    postalCode: '83334'
  },
  {
    municipality: 'Inzigkofen',
    postalCode: '72514'
  },
  {
    municipality: 'Inzlingen',
    postalCode: '79594'
  },
  {
    municipality: 'Iphofen',
    postalCode: '97346'
  },
  {
    municipality: 'Ippenschied',
    postalCode: '55566'
  },
  {
    municipality: 'Ippesheim',
    postalCode: '97258'
  },
  {
    municipality: 'Ipsheim',
    postalCode: '91472'
  },
  {
    municipality: 'Irchenrieth',
    postalCode: '92699'
  },
  {
    municipality: 'Irlbach',
    postalCode: '94342'
  },
  {
    municipality: 'Irmenach',
    postalCode: '56843'
  },
  {
    municipality: 'Irmtraut',
    postalCode: '56479'
  },
  {
    municipality: 'Irndorf',
    postalCode: '78597'
  },
  {
    municipality: 'Irrel',
    postalCode: '54666'
  },
  {
    municipality: 'Irrhausen',
    postalCode: '54689'
  },
  {
    municipality: 'Irsch',
    postalCode: '54451'
  },
  {
    municipality: 'Irschenberg',
    postalCode: '83737'
  },
  {
    municipality: 'Irsee',
    postalCode: '87660'
  },
  {
    municipality: 'Isen',
    postalCode: '84424'
  },
  {
    municipality: 'Isenburg',
    postalCode: '56271'
  },
  {
    municipality: 'Isenbüttel',
    postalCode: '38550'
  },
  {
    municipality: 'Iserlohn',
    postalCode: '58636'
  },
  {
    municipality: 'Iserlohn',
    postalCode: '58638'
  },
  {
    municipality: 'Iserlohn',
    postalCode: '58640'
  },
  {
    municipality: 'Iserlohn',
    postalCode: '58642'
  },
  {
    municipality: 'Iserlohn',
    postalCode: '58644'
  },
  {
    municipality: 'Isernhagen',
    postalCode: '30916'
  },
  {
    municipality: 'Isert',
    postalCode: '57612'
  },
  {
    municipality: 'Ismaning',
    postalCode: '85737'
  },
  {
    municipality: 'Isny im Allgäu',
    postalCode: '88316'
  },
  {
    municipality: 'Ispringen',
    postalCode: '75228'
  },
  {
    municipality: 'Isselbach',
    postalCode: '65558'
  },
  {
    municipality: 'Isselburg',
    postalCode: '46419'
  },
  {
    municipality: 'Issigau',
    postalCode: '95188'
  },
  {
    municipality: 'Issum',
    postalCode: '47661'
  },
  {
    municipality: 'Isterberg',
    postalCode: '48465'
  },
  {
    municipality: 'Itterbeck',
    postalCode: '49847'
  },
  {
    municipality: 'Ittlingen',
    postalCode: '74930'
  },
  {
    municipality: 'Itzehoe',
    postalCode: '25524'
  },
  {
    municipality: 'Itzgrund',
    postalCode: '96274'
  },
  {
    municipality: 'Itzstedt',
    postalCode: '23845'
  },
  {
    municipality: 'Iven',
    postalCode: '17391'
  },
  {
    municipality: 'Ivenack',
    postalCode: '17153'
  },
  {
    municipality: 'Jabel',
    postalCode: '17194'
  },
  {
    municipality: 'Jachenau',
    postalCode: '83676'
  },
  {
    municipality: 'Jacobsdorf',
    postalCode: '15236'
  },
  {
    municipality: 'Jade',
    postalCode: '26349'
  },
  {
    municipality: 'Jagel',
    postalCode: '24848'
  },
  {
    municipality: 'Jagel',
    postalCode: '24878'
  },
  {
    municipality: 'Jagsthausen',
    postalCode: '74249'
  },
  {
    municipality: 'Jagstzell',
    postalCode: '73489'
  },
  {
    municipality: 'Jahnsdorf/Erzgebirge',
    postalCode: '09387'
  },
  {
    municipality: 'Jahrsdorf',
    postalCode: '24594'
  },
  {
    municipality: 'Jakobsdorf',
    postalCode: '18442'
  },
  {
    municipality: 'Jakobsweiler',
    postalCode: '67814'
  },
  {
    municipality: 'Jameln',
    postalCode: '29479'
  },
  {
    municipality: 'Jamlitz',
    postalCode: '15868'
  },
  {
    municipality: 'Jämlitz-Klein Düben',
    postalCode: '03130'
  },
  {
    municipality: 'Jandelsbrunn',
    postalCode: '94118'
  },
  {
    municipality: 'Janneby',
    postalCode: '24992'
  },
  {
    municipality: 'Jänschwalde',
    postalCode: '03172'
  },
  {
    municipality: 'Jänschwalde',
    postalCode: '03197'
  },
  {
    municipality: 'Jardelund',
    postalCode: '24994'
  },
  {
    municipality: 'Jarmen',
    postalCode: '17126'
  },
  {
    municipality: 'Jatznick',
    postalCode: '17309'
  },
  {
    municipality: 'Jeckenbach',
    postalCode: '55592'
  },
  {
    municipality: 'Jelmstorf',
    postalCode: '29585'
  },
  {
    municipality: 'Jembke',
    postalCode: '38477'
  },
  {
    municipality: 'Jemgum',
    postalCode: '26844'
  },
  {
    municipality: 'Jena',
    postalCode: '07743'
  },
  {
    municipality: 'Jena',
    postalCode: '07745'
  },
  {
    municipality: 'Jena',
    postalCode: '07747'
  },
  {
    municipality: 'Jena',
    postalCode: '07749'
  },
  {
    municipality: 'Jena',
    postalCode: '07751'
  },
  {
    municipality: 'Jenalöbnitz',
    postalCode: '07751'
  },
  {
    municipality: 'Jengen',
    postalCode: '86860'
  },
  {
    municipality: 'Jerichow',
    postalCode: '39307'
  },
  {
    municipality: 'Jerichow',
    postalCode: '39319'
  },
  {
    municipality: 'Jerrishoe',
    postalCode: '24963'
  },
  {
    municipality: 'Jersbek',
    postalCode: '22941'
  },
  {
    municipality: 'Jerxheim',
    postalCode: '38381'
  },
  {
    municipality: 'Jesberg',
    postalCode: '34632'
  },
  {
    municipality: 'Jesendorf',
    postalCode: '19417'
  },
  {
    municipality: 'Jesenwang',
    postalCode: '82287'
  },
  {
    municipality: 'Jesewitz',
    postalCode: '04838'
  },
  {
    municipality: 'Jessen (Elster)',
    postalCode: '06917'
  },
  {
    municipality: 'Jesteburg',
    postalCode: '21266'
  },
  {
    municipality: 'Jestetten',
    postalCode: '79798'
  },
  {
    municipality: 'Jettenbach',
    postalCode: '84555'
  },
  {
    municipality: 'Jettenbach',
    postalCode: '66887'
  },
  {
    municipality: 'Jettingen',
    postalCode: '71131'
  },
  {
    municipality: 'Jettingen-Scheppach',
    postalCode: '89343'
  },
  {
    municipality: 'Jetzendorf',
    postalCode: '85305'
  },
  {
    municipality: 'Jevenstedt',
    postalCode: '24808'
  },
  {
    municipality: 'Jever',
    postalCode: '26441'
  },
  {
    municipality: 'Joachimsthal',
    postalCode: '16247'
  },
  {
    municipality: 'Jockgrim',
    postalCode: '76751'
  },
  {
    municipality: 'Johannesberg',
    postalCode: '63867'
  },
  {
    municipality: 'Johanngeorgenstadt',
    postalCode: '08349'
  },
  {
    municipality: 'Johanniskirchen',
    postalCode: '84381'
  },
  {
    municipality: 'Jöhstadt',
    postalCode: '09477'
  },
  {
    municipality: 'Joldelund',
    postalCode: '25862'
  },
  {
    municipality: 'Jonaswalde',
    postalCode: '04626'
  },
  {
    municipality: 'Jonsdorf',
    postalCode: '02796'
  },
  {
    municipality: 'Jördenstorf',
    postalCode: '17168'
  },
  {
    municipality: 'Jork',
    postalCode: '21635'
  },
  {
    municipality: 'Jörl',
    postalCode: '24992'
  },
  {
    municipality: 'Jossgrund',
    postalCode: '63637'
  },
  {
    municipality: 'Jübar',
    postalCode: '38489'
  },
  {
    municipality: 'Jübek',
    postalCode: '24855'
  },
  {
    municipality: 'Jüchen',
    postalCode: '41363'
  },
  {
    municipality: 'Jucken',
    postalCode: '54689'
  },
  {
    municipality: 'Jugenheim',
    postalCode: '55270'
  },
  {
    municipality: 'Jühnde',
    postalCode: '37127'
  },
  {
    municipality: 'Juist',
    postalCode: '26571'
  },
  {
    municipality: 'Julbach',
    postalCode: '84387'
  },
  {
    municipality: 'Jülich',
    postalCode: '52428'
  },
  {
    municipality: 'Juliusburg',
    postalCode: '21483'
  },
  {
    municipality: 'Jungingen',
    postalCode: '72417'
  },
  {
    municipality: 'Jünkerath',
    postalCode: '54584'
  },
  {
    municipality: 'Jürgenshagen',
    postalCode: '18246'
  },
  {
    municipality: 'Jürgenstorf',
    postalCode: '17153'
  },
  {
    municipality: 'Jüterbog',
    postalCode: '14913'
  },
  {
    municipality: 'Kaaks',
    postalCode: '25582'
  },
  {
    municipality: 'Kaarst',
    postalCode: '41564'
  },
  {
    municipality: 'Kabelhorst',
    postalCode: '23738'
  },
  {
    municipality: 'Kabelsketal',
    postalCode: '06184'
  },
  {
    municipality: 'Käbschütztal',
    postalCode: '01665'
  },
  {
    municipality: 'Kaden',
    postalCode: '56459'
  },
  {
    municipality: 'Kadenbach',
    postalCode: '56337'
  },
  {
    municipality: 'Kahla',
    postalCode: '07768'
  },
  {
    municipality: 'Kahl am Main',
    postalCode: '63796'
  },
  {
    municipality: 'Kaifenheim',
    postalCode: '56761'
  },
  {
    municipality: 'Kail',
    postalCode: '56829'
  },
  {
    municipality: 'Kaisborstel',
    postalCode: '25560'
  },
  {
    municipality: 'Kaiserpfalz',
    postalCode: '06642'
  },
  {
    municipality: 'Kaisersbach',
    postalCode: '73553'
  },
  {
    municipality: 'Kaisersbach',
    postalCode: '73642'
  },
  {
    municipality: 'Kaisersbach',
    postalCode: '73667'
  },
  {
    municipality: 'Kaisersesch',
    postalCode: '56759'
  },
  {
    municipality: 'Kaiserslautern',
    postalCode: '67655'
  },
  {
    municipality: 'Kaiserslautern',
    postalCode: '67657'
  },
  {
    municipality: 'Kaiserslautern',
    postalCode: '67659'
  },
  {
    municipality: 'Kaiserslautern',
    postalCode: '67661'
  },
  {
    municipality: 'Kaiserslautern',
    postalCode: '67663'
  },
  {
    municipality: 'Kaiser-Wilhelm-Koog',
    postalCode: '25709'
  },
  {
    municipality: 'Kaisheim',
    postalCode: '86687'
  },
  {
    municipality: 'Kakenstorf',
    postalCode: '21255'
  },
  {
    municipality: 'Kalbach',
    postalCode: '36148'
  },
  {
    municipality: 'Kalbe',
    postalCode: '27419'
  },
  {
    municipality: 'Kalbe (Milde)',
    postalCode: '39624'
  },
  {
    municipality: 'Kalbsrieth',
    postalCode: '06556'
  },
  {
    municipality: 'Kalchreuth',
    postalCode: '90562'
  },
  {
    municipality: 'Kalefeld',
    postalCode: '37589'
  },
  {
    municipality: 'Kalenborn',
    postalCode: '56759'
  },
  {
    municipality: 'Kalenborn',
    postalCode: '53505'
  },
  {
    municipality: 'Kalenborn-Scheuern',
    postalCode: '54570'
  },
  {
    municipality: 'Kalkar',
    postalCode: '47546'
  },
  {
    municipality: 'Kalkhorst',
    postalCode: '23942'
  },
  {
    municipality: 'Kalkhorst',
    postalCode: '23948'
  },
  {
    municipality: 'Kalkofen',
    postalCode: '67822'
  },
  {
    municipality: 'Kall',
    postalCode: '53925'
  },
  {
    municipality: 'Kalletal',
    postalCode: '32689'
  },
  {
    municipality: 'Kallmünz',
    postalCode: '93183'
  },
  {
    municipality: 'Kallstadt',
    postalCode: '67169'
  },
  {
    municipality: 'Kalt',
    postalCode: '56294'
  },
  {
    municipality: 'Kaltenborn',
    postalCode: '53520'
  },
  {
    municipality: 'Kaltenengers',
    postalCode: '56220'
  },
  {
    municipality: 'Kaltenholzhausen',
    postalCode: '65558'
  },
  {
    municipality: 'Kaltenkirchen',
    postalCode: '24568'
  },
  {
    municipality: 'Kaltennordheim',
    postalCode: '36452'
  },
  {
    municipality: 'Kaltental',
    postalCode: '87662'
  },
  {
    municipality: 'Kalübbe',
    postalCode: '24326'
  },
  {
    municipality: 'Kamen',
    postalCode: '59174'
  },
  {
    municipality: 'Kamenz - Kamjenc',
    postalCode: '01917'
  },
  {
    municipality: 'Kamern',
    postalCode: '39524'
  },
  {
    municipality: 'Kammeltal',
    postalCode: '89358'
  },
  {
    municipality: 'Kammerforst',
    postalCode: '56206'
  },
  {
    municipality: 'Kammerforst',
    postalCode: '99986'
  },
  {
    municipality: 'Kammerstein',
    postalCode: '91126'
  },
  {
    municipality: 'Kamminke',
    postalCode: '17419'
  },
  {
    municipality: 'Kammlach',
    postalCode: '87754'
  },
  {
    municipality: 'Kamp-Bornhofen',
    postalCode: '56341'
  },
  {
    municipality: 'Kampen (Sylt)',
    postalCode: '25999'
  },
  {
    municipality: 'Kämpfelbach',
    postalCode: '75236'
  },
  {
    municipality: 'Kamp-Lintfort',
    postalCode: '47475'
  },
  {
    municipality: 'Kandel',
    postalCode: '76870'
  },
  {
    municipality: 'Kandern',
    postalCode: '79400'
  },
  {
    municipality: 'Kankelau',
    postalCode: '21514'
  },
  {
    municipality: 'Kanzach',
    postalCode: '88422'
  },
  {
    municipality: 'Kanzem',
    postalCode: '54441'
  },
  {
    municipality: 'Kapellendorf',
    postalCode: '99510'
  },
  {
    municipality: 'Kapellen-Drusweiler',
    postalCode: '76889'
  },
  {
    municipality: 'Kaperich',
    postalCode: '56767'
  },
  {
    municipality: 'Kappel',
    postalCode: '55483'
  },
  {
    municipality: 'Kappel-Grafenhausen',
    postalCode: '77966'
  },
  {
    municipality: 'Kappeln',
    postalCode: '24376'
  },
  {
    municipality: 'Kappeln',
    postalCode: '24404'
  },
  {
    municipality: 'Kappeln',
    postalCode: '67744'
  },
  {
    municipality: 'Kappelrodeck',
    postalCode: '77876'
  },
  {
    municipality: 'Kapsweyer',
    postalCode: '76889'
  },
  {
    municipality: 'Karbach',
    postalCode: '97842'
  },
  {
    municipality: 'Karbach',
    postalCode: '56281'
  },
  {
    municipality: 'Karben',
    postalCode: '61184'
  },
  {
    municipality: 'Karby',
    postalCode: '24398'
  },
  {
    municipality: 'Karenz',
    postalCode: '19294'
  },
  {
    municipality: 'Kargow',
    postalCode: '17192'
  },
  {
    municipality: 'Karl',
    postalCode: '54534'
  },
  {
    municipality: 'Karlsbad',
    postalCode: '76307'
  },
  {
    municipality: 'Karlsburg',
    postalCode: '17495'
  },
  {
    municipality: 'Karlsdorf',
    postalCode: '07646'
  },
  {
    municipality: 'Karlsdorf-Neuthard',
    postalCode: '76689'
  },
  {
    municipality: 'Karlsfeld',
    postalCode: '85757'
  },
  {
    municipality: 'Karlshagen',
    postalCode: '17449'
  },
  {
    municipality: 'Karlshausen',
    postalCode: '54673'
  },
  {
    municipality: 'Karlshuld',
    postalCode: '86668'
  },
  {
    municipality: 'Karlskron',
    postalCode: '85123'
  },
  {
    municipality: 'Karlsruhe',
    postalCode: '76131'
  },
  {
    municipality: 'Karlsruhe',
    postalCode: '76133'
  },
  {
    municipality: 'Karlsruhe',
    postalCode: '76135'
  },
  {
    municipality: 'Karlsruhe',
    postalCode: '76137'
  },
  {
    municipality: 'Karlsruhe',
    postalCode: '76139'
  },
  {
    municipality: 'Karlsruhe',
    postalCode: '76149'
  },
  {
    municipality: 'Karlsruhe',
    postalCode: '76185'
  },
  {
    municipality: 'Karlsruhe',
    postalCode: '76187'
  },
  {
    municipality: 'Karlsruhe',
    postalCode: '76189'
  },
  {
    municipality: 'Karlsruhe',
    postalCode: '76199'
  },
  {
    municipality: 'Karlsruhe',
    postalCode: '76227'
  },
  {
    municipality: 'Karlsruhe',
    postalCode: '76228'
  },
  {
    municipality: 'Karlsruhe',
    postalCode: '76229'
  },
  {
    municipality: 'Karlstadt',
    postalCode: '97753'
  },
  {
    municipality: 'Karlstein am Main',
    postalCode: '63791'
  },
  {
    municipality: 'Karlum',
    postalCode: '25926'
  },
  {
    municipality: 'Karnin',
    postalCode: '18469'
  },
  {
    municipality: 'Karolinenkoog',
    postalCode: '25774'
  },
  {
    municipality: 'Karrenzin',
    postalCode: '19372'
  },
  {
    municipality: 'Karsbach',
    postalCode: '97783'
  },
  {
    municipality: 'Karsdorf',
    postalCode: '06638'
  },
  {
    municipality: 'Karstädt',
    postalCode: '19357'
  },
  {
    municipality: 'Karstädt',
    postalCode: '19294'
  },
  {
    municipality: 'Karwitz',
    postalCode: '29481'
  },
  {
    municipality: 'Kasbach-Ohlenberg',
    postalCode: '53547'
  },
  {
    municipality: 'Kaschenbach',
    postalCode: '54668'
  },
  {
    municipality: 'Kasdorf',
    postalCode: '56357'
  },
  {
    municipality: 'Kasel',
    postalCode: '54317'
  },
  {
    municipality: 'Kasel-Golzig',
    postalCode: '15938'
  },
  {
    municipality: 'Kasendorf',
    postalCode: '95359'
  },
  {
    municipality: 'Käshofen',
    postalCode: '66894'
  },
  {
    municipality: 'Kasseburg',
    postalCode: '22929'
  },
  {
    municipality: 'Kasseedorf',
    postalCode: '23717'
  },
  {
    municipality: 'Kassel',
    postalCode: '34117'
  },
  {
    municipality: 'Kassel',
    postalCode: '34119'
  },
  {
    municipality: 'Kassel',
    postalCode: '34121'
  },
  {
    municipality: 'Kassel',
    postalCode: '34123'
  },
  {
    municipality: 'Kassel',
    postalCode: '34125'
  },
  {
    municipality: 'Kassel',
    postalCode: '34127'
  },
  {
    municipality: 'Kassel',
    postalCode: '34128'
  },
  {
    municipality: 'Kassel',
    postalCode: '34130'
  },
  {
    municipality: 'Kassel',
    postalCode: '34131'
  },
  {
    municipality: 'Kassel',
    postalCode: '34132'
  },
  {
    municipality: 'Kassel',
    postalCode: '34134'
  },
  {
    municipality: 'Kassel',
    postalCode: '34233'
  },
  {
    municipality: 'Kassel',
    postalCode: '34355'
  },
  {
    municipality: 'Kassow',
    postalCode: '18258'
  },
  {
    municipality: 'Kastellaun',
    postalCode: '56288'
  },
  {
    municipality: 'Kastel-Staadt',
    postalCode: '54441'
  },
  {
    municipality: 'Kastl',
    postalCode: '84556'
  },
  {
    municipality: 'Kastl',
    postalCode: '95506'
  },
  {
    municipality: 'Kastl',
    postalCode: '92280'
  },
  {
    municipality: 'Kastorf',
    postalCode: '23847'
  },
  {
    municipality: 'Katharinenheerd',
    postalCode: '25836'
  },
  {
    municipality: 'Katlenburg-Lindau',
    postalCode: '37191'
  },
  {
    municipality: 'Kattendorf',
    postalCode: '24568'
  },
  {
    municipality: 'Katzenbach',
    postalCode: '67806'
  },
  {
    municipality: 'Katzenelnbogen',
    postalCode: '56368'
  },
  {
    municipality: 'Katzhütte',
    postalCode: '98746'
  },
  {
    municipality: 'Katzow',
    postalCode: '17509'
  },
  {
    municipality: 'Katzweiler',
    postalCode: '67734'
  },
  {
    municipality: 'Katzwinkel',
    postalCode: '54552'
  },
  {
    municipality: 'Katzwinkel (Sieg)',
    postalCode: '57581'
  },
  {
    municipality: 'Kaub',
    postalCode: '56349'
  },
  {
    municipality: 'Kauern',
    postalCode: '07554'
  },
  {
    municipality: 'Kaufbeuren',
    postalCode: '87600'
  },
  {
    municipality: 'Kaufering',
    postalCode: '86916'
  },
  {
    municipality: 'Kaufungen',
    postalCode: '34260'
  },
  {
    municipality: 'Kaulsdorf',
    postalCode: '07338'
  },
  {
    municipality: 'Kausen',
    postalCode: '57520'
  },
  {
    municipality: 'Kayhude',
    postalCode: '23863'
  },
  {
    municipality: 'Kefenrod',
    postalCode: '63699'
  },
  {
    municipality: 'Kehl',
    postalCode: '77694'
  },
  {
    municipality: 'Kehlbach',
    postalCode: '56355'
  },
  {
    municipality: 'Kehmstedt',
    postalCode: '99752'
  },
  {
    municipality: 'Kehrig',
    postalCode: '56729'
  },
  {
    municipality: 'Keidelheim',
    postalCode: '55471'
  },
  {
    municipality: 'Keila',
    postalCode: '07389'
  },
  {
    municipality: 'Kelberg',
    postalCode: '53539'
  },
  {
    municipality: 'Kelbra (Kyffhäuser)',
    postalCode: '06537'
  },
  {
    municipality: 'Kelheim',
    postalCode: '93309'
  },
  {
    municipality: 'Kelkheim',
    postalCode: '65779'
  },
  {
    municipality: 'Kella',
    postalCode: '37308'
  },
  {
    municipality: 'Kell am See',
    postalCode: '54427'
  },
  {
    municipality: 'Kellenbach',
    postalCode: '55606'
  },
  {
    municipality: 'Kellenhusen',
    postalCode: '23746'
  },
  {
    municipality: 'Kellinghusen',
    postalCode: '25548'
  },
  {
    municipality: 'Kellmünz a.d.Iller',
    postalCode: '89293'
  },
  {
    municipality: 'Kelsterbach',
    postalCode: '65451'
  },
  {
    municipality: 'Keltern',
    postalCode: '75210'
  },
  {
    municipality: 'Kemberg',
    postalCode: '06901'
  },
  {
    municipality: 'Kemmenau',
    postalCode: '56132'
  },
  {
    municipality: 'Kemmern',
    postalCode: '96164'
  },
  {
    municipality: 'Kemnath',
    postalCode: '95478'
  },
  {
    municipality: 'Kemnitz',
    postalCode: '17509'
  },
  {
    municipality: 'Kempen',
    postalCode: '47906'
  },
  {
    municipality: 'Kempenich',
    postalCode: '56746'
  },
  {
    municipality: 'Kempfeld',
    postalCode: '55758'
  },
  {
    municipality: 'Kempten (Allgäu)',
    postalCode: '87435'
  },
  {
    municipality: 'Kempten (Allgäu)',
    postalCode: '87437'
  },
  {
    municipality: 'Kempten (Allgäu)',
    postalCode: '87439'
  },
  {
    municipality: 'Kenn',
    postalCode: '54344'
  },
  {
    municipality: 'Kentzlin',
    postalCode: '17111'
  },
  {
    municipality: 'Kenzingen',
    postalCode: '79341'
  },
  {
    municipality: 'Kenz-Küstrow',
    postalCode: '18314'
  },
  {
    municipality: 'Keppeshausen',
    postalCode: '54673'
  },
  {
    municipality: 'Kerben',
    postalCode: '56295'
  },
  {
    municipality: 'Kerken',
    postalCode: '47647'
  },
  {
    municipality: 'Kernen im Remstal',
    postalCode: '71394'
  },
  {
    municipality: 'Kerpen',
    postalCode: '50169'
  },
  {
    municipality: 'Kerpen',
    postalCode: '50170'
  },
  {
    municipality: 'Kerpen',
    postalCode: '50171'
  },
  {
    municipality: 'Kerpen (Eifel)',
    postalCode: '54578'
  },
  {
    municipality: 'Kerschenbach',
    postalCode: '54589'
  },
  {
    municipality: 'Kerzenheim',
    postalCode: '67304'
  },
  {
    municipality: 'Kescheid',
    postalCode: '57632'
  },
  {
    municipality: 'Kesfeld',
    postalCode: '54619'
  },
  {
    municipality: 'Kesseling',
    postalCode: '53506'
  },
  {
    municipality: 'Kesten',
    postalCode: '54518'
  },
  {
    municipality: 'Kestert',
    postalCode: '56348'
  },
  {
    municipality: 'Ketsch',
    postalCode: '68775'
  },
  {
    municipality: 'Kettenhausen',
    postalCode: '57612'
  },
  {
    municipality: 'Kettenheim',
    postalCode: '55234'
  },
  {
    municipality: 'Kettenkamp',
    postalCode: '49577'
  },
  {
    municipality: 'Kettershausen',
    postalCode: '86498'
  },
  {
    municipality: 'Kettig',
    postalCode: '56220'
  },
  {
    municipality: 'Ketzin/Havel',
    postalCode: '14669'
  },
  {
    municipality: 'Kevelaer',
    postalCode: '47623'
  },
  {
    municipality: 'Kevelaer',
    postalCode: '47624'
  },
  {
    municipality: 'Kevelaer',
    postalCode: '47625'
  },
  {
    municipality: 'Kevelaer',
    postalCode: '47626'
  },
  {
    municipality: 'Kevelaer',
    postalCode: '47627'
  },
  {
    municipality: 'Kickeshausen',
    postalCode: '54689'
  },
  {
    municipality: 'Kiebitzreihe',
    postalCode: '25368'
  },
  {
    municipality: 'Kiedrich',
    postalCode: '65399'
  },
  {
    municipality: 'Kiefersfelden',
    postalCode: '83088'
  },
  {
    municipality: 'Kiel',
    postalCode: '24103'
  },
  {
    municipality: 'Kiel',
    postalCode: '24105'
  },
  {
    municipality: 'Kiel',
    postalCode: '24106'
  },
  {
    municipality: 'Kiel',
    postalCode: '24107'
  },
  {
    municipality: 'Kiel',
    postalCode: '24109'
  },
  {
    municipality: 'Kiel',
    postalCode: '24111'
  },
  {
    municipality: 'Kiel',
    postalCode: '24113'
  },
  {
    municipality: 'Kiel',
    postalCode: '24114'
  },
  {
    municipality: 'Kiel',
    postalCode: '24116'
  },
  {
    municipality: 'Kiel',
    postalCode: '24118'
  },
  {
    municipality: 'Kiel',
    postalCode: '24143'
  },
  {
    municipality: 'Kiel',
    postalCode: '24145'
  },
  {
    municipality: 'Kiel',
    postalCode: '24146'
  },
  {
    municipality: 'Kiel',
    postalCode: '24147'
  },
  {
    municipality: 'Kiel',
    postalCode: '24148'
  },
  {
    municipality: 'Kiel',
    postalCode: '24149'
  },
  {
    municipality: 'Kiel',
    postalCode: '24159'
  },
  {
    municipality: 'Kienberg',
    postalCode: '83361'
  },
  {
    municipality: 'Kierspe',
    postalCode: '58566'
  },
  {
    municipality: 'Kieselbronn',
    postalCode: '75249'
  },
  {
    municipality: 'Kieve',
    postalCode: '17209'
  },
  {
    municipality: 'Kiliansroda',
    postalCode: '99441'
  },
  {
    municipality: 'Kindelbrück',
    postalCode: '06578'
  },
  {
    municipality: 'Kindelbrück',
    postalCode: '99638'
  },
  {
    municipality: 'Kindenheim',
    postalCode: '67271'
  },
  {
    municipality: 'Kinderbeuern',
    postalCode: '54538'
  },
  {
    municipality: 'Kinding',
    postalCode: '85125'
  },
  {
    municipality: 'Kindsbach',
    postalCode: '66862'
  },
  {
    municipality: 'Kinheim',
    postalCode: '54538'
  },
  {
    municipality: 'Kinsau',
    postalCode: '86981'
  },
  {
    municipality: 'Kinzenburg',
    postalCode: '54597'
  },
  {
    municipality: 'Kipfenberg',
    postalCode: '85110'
  },
  {
    municipality: 'Kippenheim',
    postalCode: '77971'
  },
  {
    municipality: 'Kirburg',
    postalCode: '57629'
  },
  {
    municipality: 'Kirchanschöring',
    postalCode: '83329'
  },
  {
    municipality: 'Kirchanschöring',
    postalCode: '83417'
  },
  {
    municipality: 'Kirchardt',
    postalCode: '74912'
  },
  {
    municipality: 'Kirchbarkau',
    postalCode: '24245'
  },
  {
    municipality: 'Kirchberg',
    postalCode: '08107'
  },
  {
    municipality: 'Kirchberg',
    postalCode: '55481'
  },
  {
    municipality: 'Kirchberg',
    postalCode: '84434'
  },
  {
    municipality: 'Kirchberg an der Iller',
    postalCode: '88486'
  },
  {
    municipality: 'Kirchberg an der Jagst',
    postalCode: '74592'
  },
  {
    municipality: 'Kirchberg an der Murr',
    postalCode: '71737'
  },
  {
    municipality: 'Kirchberg i.Wald',
    postalCode: '94259'
  },
  {
    municipality: 'Kirchbrak',
    postalCode: '37619'
  },
  {
    municipality: 'Kirchdorf',
    postalCode: '83527'
  },
  {
    municipality: 'Kirchdorf',
    postalCode: '93348'
  },
  {
    municipality: 'Kirchdorf',
    postalCode: '27245'
  },
  {
    municipality: 'Kirchdorf am Inn',
    postalCode: '84375'
  },
  {
    municipality: 'Kirchdorf an der Amper',
    postalCode: '85414'
  },
  {
    municipality: 'Kirchdorf an der Iller',
    postalCode: '88457'
  },
  {
    municipality: 'Kirchdorf im Wald',
    postalCode: '94261'
  },
  {
    municipality: 'Kirchehrenbach',
    postalCode: '91356'
  },
  {
    municipality: 'Kircheib',
    postalCode: '57635'
  },
  {
    municipality: 'Kirchendemenreuth',
    postalCode: '92665'
  },
  {
    municipality: 'Kirchenlamitz',
    postalCode: '95158'
  },
  {
    municipality: 'Kirchenpingarten',
    postalCode: '95466'
  },
  {
    municipality: 'Kirchen (Sieg)',
    postalCode: '57548'
  },
  {
    municipality: 'Kirchensittenbach',
    postalCode: '91241'
  },
  {
    municipality: 'Kirchentellinsfurt',
    postalCode: '72138'
  },
  {
    municipality: 'Kirchenthumbach',
    postalCode: '91281'
  },
  {
    municipality: 'Kirchgandern',
    postalCode: '37318'
  },
  {
    municipality: 'Kirchgellersen',
    postalCode: '21394'
  },
  {
    municipality: 'Kirchhain',
    postalCode: '35274'
  },
  {
    municipality: 'Kirchham',
    postalCode: '94148'
  },
  {
    municipality: 'Kirchhaslach',
    postalCode: '87755'
  },
  {
    municipality: 'Kirchheilingen',
    postalCode: '99947'
  },
  {
    municipality: 'Kirchheim',
    postalCode: '97268'
  },
  {
    municipality: 'Kirchheim',
    postalCode: '36275'
  },
  {
    municipality: 'Kirchheim am Neckar',
    postalCode: '74366'
  },
  {
    municipality: 'Kirchheim am Ries',
    postalCode: '73467'
  },
  {
    municipality: 'Kirchheim an der Weinstraße',
    postalCode: '67281'
  },
  {
    municipality: 'Kirchheim bei München',
    postalCode: '85551'
  },
  {
    municipality: 'Kirchheimbolanden',
    postalCode: '67292'
  },
  {
    municipality: 'Kirchheim in Schwaben',
    postalCode: '87757'
  },
  {
    municipality: 'Kirchheim unter Teck',
    postalCode: '73230'
  },
  {
    municipality: 'Kirchhundem',
    postalCode: '57399'
  },
  {
    municipality: 'Kirch Jesar',
    postalCode: '19230'
  },
  {
    municipality: 'Kirchlauter',
    postalCode: '96166'
  },
  {
    municipality: 'Kirchlengern',
    postalCode: '32278'
  },
  {
    municipality: 'Kirchlinteln',
    postalCode: '27308'
  },
  {
    municipality: 'Kirchnüchel',
    postalCode: '23714'
  },
  {
    municipality: 'Kirchroth',
    postalCode: '94356'
  },
  {
    municipality: 'Kirchsahr',
    postalCode: '53505'
  },
  {
    municipality: 'Kirchseelte',
    postalCode: '27243'
  },
  {
    municipality: 'Kirchseeon',
    postalCode: '85614'
  },
  {
    municipality: 'Kirchspiel Garding',
    postalCode: '25836'
  },
  {
    municipality: 'Kirchtimke',
    postalCode: '27412'
  },
  {
    municipality: 'Kirchwald',
    postalCode: '56729'
  },
  {
    municipality: 'Kirchwalsede',
    postalCode: '27386'
  },
  {
    municipality: 'Kirchweidach',
    postalCode: '84558'
  },
  {
    municipality: 'Kirchweiler',
    postalCode: '54570'
  },
  {
    municipality: 'Kirchworbis',
    postalCode: '37339'
  },
  {
    municipality: 'Kirchzarten',
    postalCode: '79199'
  },
  {
    municipality: 'Kirchzell',
    postalCode: '63931'
  },
  {
    municipality: 'Kirf',
    postalCode: '54441'
  },
  {
    municipality: 'Kirkel',
    postalCode: '66459'
  },
  {
    municipality: 'Kirn',
    postalCode: '55606'
  },
  {
    municipality: 'Kirrweiler',
    postalCode: '67744'
  },
  {
    municipality: 'Kirrweiler',
    postalCode: '67489'
  },
  {
    municipality: 'Kirsbach',
    postalCode: '53539'
  },
  {
    municipality: 'Kirschkau',
    postalCode: '07919'
  },
  {
    municipality: 'Kirschroth',
    postalCode: '55566'
  },
  {
    municipality: 'Kirschweiler',
    postalCode: '55743'
  },
  {
    municipality: 'Kirtorf',
    postalCode: '36320'
  },
  {
    municipality: 'Kisdorf',
    postalCode: '24629'
  },
  {
    municipality: 'Kisselbach',
    postalCode: '56291'
  },
  {
    municipality: 'Kissenbrück',
    postalCode: '38324'
  },
  {
    municipality: 'Kissing',
    postalCode: '86438'
  },
  {
    municipality: 'Kißlegg',
    postalCode: '88353'
  },
  {
    municipality: 'Kist',
    postalCode: '97270'
  },
  {
    municipality: 'Kittendorf',
    postalCode: '17153'
  },
  {
    municipality: 'Kittlitz',
    postalCode: '23911'
  },
  {
    municipality: 'Kitzingen',
    postalCode: '97318'
  },
  {
    municipality: 'Kitzscher',
    postalCode: '04567'
  },
  {
    municipality: 'Klamp',
    postalCode: '24321'
  },
  {
    municipality: 'Klanxbüll',
    postalCode: '25924'
  },
  {
    municipality: 'Klappholz',
    postalCode: '24860'
  },
  {
    municipality: 'Klausdorf',
    postalCode: '18445'
  },
  {
    municipality: 'Klausen',
    postalCode: '54524'
  },
  {
    municipality: 'Kleinaitingen',
    postalCode: '86507'
  },
  {
    municipality: 'Klein Barkau',
    postalCode: '24245'
  },
  {
    municipality: 'Klein Belitz',
    postalCode: '18246'
  },
  {
    municipality: 'Klein Bennebek',
    postalCode: '24848'
  },
  {
    municipality: 'Klein Bennebek',
    postalCode: '24863'
  },
  {
    municipality: 'Klein Berßen',
    postalCode: '49777'
  },
  {
    municipality: 'Kleinblittersdorf',
    postalCode: '66271'
  },
  {
    municipality: 'Kleinbockedra',
    postalCode: '07646'
  },
  {
    municipality: 'Kleinbundenbach',
    postalCode: '66501'
  },
  {
    municipality: 'Klein Bünzow',
    postalCode: '17390'
  },
  {
    municipality: 'Kleinebersdorf',
    postalCode: '07646'
  },
  {
    municipality: 'Kleines Wiesental',
    postalCode: '79692'
  },
  {
    municipality: 'Kleineutersdorf',
    postalCode: '07768'
  },
  {
    municipality: 'Kleinfischlingen',
    postalCode: '67483'
  },
  {
    municipality: 'Kleinfurra',
    postalCode: '99735'
  },
  {
    municipality: 'Klein Gladebrügge',
    postalCode: '23795'
  },
  {
    municipality: 'Kleinheubach',
    postalCode: '63924'
  },
  {
    municipality: 'Kleinich',
    postalCode: '54483'
  },
  {
    municipality: 'Kleinkahl',
    postalCode: '63828'
  },
  {
    municipality: 'Kleinkarlbach',
    postalCode: '67271'
  },
  {
    municipality: 'Kleinlangenfeld',
    postalCode: '54597'
  },
  {
    municipality: 'Kleinlangheim',
    postalCode: '97355'
  },
  {
    municipality: 'Kleinmachnow',
    postalCode: '14532'
  },
  {
    municipality: 'Kleinmaischeid',
    postalCode: '56271'
  },
  {
    municipality: 'Klein Meckelsen',
    postalCode: '27419'
  },
  {
    municipality: 'Kleinmölsen',
    postalCode: '99198'
  },
  {
    municipality: 'Kleinneuhausen',
    postalCode: '99625'
  },
  {
    municipality: 'Kleinniedesheim',
    postalCode: '67259'
  },
  {
    municipality: 'Klein Nordende',
    postalCode: '25336'
  },
  {
    municipality: 'Klein Offenseth-Sparrieshoop',
    postalCode: '25365'
  },
  {
    municipality: 'Kleinostheim',
    postalCode: '63801'
  },
  {
    municipality: 'Klein Pampau',
    postalCode: '21514'
  },
  {
    municipality: 'Klein Rheide',
    postalCode: '24848'
  },
  {
    municipality: 'Kleinrinderfeld',
    postalCode: '97271'
  },
  {
    municipality: 'Klein Rogahn',
    postalCode: '19073'
  },
  {
    municipality: 'Klein Rönnau',
    postalCode: '23795'
  },
  {
    municipality: 'Kleinschwabhausen',
    postalCode: '99441'
  },
  {
    municipality: 'Kleinsendelbach',
    postalCode: '91077'
  },
  {
    municipality: 'Kleinsteinhausen',
    postalCode: '66484'
  },
  {
    municipality: 'Klein Trebbow',
    postalCode: '19069'
  },
  {
    municipality: 'Klein Upahl',
    postalCode: '18276'
  },
  {
    municipality: 'Klein Vielen',
    postalCode: '17237'
  },
  {
    municipality: 'Kleinwallstadt',
    postalCode: '63839'
  },
  {
    municipality: 'Klein Wesenberg',
    postalCode: '23860'
  },
  {
    municipality: 'Klein-Winternheim',
    postalCode: '55270'
  },
  {
    municipality: 'Klein Wittensee',
    postalCode: '24361'
  },
  {
    municipality: 'Klein Zecher',
    postalCode: '23883'
  },
  {
    municipality: 'Klempau',
    postalCode: '23628'
  },
  {
    municipality: 'Kleßen-Görne',
    postalCode: '14728'
  },
  {
    municipality: 'Kletkamp',
    postalCode: '24327'
  },
  {
    municipality: 'Klettbach',
    postalCode: '99102'
  },
  {
    municipality: 'Klettgau',
    postalCode: '79771'
  },
  {
    municipality: 'Kletzin',
    postalCode: '17111'
  },
  {
    municipality: 'Kleve',
    postalCode: '47533'
  },
  {
    municipality: 'Kleve',
    postalCode: '25554'
  },
  {
    municipality: 'Kleve',
    postalCode: '25776'
  },
  {
    municipality: 'Kleve',
    postalCode: '25779'
  },
  {
    municipality: 'Kliding',
    postalCode: '56825'
  },
  {
    municipality: 'Klietz',
    postalCode: '39524'
  },
  {
    municipality: 'Klingelbach',
    postalCode: '56368'
  },
  {
    municipality: 'Klingenberg',
    postalCode: '01774'
  },
  {
    municipality: 'Klingenberg am Main',
    postalCode: '63911'
  },
  {
    municipality: 'Klingenmünster',
    postalCode: '76889'
  },
  {
    municipality: 'Klingenthal',
    postalCode: '08248'
  },
  {
    municipality: 'Klingenthal',
    postalCode: '08267'
  },
  {
    municipality: 'Klink',
    postalCode: '17192'
  },
  {
    municipality: 'Klinkrade',
    postalCode: '23898'
  },
  {
    municipality: 'Klipphausen',
    postalCode: '01665'
  },
  {
    municipality: 'Klixbüll',
    postalCode: '25899'
  },
  {
    municipality: 'Klocksin',
    postalCode: '17194'
  },
  {
    municipality: 'Klosterkumbd',
    postalCode: '55469'
  },
  {
    municipality: 'Klosterlechfeld',
    postalCode: '86836'
  },
  {
    municipality: 'Kloster Lehnin',
    postalCode: '14797'
  },
  {
    municipality: 'Klostermansfeld',
    postalCode: '06308'
  },
  {
    municipality: 'Kloster Tempzin',
    postalCode: '19412'
  },
  {
    municipality: 'Kloster Veßra',
    postalCode: '98660'
  },
  {
    municipality: 'Klotten',
    postalCode: '56818'
  },
  {
    municipality: 'Klötze',
    postalCode: '38486'
  },
  {
    municipality: 'Kludenbach',
    postalCode: '55481'
  },
  {
    municipality: 'Kluis',
    postalCode: '18569'
  },
  {
    municipality: 'Kluse',
    postalCode: '26892'
  },
  {
    municipality: 'Klüsserath',
    postalCode: '54340'
  },
  {
    municipality: 'Klütz',
    postalCode: '23946'
  },
  {
    municipality: 'Klütz',
    postalCode: '23948'
  },
  {
    municipality: 'Kneese',
    postalCode: '19205'
  },
  {
    municipality: 'Kneitlingen',
    postalCode: '38170'
  },
  {
    municipality: 'Knetzgau',
    postalCode: '97478'
  },
  {
    municipality: 'Knittelsheim',
    postalCode: '76879'
  },
  {
    municipality: 'Knittlingen',
    postalCode: '75438'
  },
  {
    municipality: 'Knopp-Labach',
    postalCode: '66917'
  },
  {
    municipality: 'Knöringen',
    postalCode: '76833'
  },
  {
    municipality: 'Knorrendorf',
    postalCode: '17091'
  },
  {
    municipality: 'Knüllwald',
    postalCode: '34593'
  },
  {
    municipality: 'Koberg',
    postalCode: '23881'
  },
  {
    municipality: 'Kobern-Gondorf',
    postalCode: '56330'
  },
  {
    municipality: 'Koblentz',
    postalCode: '17309'
  },
  {
    municipality: 'Koblenz',
    postalCode: '56068'
  },
  {
    municipality: 'Koblenz',
    postalCode: '56070'
  },
  {
    municipality: 'Koblenz',
    postalCode: '56072'
  },
  {
    municipality: 'Koblenz',
    postalCode: '56073'
  },
  {
    municipality: 'Koblenz',
    postalCode: '56075'
  },
  {
    municipality: 'Koblenz',
    postalCode: '56076'
  },
  {
    municipality: 'Koblenz',
    postalCode: '56077'
  },
  {
    municipality: 'Kobrow',
    postalCode: '19406'
  },
  {
    municipality: 'Kochel am See',
    postalCode: '82431'
  },
  {
    municipality: 'Kochel am See',
    postalCode: '82432'
  },
  {
    municipality: 'Kodersdorf',
    postalCode: '02923'
  },
  {
    municipality: 'Köditz',
    postalCode: '95189'
  },
  {
    municipality: 'Ködnitz',
    postalCode: '95361'
  },
  {
    municipality: 'Köfering',
    postalCode: '93096'
  },
  {
    municipality: 'Kogel',
    postalCode: '19246'
  },
  {
    municipality: 'Kohlberg',
    postalCode: '92702'
  },
  {
    municipality: 'Kohlberg',
    postalCode: '72664'
  },
  {
    municipality: 'Köhn',
    postalCode: '24257'
  },
  {
    municipality: 'Kolbermoor',
    postalCode: '83059'
  },
  {
    municipality: 'Kolbingen',
    postalCode: '78600'
  },
  {
    municipality: 'Kölbingen',
    postalCode: '56459'
  },
  {
    municipality: 'Koldenbüttel',
    postalCode: '25840'
  },
  {
    municipality: 'Kolitzheim',
    postalCode: '97509'
  },
  {
    municipality: 'Kolkerheide',
    postalCode: '25862'
  },
  {
    municipality: 'Kolkwitz',
    postalCode: '03099'
  },
  {
    municipality: 'Kölleda',
    postalCode: '99625'
  },
  {
    municipality: 'Kollig',
    postalCode: '56751'
  },
  {
    municipality: 'Kollmar',
    postalCode: '25377'
  },
  {
    municipality: 'Kollmoor',
    postalCode: '25524'
  },
  {
    municipality: 'Kollnburg',
    postalCode: '94262'
  },
  {
    municipality: 'Kölln-Reisiek',
    postalCode: '25337'
  },
  {
    municipality: 'Kollow',
    postalCode: '21527'
  },
  {
    municipality: 'Kollweiler',
    postalCode: '66879'
  },
  {
    municipality: 'Köln',
    postalCode: '50667'
  },
  {
    municipality: 'Köln',
    postalCode: '50668'
  },
  {
    municipality: 'Köln',
    postalCode: '50670'
  },
  {
    municipality: 'Köln',
    postalCode: '50672'
  },
  {
    municipality: 'Köln',
    postalCode: '50674'
  },
  {
    municipality: 'Köln',
    postalCode: '50676'
  },
  {
    municipality: 'Köln',
    postalCode: '50677'
  },
  {
    municipality: 'Köln',
    postalCode: '50678'
  },
  {
    municipality: 'Köln',
    postalCode: '50679'
  },
  {
    municipality: 'Köln',
    postalCode: '50733'
  },
  {
    municipality: 'Köln',
    postalCode: '50735'
  },
  {
    municipality: 'Köln',
    postalCode: '50737'
  },
  {
    municipality: 'Köln',
    postalCode: '50739'
  },
  {
    municipality: 'Köln',
    postalCode: '50765'
  },
  {
    municipality: 'Köln',
    postalCode: '50767'
  },
  {
    municipality: 'Köln',
    postalCode: '50769'
  },
  {
    municipality: 'Köln',
    postalCode: '50823'
  },
  {
    municipality: 'Köln',
    postalCode: '50825'
  },
  {
    municipality: 'Köln',
    postalCode: '50827'
  },
  {
    municipality: 'Köln',
    postalCode: '50829'
  },
  {
    municipality: 'Köln',
    postalCode: '50858'
  },
  {
    municipality: 'Köln',
    postalCode: '50859'
  },
  {
    municipality: 'Köln',
    postalCode: '50931'
  },
  {
    municipality: 'Köln',
    postalCode: '50933'
  },
  {
    municipality: 'Köln',
    postalCode: '50935'
  },
  {
    municipality: 'Köln',
    postalCode: '50937'
  },
  {
    municipality: 'Köln',
    postalCode: '50939'
  },
  {
    municipality: 'Köln',
    postalCode: '50968'
  },
  {
    municipality: 'Köln',
    postalCode: '50969'
  },
  {
    municipality: 'Köln',
    postalCode: '50996'
  },
  {
    municipality: 'Köln',
    postalCode: '50997'
  },
  {
    municipality: 'Köln',
    postalCode: '50999'
  },
  {
    municipality: 'Köln',
    postalCode: '51061'
  },
  {
    municipality: 'Köln',
    postalCode: '51063'
  },
  {
    municipality: 'Köln',
    postalCode: '51065'
  },
  {
    municipality: 'Köln',
    postalCode: '51067'
  },
  {
    municipality: 'Köln',
    postalCode: '51069'
  },
  {
    municipality: 'Köln',
    postalCode: '51103'
  },
  {
    municipality: 'Köln',
    postalCode: '51105'
  },
  {
    municipality: 'Köln',
    postalCode: '51107'
  },
  {
    municipality: 'Köln',
    postalCode: '51109'
  },
  {
    municipality: 'Köln',
    postalCode: '51143'
  },
  {
    municipality: 'Köln',
    postalCode: '51145'
  },
  {
    municipality: 'Köln',
    postalCode: '51147'
  },
  {
    municipality: 'Köln',
    postalCode: '51149'
  },
  {
    municipality: 'Köln',
    postalCode: '51467'
  },
  {
    municipality: 'Kolverath',
    postalCode: '56767'
  },
  {
    municipality: 'Kommen',
    postalCode: '54472'
  },
  {
    municipality: 'Köngen',
    postalCode: '73257'
  },
  {
    municipality: 'Köngernheim',
    postalCode: '55278'
  },
  {
    municipality: 'Königheim',
    postalCode: '97953'
  },
  {
    municipality: 'Königsau',
    postalCode: '55606'
  },
  {
    municipality: 'Königsbach-Stein',
    postalCode: '75203'
  },
  {
    municipality: 'Königsberg in Bayern',
    postalCode: '97486'
  },
  {
    municipality: 'Königsbronn',
    postalCode: '89551'
  },
  {
    municipality: 'Königsbrück',
    postalCode: '01936'
  },
  {
    municipality: 'Königsbrunn',
    postalCode: '86343'
  },
  {
    municipality: 'Königsdorf',
    postalCode: '82549'
  },
  {
    municipality: 'Königsee',
    postalCode: '07426'
  },
  {
    municipality: 'Königseggwald',
    postalCode: '88376'
  },
  {
    municipality: 'Königsfeld',
    postalCode: '09306'
  },
  {
    municipality: 'Königsfeld',
    postalCode: '53426'
  },
  {
    municipality: 'Königsfeld',
    postalCode: '96167'
  },
  {
    municipality: 'Königsfeld',
    postalCode: '19217'
  },
  {
    municipality: 'Königsfeld im Schwarzwald',
    postalCode: '78126'
  },
  {
    municipality: 'Königshain',
    postalCode: '02829'
  },
  {
    municipality: 'Königshain-Wiederau',
    postalCode: '09306'
  },
  {
    municipality: 'Königsheim',
    postalCode: '78598'
  },
  {
    municipality: 'Königshügel',
    postalCode: '24799'
  },
  {
    municipality: 'Königslutter am Elm',
    postalCode: '38154'
  },
  {
    municipality: 'Königsmoor',
    postalCode: '21255'
  },
  {
    municipality: 'Königsmoos',
    postalCode: '86669'
  },
  {
    municipality: 'Königstein',
    postalCode: '01824'
  },
  {
    municipality: 'Königstein',
    postalCode: '92281'
  },
  {
    municipality: 'Königstein im Taunus',
    postalCode: '61462'
  },
  {
    municipality: 'Königswalde',
    postalCode: '09471'
  },
  {
    municipality: 'Königswartha - Rakecy',
    postalCode: '02699'
  },
  {
    municipality: 'Königswinter',
    postalCode: '53639'
  },
  {
    municipality: 'Königs Wusterhausen',
    postalCode: '15711'
  },
  {
    municipality: 'Königs Wusterhausen',
    postalCode: '15712'
  },
  {
    municipality: 'Königs Wusterhausen',
    postalCode: '15713'
  },
  {
    municipality: 'Konken',
    postalCode: '66871'
  },
  {
    municipality: 'Könnern',
    postalCode: '06420'
  },
  {
    municipality: 'Konnersreuth',
    postalCode: '95692'
  },
  {
    municipality: 'Konradsreuth',
    postalCode: '95176'
  },
  {
    municipality: 'Konstanz',
    postalCode: '78462'
  },
  {
    municipality: 'Konstanz',
    postalCode: '78464'
  },
  {
    municipality: 'Konstanz',
    postalCode: '78465'
  },
  {
    municipality: 'Konstanz',
    postalCode: '78467'
  },
  {
    municipality: 'Konz',
    postalCode: '54329'
  },
  {
    municipality: 'Konzell',
    postalCode: '94357'
  },
  {
    municipality: 'Kopp',
    postalCode: '54574'
  },
  {
    municipality: 'Korb',
    postalCode: '71404'
  },
  {
    municipality: 'Korbach',
    postalCode: '34497'
  },
  {
    municipality: 'Korbach',
    postalCode: '34513'
  },
  {
    municipality: 'Körborn',
    postalCode: '66871'
  },
  {
    municipality: 'Korbußen',
    postalCode: '07554'
  },
  {
    municipality: 'Kordel',
    postalCode: '54306'
  },
  {
    municipality: 'Kördorf',
    postalCode: '56370'
  },
  {
    municipality: 'Körle',
    postalCode: '34327'
  },
  {
    municipality: 'Korlingen',
    postalCode: '54317'
  },
  {
    municipality: 'Körner',
    postalCode: '99998'
  },
  {
    municipality: 'Korntal-Münchingen',
    postalCode: '70825'
  },
  {
    municipality: 'Kornwestheim',
    postalCode: '70806'
  },
  {
    municipality: 'Körperich',
    postalCode: '54675'
  },
  {
    municipality: 'Korschenbroich',
    postalCode: '41352'
  },
  {
    municipality: 'Korswandt',
    postalCode: '17419'
  },
  {
    municipality: 'Korweiler',
    postalCode: '56288'
  },
  {
    municipality: 'Kösching',
    postalCode: '85092'
  },
  {
    municipality: 'Kosel',
    postalCode: '24354'
  },
  {
    municipality: 'Koserow',
    postalCode: '17459'
  },
  {
    municipality: 'Kospoda',
    postalCode: '07806'
  },
  {
    municipality: 'Kößlarn',
    postalCode: '94149'
  },
  {
    municipality: 'Köthel',
    postalCode: '22929'
  },
  {
    municipality: 'Köthel',
    postalCode: '22929'
  },
  {
    municipality: 'Köthen (Anhalt)',
    postalCode: '06366'
  },
  {
    municipality: 'Köthen (Anhalt)',
    postalCode: '06369'
  },
  {
    municipality: 'Köthen (Anhalt)',
    postalCode: '06388'
  },
  {
    municipality: 'Kottenborn',
    postalCode: '53518'
  },
  {
    municipality: 'Kottenheim',
    postalCode: '56736'
  },
  {
    municipality: 'Kötterichen',
    postalCode: '56767'
  },
  {
    municipality: 'Kottgeisering',
    postalCode: '82288'
  },
  {
    municipality: 'Kottmar',
    postalCode: '02708'
  },
  {
    municipality: 'Kottmar',
    postalCode: '02739'
  },
  {
    municipality: 'Kottweiler-Schwanden',
    postalCode: '66879'
  },
  {
    municipality: 'Kötz',
    postalCode: '89359'
  },
  {
    municipality: 'Kotzen',
    postalCode: '14715'
  },
  {
    municipality: 'Kotzenbüll',
    postalCode: '25832'
  },
  {
    municipality: 'Köwerich',
    postalCode: '54340'
  },
  {
    municipality: 'Koxhausen',
    postalCode: '54673'
  },
  {
    municipality: 'Kraam',
    postalCode: '57635'
  },
  {
    municipality: 'Krackow',
    postalCode: '17329'
  },
  {
    municipality: 'Kradenbach',
    postalCode: '54552'
  },
  {
    municipality: 'Kraftisried',
    postalCode: '87647'
  },
  {
    municipality: 'Kraftsdorf',
    postalCode: '07586'
  },
  {
    municipality: 'Krähenberg',
    postalCode: '66894'
  },
  {
    municipality: 'Kraiburg',
    postalCode: '84559'
  },
  {
    municipality: 'Kraichtal',
    postalCode: '76703'
  },
  {
    municipality: 'Krailling',
    postalCode: '82152'
  },
  {
    municipality: 'Krailling',
    postalCode: '82349'
  },
  {
    municipality: 'Krakow am See',
    postalCode: '18292'
  },
  {
    municipality: 'Kramerhof',
    postalCode: '18445'
  },
  {
    municipality: 'Kranenburg',
    postalCode: '47559'
  },
  {
    municipality: 'Kranenburg',
    postalCode: '21726'
  },
  {
    municipality: 'Kranichfeld',
    postalCode: '99448'
  },
  {
    municipality: 'Kranzberg',
    postalCode: '85402'
  },
  {
    municipality: 'Kratzeburg',
    postalCode: '17237'
  },
  {
    municipality: 'Kratzenburg',
    postalCode: '56283'
  },
  {
    municipality: 'Krauchenwies',
    postalCode: '72505'
  },
  {
    municipality: 'Krauschwitz - Krušwica',
    postalCode: '02957'
  },
  {
    municipality: 'Krausnick-Groß Wasserburg',
    postalCode: '15910'
  },
  {
    municipality: 'Krauthausen',
    postalCode: '99819'
  },
  {
    municipality: 'Krautheim',
    postalCode: '74238'
  },
  {
    municipality: 'Krautscheid',
    postalCode: '54673'
  },
  {
    municipality: 'Krayenberggemeinde',
    postalCode: '36460'
  },
  {
    municipality: 'Kreba-Neudorf - Chrjebja-Nowa Wjes',
    postalCode: '02906'
  },
  {
    municipality: 'Krebeck',
    postalCode: '37434'
  },
  {
    municipality: 'Krefeld',
    postalCode: '47798'
  },
  {
    municipality: 'Krefeld',
    postalCode: '47799'
  },
  {
    municipality: 'Krefeld',
    postalCode: '47800'
  },
  {
    municipality: 'Krefeld',
    postalCode: '47802'
  },
  {
    municipality: 'Krefeld',
    postalCode: '47803'
  },
  {
    municipality: 'Krefeld',
    postalCode: '47804'
  },
  {
    municipality: 'Krefeld',
    postalCode: '47805'
  },
  {
    municipality: 'Krefeld',
    postalCode: '47807'
  },
  {
    municipality: 'Krefeld',
    postalCode: '47809'
  },
  {
    municipality: 'Krefeld',
    postalCode: '47829'
  },
  {
    municipality: 'Krefeld',
    postalCode: '47839'
  },
  {
    municipality: 'Kreien',
    postalCode: '19386'
  },
  {
    municipality: 'Kreimbach-Kaulbach',
    postalCode: '67757'
  },
  {
    municipality: 'Kreischa',
    postalCode: '01731'
  },
  {
    municipality: 'Krembz',
    postalCode: '19205'
  },
  {
    municipality: 'Kremitzaue',
    postalCode: '04916'
  },
  {
    municipality: 'Kremitzaue',
    postalCode: '04936'
  },
  {
    municipality: 'Kremmen',
    postalCode: '16766'
  },
  {
    municipality: 'Kremmin',
    postalCode: '19300'
  },
  {
    municipality: 'Krempdorf',
    postalCode: '25361'
  },
  {
    municipality: 'Krempdorf',
    postalCode: '25376'
  },
  {
    municipality: 'Krempe',
    postalCode: '25361'
  },
  {
    municipality: 'Krempel',
    postalCode: '25774'
  },
  {
    municipality: 'Kremperheide',
    postalCode: '25569'
  },
  {
    municipality: 'Krempermoor',
    postalCode: '25569'
  },
  {
    municipality: 'Krems II',
    postalCode: '23827'
  },
  {
    municipality: 'Kreßberg',
    postalCode: '74594'
  },
  {
    municipality: 'Kressbronn am Bodensee',
    postalCode: '88079'
  },
  {
    municipality: 'Kretz',
    postalCode: '56630'
  },
  {
    municipality: 'Kretzschau',
    postalCode: '06712'
  },
  {
    municipality: 'Kreuth',
    postalCode: '83708'
  },
  {
    municipality: 'Kreuzau',
    postalCode: '52372'
  },
  {
    municipality: 'Kreuztal',
    postalCode: '57223'
  },
  {
    municipality: 'Kreuzwertheim',
    postalCode: '97892'
  },
  {
    municipality: 'Krickenbach',
    postalCode: '67706'
  },
  {
    municipality: 'Kriebitzsch',
    postalCode: '04617'
  },
  {
    municipality: 'Kriebstein',
    postalCode: '09648'
  },
  {
    municipality: 'Kriegsfeld',
    postalCode: '67819'
  },
  {
    municipality: 'Krien',
    postalCode: '17391'
  },
  {
    municipality: 'Kriesow',
    postalCode: '17091'
  },
  {
    municipality: 'Kriftel',
    postalCode: '65830'
  },
  {
    municipality: 'Kritzmow',
    postalCode: '18198'
  },
  {
    municipality: 'Kritzow',
    postalCode: '19386'
  },
  {
    municipality: 'Krogaspe',
    postalCode: '24644'
  },
  {
    municipality: 'Krokau',
    postalCode: '24217'
  },
  {
    municipality: 'Krölpa',
    postalCode: '07387'
  },
  {
    municipality: 'Krombach',
    postalCode: '63829'
  },
  {
    municipality: 'Krombach',
    postalCode: '37308'
  },
  {
    municipality: 'Kronach',
    postalCode: '96317'
  },
  {
    municipality: 'Kronau',
    postalCode: '76709'
  },
  {
    municipality: 'Kronberg im Taunus',
    postalCode: '61476'
  },
  {
    municipality: 'Kronburg',
    postalCode: '87758'
  },
  {
    municipality: 'Kröning',
    postalCode: '84178'
  },
  {
    municipality: 'Kronprinzenkoog',
    postalCode: '25709'
  },
  {
    municipality: 'Kronsgaard',
    postalCode: '24395'
  },
  {
    municipality: 'Kronshagen',
    postalCode: '24119'
  },
  {
    municipality: 'Kronsmoor',
    postalCode: '25597'
  },
  {
    municipality: 'Kronweiler',
    postalCode: '55767'
  },
  {
    municipality: 'Kröpelin',
    postalCode: '18236'
  },
  {
    municipality: 'Kropp',
    postalCode: '24848'
  },
  {
    municipality: 'Kroppach',
    postalCode: '57612'
  },
  {
    municipality: 'Kröppelshagen-Fahrendorf',
    postalCode: '21039'
  },
  {
    municipality: 'Kröppelshagen-Fahrendorf',
    postalCode: '21529'
  },
  {
    municipality: 'Kroppen',
    postalCode: '01945'
  },
  {
    municipality: 'Kröppen',
    postalCode: '66957'
  },
  {
    municipality: 'Kroppenstedt',
    postalCode: '39397'
  },
  {
    municipality: 'Kröslin',
    postalCode: '17440'
  },
  {
    municipality: 'Krostitz',
    postalCode: '04509'
  },
  {
    municipality: 'Krottelbach',
    postalCode: '66909'
  },
  {
    municipality: 'Kröv',
    postalCode: '54536'
  },
  {
    municipality: 'Kruchten',
    postalCode: '54675'
  },
  {
    municipality: 'Kruckow',
    postalCode: '17129'
  },
  {
    municipality: 'Kruft',
    postalCode: '56642'
  },
  {
    municipality: 'Krugsdorf',
    postalCode: '17309'
  },
  {
    municipality: 'Krukow',
    postalCode: '21483'
  },
  {
    municipality: 'Krumbach (Schwaben)',
    postalCode: '86381'
  },
  {
    municipality: 'Krummbek',
    postalCode: '24217'
  },
  {
    municipality: 'Krümmel',
    postalCode: '56244'
  },
  {
    municipality: 'Krummenau',
    postalCode: '55483'
  },
  {
    municipality: 'Krummendeich',
    postalCode: '21732'
  },
  {
    municipality: 'Krummendiek',
    postalCode: '25554'
  },
  {
    municipality: 'Krummennaab',
    postalCode: '92703'
  },
  {
    municipality: 'Krummesse',
    postalCode: '23628'
  },
  {
    municipality: 'Krummhörn',
    postalCode: '26736'
  },
  {
    municipality: 'Krummin',
    postalCode: '17440'
  },
  {
    municipality: 'Krummwisch',
    postalCode: '24796'
  },
  {
    municipality: 'Krumstedt',
    postalCode: '25727'
  },
  {
    municipality: 'Krün',
    postalCode: '82467'
  },
  {
    municipality: 'Krün',
    postalCode: '82493'
  },
  {
    municipality: 'Krün',
    postalCode: '82494'
  },
  {
    municipality: 'Krunkel',
    postalCode: '56593'
  },
  {
    municipality: 'Krusenfelde',
    postalCode: '17391'
  },
  {
    municipality: 'Krusenhagen',
    postalCode: '23974'
  },
  {
    municipality: 'Krüzen',
    postalCode: '21483'
  },
  {
    municipality: 'Kublank',
    postalCode: '17349'
  },
  {
    municipality: 'Kubschütz - Kubšicy',
    postalCode: '02627'
  },
  {
    municipality: 'Kuchelmiß',
    postalCode: '18292'
  },
  {
    municipality: 'Kuchen',
    postalCode: '73329'
  },
  {
    municipality: 'Kuckssee',
    postalCode: '17217'
  },
  {
    municipality: 'Kuddewörde',
    postalCode: '22958'
  },
  {
    municipality: 'Kuden',
    postalCode: '25712'
  },
  {
    municipality: 'Kudensee',
    postalCode: '25572'
  },
  {
    municipality: 'Kuhardt',
    postalCode: '76773'
  },
  {
    municipality: 'Kühbach',
    postalCode: '86556'
  },
  {
    municipality: 'Kühdorf',
    postalCode: '07980'
  },
  {
    municipality: 'Kuhfelde',
    postalCode: '29416'
  },
  {
    municipality: 'Kühlenthal',
    postalCode: '86707'
  },
  {
    municipality: 'Kuhlen-Wendorf',
    postalCode: '19412'
  },
  {
    municipality: 'Kühlungsborn',
    postalCode: '18225'
  },
  {
    municipality: 'Kühndorf',
    postalCode: '98547'
  },
  {
    municipality: 'Kuhnhöfen',
    postalCode: '56244'
  },
  {
    municipality: 'Kühren',
    postalCode: '24211'
  },
  {
    municipality: 'Kuhs',
    postalCode: '18276'
  },
  {
    municipality: 'Kühsen',
    postalCode: '23898'
  },
  {
    municipality: 'Kuhstorf',
    postalCode: '19230'
  },
  {
    municipality: 'Kükels',
    postalCode: '23829'
  },
  {
    municipality: 'Küllstedt',
    postalCode: '37359'
  },
  {
    municipality: 'Kulmain',
    postalCode: '95508'
  },
  {
    municipality: 'Kulmbach',
    postalCode: '95326'
  },
  {
    municipality: 'Kulmbach',
    postalCode: '96369'
  },
  {
    municipality: 'Kulpin',
    postalCode: '23911'
  },
  {
    municipality: 'Külsheim',
    postalCode: '97900'
  },
  {
    municipality: 'Külz (Hunsrück)',
    postalCode: '55471'
  },
  {
    municipality: 'Kümbdchen',
    postalCode: '55471'
  },
  {
    municipality: 'Kumhausen',
    postalCode: '84036'
  },
  {
    municipality: 'Kummerfeld',
    postalCode: '25495'
  },
  {
    municipality: 'Kümmernitztal',
    postalCode: '16945'
  },
  {
    municipality: 'Kummerow',
    postalCode: '17139'
  },
  {
    municipality: 'Kümmersbruck',
    postalCode: '92245'
  },
  {
    municipality: 'Kundert',
    postalCode: '57629'
  },
  {
    municipality: 'Kunreuth',
    postalCode: '91358'
  },
  {
    municipality: 'Künzell',
    postalCode: '36093'
  },
  {
    municipality: 'Künzelsau',
    postalCode: '74653'
  },
  {
    municipality: 'Künzing',
    postalCode: '94550'
  },
  {
    municipality: 'Kupferberg',
    postalCode: '95362'
  },
  {
    municipality: 'Kupferzell',
    postalCode: '74635'
  },
  {
    municipality: 'Kuppenheim',
    postalCode: '76456'
  },
  {
    municipality: 'Küps',
    postalCode: '96328'
  },
  {
    municipality: 'Kürnach',
    postalCode: '97273'
  },
  {
    municipality: 'Kürnbach',
    postalCode: '75057'
  },
  {
    municipality: 'Kürten',
    postalCode: '51515'
  },
  {
    municipality: 'Kurtscheid',
    postalCode: '56581'
  },
  {
    municipality: 'Kusel',
    postalCode: '66869'
  },
  {
    municipality: 'Küssaberg',
    postalCode: '79790'
  },
  {
    municipality: 'Küsten',
    postalCode: '29482'
  },
  {
    municipality: 'Kusterdingen',
    postalCode: '72127'
  },
  {
    municipality: 'Kusterdingen',
    postalCode: '72138'
  },
  {
    municipality: 'Küstriner Vorland',
    postalCode: '15328'
  },
  {
    municipality: 'Kutenholz',
    postalCode: '27449'
  },
  {
    municipality: 'Kutzenhausen',
    postalCode: '86500'
  },
  {
    municipality: 'Kutzleben',
    postalCode: '99955'
  },
  {
    municipality: 'Kyffhäuserland',
    postalCode: '99707'
  },
  {
    municipality: 'Kyllburg',
    postalCode: '54655'
  },
  {
    municipality: 'Kyllburgweiler',
    postalCode: '54655'
  },
  {
    municipality: 'Kyritz',
    postalCode: '16866'
  },
  {
    municipality: 'Laaber',
    postalCode: '93164'
  },
  {
    municipality: 'Laage',
    postalCode: '18299'
  },
  {
    municipality: 'Laar',
    postalCode: '49824'
  },
  {
    municipality: 'Laasdorf',
    postalCode: '07646'
  },
  {
    municipality: 'Laatzen',
    postalCode: '30880'
  },
  {
    municipality: 'Labenz',
    postalCode: '23898'
  },
  {
    municipality: 'Laberweinting',
    postalCode: '84082'
  },
  {
    municipality: 'Laboe',
    postalCode: '24235'
  },
  {
    municipality: 'Lachen',
    postalCode: '87760'
  },
  {
    municipality: 'Lachendorf',
    postalCode: '29331'
  },
  {
    municipality: 'Ladbergen',
    postalCode: '49549'
  },
  {
    municipality: 'Ladelund',
    postalCode: '25926'
  },
  {
    municipality: 'Ladenburg',
    postalCode: '68526'
  },
  {
    municipality: 'Laer',
    postalCode: '48366'
  },
  {
    municipality: 'Lage',
    postalCode: '32791'
  },
  {
    municipality: 'Lage',
    postalCode: '49828'
  },
  {
    municipality: 'Lägerdorf',
    postalCode: '25566'
  },
  {
    municipality: 'Lähden',
    postalCode: '49774'
  },
  {
    municipality: 'Lahn',
    postalCode: '49757'
  },
  {
    municipality: 'Lahnau',
    postalCode: '35633'
  },
  {
    municipality: 'Lahnstein',
    postalCode: '56112'
  },
  {
    municipality: 'Lahnstein',
    postalCode: '56130'
  },
  {
    municipality: 'Lahntal',
    postalCode: '35094'
  },
  {
    municipality: 'Lahr',
    postalCode: '54675'
  },
  {
    municipality: 'Lahr',
    postalCode: '56288'
  },
  {
    municipality: 'Lahr/Schwarzwald',
    postalCode: '77933'
  },
  {
    municipality: 'Laichingen',
    postalCode: '89150'
  },
  {
    municipality: 'Lalendorf',
    postalCode: '18279'
  },
  {
    municipality: 'Lalling',
    postalCode: '94551'
  },
  {
    municipality: 'Lam',
    postalCode: '93462'
  },
  {
    municipality: 'Lambertsberg',
    postalCode: '54649'
  },
  {
    municipality: 'Lambrecht',
    postalCode: '67466'
  },
  {
    municipality: 'Lambrechtshagen',
    postalCode: '18069'
  },
  {
    municipality: 'Lambsborn',
    postalCode: '66894'
  },
  {
    municipality: 'Lambsheim',
    postalCode: '67245'
  },
  {
    municipality: 'Lamerdingen',
    postalCode: '86862'
  },
  {
    municipality: 'Lammershagen',
    postalCode: '24238'
  },
  {
    municipality: 'Lampaden',
    postalCode: '54316'
  },
  {
    municipality: 'Lampertheim',
    postalCode: '68623'
  },
  {
    municipality: 'Lampertswalde',
    postalCode: '01561'
  },
  {
    municipality: 'Lamspringe',
    postalCode: '31195'
  },
  {
    municipality: 'Lamstedt',
    postalCode: '21769'
  },
  {
    municipality: 'Lancken-Granitz',
    postalCode: '18586'
  },
  {
    municipality: 'Landau an der Isar',
    postalCode: '94405'
  },
  {
    municipality: 'Landau in der Pfalz',
    postalCode: '76829'
  },
  {
    municipality: 'Landensberg',
    postalCode: '89361'
  },
  {
    municipality: 'Landesbergen',
    postalCode: '31628'
  },
  {
    municipality: 'Landkern',
    postalCode: '56814'
  },
  {
    municipality: 'Landolfshausen',
    postalCode: '37136'
  },
  {
    municipality: 'Landrecht',
    postalCode: '25554'
  },
  {
    municipality: 'Landsberg',
    postalCode: '06188'
  },
  {
    municipality: 'Landsberg am Lech',
    postalCode: '86899'
  },
  {
    municipality: 'Landsberg am Lech',
    postalCode: '86932'
  },
  {
    municipality: 'Landsberied',
    postalCode: '82290'
  },
  {
    municipality: 'Landscheid',
    postalCode: '54526'
  },
  {
    municipality: 'Landscheide',
    postalCode: '25572'
  },
  {
    municipality: 'Landshut',
    postalCode: '84028'
  },
  {
    municipality: 'Landshut',
    postalCode: '84030'
  },
  {
    municipality: 'Landshut',
    postalCode: '84032'
  },
  {
    municipality: 'Landshut',
    postalCode: '84034'
  },
  {
    municipality: 'Landshut',
    postalCode: '84036'
  },
  {
    municipality: 'Landstuhl',
    postalCode: '66849'
  },
  {
    municipality: 'Langballig',
    postalCode: '24977'
  },
  {
    municipality: 'Langdorf',
    postalCode: '94264'
  },
  {
    municipality: 'Langeln',
    postalCode: '25485'
  },
  {
    municipality: 'Langelsheim',
    postalCode: '38685'
  },
  {
    municipality: 'Langelsheim',
    postalCode: '38729'
  },
  {
    municipality: 'Langen',
    postalCode: '63225'
  },
  {
    municipality: 'Langen',
    postalCode: '49838'
  },
  {
    municipality: 'Langenaltheim',
    postalCode: '91799'
  },
  {
    municipality: 'Langenargen',
    postalCode: '88085'
  },
  {
    municipality: 'Langenau',
    postalCode: '89129'
  },
  {
    municipality: 'Langenbach',
    postalCode: '85416'
  },
  {
    municipality: 'Langenbach',
    postalCode: '66909'
  },
  {
    municipality: 'Langenbach bei Kirburg',
    postalCode: '57520'
  },
  {
    municipality: 'Langenberg',
    postalCode: '33449'
  },
  {
    municipality: 'Langenbernsdorf',
    postalCode: '08428'
  },
  {
    municipality: 'Langenbrettach',
    postalCode: '74243'
  },
  {
    municipality: 'Langen Brütz',
    postalCode: '19067'
  },
  {
    municipality: 'Langenburg',
    postalCode: '74595'
  },
  {
    municipality: 'Langendorf',
    postalCode: '29484'
  },
  {
    municipality: 'Langenenslingen',
    postalCode: '88515'
  },
  {
    municipality: 'Langeneß',
    postalCode: '25863'
  },
  {
    municipality: 'Langeneß',
    postalCode: '25867'
  },
  {
    municipality: 'Langenfeld',
    postalCode: '91474'
  },
  {
    municipality: 'Langenfeld',
    postalCode: '56729'
  },
  {
    municipality: 'Langenfeld (Rheinland)',
    postalCode: '40764'
  },
  {
    municipality: 'Langenhagen',
    postalCode: '30669'
  },
  {
    municipality: 'Langenhagen',
    postalCode: '30851'
  },
  {
    municipality: 'Langenhagen',
    postalCode: '30853'
  },
  {
    municipality: 'Langenhagen',
    postalCode: '30855'
  },
  {
    municipality: 'Langenhahn',
    postalCode: '56459'
  },
  {
    municipality: 'Langenhorn',
    postalCode: '25842'
  },
  {
    municipality: 'Langenlehsten',
    postalCode: '21514'
  },
  {
    municipality: 'Langenleuba-Niederhain',
    postalCode: '04618'
  },
  {
    municipality: 'Langenlonsheim',
    postalCode: '55450'
  },
  {
    municipality: 'Langenmosen',
    postalCode: '86571'
  },
  {
    municipality: 'Langenneufnach',
    postalCode: '86863'
  },
  {
    municipality: 'Langenorla',
    postalCode: '07381'
  },
  {
    municipality: 'Langenpreising',
    postalCode: '85465'
  },
  {
    municipality: 'Langenscheid',
    postalCode: '65558'
  },
  {
    municipality: 'Langenselbold',
    postalCode: '63505'
  },
  {
    municipality: 'Langensendelbach',
    postalCode: '91094'
  },
  {
    municipality: 'Langenthal',
    postalCode: '55569'
  },
  {
    municipality: 'Langenweißbach',
    postalCode: '08134'
  },
  {
    municipality: 'Langenwetzendorf',
    postalCode: '07957'
  },
  {
    municipality: 'Langenwolschendorf',
    postalCode: '07937'
  },
  {
    municipality: 'Langenzenn',
    postalCode: '90579'
  },
  {
    municipality: 'Langeoog',
    postalCode: '26465'
  },
  {
    municipality: 'Langerringen',
    postalCode: '86853'
  },
  {
    municipality: 'Langerwehe',
    postalCode: '52379'
  },
  {
    municipality: 'Langewahl',
    postalCode: '15518'
  },
  {
    municipality: 'Langfurth',
    postalCode: '91731'
  },
  {
    municipality: 'Langgöns',
    postalCode: '35428'
  },
  {
    municipality: 'Langlingen',
    postalCode: '29364'
  },
  {
    municipality: 'Langquaid',
    postalCode: '84085'
  },
  {
    municipality: 'Langscheid',
    postalCode: '56729'
  },
  {
    municipality: 'Langstedt',
    postalCode: '24852'
  },
  {
    municipality: 'Langsur',
    postalCode: '54308'
  },
  {
    municipality: 'Langwedel',
    postalCode: '24631'
  },
  {
    municipality: 'Langwedel',
    postalCode: '27299'
  },
  {
    municipality: 'Langweid am Lech',
    postalCode: '86462'
  },
  {
    municipality: 'Langweiler',
    postalCode: '55758'
  },
  {
    municipality: 'Langweiler',
    postalCode: '67746'
  },
  {
    municipality: 'Langwieden',
    postalCode: '66894'
  },
  {
    municipality: 'Lanitz-Hassel-Tal',
    postalCode: '06628'
  },
  {
    municipality: 'Lankau',
    postalCode: '23881'
  },
  {
    municipality: 'Lanz',
    postalCode: '19309'
  },
  {
    municipality: 'Lanze',
    postalCode: '21483'
  },
  {
    municipality: 'Lappersdorf',
    postalCode: '93138'
  },
  {
    municipality: 'Lärz',
    postalCode: '17248'
  },
  {
    municipality: 'Lasbek',
    postalCode: '23847'
  },
  {
    municipality: 'Lascheid',
    postalCode: '54597'
  },
  {
    municipality: 'Lasel',
    postalCode: '54612'
  },
  {
    municipality: 'Lassan',
    postalCode: '17440'
  },
  {
    municipality: 'Lastrup',
    postalCode: '49688'
  },
  {
    municipality: 'Latendorf',
    postalCode: '24598'
  },
  {
    municipality: 'Lathen',
    postalCode: '49762'
  },
  {
    municipality: 'Laubach',
    postalCode: '35321'
  },
  {
    municipality: 'Laubach',
    postalCode: '56288'
  },
  {
    municipality: 'Laubach',
    postalCode: '56759'
  },
  {
    municipality: 'Lauben',
    postalCode: '87493'
  },
  {
    municipality: 'Lauben',
    postalCode: '87761'
  },
  {
    municipality: 'Laubenheim',
    postalCode: '55452'
  },
  {
    municipality: 'Laucha an der Unstrut',
    postalCode: '06636'
  },
  {
    municipality: 'Lauchhammer',
    postalCode: '01979'
  },
  {
    municipality: 'Lauchheim',
    postalCode: '73466'
  },
  {
    municipality: 'Lauchringen',
    postalCode: '79787'
  },
  {
    municipality: 'Lauda-Königshofen',
    postalCode: '97922'
  },
  {
    municipality: 'Laudenbach',
    postalCode: '69514'
  },
  {
    municipality: 'Laudenbach',
    postalCode: '63925'
  },
  {
    municipality: 'Laudert',
    postalCode: '56291'
  },
  {
    municipality: 'Lauenau',
    postalCode: '31867'
  },
  {
    municipality: 'Lauenbrück',
    postalCode: '27389'
  },
  {
    municipality: 'Lauenburg/Elbe',
    postalCode: '21481'
  },
  {
    municipality: 'Lauenförde',
    postalCode: '37697'
  },
  {
    municipality: 'Lauenhagen',
    postalCode: '31714'
  },
  {
    municipality: 'Lauf',
    postalCode: '77886'
  },
  {
    municipality: 'Laufach',
    postalCode: '63846'
  },
  {
    municipality: 'Lauf an der Pegnitz',
    postalCode: '91207'
  },
  {
    municipality: 'Laufeld',
    postalCode: '54533'
  },
  {
    municipality: 'Laufen',
    postalCode: '83410'
  },
  {
    municipality: 'Laufenburg (Baden)',
    postalCode: '79725'
  },
  {
    municipality: 'Laufersweiler',
    postalCode: '55487'
  },
  {
    municipality: 'Lauffen am Neckar',
    postalCode: '74348'
  },
  {
    municipality: 'Laugna',
    postalCode: '86502'
  },
  {
    municipality: 'Lauingen (Donau)',
    postalCode: '89415'
  },
  {
    municipality: 'Laumersheim',
    postalCode: '67229'
  },
  {
    municipality: 'Lauperath',
    postalCode: '54649'
  },
  {
    municipality: 'Laupheim',
    postalCode: '88471'
  },
  {
    municipality: 'Laurenburg',
    postalCode: '56379'
  },
  {
    municipality: 'Lauscha',
    postalCode: '98724'
  },
  {
    municipality: 'Lauschied',
    postalCode: '55568'
  },
  {
    municipality: 'Lausnitz',
    postalCode: '07806'
  },
  {
    municipality: 'Laußig',
    postalCode: '04838'
  },
  {
    municipality: 'Laußig',
    postalCode: '04849'
  },
  {
    municipality: 'Laußnitz',
    postalCode: '01936'
  },
  {
    municipality: 'Lauta',
    postalCode: '02991'
  },
  {
    municipality: 'Lautenbach',
    postalCode: '77794'
  },
  {
    municipality: 'Lauter',
    postalCode: '96169'
  },
  {
    municipality: 'Lauterach',
    postalCode: '89584'
  },
  {
    municipality: 'Lauterbach',
    postalCode: '36341'
  },
  {
    municipality: 'Lauterbach',
    postalCode: '78730'
  },
  {
    municipality: 'Lauterbach',
    postalCode: '99826'
  },
  {
    municipality: 'Lauter-Bernsbach',
    postalCode: '08315'
  },
  {
    municipality: 'Lauterecken',
    postalCode: '67742'
  },
  {
    municipality: 'Lauterhofen',
    postalCode: '92283'
  },
  {
    municipality: 'Lautersheim',
    postalCode: '67308'
  },
  {
    municipality: 'Lauterstein',
    postalCode: '73111'
  },
  {
    municipality: 'Lautert',
    postalCode: '56355'
  },
  {
    municipality: 'Lautertal',
    postalCode: '36369'
  },
  {
    municipality: 'Lautertal',
    postalCode: '64686'
  },
  {
    municipality: 'Lautertal',
    postalCode: '96486'
  },
  {
    municipality: 'Lautrach',
    postalCode: '87763'
  },
  {
    municipality: 'Lautzenbrücken',
    postalCode: '56472'
  },
  {
    municipality: 'Lautzenhausen',
    postalCode: '55483'
  },
  {
    municipality: 'Lawalde',
    postalCode: '02708'
  },
  {
    municipality: 'Lawitz',
    postalCode: '15898'
  },
  {
    municipality: 'Lebach',
    postalCode: '66822'
  },
  {
    municipality: 'Lebrade',
    postalCode: '24306'
  },
  {
    municipality: 'Lebus',
    postalCode: '15326'
  },
  {
    municipality: 'Lebusa',
    postalCode: '04936'
  },
  {
    municipality: 'Lechbruck a.See',
    postalCode: '86983'
  },
  {
    municipality: 'Leck',
    postalCode: '25917'
  },
  {
    municipality: 'Lederhose',
    postalCode: '07589'
  },
  {
    municipality: 'Leegebruch',
    postalCode: '16767'
  },
  {
    municipality: 'Leer',
    postalCode: '26789'
  },
  {
    municipality: 'Leese',
    postalCode: '31633'
  },
  {
    municipality: 'Leezdorf',
    postalCode: '26529'
  },
  {
    municipality: 'Leezen',
    postalCode: '23816'
  },
  {
    municipality: 'Leezen',
    postalCode: '19067'
  },
  {
    municipality: 'Legau',
    postalCode: '87764'
  },
  {
    municipality: 'Legden',
    postalCode: '48739'
  },
  {
    municipality: 'Legde/Quitzöbel',
    postalCode: '19336'
  },
  {
    municipality: 'Lehe',
    postalCode: '25774'
  },
  {
    municipality: 'Lehe',
    postalCode: '25776'
  },
  {
    municipality: 'Lehe',
    postalCode: '26892'
  },
  {
    municipality: 'Lehesten',
    postalCode: '07349'
  },
  {
    municipality: 'Lehesten',
    postalCode: '07778'
  },
  {
    municipality: 'Lehmen',
    postalCode: '56332'
  },
  {
    municipality: 'Lehmkuhlen',
    postalCode: '24211'
  },
  {
    municipality: 'Lehmrade',
    postalCode: '23883'
  },
  {
    municipality: 'Lehnstedt',
    postalCode: '99441'
  },
  {
    municipality: 'Lehrberg',
    postalCode: '91611'
  },
  {
    municipality: 'Lehre',
    postalCode: '38165'
  },
  {
    municipality: 'Lehrensteinsfeld',
    postalCode: '74251'
  },
  {
    municipality: 'Lehrte',
    postalCode: '31275'
  },
  {
    municipality: 'Leibertingen',
    postalCode: '88637'
  },
  {
    municipality: 'Leiblfing',
    postalCode: '94339'
  },
  {
    municipality: 'Leichlingen',
    postalCode: '42799'
  },
  {
    municipality: 'Leidenborn',
    postalCode: '54619'
  },
  {
    municipality: 'Leidersbach',
    postalCode: '63849'
  },
  {
    municipality: 'Leienkaul',
    postalCode: '56759'
  },
  {
    municipality: 'Leiferde',
    postalCode: '38542'
  },
  {
    municipality: 'Leimbach',
    postalCode: '53518'
  },
  {
    municipality: 'Leimbach',
    postalCode: '54673'
  },
  {
    municipality: 'Leimbach',
    postalCode: '36433'
  },
  {
    municipality: 'Leimen',
    postalCode: '69181'
  },
  {
    municipality: 'Leimen',
    postalCode: '66978'
  },
  {
    municipality: 'Leimersheim',
    postalCode: '76774'
  },
  {
    municipality: 'Leinach',
    postalCode: '97274'
  },
  {
    municipality: 'Leinburg',
    postalCode: '91227'
  },
  {
    municipality: 'Leinefelde-Worbis',
    postalCode: '37327'
  },
  {
    municipality: 'Leinefelde-Worbis',
    postalCode: '37339'
  },
  {
    municipality: 'Leinfelden-Echterdingen',
    postalCode: '70771'
  },
  {
    municipality: 'Leingarten',
    postalCode: '74211'
  },
  {
    municipality: 'Leiningen',
    postalCode: '56291'
  },
  {
    municipality: 'Leinsweiler',
    postalCode: '76829'
  },
  {
    municipality: 'Leinzell',
    postalCode: '73575'
  },
  {
    municipality: 'Leipheim',
    postalCode: '89340'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04103'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04105'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04107'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04109'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04129'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04155'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04157'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04158'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04159'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04177'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04178'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04179'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04205'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04207'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04209'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04229'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04249'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04275'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04277'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04279'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04288'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04289'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04299'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04315'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04316'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04317'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04318'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04319'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04328'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04329'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04347'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04349'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04356'
  },
  {
    municipality: 'Leipzig',
    postalCode: '04357'
  },
  {
    municipality: 'Leisel',
    postalCode: '55767'
  },
  {
    municipality: 'Leisnig',
    postalCode: '04703'
  },
  {
    municipality: 'Leitzweiler',
    postalCode: '55779'
  },
  {
    municipality: 'Leiwen',
    postalCode: '54340'
  },
  {
    municipality: 'Leizen',
    postalCode: '17209'
  },
  {
    municipality: 'Lelkendorf',
    postalCode: '17168'
  },
  {
    municipality: 'Lemberg',
    postalCode: '66969'
  },
  {
    municipality: 'Lembruch',
    postalCode: '49459'
  },
  {
    municipality: 'Lemförde',
    postalCode: '49448'
  },
  {
    municipality: 'Lemgo',
    postalCode: '32657'
  },
  {
    municipality: 'Lemgow',
    postalCode: '29485'
  },
  {
    municipality: 'Lemnitz',
    postalCode: '07819'
  },
  {
    municipality: 'Lemwerder',
    postalCode: '27809'
  },
  {
    municipality: 'Lengdorf',
    postalCode: '84435'
  },
  {
    municipality: 'Lengede',
    postalCode: '38268'
  },
  {
    municipality: 'Lengenbostel',
    postalCode: '27419'
  },
  {
    municipality: 'Lengenfeld',
    postalCode: '08485'
  },
  {
    municipality: 'Lengenwang',
    postalCode: '87663'
  },
  {
    municipality: 'Lengerich',
    postalCode: '49525'
  },
  {
    municipality: 'Lengerich',
    postalCode: '49838'
  },
  {
    municipality: 'Lengfeld',
    postalCode: '98660'
  },
  {
    municipality: 'Lenggries',
    postalCode: '83661'
  },
  {
    municipality: 'Lenne',
    postalCode: '37627'
  },
  {
    municipality: 'Lennestadt',
    postalCode: '57368'
  },
  {
    municipality: 'Lenningen',
    postalCode: '73252'
  },
  {
    municipality: 'Lenningen',
    postalCode: '73266'
  },
  {
    municipality: 'Lensahn',
    postalCode: '23738'
  },
  {
    municipality: 'Lenterode',
    postalCode: '37318'
  },
  {
    municipality: 'Lentföhrden',
    postalCode: '24632'
  },
  {
    municipality: 'Lentföhrden',
    postalCode: '24640'
  },
  {
    municipality: 'Lenting',
    postalCode: '85101'
  },
  {
    municipality: 'Lenzen (Elbe)',
    postalCode: '19309'
  },
  {
    municipality: 'Lenzerwische',
    postalCode: '19309'
  },
  {
    municipality: 'Lenzkirch',
    postalCode: '79853'
  },
  {
    municipality: 'Leonberg',
    postalCode: '71229'
  },
  {
    municipality: 'Leonberg',
    postalCode: '95666'
  },
  {
    municipality: 'Leopoldshagen',
    postalCode: '17375'
  },
  {
    municipality: 'Leopoldshöhe',
    postalCode: '33818'
  },
  {
    municipality: 'Letschin',
    postalCode: '15324'
  },
  {
    municipality: 'Lettweiler',
    postalCode: '67823'
  },
  {
    municipality: 'Leubsdorf',
    postalCode: '09573'
  },
  {
    municipality: 'Leubsdorf',
    postalCode: '53547'
  },
  {
    municipality: 'Leuchtenberg',
    postalCode: '92705'
  },
  {
    municipality: 'Leun',
    postalCode: '35638'
  },
  {
    municipality: 'Leuna',
    postalCode: '06237'
  },
  {
    municipality: 'Leupoldsgrün',
    postalCode: '95191'
  },
  {
    municipality: 'Leutenbach',
    postalCode: '71397'
  },
  {
    municipality: 'Leutenbach',
    postalCode: '91359'
  },
  {
    municipality: 'Leutenberg',
    postalCode: '07338'
  },
  {
    municipality: 'Leuterod',
    postalCode: '56244'
  },
  {
    municipality: 'Leutersdorf',
    postalCode: '02794'
  },
  {
    municipality: 'Leutersdorf',
    postalCode: '98617'
  },
  {
    municipality: 'Leutershausen',
    postalCode: '91578'
  },
  {
    municipality: 'Leutesdorf',
    postalCode: '56599'
  },
  {
    municipality: 'Leutkirch im Allgäu',
    postalCode: '88299'
  },
  {
    municipality: 'Levenhagen',
    postalCode: '17498'
  },
  {
    municipality: 'Leverkusen',
    postalCode: '51371'
  },
  {
    municipality: 'Leverkusen',
    postalCode: '51373'
  },
  {
    municipality: 'Leverkusen',
    postalCode: '51375'
  },
  {
    municipality: 'Leverkusen',
    postalCode: '51377'
  },
  {
    municipality: 'Leverkusen',
    postalCode: '51379'
  },
  {
    municipality: 'Leverkusen',
    postalCode: '51381'
  },
  {
    municipality: 'Lewitzrand',
    postalCode: '19372'
  },
  {
    municipality: 'Lewitzrand',
    postalCode: '19374'
  },
  {
    municipality: 'Lexgaard',
    postalCode: '25923'
  },
  {
    municipality: 'Lich',
    postalCode: '35423'
  },
  {
    municipality: 'Lichtenau',
    postalCode: '33165'
  },
  {
    municipality: 'Lichtenau',
    postalCode: '09244'
  },
  {
    municipality: 'Lichtenau',
    postalCode: '91586'
  },
  {
    municipality: 'Lichtenau',
    postalCode: '77839'
  },
  {
    municipality: 'Lichtenberg',
    postalCode: '95192'
  },
  {
    municipality: 'Lichtenberg',
    postalCode: '01896'
  },
  {
    municipality: 'Lichtenberg/Erzgebirge',
    postalCode: '09638'
  },
  {
    municipality: 'Lichtenborn',
    postalCode: '54619'
  },
  {
    municipality: 'Lichtenfels',
    postalCode: '35104'
  },
  {
    municipality: 'Lichtenfels',
    postalCode: '96215'
  },
  {
    municipality: 'Lichtenstein',
    postalCode: '72805'
  },
  {
    municipality: 'Lichtenstein/Sachsen',
    postalCode: '09350'
  },
  {
    municipality: 'Lichtentanne',
    postalCode: '08115'
  },
  {
    municipality: 'Lichtenwald',
    postalCode: '73669'
  },
  {
    municipality: 'Lichterfeld-Schacksdorf',
    postalCode: '03238'
  },
  {
    municipality: 'Liebenau',
    postalCode: '34396'
  },
  {
    municipality: 'Liebenau',
    postalCode: '31618'
  },
  {
    municipality: 'Liebenburg',
    postalCode: '38704'
  },
  {
    municipality: 'Liebenscheid',
    postalCode: '56479'
  },
  {
    municipality: 'Liebenwalde',
    postalCode: '16559'
  },
  {
    municipality: 'Lieberose',
    postalCode: '15868'
  },
  {
    municipality: 'Liebschützberg',
    postalCode: '04758'
  },
  {
    municipality: 'Liebshausen',
    postalCode: '55494'
  },
  {
    municipality: 'Liebstadt',
    postalCode: '01825'
  },
  {
    municipality: 'Liederbach',
    postalCode: '65835'
  },
  {
    municipality: 'Lieg',
    postalCode: '56290'
  },
  {
    municipality: 'Lienen',
    postalCode: '49536'
  },
  {
    municipality: 'Liepe',
    postalCode: '16248'
  },
  {
    municipality: 'Liepgarten',
    postalCode: '17375'
  },
  {
    municipality: 'Lierfeld',
    postalCode: '54597'
  },
  {
    municipality: 'Lierschied',
    postalCode: '56357'
  },
  {
    municipality: 'Liesenich',
    postalCode: '56858'
  },
  {
    municipality: 'Lieser',
    postalCode: '54470'
  },
  {
    municipality: 'Ließem',
    postalCode: '54636'
  },
  {
    municipality: 'Lieth',
    postalCode: '25770'
  },
  {
    municipality: 'Lietzen',
    postalCode: '15306'
  },
  {
    municipality: 'Lietzow',
    postalCode: '18528'
  },
  {
    municipality: 'Lilienthal',
    postalCode: '28865'
  },
  {
    municipality: 'Limbach',
    postalCode: '74838'
  },
  {
    municipality: 'Limbach',
    postalCode: '08468'
  },
  {
    municipality: 'Limbach',
    postalCode: '08491'
  },
  {
    municipality: 'Limbach',
    postalCode: '57629'
  },
  {
    municipality: 'Limbach',
    postalCode: '55606'
  },
  {
    municipality: 'Limbach-Oberfrohna',
    postalCode: '09212'
  },
  {
    municipality: 'Limburg an der Lahn',
    postalCode: '65549'
  },
  {
    municipality: 'Limburg an der Lahn',
    postalCode: '65550'
  },
  {
    municipality: 'Limburg an der Lahn',
    postalCode: '65551'
  },
  {
    municipality: 'Limburg an der Lahn',
    postalCode: '65552'
  },
  {
    municipality: 'Limburg an der Lahn',
    postalCode: '65553'
  },
  {
    municipality: 'Limburg an der Lahn',
    postalCode: '65554'
  },
  {
    municipality: 'Limburg an der Lahn',
    postalCode: '65555'
  },
  {
    municipality: 'Limburg an der Lahn',
    postalCode: '65556'
  },
  {
    municipality: 'Limburgerhof',
    postalCode: '67117'
  },
  {
    municipality: 'Limeshain',
    postalCode: '63694'
  },
  {
    municipality: 'Linau',
    postalCode: '22959'
  },
  {
    municipality: 'Lind',
    postalCode: '56729'
  },
  {
    municipality: 'Lind',
    postalCode: '53506'
  },
  {
    municipality: 'Linda b. Weida',
    postalCode: '07580'
  },
  {
    municipality: 'Lindau',
    postalCode: '24214'
  },
  {
    municipality: 'Lindau (Bodensee)',
    postalCode: '88131'
  },
  {
    municipality: 'Lindberg',
    postalCode: '94227'
  },
  {
    municipality: 'Linden',
    postalCode: '35440'
  },
  {
    municipality: 'Linden',
    postalCode: '57629'
  },
  {
    municipality: 'Linden',
    postalCode: '25791'
  },
  {
    municipality: 'Linden',
    postalCode: '66851'
  },
  {
    municipality: 'Linden',
    postalCode: '67706'
  },
  {
    municipality: 'Lindenau',
    postalCode: '01945'
  },
  {
    municipality: 'Lindenberg',
    postalCode: '67473'
  },
  {
    municipality: 'Lindenberg',
    postalCode: '17111'
  },
  {
    municipality: 'Lindenberg im Allgäu',
    postalCode: '88161'
  },
  {
    municipality: 'Lindendorf',
    postalCode: '15306'
  },
  {
    municipality: 'Lindenfels',
    postalCode: '64678'
  },
  {
    municipality: 'Lindenkreuz',
    postalCode: '07589'
  },
  {
    municipality: 'Lindenschied',
    postalCode: '55481'
  },
  {
    municipality: 'Lindern (Oldenburg)',
    postalCode: '49699'
  },
  {
    municipality: 'Lindetal',
    postalCode: '17349'
  },
  {
    municipality: 'Lindewerra',
    postalCode: '37318'
  },
  {
    municipality: 'Lindewitt',
    postalCode: '24969'
  },
  {
    municipality: 'Lindholz',
    postalCode: '18334'
  },
  {
    municipality: 'Lindhorst',
    postalCode: '31698'
  },
  {
    municipality: 'Lindig',
    postalCode: '07768'
  },
  {
    municipality: 'Lindlar',
    postalCode: '51789'
  },
  {
    municipality: 'Lindow (Mark)',
    postalCode: '16835'
  },
  {
    municipality: 'Lindwedel',
    postalCode: '29690'
  },
  {
    municipality: 'Lingen (Ems)',
    postalCode: '49808'
  },
  {
    municipality: 'Lingen (Ems)',
    postalCode: '49809'
  },
  {
    municipality: 'Lingen (Ems)',
    postalCode: '49811'
  },
  {
    municipality: 'Lingenfeld',
    postalCode: '67360'
  },
  {
    municipality: 'Lingerhahn',
    postalCode: '56291'
  },
  {
    municipality: 'Linkenbach',
    postalCode: '56317'
  },
  {
    municipality: 'Linkenheim-Hochstetten',
    postalCode: '76351'
  },
  {
    municipality: 'Linnich',
    postalCode: '52441'
  },
  {
    municipality: 'Linsburg',
    postalCode: '31636'
  },
  {
    municipality: 'Linsengericht',
    postalCode: '63589'
  },
  {
    municipality: 'Linthe',
    postalCode: '14822'
  },
  {
    municipality: 'Linz am Rhein',
    postalCode: '53545'
  },
  {
    municipality: 'Linz am Rhein',
    postalCode: '53560'
  },
  {
    municipality: 'Lippersdorf-Erdmannsdorf',
    postalCode: '07646'
  },
  {
    municipality: 'Lippetal',
    postalCode: '59510'
  },
  {
    municipality: 'Lipporn',
    postalCode: '56357'
  },
  {
    municipality: 'Lipprechterode',
    postalCode: '99752'
  },
  {
    municipality: 'Lippstadt',
    postalCode: '59555'
  },
  {
    municipality: 'Lippstadt',
    postalCode: '59556'
  },
  {
    municipality: 'Lippstadt',
    postalCode: '59557'
  },
  {
    municipality: 'Lippstadt',
    postalCode: '59558'
  },
  {
    municipality: 'Lirstal',
    postalCode: '56767'
  },
  {
    municipality: 'Lisberg',
    postalCode: '96170'
  },
  {
    municipality: 'Lissendorf',
    postalCode: '54587'
  },
  {
    municipality: 'List auf Sylt',
    postalCode: '25992'
  },
  {
    municipality: 'Litzendorf',
    postalCode: '96123'
  },
  {
    municipality: 'Löbau',
    postalCode: '02708'
  },
  {
    municipality: 'Lobbach',
    postalCode: '74931'
  },
  {
    municipality: 'Löberschütz',
    postalCode: '07751'
  },
  {
    municipality: 'Löbichau',
    postalCode: '04626'
  },
  {
    municipality: 'Löbnitz',
    postalCode: '18314'
  },
  {
    municipality: 'Löbnitz',
    postalCode: '04509'
  },
  {
    municipality: 'Löchgau',
    postalCode: '74369'
  },
  {
    municipality: 'Lochum',
    postalCode: '57629'
  },
  {
    municipality: 'Löcknitz',
    postalCode: '17321'
  },
  {
    municipality: 'Lockstedt',
    postalCode: '25551'
  },
  {
    municipality: 'Loddin',
    postalCode: '17459'
  },
  {
    municipality: 'Lödla',
    postalCode: '04617'
  },
  {
    municipality: 'Löf',
    postalCode: '56332'
  },
  {
    municipality: 'Loffenau',
    postalCode: '76597'
  },
  {
    municipality: 'Löffingen',
    postalCode: '79843'
  },
  {
    municipality: 'Lohbarbek',
    postalCode: '25551'
  },
  {
    municipality: 'Lohberg',
    postalCode: '93470'
  },
  {
    municipality: 'Lohe-Föhrden',
    postalCode: '24806'
  },
  {
    municipality: 'Lohe-Rickelshof',
    postalCode: '25746'
  },
  {
    municipality: 'Lohfelden',
    postalCode: '34253'
  },
  {
    municipality: 'Lohheide',
    postalCode: '29303'
  },
  {
    municipality: 'Lohkirchen',
    postalCode: '84494'
  },
  {
    municipality: 'Löhma',
    postalCode: '07907'
  },
  {
    municipality: 'Lohmar',
    postalCode: '53797'
  },
  {
    municipality: 'Lohme',
    postalCode: '18551'
  },
  {
    municipality: 'Lohmen',
    postalCode: '01847'
  },
  {
    municipality: 'Lohmen',
    postalCode: '18276'
  },
  {
    municipality: 'Löhnberg',
    postalCode: '35792'
  },
  {
    municipality: 'Lohne',
    postalCode: '49393'
  },
  {
    municipality: 'Löhne',
    postalCode: '32584'
  },
  {
    municipality: 'Lohnsfeld',
    postalCode: '67727'
  },
  {
    municipality: 'Lohnweiler',
    postalCode: '67744'
  },
  {
    municipality: 'Lohra',
    postalCode: '35102'
  },
  {
    municipality: 'Lohr am Main',
    postalCode: '97816'
  },
  {
    municipality: 'Lohrheim',
    postalCode: '65558'
  },
  {
    municipality: 'Lohsa - Łaz',
    postalCode: '02999'
  },
  {
    municipality: 'Loiching',
    postalCode: '84180'
  },
  {
    municipality: 'Loissin',
    postalCode: '17509'
  },
  {
    municipality: 'Loit',
    postalCode: '24888'
  },
  {
    municipality: 'Loitsche-Heinrichsberg',
    postalCode: '39326'
  },
  {
    municipality: 'Loitz',
    postalCode: '17121'
  },
  {
    municipality: 'Loitzendorf',
    postalCode: '94359'
  },
  {
    municipality: 'Lollar',
    postalCode: '35457'
  },
  {
    municipality: 'Löllbach',
    postalCode: '67744'
  },
  {
    municipality: 'Lollschied',
    postalCode: '56357'
  },
  {
    municipality: 'Lommatzsch',
    postalCode: '01623'
  },
  {
    municipality: 'Longen',
    postalCode: '54338'
  },
  {
    municipality: 'Longkamp',
    postalCode: '54472'
  },
  {
    municipality: 'Longuich',
    postalCode: '54340'
  },
  {
    municipality: 'Löningen',
    postalCode: '49624'
  },
  {
    municipality: 'Lonnerstadt',
    postalCode: '91475'
  },
  {
    municipality: 'Lonnig',
    postalCode: '56295'
  },
  {
    municipality: 'Lonsee',
    postalCode: '89173'
  },
  {
    municipality: 'Lonsheim',
    postalCode: '55237'
  },
  {
    municipality: 'Looft',
    postalCode: '25582'
  },
  {
    municipality: 'Loop',
    postalCode: '24644'
  },
  {
    municipality: 'Loose',
    postalCode: '24366'
  },
  {
    municipality: 'Löptin',
    postalCode: '24250'
  },
  {
    municipality: 'Lorch',
    postalCode: '65391'
  },
  {
    municipality: 'Lorch',
    postalCode: '73547'
  },
  {
    municipality: 'Lörrach',
    postalCode: '79539'
  },
  {
    municipality: 'Lörrach',
    postalCode: '79540'
  },
  {
    municipality: 'Lörrach',
    postalCode: '79541'
  },
  {
    municipality: 'Lorsch',
    postalCode: '64653'
  },
  {
    municipality: 'Lorscheid',
    postalCode: '54317'
  },
  {
    municipality: 'Lorup',
    postalCode: '26901'
  },
  {
    municipality: 'Lörzweiler',
    postalCode: '55296'
  },
  {
    municipality: 'Losheim am See',
    postalCode: '66679'
  },
  {
    municipality: 'Lösnich',
    postalCode: '54492'
  },
  {
    municipality: 'Lossatal',
    postalCode: '04808'
  },
  {
    municipality: 'Loßburg',
    postalCode: '72290'
  },
  {
    municipality: 'Lößnitz',
    postalCode: '08294'
  },
  {
    municipality: 'Lotte',
    postalCode: '49504'
  },
  {
    municipality: 'Lottorf',
    postalCode: '24878'
  },
  {
    municipality: 'Lottstetten',
    postalCode: '79807'
  },
  {
    municipality: 'Lötzbeuren',
    postalCode: '56843'
  },
  {
    municipality: 'Löwenberger Land',
    postalCode: '16775'
  },
  {
    municipality: 'Löwenstedt',
    postalCode: '25864'
  },
  {
    municipality: 'Löwenstein',
    postalCode: '74245'
  },
  {
    municipality: 'Loxstedt',
    postalCode: '27612'
  },
  {
    municipality: 'Lübbecke',
    postalCode: '32312'
  },
  {
    municipality: 'Lübbenau/Spreewald',
    postalCode: '03222'
  },
  {
    municipality: 'Lübben (Spreewald)',
    postalCode: '15907'
  },
  {
    municipality: 'Lübberstedt',
    postalCode: '27729'
  },
  {
    municipality: 'Lübberstorf',
    postalCode: '23992'
  },
  {
    municipality: 'Lübbow',
    postalCode: '29488'
  },
  {
    municipality: 'Lübeck',
    postalCode: '23552'
  },
  {
    municipality: 'Lübeck',
    postalCode: '23554'
  },
  {
    municipality: 'Lübeck',
    postalCode: '23556'
  },
  {
    municipality: 'Lübeck',
    postalCode: '23558'
  },
  {
    municipality: 'Lübeck',
    postalCode: '23560'
  },
  {
    municipality: 'Lübeck',
    postalCode: '23562'
  },
  {
    municipality: 'Lübeck',
    postalCode: '23564'
  },
  {
    municipality: 'Lübeck',
    postalCode: '23566'
  },
  {
    municipality: 'Lübeck',
    postalCode: '23568'
  },
  {
    municipality: 'Lübeck',
    postalCode: '23569'
  },
  {
    municipality: 'Lübeck',
    postalCode: '23570'
  },
  {
    municipality: 'Lübesse',
    postalCode: '19077'
  },
  {
    municipality: 'Lüblow',
    postalCode: '19288'
  },
  {
    municipality: 'Lubmin',
    postalCode: '17509'
  },
  {
    municipality: 'Lübow',
    postalCode: '23972'
  },
  {
    municipality: 'Lübs',
    postalCode: '17379'
  },
  {
    municipality: 'Lübstorf',
    postalCode: '19069'
  },
  {
    municipality: 'Lübtheen',
    postalCode: '19249'
  },
  {
    municipality: 'Lübz',
    postalCode: '19386'
  },
  {
    municipality: 'Lüchow',
    postalCode: '23898'
  },
  {
    municipality: 'Lüchow',
    postalCode: '29439'
  },
  {
    municipality: 'Lucka',
    postalCode: '04613'
  },
  {
    municipality: 'Luckaitztal',
    postalCode: '03229'
  },
  {
    municipality: 'Luckau',
    postalCode: '15926'
  },
  {
    municipality: 'Luckau (Wendland)',
    postalCode: '29487'
  },
  {
    municipality: 'Luckenbach',
    postalCode: '57629'
  },
  {
    municipality: 'Lückenburg',
    postalCode: '54424'
  },
  {
    municipality: 'Luckenwalde',
    postalCode: '14943'
  },
  {
    municipality: 'Luckow',
    postalCode: '17375'
  },
  {
    municipality: 'Lüdenscheid',
    postalCode: '58507'
  },
  {
    municipality: 'Lüdenscheid',
    postalCode: '58509'
  },
  {
    municipality: 'Lüdenscheid',
    postalCode: '58511'
  },
  {
    municipality: 'Lüdenscheid',
    postalCode: '58513'
  },
  {
    municipality: 'Lüdenscheid',
    postalCode: '58515'
  },
  {
    municipality: 'Lüder',
    postalCode: '29394'
  },
  {
    municipality: 'Lüdersburg',
    postalCode: '21379'
  },
  {
    municipality: 'Lüdersdorf',
    postalCode: '23923'
  },
  {
    municipality: 'Lüdersfeld',
    postalCode: '31702'
  },
  {
    municipality: 'Lüdershagen',
    postalCode: '18314'
  },
  {
    municipality: 'Lüdinghausen',
    postalCode: '59348'
  },
  {
    municipality: 'Ludwigsau',
    postalCode: '36251'
  },
  {
    municipality: 'Ludwigsburg',
    postalCode: '71634'
  },
  {
    municipality: 'Ludwigsburg',
    postalCode: '71636'
  },
  {
    municipality: 'Ludwigsburg',
    postalCode: '71638'
  },
  {
    municipality: 'Ludwigsburg',
    postalCode: '71640'
  },
  {
    municipality: 'Ludwigsburg',
    postalCode: '71642'
  },
  {
    municipality: 'Ludwigsburg',
    postalCode: '71672'
  },
  {
    municipality: 'Ludwigschorgast',
    postalCode: '95364'
  },
  {
    municipality: 'Ludwigsfelde',
    postalCode: '14974'
  },
  {
    municipality: 'Ludwigshafen am Rhein',
    postalCode: '67059'
  },
  {
    municipality: 'Ludwigshafen am Rhein',
    postalCode: '67061'
  },
  {
    municipality: 'Ludwigshafen am Rhein',
    postalCode: '67063'
  },
  {
    municipality: 'Ludwigshafen am Rhein',
    postalCode: '67065'
  },
  {
    municipality: 'Ludwigshafen am Rhein',
    postalCode: '67067'
  },
  {
    municipality: 'Ludwigshafen am Rhein',
    postalCode: '67069'
  },
  {
    municipality: 'Ludwigshafen am Rhein',
    postalCode: '67071'
  },
  {
    municipality: 'Ludwigshöhe',
    postalCode: '55278'
  },
  {
    municipality: 'Ludwigslust',
    postalCode: '19288'
  },
  {
    municipality: 'Ludwigsstadt',
    postalCode: '96337'
  },
  {
    municipality: 'Ludwigswinkel',
    postalCode: '66996'
  },
  {
    municipality: 'Lüerdissen',
    postalCode: '37635'
  },
  {
    municipality: 'Lug',
    postalCode: '76848'
  },
  {
    municipality: 'Lugau',
    postalCode: '09385'
  },
  {
    municipality: 'Lügde',
    postalCode: '32676'
  },
  {
    municipality: 'Luhden',
    postalCode: '31711'
  },
  {
    municipality: 'Luhe-Wildenau',
    postalCode: '92706'
  },
  {
    municipality: 'Luhnstedt',
    postalCode: '24816'
  },
  {
    municipality: 'Luisenthal',
    postalCode: '99885'
  },
  {
    municipality: 'Lülsfeld',
    postalCode: '97511'
  },
  {
    municipality: 'Lunden',
    postalCode: '25774'
  },
  {
    municipality: 'Lünebach',
    postalCode: '54597'
  },
  {
    municipality: 'Lüneburg',
    postalCode: '21335'
  },
  {
    municipality: 'Lüneburg',
    postalCode: '21337'
  },
  {
    municipality: 'Lüneburg',
    postalCode: '21339'
  },
  {
    municipality: 'Lüneburg',
    postalCode: '21391'
  },
  {
    municipality: 'Lünen',
    postalCode: '44532'
  },
  {
    municipality: 'Lünen',
    postalCode: '44534'
  },
  {
    municipality: 'Lünen',
    postalCode: '44536'
  },
  {
    municipality: 'Lünne',
    postalCode: '48480'
  },
  {
    municipality: 'Lunow-Stolzenhagen',
    postalCode: '16248'
  },
  {
    municipality: 'Lunzenau',
    postalCode: '09328'
  },
  {
    municipality: 'Lupburg',
    postalCode: '92331'
  },
  {
    municipality: 'Lürschau',
    postalCode: '24850'
  },
  {
    municipality: 'Lüssow',
    postalCode: '18442'
  },
  {
    municipality: 'Lüssow',
    postalCode: '18276'
  },
  {
    municipality: 'Lustadt',
    postalCode: '67363'
  },
  {
    municipality: 'Lütau',
    postalCode: '21483'
  },
  {
    municipality: 'Lütetsburg',
    postalCode: '26524'
  },
  {
    municipality: 'Lutherstadt Eisleben',
    postalCode: '06295'
  },
  {
    municipality: 'Lütjenburg',
    postalCode: '24321'
  },
  {
    municipality: 'Lütjenholm',
    postalCode: '25842'
  },
  {
    municipality: 'Lütjensee',
    postalCode: '22952'
  },
  {
    municipality: 'Lütjenwestedt',
    postalCode: '25585'
  },
  {
    municipality: 'Lütow',
    postalCode: '17440'
  },
  {
    municipality: 'Lutter',
    postalCode: '37318'
  },
  {
    municipality: 'Lutterbek',
    postalCode: '24235'
  },
  {
    municipality: 'Lüttow-Valluhn',
    postalCode: '19246'
  },
  {
    municipality: 'Lütz',
    postalCode: '56290'
  },
  {
    municipality: 'Lützelbach',
    postalCode: '64750'
  },
  {
    municipality: 'Lützen',
    postalCode: '06686'
  },
  {
    municipality: 'Lutzerath',
    postalCode: '56826'
  },
  {
    municipality: 'Lutzhorn',
    postalCode: '25355'
  },
  {
    municipality: 'Lutzingen',
    postalCode: '89440'
  },
  {
    municipality: 'Lützkampen',
    postalCode: '54617'
  },
  {
    municipality: 'Lützow',
    postalCode: '19209'
  },
  {
    municipality: 'Luxem',
    postalCode: '56729'
  },
  {
    municipality: 'Lychen',
    postalCode: '17279'
  },
  {
    municipality: 'Lykershausen',
    postalCode: '56346'
  },
  {
    municipality: 'Maasbüll',
    postalCode: '24975'
  },
  {
    municipality: 'Maasen',
    postalCode: '27249'
  },
  {
    municipality: 'Maasholm',
    postalCode: '24404'
  },
  {
    municipality: 'Machern',
    postalCode: '04827'
  },
  {
    municipality: 'Macken',
    postalCode: '56290'
  },
  {
    municipality: 'Mackenbach',
    postalCode: '67686'
  },
  {
    municipality: 'Mackenrode',
    postalCode: '37318'
  },
  {
    municipality: 'Mackenrodt',
    postalCode: '55758'
  },
  {
    municipality: 'Magdala',
    postalCode: '99441'
  },
  {
    municipality: 'Magdeburg',
    postalCode: '39104'
  },
  {
    municipality: 'Magdeburg',
    postalCode: '39106'
  },
  {
    municipality: 'Magdeburg',
    postalCode: '39108'
  },
  {
    municipality: 'Magdeburg',
    postalCode: '39110'
  },
  {
    municipality: 'Magdeburg',
    postalCode: '39112'
  },
  {
    municipality: 'Magdeburg',
    postalCode: '39114'
  },
  {
    municipality: 'Magdeburg',
    postalCode: '39116'
  },
  {
    municipality: 'Magdeburg',
    postalCode: '39118'
  },
  {
    municipality: 'Magdeburg',
    postalCode: '39120'
  },
  {
    municipality: 'Magdeburg',
    postalCode: '39122'
  },
  {
    municipality: 'Magdeburg',
    postalCode: '39124'
  },
  {
    municipality: 'Magdeburg',
    postalCode: '39126'
  },
  {
    municipality: 'Magdeburg',
    postalCode: '39128'
  },
  {
    municipality: 'Magdeburg',
    postalCode: '39130'
  },
  {
    municipality: 'Magstadt',
    postalCode: '71106'
  },
  {
    municipality: 'Mahlberg',
    postalCode: '77972'
  },
  {
    municipality: 'Mahlstetten',
    postalCode: '78601'
  },
  {
    municipality: 'Mähren',
    postalCode: '56459'
  },
  {
    municipality: 'Mähring',
    postalCode: '95695'
  },
  {
    municipality: 'Maierhöfen',
    postalCode: '88167'
  },
  {
    municipality: 'Maihingen',
    postalCode: '86747'
  },
  {
    municipality: 'Maikammer',
    postalCode: '67487'
  },
  {
    municipality: 'Mainaschaff',
    postalCode: '63814'
  },
  {
    municipality: 'Mainbernheim',
    postalCode: '97350'
  },
  {
    municipality: 'Mainburg',
    postalCode: '84048'
  },
  {
    municipality: 'Mainhardt',
    postalCode: '74535'
  },
  {
    municipality: 'Mainhausen',
    postalCode: '63533'
  },
  {
    municipality: 'Mainleus',
    postalCode: '95336'
  },
  {
    municipality: 'Mainstockheim',
    postalCode: '97320'
  },
  {
    municipality: 'Maintal',
    postalCode: '63477'
  },
  {
    municipality: 'Mainz',
    postalCode: '55116'
  },
  {
    municipality: 'Mainz',
    postalCode: '55118'
  },
  {
    municipality: 'Mainz',
    postalCode: '55120'
  },
  {
    municipality: 'Mainz',
    postalCode: '55122'
  },
  {
    municipality: 'Mainz',
    postalCode: '55124'
  },
  {
    municipality: 'Mainz',
    postalCode: '55126'
  },
  {
    municipality: 'Mainz',
    postalCode: '55127'
  },
  {
    municipality: 'Mainz',
    postalCode: '55128'
  },
  {
    municipality: 'Mainz',
    postalCode: '55129'
  },
  {
    municipality: 'Mainz',
    postalCode: '55130'
  },
  {
    municipality: 'Mainz',
    postalCode: '55131'
  },
  {
    municipality: 'Maisach',
    postalCode: '82216'
  },
  {
    municipality: 'Maisborn',
    postalCode: '56291'
  },
  {
    municipality: 'Maitenbeth',
    postalCode: '83558'
  },
  {
    municipality: 'Maitzborn',
    postalCode: '55481'
  },
  {
    municipality: 'Malberg',
    postalCode: '57629'
  },
  {
    municipality: 'Malberg',
    postalCode: '54655'
  },
  {
    municipality: 'Malbergweich',
    postalCode: '54655'
  },
  {
    municipality: 'Malborn',
    postalCode: '54426'
  },
  {
    municipality: 'Malchin',
    postalCode: '17139'
  },
  {
    municipality: 'Malching',
    postalCode: '94094'
  },
  {
    municipality: 'Malchow',
    postalCode: '17213'
  },
  {
    municipality: 'Malente',
    postalCode: '23714'
  },
  {
    municipality: 'Malgersdorf',
    postalCode: '84333'
  },
  {
    municipality: 'Malk Göhren',
    postalCode: '19294'
  },
  {
    municipality: 'Mallersdorf-Pfaffenberg',
    postalCode: '84066'
  },
  {
    municipality: 'Malliß',
    postalCode: '19294'
  },
  {
    municipality: 'Malsburg-Marzell',
    postalCode: '79429'
  },
  {
    municipality: 'Malsch',
    postalCode: '69254'
  },
  {
    municipality: 'Malsch',
    postalCode: '76316'
  },
  {
    municipality: 'Malschwitz - Malešecy',
    postalCode: '02694'
  },
  {
    municipality: 'Malsfeld',
    postalCode: '34323'
  },
  {
    municipality: 'Malterdingen',
    postalCode: '79364'
  },
  {
    municipality: 'Mammelzen',
    postalCode: '57636'
  },
  {
    municipality: 'Mammendorf',
    postalCode: '82291'
  },
  {
    municipality: 'Mamming',
    postalCode: '94437'
  },
  {
    municipality: 'Manching',
    postalCode: '85077'
  },
  {
    municipality: 'Mandel',
    postalCode: '55595'
  },
  {
    municipality: 'Mandelbachtal',
    postalCode: '66399'
  },
  {
    municipality: 'Mandern',
    postalCode: '54429'
  },
  {
    municipality: 'Manderscheid',
    postalCode: '54649'
  },
  {
    municipality: 'Manderscheid',
    postalCode: '54531'
  },
  {
    municipality: 'Manhagen',
    postalCode: '23738'
  },
  {
    municipality: 'Mannebach',
    postalCode: '56769'
  },
  {
    municipality: 'Mannebach',
    postalCode: '54441'
  },
  {
    municipality: 'Mannheim',
    postalCode: '68159'
  },
  {
    municipality: 'Mannheim',
    postalCode: '68161'
  },
  {
    municipality: 'Mannheim',
    postalCode: '68163'
  },
  {
    municipality: 'Mannheim',
    postalCode: '68165'
  },
  {
    municipality: 'Mannheim',
    postalCode: '68167'
  },
  {
    municipality: 'Mannheim',
    postalCode: '68169'
  },
  {
    municipality: 'Mannheim',
    postalCode: '68199'
  },
  {
    municipality: 'Mannheim',
    postalCode: '68219'
  },
  {
    municipality: 'Mannheim',
    postalCode: '68229'
  },
  {
    municipality: 'Mannheim',
    postalCode: '68239'
  },
  {
    municipality: 'Mannheim',
    postalCode: '68259'
  },
  {
    municipality: 'Mannheim',
    postalCode: '68305'
  },
  {
    municipality: 'Mannheim',
    postalCode: '68307'
  },
  {
    municipality: 'Mannheim',
    postalCode: '68309'
  },
  {
    municipality: 'Mannweiler-Cölln',
    postalCode: '67822'
  },
  {
    municipality: 'Mansfeld',
    postalCode: '06343'
  },
  {
    municipality: 'Mantel',
    postalCode: '92708'
  },
  {
    municipality: 'Manubach',
    postalCode: '55413'
  },
  {
    municipality: 'Marbach am Neckar',
    postalCode: '71672'
  },
  {
    municipality: 'Marbach am Neckar',
    postalCode: '71711'
  },
  {
    municipality: 'Marburg',
    postalCode: '35037'
  },
  {
    municipality: 'Marburg',
    postalCode: '35039'
  },
  {
    municipality: 'Marburg',
    postalCode: '35041'
  },
  {
    municipality: 'Marburg',
    postalCode: '35043'
  },
  {
    municipality: 'Marburg',
    postalCode: '35094'
  },
  {
    municipality: 'March',
    postalCode: '79232'
  },
  {
    municipality: 'Margetshöchheim',
    postalCode: '97276'
  },
  {
    municipality: 'Mariaposching',
    postalCode: '94553'
  },
  {
    municipality: 'Marienberg',
    postalCode: '09496'
  },
  {
    municipality: 'Marienfels',
    postalCode: '56357'
  },
  {
    municipality: 'Marienfließ',
    postalCode: '16945'
  },
  {
    municipality: 'Marienhafe',
    postalCode: '26529'
  },
  {
    municipality: 'Marienhausen',
    postalCode: '56269'
  },
  {
    municipality: 'Marienheide',
    postalCode: '51709'
  },
  {
    municipality: 'Marienmünster',
    postalCode: '37696'
  },
  {
    municipality: 'Marienrachdorf',
    postalCode: '56242'
  },
  {
    municipality: 'Mariental',
    postalCode: '38368'
  },
  {
    municipality: 'Marienwerder',
    postalCode: '16348'
  },
  {
    municipality: 'Maring-Noviand',
    postalCode: '54484'
  },
  {
    municipality: 'Marisfeld',
    postalCode: '98530'
  },
  {
    municipality: 'Markdorf',
    postalCode: '88677'
  },
  {
    municipality: 'Markersdorf',
    postalCode: '02829'
  },
  {
    municipality: 'Markgröningen',
    postalCode: '71706'
  },
  {
    municipality: 'Märkisch Buchholz',
    postalCode: '15748'
  },
  {
    municipality: 'Märkische Heide',
    postalCode: '15913'
  },
  {
    municipality: 'Märkische Höhe',
    postalCode: '15377'
  },
  {
    municipality: 'Märkisch Linden',
    postalCode: '16818'
  },
  {
    municipality: 'Märkisch Luch',
    postalCode: '14715'
  },
  {
    municipality: 'Markkleeberg',
    postalCode: '04416'
  },
  {
    municipality: 'Mark Landin',
    postalCode: '16278'
  },
  {
    municipality: 'Marklkofen',
    postalCode: '84163'
  },
  {
    municipality: 'Marklohe',
    postalCode: '31608'
  },
  {
    municipality: 'Markneukirchen',
    postalCode: '08258'
  },
  {
    municipality: 'Markranstädt',
    postalCode: '04420'
  },
  {
    municipality: 'Marktbergel',
    postalCode: '91613'
  },
  {
    municipality: 'Markt Berolzheim',
    postalCode: '91801'
  },
  {
    municipality: 'Markt Bibart',
    postalCode: '91477'
  },
  {
    municipality: 'Marktbreit',
    postalCode: '97340'
  },
  {
    municipality: 'Markt Einersheim',
    postalCode: '97348'
  },
  {
    municipality: 'Markt Erlbach',
    postalCode: '91459'
  },
  {
    municipality: 'Marktgraitz',
    postalCode: '96257'
  },
  {
    municipality: 'Marktheidenfeld',
    postalCode: '97828'
  },
  {
    municipality: 'Markt Indersdorf',
    postalCode: '85229'
  },
  {
    municipality: 'Marktl',
    postalCode: '84533'
  },
  {
    municipality: 'Marktleugast',
    postalCode: '95352'
  },
  {
    municipality: 'Marktleuthen',
    postalCode: '95168'
  },
  {
    municipality: 'Markt Nordheim',
    postalCode: '91478'
  },
  {
    municipality: 'Marktoberdorf',
    postalCode: '87616'
  },
  {
    municipality: 'Marktoffingen',
    postalCode: '86748'
  },
  {
    municipality: 'Marktredwitz',
    postalCode: '95615'
  },
  {
    municipality: 'Markt Rettenbach',
    postalCode: '87733'
  },
  {
    municipality: 'Marktrodach',
    postalCode: '96364'
  },
  {
    municipality: 'Marktschellenberg',
    postalCode: '83487'
  },
  {
    municipality: 'Marktschorgast',
    postalCode: '95509'
  },
  {
    municipality: 'Markt Schwaben',
    postalCode: '85570'
  },
  {
    municipality: 'Marktsteft',
    postalCode: '97342'
  },
  {
    municipality: 'Markt Taschendorf',
    postalCode: '91480'
  },
  {
    municipality: 'Markt Wald',
    postalCode: '86865'
  },
  {
    municipality: 'Marktzeuln',
    postalCode: '96275'
  },
  {
    municipality: 'Markvippach',
    postalCode: '99195'
  },
  {
    municipality: 'Marl',
    postalCode: '45768'
  },
  {
    municipality: 'Marl',
    postalCode: '45770'
  },
  {
    municipality: 'Marl',
    postalCode: '45772'
  },
  {
    municipality: 'Marl',
    postalCode: '49448'
  },
  {
    municipality: 'Marloffstein',
    postalCode: '91080'
  },
  {
    municipality: 'Marlow',
    postalCode: '18337'
  },
  {
    municipality: 'Marne',
    postalCode: '25709'
  },
  {
    municipality: 'Marnerdeich',
    postalCode: '25709'
  },
  {
    municipality: 'Marnheim',
    postalCode: '67297'
  },
  {
    municipality: 'Maroldsweisach',
    postalCode: '96126'
  },
  {
    municipality: 'Marolterode',
    postalCode: '99994'
  },
  {
    municipality: 'Maroth',
    postalCode: '56271'
  },
  {
    municipality: 'Marpingen',
    postalCode: '66646'
  },
  {
    municipality: 'Marquartstein',
    postalCode: '83250'
  },
  {
    municipality: 'Marsberg',
    postalCode: '34431'
  },
  {
    municipality: 'Marschacht',
    postalCode: '21436'
  },
  {
    municipality: 'Martensrade',
    postalCode: '24238'
  },
  {
    municipality: 'Martfeld',
    postalCode: '27327'
  },
  {
    municipality: 'Marth',
    postalCode: '37318'
  },
  {
    municipality: 'Martinroda',
    postalCode: '98693'
  },
  {
    municipality: 'Martinsheim',
    postalCode: '97340'
  },
  {
    municipality: 'Martinshöhe',
    postalCode: '66894'
  },
  {
    municipality: 'Martinstein',
    postalCode: '55627'
  },
  {
    municipality: 'Marxen',
    postalCode: '21439'
  },
  {
    municipality: 'Marxheim',
    postalCode: '86688'
  },
  {
    municipality: 'Marxzell',
    postalCode: '76359'
  },
  {
    municipality: 'Marzhausen',
    postalCode: '57627'
  },
  {
    municipality: 'Marzling',
    postalCode: '85417'
  },
  {
    municipality: 'Masburg',
    postalCode: '56761'
  },
  {
    municipality: 'Maselheim',
    postalCode: '88437'
  },
  {
    municipality: 'Maßbach',
    postalCode: '97711'
  },
  {
    municipality: 'Massenbachhausen',
    postalCode: '74252'
  },
  {
    municipality: 'Massen-Niederlausitz',
    postalCode: '03238'
  },
  {
    municipality: 'Massen-Niederlausitz',
    postalCode: '03246'
  },
  {
    municipality: 'Masserberg',
    postalCode: '98666'
  },
  {
    municipality: 'Massing',
    postalCode: '84323'
  },
  {
    municipality: 'Maßweiler',
    postalCode: '66506'
  },
  {
    municipality: 'Mastershausen',
    postalCode: '56869'
  },
  {
    municipality: 'Masthorn',
    postalCode: '54597'
  },
  {
    municipality: 'Matzenbach',
    postalCode: '66909'
  },
  {
    municipality: 'Matzerath',
    postalCode: '54597'
  },
  {
    municipality: 'Mauchenheim',
    postalCode: '67294'
  },
  {
    municipality: 'Mauden',
    postalCode: '57520'
  },
  {
    municipality: 'Mauel',
    postalCode: '54649'
  },
  {
    municipality: 'Mauer',
    postalCode: '69256'
  },
  {
    municipality: 'Mauern',
    postalCode: '85419'
  },
  {
    municipality: 'Mauerstetten',
    postalCode: '87665'
  },
  {
    municipality: 'Maulbronn',
    postalCode: '75433'
  },
  {
    municipality: 'Maulburg',
    postalCode: '79689'
  },
  {
    municipality: 'Mauschbach',
    postalCode: '66500'
  },
  {
    municipality: 'Mauth',
    postalCode: '94151'
  },
  {
    municipality: 'Maxdorf',
    postalCode: '67133'
  },
  {
    municipality: 'Maxhütte-Haidhof',
    postalCode: '93142'
  },
  {
    municipality: 'Maxsain',
    postalCode: '56244'
  },
  {
    municipality: 'Mayen',
    postalCode: '56727'
  },
  {
    municipality: 'Mayen',
    postalCode: '56729'
  },
  {
    municipality: 'Mayschoß',
    postalCode: '53508'
  },
  {
    municipality: 'Mechelroda',
    postalCode: '99441'
  },
  {
    municipality: 'Mechernich',
    postalCode: '53894'
  },
  {
    municipality: 'Mechow',
    postalCode: '23909'
  },
  {
    municipality: 'Mechtersen',
    postalCode: '21358'
  },
  {
    municipality: 'Meckel',
    postalCode: '54636'
  },
  {
    municipality: 'Meckenbach',
    postalCode: '55606'
  },
  {
    municipality: 'Meckenbach',
    postalCode: '55767'
  },
  {
    municipality: 'Meckenbeuren',
    postalCode: '88074'
  },
  {
    municipality: 'Meckenheim',
    postalCode: '53340'
  },
  {
    municipality: 'Meckenheim',
    postalCode: '67149'
  },
  {
    municipality: 'Meckesheim',
    postalCode: '74909'
  },
  {
    municipality: 'Medard',
    postalCode: '67744'
  },
  {
    municipality: 'Meddersheim',
    postalCode: '55566'
  },
  {
    municipality: 'Meddewade',
    postalCode: '23847'
  },
  {
    municipality: 'Medebach',
    postalCode: '59964'
  },
  {
    municipality: 'Medelby',
    postalCode: '24994'
  },
  {
    municipality: 'Medlingen',
    postalCode: '89441'
  },
  {
    municipality: 'Medow',
    postalCode: '17391'
  },
  {
    municipality: 'Meeder',
    postalCode: '96484'
  },
  {
    municipality: 'Meerane',
    postalCode: '08393'
  },
  {
    municipality: 'Meerbeck',
    postalCode: '31715'
  },
  {
    municipality: 'Meerbusch',
    postalCode: '40667'
  },
  {
    municipality: 'Meerbusch',
    postalCode: '40668'
  },
  {
    municipality: 'Meerbusch',
    postalCode: '40670'
  },
  {
    municipality: 'Meerfeld',
    postalCode: '54531'
  },
  {
    municipality: 'Meersburg',
    postalCode: '88709'
  },
  {
    municipality: 'Meesiger',
    postalCode: '17111'
  },
  {
    municipality: 'Meezen',
    postalCode: '24594'
  },
  {
    municipality: 'Megesheim',
    postalCode: '86750'
  },
  {
    municipality: 'Meggerdorf',
    postalCode: '24799'
  },
  {
    municipality: 'Meggerdorf',
    postalCode: '24861'
  },
  {
    municipality: 'Mehlbach',
    postalCode: '67735'
  },
  {
    municipality: 'Mehlbek',
    postalCode: '25588'
  },
  {
    municipality: 'Mehlingen',
    postalCode: '67678'
  },
  {
    municipality: 'Mehlmeisel',
    postalCode: '95694'
  },
  {
    municipality: 'Mehmels',
    postalCode: '98634'
  },
  {
    municipality: 'Mehna',
    postalCode: '04626'
  },
  {
    municipality: 'Mehren',
    postalCode: '57635'
  },
  {
    municipality: 'Mehren',
    postalCode: '54552'
  },
  {
    municipality: 'Mehring',
    postalCode: '84561'
  },
  {
    municipality: 'Mehring',
    postalCode: '54346'
  },
  {
    municipality: 'Mehrstetten',
    postalCode: '72537'
  },
  {
    municipality: 'Meiersberg',
    postalCode: '17375'
  },
  {
    municipality: 'Meinborn',
    postalCode: '56584'
  },
  {
    municipality: 'Meine',
    postalCode: '38527'
  },
  {
    municipality: 'Meinersen',
    postalCode: '38536'
  },
  {
    municipality: 'Meinerzhagen',
    postalCode: '58540'
  },
  {
    municipality: 'Meineweh',
    postalCode: '06721'
  },
  {
    municipality: 'Meinhard',
    postalCode: '37276'
  },
  {
    municipality: 'Meinheim',
    postalCode: '91802'
  },
  {
    municipality: 'Meiningen',
    postalCode: '98617'
  },
  {
    municipality: 'Meisburg',
    postalCode: '54570'
  },
  {
    municipality: 'Meisenheim',
    postalCode: '55590'
  },
  {
    municipality: 'Meißen',
    postalCode: '01662'
  },
  {
    municipality: 'Meißenheim',
    postalCode: '77974'
  },
  {
    municipality: 'Meißner',
    postalCode: '37290'
  },
  {
    municipality: 'Meitingen',
    postalCode: '86405'
  },
  {
    municipality: 'Melbeck',
    postalCode: '21406'
  },
  {
    municipality: 'Melchow',
    postalCode: '16230'
  },
  {
    municipality: 'Meldorf',
    postalCode: '25704'
  },
  {
    municipality: 'Melle',
    postalCode: '49324'
  },
  {
    municipality: 'Melle',
    postalCode: '49326'
  },
  {
    municipality: 'Melle',
    postalCode: '49328'
  },
  {
    municipality: 'Mellenthin',
    postalCode: '17429'
  },
  {
    municipality: 'Mellingen',
    postalCode: '99441'
  },
  {
    municipality: 'Mellinghausen',
    postalCode: '27249'
  },
  {
    municipality: 'Mellrichstadt',
    postalCode: '97638'
  },
  {
    municipality: 'Melsbach',
    postalCode: '56581'
  },
  {
    municipality: 'Melsdorf',
    postalCode: '24109'
  },
  {
    municipality: 'Melsungen',
    postalCode: '34212'
  },
  {
    municipality: 'Melz',
    postalCode: '17209'
  },
  {
    municipality: 'Memmelsdorf',
    postalCode: '96117'
  },
  {
    municipality: 'Memmingen',
    postalCode: '87700'
  },
  {
    municipality: 'Memmingerberg',
    postalCode: '87766'
  },
  {
    municipality: 'Menden',
    postalCode: '58706'
  },
  {
    municipality: 'Menden',
    postalCode: '58708'
  },
  {
    municipality: 'Menden',
    postalCode: '58710'
  },
  {
    municipality: 'Mendig',
    postalCode: '56743'
  },
  {
    municipality: 'Mengen',
    postalCode: '88512'
  },
  {
    municipality: 'Mengerschied',
    postalCode: '55490'
  },
  {
    municipality: 'Mengerskirchen',
    postalCode: '35794'
  },
  {
    municipality: 'Mengkofen',
    postalCode: '84152'
  },
  {
    municipality: 'Menningen',
    postalCode: '54310'
  },
  {
    municipality: 'Menslage',
    postalCode: '49637'
  },
  {
    municipality: 'Menteroda',
    postalCode: '99976'
  },
  {
    municipality: 'Menteroda',
    postalCode: '99996'
  },
  {
    municipality: 'Menzendorf',
    postalCode: '23923'
  },
  {
    municipality: 'Meppen',
    postalCode: '49716'
  },
  {
    municipality: 'Merching',
    postalCode: '86504'
  },
  {
    municipality: 'Merchweiler',
    postalCode: '66589'
  },
  {
    municipality: 'Merdingen',
    postalCode: '79291'
  },
  {
    municipality: 'Merenberg',
    postalCode: '35799'
  },
  {
    municipality: 'Mering',
    postalCode: '86415'
  },
  {
    municipality: 'Merkelbach',
    postalCode: '57629'
  },
  {
    municipality: 'Merkendorf',
    postalCode: '91732'
  },
  {
    municipality: 'Merklingen',
    postalCode: '89188'
  },
  {
    municipality: 'Merlscheid',
    postalCode: '54597'
  },
  {
    municipality: 'Mermuth',
    postalCode: '56283'
  },
  {
    municipality: 'Merschbach',
    postalCode: '54426'
  },
  {
    municipality: 'Merseburg',
    postalCode: '06217'
  },
  {
    municipality: 'Mertendorf',
    postalCode: '06618'
  },
  {
    municipality: 'Mertendorf',
    postalCode: '07619'
  },
  {
    municipality: 'Mertesdorf',
    postalCode: '54318'
  },
  {
    municipality: 'Mertesheim',
    postalCode: '67271'
  },
  {
    municipality: 'Mertingen',
    postalCode: '86690'
  },
  {
    municipality: 'Mertloch',
    postalCode: '56753'
  },
  {
    municipality: 'Merxheim',
    postalCode: '55627'
  },
  {
    municipality: 'Merzalben',
    postalCode: '66978'
  },
  {
    municipality: 'Merzdorf',
    postalCode: '04932'
  },
  {
    municipality: 'Merzen',
    postalCode: '49586'
  },
  {
    municipality: 'Merzenich',
    postalCode: '52399'
  },
  {
    municipality: 'Merzhausen',
    postalCode: '79249'
  },
  {
    municipality: 'Merzig',
    postalCode: '66663'
  },
  {
    municipality: 'Merzkirchen',
    postalCode: '54439'
  },
  {
    municipality: 'Merzweiler',
    postalCode: '67746'
  },
  {
    municipality: 'Meschede',
    postalCode: '59872'
  },
  {
    municipality: 'Mescherin',
    postalCode: '16307'
  },
  {
    municipality: 'Mesekenhagen',
    postalCode: '17498'
  },
  {
    municipality: 'Mesenich',
    postalCode: '56820'
  },
  {
    municipality: 'Mespelbrunn',
    postalCode: '63875'
  },
  {
    municipality: 'Messel',
    postalCode: '64409'
  },
  {
    municipality: 'Messenkamp',
    postalCode: '31867'
  },
  {
    municipality: 'Messerich',
    postalCode: '54636'
  },
  {
    municipality: 'Messingen',
    postalCode: '49832'
  },
  {
    municipality: 'Meßkirch',
    postalCode: '88605'
  },
  {
    municipality: 'Meßstetten',
    postalCode: '72469'
  },
  {
    municipality: 'Mestlin',
    postalCode: '19374'
  },
  {
    municipality: 'Metelen',
    postalCode: '48629'
  },
  {
    municipality: 'Metelsdorf',
    postalCode: '23972'
  },
  {
    municipality: 'Metten',
    postalCode: '94526'
  },
  {
    municipality: 'Mettendorf',
    postalCode: '54675'
  },
  {
    municipality: 'Mettenheim',
    postalCode: '84562'
  },
  {
    municipality: 'Mettenheim',
    postalCode: '67582'
  },
  {
    municipality: 'Metterich',
    postalCode: '54634'
  },
  {
    municipality: 'Mettingen',
    postalCode: '49497'
  },
  {
    municipality: 'Mettlach',
    postalCode: '66693'
  },
  {
    municipality: 'Mettmann',
    postalCode: '40822'
  },
  {
    municipality: 'Mettweiler',
    postalCode: '55777'
  },
  {
    municipality: 'Metzenhausen',
    postalCode: '55481'
  },
  {
    municipality: 'Metzingen',
    postalCode: '72555'
  },
  {
    municipality: 'Meudt',
    postalCode: '56414'
  },
  {
    municipality: 'Meura',
    postalCode: '98744'
  },
  {
    municipality: 'Meusebach',
    postalCode: '07646'
  },
  {
    municipality: 'Meuselwitz',
    postalCode: '04610'
  },
  {
    municipality: 'Meuspath',
    postalCode: '53520'
  },
  {
    municipality: 'Meyenburg',
    postalCode: '16945'
  },
  {
    municipality: 'Meyn',
    postalCode: '24980'
  },
  {
    municipality: 'Michelau in Oberfranken',
    postalCode: '96247'
  },
  {
    municipality: 'Michelau i.Steigerwald',
    postalCode: '97513'
  },
  {
    municipality: 'Michelbach',
    postalCode: '57610'
  },
  {
    municipality: 'Michelbach',
    postalCode: '56288'
  },
  {
    municipality: 'Michelbach an der Bilz',
    postalCode: '74544'
  },
  {
    municipality: 'Michelfeld',
    postalCode: '74545'
  },
  {
    municipality: 'Michelsneukirchen',
    postalCode: '93185'
  },
  {
    municipality: 'Michelstadt',
    postalCode: '64720'
  },
  {
    municipality: 'Michendorf',
    postalCode: '14552'
  },
  {
    municipality: 'Mickhausen',
    postalCode: '86866'
  },
  {
    municipality: 'Midlum',
    postalCode: '25938'
  },
  {
    municipality: 'Miehlen',
    postalCode: '56357'
  },
  {
    municipality: 'Mielkendorf',
    postalCode: '24247'
  },
  {
    municipality: 'Miellen',
    postalCode: '56132'
  },
  {
    municipality: 'Miesbach',
    postalCode: '83714'
  },
  {
    municipality: 'Miesitz',
    postalCode: '07819'
  },
  {
    municipality: 'Mietingen',
    postalCode: '88487'
  },
  {
    municipality: 'Milda',
    postalCode: '07751'
  },
  {
    municipality: 'Mildenau',
    postalCode: '09456'
  },
  {
    municipality: 'Mildstedt',
    postalCode: '25866'
  },
  {
    municipality: 'Millienhagen-Oebelitz',
    postalCode: '18461'
  },
  {
    municipality: 'Milmersdorf',
    postalCode: '17268'
  },
  {
    municipality: 'Milow',
    postalCode: '19294'
  },
  {
    municipality: 'Milow',
    postalCode: '19300'
  },
  {
    municipality: 'Milower Land',
    postalCode: '14715'
  },
  {
    municipality: 'Miltach',
    postalCode: '93468'
  },
  {
    municipality: 'Miltenberg',
    postalCode: '63897'
  },
  {
    municipality: 'Mindelheim',
    postalCode: '87719'
  },
  {
    municipality: 'Mindelstetten',
    postalCode: '93349'
  },
  {
    municipality: 'Minden',
    postalCode: '32423'
  },
  {
    municipality: 'Minden',
    postalCode: '32425'
  },
  {
    municipality: 'Minden',
    postalCode: '32427'
  },
  {
    municipality: 'Minden',
    postalCode: '32429'
  },
  {
    municipality: 'Minden',
    postalCode: '54310'
  },
  {
    municipality: 'Minderlittgen',
    postalCode: '54518'
  },
  {
    municipality: 'Minfeld',
    postalCode: '76872'
  },
  {
    municipality: 'Minheim',
    postalCode: '54518'
  },
  {
    municipality: 'Mintraching',
    postalCode: '93098'
  },
  {
    municipality: 'Mirow',
    postalCode: '17252'
  },
  {
    municipality: 'Misselberg',
    postalCode: '56377'
  },
  {
    municipality: 'Missen-Wilhams',
    postalCode: '87547'
  },
  {
    municipality: 'Mistelbach',
    postalCode: '95511'
  },
  {
    municipality: 'Mistelgau',
    postalCode: '95490'
  },
  {
    municipality: 'Mistorf',
    postalCode: '18276'
  },
  {
    municipality: 'Mittelangeln',
    postalCode: '24986'
  },
  {
    municipality: 'Mittelbiberach',
    postalCode: '88441'
  },
  {
    municipality: 'Mittelbrunn',
    postalCode: '66851'
  },
  {
    municipality: 'Mitteleschenbach',
    postalCode: '91734'
  },
  {
    municipality: 'Mittelfischbach',
    postalCode: '56370'
  },
  {
    municipality: 'Mittelherwigsdorf',
    postalCode: '02763'
  },
  {
    municipality: 'Mittelhof',
    postalCode: '57537'
  },
  {
    municipality: 'Mittelneufnach',
    postalCode: '86868'
  },
  {
    municipality: 'Mittelnkirchen',
    postalCode: '21720'
  },
  {
    municipality: 'Mittelpöllnitz',
    postalCode: '07819'
  },
  {
    municipality: 'Mittelreidenbach',
    postalCode: '55758'
  },
  {
    municipality: 'Mittelsinn',
    postalCode: '97785'
  },
  {
    municipality: 'Mittelsömmern',
    postalCode: '99955'
  },
  {
    municipality: 'Mittelstenahe',
    postalCode: '21770'
  },
  {
    municipality: 'Mittelstetten',
    postalCode: '82293'
  },
  {
    municipality: 'Mittelstrimmig',
    postalCode: '56858'
  },
  {
    municipality: 'Mittenaar',
    postalCode: '35756'
  },
  {
    municipality: 'Mittenwald',
    postalCode: '82481'
  },
  {
    municipality: 'Mittenwalde',
    postalCode: '15749'
  },
  {
    municipality: 'Mittenwalde',
    postalCode: '17268'
  },
  {
    municipality: 'Mitterfels',
    postalCode: '94360'
  },
  {
    municipality: 'Mitterskirchen',
    postalCode: '84335'
  },
  {
    municipality: 'Mitterteich',
    postalCode: '95666'
  },
  {
    municipality: 'Mittweida',
    postalCode: '09648'
  },
  {
    municipality: 'Mitwitz',
    postalCode: '96268'
  },
  {
    municipality: 'Mixdorf',
    postalCode: '15299'
  },
  {
    municipality: 'Möckern',
    postalCode: '39279'
  },
  {
    municipality: 'Möckern',
    postalCode: '39291'
  },
  {
    municipality: 'Möckern',
    postalCode: '07646'
  },
  {
    municipality: 'Möckmühl',
    postalCode: '74219'
  },
  {
    municipality: 'Mockrehna',
    postalCode: '04862'
  },
  {
    municipality: 'Modautal',
    postalCode: '64397'
  },
  {
    municipality: 'Mödingen',
    postalCode: '89426'
  },
  {
    municipality: 'Moers',
    postalCode: '47441'
  },
  {
    municipality: 'Moers',
    postalCode: '47443'
  },
  {
    municipality: 'Moers',
    postalCode: '47445'
  },
  {
    municipality: 'Moers',
    postalCode: '47447'
  },
  {
    municipality: 'Mogendorf',
    postalCode: '56424'
  },
  {
    municipality: 'Mögglingen',
    postalCode: '73563'
  },
  {
    municipality: 'Möglingen',
    postalCode: '71696'
  },
  {
    municipality: 'Mohlsdorf-Teichwolframsdorf',
    postalCode: '07987'
  },
  {
    municipality: 'Möhnesee',
    postalCode: '59519'
  },
  {
    municipality: 'Möhnsen',
    postalCode: '21493'
  },
  {
    municipality: 'Möhrendorf',
    postalCode: '91096'
  },
  {
    municipality: 'Mohrkirch',
    postalCode: '24392'
  },
  {
    municipality: 'Mohrkirch',
    postalCode: '24405'
  },
  {
    municipality: 'Mohrkirch',
    postalCode: '24891'
  },
  {
    municipality: 'Moisburg',
    postalCode: '21647'
  },
  {
    municipality: 'Molauer Land',
    postalCode: '06618'
  },
  {
    municipality: 'Molbergen',
    postalCode: '49696'
  },
  {
    municipality: 'Molfsee',
    postalCode: '24113'
  },
  {
    municipality: 'Möllenbeck',
    postalCode: '17237'
  },
  {
    municipality: 'Möllenbeck',
    postalCode: '19300'
  },
  {
    municipality: 'Möllenhagen',
    postalCode: '17219'
  },
  {
    municipality: 'Mölln',
    postalCode: '17091'
  },
  {
    municipality: 'Mölln',
    postalCode: '23879'
  },
  {
    municipality: 'Molsberg',
    postalCode: '56414'
  },
  {
    municipality: 'Molschleben',
    postalCode: '99869'
  },
  {
    municipality: 'Mölschow',
    postalCode: '17449'
  },
  {
    municipality: 'Mölsheim',
    postalCode: '67591'
  },
  {
    municipality: 'Moltzow',
    postalCode: '17194'
  },
  {
    municipality: 'Molzhain',
    postalCode: '57520'
  },
  {
    municipality: 'Mömbris',
    postalCode: '63776'
  },
  {
    municipality: 'Mömlingen',
    postalCode: '63853'
  },
  {
    municipality: 'Mommenheim',
    postalCode: '55278'
  },
  {
    municipality: 'Mönchberg',
    postalCode: '63933'
  },
  {
    municipality: 'Mönchengladbach',
    postalCode: '41061'
  },
  {
    municipality: 'Mönchengladbach',
    postalCode: '41063'
  },
  {
    municipality: 'Mönchengladbach',
    postalCode: '41065'
  },
  {
    municipality: 'Mönchengladbach',
    postalCode: '41066'
  },
  {
    municipality: 'Mönchengladbach',
    postalCode: '41068'
  },
  {
    municipality: 'Mönchengladbach',
    postalCode: '41069'
  },
  {
    municipality: 'Mönchengladbach',
    postalCode: '41169'
  },
  {
    municipality: 'Mönchengladbach',
    postalCode: '41179'
  },
  {
    municipality: 'Mönchengladbach',
    postalCode: '41189'
  },
  {
    municipality: 'Mönchengladbach',
    postalCode: '41199'
  },
  {
    municipality: 'Mönchengladbach',
    postalCode: '41236'
  },
  {
    municipality: 'Mönchengladbach',
    postalCode: '41238'
  },
  {
    municipality: 'Mönchengladbach',
    postalCode: '41239'
  },
  {
    municipality: 'Mönchgut',
    postalCode: '18586'
  },
  {
    municipality: 'Mönchhagen',
    postalCode: '18182'
  },
  {
    municipality: 'Mönchpfiffel-Nikolausrieth',
    postalCode: '06556'
  },
  {
    municipality: 'Mönchsdeggingen',
    postalCode: '86751'
  },
  {
    municipality: 'Mönchsroth',
    postalCode: '91614'
  },
  {
    municipality: 'Mönchweiler',
    postalCode: '78087'
  },
  {
    municipality: 'Monheim',
    postalCode: '86653'
  },
  {
    municipality: 'Monheim am Rhein',
    postalCode: '40789'
  },
  {
    municipality: 'Mönkeberg',
    postalCode: '24248'
  },
  {
    municipality: 'Mönkebude',
    postalCode: '17375'
  },
  {
    municipality: 'Mönkhagen',
    postalCode: '23619'
  },
  {
    municipality: 'Mönkloh',
    postalCode: '24576'
  },
  {
    municipality: 'Monreal',
    postalCode: '56729'
  },
  {
    municipality: 'Monschau',
    postalCode: '52156'
  },
  {
    municipality: 'Monsheim',
    postalCode: '67590'
  },
  {
    municipality: 'Mönsheim',
    postalCode: '71297'
  },
  {
    municipality: 'Monstab',
    postalCode: '04617'
  },
  {
    municipality: 'Montabaur',
    postalCode: '56410'
  },
  {
    municipality: 'Möntenich',
    postalCode: '56754'
  },
  {
    municipality: 'Monzelfeld',
    postalCode: '54472'
  },
  {
    municipality: 'Monzernheim',
    postalCode: '55234'
  },
  {
    municipality: 'Monzingen',
    postalCode: '55569'
  },
  {
    municipality: 'Moordiek',
    postalCode: '25597'
  },
  {
    municipality: 'Moorenweis',
    postalCode: '82272'
  },
  {
    municipality: 'Moorhusen',
    postalCode: '25554'
  },
  {
    municipality: 'Moormerland',
    postalCode: '26802'
  },
  {
    municipality: 'Moorrege',
    postalCode: '25436'
  },
  {
    municipality: 'Moorweg',
    postalCode: '26427'
  },
  {
    municipality: 'Moos',
    postalCode: '94554'
  },
  {
    municipality: 'Moos',
    postalCode: '78345'
  },
  {
    municipality: 'Moosach',
    postalCode: '85665'
  },
  {
    municipality: 'Moosbach',
    postalCode: '92709'
  },
  {
    municipality: 'Moosburg',
    postalCode: '85368'
  },
  {
    municipality: 'Moosburg',
    postalCode: '88422'
  },
  {
    municipality: 'Moosinning',
    postalCode: '85452'
  },
  {
    municipality: 'Moosthenning',
    postalCode: '84164'
  },
  {
    municipality: 'Moraas',
    postalCode: '19230'
  },
  {
    municipality: 'Morbach',
    postalCode: '54497'
  },
  {
    municipality: 'Mörel',
    postalCode: '24594'
  },
  {
    municipality: 'Mörfelden-Walldorf',
    postalCode: '64546'
  },
  {
    municipality: 'Moringen',
    postalCode: '37186'
  },
  {
    municipality: 'Moritzburg',
    postalCode: '01468'
  },
  {
    municipality: 'Moritzheim',
    postalCode: '56865'
  },
  {
    municipality: 'Mörlen',
    postalCode: '57583'
  },
  {
    municipality: 'Mörlenbach',
    postalCode: '69509'
  },
  {
    municipality: 'Mörnsheim',
    postalCode: '91804'
  },
  {
    municipality: 'Morsbach',
    postalCode: '51597'
  },
  {
    municipality: 'Mörsbach',
    postalCode: '57629'
  },
  {
    municipality: 'Mörschbach',
    postalCode: '55494'
  },
  {
    municipality: 'Morscheid',
    postalCode: '54317'
  },
  {
    municipality: 'Morschen',
    postalCode: '34326'
  },
  {
    municipality: 'Morschheim',
    postalCode: '67294'
  },
  {
    municipality: 'Mörschied',
    postalCode: '55758'
  },
  {
    municipality: 'Mörsdorf',
    postalCode: '56290'
  },
  {
    municipality: 'Mörsdorf',
    postalCode: '07646'
  },
  {
    municipality: 'Mörsfeld',
    postalCode: '67808'
  },
  {
    municipality: 'Morshausen',
    postalCode: '56283'
  },
  {
    municipality: 'Mörstadt',
    postalCode: '67591'
  },
  {
    municipality: 'Mosbach',
    postalCode: '74821'
  },
  {
    municipality: 'Mosbruch',
    postalCode: '56767'
  },
  {
    municipality: 'Moschheim',
    postalCode: '56424'
  },
  {
    municipality: 'Moselkern',
    postalCode: '56254'
  },
  {
    municipality: 'Möser',
    postalCode: '39175'
  },
  {
    municipality: 'Möser',
    postalCode: '39291'
  },
  {
    municipality: 'Mossautal',
    postalCode: '64756'
  },
  {
    municipality: 'Moßbach',
    postalCode: '07907'
  },
  {
    municipality: 'Mössingen',
    postalCode: '72116'
  },
  {
    municipality: 'Motten',
    postalCode: '97786'
  },
  {
    municipality: 'Möttingen',
    postalCode: '86753'
  },
  {
    municipality: 'Mötzing',
    postalCode: '93099'
  },
  {
    municipality: 'Mötzingen',
    postalCode: '71159'
  },
  {
    municipality: 'Moxa',
    postalCode: '07381'
  },
  {
    municipality: 'Mözen',
    postalCode: '23795'
  },
  {
    municipality: 'Much',
    postalCode: '53804'
  },
  {
    municipality: 'Mucheln',
    postalCode: '24238'
  },
  {
    municipality: 'Mücheln (Geiseltal)',
    postalCode: '06249'
  },
  {
    municipality: 'Mücheln (Geiseltal)',
    postalCode: '06255'
  },
  {
    municipality: 'Mücheln (Geiseltal)',
    postalCode: '06268'
  },
  {
    municipality: 'Mücheln (Geiseltal)',
    postalCode: '06632'
  },
  {
    municipality: 'Muchow',
    postalCode: '19300'
  },
  {
    municipality: 'Mücka - Mikow',
    postalCode: '02906'
  },
  {
    municipality: 'Mücke',
    postalCode: '35325'
  },
  {
    municipality: 'Mückeln',
    postalCode: '54558'
  },
  {
    municipality: 'Mudau',
    postalCode: '69427'
  },
  {
    municipality: 'Müden (Aller)',
    postalCode: '38539'
  },
  {
    municipality: 'Mudenbach',
    postalCode: '57614'
  },
  {
    municipality: 'Müden (Mosel)',
    postalCode: '56254'
  },
  {
    municipality: 'Mudersbach',
    postalCode: '57555'
  },
  {
    municipality: 'Mudershausen',
    postalCode: '65623'
  },
  {
    municipality: 'Mügeln',
    postalCode: '04769'
  },
  {
    municipality: 'Muggensturm',
    postalCode: '76461'
  },
  {
    municipality: 'Müglitztal',
    postalCode: '01809'
  },
  {
    municipality: 'Mühbrook',
    postalCode: '24582'
  },
  {
    municipality: 'Mühlacker',
    postalCode: '75417'
  },
  {
    municipality: 'Mühlau',
    postalCode: '09241'
  },
  {
    municipality: 'Mühlberg/Elbe',
    postalCode: '04895'
  },
  {
    municipality: 'Mühlberg/Elbe',
    postalCode: '04931'
  },
  {
    municipality: 'Mühldorf a. Inn',
    postalCode: '84453'
  },
  {
    municipality: 'Mühlenbach',
    postalCode: '77796'
  },
  {
    municipality: 'Mühlenbarbek',
    postalCode: '25548'
  },
  {
    municipality: 'Mühlenbecker Land',
    postalCode: '16515'
  },
  {
    municipality: 'Mühlenbecker Land',
    postalCode: '16552'
  },
  {
    municipality: 'Mühlenbecker Land',
    postalCode: '16567'
  },
  {
    municipality: 'Mühlenberge',
    postalCode: '14662'
  },
  {
    municipality: 'Mühlen Eichsen',
    postalCode: '19205'
  },
  {
    municipality: 'Mühlenfließ',
    postalCode: '14822'
  },
  {
    municipality: 'Mühlenfließ',
    postalCode: '14823'
  },
  {
    municipality: 'Mühlenrade',
    postalCode: '21493'
  },
  {
    municipality: 'Mühlental',
    postalCode: '08626'
  },
  {
    municipality: 'Mühlhausen',
    postalCode: '69242'
  },
  {
    municipality: 'Mühlhausen',
    postalCode: '96172'
  },
  {
    municipality: 'Mühlhausen',
    postalCode: '92360'
  },
  {
    municipality: 'Mühlhausen',
    postalCode: '99974'
  },
  {
    municipality: 'Mühlhausen',
    postalCode: '99998'
  },
  {
    municipality: 'Mühlhausen-Ehingen',
    postalCode: '78259'
  },
  {
    municipality: 'Mühlhausen im Täle',
    postalCode: '73347'
  },
  {
    municipality: 'Mühlheim am Main',
    postalCode: '63165'
  },
  {
    municipality: 'Mühlheim an der Donau',
    postalCode: '78570'
  },
  {
    municipality: 'Mühlingen',
    postalCode: '78357'
  },
  {
    municipality: 'Mühlpfad',
    postalCode: '56291'
  },
  {
    municipality: 'Mühl Rosin',
    postalCode: '18276'
  },
  {
    municipality: 'Mühltal',
    postalCode: '64367'
  },
  {
    municipality: 'Muhr am See',
    postalCode: '91735'
  },
  {
    municipality: 'Mülbach',
    postalCode: '54636'
  },
  {
    municipality: 'Mulda/Sachsen',
    postalCode: '09619'
  },
  {
    municipality: 'Muldenhammer',
    postalCode: '08262'
  },
  {
    municipality: 'Muldestausee',
    postalCode: '06774'
  },
  {
    municipality: 'Mulfingen',
    postalCode: '74673'
  },
  {
    municipality: 'Mülheim an der Mosel',
    postalCode: '54486'
  },
  {
    municipality: 'Mülheim an der Ruhr',
    postalCode: '45468'
  },
  {
    municipality: 'Mülheim an der Ruhr',
    postalCode: '45470'
  },
  {
    municipality: 'Mülheim an der Ruhr',
    postalCode: '45472'
  },
  {
    municipality: 'Mülheim an der Ruhr',
    postalCode: '45473'
  },
  {
    municipality: 'Mülheim an der Ruhr',
    postalCode: '45475'
  },
  {
    municipality: 'Mülheim an der Ruhr',
    postalCode: '45476'
  },
  {
    municipality: 'Mülheim an der Ruhr',
    postalCode: '45478'
  },
  {
    municipality: 'Mülheim an der Ruhr',
    postalCode: '45479'
  },
  {
    municipality: 'Mülheim an der Ruhr',
    postalCode: '45481'
  },
  {
    municipality: 'Mülheim-Kärlich',
    postalCode: '56218'
  },
  {
    municipality: 'Müllenbach',
    postalCode: '53520'
  },
  {
    municipality: 'Müllenbach',
    postalCode: '56761'
  },
  {
    municipality: 'Müllheim',
    postalCode: '79379'
  },
  {
    municipality: 'Müllrose',
    postalCode: '15299'
  },
  {
    municipality: 'Mülsen',
    postalCode: '08132'
  },
  {
    municipality: 'Münchberg',
    postalCode: '95213'
  },
  {
    municipality: 'Müncheberg',
    postalCode: '15374'
  },
  {
    municipality: 'Münchehofe',
    postalCode: '15748'
  },
  {
    municipality: 'München',
    postalCode: '80331'
  },
  {
    municipality: 'München',
    postalCode: '80333'
  },
  {
    municipality: 'München',
    postalCode: '80335'
  },
  {
    municipality: 'München',
    postalCode: '80336'
  },
  {
    municipality: 'München',
    postalCode: '80337'
  },
  {
    municipality: 'München',
    postalCode: '80339'
  },
  {
    municipality: 'München',
    postalCode: '80469'
  },
  {
    municipality: 'München',
    postalCode: '80538'
  },
  {
    municipality: 'München',
    postalCode: '80539'
  },
  {
    municipality: 'München',
    postalCode: '80634'
  },
  {
    municipality: 'München',
    postalCode: '80636'
  },
  {
    municipality: 'München',
    postalCode: '80637'
  },
  {
    municipality: 'München',
    postalCode: '80638'
  },
  {
    municipality: 'München',
    postalCode: '80639'
  },
  {
    municipality: 'München',
    postalCode: '80686'
  },
  {
    municipality: 'München',
    postalCode: '80687'
  },
  {
    municipality: 'München',
    postalCode: '80689'
  },
  {
    municipality: 'München',
    postalCode: '80796'
  },
  {
    municipality: 'München',
    postalCode: '80797'
  },
  {
    municipality: 'München',
    postalCode: '80798'
  },
  {
    municipality: 'München',
    postalCode: '80799'
  },
  {
    municipality: 'München',
    postalCode: '80801'
  },
  {
    municipality: 'München',
    postalCode: '80802'
  },
  {
    municipality: 'München',
    postalCode: '80803'
  },
  {
    municipality: 'München',
    postalCode: '80804'
  },
  {
    municipality: 'München',
    postalCode: '80805'
  },
  {
    municipality: 'München',
    postalCode: '80807'
  },
  {
    municipality: 'München',
    postalCode: '80809'
  },
  {
    municipality: 'München',
    postalCode: '80933'
  },
  {
    municipality: 'München',
    postalCode: '80935'
  },
  {
    municipality: 'München',
    postalCode: '80937'
  },
  {
    municipality: 'München',
    postalCode: '80939'
  },
  {
    municipality: 'München',
    postalCode: '80992'
  },
  {
    municipality: 'München',
    postalCode: '80993'
  },
  {
    municipality: 'München',
    postalCode: '80995'
  },
  {
    municipality: 'München',
    postalCode: '80997'
  },
  {
    municipality: 'München',
    postalCode: '80999'
  },
  {
    municipality: 'München',
    postalCode: '81241'
  },
  {
    municipality: 'München',
    postalCode: '81243'
  },
  {
    municipality: 'München',
    postalCode: '81245'
  },
  {
    municipality: 'München',
    postalCode: '81247'
  },
  {
    municipality: 'München',
    postalCode: '81248'
  },
  {
    municipality: 'München',
    postalCode: '81249'
  },
  {
    municipality: 'München',
    postalCode: '81369'
  },
  {
    municipality: 'München',
    postalCode: '81371'
  },
  {
    municipality: 'München',
    postalCode: '81373'
  },
  {
    municipality: 'München',
    postalCode: '81375'
  },
  {
    municipality: 'München',
    postalCode: '81377'
  },
  {
    municipality: 'München',
    postalCode: '81379'
  },
  {
    municipality: 'München',
    postalCode: '81475'
  },
  {
    municipality: 'München',
    postalCode: '81476'
  },
  {
    municipality: 'München',
    postalCode: '81477'
  },
  {
    municipality: 'München',
    postalCode: '81479'
  },
  {
    municipality: 'München',
    postalCode: '81539'
  },
  {
    municipality: 'München',
    postalCode: '81541'
  },
  {
    municipality: 'München',
    postalCode: '81543'
  },
  {
    municipality: 'München',
    postalCode: '81545'
  },
  {
    municipality: 'München',
    postalCode: '81547'
  },
  {
    municipality: 'München',
    postalCode: '81549'
  },
  {
    municipality: 'München',
    postalCode: '81667'
  },
  {
    municipality: 'München',
    postalCode: '81669'
  },
  {
    municipality: 'München',
    postalCode: '81671'
  },
  {
    municipality: 'München',
    postalCode: '81673'
  },
  {
    municipality: 'München',
    postalCode: '81675'
  },
  {
    municipality: 'München',
    postalCode: '81677'
  },
  {
    municipality: 'München',
    postalCode: '81679'
  },
  {
    municipality: 'München',
    postalCode: '81735'
  },
  {
    municipality: 'München',
    postalCode: '81737'
  },
  {
    municipality: 'München',
    postalCode: '81739'
  },
  {
    municipality: 'München',
    postalCode: '81825'
  },
  {
    municipality: 'München',
    postalCode: '81827'
  },
  {
    municipality: 'München',
    postalCode: '81829'
  },
  {
    municipality: 'München',
    postalCode: '81925'
  },
  {
    municipality: 'München',
    postalCode: '81927'
  },
  {
    municipality: 'München',
    postalCode: '81929'
  },
  {
    municipality: 'München',
    postalCode: '85540'
  },
  {
    municipality: 'Münchenbernsdorf',
    postalCode: '07589'
  },
  {
    municipality: 'Münchhausen',
    postalCode: '35117'
  },
  {
    municipality: 'Münchsmünster',
    postalCode: '85126'
  },
  {
    municipality: 'Münchsteinach',
    postalCode: '91481'
  },
  {
    municipality: 'Münchwald',
    postalCode: '55595'
  },
  {
    municipality: 'Münchweiler am Klingbach',
    postalCode: '76857'
  },
  {
    municipality: 'Münchweiler an der Alsenz',
    postalCode: '67728'
  },
  {
    municipality: 'Münchweiler an der Rodalb',
    postalCode: '66955'
  },
  {
    municipality: 'Münchweiler an der Rodalb',
    postalCode: '66981'
  },
  {
    municipality: 'Mundelsheim',
    postalCode: '74395'
  },
  {
    municipality: 'Munderkingen',
    postalCode: '89597'
  },
  {
    municipality: 'Mündersbach',
    postalCode: '56271'
  },
  {
    municipality: 'Münk',
    postalCode: '56729'
  },
  {
    municipality: 'Munkbrarup',
    postalCode: '24960'
  },
  {
    municipality: 'Münnerstadt',
    postalCode: '97702'
  },
  {
    municipality: 'Munningen',
    postalCode: '86754'
  },
  {
    municipality: 'Münsing',
    postalCode: '82541'
  },
  {
    municipality: 'Münsingen',
    postalCode: '72525'
  },
  {
    municipality: 'Munster',
    postalCode: '29633'
  },
  {
    municipality: 'Münster',
    postalCode: '48143'
  },
  {
    municipality: 'Münster',
    postalCode: '48145'
  },
  {
    municipality: 'Münster',
    postalCode: '48147'
  },
  {
    municipality: 'Münster',
    postalCode: '48149'
  },
  {
    municipality: 'Münster',
    postalCode: '48151'
  },
  {
    municipality: 'Münster',
    postalCode: '48153'
  },
  {
    municipality: 'Münster',
    postalCode: '48155'
  },
  {
    municipality: 'Münster',
    postalCode: '48157'
  },
  {
    municipality: 'Münster',
    postalCode: '48159'
  },
  {
    municipality: 'Münster',
    postalCode: '48161'
  },
  {
    municipality: 'Münster',
    postalCode: '48163'
  },
  {
    municipality: 'Münster',
    postalCode: '48165'
  },
  {
    municipality: 'Münster',
    postalCode: '48167'
  },
  {
    municipality: 'Münster',
    postalCode: '86692'
  },
  {
    municipality: 'Münsterappel',
    postalCode: '67822'
  },
  {
    municipality: 'Münsterdorf',
    postalCode: '25587'
  },
  {
    municipality: 'Münsterhausen',
    postalCode: '86505'
  },
  {
    municipality: 'Münster (Hessen)',
    postalCode: '64839'
  },
  {
    municipality: 'Münstermaifeld',
    postalCode: '56294'
  },
  {
    municipality: 'Münster-Sarmsheim',
    postalCode: '55424'
  },
  {
    municipality: 'Münstertal/Schwarzwald',
    postalCode: '79244'
  },
  {
    municipality: 'Münzenberg',
    postalCode: '35516'
  },
  {
    municipality: 'Murchin',
    postalCode: '17390'
  },
  {
    municipality: 'Murg',
    postalCode: '79730'
  },
  {
    municipality: 'Mürlenbach',
    postalCode: '54570'
  },
  {
    municipality: 'Murnau am Staffelsee',
    postalCode: '82418'
  },
  {
    municipality: 'Murr',
    postalCode: '71711'
  },
  {
    municipality: 'Murrhardt',
    postalCode: '71540'
  },
  {
    municipality: 'Müsch',
    postalCode: '53533'
  },
  {
    municipality: 'Müschenbach',
    postalCode: '57629'
  },
  {
    municipality: 'Müssen',
    postalCode: '21516'
  },
  {
    municipality: 'Mustin',
    postalCode: '23911'
  },
  {
    municipality: 'Mustin',
    postalCode: '19406'
  },
  {
    municipality: 'Musweiler',
    postalCode: '54534'
  },
  {
    municipality: 'Mutlangen',
    postalCode: '73557'
  },
  {
    municipality: 'Mutterschied',
    postalCode: '55469'
  },
  {
    municipality: 'Mutterstadt',
    postalCode: '67112'
  },
  {
    municipality: 'Mützenich',
    postalCode: '54608'
  },
  {
    municipality: 'Muxerath',
    postalCode: '54673'
  },
  {
    municipality: 'Nabburg',
    postalCode: '92507'
  },
  {
    municipality: 'Nachrodt-Wiblingwerde',
    postalCode: '58769'
  },
  {
    municipality: 'Nachtsheim',
    postalCode: '56729'
  },
  {
    municipality: 'Nack',
    postalCode: '55234'
  },
  {
    municipality: 'Nackenheim',
    postalCode: '55299'
  },
  {
    municipality: 'Nadrensee',
    postalCode: '17329'
  },
  {
    municipality: 'Nagel',
    postalCode: '95697'
  },
  {
    municipality: 'Nagold',
    postalCode: '72202'
  },
  {
    municipality: 'Nahe',
    postalCode: '23866'
  },
  {
    municipality: 'Nahrendorf',
    postalCode: '21369'
  },
  {
    municipality: 'Naila',
    postalCode: '95119'
  },
  {
    municipality: 'Nalbach',
    postalCode: '66809'
  },
  {
    municipality: 'Namborn',
    postalCode: '66640'
  },
  {
    municipality: 'Nandlstadt',
    postalCode: '85395'
  },
  {
    municipality: 'Nandlstadt',
    postalCode: '85405'
  },
  {
    municipality: 'Nannhausen',
    postalCode: '55469'
  },
  {
    municipality: 'Nanzdietschweiler',
    postalCode: '66909'
  },
  {
    municipality: 'Nasingen',
    postalCode: '54673'
  },
  {
    municipality: 'Nassau',
    postalCode: '56377'
  },
  {
    municipality: 'Nassenfels',
    postalCode: '85128'
  },
  {
    municipality: 'Nastätten',
    postalCode: '56355'
  },
  {
    municipality: 'Natendorf',
    postalCode: '29587'
  },
  {
    municipality: 'Nattenheim',
    postalCode: '54636'
  },
  {
    municipality: 'Nattheim',
    postalCode: '89564'
  },
  {
    municipality: 'Nauen',
    postalCode: '14641'
  },
  {
    municipality: 'Nauendorf',
    postalCode: '99448'
  },
  {
    municipality: 'Nauheim',
    postalCode: '64569'
  },
  {
    municipality: 'Naumburg',
    postalCode: '34311'
  },
  {
    municipality: 'Naumburg (Saale)',
    postalCode: '06618'
  },
  {
    municipality: 'Naumburg (Saale)',
    postalCode: '06628'
  },
  {
    municipality: 'Naundorf',
    postalCode: '04769'
  },
  {
    municipality: 'Naunheim',
    postalCode: '56753'
  },
  {
    municipality: 'Naunhof',
    postalCode: '04683'
  },
  {
    municipality: 'Nauort',
    postalCode: '56237'
  },
  {
    municipality: 'Naurath (Eifel)',
    postalCode: '54340'
  },
  {
    municipality: 'Naurath (Wald)',
    postalCode: '54426'
  },
  {
    municipality: 'Nauroth',
    postalCode: '57583'
  },
  {
    municipality: 'Nausnitz',
    postalCode: '07616'
  },
  {
    municipality: 'Nazza',
    postalCode: '99826'
  },
  {
    municipality: 'Nebel',
    postalCode: '25946'
  },
  {
    municipality: 'Nebelschütz - Njebjelčicy',
    postalCode: '01920'
  },
  {
    municipality: 'Nebra (Unstrut)',
    postalCode: '06642'
  },
  {
    municipality: 'Neckarbischofsheim',
    postalCode: '74924'
  },
  {
    municipality: 'Neckargemünd',
    postalCode: '69151'
  },
  {
    municipality: 'Neckargerach',
    postalCode: '69437'
  },
  {
    municipality: 'Neckarsteinach',
    postalCode: '69239'
  },
  {
    municipality: 'Neckarsulm',
    postalCode: '74172'
  },
  {
    municipality: 'Neckartailfingen',
    postalCode: '72666'
  },
  {
    municipality: 'Neckartenzlingen',
    postalCode: '72654'
  },
  {
    municipality: 'Neckarwestheim',
    postalCode: '74382'
  },
  {
    municipality: 'Neckarzimmern',
    postalCode: '74865'
  },
  {
    municipality: 'Neddemin',
    postalCode: '17039'
  },
  {
    municipality: 'Neef',
    postalCode: '56858'
  },
  {
    municipality: 'Neenstetten',
    postalCode: '89189'
  },
  {
    municipality: 'Neetze',
    postalCode: '21398'
  },
  {
    municipality: 'Neetzka',
    postalCode: '17349'
  },
  {
    municipality: 'Neetzow-Liepen',
    postalCode: '17391'
  },
  {
    municipality: 'Negenborn',
    postalCode: '37643'
  },
  {
    municipality: 'Negenharrie',
    postalCode: '24625'
  },
  {
    municipality: 'Negernbötel',
    postalCode: '23795'
  },
  {
    municipality: 'Nehms',
    postalCode: '23813'
  },
  {
    municipality: 'Nehmten',
    postalCode: '24326'
  },
  {
    municipality: 'Nehren',
    postalCode: '56820'
  },
  {
    municipality: 'Nehren',
    postalCode: '72147'
  },
  {
    municipality: 'Neichen',
    postalCode: '54552'
  },
  {
    municipality: 'Neidenbach',
    postalCode: '54657'
  },
  {
    municipality: 'Neidenfels',
    postalCode: '67468'
  },
  {
    municipality: 'Neidenstein',
    postalCode: '74933'
  },
  {
    municipality: 'Neidlingen',
    postalCode: '73272'
  },
  {
    municipality: 'Neißeaue',
    postalCode: '02829'
  },
  {
    municipality: 'Neiße-Malxetal',
    postalCode: '03159'
  },
  {
    municipality: 'Neißemünde',
    postalCode: '15898'
  },
  {
    municipality: 'Neitersen',
    postalCode: '57638'
  },
  {
    municipality: 'Nellingen',
    postalCode: '89191'
  },
  {
    municipality: 'Nemsdorf-Göhrendorf',
    postalCode: '06268'
  },
  {
    municipality: 'Nenndorf',
    postalCode: '26556'
  },
  {
    municipality: 'Nennhausen',
    postalCode: '14715'
  },
  {
    municipality: 'Nennslingen',
    postalCode: '91790'
  },
  {
    municipality: 'Nentershausen',
    postalCode: '36214'
  },
  {
    municipality: 'Nentershausen',
    postalCode: '56412'
  },
  {
    municipality: 'Nerdlen',
    postalCode: '54552'
  },
  {
    municipality: 'Nerenstetten',
    postalCode: '89129'
  },
  {
    municipality: 'Neresheim',
    postalCode: '73450'
  },
  {
    municipality: 'Neritz',
    postalCode: '23843'
  },
  {
    municipality: 'Neroth',
    postalCode: '54570'
  },
  {
    municipality: 'Nersingen',
    postalCode: '89278'
  },
  {
    municipality: 'Nerzweiler',
    postalCode: '67749'
  },
  {
    municipality: 'Neschwitz - Njeswačidło',
    postalCode: '02699'
  },
  {
    municipality: 'Nesse-Apfelstädt',
    postalCode: '99192'
  },
  {
    municipality: 'Nesselwang',
    postalCode: '87484'
  },
  {
    municipality: 'Nessetal',
    postalCode: '99869'
  },
  {
    municipality: 'Netphen',
    postalCode: '57250'
  },
  {
    municipality: 'Nettelsee',
    postalCode: '24250'
  },
  {
    municipality: 'Nettersheim',
    postalCode: '53947'
  },
  {
    municipality: 'Nettetal',
    postalCode: '41334'
  },
  {
    municipality: 'Netzbach',
    postalCode: '65623'
  },
  {
    municipality: 'Netzschkau',
    postalCode: '08491'
  },
  {
    municipality: 'Neu-Anspach',
    postalCode: '61267'
  },
  {
    municipality: 'Neu-Bamberg',
    postalCode: '55546'
  },
  {
    municipality: 'Neuberend',
    postalCode: '24879'
  },
  {
    municipality: 'Neuberg',
    postalCode: '63543'
  },
  {
    municipality: 'Neubeuern',
    postalCode: '83115'
  },
  {
    municipality: 'Neubiberg',
    postalCode: '85579'
  },
  {
    municipality: 'Neu Boltenhagen',
    postalCode: '17509'
  },
  {
    municipality: 'Neubörger',
    postalCode: '26909'
  },
  {
    municipality: 'Neubrandenburg',
    postalCode: '17033'
  },
  {
    municipality: 'Neubrandenburg',
    postalCode: '17034'
  },
  {
    municipality: 'Neubrandenburg',
    postalCode: '17036'
  },
  {
    municipality: 'Neubrunn',
    postalCode: '97277'
  },
  {
    municipality: 'Neubrunn',
    postalCode: '98617'
  },
  {
    municipality: 'Neubukow',
    postalCode: '18233'
  },
  {
    municipality: 'Neubulach',
    postalCode: '75385'
  },
  {
    municipality: 'Neubulach',
    postalCode: '75387'
  },
  {
    municipality: 'Neuburg',
    postalCode: '23974'
  },
  {
    municipality: 'Neuburg am Inn',
    postalCode: '94036'
  },
  {
    municipality: 'Neuburg am Inn',
    postalCode: '94127'
  },
  {
    municipality: 'Neuburg am Rhein',
    postalCode: '76776'
  },
  {
    municipality: 'Neuburg an der Donau',
    postalCode: '86633'
  },
  {
    municipality: 'Neuburg an der Kammel',
    postalCode: '86476'
  },
  {
    municipality: 'Neuching',
    postalCode: '85467'
  },
  {
    municipality: 'Neu Darchau',
    postalCode: '29490'
  },
  {
    municipality: 'Neudenau',
    postalCode: '74861'
  },
  {
    municipality: 'Neudorf-Bornstein',
    postalCode: '24214'
  },
  {
    municipality: 'Neudrossenfeld',
    postalCode: '95512'
  },
  {
    municipality: 'Neu Duvenstedt',
    postalCode: '24791'
  },
  {
    municipality: 'Neu Duvenstedt',
    postalCode: '24794'
  },
  {
    municipality: 'Neu-Eichenberg',
    postalCode: '37249'
  },
  {
    municipality: 'Neuenbrook',
    postalCode: '25361'
  },
  {
    municipality: 'Neuenbrook',
    postalCode: '25578'
  },
  {
    municipality: 'Neuenbürg',
    postalCode: '75305'
  },
  {
    municipality: 'Neuenburg am Rhein',
    postalCode: '79395'
  },
  {
    municipality: 'Neuendeich',
    postalCode: '25436'
  },
  {
    municipality: 'Neuendettelsau',
    postalCode: '91564'
  },
  {
    municipality: 'Neuendorf',
    postalCode: '97788'
  },
  {
    municipality: 'Neuendorf',
    postalCode: '54597'
  },
  {
    municipality: 'Neuendorf bei Elmshorn',
    postalCode: '25335'
  },
  {
    municipality: 'Neuendorf-Sachsenbande',
    postalCode: '25554'
  },
  {
    municipality: 'Neuengönna',
    postalCode: '07778'
  },
  {
    municipality: 'Neuengörs',
    postalCode: '23818'
  },
  {
    municipality: 'Neuenhagen bei Berlin',
    postalCode: '15366'
  },
  {
    municipality: 'Neuenhaus',
    postalCode: '49828'
  },
  {
    municipality: 'Neuenkirchen',
    postalCode: '48485'
  },
  {
    municipality: 'Neuenkirchen',
    postalCode: '25792'
  },
  {
    municipality: 'Neuenkirchen',
    postalCode: '21640'
  },
  {
    municipality: 'Neuenkirchen',
    postalCode: '17498'
  },
  {
    municipality: 'Neuenkirchen',
    postalCode: '17039'
  },
  {
    municipality: 'Neuenkirchen',
    postalCode: '17392'
  },
  {
    municipality: 'Neuenkirchen',
    postalCode: '18569'
  },
  {
    municipality: 'Neuenkirchen',
    postalCode: '27251'
  },
  {
    municipality: 'Neuenkirchen',
    postalCode: '21763'
  },
  {
    municipality: 'Neuenkirchen',
    postalCode: '29643'
  },
  {
    municipality: 'Neuenkirchen',
    postalCode: '49586'
  },
  {
    municipality: 'Neuenkirchen-Vörden',
    postalCode: '49434'
  },
  {
    municipality: 'Neuenmarkt',
    postalCode: '95339'
  },
  {
    municipality: 'Neuenrade',
    postalCode: '58809'
  },
  {
    municipality: 'Neuensalz',
    postalCode: '08541'
  },
  {
    municipality: 'Neuenstadt am Kocher',
    postalCode: '74196'
  },
  {
    municipality: 'Neuenstein',
    postalCode: '36286'
  },
  {
    municipality: 'Neuenstein',
    postalCode: '74632'
  },
  {
    municipality: 'Neuental',
    postalCode: '34599'
  },
  {
    municipality: 'Neuerburg',
    postalCode: '54673'
  },
  {
    municipality: 'Neuerkirch',
    postalCode: '55471'
  },
  {
    municipality: 'Neufahrn bei Freising',
    postalCode: '85375'
  },
  {
    municipality: 'Neufahrn bei Freising',
    postalCode: '85376'
  },
  {
    municipality: 'Neufahrn in Niederbayern',
    postalCode: '84088'
  },
  {
    municipality: 'Neufeld',
    postalCode: '25724'
  },
  {
    municipality: 'Neufelderkoog',
    postalCode: '25724'
  },
  {
    municipality: 'Neuffen',
    postalCode: '72639'
  },
  {
    municipality: 'Neufra',
    postalCode: '72419'
  },
  {
    municipality: 'Neufraunhofen',
    postalCode: '84181'
  },
  {
    municipality: 'Neu Gülze',
    postalCode: '19258'
  },
  {
    municipality: 'Neuhardenberg',
    postalCode: '15320'
  },
  {
    municipality: 'Neuharlingersiel',
    postalCode: '26427'
  },
  {
    municipality: 'Neuhaus',
    postalCode: '21785'
  },
  {
    municipality: 'Neuhaus a.d.Pegnitz',
    postalCode: '91284'
  },
  {
    municipality: 'Neuhaus am Inn',
    postalCode: '94152'
  },
  {
    municipality: 'Neuhaus am Rennweg',
    postalCode: '98724'
  },
  {
    municipality: 'Neuhäusel',
    postalCode: '56335'
  },
  {
    municipality: 'Neuhausen',
    postalCode: '75242'
  },
  {
    municipality: 'Neuhausen auf den Fildern',
    postalCode: '73765'
  },
  {
    municipality: 'Neuhausen/Erzgebirge',
    postalCode: '09544'
  },
  {
    municipality: 'Neuhausen ob Eck',
    postalCode: '78579'
  },
  {
    municipality: 'Neuhausen/Spree',
    postalCode: '03058'
  },
  {
    municipality: 'Neuheilenbach',
    postalCode: '54597'
  },
  {
    municipality: 'Neuhemsbach',
    postalCode: '67680'
  },
  {
    municipality: 'Neuhof',
    postalCode: '36119'
  },
  {
    municipality: 'Neuhof a.d.Zenn',
    postalCode: '90616'
  },
  {
    municipality: 'Neuhofen',
    postalCode: '67141'
  },
  {
    municipality: 'Neuhütten',
    postalCode: '97843'
  },
  {
    municipality: 'Neuhütten',
    postalCode: '54422'
  },
  {
    municipality: 'Neu-Isenburg',
    postalCode: '63263'
  },
  {
    municipality: 'Neukalen',
    postalCode: '17154'
  },
  {
    municipality: 'Neu Kaliß',
    postalCode: '19294'
  },
  {
    municipality: 'Neukamperfehn',
    postalCode: '26835'
  },
  {
    municipality: 'Neukieritzsch',
    postalCode: '04575'
  },
  {
    municipality: 'Neukirch',
    postalCode: '01936'
  },
  {
    municipality: 'Neukirch',
    postalCode: '88099'
  },
  {
    municipality: 'Neukirchen',
    postalCode: '23779'
  },
  {
    municipality: 'Neukirchen',
    postalCode: '34626'
  },
  {
    municipality: 'Neukirchen',
    postalCode: '94362'
  },
  {
    municipality: 'Neukirchen',
    postalCode: '25927'
  },
  {
    municipality: 'Neukirchen-Balbini',
    postalCode: '92445'
  },
  {
    municipality: 'Neukirchen beim Heiligen Blut',
    postalCode: '93453'
  },
  {
    municipality: 'Neukirchen bei Sulzbach-Rosenberg',
    postalCode: '92259'
  },
  {
    municipality: 'Neukirchen/Erzgebirge',
    postalCode: '09221'
  },
  {
    municipality: 'Neukirchen/Pleiße',
    postalCode: '08459'
  },
  {
    municipality: 'Neukirchen-Vluyn',
    postalCode: '47506'
  },
  {
    municipality: 'Neukirchen vorm Wald',
    postalCode: '94154'
  },
  {
    municipality: 'Neukirch/Lausitz',
    postalCode: '01904'
  },
  {
    municipality: 'Neukloster',
    postalCode: '23992'
  },
  {
    municipality: 'Neu Kosenow',
    postalCode: '17398'
  },
  {
    municipality: 'Neulehe',
    postalCode: '26909'
  },
  {
    municipality: 'Neuleiningen',
    postalCode: '67271'
  },
  {
    municipality: 'Neuler',
    postalCode: '73491'
  },
  {
    municipality: 'Neulewin',
    postalCode: '16259'
  },
  {
    municipality: 'Neulingen',
    postalCode: '75245'
  },
  {
    municipality: 'Neulußheim',
    postalCode: '68809'
  },
  {
    municipality: 'Neumagen-Dhron',
    postalCode: '54347'
  },
  {
    municipality: 'Neumark',
    postalCode: '08496'
  },
  {
    municipality: 'Neumark',
    postalCode: '99439'
  },
  {
    municipality: 'Neumarkt in der Oberpfalz',
    postalCode: '92318'
  },
  {
    municipality: 'Neumarkt in der Oberpfalz',
    postalCode: '92348'
  },
  {
    municipality: 'Neumarkt-Sankt Veit',
    postalCode: '84494'
  },
  {
    municipality: 'Neumünster',
    postalCode: '24534'
  },
  {
    municipality: 'Neumünster',
    postalCode: '24536'
  },
  {
    municipality: 'Neumünster',
    postalCode: '24537'
  },
  {
    municipality: 'Neumünster',
    postalCode: '24539'
  },
  {
    municipality: 'Neunburg vorm Wald',
    postalCode: '92431'
  },
  {
    municipality: 'Neundorf',
    postalCode: '07924'
  },
  {
    municipality: 'Neunkhausen',
    postalCode: '57520'
  },
  {
    municipality: 'Neunkirchen',
    postalCode: '57290'
  },
  {
    municipality: 'Neunkirchen',
    postalCode: '63930'
  },
  {
    municipality: 'Neunkirchen',
    postalCode: '74867'
  },
  {
    municipality: 'Neunkirchen',
    postalCode: '56479'
  },
  {
    municipality: 'Neunkirchen',
    postalCode: '66538'
  },
  {
    municipality: 'Neunkirchen',
    postalCode: '66539'
  },
  {
    municipality: 'Neunkirchen',
    postalCode: '66540'
  },
  {
    municipality: 'Neunkirchen',
    postalCode: '54426'
  },
  {
    municipality: 'Neunkirchen a.Brand',
    postalCode: '91077'
  },
  {
    municipality: 'Neunkirchen am Potzberg',
    postalCode: '66887'
  },
  {
    municipality: 'Neunkirchen a. Sand',
    postalCode: '91233'
  },
  {
    municipality: 'Neunkirchen-Seelscheid',
    postalCode: '53819'
  },
  {
    municipality: 'Neuötting',
    postalCode: '84524'
  },
  {
    municipality: 'Neupetershain',
    postalCode: '03103'
  },
  {
    municipality: 'Neu Poserin',
    postalCode: '19399'
  },
  {
    municipality: 'Neupotz',
    postalCode: '76777'
  },
  {
    municipality: 'Neureichenau',
    postalCode: '94089'
  },
  {
    municipality: 'Neuried',
    postalCode: '82061'
  },
  {
    municipality: 'Neuried',
    postalCode: '82131'
  },
  {
    municipality: 'Neuried',
    postalCode: '77743'
  },
  {
    municipality: 'Neuruppin',
    postalCode: '16816'
  },
  {
    municipality: 'Neuruppin',
    postalCode: '16818'
  },
  {
    municipality: 'Neuruppin',
    postalCode: '16827'
  },
  {
    municipality: 'Neuruppin',
    postalCode: '16833'
  },
  {
    municipality: 'Neuruppin',
    postalCode: '16835'
  },
  {
    municipality: 'Neusalza-Spremberg',
    postalCode: '02742'
  },
  {
    municipality: 'Neusäß',
    postalCode: '86356'
  },
  {
    municipality: 'Neuschönau',
    postalCode: '94556'
  },
  {
    municipality: 'Neuschoo',
    postalCode: '26487'
  },
  {
    municipality: 'Neu-Seeland',
    postalCode: '03103'
  },
  {
    municipality: 'Neusitz',
    postalCode: '91616'
  },
  {
    municipality: 'Neusorg',
    postalCode: '95700'
  },
  {
    municipality: 'Neuss',
    postalCode: '41460'
  },
  {
    municipality: 'Neuss',
    postalCode: '41462'
  },
  {
    municipality: 'Neuss',
    postalCode: '41464'
  },
  {
    municipality: 'Neuss',
    postalCode: '41466'
  },
  {
    municipality: 'Neuss',
    postalCode: '41468'
  },
  {
    municipality: 'Neuss',
    postalCode: '41469'
  },
  {
    municipality: 'Neuss',
    postalCode: '41470'
  },
  {
    municipality: 'Neuss',
    postalCode: '41472'
  },
  {
    municipality: 'Neustadt',
    postalCode: '35279'
  },
  {
    municipality: 'Neustadt a.Main',
    postalCode: '97845'
  },
  {
    municipality: 'Neustadt am Kulm',
    postalCode: '95514'
  },
  {
    municipality: 'Neustadt am Rübenberge',
    postalCode: '31535'
  },
  {
    municipality: 'Neustadt an der Aisch',
    postalCode: '91413'
  },
  {
    municipality: 'Neustadt an der Donau',
    postalCode: '93333'
  },
  {
    municipality: 'Neustadt an der Orla',
    postalCode: '07806'
  },
  {
    municipality: 'Neustadt an der Waldnaab',
    postalCode: '92660'
  },
  {
    municipality: 'Neustadt an der Weinstraße',
    postalCode: '67433'
  },
  {
    municipality: 'Neustadt an der Weinstraße',
    postalCode: '67434'
  },
  {
    municipality: 'Neustadt an der Weinstraße',
    postalCode: '67435'
  },
  {
    municipality: 'Neustadt bei Coburg',
    postalCode: '96465'
  },
  {
    municipality: 'Neustadt (Dosse)',
    postalCode: '16845'
  },
  {
    municipality: 'Neustadt-Glewe',
    postalCode: '19306'
  },
  {
    municipality: 'Neustadt in Holstein',
    postalCode: '23730'
  },
  {
    municipality: 'Neustadt in Sachsen',
    postalCode: '01844'
  },
  {
    municipality: 'Neustadt/Vogtland',
    postalCode: '08223'
  },
  {
    municipality: 'Neustadt/ Westerwald',
    postalCode: '56479'
  },
  {
    municipality: 'Neustadt (Wied)',
    postalCode: '53577'
  },
  {
    municipality: 'Neustetten',
    postalCode: '72149'
  },
  {
    municipality: 'Neustrelitz',
    postalCode: '17235'
  },
  {
    municipality: 'Neutraubling',
    postalCode: '93073'
  },
  {
    municipality: 'Neutrebbin',
    postalCode: '15320'
  },
  {
    municipality: 'Neu-Ulm',
    postalCode: '89231'
  },
  {
    municipality: 'Neu-Ulm',
    postalCode: '89233'
  },
  {
    municipality: 'Neuweiler',
    postalCode: '75389'
  },
  {
    municipality: 'Neuwied',
    postalCode: '56564'
  },
  {
    municipality: 'Neuwied',
    postalCode: '56566'
  },
  {
    municipality: 'Neuwied',
    postalCode: '56567'
  },
  {
    municipality: 'Neuwittenbek',
    postalCode: '24161'
  },
  {
    municipality: 'Neuwittenbek',
    postalCode: '24214'
  },
  {
    municipality: 'Neu Wulmstorf',
    postalCode: '21629'
  },
  {
    municipality: 'Neu Zauche',
    postalCode: '15913'
  },
  {
    municipality: 'Neuzelle',
    postalCode: '15898'
  },
  {
    municipality: 'Neverin',
    postalCode: '17039'
  },
  {
    municipality: 'Neversdorf',
    postalCode: '23816'
  },
  {
    municipality: 'Newel',
    postalCode: '54309'
  },
  {
    municipality: 'Ney',
    postalCode: '56283'
  },
  {
    municipality: 'Nickenich',
    postalCode: '56645'
  },
  {
    municipality: 'Nidda',
    postalCode: '63667'
  },
  {
    municipality: 'Niddatal',
    postalCode: '61194'
  },
  {
    municipality: 'Nidderau',
    postalCode: '61130'
  },
  {
    municipality: 'Nideggen',
    postalCode: '52385'
  },
  {
    municipality: 'Nieblum',
    postalCode: '25938'
  },
  {
    municipality: 'Niebüll',
    postalCode: '25899'
  },
  {
    municipality: 'Nieby',
    postalCode: '24395'
  },
  {
    municipality: 'Nieden',
    postalCode: '17309'
  },
  {
    municipality: 'Niedenstein',
    postalCode: '34305'
  },
  {
    municipality: 'Niederahr',
    postalCode: '56414'
  },
  {
    municipality: 'Niederaichbach',
    postalCode: '84100'
  },
  {
    municipality: 'Niederalben',
    postalCode: '66887'
  },
  {
    municipality: 'Niederalteich',
    postalCode: '94557'
  },
  {
    municipality: 'Niederau',
    postalCode: '01689'
  },
  {
    municipality: 'Niederaula',
    postalCode: '36272'
  },
  {
    municipality: 'Niederbachheim',
    postalCode: '56357'
  },
  {
    municipality: 'Niederbergkirchen',
    postalCode: '84494'
  },
  {
    municipality: 'Niederbösa',
    postalCode: '99718'
  },
  {
    municipality: 'Niederbreitbach',
    postalCode: '56589'
  },
  {
    municipality: 'Niederbrombach',
    postalCode: '55767'
  },
  {
    municipality: 'Niederburg',
    postalCode: '55432'
  },
  {
    municipality: 'Niederdorf',
    postalCode: '09366'
  },
  {
    municipality: 'Niederdorfelden',
    postalCode: '61138'
  },
  {
    municipality: 'Niederdreisbach',
    postalCode: '57520'
  },
  {
    municipality: 'Niederdürenbach',
    postalCode: '56651'
  },
  {
    municipality: 'Niedere Börde',
    postalCode: '39326'
  },
  {
    municipality: 'Niedere Börde',
    postalCode: '39345'
  },
  {
    municipality: 'Niederelbert',
    postalCode: '56412'
  },
  {
    municipality: 'Niedererbach',
    postalCode: '56412'
  },
  {
    municipality: 'Niederer Fläming',
    postalCode: '14913'
  },
  {
    municipality: 'Niedereschach',
    postalCode: '78078'
  },
  {
    municipality: 'Niederfell',
    postalCode: '56332'
  },
  {
    municipality: 'Niederfinow',
    postalCode: '16248'
  },
  {
    municipality: 'Niederfischbach',
    postalCode: '57572'
  },
  {
    municipality: 'Niederfrohna',
    postalCode: '09243'
  },
  {
    municipality: 'Niederfüllbach',
    postalCode: '96489'
  },
  {
    municipality: 'Niedergebra',
    postalCode: '99759'
  },
  {
    municipality: 'Niedergeckler',
    postalCode: '54675'
  },
  {
    municipality: 'Niedergörsdorf',
    postalCode: '14913'
  },
  {
    municipality: 'Niederhambach',
    postalCode: '55767'
  },
  {
    municipality: 'Niederhausen',
    postalCode: '55585'
  },
  {
    municipality: 'Niederhausen an der Appel',
    postalCode: '67822'
  },
  {
    municipality: 'Niederheimbach',
    postalCode: '55413'
  },
  {
    municipality: 'Nieder-Hilbersheim',
    postalCode: '55437'
  },
  {
    municipality: 'Niederhofen',
    postalCode: '56316'
  },
  {
    municipality: 'Niederhorbach',
    postalCode: '76889'
  },
  {
    municipality: 'Niederhosenbach',
    postalCode: '55758'
  },
  {
    municipality: 'Niederirsen',
    postalCode: '57589'
  },
  {
    municipality: 'Niederkassel',
    postalCode: '53859'
  },
  {
    municipality: 'Niederkirchen',
    postalCode: '67700'
  },
  {
    municipality: 'Niederkirchen bei Deidesheim',
    postalCode: '67150'
  },
  {
    municipality: 'Nieder Kostenz',
    postalCode: '55481'
  },
  {
    municipality: 'Niederkrüchten',
    postalCode: '41372'
  },
  {
    municipality: 'Niederkumbd',
    postalCode: '55469'
  },
  {
    municipality: 'Niederlangen',
    postalCode: '49779'
  },
  {
    municipality: 'Niederlauch',
    postalCode: '54614'
  },
  {
    municipality: 'Niederlauer',
    postalCode: '97618'
  },
  {
    municipality: 'Niedermohr',
    postalCode: '66879'
  },
  {
    municipality: 'Niedermoschel',
    postalCode: '67822'
  },
  {
    municipality: 'Niedermurach',
    postalCode: '92545'
  },
  {
    municipality: 'Niedernberg',
    postalCode: '63843'
  },
  {
    municipality: 'Niederneisen',
    postalCode: '65629'
  },
  {
    municipality: 'Niedernhall',
    postalCode: '74676'
  },
  {
    municipality: 'Niedernhausen',
    postalCode: '65527'
  },
  {
    municipality: 'Niedernwöhren',
    postalCode: '31712'
  },
  {
    municipality: 'Niederöfflingen',
    postalCode: '54533'
  },
  {
    municipality: 'Nieder-Olm',
    postalCode: '55268'
  },
  {
    municipality: 'Niederorschel',
    postalCode: '37355'
  },
  {
    municipality: 'Niederotterbach',
    postalCode: '76889'
  },
  {
    municipality: 'Niederpierscheid',
    postalCode: '54649'
  },
  {
    municipality: 'Niederraden',
    postalCode: '54675'
  },
  {
    municipality: 'Niederrieden',
    postalCode: '87767'
  },
  {
    municipality: 'Niederroßbach',
    postalCode: '56479'
  },
  {
    municipality: 'Niedersayn',
    postalCode: '56244'
  },
  {
    municipality: 'Niederscheidweiler',
    postalCode: '54533'
  },
  {
    municipality: 'Niederschlettenbach',
    postalCode: '76891'
  },
  {
    municipality: 'Niederschönenfeld',
    postalCode: '86694'
  },
  {
    municipality: 'Niedersohren',
    postalCode: '55487'
  },
  {
    municipality: 'Niederstadtfeld',
    postalCode: '54570'
  },
  {
    municipality: 'Niederstaufenbach',
    postalCode: '66879'
  },
  {
    municipality: 'Niederstedem',
    postalCode: '54634'
  },
  {
    municipality: 'Niedersteinebach',
    postalCode: '56593'
  },
  {
    municipality: 'Niederstetten',
    postalCode: '97996'
  },
  {
    municipality: 'Niederstotzingen',
    postalCode: '89168'
  },
  {
    municipality: 'Niedert',
    postalCode: '56291'
  },
  {
    municipality: 'Niedertaufkirchen',
    postalCode: '84494'
  },
  {
    municipality: 'Niedertiefenbach',
    postalCode: '56368'
  },
  {
    municipality: 'Niedertrebra',
    postalCode: '99518'
  },
  {
    municipality: 'Niederviehbach',
    postalCode: '84183'
  },
  {
    municipality: 'Niederwallmenach',
    postalCode: '56357'
  },
  {
    municipality: 'Niederwambach',
    postalCode: '57614'
  },
  {
    municipality: 'Niederweiler',
    postalCode: '54636'
  },
  {
    municipality: 'Niederweiler',
    postalCode: '55491'
  },
  {
    municipality: 'Niederweis',
    postalCode: '54298'
  },
  {
    municipality: 'Niederweis',
    postalCode: '54668'
  },
  {
    municipality: 'Niederwerrn',
    postalCode: '97464'
  },
  {
    municipality: 'Niederwerth',
    postalCode: '56179'
  },
  {
    municipality: 'Niederwiesa',
    postalCode: '09577'
  },
  {
    municipality: 'Nieder-Wiesen',
    postalCode: '55234'
  },
  {
    municipality: 'Niederwinkling',
    postalCode: '94559'
  },
  {
    municipality: 'Niederwörresbach',
    postalCode: '55758'
  },
  {
    municipality: 'Niederwürschnitz',
    postalCode: '09399'
  },
  {
    municipality: 'Niederzier',
    postalCode: '52382'
  },
  {
    municipality: 'Niederzissen',
    postalCode: '56651'
  },
  {
    municipality: 'Niefern-Öschelbronn',
    postalCode: '75223'
  },
  {
    municipality: 'Nieheim',
    postalCode: '33039'
  },
  {
    municipality: 'Niehl',
    postalCode: '54646'
  },
  {
    municipality: 'Niemegk',
    postalCode: '14823'
  },
  {
    municipality: 'Niemetal',
    postalCode: '37127'
  },
  {
    municipality: 'Nienborstel',
    postalCode: '24819'
  },
  {
    municipality: 'Nienburg (Saale)',
    postalCode: '06429'
  },
  {
    municipality: 'Nienburg/Weser',
    postalCode: '31582'
  },
  {
    municipality: 'Nienbüttel',
    postalCode: '25596'
  },
  {
    municipality: 'Niendorf bei Berkenthin',
    postalCode: '23919'
  },
  {
    municipality: 'Niendorf/Stecknitz',
    postalCode: '23881'
  },
  {
    municipality: 'Nienhagen',
    postalCode: '18211'
  },
  {
    municipality: 'Nienhagen',
    postalCode: '29336'
  },
  {
    municipality: 'Nienstädt',
    postalCode: '31688'
  },
  {
    municipality: 'Nienwohld',
    postalCode: '23863'
  },
  {
    municipality: 'Niepars',
    postalCode: '18442'
  },
  {
    municipality: 'Niersbach',
    postalCode: '54518'
  },
  {
    municipality: 'Nierstein',
    postalCode: '55283'
  },
  {
    municipality: 'Niesgrau',
    postalCode: '24395'
  },
  {
    municipality: 'Niesky',
    postalCode: '02906'
  },
  {
    municipality: 'Nieste',
    postalCode: '34329'
  },
  {
    municipality: 'Niestetal',
    postalCode: '34266'
  },
  {
    municipality: 'Nievern',
    postalCode: '56132'
  },
  {
    municipality: 'Nimritz',
    postalCode: '07381'
  },
  {
    municipality: 'Nimshuscheid',
    postalCode: '54612'
  },
  {
    municipality: 'Nimsreuland',
    postalCode: '54614'
  },
  {
    municipality: 'Nindorf',
    postalCode: '25704'
  },
  {
    municipality: 'Nindorf',
    postalCode: '24594'
  },
  {
    municipality: 'Nister',
    postalCode: '57645'
  },
  {
    municipality: 'Nisterau',
    postalCode: '56472'
  },
  {
    municipality: 'Nisterberg',
    postalCode: '56472'
  },
  {
    municipality: 'Nister-Möhrendorf',
    postalCode: '56477'
  },
  {
    municipality: 'Nistertal',
    postalCode: '57647'
  },
  {
    municipality: 'Nittel',
    postalCode: '54453'
  },
  {
    municipality: 'Nittenau',
    postalCode: '93149'
  },
  {
    municipality: 'Nittendorf',
    postalCode: '93152'
  },
  {
    municipality: 'Nitz',
    postalCode: '56729'
  },
  {
    municipality: 'Nobitz',
    postalCode: '04603'
  },
  {
    municipality: 'Nochern',
    postalCode: '56357'
  },
  {
    municipality: 'Nöda',
    postalCode: '99195'
  },
  {
    municipality: 'Noer',
    postalCode: '24214'
  },
  {
    municipality: 'Nohen',
    postalCode: '55767'
  },
  {
    municipality: 'Nohfelden',
    postalCode: '66625'
  },
  {
    municipality: 'Nohn',
    postalCode: '54578'
  },
  {
    municipality: 'Nomborn',
    postalCode: '56412'
  },
  {
    municipality: 'Nonnenhorn',
    postalCode: '88149'
  },
  {
    municipality: 'Nonnweiler',
    postalCode: '66620'
  },
  {
    municipality: 'Norath',
    postalCode: '56291'
  },
  {
    municipality: 'Norddeich',
    postalCode: '25764'
  },
  {
    municipality: 'Norddorf auf Amrum',
    postalCode: '25946'
  },
  {
    municipality: 'Norden',
    postalCode: '26506'
  },
  {
    municipality: 'Nordendorf',
    postalCode: '86695'
  },
  {
    municipality: 'Nordenham',
    postalCode: '26954'
  },
  {
    municipality: 'Norderbrarup',
    postalCode: '24392'
  },
  {
    municipality: 'Norderfriedrichskoog',
    postalCode: '25870'
  },
  {
    municipality: 'Norderheistedt',
    postalCode: '25779'
  },
  {
    municipality: 'Nordermeldorf',
    postalCode: '25704'
  },
  {
    municipality: 'Norderney',
    postalCode: '26548'
  },
  {
    municipality: 'Norderstedt',
    postalCode: '22844'
  },
  {
    municipality: 'Norderstedt',
    postalCode: '22846'
  },
  {
    municipality: 'Norderstedt',
    postalCode: '22848'
  },
  {
    municipality: 'Norderstedt',
    postalCode: '22850'
  },
  {
    municipality: 'Norderstedt',
    postalCode: '22851'
  },
  {
    municipality: 'Norderwöhrden',
    postalCode: '25746'
  },
  {
    municipality: 'Nordhackstedt',
    postalCode: '24980'
  },
  {
    municipality: 'Nordhalben',
    postalCode: '96365'
  },
  {
    municipality: 'Nordharz',
    postalCode: '38855'
  },
  {
    municipality: 'Nordharz',
    postalCode: '38871'
  },
  {
    municipality: 'Nordhastedt',
    postalCode: '25785'
  },
  {
    municipality: 'Nordhausen',
    postalCode: '99734'
  },
  {
    municipality: 'Nordheim',
    postalCode: '74226'
  },
  {
    municipality: 'Nordheim a.Main',
    postalCode: '97334'
  },
  {
    municipality: 'Nordheim v.d.Rhön',
    postalCode: '97647'
  },
  {
    municipality: 'Nordhofen',
    postalCode: '56242'
  },
  {
    municipality: 'Nordhorn',
    postalCode: '48527'
  },
  {
    municipality: 'Nordhorn',
    postalCode: '48529'
  },
  {
    municipality: 'Nordhorn',
    postalCode: '48531'
  },
  {
    municipality: 'Nordkirchen',
    postalCode: '59394'
  },
  {
    municipality: 'Nordleda',
    postalCode: '21765'
  },
  {
    municipality: 'Nördlingen',
    postalCode: '86720'
  },
  {
    municipality: 'Nordrach',
    postalCode: '77787'
  },
  {
    municipality: 'Nordsehl',
    postalCode: '31717'
  },
  {
    municipality: 'Nordstemmen',
    postalCode: '31171'
  },
  {
    municipality: 'Nordstrand',
    postalCode: '25845'
  },
  {
    municipality: 'Nordwalde',
    postalCode: '48356'
  },
  {
    municipality: 'Nordwestuckermark',
    postalCode: '17291'
  },
  {
    municipality: 'Norheim',
    postalCode: '55585'
  },
  {
    municipality: 'Norken',
    postalCode: '57629'
  },
  {
    municipality: 'Norstedt',
    postalCode: '25884'
  },
  {
    municipality: 'Nörten-Hardenberg',
    postalCode: '37176'
  },
  {
    municipality: 'Nörtershausen',
    postalCode: '56283'
  },
  {
    municipality: 'Northeim',
    postalCode: '37154'
  },
  {
    municipality: 'Nortmoor',
    postalCode: '26845'
  },
  {
    municipality: 'Nortorf',
    postalCode: '25554'
  },
  {
    municipality: 'Nortorf',
    postalCode: '24589'
  },
  {
    municipality: 'Nortrup',
    postalCode: '49638'
  },
  {
    municipality: 'Nörvenich',
    postalCode: '52388'
  },
  {
    municipality: 'Nossen',
    postalCode: '01683'
  },
  {
    municipality: 'Nossendorf',
    postalCode: '17111'
  },
  {
    municipality: 'Nossentiner Hütte',
    postalCode: '17214'
  },
  {
    municipality: 'Nostorf',
    postalCode: '19258'
  },
  {
    municipality: 'Nothweiler',
    postalCode: '76891'
  },
  {
    municipality: 'Nottensdorf',
    postalCode: '21640'
  },
  {
    municipality: 'Nottertal-Heilinger Höhen',
    postalCode: '99994'
  },
  {
    municipality: 'Nottfeld',
    postalCode: '24392'
  },
  {
    municipality: 'Nottleben',
    postalCode: '99192'
  },
  {
    municipality: 'Nottuln',
    postalCode: '48301'
  },
  {
    municipality: 'Notzingen',
    postalCode: '73274'
  },
  {
    municipality: 'Nübbel',
    postalCode: '24809'
  },
  {
    municipality: 'Nübel',
    postalCode: '24881'
  },
  {
    municipality: 'Nüdlingen',
    postalCode: '97720'
  },
  {
    municipality: 'Nufringen',
    postalCode: '71154'
  },
  {
    municipality: 'Nümbrecht',
    postalCode: '51588'
  },
  {
    municipality: 'Nünchritz',
    postalCode: '01612'
  },
  {
    municipality: 'Nünschweiler',
    postalCode: '66989'
  },
  {
    municipality: 'Nürburg',
    postalCode: '53520'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90402'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90403'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90408'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90409'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90411'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90419'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90425'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90427'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90429'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90431'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90439'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90441'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90443'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90449'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90451'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90453'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90455'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90459'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90461'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90469'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90471'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90473'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90475'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90478'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90480'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90482'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90489'
  },
  {
    municipality: 'Nürnberg',
    postalCode: '90491'
  },
  {
    municipality: 'Nürtingen',
    postalCode: '72622'
  },
  {
    municipality: 'Nusbaum',
    postalCode: '54675'
  },
  {
    municipality: 'Nusplingen',
    postalCode: '72362'
  },
  {
    municipality: 'Nußbach',
    postalCode: '67759'
  },
  {
    municipality: 'Nußbaum',
    postalCode: '55569'
  },
  {
    municipality: 'Nußdorf',
    postalCode: '83365'
  },
  {
    municipality: 'Nußdorf am Inn',
    postalCode: '83131'
  },
  {
    municipality: 'Nusse',
    postalCode: '23896'
  },
  {
    municipality: 'Nußloch',
    postalCode: '69226'
  },
  {
    municipality: 'Nustrow',
    postalCode: '18195'
  },
  {
    municipality: 'Nüsttal',
    postalCode: '36167'
  },
  {
    municipality: 'Nuthetal',
    postalCode: '14558'
  },
  {
    municipality: 'Nuthe-Urstromtal',
    postalCode: '14947'
  },
  {
    municipality: 'Nutteln',
    postalCode: '25594'
  },
  {
    municipality: 'Nützen',
    postalCode: '24568'
  },
  {
    municipality: 'Oberahr',
    postalCode: '56414'
  },
  {
    municipality: 'Oberalben',
    postalCode: '66871'
  },
  {
    municipality: 'Oberammergau',
    postalCode: '82487'
  },
  {
    municipality: 'Oberarnbach',
    postalCode: '66851'
  },
  {
    municipality: 'Oberasbach',
    postalCode: '90522'
  },
  {
    municipality: 'Oberau',
    postalCode: '82496'
  },
  {
    municipality: 'Oberaudorf',
    postalCode: '83080'
  },
  {
    municipality: 'Oberaula',
    postalCode: '36280'
  },
  {
    municipality: 'Oberaurach',
    postalCode: '97514'
  },
  {
    municipality: 'Oberbachheim',
    postalCode: '56355'
  },
  {
    municipality: 'Oberbarnim',
    postalCode: '15377'
  },
  {
    municipality: 'Oberbergkirchen',
    postalCode: '84564'
  },
  {
    municipality: 'Oberbettingen',
    postalCode: '54578'
  },
  {
    municipality: 'Oberbillig',
    postalCode: '54331'
  },
  {
    municipality: 'Oberbodnitz',
    postalCode: '07646'
  },
  {
    municipality: 'Oberboihingen',
    postalCode: '72644'
  },
  {
    municipality: 'Oberbösa',
    postalCode: '99718'
  },
  {
    municipality: 'Oberbrombach',
    postalCode: '55767'
  },
  {
    municipality: 'Oberdachstetten',
    postalCode: '91617'
  },
  {
    municipality: 'Oberderdingen',
    postalCode: '75038'
  },
  {
    municipality: 'Oberdiebach',
    postalCode: '55413'
  },
  {
    municipality: 'Oberding',
    postalCode: '85445'
  },
  {
    municipality: 'Oberdischingen',
    postalCode: '89610'
  },
  {
    municipality: 'Oberdolling',
    postalCode: '85129'
  },
  {
    municipality: 'Oberdreis',
    postalCode: '57639'
  },
  {
    municipality: 'Oberdürenbach',
    postalCode: '56651'
  },
  {
    municipality: 'Oberehe-Stroheich',
    postalCode: '54578'
  },
  {
    municipality: 'Oberelbert',
    postalCode: '56412'
  },
  {
    municipality: 'Oberelsbach',
    postalCode: '97656'
  },
  {
    municipality: 'Oberelz',
    postalCode: '56767'
  },
  {
    municipality: 'Obererbach',
    postalCode: '57612'
  },
  {
    municipality: 'Obererbach',
    postalCode: '56414'
  },
  {
    municipality: 'Obere Warnow',
    postalCode: '19374'
  },
  {
    municipality: 'Oberfell',
    postalCode: '56332'
  },
  {
    municipality: 'Oberfischbach',
    postalCode: '56370'
  },
  {
    municipality: 'Ober-Flörsheim',
    postalCode: '55234'
  },
  {
    municipality: 'Obergeckler',
    postalCode: '54675'
  },
  {
    municipality: 'Obergriesbach',
    postalCode: '86573'
  },
  {
    municipality: 'Obergröningen',
    postalCode: '73569'
  },
  {
    municipality: 'Obergünzburg',
    postalCode: '87634'
  },
  {
    municipality: 'Obergurig - Hornja Hórka',
    postalCode: '02692'
  },
  {
    municipality: 'Oberhaching',
    postalCode: '82041'
  },
  {
    municipality: 'Oberhaching',
    postalCode: '82064'
  },
  {
    municipality: 'Oberhaid',
    postalCode: '56237'
  },
  {
    municipality: 'Oberhaid',
    postalCode: '96173'
  },
  {
    municipality: 'Oberhambach',
    postalCode: '55765'
  },
  {
    municipality: 'Oberharmersbach',
    postalCode: '77784'
  },
  {
    municipality: 'Oberharz am Brocken',
    postalCode: '38875'
  },
  {
    municipality: 'Oberharz am Brocken',
    postalCode: '38877'
  },
  {
    municipality: 'Oberharz am Brocken',
    postalCode: '38889'
  },
  {
    municipality: 'Oberharz am Brocken',
    postalCode: '38899'
  },
  {
    municipality: 'Oberhausen',
    postalCode: '46045'
  },
  {
    municipality: 'Oberhausen',
    postalCode: '46047'
  },
  {
    municipality: 'Oberhausen',
    postalCode: '46049'
  },
  {
    municipality: 'Oberhausen',
    postalCode: '46117'
  },
  {
    municipality: 'Oberhausen',
    postalCode: '46119'
  },
  {
    municipality: 'Oberhausen',
    postalCode: '46145'
  },
  {
    municipality: 'Oberhausen',
    postalCode: '46147'
  },
  {
    municipality: 'Oberhausen',
    postalCode: '46149'
  },
  {
    municipality: 'Oberhausen',
    postalCode: '82386'
  },
  {
    municipality: 'Oberhausen',
    postalCode: '86697'
  },
  {
    municipality: 'Oberhausen',
    postalCode: '76887'
  },
  {
    municipality: 'Oberhausen an der Appel',
    postalCode: '67822'
  },
  {
    municipality: 'Oberhausen an der Nahe',
    postalCode: '55585'
  },
  {
    municipality: 'Oberhausen bei Kirn',
    postalCode: '55606'
  },
  {
    municipality: 'Oberhausen-Rheinhausen',
    postalCode: '68794'
  },
  {
    municipality: 'Oberheimbach',
    postalCode: '55413'
  },
  {
    municipality: 'Oberheldrungen',
    postalCode: '06577'
  },
  {
    municipality: 'Ober-Hilbersheim',
    postalCode: '55437'
  },
  {
    municipality: 'Oberhof',
    postalCode: '98559'
  },
  {
    municipality: 'Oberhonnefeld-Gierend',
    postalCode: '56587'
  },
  {
    municipality: 'Oberhosenbach',
    postalCode: '55758'
  },
  {
    municipality: 'Oberickelsheim',
    postalCode: '97258'
  },
  {
    municipality: 'Oberirsen',
    postalCode: '57635'
  },
  {
    municipality: 'Oberkail',
    postalCode: '54533'
  },
  {
    municipality: 'Oberkirch',
    postalCode: '77704'
  },
  {
    municipality: 'Oberkirn',
    postalCode: '55624'
  },
  {
    municipality: 'Oberkochen',
    postalCode: '73447'
  },
  {
    municipality: 'Ober Kostenz',
    postalCode: '55481'
  },
  {
    municipality: 'Oberkotzau',
    postalCode: '95145'
  },
  {
    municipality: 'Oberkrämer',
    postalCode: '16727'
  },
  {
    municipality: 'Oberlahr',
    postalCode: '57641'
  },
  {
    municipality: 'Oberlangen',
    postalCode: '49779'
  },
  {
    municipality: 'Oberlascheid',
    postalCode: '54608'
  },
  {
    municipality: 'Oberlauch',
    postalCode: '54614'
  },
  {
    municipality: 'Oberleichtersbach',
    postalCode: '97789'
  },
  {
    municipality: 'Oberlungwitz',
    postalCode: '09353'
  },
  {
    municipality: 'Obermaiselstein',
    postalCode: '87538'
  },
  {
    municipality: 'Obermarchtal',
    postalCode: '89611'
  },
  {
    municipality: 'Obermaßfeld-Grimmenthal',
    postalCode: '98617'
  },
  {
    municipality: 'Obermeitingen',
    postalCode: '86836'
  },
  {
    municipality: 'Obermichelbach',
    postalCode: '90587'
  },
  {
    municipality: 'Ober-Mörlen',
    postalCode: '61239'
  },
  {
    municipality: 'Obermoschel',
    postalCode: '67823'
  },
  {
    municipality: 'Obernbreit',
    postalCode: '97342'
  },
  {
    municipality: 'Obernburg am Main',
    postalCode: '63785'
  },
  {
    municipality: 'Oberndorf',
    postalCode: '21787'
  },
  {
    municipality: 'Oberndorf',
    postalCode: '67821'
  },
  {
    municipality: 'Oberndorf a.Lech',
    postalCode: '86698'
  },
  {
    municipality: 'Oberndorf am Neckar',
    postalCode: '78727'
  },
  {
    municipality: 'Oberneisen',
    postalCode: '65558'
  },
  {
    municipality: 'Oberneukirchen',
    postalCode: '84565'
  },
  {
    municipality: 'Obernfeld',
    postalCode: '37434'
  },
  {
    municipality: 'Obernheim',
    postalCode: '72364'
  },
  {
    municipality: 'Obernheim-Kirchenarnbach',
    postalCode: '66919'
  },
  {
    municipality: 'Obernhof',
    postalCode: '56379'
  },
  {
    municipality: 'Obernholz',
    postalCode: '29386'
  },
  {
    municipality: 'Obernkirchen',
    postalCode: '31683'
  },
  {
    municipality: 'Obernzell',
    postalCode: '94107'
  },
  {
    municipality: 'Obernzell',
    postalCode: '94130'
  },
  {
    municipality: 'Obernzenn',
    postalCode: '91619'
  },
  {
    municipality: 'Oberöfflingen',
    postalCode: '54533'
  },
  {
    municipality: 'Ober-Olm',
    postalCode: '55270'
  },
  {
    municipality: 'Oberoppurg',
    postalCode: '07381'
  },
  {
    municipality: 'Oberostendorf',
    postalCode: '86869'
  },
  {
    municipality: 'Oberotterbach',
    postalCode: '76889'
  },
  {
    municipality: 'Oberottmarshausen',
    postalCode: '86507'
  },
  {
    municipality: 'Oberpframmern',
    postalCode: '85667'
  },
  {
    municipality: 'Oberpierscheid',
    postalCode: '54649'
  },
  {
    municipality: 'Oberpleichfeld',
    postalCode: '97241'
  },
  {
    municipality: 'Oberpöring',
    postalCode: '94562'
  },
  {
    municipality: 'Oberraden',
    postalCode: '56587'
  },
  {
    municipality: 'Ober-Ramstadt',
    postalCode: '64372'
  },
  {
    municipality: 'Oberreichenbach',
    postalCode: '75394'
  },
  {
    municipality: 'Oberreichenbach',
    postalCode: '91097'
  },
  {
    municipality: 'Oberreidenbach',
    postalCode: '55758'
  },
  {
    municipality: 'Oberreute',
    postalCode: '88179'
  },
  {
    municipality: 'Oberried',
    postalCode: '79254'
  },
  {
    municipality: 'Oberrieden',
    postalCode: '87769'
  },
  {
    municipality: 'Oberriexingen',
    postalCode: '71739'
  },
  {
    municipality: 'Oberrod',
    postalCode: '56479'
  },
  {
    municipality: 'Oberroßbach',
    postalCode: '56479'
  },
  {
    municipality: 'Oberrot',
    postalCode: '74420'
  },
  {
    municipality: 'Oberroth',
    postalCode: '89294'
  },
  {
    municipality: 'Oberscheidweiler',
    postalCode: '54533'
  },
  {
    municipality: 'Oberscheinfeld',
    postalCode: '91483'
  },
  {
    municipality: 'Oberschleißheim',
    postalCode: '85764'
  },
  {
    municipality: 'Oberschlettenbach',
    postalCode: '76889'
  },
  {
    municipality: 'Oberschneiding',
    postalCode: '94363'
  },
  {
    municipality: 'Oberschöna',
    postalCode: '09600'
  },
  {
    municipality: 'Oberschönegg',
    postalCode: '87770'
  },
  {
    municipality: 'Oberschwarzach',
    postalCode: '97516'
  },
  {
    municipality: 'Oberschweinbach',
    postalCode: '82294'
  },
  {
    municipality: 'Obersimten',
    postalCode: '66957'
  },
  {
    municipality: 'Obersinn',
    postalCode: '97791'
  },
  {
    municipality: 'Obersöchering',
    postalCode: '82395'
  },
  {
    municipality: 'Obersontheim',
    postalCode: '74423'
  },
  {
    municipality: 'Oberstadion',
    postalCode: '89613'
  },
  {
    municipality: 'Oberstadt',
    postalCode: '98530'
  },
  {
    municipality: 'Oberstadtfeld',
    postalCode: '54570'
  },
  {
    municipality: 'Oberstaufen',
    postalCode: '87534'
  },
  {
    municipality: 'Oberstaufenbach',
    postalCode: '66879'
  },
  {
    municipality: 'Oberstdorf',
    postalCode: '87561'
  },
  {
    municipality: 'Oberstedem',
    postalCode: '54634'
  },
  {
    municipality: 'Obersteinebach',
    postalCode: '56593'
  },
  {
    municipality: 'Oberstenfeld',
    postalCode: '71720'
  },
  {
    municipality: 'Oberstreit',
    postalCode: '55596'
  },
  {
    municipality: 'Oberstreu',
    postalCode: '97640'
  },
  {
    municipality: 'Obersulm',
    postalCode: '74182'
  },
  {
    municipality: 'Obersülzen',
    postalCode: '67271'
  },
  {
    municipality: 'Obersüßbach',
    postalCode: '84101'
  },
  {
    municipality: 'Obertaufkirchen',
    postalCode: '84419'
  },
  {
    municipality: 'Oberteuringen',
    postalCode: '88094'
  },
  {
    municipality: 'Oberthal',
    postalCode: '66649'
  },
  {
    municipality: 'Oberthulba',
    postalCode: '97723'
  },
  {
    municipality: 'Obertiefenbach',
    postalCode: '56357'
  },
  {
    municipality: 'Obertraubling',
    postalCode: '93083'
  },
  {
    municipality: 'Obertrebra',
    postalCode: '99510'
  },
  {
    municipality: 'Obertrubach',
    postalCode: '91286'
  },
  {
    municipality: 'Obertshausen',
    postalCode: '63179'
  },
  {
    municipality: 'Oberuckersee',
    postalCode: '17291'
  },
  {
    municipality: 'Oberursel',
    postalCode: '61440'
  },
  {
    municipality: 'Oberviechtach',
    postalCode: '92526'
  },
  {
    municipality: 'Oberwallmenach',
    postalCode: '56357'
  },
  {
    municipality: 'Oberwambach',
    postalCode: '57614'
  },
  {
    municipality: 'Oberweid',
    postalCode: '98634'
  },
  {
    municipality: 'Oberweiler',
    postalCode: '54636'
  },
  {
    municipality: 'Oberweiler im Tal',
    postalCode: '67756'
  },
  {
    municipality: 'Oberweiler-Tiefenbach',
    postalCode: '67752'
  },
  {
    municipality: 'Oberweis',
    postalCode: '54636'
  },
  {
    municipality: 'Oberwesel',
    postalCode: '55430'
  },
  {
    municipality: 'Oberwiera',
    postalCode: '08396'
  },
  {
    municipality: 'Oberwies',
    postalCode: '56379'
  },
  {
    municipality: 'Oberwiesen',
    postalCode: '67294'
  },
  {
    municipality: 'Oberwiesenthal',
    postalCode: '09484'
  },
  {
    municipality: 'Oberwolfach',
    postalCode: '77709'
  },
  {
    municipality: 'Oberwörresbach',
    postalCode: '55758'
  },
  {
    municipality: 'Oberzent',
    postalCode: '64760'
  },
  {
    municipality: 'Oberzissen',
    postalCode: '56651'
  },
  {
    municipality: 'Obhausen',
    postalCode: '06268'
  },
  {
    municipality: 'Obing',
    postalCode: '83119'
  },
  {
    municipality: 'Obrigheim',
    postalCode: '74847'
  },
  {
    municipality: 'Obrigheim (Pfalz)',
    postalCode: '67283'
  },
  {
    municipality: 'Ochsenfurt',
    postalCode: '97199'
  },
  {
    municipality: 'Ochsenhausen',
    postalCode: '88416'
  },
  {
    municipality: 'Ochtendung',
    postalCode: '56299'
  },
  {
    municipality: 'Ochtersum',
    postalCode: '26489'
  },
  {
    municipality: 'Ochtrup',
    postalCode: '48607'
  },
  {
    municipality: 'Ockenfels',
    postalCode: '53545'
  },
  {
    municipality: 'Ockenheim',
    postalCode: '55437'
  },
  {
    municipality: 'Ockfen',
    postalCode: '54441'
  },
  {
    municipality: 'Ockholm',
    postalCode: '25842'
  },
  {
    municipality: 'Odderade',
    postalCode: '25785'
  },
  {
    municipality: 'Odelzhausen',
    postalCode: '85235'
  },
  {
    municipality: 'Odenbach',
    postalCode: '67748'
  },
  {
    municipality: 'Odenthal',
    postalCode: '51519'
  },
  {
    municipality: 'Oderaue',
    postalCode: '16259'
  },
  {
    municipality: 'Oderberg',
    postalCode: '16248'
  },
  {
    municipality: 'Odernheim am Glan',
    postalCode: '55571'
  },
  {
    municipality: 'Oderwitz',
    postalCode: '02791'
  },
  {
    municipality: 'Odisheim',
    postalCode: '21775'
  },
  {
    municipality: 'Oebisfelde-Weferlingen',
    postalCode: '39343'
  },
  {
    municipality: 'Oebisfelde-Weferlingen',
    postalCode: '39356'
  },
  {
    municipality: 'Oebisfelde-Weferlingen',
    postalCode: '39359'
  },
  {
    municipality: 'Oebisfelde-Weferlingen',
    postalCode: '39646'
  },
  {
    municipality: 'Oechsen',
    postalCode: '36404'
  },
  {
    municipality: 'Oederan',
    postalCode: '09569'
  },
  {
    municipality: 'Oederquart',
    postalCode: '21734'
  },
  {
    municipality: 'Oedheim',
    postalCode: '74229'
  },
  {
    municipality: 'Oelde',
    postalCode: '59302'
  },
  {
    municipality: 'Oelixdorf',
    postalCode: '25524'
  },
  {
    municipality: 'Oelsberg',
    postalCode: '56357'
  },
  {
    municipality: 'Oelsnitz/Erzgeb.',
    postalCode: '09376'
  },
  {
    municipality: 'Oelsnitz/Vogtland',
    postalCode: '08606'
  },
  {
    municipality: 'Oerel',
    postalCode: '27432'
  },
  {
    municipality: 'Oer-Erkenschwick',
    postalCode: '45739'
  },
  {
    municipality: 'Oering',
    postalCode: '23845'
  },
  {
    municipality: 'Oerlenbach',
    postalCode: '97714'
  },
  {
    municipality: 'Oerlinghausen',
    postalCode: '33813'
  },
  {
    municipality: 'Oersberg',
    postalCode: '24407'
  },
  {
    municipality: 'Oersdorf',
    postalCode: '24568'
  },
  {
    municipality: 'Oeschebüttel',
    postalCode: '25548'
  },
  {
    municipality: 'Oesterdeichstrich',
    postalCode: '25761'
  },
  {
    municipality: 'Oesterwurth',
    postalCode: '25764'
  },
  {
    municipality: 'Oestrich-Winkel',
    postalCode: '65375'
  },
  {
    municipality: 'Oettern',
    postalCode: '99438'
  },
  {
    municipality: 'Oettersdorf',
    postalCode: '07907'
  },
  {
    municipality: 'Oettingen i.Bay.',
    postalCode: '86732'
  },
  {
    municipality: 'Oetzen',
    postalCode: '29588'
  },
  {
    municipality: 'Oevenum',
    postalCode: '25938'
  },
  {
    municipality: 'Oeversee',
    postalCode: '24988'
  },
  {
    municipality: 'Offenau',
    postalCode: '74254'
  },
  {
    municipality: 'Offenbach am Main',
    postalCode: '63065'
  },
  {
    municipality: 'Offenbach am Main',
    postalCode: '63067'
  },
  {
    municipality: 'Offenbach am Main',
    postalCode: '63069'
  },
  {
    municipality: 'Offenbach am Main',
    postalCode: '63071'
  },
  {
    municipality: 'Offenbach am Main',
    postalCode: '63073'
  },
  {
    municipality: 'Offenbach am Main',
    postalCode: '63075'
  },
  {
    municipality: 'Offenbach an der Queich',
    postalCode: '76877'
  },
  {
    municipality: 'Offenbach-Hundheim',
    postalCode: '67749'
  },
  {
    municipality: 'Offenberg',
    postalCode: '94560'
  },
  {
    municipality: 'Offenburg',
    postalCode: '77652'
  },
  {
    municipality: 'Offenburg',
    postalCode: '77654'
  },
  {
    municipality: 'Offenburg',
    postalCode: '77656'
  },
  {
    municipality: 'Offenbüttel',
    postalCode: '25767'
  },
  {
    municipality: 'Offenhausen',
    postalCode: '91238'
  },
  {
    municipality: 'Offenheim',
    postalCode: '55234'
  },
  {
    municipality: 'Offingen',
    postalCode: '89362'
  },
  {
    municipality: 'Offstein',
    postalCode: '67591'
  },
  {
    municipality: 'Ofterdingen',
    postalCode: '72131'
  },
  {
    municipality: 'Ofterschwang',
    postalCode: '87527'
  },
  {
    municipality: 'Oftersheim',
    postalCode: '68723'
  },
  {
    municipality: 'Oggelshausen',
    postalCode: '88422'
  },
  {
    municipality: 'Ohlenhard',
    postalCode: '53520'
  },
  {
    municipality: 'Ohlsbach',
    postalCode: '77797'
  },
  {
    municipality: 'Ohlstadt',
    postalCode: '82441'
  },
  {
    municipality: 'Ohlweiler',
    postalCode: '55469'
  },
  {
    municipality: 'Ohmbach',
    postalCode: '66903'
  },
  {
    municipality: 'Ohmden',
    postalCode: '73275'
  },
  {
    municipality: 'Ohne',
    postalCode: '48465'
  },
  {
    municipality: 'Öhningen',
    postalCode: '78337'
  },
  {
    municipality: 'Ohorn',
    postalCode: '01896'
  },
  {
    municipality: 'Ohrdruf',
    postalCode: '99885'
  },
  {
    municipality: 'Ohrenbach',
    postalCode: '91620'
  },
  {
    municipality: 'Öhringen',
    postalCode: '74613'
  },
  {
    municipality: 'Ohrum',
    postalCode: '38312'
  },
  {
    municipality: 'Olbernhau',
    postalCode: '09526'
  },
  {
    municipality: 'Olbersdorf',
    postalCode: '02785'
  },
  {
    municipality: 'Ölbronn-Dürrn',
    postalCode: '75248'
  },
  {
    municipality: 'Olching',
    postalCode: '82140'
  },
  {
    municipality: 'Oldenborstel',
    postalCode: '25560'
  },
  {
    municipality: 'Oldenburg',
    postalCode: '26121'
  },
  {
    municipality: 'Oldenburg',
    postalCode: '26122'
  },
  {
    municipality: 'Oldenburg',
    postalCode: '26123'
  },
  {
    municipality: 'Oldenburg',
    postalCode: '26125'
  },
  {
    municipality: 'Oldenburg',
    postalCode: '26127'
  },
  {
    municipality: 'Oldenburg',
    postalCode: '26129'
  },
  {
    municipality: 'Oldenburg',
    postalCode: '26131'
  },
  {
    municipality: 'Oldenburg',
    postalCode: '26133'
  },
  {
    municipality: 'Oldenburg',
    postalCode: '26135'
  },
  {
    municipality: 'Oldenburg in Holstein',
    postalCode: '23758'
  },
  {
    municipality: 'Oldenbüttel',
    postalCode: '25557'
  },
  {
    municipality: 'Oldendorf',
    postalCode: '21726'
  },
  {
    municipality: 'Oldendorf',
    postalCode: '25588'
  },
  {
    municipality: 'Oldendorf (Luhe)',
    postalCode: '21385'
  },
  {
    municipality: 'Oldenhütten',
    postalCode: '24793'
  },
  {
    municipality: 'Oldenswort',
    postalCode: '25870'
  },
  {
    municipality: 'Oldersbek',
    postalCode: '25873'
  },
  {
    municipality: 'Olderup',
    postalCode: '25860'
  },
  {
    municipality: 'Oldsum',
    postalCode: '25938'
  },
  {
    municipality: 'Olfen',
    postalCode: '59399'
  },
  {
    municipality: 'Ollendorf',
    postalCode: '99198'
  },
  {
    municipality: 'Öllingen',
    postalCode: '89129'
  },
  {
    municipality: 'Ollmuth',
    postalCode: '54316'
  },
  {
    municipality: 'Olmscheid',
    postalCode: '54689'
  },
  {
    municipality: 'Olpe',
    postalCode: '57462'
  },
  {
    municipality: 'Olsberg',
    postalCode: '59939'
  },
  {
    municipality: 'Olsbrücken',
    postalCode: '67737'
  },
  {
    municipality: 'Olsdorf',
    postalCode: '54646'
  },
  {
    municipality: 'Ölsen',
    postalCode: '57612'
  },
  {
    municipality: 'Olzheim',
    postalCode: '54597'
  },
  {
    municipality: 'Onsdorf',
    postalCode: '54456'
  },
  {
    municipality: 'Opfenbach',
    postalCode: '88145'
  },
  {
    municipality: 'Öpfingen',
    postalCode: '89614'
  },
  {
    municipality: 'Oppach',
    postalCode: '02736'
  },
  {
    municipality: 'Oppenau',
    postalCode: '77728'
  },
  {
    municipality: 'Oppenheim',
    postalCode: '55276'
  },
  {
    municipality: 'Oppenweiler',
    postalCode: '71560'
  },
  {
    municipality: 'Oppenweiler',
    postalCode: '71570'
  },
  {
    municipality: 'Oppershausen',
    postalCode: '99986'
  },
  {
    municipality: 'Oppertshausen',
    postalCode: '55469'
  },
  {
    municipality: 'Oppurg',
    postalCode: '07381'
  },
  {
    municipality: 'Oranienbaum-Wörlitz',
    postalCode: '06785'
  },
  {
    municipality: 'Oranienburg',
    postalCode: '16515'
  },
  {
    municipality: 'Orbis',
    postalCode: '67294'
  },
  {
    municipality: 'Orenhofen',
    postalCode: '54298'
  },
  {
    municipality: 'Orfgen',
    postalCode: '57632'
  },
  {
    municipality: 'Orlamünde',
    postalCode: '07768'
  },
  {
    municipality: 'Orlenbach',
    postalCode: '54595'
  },
  {
    municipality: 'Ormont',
    postalCode: '54597'
  },
  {
    municipality: 'Ornbau',
    postalCode: '91737'
  },
  {
    municipality: 'Orsfeld',
    postalCode: '54655'
  },
  {
    municipality: 'Orsingen-Nenzingen',
    postalCode: '78359'
  },
  {
    municipality: 'Ortenberg',
    postalCode: '63683'
  },
  {
    municipality: 'Ortenberg',
    postalCode: '77799'
  },
  {
    municipality: 'Ortenburg',
    postalCode: '94496'
  },
  {
    municipality: 'Ortrand',
    postalCode: '01990'
  },
  {
    municipality: 'Osann-Monzel',
    postalCode: '54518'
  },
  {
    municipality: 'Osburg',
    postalCode: '54317'
  },
  {
    municipality: 'Oschatz',
    postalCode: '04758'
  },
  {
    municipality: 'Oschersleben',
    postalCode: '39387'
  },
  {
    municipality: 'Osdorf',
    postalCode: '24251'
  },
  {
    municipality: 'Osloß',
    postalCode: '38557'
  },
  {
    municipality: 'Osnabrück',
    postalCode: '49074'
  },
  {
    municipality: 'Osnabrück',
    postalCode: '49076'
  },
  {
    municipality: 'Osnabrück',
    postalCode: '49078'
  },
  {
    municipality: 'Osnabrück',
    postalCode: '49080'
  },
  {
    municipality: 'Osnabrück',
    postalCode: '49082'
  },
  {
    municipality: 'Osnabrück',
    postalCode: '49084'
  },
  {
    municipality: 'Osnabrück',
    postalCode: '49086'
  },
  {
    municipality: 'Osnabrück',
    postalCode: '49088'
  },
  {
    municipality: 'Osnabrück',
    postalCode: '49090'
  },
  {
    municipality: 'Oßling - Wóslink',
    postalCode: '01920'
  },
  {
    municipality: 'Ostbevern',
    postalCode: '48346'
  },
  {
    municipality: 'Osteel',
    postalCode: '26529'
  },
  {
    municipality: 'Ostelsheim',
    postalCode: '75395'
  },
  {
    municipality: 'Osten',
    postalCode: '21756'
  },
  {
    municipality: 'Ostenfeld',
    postalCode: '24790'
  },
  {
    municipality: 'Ostenfeld (Husum)',
    postalCode: '25872'
  },
  {
    municipality: 'Osterberg',
    postalCode: '89296'
  },
  {
    municipality: 'Osterbruch',
    postalCode: '21762'
  },
  {
    municipality: 'Osterburg (Altmark)',
    postalCode: '39606'
  },
  {
    municipality: 'Osterburken',
    postalCode: '74706'
  },
  {
    municipality: 'Osterby',
    postalCode: '24367'
  },
  {
    municipality: 'Osterby',
    postalCode: '24994'
  },
  {
    municipality: 'Ostercappeln',
    postalCode: '49179'
  },
  {
    municipality: 'Ostereistedt',
    postalCode: '27404'
  },
  {
    municipality: 'Osterfeld',
    postalCode: '06721'
  },
  {
    municipality: 'Osterheide',
    postalCode: '29664'
  },
  {
    municipality: 'Osterheide',
    postalCode: '29683'
  },
  {
    municipality: 'Osterhever',
    postalCode: '25836'
  },
  {
    municipality: 'Osterhofen',
    postalCode: '94486'
  },
  {
    municipality: 'Osterholz-Scharmbeck',
    postalCode: '27711'
  },
  {
    municipality: 'Osterhorn',
    postalCode: '25364'
  },
  {
    municipality: 'Osternienburger Land',
    postalCode: '06386'
  },
  {
    municipality: 'Osterode am Harz',
    postalCode: '37520'
  },
  {
    municipality: 'Oster-Ohrstedt',
    postalCode: '25885'
  },
  {
    municipality: 'Osterrade',
    postalCode: '25767'
  },
  {
    municipality: 'Osterrönfeld',
    postalCode: '24783'
  },
  {
    municipality: 'Osterspai',
    postalCode: '56340'
  },
  {
    municipality: 'Osterstedt',
    postalCode: '25590'
  },
  {
    municipality: 'Osterwald',
    postalCode: '49828'
  },
  {
    municipality: 'Osterwieck',
    postalCode: '38835'
  },
  {
    municipality: 'Osterwieck',
    postalCode: '38836'
  },
  {
    municipality: 'Osterzell',
    postalCode: '87662'
  },
  {
    municipality: 'Ostfildern',
    postalCode: '73760'
  },
  {
    municipality: 'Osthausen-Wülfershausen',
    postalCode: '99310'
  },
  {
    municipality: 'Ostheim v.d.Rhön',
    postalCode: '97645'
  },
  {
    municipality: 'Osthofen',
    postalCode: '67574'
  },
  {
    municipality: 'Ostrach',
    postalCode: '88356'
  },
  {
    municipality: 'Ostramondra',
    postalCode: '99636'
  },
  {
    municipality: 'Ostrau',
    postalCode: '04749'
  },
  {
    municipality: 'Ostrhauderfehn',
    postalCode: '26842'
  },
  {
    municipality: 'Östringen',
    postalCode: '76684'
  },
  {
    municipality: 'Ostritz',
    postalCode: '02899'
  },
  {
    municipality: 'Ostrohe',
    postalCode: '25746'
  },
  {
    municipality: 'Oststeinbek',
    postalCode: '22113'
  },
  {
    municipality: 'Ötigheim',
    postalCode: '76470'
  },
  {
    municipality: 'Ötisheim',
    postalCode: '75443'
  },
  {
    municipality: 'Ottenbach',
    postalCode: '73113'
  },
  {
    municipality: 'Ottenbach',
    postalCode: '73529'
  },
  {
    municipality: 'Ottenbüttel',
    postalCode: '25591'
  },
  {
    municipality: 'Ottendorf',
    postalCode: '24107'
  },
  {
    municipality: 'Ottendorf',
    postalCode: '07646'
  },
  {
    municipality: 'Ottendorf-Okrilla',
    postalCode: '01458'
  },
  {
    municipality: 'Ottenhofen',
    postalCode: '85570'
  },
  {
    municipality: 'Ottenhöfen im Schwarzwald',
    postalCode: '77883'
  },
  {
    municipality: 'Ottensoos',
    postalCode: '91242'
  },
  {
    municipality: 'Ottenstein',
    postalCode: '31868'
  },
  {
    municipality: 'Otter',
    postalCode: '21259'
  },
  {
    municipality: 'Otterbach',
    postalCode: '67731'
  },
  {
    municipality: 'Otterberg',
    postalCode: '67697'
  },
  {
    municipality: 'Otterfing',
    postalCode: '83624'
  },
  {
    municipality: 'Otterndorf',
    postalCode: '21762'
  },
  {
    municipality: 'Ottersberg',
    postalCode: '28870'
  },
  {
    municipality: 'Ottersheim',
    postalCode: '67308'
  },
  {
    municipality: 'Ottersheim bei Landau',
    postalCode: '76879'
  },
  {
    municipality: 'Otterstadt',
    postalCode: '67166'
  },
  {
    municipality: 'Ottersweier',
    postalCode: '77833'
  },
  {
    municipality: 'Otterwisch',
    postalCode: '04668'
  },
  {
    municipality: 'Otting',
    postalCode: '86700'
  },
  {
    municipality: 'Ottobeuren',
    postalCode: '87724'
  },
  {
    municipality: 'Ottobrunn',
    postalCode: '85521'
  },
  {
    municipality: 'Ottrau',
    postalCode: '34633'
  },
  {
    municipality: 'Ottweiler',
    postalCode: '66564'
  },
  {
    municipality: 'Otzberg',
    postalCode: '64853'
  },
  {
    municipality: 'Otzing',
    postalCode: '94563'
  },
  {
    municipality: 'Ötzingen',
    postalCode: '56244'
  },
  {
    municipality: 'Otzweiler',
    postalCode: '55606'
  },
  {
    municipality: 'Ovelgönne',
    postalCode: '26939'
  },
  {
    municipality: 'Overath',
    postalCode: '51491'
  },
  {
    municipality: 'Owen',
    postalCode: '73277'
  },
  {
    municipality: 'Owingen',
    postalCode: '88696'
  },
  {
    municipality: 'Owschlag',
    postalCode: '24811'
  },
  {
    municipality: 'Owschlag',
    postalCode: '24848'
  },
  {
    municipality: 'Oybin',
    postalCode: '02797'
  },
  {
    municipality: 'Oy-Mittelberg',
    postalCode: '87466'
  },
  {
    municipality: 'Oyten',
    postalCode: '28876'
  },
  {
    municipality: 'Padenstedt',
    postalCode: '24634'
  },
  {
    municipality: 'Paderborn',
    postalCode: '33098'
  },
  {
    municipality: 'Paderborn',
    postalCode: '33100'
  },
  {
    municipality: 'Paderborn',
    postalCode: '33102'
  },
  {
    municipality: 'Paderborn',
    postalCode: '33104'
  },
  {
    municipality: 'Paderborn',
    postalCode: '33106'
  },
  {
    municipality: 'Paderborn',
    postalCode: '33154'
  },
  {
    municipality: 'Paderborn',
    postalCode: '33161'
  },
  {
    municipality: 'Pähl',
    postalCode: '82396'
  },
  {
    municipality: 'Pahlen',
    postalCode: '25794'
  },
  {
    municipality: 'Painten',
    postalCode: '93351'
  },
  {
    municipality: 'Paitzdorf',
    postalCode: '07580'
  },
  {
    municipality: 'Palling',
    postalCode: '83349'
  },
  {
    municipality: 'Palzem',
    postalCode: '54439'
  },
  {
    municipality: 'Pampow',
    postalCode: '19075'
  },
  {
    municipality: 'Panker',
    postalCode: '24321'
  },
  {
    municipality: 'Panketal',
    postalCode: '16341'
  },
  {
    municipality: 'Panschwitz-Kuckau - Pančicy-Kukow',
    postalCode: '01920'
  },
  {
    municipality: 'Pantelitz',
    postalCode: '18442'
  },
  {
    municipality: 'Panten',
    postalCode: '23896'
  },
  {
    municipality: 'Pantenburg',
    postalCode: '54531'
  },
  {
    municipality: 'Panzweiler',
    postalCode: '56865'
  },
  {
    municipality: 'Papenburg',
    postalCode: '26871'
  },
  {
    municipality: 'Papendorf',
    postalCode: '18059'
  },
  {
    municipality: 'Papendorf',
    postalCode: '17309'
  },
  {
    municipality: 'Papenhagen',
    postalCode: '18510'
  },
  {
    municipality: 'Pappenheim',
    postalCode: '91788'
  },
  {
    municipality: 'Parchim',
    postalCode: '19370'
  },
  {
    municipality: 'Parchim',
    postalCode: '19374'
  },
  {
    municipality: 'Parchtitz',
    postalCode: '18528'
  },
  {
    municipality: 'Parkstein',
    postalCode: '92711'
  },
  {
    municipality: 'Parkstetten',
    postalCode: '94365'
  },
  {
    municipality: 'Parsau',
    postalCode: '38470'
  },
  {
    municipality: 'Parsberg',
    postalCode: '92331'
  },
  {
    municipality: 'Parsteinsee',
    postalCode: '16248'
  },
  {
    municipality: 'Partenheim',
    postalCode: '55288'
  },
  {
    municipality: 'Partenstein',
    postalCode: '97846'
  },
  {
    municipality: 'Parthenstein',
    postalCode: '04668'
  },
  {
    municipality: 'Paschel',
    postalCode: '54314'
  },
  {
    municipality: 'Pasewalk',
    postalCode: '17309'
  },
  {
    municipality: 'Paska',
    postalCode: '07381'
  },
  {
    municipality: 'Passade',
    postalCode: '24253'
  },
  {
    municipality: 'Passau',
    postalCode: '94032'
  },
  {
    municipality: 'Passau',
    postalCode: '94034'
  },
  {
    municipality: 'Passau',
    postalCode: '94036'
  },
  {
    municipality: 'Passee',
    postalCode: '23992'
  },
  {
    municipality: 'Passow',
    postalCode: '19386'
  },
  {
    municipality: 'Passow',
    postalCode: '16306'
  },
  {
    municipality: 'Pastetten',
    postalCode: '85669'
  },
  {
    municipality: 'Patersberg',
    postalCode: '56348'
  },
  {
    municipality: 'Patersdorf',
    postalCode: '94265'
  },
  {
    municipality: 'Pätow-Steegen',
    postalCode: '19230'
  },
  {
    municipality: 'Pattensen',
    postalCode: '30982'
  },
  {
    municipality: 'Patzig',
    postalCode: '18528'
  },
  {
    municipality: 'Paulinenaue',
    postalCode: '14641'
  },
  {
    municipality: 'Paunzhausen',
    postalCode: '85307'
  },
  {
    municipality: 'Pausa-Mühltroff',
    postalCode: '07919'
  },
  {
    municipality: 'Pausa-Mühltroff',
    postalCode: '07952'
  },
  {
    municipality: 'Pausa-Mühltroff',
    postalCode: '08539'
  },
  {
    municipality: 'Päwesin',
    postalCode: '14778'
  },
  {
    municipality: 'Pechbrunn',
    postalCode: '95701'
  },
  {
    municipality: 'Peenehagen',
    postalCode: '17192'
  },
  {
    municipality: 'Peenehagen',
    postalCode: '17194'
  },
  {
    municipality: 'Peenemünde',
    postalCode: '17449'
  },
  {
    municipality: 'Peffingen',
    postalCode: '54668'
  },
  {
    municipality: 'Pegau',
    postalCode: '04523'
  },
  {
    municipality: 'Pegestorf',
    postalCode: '37619'
  },
  {
    municipality: 'Pegnitz',
    postalCode: '91257'
  },
  {
    municipality: 'Peine',
    postalCode: '31224'
  },
  {
    municipality: 'Peine',
    postalCode: '31226'
  },
  {
    municipality: 'Peine',
    postalCode: '31228'
  },
  {
    municipality: 'Peissen',
    postalCode: '25551'
  },
  {
    municipality: 'Peißenberg',
    postalCode: '82380'
  },
  {
    municipality: 'Peiting',
    postalCode: '86971'
  },
  {
    municipality: 'Peitz',
    postalCode: '03185'
  },
  {
    municipality: 'Pellingen',
    postalCode: '54331'
  },
  {
    municipality: 'Pellworm',
    postalCode: '25845'
  },
  {
    municipality: 'Pellworm',
    postalCode: '25849'
  },
  {
    municipality: 'Pelm',
    postalCode: '54570'
  },
  {
    municipality: 'Pemfling',
    postalCode: '93482'
  },
  {
    municipality: 'Penig',
    postalCode: '09322'
  },
  {
    municipality: 'Penkow',
    postalCode: '17213'
  },
  {
    municipality: 'Penkun',
    postalCode: '17328'
  },
  {
    municipality: 'Pennigsehl',
    postalCode: '31621'
  },
  {
    municipality: 'Pentling',
    postalCode: '93080'
  },
  {
    municipality: 'Penzberg',
    postalCode: '82377'
  },
  {
    municipality: 'Penzin',
    postalCode: '18249'
  },
  {
    municipality: 'Penzing',
    postalCode: '86929'
  },
  {
    municipality: 'Penzlin',
    postalCode: '17217'
  },
  {
    municipality: 'Penzlin',
    postalCode: '17219'
  },
  {
    municipality: 'Perach',
    postalCode: '84567'
  },
  {
    municipality: 'Perasdorf',
    postalCode: '94366'
  },
  {
    municipality: 'Perkam',
    postalCode: '94368'
  },
  {
    municipality: 'Perl',
    postalCode: '66706'
  },
  {
    municipality: 'Perleberg',
    postalCode: '19348'
  },
  {
    municipality: 'Perlesreut',
    postalCode: '94157'
  },
  {
    municipality: 'Perlin',
    postalCode: '19209'
  },
  {
    municipality: 'Perscheid',
    postalCode: '55430'
  },
  {
    municipality: 'Pessin',
    postalCode: '14641'
  },
  {
    municipality: 'Petersaurach',
    postalCode: '91580'
  },
  {
    municipality: 'Petersberg',
    postalCode: '36100'
  },
  {
    municipality: 'Petersberg',
    postalCode: '66989'
  },
  {
    municipality: 'Petersberg',
    postalCode: '06193'
  },
  {
    municipality: 'Petersberg',
    postalCode: '07616'
  },
  {
    municipality: 'Petersdorf',
    postalCode: '86574'
  },
  {
    municipality: 'Petershagen',
    postalCode: '32469'
  },
  {
    municipality: 'Petershagen/Eggersdorf',
    postalCode: '15345'
  },
  {
    municipality: 'Petershagen/Eggersdorf',
    postalCode: '15370'
  },
  {
    municipality: 'Petershausen',
    postalCode: '85238'
  },
  {
    municipality: 'Peterslahr',
    postalCode: '57632'
  },
  {
    municipality: 'Peterswald-Löffelscheid',
    postalCode: '56858'
  },
  {
    municipality: 'Pettendorf',
    postalCode: '93186'
  },
  {
    municipality: 'Petting',
    postalCode: '83367'
  },
  {
    municipality: 'Pettstadt',
    postalCode: '96175'
  },
  {
    municipality: 'Peuschen',
    postalCode: '07389'
  },
  {
    municipality: 'Pfaffenhausen',
    postalCode: '87772'
  },
  {
    municipality: 'Pfaffenhofen',
    postalCode: '74397'
  },
  {
    municipality: 'Pfaffenhofen an der Glonn',
    postalCode: '85235'
  },
  {
    municipality: 'Pfaffenhofen an der Ilm',
    postalCode: '85276'
  },
  {
    municipality: 'Pfaffenhofen an der Roth',
    postalCode: '89284'
  },
  {
    municipality: 'Pfaffen-Schwabenheim',
    postalCode: '55546'
  },
  {
    municipality: 'Pfaffenweiler',
    postalCode: '79292'
  },
  {
    municipality: 'Pfaffing',
    postalCode: '83539'
  },
  {
    municipality: 'Pfaffschwende',
    postalCode: '37308'
  },
  {
    municipality: 'Pfakofen',
    postalCode: '93101'
  },
  {
    municipality: 'Pfalzfeld',
    postalCode: '56291'
  },
  {
    municipality: 'Pfalzgrafenweiler',
    postalCode: '72285'
  },
  {
    municipality: 'Pfarrkirchen',
    postalCode: '84347'
  },
  {
    municipality: 'Pfarrweisach',
    postalCode: '96176'
  },
  {
    municipality: 'Pfatter',
    postalCode: '93102'
  },
  {
    municipality: 'Pfedelbach',
    postalCode: '74629'
  },
  {
    municipality: 'Pfeffelbach',
    postalCode: '66871'
  },
  {
    municipality: 'Pfeffenhausen',
    postalCode: '84076'
  },
  {
    municipality: 'Pferdingsleben',
    postalCode: '99869'
  },
  {
    municipality: 'Pfinztal',
    postalCode: '76327'
  },
  {
    municipality: 'Pfofeld',
    postalCode: '91738'
  },
  {
    municipality: 'Pförring',
    postalCode: '85104'
  },
  {
    municipality: 'Pforzen',
    postalCode: '87666'
  },
  {
    municipality: 'Pforzheim',
    postalCode: '75172'
  },
  {
    municipality: 'Pforzheim',
    postalCode: '75173'
  },
  {
    municipality: 'Pforzheim',
    postalCode: '75175'
  },
  {
    municipality: 'Pforzheim',
    postalCode: '75177'
  },
  {
    municipality: 'Pforzheim',
    postalCode: '75179'
  },
  {
    municipality: 'Pforzheim',
    postalCode: '75180'
  },
  {
    municipality: 'Pforzheim',
    postalCode: '75181'
  },
  {
    municipality: 'Pfreimd',
    postalCode: '92536'
  },
  {
    municipality: 'Pfronstetten',
    postalCode: '72539'
  },
  {
    municipality: 'Pfronten',
    postalCode: '87459'
  },
  {
    municipality: 'Pfullendorf',
    postalCode: '88630'
  },
  {
    municipality: 'Pfullingen',
    postalCode: '72793'
  },
  {
    municipality: 'Pfungstadt',
    postalCode: '64319'
  },
  {
    municipality: 'Philippsburg',
    postalCode: '76661'
  },
  {
    municipality: 'Philippsheim',
    postalCode: '54662'
  },
  {
    municipality: 'Philippsreut',
    postalCode: '94158'
  },
  {
    municipality: 'Philippsthal (Werra)',
    postalCode: '36269'
  },
  {
    municipality: 'Picher',
    postalCode: '19230'
  },
  {
    municipality: 'Pickließem',
    postalCode: '54647'
  },
  {
    municipality: 'Piding',
    postalCode: '83451'
  },
  {
    municipality: 'Pielenhofen',
    postalCode: '93188'
  },
  {
    municipality: 'Piesport',
    postalCode: '54498'
  },
  {
    municipality: 'Pillig',
    postalCode: '56753'
  },
  {
    municipality: 'Pilsach',
    postalCode: '92367'
  },
  {
    municipality: 'Pilsting',
    postalCode: '94431'
  },
  {
    municipality: 'Pingelshagen',
    postalCode: '19069'
  },
  {
    municipality: 'Pinneberg',
    postalCode: '25421'
  },
  {
    municipality: 'Pinnow',
    postalCode: '19065'
  },
  {
    municipality: 'Pinnow',
    postalCode: '16278'
  },
  {
    municipality: 'Pintesfeld',
    postalCode: '54649'
  },
  {
    municipality: 'Pinzberg',
    postalCode: '91361'
  },
  {
    municipality: 'Pirk',
    postalCode: '92712'
  },
  {
    municipality: 'Pirmasens',
    postalCode: '66953'
  },
  {
    municipality: 'Pirmasens',
    postalCode: '66954'
  },
  {
    municipality: 'Pirmasens',
    postalCode: '66955'
  },
  {
    municipality: 'Pirna',
    postalCode: '01796'
  },
  {
    municipality: 'Pirow',
    postalCode: '19348'
  },
  {
    municipality: 'Pittenbach',
    postalCode: '54595'
  },
  {
    municipality: 'Pittenhart',
    postalCode: '83132'
  },
  {
    municipality: 'Plaaz',
    postalCode: '18276'
  },
  {
    municipality: 'Plaidt',
    postalCode: '56637'
  },
  {
    municipality: 'Planebruch',
    postalCode: '14822'
  },
  {
    municipality: 'Planegg',
    postalCode: '82152'
  },
  {
    municipality: 'Planetal',
    postalCode: '14806'
  },
  {
    municipality: 'Plankenfels',
    postalCode: '95515'
  },
  {
    municipality: 'Plankstadt',
    postalCode: '68723'
  },
  {
    municipality: 'Plascheid',
    postalCode: '54673'
  },
  {
    municipality: 'Plate',
    postalCode: '19086'
  },
  {
    municipality: 'Platten',
    postalCode: '54518'
  },
  {
    municipality: 'Plattenburg',
    postalCode: '19339'
  },
  {
    municipality: 'Plattling',
    postalCode: '94447'
  },
  {
    municipality: 'Plau am See',
    postalCode: '19395'
  },
  {
    municipality: 'Plaue',
    postalCode: '99338'
  },
  {
    municipality: 'Plauen',
    postalCode: '08523'
  },
  {
    municipality: 'Plauen',
    postalCode: '08525'
  },
  {
    municipality: 'Plauen',
    postalCode: '08527'
  },
  {
    municipality: 'Plauen',
    postalCode: '08529'
  },
  {
    municipality: 'Plauen',
    postalCode: '08541'
  },
  {
    municipality: 'Plauen',
    postalCode: '08547'
  },
  {
    municipality: 'Plech',
    postalCode: '91287'
  },
  {
    municipality: 'Pleckhausen',
    postalCode: '56593'
  },
  {
    municipality: 'Pleidelsheim',
    postalCode: '74385'
  },
  {
    municipality: 'Plein',
    postalCode: '54518'
  },
  {
    municipality: 'Pleinfeld',
    postalCode: '91785'
  },
  {
    municipality: 'Pleiskirchen',
    postalCode: '84568'
  },
  {
    municipality: 'Pleisweiler-Oberhofen',
    postalCode: '76889'
  },
  {
    municipality: 'Pleitersheim',
    postalCode: '55576'
  },
  {
    municipality: 'Pleizenhausen',
    postalCode: '55469'
  },
  {
    municipality: 'Pleß',
    postalCode: '87773'
  },
  {
    municipality: 'Plessa',
    postalCode: '04928'
  },
  {
    municipality: 'Plettenberg',
    postalCode: '58840'
  },
  {
    municipality: 'Pleystein',
    postalCode: '92714'
  },
  {
    municipality: 'Pliening',
    postalCode: '85652'
  },
  {
    municipality: 'Pliezhausen',
    postalCode: '72124'
  },
  {
    municipality: 'Plochingen',
    postalCode: '73207'
  },
  {
    municipality: 'Plön',
    postalCode: '24306'
  },
  {
    municipality: 'Plößberg',
    postalCode: '95703'
  },
  {
    municipality: 'Plothen',
    postalCode: '07907'
  },
  {
    municipality: 'Plötzkau',
    postalCode: '06425'
  },
  {
    municipality: 'Plöwen',
    postalCode: '17321'
  },
  {
    municipality: 'Plüderhausen',
    postalCode: '73642'
  },
  {
    municipality: 'Plüderhausen',
    postalCode: '73655'
  },
  {
    municipality: 'Plütscheid',
    postalCode: '54597'
  },
  {
    municipality: 'Pluwig',
    postalCode: '54316'
  },
  {
    municipality: 'Pockau-Lengefeld',
    postalCode: '09509'
  },
  {
    municipality: 'Pockau-Lengefeld',
    postalCode: '09514'
  },
  {
    municipality: 'Pocking',
    postalCode: '94060'
  },
  {
    municipality: 'Pöcking',
    postalCode: '82343'
  },
  {
    municipality: 'Podelzig',
    postalCode: '15326'
  },
  {
    municipality: 'Pogeez',
    postalCode: '23911'
  },
  {
    municipality: 'Poggensee',
    postalCode: '23896'
  },
  {
    municipality: 'Pohl',
    postalCode: '56357'
  },
  {
    municipality: 'Pöhl',
    postalCode: '08543'
  },
  {
    municipality: 'Pohle',
    postalCode: '31867'
  },
  {
    municipality: 'Pohlheim',
    postalCode: '35415'
  },
  {
    municipality: 'Pohnsdorf',
    postalCode: '24211'
  },
  {
    municipality: 'Poing',
    postalCode: '85586'
  },
  {
    municipality: 'Pokrent',
    postalCode: '19205'
  },
  {
    municipality: 'Polch',
    postalCode: '56751'
  },
  {
    municipality: 'Pölchow',
    postalCode: '18059'
  },
  {
    municipality: 'Pölich',
    postalCode: '54340'
  },
  {
    municipality: 'Pölitz',
    postalCode: '23847'
  },
  {
    municipality: 'Polle',
    postalCode: '37647'
  },
  {
    municipality: 'Pollenfeld',
    postalCode: '85131'
  },
  {
    municipality: 'Pollhagen',
    postalCode: '31718'
  },
  {
    municipality: 'Polling',
    postalCode: '82398'
  },
  {
    municipality: 'Polling',
    postalCode: '84570'
  },
  {
    municipality: 'Polsingen',
    postalCode: '91805'
  },
  {
    municipality: 'Pölzig',
    postalCode: '07554'
  },
  {
    municipality: 'Polzow',
    postalCode: '17309'
  },
  {
    municipality: 'Pommelsbrunn',
    postalCode: '91224'
  },
  {
    municipality: 'Pommerby',
    postalCode: '24395'
  },
  {
    municipality: 'Pommern',
    postalCode: '56829'
  },
  {
    municipality: 'Pommersfelden',
    postalCode: '96178'
  },
  {
    municipality: 'Pomster',
    postalCode: '53534'
  },
  {
    municipality: 'Ponitz',
    postalCode: '04639'
  },
  {
    municipality: 'Poppenbüll',
    postalCode: '25836'
  },
  {
    municipality: 'Poppendorf',
    postalCode: '18184'
  },
  {
    municipality: 'Poppenhausen',
    postalCode: '97490'
  },
  {
    municipality: 'Poppenhausen',
    postalCode: '36163'
  },
  {
    municipality: 'Poppenricht',
    postalCode: '92284'
  },
  {
    municipality: 'Pörmitz',
    postalCode: '07907'
  },
  {
    municipality: 'Pörnbach',
    postalCode: '85309'
  },
  {
    municipality: 'Porta Westfalica',
    postalCode: '32457'
  },
  {
    municipality: 'Pöschendorf',
    postalCode: '25560'
  },
  {
    municipality: 'Poseritz',
    postalCode: '18574'
  },
  {
    municipality: 'Pösing',
    postalCode: '93483'
  },
  {
    municipality: 'Pößneck',
    postalCode: '07381'
  },
  {
    municipality: 'Postau',
    postalCode: '84103'
  },
  {
    municipality: 'Postbauer-Heng',
    postalCode: '92353'
  },
  {
    municipality: 'Posterstein',
    postalCode: '04626'
  },
  {
    municipality: 'Postfeld',
    postalCode: '24211'
  },
  {
    municipality: 'Postlow',
    postalCode: '17391'
  },
  {
    municipality: 'Postmünster',
    postalCode: '84389'
  },
  {
    municipality: 'Potsdam',
    postalCode: '14467'
  },
  {
    municipality: 'Potsdam',
    postalCode: '14469'
  },
  {
    municipality: 'Potsdam',
    postalCode: '14471'
  },
  {
    municipality: 'Potsdam',
    postalCode: '14473'
  },
  {
    municipality: 'Potsdam',
    postalCode: '14476'
  },
  {
    municipality: 'Potsdam',
    postalCode: '14478'
  },
  {
    municipality: 'Potsdam',
    postalCode: '14480'
  },
  {
    municipality: 'Potsdam',
    postalCode: '14482'
  },
  {
    municipality: 'Pottenstein',
    postalCode: '91278'
  },
  {
    municipality: 'Pöttmes',
    postalCode: '86554'
  },
  {
    municipality: 'Pottum',
    postalCode: '56459'
  },
  {
    municipality: 'Poxdorf',
    postalCode: '91099'
  },
  {
    municipality: 'Poxdorf',
    postalCode: '07616'
  },
  {
    municipality: 'Poyenberg',
    postalCode: '25581'
  },
  {
    municipality: 'Pracht',
    postalCode: '57589'
  },
  {
    municipality: 'Prackenbach',
    postalCode: '94267'
  },
  {
    municipality: 'Pragsdorf',
    postalCode: '17094'
  },
  {
    municipality: 'Prasdorf',
    postalCode: '24253'
  },
  {
    municipality: 'Prath',
    postalCode: '56346'
  },
  {
    municipality: 'Prebberede',
    postalCode: '17168'
  },
  {
    municipality: 'Prebitz',
    postalCode: '95473'
  },
  {
    municipality: 'Preetz',
    postalCode: '24211'
  },
  {
    municipality: 'Preetz',
    postalCode: '18445'
  },
  {
    municipality: 'Preischeid',
    postalCode: '54673'
  },
  {
    municipality: 'Preischeid',
    postalCode: '54689'
  },
  {
    municipality: 'Preist',
    postalCode: '54664'
  },
  {
    municipality: 'Prem',
    postalCode: '86984'
  },
  {
    municipality: 'Premnitz',
    postalCode: '14727'
  },
  {
    municipality: 'Prenzlau',
    postalCode: '17291'
  },
  {
    municipality: 'Prerow',
    postalCode: '18375'
  },
  {
    municipality: 'Pressath',
    postalCode: '92690'
  },
  {
    municipality: 'Presseck',
    postalCode: '95355'
  },
  {
    municipality: 'Pressig',
    postalCode: '96332'
  },
  {
    municipality: 'Pretzfeld',
    postalCode: '91362'
  },
  {
    municipality: 'Preußisch Oldendorf',
    postalCode: '32361'
  },
  {
    municipality: 'Prezelle',
    postalCode: '29491'
  },
  {
    municipality: 'Priborn',
    postalCode: '17209'
  },
  {
    municipality: 'Prichsenstadt',
    postalCode: '97357'
  },
  {
    municipality: 'Prien am Chiemsee',
    postalCode: '83209'
  },
  {
    municipality: 'Priepert',
    postalCode: '17255'
  },
  {
    municipality: 'Priesendorf',
    postalCode: '96170'
  },
  {
    municipality: 'Priestewitz',
    postalCode: '01561'
  },
  {
    municipality: 'Prinzenmoor',
    postalCode: '24805'
  },
  {
    municipality: 'Prinzhöfte',
    postalCode: '27243'
  },
  {
    municipality: 'Pripsleben',
    postalCode: '17091'
  },
  {
    municipality: 'Prisdorf',
    postalCode: '25497'
  },
  {
    municipality: 'Prislich',
    postalCode: '19300'
  },
  {
    municipality: 'Prittriching',
    postalCode: '86931'
  },
  {
    municipality: 'Pritzier',
    postalCode: '19230'
  },
  {
    municipality: 'Pritzwalk',
    postalCode: '16928'
  },
  {
    municipality: 'Probsteierhagen',
    postalCode: '24253'
  },
  {
    municipality: 'Probstzella',
    postalCode: '07330'
  },
  {
    municipality: 'Prohn',
    postalCode: '18445'
  },
  {
    municipality: 'Pronsfeld',
    postalCode: '54597'
  },
  {
    municipality: 'Pronstorf',
    postalCode: '23820'
  },
  {
    municipality: 'Prosselsheim',
    postalCode: '97279'
  },
  {
    municipality: 'Prötzel',
    postalCode: '15345'
  },
  {
    municipality: 'Pruchten',
    postalCode: '18356'
  },
  {
    municipality: 'Prüm',
    postalCode: '54595'
  },
  {
    municipality: 'Prümzurlay',
    postalCode: '54668'
  },
  {
    municipality: 'Prutting',
    postalCode: '83134'
  },
  {
    municipality: 'Püchersreuth',
    postalCode: '92715'
  },
  {
    municipality: 'Puchheim',
    postalCode: '82178'
  },
  {
    municipality: 'Pudagla',
    postalCode: '17429'
  },
  {
    municipality: 'Puderbach',
    postalCode: '56305'
  },
  {
    municipality: 'Pulheim',
    postalCode: '50259'
  },
  {
    municipality: 'Pullach im Isartal',
    postalCode: '82049'
  },
  {
    municipality: 'Pullenreuth',
    postalCode: '95704'
  },
  {
    municipality: 'Puls',
    postalCode: '25560'
  },
  {
    municipality: 'Pulsnitz',
    postalCode: '01896'
  },
  {
    municipality: 'Pünderich',
    postalCode: '56862'
  },
  {
    municipality: 'Pürgen',
    postalCode: '86932'
  },
  {
    municipality: 'Puschendorf',
    postalCode: '90617'
  },
  {
    municipality: 'Puschwitz - Bóšicy',
    postalCode: '02699'
  },
  {
    municipality: 'Putbus',
    postalCode: '18581'
  },
  {
    municipality: 'Putgarten',
    postalCode: '18556'
  },
  {
    municipality: 'Putlitz',
    postalCode: '16949'
  },
  {
    municipality: 'Püttlingen',
    postalCode: '66346'
  },
  {
    municipality: 'Putzbrunn',
    postalCode: '85640'
  },
  {
    municipality: 'Pyrbaum',
    postalCode: '90602'
  },
  {
    municipality: 'Quakenbrück',
    postalCode: '49610'
  },
  {
    municipality: 'Quarnbek',
    postalCode: '24107'
  },
  {
    municipality: 'Quarnstedt',
    postalCode: '25563'
  },
  {
    municipality: 'Quaschwitz',
    postalCode: '07389'
  },
  {
    municipality: 'Quedlinburg',
    postalCode: '06484'
  },
  {
    municipality: 'Quedlinburg',
    postalCode: '06485'
  },
  {
    municipality: 'Queidersbach',
    postalCode: '66851'
  },
  {
    municipality: 'Quendorf',
    postalCode: '48465'
  },
  {
    municipality: 'Querenhorst',
    postalCode: '38368'
  },
  {
    municipality: 'Querfurt',
    postalCode: '06268'
  },
  {
    municipality: 'Quernheim',
    postalCode: '49448'
  },
  {
    municipality: 'Quickborn',
    postalCode: '25451'
  },
  {
    municipality: 'Quickborn',
    postalCode: '25712'
  },
  {
    municipality: 'Quiddelbach',
    postalCode: '53518'
  },
  {
    municipality: 'Quierschied',
    postalCode: '66287'
  },
  {
    municipality: 'Quirnbach',
    postalCode: '56242'
  },
  {
    municipality: 'Quirnbach/Pfalz',
    postalCode: '66909'
  },
  {
    municipality: 'Quirnheim',
    postalCode: '67280'
  },
  {
    municipality: 'Quitzdorf am See - Kwětanecy',
    postalCode: '02906'
  },
  {
    municipality: 'Raa-Besenbek',
    postalCode: '25335'
  },
  {
    municipality: 'Rabel',
    postalCode: '24376'
  },
  {
    municipality: 'Rabenau',
    postalCode: '35466'
  },
  {
    municipality: 'Rabenau',
    postalCode: '01734'
  },
  {
    municipality: 'Rabenholz',
    postalCode: '24395'
  },
  {
    municipality: 'Rabenkirchen-Faulück',
    postalCode: '24407'
  },
  {
    municipality: 'Raben Steinfeld',
    postalCode: '19065'
  },
  {
    municipality: 'Rabenstein/Fläming',
    postalCode: '14823'
  },
  {
    municipality: 'Räbke',
    postalCode: '38375'
  },
  {
    municipality: 'Räckelwitz - Worklecy',
    postalCode: '01920'
  },
  {
    municipality: 'Racksen',
    postalCode: '57612'
  },
  {
    municipality: 'Rackwitz',
    postalCode: '04519'
  },
  {
    municipality: 'Radbruch',
    postalCode: '21449'
  },
  {
    municipality: 'Raddestorf',
    postalCode: '31604'
  },
  {
    municipality: 'Rade',
    postalCode: '25579'
  },
  {
    municipality: 'Rade',
    postalCode: '24790'
  },
  {
    municipality: 'Rade',
    postalCode: '24794'
  },
  {
    municipality: 'Radeberg',
    postalCode: '01454'
  },
  {
    municipality: 'Radebeul',
    postalCode: '01445'
  },
  {
    municipality: 'Rade b. Hohenwestedt',
    postalCode: '24594'
  },
  {
    municipality: 'Radeburg',
    postalCode: '01471'
  },
  {
    municipality: 'Radevormwald',
    postalCode: '42477'
  },
  {
    municipality: 'Radibor - Radwor',
    postalCode: '02627'
  },
  {
    municipality: 'Radolfzell am Bodensee',
    postalCode: '78315'
  },
  {
    municipality: 'Raesfeld',
    postalCode: '46348'
  },
  {
    municipality: 'Ragow-Merz',
    postalCode: '15848'
  },
  {
    municipality: 'Raguhn-Jeßnitz',
    postalCode: '06779'
  },
  {
    municipality: 'Raguhn-Jeßnitz',
    postalCode: '06800'
  },
  {
    municipality: 'Rahden',
    postalCode: '32369'
  },
  {
    municipality: 'Rain',
    postalCode: '94369'
  },
  {
    municipality: 'Rain',
    postalCode: '86641'
  },
  {
    municipality: 'Rainau',
    postalCode: '73492'
  },
  {
    municipality: 'Raisting',
    postalCode: '82399'
  },
  {
    municipality: 'Raitenbuch',
    postalCode: '91790'
  },
  {
    municipality: 'Ralbitz-Rosenthal - Ralbicy-Róžant',
    postalCode: '01920'
  },
  {
    municipality: 'Ralingen',
    postalCode: '54310'
  },
  {
    municipality: 'Ralswiek',
    postalCode: '18528'
  },
  {
    municipality: 'Ramberg',
    postalCode: '76829'
  },
  {
    municipality: 'Ramberg',
    postalCode: '76857'
  },
  {
    municipality: 'Rambin',
    postalCode: '18573'
  },
  {
    municipality: 'Ramerberg',
    postalCode: '83561'
  },
  {
    municipality: 'Ramhusen',
    postalCode: '25715'
  },
  {
    municipality: 'Ramin',
    postalCode: '17321'
  },
  {
    municipality: 'Rammelsbach',
    postalCode: '66887'
  },
  {
    municipality: 'Rammenau',
    postalCode: '01877'
  },
  {
    municipality: 'Rammingen',
    postalCode: '89192'
  },
  {
    municipality: 'Rammingen',
    postalCode: '86871'
  },
  {
    municipality: 'Ramsau bei Berchtesgaden',
    postalCode: '83486'
  },
  {
    municipality: 'Ramsen',
    postalCode: '67305'
  },
  {
    municipality: 'Ramstedt',
    postalCode: '25876'
  },
  {
    municipality: 'Ramstein-Miesenbach',
    postalCode: '66877'
  },
  {
    municipality: 'Ramsthal',
    postalCode: '97729'
  },
  {
    municipality: 'Randersacker',
    postalCode: '97236'
  },
  {
    municipality: 'Randowtal',
    postalCode: '17291'
  },
  {
    municipality: 'Rangendingen',
    postalCode: '72414'
  },
  {
    municipality: 'Rangsdorf',
    postalCode: '15834'
  },
  {
    municipality: 'Ranis',
    postalCode: '07389'
  },
  {
    municipality: 'Rankwitz',
    postalCode: '17406'
  },
  {
    municipality: 'Rannstedt',
    postalCode: '99518'
  },
  {
    municipality: 'Rannungen',
    postalCode: '97517'
  },
  {
    municipality: 'Ransbach-Baumbach',
    postalCode: '56235'
  },
  {
    municipality: 'Ranschbach',
    postalCode: '76829'
  },
  {
    municipality: 'Ranstadt',
    postalCode: '63691'
  },
  {
    municipality: 'Ransweiler',
    postalCode: '67808'
  },
  {
    municipality: 'Rantrum',
    postalCode: '25873'
  },
  {
    municipality: 'Rantzau',
    postalCode: '24321'
  },
  {
    municipality: 'Rantzau',
    postalCode: '24329'
  },
  {
    municipality: 'Rappin',
    postalCode: '18528'
  },
  {
    municipality: 'Raschau-Markersbach',
    postalCode: '08352'
  },
  {
    municipality: 'Rascheid',
    postalCode: '54413'
  },
  {
    municipality: 'Rasdorf',
    postalCode: '36169'
  },
  {
    municipality: 'Rastatt',
    postalCode: '76437'
  },
  {
    municipality: 'Rastdorf',
    postalCode: '26901'
  },
  {
    municipality: 'Rastede',
    postalCode: '26180'
  },
  {
    municipality: 'Rastenberg',
    postalCode: '99636'
  },
  {
    municipality: 'Rastorf',
    postalCode: '24211'
  },
  {
    municipality: 'Rastow',
    postalCode: '19077'
  },
  {
    municipality: 'Ratekau',
    postalCode: '23611'
  },
  {
    municipality: 'Ratekau',
    postalCode: '23626'
  },
  {
    municipality: 'Ratekau',
    postalCode: '23669'
  },
  {
    municipality: 'Ratekau',
    postalCode: '23689'
  },
  {
    municipality: 'Rathen',
    postalCode: '01824'
  },
  {
    municipality: 'Rathenow',
    postalCode: '14712'
  },
  {
    municipality: 'Rathjensdorf',
    postalCode: '24306'
  },
  {
    municipality: 'Rathmannsdorf',
    postalCode: '01814'
  },
  {
    municipality: 'Rathskirchen',
    postalCode: '67744'
  },
  {
    municipality: 'Rathsweiler',
    postalCode: '66887'
  },
  {
    municipality: 'Ratingen',
    postalCode: '40472'
  },
  {
    municipality: 'Ratingen',
    postalCode: '40878'
  },
  {
    municipality: 'Ratingen',
    postalCode: '40880'
  },
  {
    municipality: 'Ratingen',
    postalCode: '40882'
  },
  {
    municipality: 'Ratingen',
    postalCode: '40883'
  },
  {
    municipality: 'Ratingen',
    postalCode: '40885'
  },
  {
    municipality: 'Ratshausen',
    postalCode: '72365'
  },
  {
    municipality: 'Rattelsdorf',
    postalCode: '96179'
  },
  {
    municipality: 'Rattelsdorf',
    postalCode: '07646'
  },
  {
    municipality: 'Rattenberg',
    postalCode: '94371'
  },
  {
    municipality: 'Rattenkirchen',
    postalCode: '84431'
  },
  {
    municipality: 'Rattiszell',
    postalCode: '94372'
  },
  {
    municipality: 'Ratzeburg',
    postalCode: '23909'
  },
  {
    municipality: 'Ratzert',
    postalCode: '57614'
  },
  {
    municipality: 'Rätzlingen',
    postalCode: '29590'
  },
  {
    municipality: 'Raubach',
    postalCode: '56316'
  },
  {
    municipality: 'Raubling',
    postalCode: '83064'
  },
  {
    municipality: 'Rauda',
    postalCode: '07613'
  },
  {
    municipality: 'Rauen',
    postalCode: '15518'
  },
  {
    municipality: 'Rauenberg',
    postalCode: '69231'
  },
  {
    municipality: 'Rauhenebrach',
    postalCode: '96181'
  },
  {
    municipality: 'Raumbach',
    postalCode: '55592'
  },
  {
    municipality: 'Raunheim',
    postalCode: '65479'
  },
  {
    municipality: 'Rauschenberg',
    postalCode: '35282'
  },
  {
    municipality: 'Rauschwitz',
    postalCode: '07616'
  },
  {
    municipality: 'Rausdorf',
    postalCode: '22929'
  },
  {
    municipality: 'Rausdorf',
    postalCode: '07646'
  },
  {
    municipality: 'Ravengiersburg',
    postalCode: '55471'
  },
  {
    municipality: 'Ravensburg',
    postalCode: '88212'
  },
  {
    municipality: 'Ravensburg',
    postalCode: '88213'
  },
  {
    municipality: 'Ravensburg',
    postalCode: '88214'
  },
  {
    municipality: 'Ravenstein',
    postalCode: '74747'
  },
  {
    municipality: 'Raversbeuren',
    postalCode: '56850'
  },
  {
    municipality: 'Rayerschied',
    postalCode: '55469'
  },
  {
    municipality: 'Rech',
    postalCode: '53506'
  },
  {
    municipality: 'Rechberghausen',
    postalCode: '73098'
  },
  {
    municipality: 'Rechenberg-Bienenmühle',
    postalCode: '09623'
  },
  {
    municipality: 'Rechlin',
    postalCode: '17248'
  },
  {
    municipality: 'Rechtenbach',
    postalCode: '97848'
  },
  {
    municipality: 'Rechtenstein',
    postalCode: '89611'
  },
  {
    municipality: 'Rechtmehring',
    postalCode: '83562'
  },
  {
    municipality: 'Rechtsupweg',
    postalCode: '26529'
  },
  {
    municipality: 'Recke',
    postalCode: '49509'
  },
  {
    municipality: 'Reckendorf',
    postalCode: '96182'
  },
  {
    municipality: 'Reckenroth',
    postalCode: '56370'
  },
  {
    municipality: 'Reckershausen',
    postalCode: '55481'
  },
  {
    municipality: 'Recklinghausen',
    postalCode: '45657'
  },
  {
    municipality: 'Recklinghausen',
    postalCode: '45659'
  },
  {
    municipality: 'Recklinghausen',
    postalCode: '45661'
  },
  {
    municipality: 'Recklinghausen',
    postalCode: '45663'
  },
  {
    municipality: 'Recklinghausen',
    postalCode: '45665'
  },
  {
    municipality: 'Reddelich',
    postalCode: '18209'
  },
  {
    municipality: 'Redefin',
    postalCode: '19230'
  },
  {
    municipality: 'Rednitzhembach',
    postalCode: '91126'
  },
  {
    municipality: 'Redwitz a.d.Rodach',
    postalCode: '96257'
  },
  {
    municipality: 'Rees',
    postalCode: '46459'
  },
  {
    municipality: 'Reesdorf',
    postalCode: '24241'
  },
  {
    municipality: 'Reeßum',
    postalCode: '27367'
  },
  {
    municipality: 'Regen',
    postalCode: '94209'
  },
  {
    municipality: 'Regensburg',
    postalCode: '93047'
  },
  {
    municipality: 'Regensburg',
    postalCode: '93049'
  },
  {
    municipality: 'Regensburg',
    postalCode: '93051'
  },
  {
    municipality: 'Regensburg',
    postalCode: '93053'
  },
  {
    municipality: 'Regensburg',
    postalCode: '93055'
  },
  {
    municipality: 'Regensburg',
    postalCode: '93057'
  },
  {
    municipality: 'Regensburg',
    postalCode: '93059'
  },
  {
    municipality: 'Regenstauf',
    postalCode: '93128'
  },
  {
    municipality: 'Regesbostel',
    postalCode: '21649'
  },
  {
    municipality: 'Regis-Breitingen',
    postalCode: '04565'
  },
  {
    municipality: 'Regnitzlosau',
    postalCode: '95194'
  },
  {
    municipality: 'Rehau',
    postalCode: '95111'
  },
  {
    municipality: 'Rehbach',
    postalCode: '55566'
  },
  {
    municipality: 'Rehborn',
    postalCode: '55592'
  },
  {
    municipality: 'Rehburg-Loccum',
    postalCode: '31547'
  },
  {
    municipality: 'Rehden',
    postalCode: '49453'
  },
  {
    municipality: 'Rehe',
    postalCode: '56479'
  },
  {
    municipality: 'Reher',
    postalCode: '25593'
  },
  {
    municipality: 'Rehfelde',
    postalCode: '15345'
  },
  {
    municipality: 'Rehhorst',
    postalCode: '23619'
  },
  {
    municipality: 'Rehling',
    postalCode: '86508'
  },
  {
    municipality: 'Rehlingen',
    postalCode: '21385'
  },
  {
    municipality: 'Rehlingen-Siersburg',
    postalCode: '66780'
  },
  {
    municipality: 'Rehm-Flehde-Bargen',
    postalCode: '25776'
  },
  {
    municipality: 'Rehna',
    postalCode: '19217'
  },
  {
    municipality: 'Rehweiler',
    postalCode: '66907'
  },
  {
    municipality: 'Reich',
    postalCode: '55471'
  },
  {
    municipality: 'Reichartshausen',
    postalCode: '74934'
  },
  {
    municipality: 'Reichelsheim',
    postalCode: '61203'
  },
  {
    municipality: 'Reichelsheim (Odenwald)',
    postalCode: '64385'
  },
  {
    municipality: 'Reichenau',
    postalCode: '78479'
  },
  {
    municipality: 'Reichenbach',
    postalCode: '93189'
  },
  {
    municipality: 'Reichenbach',
    postalCode: '96358'
  },
  {
    municipality: 'Reichenbach',
    postalCode: '55776'
  },
  {
    municipality: 'Reichenbach',
    postalCode: '07629'
  },
  {
    municipality: 'Reichenbach',
    postalCode: '08468'
  },
  {
    municipality: 'Reichenbach',
    postalCode: '08499'
  },
  {
    municipality: 'Reichenbach am Heuberg',
    postalCode: '78564'
  },
  {
    municipality: 'Reichenbach an der Fils',
    postalCode: '73262'
  },
  {
    municipality: 'Reichenbach/Oberlausitz',
    postalCode: '02894'
  },
  {
    municipality: 'Reichenbach-Steegen',
    postalCode: '66879'
  },
  {
    municipality: 'Reichenberg',
    postalCode: '97234'
  },
  {
    municipality: 'Reichenberg',
    postalCode: '56357'
  },
  {
    municipality: 'Reichenow-Möglin',
    postalCode: '15345'
  },
  {
    municipality: 'Reichenschwand',
    postalCode: '91244'
  },
  {
    municipality: 'Reichenwalde',
    postalCode: '15526'
  },
  {
    municipality: 'Reichersbeuern',
    postalCode: '83677'
  },
  {
    municipality: 'Reichertshausen',
    postalCode: '85293'
  },
  {
    municipality: 'Reichertsheim',
    postalCode: '84437'
  },
  {
    municipality: 'Reichertshofen',
    postalCode: '85084'
  },
  {
    municipality: 'Reichling',
    postalCode: '86934'
  },
  {
    municipality: 'Reichshof',
    postalCode: '51580'
  },
  {
    municipality: 'Reichstädt',
    postalCode: '07580'
  },
  {
    municipality: 'Reichsthal',
    postalCode: '67759'
  },
  {
    municipality: 'Reichweiler',
    postalCode: '66871'
  },
  {
    municipality: 'Reidenhausen',
    postalCode: '56865'
  },
  {
    municipality: 'Reifenberg',
    postalCode: '66507'
  },
  {
    municipality: 'Reiferscheid',
    postalCode: '57632'
  },
  {
    municipality: 'Reiff',
    postalCode: '54619'
  },
  {
    municipality: 'Reiffelbach',
    postalCode: '67829'
  },
  {
    municipality: 'Reifferscheid',
    postalCode: '53520'
  },
  {
    municipality: 'Reil',
    postalCode: '56861'
  },
  {
    municipality: 'Reilingen',
    postalCode: '68799'
  },
  {
    municipality: 'Reimerath',
    postalCode: '53539'
  },
  {
    municipality: 'Reimershagen',
    postalCode: '18276'
  },
  {
    municipality: 'Reimlingen',
    postalCode: '86756'
  },
  {
    municipality: 'Reinbek',
    postalCode: '21465'
  },
  {
    municipality: 'Reinbek',
    postalCode: '21521'
  },
  {
    municipality: 'Reinfeld',
    postalCode: '23858'
  },
  {
    municipality: 'Reinhardshagen',
    postalCode: '34359'
  },
  {
    municipality: 'Reinhardtsdorf-Schöna',
    postalCode: '01814'
  },
  {
    municipality: 'Reinheim',
    postalCode: '64354'
  },
  {
    municipality: 'Reinholterode',
    postalCode: '37308'
  },
  {
    municipality: 'Reinsberg',
    postalCode: '09629'
  },
  {
    municipality: 'Reinsberg',
    postalCode: '09634'
  },
  {
    municipality: 'Reinsbüttel',
    postalCode: '25764'
  },
  {
    municipality: 'Reinsdorf',
    postalCode: '08141'
  },
  {
    municipality: 'Reinsdorf',
    postalCode: '06556'
  },
  {
    municipality: 'Reinsfeld',
    postalCode: '54421'
  },
  {
    municipality: 'Reinstädt',
    postalCode: '07768'
  },
  {
    municipality: 'Reinstorf',
    postalCode: '21400'
  },
  {
    municipality: 'Reipeldingen',
    postalCode: '54689'
  },
  {
    municipality: 'Reipoltskirchen',
    postalCode: '67753'
  },
  {
    municipality: 'Reisbach',
    postalCode: '94419'
  },
  {
    municipality: 'Reischach',
    postalCode: '84571'
  },
  {
    municipality: 'Reiskirchen',
    postalCode: '35447'
  },
  {
    municipality: 'Reit im Winkl',
    postalCode: '83242'
  },
  {
    municipality: 'Reitwein',
    postalCode: '15328'
  },
  {
    municipality: 'Reitzenhain',
    postalCode: '56357'
  },
  {
    municipality: 'Reken',
    postalCode: '48734'
  },
  {
    municipality: 'Rellingen',
    postalCode: '25462'
  },
  {
    municipality: 'Relsberg',
    postalCode: '67753'
  },
  {
    municipality: 'Remagen',
    postalCode: '53424'
  },
  {
    municipality: 'Remchingen',
    postalCode: '75196'
  },
  {
    municipality: 'Remlingen',
    postalCode: '97280'
  },
  {
    municipality: 'Remlingen-Semmenstedt',
    postalCode: '38319'
  },
  {
    municipality: 'Remlingen-Semmenstedt',
    postalCode: '38327'
  },
  {
    municipality: 'Remmels',
    postalCode: '24594'
  },
  {
    municipality: 'Remptendorf',
    postalCode: '07368'
  },
  {
    municipality: 'Remscheid',
    postalCode: '42853'
  },
  {
    municipality: 'Remscheid',
    postalCode: '42855'
  },
  {
    municipality: 'Remscheid',
    postalCode: '42857'
  },
  {
    municipality: 'Remscheid',
    postalCode: '42859'
  },
  {
    municipality: 'Remscheid',
    postalCode: '42897'
  },
  {
    municipality: 'Remscheid',
    postalCode: '42899'
  },
  {
    municipality: 'Remse',
    postalCode: '08373'
  },
  {
    municipality: 'Remseck am Neckar',
    postalCode: '71686'
  },
  {
    municipality: 'Remshalden',
    postalCode: '73630'
  },
  {
    municipality: 'Renchen',
    postalCode: '77871'
  },
  {
    municipality: 'Rendsburg',
    postalCode: '24768'
  },
  {
    municipality: 'Rendswühren',
    postalCode: '24619'
  },
  {
    municipality: 'Rengsdorf',
    postalCode: '56579'
  },
  {
    municipality: 'Renkenberge',
    postalCode: '49762'
  },
  {
    municipality: 'Rennau',
    postalCode: '38368'
  },
  {
    municipality: 'Rennerod',
    postalCode: '56477'
  },
  {
    municipality: 'Rennertshofen',
    postalCode: '86643'
  },
  {
    municipality: 'Renningen',
    postalCode: '71272'
  },
  {
    municipality: 'Renquishausen',
    postalCode: '78603'
  },
  {
    municipality: 'Renthendorf',
    postalCode: '07646'
  },
  {
    municipality: 'Rentweinsdorf',
    postalCode: '96184'
  },
  {
    municipality: 'Reppenstedt',
    postalCode: '21391'
  },
  {
    municipality: 'Rerik',
    postalCode: '18230'
  },
  {
    municipality: 'Rethem (Aller)',
    postalCode: '27336'
  },
  {
    municipality: 'Rethwisch',
    postalCode: '25566'
  },
  {
    municipality: 'Rethwisch',
    postalCode: '23847'
  },
  {
    municipality: 'Retschow',
    postalCode: '18211'
  },
  {
    municipality: 'Rettenbach',
    postalCode: '93191'
  },
  {
    municipality: 'Rettenbach',
    postalCode: '89364'
  },
  {
    municipality: 'Rettenbach a.Auerberg',
    postalCode: '87675'
  },
  {
    municipality: 'Rettenberg',
    postalCode: '87549'
  },
  {
    municipality: 'Retterath',
    postalCode: '56769'
  },
  {
    municipality: 'Rettersen',
    postalCode: '57635'
  },
  {
    municipality: 'Rettershain',
    postalCode: '56357'
  },
  {
    municipality: 'Rettert',
    postalCode: '56370'
  },
  {
    municipality: 'Retzow',
    postalCode: '14641'
  },
  {
    municipality: 'Retzstadt',
    postalCode: '97282'
  },
  {
    municipality: 'Reudelsterz',
    postalCode: '56727'
  },
  {
    municipality: 'Reurieth',
    postalCode: '98646'
  },
  {
    municipality: 'Reußenköge',
    postalCode: '25821'
  },
  {
    municipality: 'Reut',
    postalCode: '84367'
  },
  {
    municipality: 'Reute',
    postalCode: '79276'
  },
  {
    municipality: 'Reuth',
    postalCode: '54597'
  },
  {
    municipality: 'Reuth b.Erbendorf',
    postalCode: '92717'
  },
  {
    municipality: 'Reutlingen',
    postalCode: '72760'
  },
  {
    municipality: 'Reutlingen',
    postalCode: '72762'
  },
  {
    municipality: 'Reutlingen',
    postalCode: '72764'
  },
  {
    municipality: 'Reutlingen',
    postalCode: '72766'
  },
  {
    municipality: 'Reutlingen',
    postalCode: '72768'
  },
  {
    municipality: 'Reutlingen',
    postalCode: '72770'
  },
  {
    municipality: 'Rhade',
    postalCode: '27404'
  },
  {
    municipality: 'Rhauderfehn',
    postalCode: '26817'
  },
  {
    municipality: 'Rhaunen',
    postalCode: '55624'
  },
  {
    municipality: 'Rheda-Wiedenbrück',
    postalCode: '33378'
  },
  {
    municipality: 'Rhede',
    postalCode: '46414'
  },
  {
    municipality: 'Rhede (Ems)',
    postalCode: '26899'
  },
  {
    municipality: 'Rheinau',
    postalCode: '77866'
  },
  {
    municipality: 'Rheinbach',
    postalCode: '53359'
  },
  {
    municipality: 'Rheinberg',
    postalCode: '47495'
  },
  {
    municipality: 'Rheinböllen',
    postalCode: '55494'
  },
  {
    municipality: 'Rheinbreitbach',
    postalCode: '53619'
  },
  {
    municipality: 'Rheinbrohl',
    postalCode: '56598'
  },
  {
    municipality: 'Rheine',
    postalCode: '48429'
  },
  {
    municipality: 'Rheine',
    postalCode: '48431'
  },
  {
    municipality: 'Rheine',
    postalCode: '48432'
  },
  {
    municipality: 'Rheinfelden (Baden)',
    postalCode: '79618'
  },
  {
    municipality: 'Rheinhausen',
    postalCode: '79365'
  },
  {
    municipality: 'Rheinmünster',
    postalCode: '77836'
  },
  {
    municipality: 'Rheinsberg',
    postalCode: '16818'
  },
  {
    municipality: 'Rheinsberg',
    postalCode: '16831'
  },
  {
    municipality: 'Rheinsberg',
    postalCode: '16835'
  },
  {
    municipality: 'Rheinsberg',
    postalCode: '16837'
  },
  {
    municipality: 'Rheinstetten',
    postalCode: '76287'
  },
  {
    municipality: 'Rheinzabern',
    postalCode: '76764'
  },
  {
    municipality: 'Rhens',
    postalCode: '56321'
  },
  {
    municipality: 'Rhens',
    postalCode: '56323'
  },
  {
    municipality: 'Rheurdt',
    postalCode: '47509'
  },
  {
    municipality: 'Rhinow',
    postalCode: '14728'
  },
  {
    municipality: 'Rhodt unter Rietburg',
    postalCode: '76835'
  },
  {
    municipality: 'Rhönblick',
    postalCode: '98617'
  },
  {
    municipality: 'Rhumspringe',
    postalCode: '37434'
  },
  {
    municipality: 'Ribbesbüttel',
    postalCode: '38551'
  },
  {
    municipality: 'Ribnitz-Damgarten',
    postalCode: '18311'
  },
  {
    municipality: 'Richtenberg',
    postalCode: '18461'
  },
  {
    municipality: 'Rickenbach',
    postalCode: '79736'
  },
  {
    municipality: 'Rickert',
    postalCode: '24782'
  },
  {
    municipality: 'Rickert',
    postalCode: '24787'
  },
  {
    municipality: 'Rickling',
    postalCode: '24635'
  },
  {
    municipality: 'Ried',
    postalCode: '86510'
  },
  {
    municipality: 'Riedbach',
    postalCode: '97519'
  },
  {
    municipality: 'Riede',
    postalCode: '27339'
  },
  {
    municipality: 'Riedelberg',
    postalCode: '66484'
  },
  {
    municipality: 'Rieden',
    postalCode: '87668'
  },
  {
    municipality: 'Rieden',
    postalCode: '56745'
  },
  {
    municipality: 'Rieden',
    postalCode: '92286'
  },
  {
    municipality: 'Rieden am Forggensee',
    postalCode: '87669'
  },
  {
    municipality: 'Riedenberg',
    postalCode: '97792'
  },
  {
    municipality: 'Riedenburg',
    postalCode: '93339'
  },
  {
    municipality: 'Riedenheim',
    postalCode: '97283'
  },
  {
    municipality: 'Riederich',
    postalCode: '72585'
  },
  {
    municipality: 'Riedering',
    postalCode: '83083'
  },
  {
    municipality: 'Riedhausen',
    postalCode: '88377'
  },
  {
    municipality: 'Riedlingen',
    postalCode: '88499'
  },
  {
    municipality: 'Riedstadt',
    postalCode: '64560'
  },
  {
    municipality: 'Riegel',
    postalCode: '79359'
  },
  {
    municipality: 'Riegelsberg',
    postalCode: '66292'
  },
  {
    municipality: 'Riegenroth',
    postalCode: '55469'
  },
  {
    municipality: 'Riegsee',
    postalCode: '82418'
  },
  {
    municipality: 'Riekofen',
    postalCode: '93104'
  },
  {
    municipality: 'Rielasingen-Worblingen',
    postalCode: '78239'
  },
  {
    municipality: 'Rieneck',
    postalCode: '97794'
  },
  {
    municipality: 'Rieps',
    postalCode: '19217'
  },
  {
    municipality: 'Riepsdorf',
    postalCode: '23738'
  },
  {
    municipality: 'Riesa',
    postalCode: '01587'
  },
  {
    municipality: 'Riesa',
    postalCode: '01589'
  },
  {
    municipality: 'Riesa',
    postalCode: '01591'
  },
  {
    municipality: 'Riesa',
    postalCode: '01594'
  },
  {
    municipality: 'Riesbürg',
    postalCode: '73469'
  },
  {
    municipality: 'Rieschweiler-Mühlbach',
    postalCode: '66509'
  },
  {
    municipality: 'Rieseby',
    postalCode: '24354'
  },
  {
    municipality: 'Rieste',
    postalCode: '49597'
  },
  {
    municipality: 'Riesweiler',
    postalCode: '55499'
  },
  {
    municipality: 'Rietberg',
    postalCode: '33397'
  },
  {
    municipality: 'Rietheim-Weilheim',
    postalCode: '78604'
  },
  {
    municipality: 'Riethgen',
    postalCode: '99638'
  },
  {
    municipality: 'Riethnordhausen',
    postalCode: '99195'
  },
  {
    municipality: 'Rietschen - Rěčicy',
    postalCode: '02956'
  },
  {
    municipality: 'Rietz-Neuendorf',
    postalCode: '15848'
  },
  {
    municipality: 'Rietzneuendorf-Staakow',
    postalCode: '15910'
  },
  {
    municipality: 'Rimbach',
    postalCode: '64668'
  },
  {
    municipality: 'Rimbach',
    postalCode: '84326'
  },
  {
    municipality: 'Rimbach',
    postalCode: '93485'
  },
  {
    municipality: 'Rimpar',
    postalCode: '97222'
  },
  {
    municipality: 'Rimsberg',
    postalCode: '55765'
  },
  {
    municipality: 'Rimsting',
    postalCode: '83253'
  },
  {
    municipality: 'Rinchnach',
    postalCode: '94269'
  },
  {
    municipality: 'Ringe',
    postalCode: '49824'
  },
  {
    municipality: 'Ringelai',
    postalCode: '94160'
  },
  {
    municipality: 'Ringgau',
    postalCode: '37296'
  },
  {
    municipality: 'Ringleben',
    postalCode: '99189'
  },
  {
    municipality: 'Ringsberg',
    postalCode: '24977'
  },
  {
    municipality: 'Ringsheim',
    postalCode: '77975'
  },
  {
    municipality: 'Rinnthal',
    postalCode: '76857'
  },
  {
    municipality: 'Rinteln',
    postalCode: '31737'
  },
  {
    municipality: 'Rinzenberg',
    postalCode: '55767'
  },
  {
    municipality: 'Riol',
    postalCode: '54340'
  },
  {
    municipality: 'Rippershausen',
    postalCode: '98639'
  },
  {
    municipality: 'Risum-Lindholm',
    postalCode: '25920'
  },
  {
    municipality: 'Ritschenhausen',
    postalCode: '98617'
  },
  {
    municipality: 'Ritterhude',
    postalCode: '27721'
  },
  {
    municipality: 'Rittersdorf',
    postalCode: '54636'
  },
  {
    municipality: 'Rittersdorf',
    postalCode: '99448'
  },
  {
    municipality: 'Rittersheim',
    postalCode: '67294'
  },
  {
    municipality: 'Ritzerau',
    postalCode: '23896'
  },
  {
    municipality: 'Ritzerow',
    postalCode: '17153'
  },
  {
    municipality: 'Rivenich',
    postalCode: '54518'
  },
  {
    municipality: 'Riveris',
    postalCode: '54317'
  },
  {
    municipality: 'Röbel/Müritz',
    postalCode: '17207'
  },
  {
    municipality: 'Rochau',
    postalCode: '39579'
  },
  {
    municipality: 'Rochlitz',
    postalCode: '09306'
  },
  {
    municipality: 'Rockenberg',
    postalCode: '35519'
  },
  {
    municipality: 'Rockenhausen',
    postalCode: '67806'
  },
  {
    municipality: 'Rockeskyll',
    postalCode: '54570'
  },
  {
    municipality: 'Röckingen',
    postalCode: '91740'
  },
  {
    municipality: 'Rockstedt',
    postalCode: '99713'
  },
  {
    municipality: 'Röckwitz',
    postalCode: '17091'
  },
  {
    municipality: 'Rodalben',
    postalCode: '66976'
  },
  {
    municipality: 'Rodder',
    postalCode: '53520'
  },
  {
    municipality: 'Rodeberg',
    postalCode: '99976'
  },
  {
    municipality: 'Rödelhausen',
    postalCode: '56858'
  },
  {
    municipality: 'Rödelmaier',
    postalCode: '97618'
  },
  {
    municipality: 'Rödelsee',
    postalCode: '97348'
  },
  {
    municipality: 'Roden',
    postalCode: '97849'
  },
  {
    municipality: 'Rodenäs',
    postalCode: '25924'
  },
  {
    municipality: 'Rodenbach',
    postalCode: '67688'
  },
  {
    municipality: 'Rodenbach',
    postalCode: '63517'
  },
  {
    municipality: 'Rodenbach bei Puderbach',
    postalCode: '57639'
  },
  {
    municipality: 'Rodenbek',
    postalCode: '24247'
  },
  {
    municipality: 'Rodenberg',
    postalCode: '31552'
  },
  {
    municipality: 'Rödental',
    postalCode: '96472'
  },
  {
    municipality: 'Röderaue',
    postalCode: '01609'
  },
  {
    municipality: 'Röderland',
    postalCode: '04932'
  },
  {
    municipality: 'Rödermark',
    postalCode: '63322'
  },
  {
    municipality: 'Rödern',
    postalCode: '55481'
  },
  {
    municipality: 'Rodershausen',
    postalCode: '54673'
  },
  {
    municipality: 'Rödersheim-Gronau',
    postalCode: '67127'
  },
  {
    municipality: 'Rodewald',
    postalCode: '31637'
  },
  {
    municipality: 'Rodewisch',
    postalCode: '08228'
  },
  {
    municipality: 'Rodgau',
    postalCode: '63110'
  },
  {
    municipality: 'Roding',
    postalCode: '93426'
  },
  {
    municipality: 'Rödinghausen',
    postalCode: '32289'
  },
  {
    municipality: 'Roduchelstorf',
    postalCode: '23923'
  },
  {
    municipality: 'Roes',
    postalCode: '56754'
  },
  {
    municipality: 'Roetgen',
    postalCode: '52159'
  },
  {
    municipality: 'Röfingen',
    postalCode: '89365'
  },
  {
    municipality: 'Rogätz',
    postalCode: '39326'
  },
  {
    municipality: 'Roggenburg',
    postalCode: '89297'
  },
  {
    municipality: 'Roggendorf',
    postalCode: '19205'
  },
  {
    municipality: 'Roggenstorf',
    postalCode: '23936'
  },
  {
    municipality: 'Roggentin',
    postalCode: '18184'
  },
  {
    municipality: 'Rögling',
    postalCode: '86703'
  },
  {
    municipality: 'Rögnitz',
    postalCode: '19205'
  },
  {
    municipality: 'Röhl',
    postalCode: '54636'
  },
  {
    municipality: 'Rohlstorf',
    postalCode: '23821'
  },
  {
    municipality: 'Rohr',
    postalCode: '91189'
  },
  {
    municipality: 'Rohr',
    postalCode: '98530'
  },
  {
    municipality: 'Rohrbach',
    postalCode: '85296'
  },
  {
    municipality: 'Rohrbach',
    postalCode: '55776'
  },
  {
    municipality: 'Rohrbach',
    postalCode: '55490'
  },
  {
    municipality: 'Rohrbach',
    postalCode: '76865'
  },
  {
    municipality: 'Rohrbach',
    postalCode: '07429'
  },
  {
    municipality: 'Rohrberg',
    postalCode: '38489'
  },
  {
    municipality: 'Rohrberg',
    postalCode: '37318'
  },
  {
    municipality: 'Rohrdorf',
    postalCode: '72229'
  },
  {
    municipality: 'Rohrdorf',
    postalCode: '83101'
  },
  {
    municipality: 'Rohrenfels',
    postalCode: '86701'
  },
  {
    municipality: 'Röhrig',
    postalCode: '37318'
  },
  {
    municipality: 'Rohr i.NB',
    postalCode: '93352'
  },
  {
    municipality: 'Röhrmoos',
    postalCode: '85244'
  },
  {
    municipality: 'Röhrnbach',
    postalCode: '94133'
  },
  {
    municipality: 'Rohrsen',
    postalCode: '31627'
  },
  {
    municipality: 'Roigheim',
    postalCode: '74255'
  },
  {
    municipality: 'Roklum',
    postalCode: '38325'
  },
  {
    municipality: 'Röllbach',
    postalCode: '63934'
  },
  {
    municipality: 'Rollshausen',
    postalCode: '37434'
  },
  {
    municipality: 'Rollwitz',
    postalCode: '17309'
  },
  {
    municipality: 'Rom',
    postalCode: '19372'
  },
  {
    municipality: 'Römerberg',
    postalCode: '67354'
  },
  {
    municipality: 'Römerstein',
    postalCode: '72587'
  },
  {
    municipality: 'Römhild',
    postalCode: '98630'
  },
  {
    municipality: 'Rommersheim',
    postalCode: '54597'
  },
  {
    municipality: 'Rommerskirchen',
    postalCode: '41569'
  },
  {
    municipality: 'Römnitz',
    postalCode: '23909'
  },
  {
    municipality: 'Romrod',
    postalCode: '36329'
  },
  {
    municipality: 'Römstedt',
    postalCode: '29591'
  },
  {
    municipality: 'Rondeshagen',
    postalCode: '23919'
  },
  {
    municipality: 'Ronneburg',
    postalCode: '63549'
  },
  {
    municipality: 'Ronneburg',
    postalCode: '07580'
  },
  {
    municipality: 'Ronnenberg',
    postalCode: '30952'
  },
  {
    municipality: 'Ronsberg',
    postalCode: '87671'
  },
  {
    municipality: 'Ronshausen',
    postalCode: '36217'
  },
  {
    municipality: 'Rorodt',
    postalCode: '54411'
  },
  {
    municipality: 'Rosa',
    postalCode: '98590'
  },
  {
    municipality: 'Rosbach v. d. Höhe',
    postalCode: '61191'
  },
  {
    municipality: 'Roschbach',
    postalCode: '76835'
  },
  {
    municipality: 'Rosche',
    postalCode: '29571'
  },
  {
    municipality: 'Roscheid',
    postalCode: '54619'
  },
  {
    municipality: 'Rosdorf',
    postalCode: '25548'
  },
  {
    municipality: 'Rosdorf',
    postalCode: '37124'
  },
  {
    municipality: 'Roseburg',
    postalCode: '21514'
  },
  {
    municipality: 'Rosenau',
    postalCode: '14789'
  },
  {
    municipality: 'Rosenbach',
    postalCode: '02708'
  },
  {
    municipality: 'Rosenbach/Vogtland',
    postalCode: '08527'
  },
  {
    municipality: 'Rosenbach/Vogtland',
    postalCode: '08539'
  },
  {
    municipality: 'Rosenbach/Vogtland',
    postalCode: '08548'
  },
  {
    municipality: 'Rosenberg',
    postalCode: '74749'
  },
  {
    municipality: 'Rosenberg',
    postalCode: '73494'
  },
  {
    municipality: 'Rosendahl',
    postalCode: '48720'
  },
  {
    municipality: 'Rosendorf',
    postalCode: '07819'
  },
  {
    municipality: 'Rosenfeld',
    postalCode: '72348'
  },
  {
    municipality: 'Rosengarten',
    postalCode: '21224'
  },
  {
    municipality: 'Rosengarten',
    postalCode: '74538'
  },
  {
    municipality: 'Rosenheim',
    postalCode: '57520'
  },
  {
    municipality: 'Rosenheim',
    postalCode: '83022'
  },
  {
    municipality: 'Rosenheim',
    postalCode: '83024'
  },
  {
    municipality: 'Rosenheim',
    postalCode: '83026'
  },
  {
    municipality: 'Rosenkopf',
    postalCode: '66894'
  },
  {
    municipality: 'Rosenow',
    postalCode: '17091'
  },
  {
    municipality: 'Rosenthal',
    postalCode: '35119'
  },
  {
    municipality: 'Rosenthal am Rennsteig',
    postalCode: '07366'
  },
  {
    municipality: 'Rosenthal-Bielatal',
    postalCode: '01824'
  },
  {
    municipality: 'Rositz',
    postalCode: '04617'
  },
  {
    municipality: 'Roskow',
    postalCode: '14778'
  },
  {
    municipality: 'Röslau',
    postalCode: '95195'
  },
  {
    municipality: 'Rösrath',
    postalCode: '51503'
  },
  {
    municipality: 'Rossau',
    postalCode: '09661'
  },
  {
    municipality: 'Roßbach',
    postalCode: '53547'
  },
  {
    municipality: 'Roßbach',
    postalCode: '56271'
  },
  {
    municipality: 'Roßbach',
    postalCode: '94439'
  },
  {
    municipality: 'Roßdorf',
    postalCode: '64380'
  },
  {
    municipality: 'Roßdorf',
    postalCode: '98590'
  },
  {
    municipality: 'Roßhaupten',
    postalCode: '87672'
  },
  {
    municipality: 'Rossin',
    postalCode: '17398'
  },
  {
    municipality: 'Roßleben-Wiehe',
    postalCode: '06571'
  },
  {
    municipality: 'Rossow',
    postalCode: '17322'
  },
  {
    municipality: 'Roßtal',
    postalCode: '90574'
  },
  {
    municipality: 'Roßwein',
    postalCode: '04741'
  },
  {
    municipality: 'Rostock',
    postalCode: '18055'
  },
  {
    municipality: 'Rostock',
    postalCode: '18057'
  },
  {
    municipality: 'Rostock',
    postalCode: '18059'
  },
  {
    municipality: 'Rostock',
    postalCode: '18069'
  },
  {
    municipality: 'Rostock',
    postalCode: '18106'
  },
  {
    municipality: 'Rostock',
    postalCode: '18107'
  },
  {
    municipality: 'Rostock',
    postalCode: '18109'
  },
  {
    municipality: 'Rostock',
    postalCode: '18119'
  },
  {
    municipality: 'Rostock',
    postalCode: '18146'
  },
  {
    municipality: 'Rostock',
    postalCode: '18147'
  },
  {
    municipality: 'Rostock',
    postalCode: '18181'
  },
  {
    municipality: 'Rostock',
    postalCode: '18182'
  },
  {
    municipality: 'Rot am See',
    postalCode: '74585'
  },
  {
    municipality: 'Rot an der Rot',
    postalCode: '88430'
  },
  {
    municipality: 'Rotenburg',
    postalCode: '27356'
  },
  {
    municipality: 'Rotenburg an der Fulda',
    postalCode: '36199'
  },
  {
    municipality: 'Rotenhain',
    postalCode: '56459'
  },
  {
    municipality: 'Rötgesbüttel',
    postalCode: '38531'
  },
  {
    municipality: 'Roth',
    postalCode: '91154'
  },
  {
    municipality: 'Roth',
    postalCode: '57539'
  },
  {
    municipality: 'Roth',
    postalCode: '56368'
  },
  {
    municipality: 'Roth',
    postalCode: '56288'
  },
  {
    municipality: 'Roth',
    postalCode: '55442'
  },
  {
    municipality: 'Rötha',
    postalCode: '04571'
  },
  {
    municipality: 'Roth an der Our',
    postalCode: '54675'
  },
  {
    municipality: 'Roth bei Prüm',
    postalCode: '54597'
  },
  {
    municipality: 'Rothemühl',
    postalCode: '17379'
  },
  {
    municipality: 'Rothenbach',
    postalCode: '56459'
  },
  {
    municipality: 'Röthenbach (Allgäu)',
    postalCode: '88167'
  },
  {
    municipality: 'Röthenbach an der Pegnitz',
    postalCode: '90552'
  },
  {
    municipality: 'Rothenbuch',
    postalCode: '63860'
  },
  {
    municipality: 'Rothenbuch',
    postalCode: '97840'
  },
  {
    municipality: 'Rothenburg ob der Tauber',
    postalCode: '91541'
  },
  {
    municipality: 'Rothenburg/Oberlausitz',
    postalCode: '02929'
  },
  {
    municipality: 'Rothenfels',
    postalCode: '97851'
  },
  {
    municipality: 'Rothenklempenow',
    postalCode: '17321'
  },
  {
    municipality: 'Rothenklempenow',
    postalCode: '17322'
  },
  {
    municipality: 'Rothenstein',
    postalCode: '07751'
  },
  {
    municipality: 'Röthlein',
    postalCode: '97520'
  },
  {
    municipality: 'Rothselberg',
    postalCode: '67753'
  },
  {
    municipality: 'Rötsweiler-Nockenthal',
    postalCode: '55767'
  },
  {
    municipality: 'Rott',
    postalCode: '57632'
  },
  {
    municipality: 'Rott',
    postalCode: '86935'
  },
  {
    municipality: 'Rottach-Egern',
    postalCode: '83700'
  },
  {
    municipality: 'Rott am Inn',
    postalCode: '83543'
  },
  {
    municipality: 'Rottenacker',
    postalCode: '89616'
  },
  {
    municipality: 'Röttenbach',
    postalCode: '91187'
  },
  {
    municipality: 'Röttenbach',
    postalCode: '91341'
  },
  {
    municipality: 'Rottenbuch',
    postalCode: '82401'
  },
  {
    municipality: 'Rottenburg a. d. Laaber',
    postalCode: '84056'
  },
  {
    municipality: 'Rottenburg am Neckar',
    postalCode: '72108'
  },
  {
    municipality: 'Rottendorf',
    postalCode: '97228'
  },
  {
    municipality: 'Rotthalmünster',
    postalCode: '94094'
  },
  {
    municipality: 'Röttingen',
    postalCode: '97285'
  },
  {
    municipality: 'Rottweil',
    postalCode: '78628'
  },
  {
    municipality: 'Rötz',
    postalCode: '92444'
  },
  {
    municipality: 'Rövershagen',
    postalCode: '18182'
  },
  {
    municipality: 'Roxheim',
    postalCode: '55595'
  },
  {
    municipality: 'Rubenow',
    postalCode: '17509'
  },
  {
    municipality: 'Rüber',
    postalCode: '56295'
  },
  {
    municipality: 'Rubkow',
    postalCode: '17390'
  },
  {
    municipality: 'Rückeroth',
    postalCode: '56244'
  },
  {
    municipality: 'Rückersdorf',
    postalCode: '90607'
  },
  {
    municipality: 'Rückersdorf',
    postalCode: '03238'
  },
  {
    municipality: 'Rückersdorf',
    postalCode: '07580'
  },
  {
    municipality: 'Rückholz',
    postalCode: '87494'
  },
  {
    municipality: 'Rückweiler',
    postalCode: '55776'
  },
  {
    municipality: 'Rudelzhausen',
    postalCode: '84104'
  },
  {
    municipality: 'Rüdenau',
    postalCode: '63924'
  },
  {
    municipality: 'Rüdenhausen',
    postalCode: '97355'
  },
  {
    municipality: 'Ruderatshofen',
    postalCode: '87674'
  },
  {
    municipality: 'Rudersberg',
    postalCode: '73635'
  },
  {
    municipality: 'Rüdersdorf bei Berlin',
    postalCode: '15345'
  },
  {
    municipality: 'Rüdersdorf bei Berlin',
    postalCode: '15378'
  },
  {
    municipality: 'Rüdersdorf bei Berlin',
    postalCode: '15562'
  },
  {
    municipality: 'Rüdershausen',
    postalCode: '37434'
  },
  {
    municipality: 'Ruderting',
    postalCode: '94161'
  },
  {
    municipality: 'Rüdesheim',
    postalCode: '55593'
  },
  {
    municipality: 'Rüdesheim am Rhein',
    postalCode: '65385'
  },
  {
    municipality: 'Rüdnitz',
    postalCode: '16321'
  },
  {
    municipality: 'Rudolstadt',
    postalCode: '07407'
  },
  {
    municipality: 'Rugendorf',
    postalCode: '95365'
  },
  {
    municipality: 'Rügge',
    postalCode: '24405'
  },
  {
    municipality: 'Rügland',
    postalCode: '91622'
  },
  {
    municipality: 'Rühen',
    postalCode: '38471'
  },
  {
    municipality: 'Ruhla',
    postalCode: '99842'
  },
  {
    municipality: 'Ruhland',
    postalCode: '01945'
  },
  {
    municipality: 'Ruhmannsfelden',
    postalCode: '94239'
  },
  {
    municipality: 'Rühn',
    postalCode: '18246'
  },
  {
    municipality: 'Ruhner Berge',
    postalCode: '19376'
  },
  {
    municipality: 'Ruhpolding',
    postalCode: '83324'
  },
  {
    municipality: 'Rühstädt',
    postalCode: '19322'
  },
  {
    municipality: 'Ruhstorf a.d.Rott',
    postalCode: '94099'
  },
  {
    municipality: 'Ruhwinkel',
    postalCode: '24601'
  },
  {
    municipality: 'Rukieten',
    postalCode: '18258'
  },
  {
    municipality: 'Rullstorf',
    postalCode: '21379'
  },
  {
    municipality: 'Rülzheim',
    postalCode: '76761'
  },
  {
    municipality: 'Rumbach',
    postalCode: '76891'
  },
  {
    municipality: 'Rümmelsheim',
    postalCode: '55452'
  },
  {
    municipality: 'Rümmingen',
    postalCode: '79595'
  },
  {
    municipality: 'Rumohr',
    postalCode: '24254'
  },
  {
    municipality: 'Rümpel',
    postalCode: '23843'
  },
  {
    municipality: 'Runding',
    postalCode: '93486'
  },
  {
    municipality: 'Runkel',
    postalCode: '65594'
  },
  {
    municipality: 'Ruppach-Goldhausen',
    postalCode: '56412'
  },
  {
    municipality: 'Ruppertsberg',
    postalCode: '67152'
  },
  {
    municipality: 'Ruppertsecken',
    postalCode: '67808'
  },
  {
    municipality: 'Ruppertshofen',
    postalCode: '56357'
  },
  {
    municipality: 'Ruppertshofen',
    postalCode: '73577'
  },
  {
    municipality: 'Ruppertsweiler',
    postalCode: '66957'
  },
  {
    municipality: 'Ruppichteroth',
    postalCode: '53809'
  },
  {
    municipality: 'Ruschberg',
    postalCode: '55776'
  },
  {
    municipality: 'Rüscheid',
    postalCode: '56584'
  },
  {
    municipality: 'Rüsselsheim am Main',
    postalCode: '65428'
  },
  {
    municipality: 'Rüssingen',
    postalCode: '67308'
  },
  {
    municipality: 'Rust',
    postalCode: '77977'
  },
  {
    municipality: 'Rustenfelde',
    postalCode: '37318'
  },
  {
    municipality: 'Rutesheim',
    postalCode: '71277'
  },
  {
    municipality: 'Rüthen',
    postalCode: '59602'
  },
  {
    municipality: 'Rüthnick',
    postalCode: '16835'
  },
  {
    municipality: 'Ruthweiler',
    postalCode: '66869'
  },
  {
    municipality: 'Rüting',
    postalCode: '23936'
  },
  {
    municipality: 'Rutsweiler am Glan',
    postalCode: '66887'
  },
  {
    municipality: 'Rutsweiler an der Lauter',
    postalCode: '67752'
  },
  {
    municipality: 'Ruttersdorf-Lotschen',
    postalCode: '07646'
  },
  {
    municipality: 'Saal',
    postalCode: '18317'
  },
  {
    municipality: 'Saal a.d.Donau',
    postalCode: '93342'
  },
  {
    municipality: 'Saal a.d.Saale',
    postalCode: '97633'
  },
  {
    municipality: 'Saalburg-Ebersdorf',
    postalCode: '07929'
  },
  {
    municipality: 'Saaldorf-Surheim',
    postalCode: '83416'
  },
  {
    municipality: 'Saalfeld/Saale',
    postalCode: '07318'
  },
  {
    municipality: 'Saalstadt',
    postalCode: '66919'
  },
  {
    municipality: 'Saara',
    postalCode: '07589'
  },
  {
    municipality: 'Saarbrücken',
    postalCode: '66111'
  },
  {
    municipality: 'Saarbrücken',
    postalCode: '66113'
  },
  {
    municipality: 'Saarbrücken',
    postalCode: '66115'
  },
  {
    municipality: 'Saarbrücken',
    postalCode: '66117'
  },
  {
    municipality: 'Saarbrücken',
    postalCode: '66119'
  },
  {
    municipality: 'Saarbrücken',
    postalCode: '66121'
  },
  {
    municipality: 'Saarbrücken',
    postalCode: '66123'
  },
  {
    municipality: 'Saarbrücken',
    postalCode: '66125'
  },
  {
    municipality: 'Saarbrücken',
    postalCode: '66126'
  },
  {
    municipality: 'Saarbrücken',
    postalCode: '66127'
  },
  {
    municipality: 'Saarbrücken',
    postalCode: '66128'
  },
  {
    municipality: 'Saarbrücken',
    postalCode: '66129'
  },
  {
    municipality: 'Saarbrücken',
    postalCode: '66130'
  },
  {
    municipality: 'Saarbrücken',
    postalCode: '66131'
  },
  {
    municipality: 'Saarbrücken',
    postalCode: '66132'
  },
  {
    municipality: 'Saarbrücken',
    postalCode: '66133'
  },
  {
    municipality: 'Saarburg',
    postalCode: '54439'
  },
  {
    municipality: 'Saarlouis',
    postalCode: '66740'
  },
  {
    municipality: 'Saarwellingen',
    postalCode: '66793'
  },
  {
    municipality: 'Sachsen bei Ansbach',
    postalCode: '91623'
  },
  {
    municipality: 'Sachsenhagen',
    postalCode: '31553'
  },
  {
    municipality: 'Sachsenheim',
    postalCode: '74343'
  },
  {
    municipality: 'Sachsenkam',
    postalCode: '83679'
  },
  {
    municipality: 'Saerbeck',
    postalCode: '48369'
  },
  {
    municipality: 'Saffig',
    postalCode: '56648'
  },
  {
    municipality: 'Sagard',
    postalCode: '18551'
  },
  {
    municipality: 'Sahms',
    postalCode: '21493'
  },
  {
    municipality: 'Sailauf',
    postalCode: '63877'
  },
  {
    municipality: 'Salach',
    postalCode: '73084'
  },
  {
    municipality: 'Salching',
    postalCode: '94330'
  },
  {
    municipality: 'Saldenburg',
    postalCode: '94163'
  },
  {
    municipality: 'Salem',
    postalCode: '23883'
  },
  {
    municipality: 'Salem',
    postalCode: '23911'
  },
  {
    municipality: 'Salem',
    postalCode: '88682'
  },
  {
    municipality: 'Salgen',
    postalCode: '87775'
  },
  {
    municipality: 'Sallgast',
    postalCode: '03238'
  },
  {
    municipality: 'Salm',
    postalCode: '54570'
  },
  {
    municipality: 'Salmtal',
    postalCode: '54528'
  },
  {
    municipality: 'Salz',
    postalCode: '97616'
  },
  {
    municipality: 'Salz',
    postalCode: '56414'
  },
  {
    municipality: 'Salzatal',
    postalCode: '06198'
  },
  {
    municipality: 'Salzbergen',
    postalCode: '48499'
  },
  {
    municipality: 'Salzburg',
    postalCode: '56479'
  },
  {
    municipality: 'Salzgitter',
    postalCode: '38226'
  },
  {
    municipality: 'Salzgitter',
    postalCode: '38228'
  },
  {
    municipality: 'Salzgitter',
    postalCode: '38229'
  },
  {
    municipality: 'Salzgitter',
    postalCode: '38239'
  },
  {
    municipality: 'Salzgitter',
    postalCode: '38259'
  },
  {
    municipality: 'Salzhausen',
    postalCode: '21376'
  },
  {
    municipality: 'Salzhemmendorf',
    postalCode: '31020'
  },
  {
    municipality: 'Salzkotten',
    postalCode: '33154'
  },
  {
    municipality: 'Salzwedel',
    postalCode: '29410'
  },
  {
    municipality: 'Salzweg',
    postalCode: '94121'
  },
  {
    municipality: 'Samerberg',
    postalCode: '83122'
  },
  {
    municipality: 'Samern',
    postalCode: '48465'
  },
  {
    municipality: 'Samtens',
    postalCode: '18573'
  },
  {
    municipality: 'Sand a. Main',
    postalCode: '97522'
  },
  {
    municipality: 'Sandau (Elbe)',
    postalCode: '39524'
  },
  {
    municipality: 'Sandberg',
    postalCode: '97657'
  },
  {
    municipality: 'Sandbostel',
    postalCode: '27446'
  },
  {
    municipality: 'Sande',
    postalCode: '26452'
  },
  {
    municipality: 'Sandersdorf-Brehna',
    postalCode: '06792'
  },
  {
    municipality: 'Sandersdorf-Brehna',
    postalCode: '06794'
  },
  {
    municipality: 'Sandersdorf-Brehna',
    postalCode: '06796'
  },
  {
    municipality: 'Sandersdorf-Brehna',
    postalCode: '06809'
  },
  {
    municipality: 'Sandesneben',
    postalCode: '23898'
  },
  {
    municipality: 'Sandhausen',
    postalCode: '69207'
  },
  {
    municipality: 'Sangerhausen',
    postalCode: '06526'
  },
  {
    municipality: 'Sanitz',
    postalCode: '18190'
  },
  {
    municipality: 'Sankt Alban',
    postalCode: '67813'
  },
  {
    municipality: 'Sankt Alban',
    postalCode: '67822'
  },
  {
    municipality: 'Sankt Aldegund',
    postalCode: '56858'
  },
  {
    municipality: 'Sankt Annen',
    postalCode: '25776'
  },
  {
    municipality: 'Sankt Augustin',
    postalCode: '53757'
  },
  {
    municipality: 'Sankt Bernhard',
    postalCode: '98660'
  },
  {
    municipality: 'Sankt Englmar',
    postalCode: '94379'
  },
  {
    municipality: 'Sankt Goar',
    postalCode: '56329'
  },
  {
    municipality: 'Sankt Goarshausen',
    postalCode: '56346'
  },
  {
    municipality: 'Sankt Ingbert',
    postalCode: '66386'
  },
  {
    municipality: 'Sankt Johann',
    postalCode: '56727'
  },
  {
    municipality: 'Sankt Johann',
    postalCode: '55578'
  },
  {
    municipality: 'Sankt Julian',
    postalCode: '66887'
  },
  {
    municipality: 'Sankt Katharinen',
    postalCode: '53562'
  },
  {
    municipality: 'Sankt Katharinen',
    postalCode: '55595'
  },
  {
    municipality: 'Sankt Margarethen',
    postalCode: '25572'
  },
  {
    municipality: 'Sankt Martin',
    postalCode: '67487'
  },
  {
    municipality: 'Sankt Michaelisdonn',
    postalCode: '25693'
  },
  {
    municipality: 'Sankt Oswald-Riedlhütte',
    postalCode: '94566'
  },
  {
    municipality: 'Sankt Oswald-Riedlhütte',
    postalCode: '94568'
  },
  {
    municipality: 'Sankt Peter',
    postalCode: '79271'
  },
  {
    municipality: 'Sankt Peter-Ording',
    postalCode: '25826'
  },
  {
    municipality: 'Sankt Sebastian',
    postalCode: '56220'
  },
  {
    municipality: 'Sankt Thomas',
    postalCode: '54655'
  },
  {
    municipality: 'Sankt Wendel',
    postalCode: '66606'
  },
  {
    municipality: 'Sankt Wolfgang',
    postalCode: '84427'
  },
  {
    municipality: 'Sargenroth',
    postalCode: '55471'
  },
  {
    municipality: 'Sarlhusen',
    postalCode: '24616'
  },
  {
    municipality: 'Sarmersbach',
    postalCode: '54552'
  },
  {
    municipality: 'Sarmstorf',
    postalCode: '18276'
  },
  {
    municipality: 'Sarnow',
    postalCode: '17392'
  },
  {
    municipality: 'Sarow',
    postalCode: '17111'
  },
  {
    municipality: 'Sarstedt',
    postalCode: '31157'
  },
  {
    municipality: 'Sarzbüttel',
    postalCode: '25785'
  },
  {
    municipality: 'Sasbach',
    postalCode: '77880'
  },
  {
    municipality: 'Sasbach am Kaiserstuhl',
    postalCode: '79361'
  },
  {
    municipality: 'Sasbachwalden',
    postalCode: '77887'
  },
  {
    municipality: 'Sassen',
    postalCode: '56767'
  },
  {
    municipality: 'Sassenberg',
    postalCode: '48336'
  },
  {
    municipality: 'Sassenburg',
    postalCode: '38524'
  },
  {
    municipality: 'Sassen-Trantow',
    postalCode: '17121'
  },
  {
    municipality: 'Sassnitz',
    postalCode: '18546'
  },
  {
    municipality: 'Saterland - Seelterlound',
    postalCode: '26683'
  },
  {
    municipality: 'Satow',
    postalCode: '18239'
  },
  {
    municipality: 'Satteldorf',
    postalCode: '74589'
  },
  {
    municipality: 'Sauensiek',
    postalCode: '21644'
  },
  {
    municipality: 'Sauerlach',
    postalCode: '82054'
  },
  {
    municipality: 'Sauerthal',
    postalCode: '65391'
  },
  {
    municipality: 'Sauldorf',
    postalCode: '88605'
  },
  {
    municipality: 'Saulgrub',
    postalCode: '82442'
  },
  {
    municipality: 'Saulheim',
    postalCode: '55291'
  },
  {
    municipality: 'Saustrup',
    postalCode: '24392'
  },
  {
    municipality: 'Sauzin',
    postalCode: '17440'
  },
  {
    municipality: 'Saxler',
    postalCode: '54558'
  },
  {
    municipality: 'Sayda',
    postalCode: '09619'
  },
  {
    municipality: 'Schaafheim',
    postalCode: '64850'
  },
  {
    municipality: 'Schaalby',
    postalCode: '24882'
  },
  {
    municipality: 'Schacht-Audorf',
    postalCode: '24790'
  },
  {
    municipality: 'Schacht-Audorf',
    postalCode: '24794'
  },
  {
    municipality: 'Schachtebich',
    postalCode: '37318'
  },
  {
    municipality: 'Schackendorf',
    postalCode: '23795'
  },
  {
    municipality: 'Schafflund',
    postalCode: '24980'
  },
  {
    municipality: 'Schafstedt',
    postalCode: '25725'
  },
  {
    municipality: 'Schäftlarn',
    postalCode: '82067'
  },
  {
    municipality: 'Schäftlarn',
    postalCode: '82069'
  },
  {
    municipality: 'Schalkau',
    postalCode: '96528'
  },
  {
    municipality: 'Schalkenbach',
    postalCode: '53426'
  },
  {
    municipality: 'Schalkenmehren',
    postalCode: '54552'
  },
  {
    municipality: 'Schalkham',
    postalCode: '84175'
  },
  {
    municipality: 'Schalkholz',
    postalCode: '25782'
  },
  {
    municipality: 'Schalksmühle',
    postalCode: '58579'
  },
  {
    municipality: 'Schallbach',
    postalCode: '79597'
  },
  {
    municipality: 'Schallodenbach',
    postalCode: '67701'
  },
  {
    municipality: 'Schallstadt',
    postalCode: '79227'
  },
  {
    municipality: 'Schankweiler',
    postalCode: '54668'
  },
  {
    municipality: 'Schapen',
    postalCode: '48480'
  },
  {
    municipality: 'Schaprode',
    postalCode: '18569'
  },
  {
    municipality: 'Scharbeutz',
    postalCode: '23629'
  },
  {
    municipality: 'Scharbeutz',
    postalCode: '23683'
  },
  {
    municipality: 'Scharbeutz',
    postalCode: '23684'
  },
  {
    municipality: 'Scharfbillig',
    postalCode: '54636'
  },
  {
    municipality: 'Scharnebeck',
    postalCode: '21379'
  },
  {
    municipality: 'Schashagen',
    postalCode: '23730'
  },
  {
    municipality: 'Schauenburg',
    postalCode: '34270'
  },
  {
    municipality: 'Schauenstein',
    postalCode: '95197'
  },
  {
    municipality: 'Schauerberg',
    postalCode: '66919'
  },
  {
    municipality: 'Schaufling',
    postalCode: '94571'
  },
  {
    municipality: 'Schauren',
    postalCode: '55758'
  },
  {
    municipality: 'Schauren',
    postalCode: '56865'
  },
  {
    municipality: 'Schechen',
    postalCode: '83135'
  },
  {
    municipality: 'Schechingen',
    postalCode: '73579'
  },
  {
    municipality: 'Scheden',
    postalCode: '37127'
  },
  {
    municipality: 'Scheer',
    postalCode: '72516'
  },
  {
    municipality: 'Scheeßel',
    postalCode: '27383'
  },
  {
    municipality: 'Schefflenz',
    postalCode: '74850'
  },
  {
    municipality: 'Scheggerott',
    postalCode: '24392'
  },
  {
    municipality: 'Scheibenberg',
    postalCode: '09481'
  },
  {
    municipality: 'Scheibenhardt',
    postalCode: '76779'
  },
  {
    municipality: 'Scheid',
    postalCode: '54611'
  },
  {
    municipality: 'Scheidegg',
    postalCode: '88175'
  },
  {
    municipality: 'Scheiditz',
    postalCode: '07646'
  },
  {
    municipality: 'Scheidt',
    postalCode: '56379'
  },
  {
    municipality: 'Scheinfeld',
    postalCode: '91443'
  },
  {
    municipality: 'Scheitenkorb',
    postalCode: '54673'
  },
  {
    municipality: 'Schelklingen',
    postalCode: '89601'
  },
  {
    municipality: 'Schellerten',
    postalCode: '31174'
  },
  {
    municipality: 'Schellhorn',
    postalCode: '24211'
  },
  {
    municipality: 'Schellweiler',
    postalCode: '66869'
  },
  {
    municipality: 'Schemmerhofen',
    postalCode: '88433'
  },
  {
    municipality: 'Schenefeld',
    postalCode: '22869'
  },
  {
    municipality: 'Schenefeld',
    postalCode: '25560'
  },
  {
    municipality: 'Schenkelberg',
    postalCode: '56244'
  },
  {
    municipality: 'Schenkenberg',
    postalCode: '17291'
  },
  {
    municipality: 'Schenkendöbern',
    postalCode: '03172'
  },
  {
    municipality: 'Schenkenzell',
    postalCode: '77773'
  },
  {
    municipality: 'Schenklengsfeld',
    postalCode: '36277'
  },
  {
    municipality: 'Schermbeck',
    postalCode: '46514'
  },
  {
    municipality: 'Schernfeld',
    postalCode: '85132'
  },
  {
    municipality: 'Scherstetten',
    postalCode: '86872'
  },
  {
    municipality: 'Scheßlitz',
    postalCode: '96110'
  },
  {
    municipality: 'Scheuerfeld',
    postalCode: '57584'
  },
  {
    municipality: 'Scheuern',
    postalCode: '54673'
  },
  {
    municipality: 'Scheuring',
    postalCode: '86937'
  },
  {
    municipality: 'Scheyern',
    postalCode: '85298'
  },
  {
    municipality: 'Schieder-Schwalenberg',
    postalCode: '32816'
  },
  {
    municipality: 'Schieren',
    postalCode: '23795'
  },
  {
    municipality: 'Schierensee',
    postalCode: '24241'
  },
  {
    municipality: 'Schierling',
    postalCode: '84069'
  },
  {
    municipality: 'Schiersfeld',
    postalCode: '67808'
  },
  {
    municipality: 'Schiersfeld',
    postalCode: '67823'
  },
  {
    municipality: 'Schiesheim',
    postalCode: '65623'
  },
  {
    municipality: 'Schiffdorf',
    postalCode: '27619'
  },
  {
    municipality: 'Schifferstadt',
    postalCode: '67105'
  },
  {
    municipality: 'Schiffweiler',
    postalCode: '66578'
  },
  {
    municipality: 'Schilda',
    postalCode: '03253'
  },
  {
    municipality: 'Schildetal',
    postalCode: '19209'
  },
  {
    municipality: 'Schillingen',
    postalCode: '54429'
  },
  {
    municipality: 'Schillingsfürst',
    postalCode: '91583'
  },
  {
    municipality: 'Schillsdorf',
    postalCode: '24637'
  },
  {
    municipality: 'Schiltach',
    postalCode: '77761'
  },
  {
    municipality: 'Schiltberg',
    postalCode: '86576'
  },
  {
    municipality: 'Schimberg',
    postalCode: '37308'
  },
  {
    municipality: 'Schindhard',
    postalCode: '66996'
  },
  {
    municipality: 'Schinkel',
    postalCode: '24214'
  },
  {
    municipality: 'Schiphorst',
    postalCode: '23847'
  },
  {
    municipality: 'Schipkau',
    postalCode: '01968'
  },
  {
    municipality: 'Schipkau',
    postalCode: '01993'
  },
  {
    municipality: 'Schipkau',
    postalCode: '01994'
  },
  {
    municipality: 'Schipkau',
    postalCode: '01998'
  },
  {
    municipality: 'Schirgiswalde-Kirschau',
    postalCode: '02681'
  },
  {
    municipality: 'Schirmitz',
    postalCode: '92718'
  },
  {
    municipality: 'Schirnding',
    postalCode: '95706'
  },
  {
    municipality: 'Schkeuditz',
    postalCode: '04435'
  },
  {
    municipality: 'Schkölen',
    postalCode: '07619'
  },
  {
    municipality: 'Schkopau',
    postalCode: '06258'
  },
  {
    municipality: 'Schladen-Werla',
    postalCode: '38315'
  },
  {
    municipality: 'Schladt',
    postalCode: '54534'
  },
  {
    municipality: 'Schlagsdorf',
    postalCode: '19217'
  },
  {
    municipality: 'Schlaitdorf',
    postalCode: '72667'
  },
  {
    municipality: 'Schlammersdorf',
    postalCode: '95519'
  },
  {
    municipality: 'Schlangen',
    postalCode: '33189'
  },
  {
    municipality: 'Schlangenbad',
    postalCode: '65388'
  },
  {
    municipality: 'Schlat',
    postalCode: '73114'
  },
  {
    municipality: 'Schlaubetal',
    postalCode: '15890'
  },
  {
    municipality: 'Schleching',
    postalCode: '83259'
  },
  {
    municipality: 'Schlechtsart',
    postalCode: '98663'
  },
  {
    municipality: 'Schlehdorf',
    postalCode: '82439'
  },
  {
    municipality: 'Schlehdorf',
    postalCode: '82444'
  },
  {
    municipality: 'Schleich',
    postalCode: '54340'
  },
  {
    municipality: 'Schleid',
    postalCode: '54636'
  },
  {
    municipality: 'Schleid',
    postalCode: '36419'
  },
  {
    municipality: 'Schleiden',
    postalCode: '53937'
  },
  {
    municipality: 'Schleife - Slepo',
    postalCode: '02959'
  },
  {
    municipality: 'Schleifreisen',
    postalCode: '07629'
  },
  {
    municipality: 'Schleiz',
    postalCode: '07907'
  },
  {
    municipality: 'Schlemmin',
    postalCode: '18320'
  },
  {
    municipality: 'Schlepzig',
    postalCode: '15910'
  },
  {
    municipality: 'Schlesen',
    postalCode: '24256'
  },
  {
    municipality: 'Schleswig',
    postalCode: '24837'
  },
  {
    municipality: 'Schlettau',
    postalCode: '09487'
  },
  {
    municipality: 'Schleusegrund',
    postalCode: '98666'
  },
  {
    municipality: 'Schleusegrund',
    postalCode: '98667'
  },
  {
    municipality: 'Schleusingen',
    postalCode: '98553'
  },
  {
    municipality: 'Schlichting',
    postalCode: '25779'
  },
  {
    municipality: 'Schlieben',
    postalCode: '04936'
  },
  {
    municipality: 'Schliengen',
    postalCode: '79418'
  },
  {
    municipality: 'Schlier',
    postalCode: '88281'
  },
  {
    municipality: 'Schlierbach',
    postalCode: '73278'
  },
  {
    municipality: 'Schlierschied',
    postalCode: '55483'
  },
  {
    municipality: 'Schliersee',
    postalCode: '83727'
  },
  {
    municipality: 'Schlitz',
    postalCode: '36110'
  },
  {
    municipality: 'Schlöben',
    postalCode: '07646'
  },
  {
    municipality: 'Schloen-Dratow',
    postalCode: '17192'
  },
  {
    municipality: 'Schloen-Dratow',
    postalCode: '17219'
  },
  {
    municipality: 'Schloßböckelheim',
    postalCode: '55596'
  },
  {
    municipality: 'Schloß Holte-Stukenbrock',
    postalCode: '33758'
  },
  {
    municipality: 'Schloßvippach',
    postalCode: '99195'
  },
  {
    municipality: 'Schlotfeld',
    postalCode: '25551'
  },
  {
    municipality: 'Schluchsee',
    postalCode: '79859'
  },
  {
    municipality: 'Schlüchtern',
    postalCode: '36381'
  },
  {
    municipality: 'Schlüsselfeld',
    postalCode: '96132'
  },
  {
    municipality: 'Schmalenberg',
    postalCode: '67718'
  },
  {
    municipality: 'Schmalensee',
    postalCode: '24638'
  },
  {
    municipality: 'Schmalfeld',
    postalCode: '24640'
  },
  {
    municipality: 'Schmalkalden',
    postalCode: '98574'
  },
  {
    municipality: 'Schmalkalden',
    postalCode: '98587'
  },
  {
    municipality: 'Schmallenberg',
    postalCode: '57392'
  },
  {
    municipality: 'Schmalstede',
    postalCode: '24241'
  },
  {
    municipality: 'Schmatzin',
    postalCode: '17390'
  },
  {
    municipality: 'Schmedeswurth',
    postalCode: '25724'
  },
  {
    municipality: 'Schmeheim',
    postalCode: '98530'
  },
  {
    municipality: 'Schmelz',
    postalCode: '66839'
  },
  {
    municipality: 'Schmidgaden',
    postalCode: '92546'
  },
  {
    municipality: 'Schmidmühlen',
    postalCode: '92287'
  },
  {
    municipality: 'Schmidthachenbach',
    postalCode: '55758'
  },
  {
    municipality: 'Schmiechen',
    postalCode: '86511'
  },
  {
    municipality: 'Schmiedehausen',
    postalCode: '99518'
  },
  {
    municipality: 'Schmieritz',
    postalCode: '07819'
  },
  {
    municipality: 'Schmilau',
    postalCode: '23883'
  },
  {
    municipality: 'Schmilau',
    postalCode: '23909'
  },
  {
    municipality: 'Schmilau',
    postalCode: '23911'
  },
  {
    municipality: 'Schmißberg',
    postalCode: '55765'
  },
  {
    municipality: 'Schmitshausen',
    postalCode: '66484'
  },
  {
    municipality: 'Schmitshausen',
    postalCode: '66917'
  },
  {
    municipality: 'Schmitt',
    postalCode: '56825'
  },
  {
    municipality: 'Schmitten im Taunus',
    postalCode: '61389'
  },
  {
    municipality: 'Schmittweiler',
    postalCode: '67829'
  },
  {
    municipality: 'Schmogrow-Fehrow',
    postalCode: '03096'
  },
  {
    municipality: 'Schmölln',
    postalCode: '04626'
  },
  {
    municipality: 'Schmölln-Putzkau',
    postalCode: '01877'
  },
  {
    municipality: 'Schmorda',
    postalCode: '07389'
  },
  {
    municipality: 'Schnabelwaid',
    postalCode: '91289'
  },
  {
    municipality: 'Schnackenburg',
    postalCode: '29493'
  },
  {
    municipality: 'Schnaitsee',
    postalCode: '83530'
  },
  {
    municipality: 'Schnaittach',
    postalCode: '91220'
  },
  {
    municipality: 'Schnaittenbach',
    postalCode: '92253'
  },
  {
    municipality: 'Schnakenbek',
    postalCode: '21481'
  },
  {
    municipality: 'Schnarup-Thumby',
    postalCode: '24891'
  },
  {
    municipality: 'Schnaudertal',
    postalCode: '06712'
  },
  {
    municipality: 'Schneckenhausen',
    postalCode: '67699'
  },
  {
    municipality: 'Schneckenlohe',
    postalCode: '96277'
  },
  {
    municipality: 'Schneeberg',
    postalCode: '63936'
  },
  {
    municipality: 'Schneeberg',
    postalCode: '08289'
  },
  {
    municipality: 'Schnega',
    postalCode: '29465'
  },
  {
    municipality: 'Schneizlreuth',
    postalCode: '83458'
  },
  {
    municipality: 'Schnelldorf',
    postalCode: '91625'
  },
  {
    municipality: 'Schneppenbach',
    postalCode: '55608'
  },
  {
    municipality: 'Schneverdingen',
    postalCode: '29640'
  },
  {
    municipality: 'Schnorbach',
    postalCode: '55497'
  },
  {
    municipality: 'Schnürpflingen',
    postalCode: '89194'
  },
  {
    municipality: 'Schoden',
    postalCode: '54441'
  },
  {
    municipality: 'Schöffengrund',
    postalCode: '35641'
  },
  {
    municipality: 'Schöfweg',
    postalCode: '94572'
  },
  {
    municipality: 'Scholen',
    postalCode: '27251'
  },
  {
    municipality: 'Schollbrunn',
    postalCode: '97852'
  },
  {
    municipality: 'Schollbrunn',
    postalCode: '97907'
  },
  {
    municipality: 'Schollene',
    postalCode: '14715'
  },
  {
    municipality: 'Schöllkrippen',
    postalCode: '63825'
  },
  {
    municipality: 'Schöllnach',
    postalCode: '94508'
  },
  {
    municipality: 'Schömberg',
    postalCode: '75328'
  },
  {
    municipality: 'Schömberg',
    postalCode: '72355'
  },
  {
    municipality: 'Schömerich',
    postalCode: '54314'
  },
  {
    municipality: 'Schonach im Schwarzwald',
    postalCode: '78136'
  },
  {
    municipality: 'Schönaich',
    postalCode: '71101'
  },
  {
    municipality: 'Schönau',
    postalCode: '69250'
  },
  {
    municipality: 'Schönau',
    postalCode: '84337'
  },
  {
    municipality: 'Schönau a.d.Brend',
    postalCode: '97659'
  },
  {
    municipality: 'Schönau am Königssee',
    postalCode: '83471'
  },
  {
    municipality: 'Schönau-Berzdorf auf dem Eigen',
    postalCode: '02899'
  },
  {
    municipality: 'Schönau im Schwarzwald',
    postalCode: '79677'
  },
  {
    municipality: 'Schönau (Pfalz)',
    postalCode: '66996'
  },
  {
    municipality: 'Schönbach',
    postalCode: '54552'
  },
  {
    municipality: 'Schönbach',
    postalCode: '02708'
  },
  {
    municipality: 'Schönbeck',
    postalCode: '17349'
  },
  {
    municipality: 'Schönbek',
    postalCode: '24582'
  },
  {
    municipality: 'Schönberg',
    postalCode: '08393'
  },
  {
    municipality: 'Schönberg',
    postalCode: '84573'
  },
  {
    municipality: 'Schönberg',
    postalCode: '94513'
  },
  {
    municipality: 'Schönberg',
    postalCode: '54426'
  },
  {
    municipality: 'Schönberg',
    postalCode: '22929'
  },
  {
    municipality: 'Schönberg',
    postalCode: '23923'
  },
  {
    municipality: 'Schönberg (Holstein)',
    postalCode: '24217'
  },
  {
    municipality: 'Schönborn',
    postalCode: '56370'
  },
  {
    municipality: 'Schönborn',
    postalCode: '55469'
  },
  {
    municipality: 'Schönborn',
    postalCode: '67808'
  },
  {
    municipality: 'Schönborn',
    postalCode: '03253'
  },
  {
    municipality: 'Schönbrunn',
    postalCode: '69436'
  },
  {
    municipality: 'Schönbrunn i.Steigerwald',
    postalCode: '96185'
  },
  {
    municipality: 'Schönburg',
    postalCode: '06618'
  },
  {
    municipality: 'Schöndorf',
    postalCode: '54316'
  },
  {
    municipality: 'Schöndorf',
    postalCode: '07924'
  },
  {
    municipality: 'Schondorf am Ammersee',
    postalCode: '86938'
  },
  {
    municipality: 'Schondra',
    postalCode: '97795'
  },
  {
    municipality: 'Schönebeck (Elbe)',
    postalCode: '39217'
  },
  {
    municipality: 'Schönebeck (Elbe)',
    postalCode: '39218'
  },
  {
    municipality: 'Schöneberg',
    postalCode: '57638'
  },
  {
    municipality: 'Schöneberg',
    postalCode: '55444'
  },
  {
    municipality: 'Schöneck',
    postalCode: '61137'
  },
  {
    municipality: 'Schönecken',
    postalCode: '54614'
  },
  {
    municipality: 'Schöneck/Vogtl.',
    postalCode: '08261'
  },
  {
    municipality: 'Schönefeld',
    postalCode: '12529'
  },
  {
    municipality: 'Schöneiche bei Berlin',
    postalCode: '15566'
  },
  {
    municipality: 'Schönenberg',
    postalCode: '79677'
  },
  {
    municipality: 'Schönenberg-Kübelberg',
    postalCode: '66901'
  },
  {
    municipality: 'Schönermark',
    postalCode: '16775'
  },
  {
    municipality: 'Schönewalde',
    postalCode: '04916'
  },
  {
    municipality: 'Schönewörde',
    postalCode: '29396'
  },
  {
    municipality: 'Schönfeld',
    postalCode: '01561'
  },
  {
    municipality: 'Schönfeld',
    postalCode: '17291'
  },
  {
    municipality: 'Schönfeld',
    postalCode: '17111'
  },
  {
    municipality: 'Schongau',
    postalCode: '86956'
  },
  {
    municipality: 'Schöngeising',
    postalCode: '82296'
  },
  {
    municipality: 'Schöngleina',
    postalCode: '07646'
  },
  {
    municipality: 'Schönhagen',
    postalCode: '37318'
  },
  {
    municipality: 'Schönhausen',
    postalCode: '17337'
  },
  {
    municipality: 'Schönhausen (Elbe)',
    postalCode: '39524'
  },
  {
    municipality: 'Schönheide',
    postalCode: '08304'
  },
  {
    municipality: 'Schönhorst',
    postalCode: '24220'
  },
  {
    municipality: 'Schöningen',
    postalCode: '38364'
  },
  {
    municipality: 'Schönkirchen',
    postalCode: '24232'
  },
  {
    municipality: 'Schönsee',
    postalCode: '92539'
  },
  {
    municipality: 'Schönstedt',
    postalCode: '99947'
  },
  {
    municipality: 'Schonstett',
    postalCode: '83137'
  },
  {
    municipality: 'Schöntal',
    postalCode: '74214'
  },
  {
    municipality: 'Schönthal',
    postalCode: '93488'
  },
  {
    municipality: 'Schonungen',
    postalCode: '97453'
  },
  {
    municipality: 'Schönwald',
    postalCode: '95173'
  },
  {
    municipality: 'Schönwald',
    postalCode: '15910'
  },
  {
    municipality: 'Schönwalde',
    postalCode: '17309'
  },
  {
    municipality: 'Schönwalde am Bungsberg',
    postalCode: '23744'
  },
  {
    municipality: 'Schönwalde-Glien',
    postalCode: '14621'
  },
  {
    municipality: 'Schönwald im Schwarzwald',
    postalCode: '78141'
  },
  {
    municipality: 'Schönwölkau',
    postalCode: '04509'
  },
  {
    municipality: 'Schopfheim',
    postalCode: '79650'
  },
  {
    municipality: 'Schopfloch',
    postalCode: '91626'
  },
  {
    municipality: 'Schopfloch',
    postalCode: '72296'
  },
  {
    municipality: 'Schopp',
    postalCode: '67707'
  },
  {
    municipality: 'Schöppenstedt',
    postalCode: '38170'
  },
  {
    municipality: 'Schöppingen',
    postalCode: '48624'
  },
  {
    municipality: 'Schöps',
    postalCode: '07768'
  },
  {
    municipality: 'Schöpstal',
    postalCode: '02829'
  },
  {
    municipality: 'Schorfheide',
    postalCode: '16244'
  },
  {
    municipality: 'Schorndorf',
    postalCode: '73614'
  },
  {
    municipality: 'Schorndorf',
    postalCode: '93489'
  },
  {
    municipality: 'Schornsheim',
    postalCode: '55288'
  },
  {
    municipality: 'Schorssow',
    postalCode: '17166'
  },
  {
    municipality: 'Schortens',
    postalCode: '26419'
  },
  {
    municipality: 'Schossin',
    postalCode: '19073'
  },
  {
    municipality: 'Schossin',
    postalCode: '19075'
  },
  {
    municipality: 'Schotten',
    postalCode: '63679'
  },
  {
    municipality: 'Schraden',
    postalCode: '04928'
  },
  {
    municipality: 'Schramberg',
    postalCode: '78144'
  },
  {
    municipality: 'Schramberg',
    postalCode: '78713'
  },
  {
    municipality: 'Schraplau',
    postalCode: '06279'
  },
  {
    municipality: 'Schrecksbach',
    postalCode: '34637'
  },
  {
    municipality: 'Schretstaken',
    postalCode: '21493'
  },
  {
    municipality: 'Schriesheim',
    postalCode: '69198'
  },
  {
    municipality: 'Schrobenhausen',
    postalCode: '86529'
  },
  {
    municipality: 'Schrozberg',
    postalCode: '74575'
  },
  {
    municipality: 'Schrum',
    postalCode: '25782'
  },
  {
    municipality: 'Schuby',
    postalCode: '24837'
  },
  {
    municipality: 'Schuby',
    postalCode: '24850'
  },
  {
    municipality: 'Schuld',
    postalCode: '53520'
  },
  {
    municipality: 'Schulendorf',
    postalCode: '21516'
  },
  {
    municipality: 'Schülldorf',
    postalCode: '24790'
  },
  {
    municipality: 'Schüller',
    postalCode: '54586'
  },
  {
    municipality: 'Schülp',
    postalCode: '25764'
  },
  {
    municipality: 'Schülp bei Nortorf',
    postalCode: '24589'
  },
  {
    municipality: 'Schülp bei Rendsburg',
    postalCode: '24768'
  },
  {
    municipality: 'Schülp bei Rendsburg',
    postalCode: '24797'
  },
  {
    municipality: 'Schülp bei Rendsburg',
    postalCode: '24813'
  },
  {
    municipality: 'Schulzendorf',
    postalCode: '15732'
  },
  {
    municipality: 'Schürdt',
    postalCode: '57632'
  },
  {
    municipality: 'Schürensöhlen',
    postalCode: '23847'
  },
  {
    municipality: 'Schuttertal',
    postalCode: '77978'
  },
  {
    municipality: 'Schutterwald',
    postalCode: '77746'
  },
  {
    municipality: 'Schüttorf',
    postalCode: '48465'
  },
  {
    municipality: 'Schutz',
    postalCode: '54570'
  },
  {
    municipality: 'Schutzbach',
    postalCode: '57520'
  },
  {
    municipality: 'Schwaan',
    postalCode: '18258'
  },
  {
    municipality: 'Schwaara',
    postalCode: '07554'
  },
  {
    municipality: 'Schwabach',
    postalCode: '91126'
  },
  {
    municipality: 'Schwabbruck',
    postalCode: '86986'
  },
  {
    municipality: 'Schwabenheim an der Selz',
    postalCode: '55270'
  },
  {
    municipality: 'Schwabhausen',
    postalCode: '85247'
  },
  {
    municipality: 'Schwabhausen',
    postalCode: '99869'
  },
  {
    municipality: 'Schwäbisch Gmünd',
    postalCode: '73072'
  },
  {
    municipality: 'Schwäbisch Gmünd',
    postalCode: '73525'
  },
  {
    municipality: 'Schwäbisch Gmünd',
    postalCode: '73527'
  },
  {
    municipality: 'Schwäbisch Gmünd',
    postalCode: '73529'
  },
  {
    municipality: 'Schwäbisch Gmünd',
    postalCode: '73550'
  },
  {
    municipality: 'Schwäbisch Gmünd',
    postalCode: '73553'
  },
  {
    municipality: 'Schwäbisch Hall',
    postalCode: '74523'
  },
  {
    municipality: 'Schwabmünchen',
    postalCode: '86830'
  },
  {
    municipality: 'Schwabsoien',
    postalCode: '86987'
  },
  {
    municipality: 'Schwabstedt',
    postalCode: '25876'
  },
  {
    municipality: 'Schwaförden',
    postalCode: '27252'
  },
  {
    municipality: 'Schwaig bei Nürnberg',
    postalCode: '90571'
  },
  {
    municipality: 'Schwaigen',
    postalCode: '82445'
  },
  {
    municipality: 'Schwaigern',
    postalCode: '74193'
  },
  {
    municipality: 'Schwaikheim',
    postalCode: '71409'
  },
  {
    municipality: 'Schwalbach',
    postalCode: '65824'
  },
  {
    municipality: 'Schwalbach',
    postalCode: '66773'
  },
  {
    municipality: 'Schwall',
    postalCode: '56281'
  },
  {
    municipality: 'Schwallungen',
    postalCode: '98590'
  },
  {
    municipality: 'Schwalmstadt',
    postalCode: '34613'
  },
  {
    municipality: 'Schwalmtal',
    postalCode: '41366'
  },
  {
    municipality: 'Schwalmtal',
    postalCode: '36318'
  },
  {
    municipality: 'Schwanau',
    postalCode: '77963'
  },
  {
    municipality: 'Schwandorf',
    postalCode: '92421'
  },
  {
    municipality: 'Schwanebeck',
    postalCode: '39397'
  },
  {
    municipality: 'Schwanewede',
    postalCode: '28790'
  },
  {
    municipality: 'Schwanfeld',
    postalCode: '97523'
  },
  {
    municipality: 'Schwangau',
    postalCode: '87645'
  },
  {
    municipality: 'Schwanheide',
    postalCode: '19258'
  },
  {
    municipality: 'Schwanheim',
    postalCode: '76848'
  },
  {
    municipality: 'Schwanstetten',
    postalCode: '90596'
  },
  {
    municipality: 'Schwarme',
    postalCode: '27327'
  },
  {
    municipality: 'Schwarmstedt',
    postalCode: '29690'
  },
  {
    municipality: 'Schwartbuck',
    postalCode: '24257'
  },
  {
    municipality: 'Schwarz',
    postalCode: '17252'
  },
  {
    municipality: 'Schwarza',
    postalCode: '98547'
  },
  {
    municipality: 'Schwarzach',
    postalCode: '74869'
  },
  {
    municipality: 'Schwarzach',
    postalCode: '94374'
  },
  {
    municipality: 'Schwarzach am Main',
    postalCode: '97359'
  },
  {
    municipality: 'Schwarzach b.Nabburg',
    postalCode: '92548'
  },
  {
    municipality: 'Schwarzatal',
    postalCode: '98744'
  },
  {
    municipality: 'Schwarzbach',
    postalCode: '01945'
  },
  {
    municipality: 'Schwarzbach',
    postalCode: '07589'
  },
  {
    municipality: 'Schwarzburg',
    postalCode: '07427'
  },
  {
    municipality: 'Schwarzen',
    postalCode: '55481'
  },
  {
    municipality: 'Schwarzenbach',
    postalCode: '92720'
  },
  {
    municipality: 'Schwarzenbach a.d.Saale',
    postalCode: '95126'
  },
  {
    municipality: 'Schwarzenbach a.Wald',
    postalCode: '95131'
  },
  {
    municipality: 'Schwarzenbek',
    postalCode: '21493'
  },
  {
    municipality: 'Schwarzenberg/Erzgebirge',
    postalCode: '08340'
  },
  {
    municipality: 'Schwarzenborn',
    postalCode: '34639'
  },
  {
    municipality: 'Schwarzenborn',
    postalCode: '54533'
  },
  {
    municipality: 'Schwarzenbruck',
    postalCode: '90592'
  },
  {
    municipality: 'Schwarzenfeld',
    postalCode: '92521'
  },
  {
    municipality: 'Schwarzerden',
    postalCode: '55629'
  },
  {
    municipality: 'Schwarzheide',
    postalCode: '01987'
  },
  {
    municipality: 'Schwarzhofen',
    postalCode: '92447'
  },
  {
    municipality: 'Schwasdorf',
    postalCode: '17168'
  },
  {
    municipality: 'Schwebheim',
    postalCode: '97525'
  },
  {
    municipality: 'Schwedelbach',
    postalCode: '67685'
  },
  {
    municipality: 'Schwedeneck',
    postalCode: '24229'
  },
  {
    municipality: 'Schwedt/Oder',
    postalCode: '16303'
  },
  {
    municipality: 'Schwegenheim',
    postalCode: '67365'
  },
  {
    municipality: 'Schweich',
    postalCode: '54338'
  },
  {
    municipality: 'Schweickershausen',
    postalCode: '98663'
  },
  {
    municipality: 'Schweigen-Rechtenbach',
    postalCode: '76889'
  },
  {
    municipality: 'Schweighausen',
    postalCode: '56377'
  },
  {
    municipality: 'Schweighofen',
    postalCode: '76889'
  },
  {
    municipality: 'Schweindorf',
    postalCode: '26556'
  },
  {
    municipality: 'Schweinfurt',
    postalCode: '97421'
  },
  {
    municipality: 'Schweinfurt',
    postalCode: '97422'
  },
  {
    municipality: 'Schweinfurt',
    postalCode: '97424'
  },
  {
    municipality: 'Schweinschied',
    postalCode: '67744'
  },
  {
    municipality: 'Schweisweiler',
    postalCode: '67808'
  },
  {
    municipality: 'Schweitenkirchen',
    postalCode: '85301'
  },
  {
    municipality: 'Schweix',
    postalCode: '66957'
  },
  {
    municipality: 'Schwelm',
    postalCode: '58332'
  },
  {
    municipality: 'Schwendi',
    postalCode: '88477'
  },
  {
    municipality: 'Schwenningen',
    postalCode: '89443'
  },
  {
    municipality: 'Schwenningen',
    postalCode: '72477'
  },
  {
    municipality: 'Schwentinental',
    postalCode: '24222'
  },
  {
    municipality: 'Schwentinental',
    postalCode: '24223'
  },
  {
    municipality: 'Schwepnitz',
    postalCode: '01936'
  },
  {
    municipality: 'Schweppenhausen',
    postalCode: '55444'
  },
  {
    municipality: 'Schwerbach',
    postalCode: '55624'
  },
  {
    municipality: 'Schwerin',
    postalCode: '19053'
  },
  {
    municipality: 'Schwerin',
    postalCode: '19055'
  },
  {
    municipality: 'Schwerin',
    postalCode: '19057'
  },
  {
    municipality: 'Schwerin',
    postalCode: '19059'
  },
  {
    municipality: 'Schwerin',
    postalCode: '19061'
  },
  {
    municipality: 'Schwerin',
    postalCode: '19063'
  },
  {
    municipality: 'Schwerin',
    postalCode: '15755'
  },
  {
    municipality: 'Schweringen',
    postalCode: '27324'
  },
  {
    municipality: 'Schweringen',
    postalCode: '27333'
  },
  {
    municipality: 'Schwerinsdorf',
    postalCode: '26835'
  },
  {
    municipality: 'Schwerstedt',
    postalCode: '99634'
  },
  {
    municipality: 'Schwerte',
    postalCode: '58239'
  },
  {
    municipality: 'Schwesing',
    postalCode: '25813'
  },
  {
    municipality: 'Schwetzingen',
    postalCode: '68723'
  },
  {
    municipality: 'Schwieberdingen',
    postalCode: '71701'
  },
  {
    municipality: 'Schwieberdingen',
    postalCode: '71706'
  },
  {
    municipality: 'Schwielochsee',
    postalCode: '15913'
  },
  {
    municipality: 'Schwielowsee',
    postalCode: '14548'
  },
  {
    municipality: 'Schwienau',
    postalCode: '29593'
  },
  {
    municipality: 'Schwifting',
    postalCode: '86940'
  },
  {
    municipality: 'Schwindegg',
    postalCode: '84419'
  },
  {
    municipality: 'Schwirzheim',
    postalCode: '54597'
  },
  {
    municipality: 'Schwissel',
    postalCode: '23795'
  },
  {
    municipality: 'Schwobfeld',
    postalCode: '37318'
  },
  {
    municipality: 'Schwollen',
    postalCode: '55767'
  },
  {
    municipality: 'Schwörstadt',
    postalCode: '79739'
  },
  {
    municipality: 'Schwülper',
    postalCode: '38179'
  },
  {
    municipality: 'Sebnitz',
    postalCode: '01855'
  },
  {
    municipality: 'Seck',
    postalCode: '56479'
  },
  {
    municipality: 'Seckach',
    postalCode: '74743'
  },
  {
    municipality: 'Seddiner See',
    postalCode: '14554'
  },
  {
    municipality: 'Seebach',
    postalCode: '77889'
  },
  {
    municipality: 'Seebach',
    postalCode: '99846'
  },
  {
    municipality: 'Seeblick',
    postalCode: '14715'
  },
  {
    municipality: 'Seeburg',
    postalCode: '37136'
  },
  {
    municipality: 'Seedorf',
    postalCode: '23823'
  },
  {
    municipality: 'Seedorf',
    postalCode: '27404'
  },
  {
    municipality: 'Seedorf',
    postalCode: '23883'
  },
  {
    municipality: 'Seefeld',
    postalCode: '25557'
  },
  {
    municipality: 'Seefeld',
    postalCode: '82229'
  },
  {
    municipality: 'Seeg',
    postalCode: '87637'
  },
  {
    municipality: 'Seegebiet Mansfelder Land',
    postalCode: '06317'
  },
  {
    municipality: 'Seehausen',
    postalCode: '39615'
  },
  {
    municipality: 'Seehausen am Staffelsee',
    postalCode: '82418'
  },
  {
    municipality: 'Seeheim-Jugenheim',
    postalCode: '64342'
  },
  {
    municipality: 'Seehof',
    postalCode: '19069'
  },
  {
    municipality: 'Seekirch',
    postalCode: '88422'
  },
  {
    municipality: 'Seeland',
    postalCode: '06449'
  },
  {
    municipality: 'Seeland',
    postalCode: '06464'
  },
  {
    municipality: 'Seeland',
    postalCode: '06466'
  },
  {
    municipality: 'Seeland',
    postalCode: '06467'
  },
  {
    municipality: 'Seeland',
    postalCode: '06469'
  },
  {
    municipality: 'Seelbach',
    postalCode: '77960'
  },
  {
    municipality: 'Seelbach',
    postalCode: '56377'
  },
  {
    municipality: 'Seelbach bei Hamm (Sieg)',
    postalCode: '57577'
  },
  {
    municipality: 'Seelbach (Westerwald)',
    postalCode: '57632'
  },
  {
    municipality: 'Seelen',
    postalCode: '67744'
  },
  {
    municipality: 'Seelingstädt',
    postalCode: '07580'
  },
  {
    municipality: 'Seelitz',
    postalCode: '09306'
  },
  {
    municipality: 'Seelow',
    postalCode: '15306'
  },
  {
    municipality: 'Seelze',
    postalCode: '30926'
  },
  {
    municipality: 'Seeon-Seebruck',
    postalCode: '83358'
  },
  {
    municipality: 'Seeon-Seebruck',
    postalCode: '83370'
  },
  {
    municipality: 'Seeon-Seebruck',
    postalCode: '83376'
  },
  {
    municipality: 'Seesbach',
    postalCode: '55629'
  },
  {
    municipality: 'Seesen',
    postalCode: '38723'
  },
  {
    municipality: 'Seeshaupt',
    postalCode: '82402'
  },
  {
    municipality: 'Seester',
    postalCode: '25370'
  },
  {
    municipality: 'Seestermühe',
    postalCode: '25371'
  },
  {
    municipality: 'Seeth',
    postalCode: '25840'
  },
  {
    municipality: 'Seeth',
    postalCode: '25878'
  },
  {
    municipality: 'Seeth-Ekholt',
    postalCode: '25337'
  },
  {
    municipality: 'Seevetal',
    postalCode: '21217'
  },
  {
    municipality: 'Seevetal',
    postalCode: '21218'
  },
  {
    municipality: 'Seevetal',
    postalCode: '21220'
  },
  {
    municipality: 'Seewald',
    postalCode: '72297'
  },
  {
    municipality: 'Seffern',
    postalCode: '54636'
  },
  {
    municipality: 'Sefferweich',
    postalCode: '54636'
  },
  {
    municipality: 'Seggebruch',
    postalCode: '31691'
  },
  {
    municipality: 'Segnitz',
    postalCode: '97340'
  },
  {
    municipality: 'Sehestedt',
    postalCode: '24814'
  },
  {
    municipality: 'Sehlde',
    postalCode: '38279'
  },
  {
    municipality: 'Sehlem',
    postalCode: '54518'
  },
  {
    municipality: 'Sehlen',
    postalCode: '18528'
  },
  {
    municipality: 'Sehmatal',
    postalCode: '09465'
  },
  {
    municipality: 'Sehnde',
    postalCode: '31319'
  },
  {
    municipality: 'Seibersbach',
    postalCode: '55444'
  },
  {
    municipality: 'Seifen',
    postalCode: '57632'
  },
  {
    municipality: 'Seiffen/Erzgebirge',
    postalCode: '09548'
  },
  {
    municipality: 'Seifhennersdorf',
    postalCode: '02782'
  },
  {
    municipality: 'Seinsfeld',
    postalCode: '54655'
  },
  {
    municipality: 'Seinsheim',
    postalCode: '97342'
  },
  {
    municipality: 'Seisla',
    postalCode: '07389'
  },
  {
    municipality: 'Seitenroda',
    postalCode: '07768'
  },
  {
    municipality: 'Seitingen-Oberflacht',
    postalCode: '78606'
  },
  {
    municipality: 'Seiwerath',
    postalCode: '54597'
  },
  {
    municipality: 'Selb',
    postalCode: '95100'
  },
  {
    municipality: 'Selbach (Sieg)',
    postalCode: '57537'
  },
  {
    municipality: 'Selbitz',
    postalCode: '95152'
  },
  {
    municipality: 'Selchenbach',
    postalCode: '66871'
  },
  {
    municipality: 'Selent',
    postalCode: '24238'
  },
  {
    municipality: 'Selfkant',
    postalCode: '52538'
  },
  {
    municipality: 'Seligenstadt',
    postalCode: '63500'
  },
  {
    municipality: 'Selk',
    postalCode: '24884'
  },
  {
    municipality: 'Selke-Aue',
    postalCode: '06458'
  },
  {
    municipality: 'Sellerich',
    postalCode: '54608'
  },
  {
    municipality: 'Sellin',
    postalCode: '18586'
  },
  {
    municipality: 'Selm',
    postalCode: '59379'
  },
  {
    municipality: 'Selmsdorf',
    postalCode: '23923'
  },
  {
    municipality: 'Selpin',
    postalCode: '18195'
  },
  {
    municipality: 'Selsingen',
    postalCode: '27446'
  },
  {
    municipality: 'Selters (Taunus)',
    postalCode: '65618'
  },
  {
    municipality: 'Selters (Westerwald)',
    postalCode: '56242'
  },
  {
    municipality: 'Selzen',
    postalCode: '55278'
  },
  {
    municipality: 'Sembach',
    postalCode: '67681'
  },
  {
    municipality: 'Semlow',
    postalCode: '18334'
  },
  {
    municipality: 'Senden',
    postalCode: '48308'
  },
  {
    municipality: 'Senden',
    postalCode: '89250'
  },
  {
    municipality: 'Sendenhorst',
    postalCode: '48324'
  },
  {
    municipality: 'Senftenberg',
    postalCode: '01945'
  },
  {
    municipality: 'Senftenberg',
    postalCode: '01968'
  },
  {
    municipality: 'Senftenberg',
    postalCode: '01996'
  },
  {
    municipality: 'Sengenthal',
    postalCode: '92369'
  },
  {
    municipality: 'Sengerich',
    postalCode: '54619'
  },
  {
    municipality: 'Senheim',
    postalCode: '56820'
  },
  {
    municipality: 'Sennfeld',
    postalCode: '97526'
  },
  {
    municipality: 'Senscheid',
    postalCode: '53520'
  },
  {
    municipality: 'Sensweiler',
    postalCode: '55758'
  },
  {
    municipality: 'Serba',
    postalCode: '07616'
  },
  {
    municipality: 'Serrig',
    postalCode: '54455'
  },
  {
    municipality: 'Sersheim',
    postalCode: '74372'
  },
  {
    municipality: 'Sessenbach',
    postalCode: '56237'
  },
  {
    municipality: 'Sessenhausen',
    postalCode: '56244'
  },
  {
    municipality: 'Seßlach',
    postalCode: '96145'
  },
  {
    municipality: 'Seth',
    postalCode: '23845'
  },
  {
    municipality: 'Setzingen',
    postalCode: '89129'
  },
  {
    municipality: 'Seubersdorf in der Oberpfalz',
    postalCode: '92358'
  },
  {
    municipality: 'Seukendorf',
    postalCode: '90556'
  },
  {
    municipality: 'Seulingen',
    postalCode: '37136'
  },
  {
    municipality: 'Sevenig bei Neuerburg',
    postalCode: '54673'
  },
  {
    municipality: 'Sevenig (Our)',
    postalCode: '54617'
  },
  {
    municipality: 'Sexau',
    postalCode: '79350'
  },
  {
    municipality: 'Seybothenreuth',
    postalCode: '95517'
  },
  {
    municipality: 'Sibbesse',
    postalCode: '31079'
  },
  {
    municipality: 'Sickerode',
    postalCode: '37308'
  },
  {
    municipality: 'Sickte',
    postalCode: '38173'
  },
  {
    municipality: 'Siebeldingen',
    postalCode: '76833'
  },
  {
    municipality: 'Siebenbach',
    postalCode: '56729'
  },
  {
    municipality: 'Siebenbäumen',
    postalCode: '23847'
  },
  {
    municipality: 'Siebeneichen',
    postalCode: '21514'
  },
  {
    municipality: 'Siedenbollentin',
    postalCode: '17089'
  },
  {
    municipality: 'Siedenbrünzow',
    postalCode: '17111'
  },
  {
    municipality: 'Siedenburg',
    postalCode: '27254'
  },
  {
    municipality: 'Siefersheim',
    postalCode: '55599'
  },
  {
    municipality: 'Siegbach',
    postalCode: '35768'
  },
  {
    municipality: 'Siegburg',
    postalCode: '53721'
  },
  {
    municipality: 'Siegelsbach',
    postalCode: '74936'
  },
  {
    municipality: 'Siegen',
    postalCode: '57072'
  },
  {
    municipality: 'Siegen',
    postalCode: '57074'
  },
  {
    municipality: 'Siegen',
    postalCode: '57076'
  },
  {
    municipality: 'Siegen',
    postalCode: '57078'
  },
  {
    municipality: 'Siegen',
    postalCode: '57080'
  },
  {
    municipality: 'Siegenburg',
    postalCode: '93354'
  },
  {
    municipality: 'Siegsdorf',
    postalCode: '83313'
  },
  {
    municipality: 'Siehdichum',
    postalCode: '15890'
  },
  {
    municipality: 'Siek',
    postalCode: '22962'
  },
  {
    municipality: 'Sielenbach',
    postalCode: '86577'
  },
  {
    municipality: 'Siemz-Niendorf',
    postalCode: '23923'
  },
  {
    municipality: 'Sien',
    postalCode: '55758'
  },
  {
    municipality: 'Sienhachenbach',
    postalCode: '55758'
  },
  {
    municipality: 'Sierksdorf',
    postalCode: '23730'
  },
  {
    municipality: 'Sierksrade',
    postalCode: '23847'
  },
  {
    municipality: 'Sierscheid',
    postalCode: '53520'
  },
  {
    municipality: 'Siershahn',
    postalCode: '56427'
  },
  {
    municipality: 'Siesbach',
    postalCode: '55767'
  },
  {
    municipality: 'Sietow',
    postalCode: '17209'
  },
  {
    municipality: 'Sieversdorf-Hohenofen',
    postalCode: '16845'
  },
  {
    municipality: 'Sievershütten',
    postalCode: '24641'
  },
  {
    municipality: 'Sieverstedt',
    postalCode: '24885'
  },
  {
    municipality: 'Siggelkow',
    postalCode: '19376'
  },
  {
    municipality: 'Sigmaringen',
    postalCode: '72488'
  },
  {
    municipality: 'Sigmaringendorf',
    postalCode: '72517'
  },
  {
    municipality: 'Sigmarszell',
    postalCode: '88138'
  },
  {
    municipality: 'Silberstedt',
    postalCode: '24887'
  },
  {
    municipality: 'Silbitz',
    postalCode: '07613'
  },
  {
    municipality: 'Silz',
    postalCode: '76857'
  },
  {
    municipality: 'Silz',
    postalCode: '17214'
  },
  {
    municipality: 'Silzen',
    postalCode: '25551'
  },
  {
    municipality: 'Simbach',
    postalCode: '84359'
  },
  {
    municipality: 'Simbach',
    postalCode: '94436'
  },
  {
    municipality: 'Simmelsdorf',
    postalCode: '91245'
  },
  {
    municipality: 'Simmerath',
    postalCode: '52152'
  },
  {
    municipality: 'Simmern',
    postalCode: '56337'
  },
  {
    municipality: 'Simmern/Hunsrück',
    postalCode: '55469'
  },
  {
    municipality: 'Simmersfeld',
    postalCode: '72226'
  },
  {
    municipality: 'Simmershofen',
    postalCode: '97215'
  },
  {
    municipality: 'Simmertal',
    postalCode: '55618'
  },
  {
    municipality: 'Simmozheim',
    postalCode: '75397'
  },
  {
    municipality: 'Simonsberg',
    postalCode: '25813'
  },
  {
    municipality: 'Simonswald',
    postalCode: '79263'
  },
  {
    municipality: 'Simonswald',
    postalCode: '79271'
  },
  {
    municipality: 'Sindelfingen',
    postalCode: '71063'
  },
  {
    municipality: 'Sindelfingen',
    postalCode: '71065'
  },
  {
    municipality: 'Sindelfingen',
    postalCode: '71067'
  },
  {
    municipality: 'Sindelfingen',
    postalCode: '71069'
  },
  {
    municipality: 'Sindelsdorf',
    postalCode: '82404'
  },
  {
    municipality: 'Singen (Hohentwiel)',
    postalCode: '78224'
  },
  {
    municipality: 'Singhofen',
    postalCode: '56379'
  },
  {
    municipality: 'Sinn',
    postalCode: '35764'
  },
  {
    municipality: 'Sinntal',
    postalCode: '36391'
  },
  {
    municipality: 'Sinsheim',
    postalCode: '74889'
  },
  {
    municipality: 'Sinspelt',
    postalCode: '54675'
  },
  {
    municipality: 'Sinzheim',
    postalCode: '76547'
  },
  {
    municipality: 'Sinzig',
    postalCode: '53489'
  },
  {
    municipality: 'Sinzing',
    postalCode: '93161'
  },
  {
    municipality: 'Sippersfeld',
    postalCode: '67729'
  },
  {
    municipality: 'Sipplingen',
    postalCode: '78354'
  },
  {
    municipality: 'Sirksfelde',
    postalCode: '23898'
  },
  {
    municipality: 'Sittensen',
    postalCode: '27419'
  },
  {
    municipality: 'Sitters',
    postalCode: '67823'
  },
  {
    municipality: 'Sitzendorf',
    postalCode: '07429'
  },
  {
    municipality: 'Söchtenau',
    postalCode: '83139'
  },
  {
    municipality: 'Soderstorf',
    postalCode: '21388'
  },
  {
    municipality: 'Soest',
    postalCode: '59494'
  },
  {
    municipality: 'Sögel',
    postalCode: '49751'
  },
  {
    municipality: 'Sohland an der Spree',
    postalCode: '02689'
  },
  {
    municipality: 'Söhlde',
    postalCode: '31185'
  },
  {
    municipality: 'Sohren',
    postalCode: '55487'
  },
  {
    municipality: 'Söhrewald',
    postalCode: '34320'
  },
  {
    municipality: 'Sohrschied',
    postalCode: '55487'
  },
  {
    municipality: 'Sölden',
    postalCode: '79294'
  },
  {
    municipality: 'Solingen',
    postalCode: '42651'
  },
  {
    municipality: 'Solingen',
    postalCode: '42653'
  },
  {
    municipality: 'Solingen',
    postalCode: '42655'
  },
  {
    municipality: 'Solingen',
    postalCode: '42657'
  },
  {
    municipality: 'Solingen',
    postalCode: '42659'
  },
  {
    municipality: 'Solingen',
    postalCode: '42697'
  },
  {
    municipality: 'Solingen',
    postalCode: '42699'
  },
  {
    municipality: 'Solingen',
    postalCode: '42719'
  },
  {
    municipality: 'Solkwitz',
    postalCode: '07381'
  },
  {
    municipality: 'Sollerup',
    postalCode: '24852'
  },
  {
    municipality: 'Söllingen',
    postalCode: '38387'
  },
  {
    municipality: 'Sollstedt',
    postalCode: '99759'
  },
  {
    municipality: 'Sollwitt',
    postalCode: '25884'
  },
  {
    municipality: 'Solms',
    postalCode: '35606'
  },
  {
    municipality: 'Solnhofen',
    postalCode: '91807'
  },
  {
    municipality: 'Soltau',
    postalCode: '29614'
  },
  {
    municipality: 'Soltendieck',
    postalCode: '29594'
  },
  {
    municipality: 'Sommerach',
    postalCode: '97334'
  },
  {
    municipality: 'Sommerau',
    postalCode: '54317'
  },
  {
    municipality: 'Sömmerda',
    postalCode: '99610'
  },
  {
    municipality: 'Sömmerda',
    postalCode: '99625'
  },
  {
    municipality: 'Sommerhausen',
    postalCode: '97286'
  },
  {
    municipality: 'Sommerkahl',
    postalCode: '63825'
  },
  {
    municipality: 'Sommerland',
    postalCode: '25358'
  },
  {
    municipality: 'Sommerloch',
    postalCode: '55595'
  },
  {
    municipality: 'Sommersdorf',
    postalCode: '39365'
  },
  {
    municipality: 'Sommersdorf',
    postalCode: '17111'
  },
  {
    municipality: 'Sonderhofen',
    postalCode: '97255'
  },
  {
    municipality: 'Sondershausen',
    postalCode: '99706'
  },
  {
    municipality: 'Sondheim v.d.Rhön',
    postalCode: '97647'
  },
  {
    municipality: 'Sonneberg',
    postalCode: '96515'
  },
  {
    municipality: 'Sonneborn',
    postalCode: '99869'
  },
  {
    municipality: 'Sönnebüll',
    postalCode: '25821'
  },
  {
    municipality: 'Sonnefeld',
    postalCode: '96242'
  },
  {
    municipality: 'Sonnen',
    postalCode: '94164'
  },
  {
    municipality: 'Sonnenberg',
    postalCode: '16775'
  },
  {
    municipality: 'Sonnenberg-Winnenberg',
    postalCode: '55767'
  },
  {
    municipality: 'Sonnenbühl',
    postalCode: '72820'
  },
  {
    municipality: 'Sonnenstein',
    postalCode: '37345'
  },
  {
    municipality: 'Sonnewalde',
    postalCode: '03249'
  },
  {
    municipality: 'Sonnschied',
    postalCode: '55758'
  },
  {
    municipality: 'Sonsbeck',
    postalCode: '47665'
  },
  {
    municipality: 'Sontheim',
    postalCode: '87776'
  },
  {
    municipality: 'Sontheim an der Brenz',
    postalCode: '89567'
  },
  {
    municipality: 'Sonthofen',
    postalCode: '87527'
  },
  {
    municipality: 'Sontra',
    postalCode: '36205'
  },
  {
    municipality: 'Sophienhamm',
    postalCode: '24806'
  },
  {
    municipality: 'Sören',
    postalCode: '24241'
  },
  {
    municipality: 'Sörgenloch',
    postalCode: '55270'
  },
  {
    municipality: 'Sörth',
    postalCode: '57636'
  },
  {
    municipality: 'Sörup',
    postalCode: '24966'
  },
  {
    municipality: 'Sosberg',
    postalCode: '56858'
  },
  {
    municipality: 'Sottrum',
    postalCode: '27367'
  },
  {
    municipality: 'Soyen',
    postalCode: '83564'
  },
  {
    municipality: 'Spabrücken',
    postalCode: '55595'
  },
  {
    municipality: 'Spahnharrenstätte',
    postalCode: '49751'
  },
  {
    municipality: 'Spaichingen',
    postalCode: '78549'
  },
  {
    municipality: 'Spall',
    postalCode: '55595'
  },
  {
    municipality: 'Spalt',
    postalCode: '91174'
  },
  {
    municipality: 'Spangdahlem',
    postalCode: '54529'
  },
  {
    municipality: 'Spangenberg',
    postalCode: '34286'
  },
  {
    municipality: 'Spantekow',
    postalCode: '17391'
  },
  {
    municipality: 'Spantekow',
    postalCode: '17392'
  },
  {
    municipality: 'Spardorf',
    postalCode: '91080'
  },
  {
    municipality: 'Sparneck',
    postalCode: '95234'
  },
  {
    municipality: 'Spatzenhausen',
    postalCode: '82418'
  },
  {
    municipality: 'Spatzenhausen',
    postalCode: '82447'
  },
  {
    municipality: 'Spay',
    postalCode: '56322'
  },
  {
    municipality: 'Spechbach',
    postalCode: '74937'
  },
  {
    municipality: 'Speicher',
    postalCode: '54662'
  },
  {
    municipality: 'Speichersdorf',
    postalCode: '95469'
  },
  {
    municipality: 'Speinshart',
    postalCode: '92676'
  },
  {
    municipality: 'Spelle',
    postalCode: '48480'
  },
  {
    municipality: 'Spenge',
    postalCode: '32139'
  },
  {
    municipality: 'Spesenroth',
    postalCode: '56288'
  },
  {
    municipality: 'Spessart',
    postalCode: '56746'
  },
  {
    municipality: 'Speyer',
    postalCode: '67346'
  },
  {
    municipality: 'Spiegelau',
    postalCode: '94518'
  },
  {
    municipality: 'Spiegelberg',
    postalCode: '71579'
  },
  {
    municipality: 'Spiekeroog',
    postalCode: '26474'
  },
  {
    municipality: 'Spiesen-Elversberg',
    postalCode: '66583'
  },
  {
    municipality: 'Spiesheim',
    postalCode: '55288'
  },
  {
    municipality: 'Spirkelbach',
    postalCode: '76848'
  },
  {
    municipality: 'Splietsdorf',
    postalCode: '18513'
  },
  {
    municipality: 'Sponheim',
    postalCode: '55595'
  },
  {
    municipality: 'Sponholz',
    postalCode: '17039'
  },
  {
    municipality: 'Spornitz',
    postalCode: '19372'
  },
  {
    municipality: 'Spraitbach',
    postalCode: '73565'
  },
  {
    municipality: 'Spraitbach',
    postalCode: '73568'
  },
  {
    municipality: 'Spraitbach',
    postalCode: '73577'
  },
  {
    municipality: 'Sprakebüll',
    postalCode: '25917'
  },
  {
    municipality: 'Sprakensehl',
    postalCode: '29365'
  },
  {
    municipality: 'Spreenhagen',
    postalCode: '15528'
  },
  {
    municipality: 'Spreetal - Sprjewiny Doł',
    postalCode: '02979'
  },
  {
    municipality: 'Spreewaldheide',
    postalCode: '15913'
  },
  {
    municipality: 'Spremberg',
    postalCode: '03130'
  },
  {
    municipality: 'Sprendlingen',
    postalCode: '55576'
  },
  {
    municipality: 'Springe',
    postalCode: '31832'
  },
  {
    municipality: 'Sprockhövel',
    postalCode: '45549'
  },
  {
    municipality: 'Sprötau',
    postalCode: '99610'
  },
  {
    municipality: 'Stäbelow',
    postalCode: '18198'
  },
  {
    municipality: 'Stade',
    postalCode: '21680'
  },
  {
    municipality: 'Stade',
    postalCode: '21682'
  },
  {
    municipality: 'Stade',
    postalCode: '21683'
  },
  {
    municipality: 'Stade',
    postalCode: '21684'
  },
  {
    municipality: 'Stadecken-Elsheim',
    postalCode: '55271'
  },
  {
    municipality: 'Stadelhofen',
    postalCode: '96187'
  },
  {
    municipality: 'Stadland',
    postalCode: '26935'
  },
  {
    municipality: 'Stadland',
    postalCode: '26936'
  },
  {
    municipality: 'Stadland',
    postalCode: '26937'
  },
  {
    municipality: 'Stadlern',
    postalCode: '92549'
  },
  {
    municipality: 'Stadtallendorf',
    postalCode: '35260'
  },
  {
    municipality: 'Stadtbergen',
    postalCode: '86391'
  },
  {
    municipality: 'Stadthagen',
    postalCode: '31655'
  },
  {
    municipality: 'Stadtilm',
    postalCode: '99326'
  },
  {
    municipality: 'Stadtkyll',
    postalCode: '54589'
  },
  {
    municipality: 'Stadtlauringen',
    postalCode: '97488'
  },
  {
    municipality: 'Stadtlohn',
    postalCode: '48703'
  },
  {
    municipality: 'Stadtoldendorf',
    postalCode: '37627'
  },
  {
    municipality: 'Stadtprozelten',
    postalCode: '97909'
  },
  {
    municipality: 'Stadtroda',
    postalCode: '07646'
  },
  {
    municipality: 'Stadtsteinach',
    postalCode: '95346'
  },
  {
    municipality: 'Stadum',
    postalCode: '25917'
  },
  {
    municipality: 'Staffhorst',
    postalCode: '27254'
  },
  {
    municipality: 'Stafstedt',
    postalCode: '24816'
  },
  {
    municipality: 'Stahlberg',
    postalCode: '67808'
  },
  {
    municipality: 'Stahlhofen',
    postalCode: '56412'
  },
  {
    municipality: 'Stahlhofen am Wiesensee',
    postalCode: '56459'
  },
  {
    municipality: 'Stahnsdorf',
    postalCode: '14532'
  },
  {
    municipality: 'Staig',
    postalCode: '89195'
  },
  {
    municipality: 'Stakendorf',
    postalCode: '24217'
  },
  {
    municipality: 'Stallwang',
    postalCode: '94375'
  },
  {
    municipality: 'Stammbach',
    postalCode: '95236'
  },
  {
    municipality: 'Stammham',
    postalCode: '84533'
  },
  {
    municipality: 'Stammham',
    postalCode: '85092'
  },
  {
    municipality: 'Stammham',
    postalCode: '85134'
  },
  {
    municipality: 'Stamsried',
    postalCode: '93491'
  },
  {
    municipality: 'Standenbühl',
    postalCode: '67816'
  },
  {
    municipality: 'Stangheck',
    postalCode: '24395'
  },
  {
    municipality: 'Stapel',
    postalCode: '25879'
  },
  {
    municipality: 'Stapelfeld',
    postalCode: '22145'
  },
  {
    municipality: 'Starkenberg',
    postalCode: '04617'
  },
  {
    municipality: 'Starkenburg',
    postalCode: '56843'
  },
  {
    municipality: 'Starnberg',
    postalCode: '82319'
  },
  {
    municipality: 'Starzach',
    postalCode: '72181'
  },
  {
    municipality: 'Staßfurt',
    postalCode: '39418'
  },
  {
    municipality: 'Staßfurt',
    postalCode: '39443'
  },
  {
    municipality: 'Staßfurt',
    postalCode: '39446'
  },
  {
    municipality: 'Stauchitz',
    postalCode: '01594'
  },
  {
    municipality: 'Staudach-Egerndach',
    postalCode: '83224'
  },
  {
    municipality: 'Staudernheim',
    postalCode: '55568'
  },
  {
    municipality: 'Staudt',
    postalCode: '56424'
  },
  {
    municipality: 'Staufenberg',
    postalCode: '35460'
  },
  {
    municipality: 'Staufenberg',
    postalCode: '34355'
  },
  {
    municipality: 'Staufen im Breisgau',
    postalCode: '79219'
  },
  {
    municipality: 'Staven',
    postalCode: '17039'
  },
  {
    municipality: 'Stavenhagen',
    postalCode: '17153'
  },
  {
    municipality: 'Stavern',
    postalCode: '49777'
  },
  {
    municipality: 'St. Blasien',
    postalCode: '79837'
  },
  {
    municipality: 'Stebach',
    postalCode: '56276'
  },
  {
    municipality: 'Stechlin',
    postalCode: '16775'
  },
  {
    municipality: 'Stechow-Ferchesar',
    postalCode: '14715'
  },
  {
    municipality: 'Stedesand',
    postalCode: '25920'
  },
  {
    municipality: 'Stedesdorf',
    postalCode: '26427'
  },
  {
    municipality: 'Steenfeld',
    postalCode: '25557'
  },
  {
    municipality: 'Steffeln',
    postalCode: '54597'
  },
  {
    municipality: 'Steffenberg',
    postalCode: '35239'
  },
  {
    municipality: 'Steffenshagen',
    postalCode: '18209'
  },
  {
    municipality: 'Stegaurach',
    postalCode: '96135'
  },
  {
    municipality: 'Stegen',
    postalCode: '79252'
  },
  {
    municipality: 'St. Egidien',
    postalCode: '09356'
  },
  {
    municipality: 'Steigra',
    postalCode: '06268'
  },
  {
    municipality: 'Steimbke',
    postalCode: '31634'
  },
  {
    municipality: 'Steimel',
    postalCode: '57614'
  },
  {
    municipality: 'Stein',
    postalCode: '24235'
  },
  {
    municipality: 'Stein',
    postalCode: '90547'
  },
  {
    municipality: 'Steina',
    postalCode: '01920'
  },
  {
    municipality: 'Steinach',
    postalCode: '77790'
  },
  {
    municipality: 'Steinach',
    postalCode: '94377'
  },
  {
    municipality: 'Steinach',
    postalCode: '96523'
  },
  {
    municipality: 'Steinalben',
    postalCode: '66851'
  },
  {
    municipality: 'Steinau',
    postalCode: '21775'
  },
  {
    municipality: 'Steinau an der Straße',
    postalCode: '36396'
  },
  {
    municipality: 'Steinbach',
    postalCode: '61449'
  },
  {
    municipality: 'Steinbach',
    postalCode: '56291'
  },
  {
    municipality: 'Steinbach',
    postalCode: '37308'
  },
  {
    municipality: 'Steinbach am Donnersberg',
    postalCode: '67808'
  },
  {
    municipality: 'Steinbach am Glan',
    postalCode: '66909'
  },
  {
    municipality: 'Steinbach am Wald',
    postalCode: '96361'
  },
  {
    municipality: 'Steinbach-Hallenberg',
    postalCode: '98587'
  },
  {
    municipality: 'Steinberg',
    postalCode: '08237'
  },
  {
    municipality: 'Steinberg',
    postalCode: '24972'
  },
  {
    municipality: 'Steinberg am See',
    postalCode: '92449'
  },
  {
    municipality: 'Steinbergkirche',
    postalCode: '24972'
  },
  {
    municipality: 'Stein-Bockenheim',
    postalCode: '55599'
  },
  {
    municipality: 'Steinborn',
    postalCode: '54655'
  },
  {
    municipality: 'Steinburg',
    postalCode: '22964'
  },
  {
    municipality: 'Steindorf',
    postalCode: '82297'
  },
  {
    municipality: 'Steinebach an der Wied',
    postalCode: '57629'
  },
  {
    municipality: 'Steinebach/Sieg',
    postalCode: '57520'
  },
  {
    municipality: 'Steineberg',
    postalCode: '54552'
  },
  {
    municipality: 'Steinefrenz',
    postalCode: '56414'
  },
  {
    municipality: 'Steinen',
    postalCode: '56244'
  },
  {
    municipality: 'Steinen',
    postalCode: '79585'
  },
  {
    municipality: 'Steinenbronn',
    postalCode: '71144'
  },
  {
    municipality: 'Steineroth',
    postalCode: '57518'
  },
  {
    municipality: 'Steinfeld',
    postalCode: '97854'
  },
  {
    municipality: 'Steinfeld',
    postalCode: '24888'
  },
  {
    municipality: 'Steinfeld',
    postalCode: '76889'
  },
  {
    municipality: 'Steinfeld',
    postalCode: '49439'
  },
  {
    municipality: 'Steinfurt',
    postalCode: '48565'
  },
  {
    municipality: 'Steingaden',
    postalCode: '86989'
  },
  {
    municipality: 'Steinhagen',
    postalCode: '33803'
  },
  {
    municipality: 'Steinhagen',
    postalCode: '18442'
  },
  {
    municipality: 'Steinhagen',
    postalCode: '18246'
  },
  {
    municipality: 'Steinhausen an der Rottum',
    postalCode: '88416'
  },
  {
    municipality: 'Steinheim',
    postalCode: '32839'
  },
  {
    municipality: 'Steinheim am Albuch',
    postalCode: '73566'
  },
  {
    municipality: 'Steinheim am Albuch',
    postalCode: '89555'
  },
  {
    municipality: 'Steinheim an der Murr',
    postalCode: '71711'
  },
  {
    municipality: 'Steinheuterode',
    postalCode: '37318'
  },
  {
    municipality: 'Steinhöfel',
    postalCode: '15518'
  },
  {
    municipality: 'Steinhöring',
    postalCode: '85643'
  },
  {
    municipality: 'Steinhorst',
    postalCode: '29367'
  },
  {
    municipality: 'Steinhorst',
    postalCode: '23847'
  },
  {
    municipality: 'Steinigtwolmsdorf',
    postalCode: '01904'
  },
  {
    municipality: 'Steiningen',
    postalCode: '54552'
  },
  {
    municipality: 'Steinkirchen',
    postalCode: '21720'
  },
  {
    municipality: 'Steinkirchen',
    postalCode: '84439'
  },
  {
    municipality: 'Steinmauern',
    postalCode: '76479'
  },
  {
    municipality: 'Stein-Neukirch',
    postalCode: '56479'
  },
  {
    municipality: 'Steinreich',
    postalCode: '15938'
  },
  {
    municipality: 'Steinsberg',
    postalCode: '56379'
  },
  {
    municipality: 'Steinsfeld',
    postalCode: '91628'
  },
  {
    municipality: 'Steinweiler',
    postalCode: '76872'
  },
  {
    municipality: 'Steinwenden',
    postalCode: '66879'
  },
  {
    municipality: 'Steinwiesen',
    postalCode: '96349'
  },
  {
    municipality: 'Stein-Wingert',
    postalCode: '57629'
  },
  {
    municipality: 'Steißlingen',
    postalCode: '78256'
  },
  {
    municipality: 'Stelle',
    postalCode: '21435'
  },
  {
    municipality: 'Stelle-Wittenwurth',
    postalCode: '25795'
  },
  {
    municipality: 'Stelzenberg',
    postalCode: '67705'
  },
  {
    municipality: 'Stemmen',
    postalCode: '27389'
  },
  {
    municipality: 'Stemshorn',
    postalCode: '49448'
  },
  {
    municipality: 'Stemwede',
    postalCode: '32351'
  },
  {
    municipality: 'Stendal',
    postalCode: '39576'
  },
  {
    municipality: 'Stepenitztal',
    postalCode: '23936'
  },
  {
    municipality: 'Stephanskirchen',
    postalCode: '83071'
  },
  {
    municipality: 'Stephansposching',
    postalCode: '94569'
  },
  {
    municipality: 'Sterley',
    postalCode: '23883'
  },
  {
    municipality: 'Sternberg',
    postalCode: '19406'
  },
  {
    municipality: 'Sternenfels',
    postalCode: '75447'
  },
  {
    municipality: 'Sterup',
    postalCode: '24996'
  },
  {
    municipality: 'Stetten',
    postalCode: '87778'
  },
  {
    municipality: 'Stetten',
    postalCode: '67294'
  },
  {
    municipality: 'Stetten',
    postalCode: '88719'
  },
  {
    municipality: 'Stetten am kalten Markt',
    postalCode: '72510'
  },
  {
    municipality: 'Stettfeld',
    postalCode: '96188'
  },
  {
    municipality: 'Steyerberg',
    postalCode: '31595'
  },
  {
    municipality: 'St. Gangloff',
    postalCode: '07629'
  },
  {
    municipality: 'St. Georgen im Schwarzwald',
    postalCode: '78112'
  },
  {
    municipality: 'Stiefenhofen',
    postalCode: '88167'
  },
  {
    municipality: 'Stimpfach',
    postalCode: '74597'
  },
  {
    municipality: 'Stinstedt',
    postalCode: '21772'
  },
  {
    municipality: 'Stipsdorf',
    postalCode: '23795'
  },
  {
    municipality: 'Stipshausen',
    postalCode: '55758'
  },
  {
    municipality: 'St. Johann',
    postalCode: '72813'
  },
  {
    municipality: 'St. Leon-Rot',
    postalCode: '68789'
  },
  {
    municipality: 'St. Märgen',
    postalCode: '79274'
  },
  {
    municipality: 'Stockach',
    postalCode: '78333'
  },
  {
    municipality: 'Stockelsdorf',
    postalCode: '23617'
  },
  {
    municipality: 'Stockem',
    postalCode: '54646'
  },
  {
    municipality: 'Stockhausen-Illfurth',
    postalCode: '56472'
  },
  {
    municipality: 'Stockheim',
    postalCode: '97640'
  },
  {
    municipality: 'Stockheim',
    postalCode: '96342'
  },
  {
    municipality: 'Stöckse',
    postalCode: '31638'
  },
  {
    municipality: 'Stocksee',
    postalCode: '24326'
  },
  {
    municipality: 'Stockstadt',
    postalCode: '64589'
  },
  {
    municipality: 'Stockstadt am Main',
    postalCode: '63811'
  },
  {
    municipality: 'Stockum-Püschen',
    postalCode: '56459'
  },
  {
    municipality: 'Stödtlen',
    postalCode: '73495'
  },
  {
    municipality: 'Stoetze',
    postalCode: '29597'
  },
  {
    municipality: 'Stolberg',
    postalCode: '52222'
  },
  {
    municipality: 'Stolberg',
    postalCode: '52223'
  },
  {
    municipality: 'Stolberg',
    postalCode: '52224'
  },
  {
    municipality: 'Stolk',
    postalCode: '24890'
  },
  {
    municipality: 'Stollberg/Erzgebirge',
    postalCode: '09366'
  },
  {
    municipality: 'Stolpe',
    postalCode: '24601'
  },
  {
    municipality: 'Stolpe',
    postalCode: '19372'
  },
  {
    municipality: 'Stolpe an der Peene',
    postalCode: '17391'
  },
  {
    municipality: 'Stolpe auf Usedom',
    postalCode: '17406'
  },
  {
    municipality: 'Stolpen',
    postalCode: '01833'
  },
  {
    municipality: 'Stoltebüll',
    postalCode: '24409'
  },
  {
    municipality: 'Stoltenberg',
    postalCode: '24256'
  },
  {
    municipality: 'Stolzenau',
    postalCode: '31592'
  },
  {
    municipality: 'Storbeck-Frankendorf',
    postalCode: '16818'
  },
  {
    municipality: 'Stördorf',
    postalCode: '25554'
  },
  {
    municipality: 'Störkathen',
    postalCode: '25548'
  },
  {
    municipality: 'Storkow (Mark)',
    postalCode: '15859'
  },
  {
    municipality: 'Störnstein',
    postalCode: '92721'
  },
  {
    municipality: 'Stößen',
    postalCode: '06667'
  },
  {
    municipality: 'Stötten a.Auerberg',
    postalCode: '87675'
  },
  {
    municipality: 'Stöttwang',
    postalCode: '87677'
  },
  {
    municipality: 'Straelen',
    postalCode: '47638'
  },
  {
    municipality: 'Strahlungen',
    postalCode: '97618'
  },
  {
    municipality: 'Stralendorf',
    postalCode: '19073'
  },
  {
    municipality: 'Stralsund',
    postalCode: '18435'
  },
  {
    municipality: 'Stralsund',
    postalCode: '18437'
  },
  {
    municipality: 'Stralsund',
    postalCode: '18439'
  },
  {
    municipality: 'Strande',
    postalCode: '24229'
  },
  {
    municipality: 'Strasburg (Uckermark)',
    postalCode: '17335'
  },
  {
    municipality: 'Straßberg',
    postalCode: '72479'
  },
  {
    municipality: 'Straßenhaus',
    postalCode: '56587'
  },
  {
    municipality: 'Straßkirchen',
    postalCode: '94342'
  },
  {
    municipality: 'Straßlach-Dingharting',
    postalCode: '82064'
  },
  {
    municipality: 'Straubenhardt',
    postalCode: '75334'
  },
  {
    municipality: 'Straubing',
    postalCode: '94315'
  },
  {
    municipality: 'Straufhain',
    postalCode: '98646'
  },
  {
    municipality: 'Straupitz (Spreewald)',
    postalCode: '15913'
  },
  {
    municipality: 'Strausberg',
    postalCode: '15344'
  },
  {
    municipality: 'Straußfurt',
    postalCode: '99634'
  },
  {
    municipality: 'Strehla',
    postalCode: '01616'
  },
  {
    municipality: 'Streithausen',
    postalCode: '57629'
  },
  {
    municipality: 'Strickscheid',
    postalCode: '54597'
  },
  {
    municipality: 'Striegistal',
    postalCode: '09661'
  },
  {
    municipality: 'Strohkirchen',
    postalCode: '19230'
  },
  {
    municipality: 'Strohn',
    postalCode: '54558'
  },
  {
    municipality: 'Stromberg',
    postalCode: '55442'
  },
  {
    municipality: 'Strotzbüsch',
    postalCode: '54552'
  },
  {
    municipality: 'Strübbel',
    postalCode: '25792'
  },
  {
    municipality: 'Struckum',
    postalCode: '25821'
  },
  {
    municipality: 'Strukdorf',
    postalCode: '23815'
  },
  {
    municipality: 'Strullendorf',
    postalCode: '96129'
  },
  {
    municipality: 'Struppen',
    postalCode: '01796'
  },
  {
    municipality: 'Strüth',
    postalCode: '56357'
  },
  {
    municipality: 'Struvenhütten',
    postalCode: '24643'
  },
  {
    municipality: 'Struxdorf',
    postalCode: '24891'
  },
  {
    municipality: 'Stubben',
    postalCode: '23847'
  },
  {
    municipality: 'Stubbendorf',
    postalCode: '18195'
  },
  {
    municipality: 'Stubenberg',
    postalCode: '94166'
  },
  {
    municipality: 'Stüdenitz-Schönermark',
    postalCode: '16845'
  },
  {
    municipality: 'Stuer',
    postalCode: '17209'
  },
  {
    municipality: 'Stühlingen',
    postalCode: '79780'
  },
  {
    municipality: 'Stuhr',
    postalCode: '28816'
  },
  {
    municipality: 'Stulln',
    postalCode: '92551'
  },
  {
    municipality: 'Stürzelbach',
    postalCode: '57614'
  },
  {
    municipality: 'Stutensee',
    postalCode: '76297'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70173'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70174'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70176'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70178'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70180'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70182'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70184'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70186'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70188'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70190'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70191'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70192'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70193'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70195'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70197'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70199'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70327'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70329'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70372'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70374'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70376'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70378'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70435'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70437'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70439'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70469'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70499'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70563'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70565'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70567'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70569'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70597'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70599'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70619'
  },
  {
    municipality: 'Stuttgart',
    postalCode: '70629'
  },
  {
    municipality: 'Stützengrün',
    postalCode: '08328'
  },
  {
    municipality: 'Stuvenborn',
    postalCode: '24641'
  },
  {
    municipality: 'Südbrookmerland',
    postalCode: '26624'
  },
  {
    municipality: 'Südbrookmerland',
    postalCode: '26759'
  },
  {
    municipality: 'Südeichsfeld',
    postalCode: '99976'
  },
  {
    municipality: 'Südeichsfeld',
    postalCode: '99988'
  },
  {
    municipality: 'Süderau',
    postalCode: '25361'
  },
  {
    municipality: 'Süderbrarup',
    postalCode: '24392'
  },
  {
    municipality: 'Suderburg',
    postalCode: '29556'
  },
  {
    municipality: 'Süderdeich',
    postalCode: '25764'
  },
  {
    municipality: 'Süderdorf',
    postalCode: '25782'
  },
  {
    municipality: 'Süderende',
    postalCode: '25938'
  },
  {
    municipality: 'Süderfahrenstedt',
    postalCode: '24890'
  },
  {
    municipality: 'Südergellersen',
    postalCode: '21394'
  },
  {
    municipality: 'Süderhackstedt',
    postalCode: '24852'
  },
  {
    municipality: 'Süderhackstedt',
    postalCode: '24992'
  },
  {
    municipality: 'Süderhastedt',
    postalCode: '25727'
  },
  {
    municipality: 'Süderheistedt',
    postalCode: '25779'
  },
  {
    municipality: 'Süderhöft',
    postalCode: '25876'
  },
  {
    municipality: 'Süderholz',
    postalCode: '18516'
  },
  {
    municipality: 'Süderlügum',
    postalCode: '25923'
  },
  {
    municipality: 'Südermarsch',
    postalCode: '25813'
  },
  {
    municipality: 'Südermarsch',
    postalCode: '25840'
  },
  {
    municipality: 'Südharz',
    postalCode: '06536'
  },
  {
    municipality: 'Südheide',
    postalCode: '29303'
  },
  {
    municipality: 'Südheide',
    postalCode: '29320'
  },
  {
    municipality: 'Südheide',
    postalCode: '29345'
  },
  {
    municipality: 'Südliches Anhalt',
    postalCode: '06369'
  },
  {
    municipality: 'Südliches Anhalt',
    postalCode: '06386'
  },
  {
    municipality: 'Südliches Anhalt',
    postalCode: '06388'
  },
  {
    municipality: 'Südlohn',
    postalCode: '46354'
  },
  {
    municipality: 'Südmüritz',
    postalCode: '17207'
  },
  {
    municipality: 'Sudwalde',
    postalCode: '27257'
  },
  {
    municipality: 'Sugenheim',
    postalCode: '91438'
  },
  {
    municipality: 'Sugenheim',
    postalCode: '91484'
  },
  {
    municipality: 'Suhl',
    postalCode: '98527'
  },
  {
    municipality: 'Suhl',
    postalCode: '98528'
  },
  {
    municipality: 'Suhl',
    postalCode: '98529'
  },
  {
    municipality: 'Suhlendorf',
    postalCode: '29562'
  },
  {
    municipality: 'Sukow',
    postalCode: '19079'
  },
  {
    municipality: 'Sukow-Levitzow',
    postalCode: '17168'
  },
  {
    municipality: 'Sülfeld',
    postalCode: '23845'
  },
  {
    municipality: 'Sülfeld',
    postalCode: '23867'
  },
  {
    municipality: 'Sulingen',
    postalCode: '27232'
  },
  {
    municipality: 'Sülm',
    postalCode: '54636'
  },
  {
    municipality: 'Sülstorf',
    postalCode: '19077'
  },
  {
    municipality: 'Sulza',
    postalCode: '07751'
  },
  {
    municipality: 'Sulz am Neckar',
    postalCode: '72172'
  },
  {
    municipality: 'Sulzbach',
    postalCode: '65843'
  },
  {
    municipality: 'Sulzbach',
    postalCode: '56379'
  },
  {
    municipality: 'Sulzbach',
    postalCode: '55758'
  },
  {
    municipality: 'Sulzbach am Main',
    postalCode: '63834'
  },
  {
    municipality: 'Sulzbach an der Murr',
    postalCode: '71560'
  },
  {
    municipality: 'Sulzbach-Laufen',
    postalCode: '74429'
  },
  {
    municipality: 'Sulzbach-Rosenberg',
    postalCode: '92237'
  },
  {
    municipality: 'Sulzbach/Saar',
    postalCode: '66280'
  },
  {
    municipality: 'Sulzbachtal',
    postalCode: '67734'
  },
  {
    municipality: 'Sulzberg',
    postalCode: '87477'
  },
  {
    municipality: 'Sulzburg',
    postalCode: '79295'
  },
  {
    municipality: 'Sulzdorf a.d.Lederhecke',
    postalCode: '97528'
  },
  {
    municipality: 'Sulzemoos',
    postalCode: '85254'
  },
  {
    municipality: 'Sulzemoos',
    postalCode: '85259'
  },
  {
    municipality: 'Sülzetal',
    postalCode: '39171'
  },
  {
    municipality: 'Sulzfeld',
    postalCode: '97633'
  },
  {
    municipality: 'Sulzfeld',
    postalCode: '75056'
  },
  {
    municipality: 'Sülzfeld',
    postalCode: '98617'
  },
  {
    municipality: 'Sulzfeld am Main',
    postalCode: '97320'
  },
  {
    municipality: 'Sulzheim',
    postalCode: '97529'
  },
  {
    municipality: 'Sulzheim',
    postalCode: '55286'
  },
  {
    municipality: 'Sulzthal',
    postalCode: '97717'
  },
  {
    municipality: 'Sünching',
    postalCode: '93104'
  },
  {
    municipality: 'Sundern',
    postalCode: '59846'
  },
  {
    municipality: 'Sundhagen',
    postalCode: '18519'
  },
  {
    municipality: 'Sundhausen',
    postalCode: '99947'
  },
  {
    municipality: 'Süpplingen',
    postalCode: '38373'
  },
  {
    municipality: 'Süpplingenburg',
    postalCode: '38376'
  },
  {
    municipality: 'Surberg',
    postalCode: '83362'
  },
  {
    municipality: 'Surwold',
    postalCode: '26903'
  },
  {
    municipality: 'Süsel',
    postalCode: '23701'
  },
  {
    municipality: 'Süßen',
    postalCode: '73079'
  },
  {
    municipality: 'Sustrum',
    postalCode: '49762'
  },
  {
    municipality: 'Suthfeld',
    postalCode: '31555'
  },
  {
    municipality: 'Swisttal',
    postalCode: '53913'
  },
  {
    municipality: 'Sydower Fließ',
    postalCode: '16230'
  },
  {
    municipality: 'Syke',
    postalCode: '28857'
  },
  {
    municipality: 'Sylt',
    postalCode: '25980'
  },
  {
    municipality: 'Syrgenstein',
    postalCode: '89428'
  },
  {
    municipality: 'Taarstedt',
    postalCode: '24893'
  },
  {
    municipality: 'Taben-Rodt',
    postalCode: '54441'
  },
  {
    municipality: 'Tacherting',
    postalCode: '83342'
  },
  {
    municipality: 'Taching am See',
    postalCode: '83373'
  },
  {
    municipality: 'Tackesdorf',
    postalCode: '24797'
  },
  {
    municipality: 'Tackesdorf',
    postalCode: '25585'
  },
  {
    municipality: 'Täferrot',
    postalCode: '73527'
  },
  {
    municipality: 'Tagmersheim',
    postalCode: '86704'
  },
  {
    municipality: 'Talheim',
    postalCode: '74388'
  },
  {
    municipality: 'Talheim',
    postalCode: '78607'
  },
  {
    municipality: 'Talkau',
    postalCode: '21493'
  },
  {
    municipality: 'Talling',
    postalCode: '54426'
  },
  {
    municipality: 'Tambach-Dietharz',
    postalCode: '99897'
  },
  {
    municipality: 'Tamm',
    postalCode: '71732'
  },
  {
    municipality: 'Tangerhütte',
    postalCode: '39517'
  },
  {
    municipality: 'Tangerhütte',
    postalCode: '39579'
  },
  {
    municipality: 'Tangermünde',
    postalCode: '39590'
  },
  {
    municipality: 'Tangstedt',
    postalCode: '25499'
  },
  {
    municipality: 'Tangstedt',
    postalCode: '22889'
  },
  {
    municipality: 'Tann',
    postalCode: '84367'
  },
  {
    municipality: 'Tanna',
    postalCode: '07922'
  },
  {
    municipality: 'Tannenberg',
    postalCode: '09468'
  },
  {
    municipality: 'Tännesberg',
    postalCode: '92723'
  },
  {
    municipality: 'Tannhausen',
    postalCode: '73497'
  },
  {
    municipality: 'Tannheim',
    postalCode: '88459'
  },
  {
    municipality: 'Tann (Rhön)',
    postalCode: '36142'
  },
  {
    municipality: 'Tantow',
    postalCode: '16307'
  },
  {
    municipality: 'Tapfheim',
    postalCode: '86660'
  },
  {
    municipality: 'Tappenbeck',
    postalCode: '38479'
  },
  {
    municipality: 'Tappendorf',
    postalCode: '24594'
  },
  {
    municipality: 'Tarbek',
    postalCode: '24619'
  },
  {
    municipality: 'Tarmstedt',
    postalCode: '27412'
  },
  {
    municipality: 'Tarnow',
    postalCode: '18249'
  },
  {
    municipality: 'Tarp',
    postalCode: '24963'
  },
  {
    municipality: 'Tasdorf',
    postalCode: '24536'
  },
  {
    municipality: 'Tastrup',
    postalCode: '24943'
  },
  {
    municipality: 'Tastungen',
    postalCode: '37339'
  },
  {
    municipality: 'Tating',
    postalCode: '25881'
  },
  {
    municipality: 'Tauberbischofsheim',
    postalCode: '97941'
  },
  {
    municipality: 'Tauberrettersheim',
    postalCode: '97285'
  },
  {
    municipality: 'Taucha',
    postalCode: '04425'
  },
  {
    municipality: 'Tauche',
    postalCode: '15848'
  },
  {
    municipality: 'Tauer',
    postalCode: '03185'
  },
  {
    municipality: 'Taufkirchen',
    postalCode: '82024'
  },
  {
    municipality: 'Taufkirchen',
    postalCode: '84416'
  },
  {
    municipality: 'Taufkirchen',
    postalCode: '84574'
  },
  {
    municipality: 'Taunusstein',
    postalCode: '65232'
  },
  {
    municipality: 'Taura',
    postalCode: '09249'
  },
  {
    municipality: 'Tautenburg',
    postalCode: '07778'
  },
  {
    municipality: 'Tautendorf',
    postalCode: '07646'
  },
  {
    municipality: 'Tautenhain',
    postalCode: '07639'
  },
  {
    municipality: 'Tawern',
    postalCode: '54456'
  },
  {
    municipality: 'Techelsdorf',
    postalCode: '24220'
  },
  {
    municipality: 'Techentin',
    postalCode: '19399'
  },
  {
    municipality: 'Tecklenburg',
    postalCode: '49545'
  },
  {
    municipality: 'Tegau',
    postalCode: '07907'
  },
  {
    municipality: 'Tegernheim',
    postalCode: '93105'
  },
  {
    municipality: 'Tegernsee',
    postalCode: '83684'
  },
  {
    municipality: 'Teichland',
    postalCode: '03185'
  },
  {
    municipality: 'Teichwitz',
    postalCode: '07570'
  },
  {
    municipality: 'Teisendorf',
    postalCode: '83317'
  },
  {
    municipality: 'Teisendorf',
    postalCode: '83364'
  },
  {
    municipality: 'Teising',
    postalCode: '84576'
  },
  {
    municipality: 'Teisnach',
    postalCode: '94244'
  },
  {
    municipality: 'Teistungen',
    postalCode: '37339'
  },
  {
    municipality: 'Teldau',
    postalCode: '19273'
  },
  {
    municipality: 'Telgte',
    postalCode: '48291'
  },
  {
    municipality: 'Tellig',
    postalCode: '56858'
  },
  {
    municipality: 'Tellingstedt',
    postalCode: '25782'
  },
  {
    municipality: 'Teltow',
    postalCode: '14513'
  },
  {
    municipality: 'Temmels',
    postalCode: '54441'
  },
  {
    municipality: 'Temmen-Ringenwalde',
    postalCode: '17268'
  },
  {
    municipality: 'Temnitzquell',
    postalCode: '16818'
  },
  {
    municipality: 'Temnitztal',
    postalCode: '16845'
  },
  {
    municipality: 'Templin',
    postalCode: '17268'
  },
  {
    municipality: 'Tengen',
    postalCode: '78250'
  },
  {
    municipality: 'Teningen',
    postalCode: '79312'
  },
  {
    municipality: 'Teningen',
    postalCode: '79331'
  },
  {
    municipality: 'Tensbüttel-Röst',
    postalCode: '25767'
  },
  {
    municipality: 'Tensfeld',
    postalCode: '23824'
  },
  {
    municipality: 'Teschenmoschel',
    postalCode: '67806'
  },
  {
    municipality: 'Tespe',
    postalCode: '21395'
  },
  {
    municipality: 'Tessin',
    postalCode: '18195'
  },
  {
    municipality: 'Tessin b. Boizenburg',
    postalCode: '19258'
  },
  {
    municipality: 'Testorf-Steinfort',
    postalCode: '23936'
  },
  {
    municipality: 'Tetenbüll',
    postalCode: '25882'
  },
  {
    municipality: 'Tetenhusen',
    postalCode: '24817'
  },
  {
    municipality: 'Teterow',
    postalCode: '17166'
  },
  {
    municipality: 'Tettau',
    postalCode: '96355'
  },
  {
    municipality: 'Tettau',
    postalCode: '01945'
  },
  {
    municipality: 'Tettenweis',
    postalCode: '94167'
  },
  {
    municipality: 'Tettnang',
    postalCode: '88069'
  },
  {
    municipality: 'Tettnang',
    postalCode: '88079'
  },
  {
    municipality: 'Teublitz',
    postalCode: '93158'
  },
  {
    municipality: 'Teuchern',
    postalCode: '06682'
  },
  {
    municipality: 'Teugn',
    postalCode: '93356'
  },
  {
    municipality: 'Teunz',
    postalCode: '92552'
  },
  {
    municipality: 'Teupitz',
    postalCode: '15755'
  },
  {
    municipality: 'Teuschnitz',
    postalCode: '96358'
  },
  {
    municipality: 'Teutschenthal',
    postalCode: '06179'
  },
  {
    municipality: 'Thaden',
    postalCode: '25557'
  },
  {
    municipality: 'Thaining',
    postalCode: '86943'
  },
  {
    municipality: 'Thale',
    postalCode: '06502'
  },
  {
    municipality: 'Thaleischweiler-Fröschen',
    postalCode: '66987'
  },
  {
    municipality: 'Thalfang',
    postalCode: '54424'
  },
  {
    municipality: 'Thalhausen',
    postalCode: '56584'
  },
  {
    municipality: 'Thalheim/Erzgebirge',
    postalCode: '09380'
  },
  {
    municipality: 'Thallichtenberg',
    postalCode: '66871'
  },
  {
    municipality: 'Thallwitz',
    postalCode: '04808'
  },
  {
    municipality: 'Thalmassing',
    postalCode: '93107'
  },
  {
    municipality: 'Thalmässing',
    postalCode: '91177'
  },
  {
    municipality: 'Thalwenden',
    postalCode: '37318'
  },
  {
    municipality: 'Thandorf',
    postalCode: '19217'
  },
  {
    municipality: 'Thannhausen',
    postalCode: '86470'
  },
  {
    municipality: 'Thanstein',
    postalCode: '92554'
  },
  {
    municipality: 'Tharandt',
    postalCode: '01737'
  },
  {
    municipality: 'Thedinghausen',
    postalCode: '27321'
  },
  {
    municipality: 'Theilenhofen',
    postalCode: '91741'
  },
  {
    municipality: 'Theilheim',
    postalCode: '97288'
  },
  {
    municipality: 'Theisbergstegen',
    postalCode: '66871'
  },
  {
    municipality: 'Theisseil',
    postalCode: '92637'
  },
  {
    municipality: 'Thelkow',
    postalCode: '18195'
  },
  {
    municipality: 'Themar',
    postalCode: '98660'
  },
  {
    municipality: 'Theres',
    postalCode: '97531'
  },
  {
    municipality: 'Thermalbad Wiesenbad',
    postalCode: '09488'
  },
  {
    municipality: 'Theuma',
    postalCode: '08541'
  },
  {
    municipality: 'Thiendorf',
    postalCode: '01561'
  },
  {
    municipality: 'Thierhaupten',
    postalCode: '86672'
  },
  {
    municipality: 'Thierschneck',
    postalCode: '07774'
  },
  {
    municipality: 'Thiersheim',
    postalCode: '95707'
  },
  {
    municipality: 'Thierstein',
    postalCode: '95199'
  },
  {
    municipality: 'Tholey',
    postalCode: '66636'
  },
  {
    municipality: 'Thomasburg',
    postalCode: '21401'
  },
  {
    municipality: 'Thomm',
    postalCode: '54317'
  },
  {
    municipality: 'Thonhausen',
    postalCode: '04626'
  },
  {
    municipality: 'Thörlingen',
    postalCode: '56291'
  },
  {
    municipality: 'Thörnich',
    postalCode: '54340'
  },
  {
    municipality: 'Thuine',
    postalCode: '49832'
  },
  {
    municipality: 'Thulendorf',
    postalCode: '18184'
  },
  {
    municipality: 'Thum',
    postalCode: '09419'
  },
  {
    municipality: 'Thumby',
    postalCode: '24351'
  },
  {
    municipality: 'Thundorf i.UFr.',
    postalCode: '97711'
  },
  {
    municipality: 'Thüngen',
    postalCode: '97289'
  },
  {
    municipality: 'Thüngersheim',
    postalCode: '97291'
  },
  {
    municipality: 'Thür',
    postalCode: '56743'
  },
  {
    municipality: 'Thürkow',
    postalCode: '17168'
  },
  {
    municipality: 'Thurmansbang',
    postalCode: '94169'
  },
  {
    municipality: 'Thurnau',
    postalCode: '95349'
  },
  {
    municipality: 'Thyrnau',
    postalCode: '94136'
  },
  {
    municipality: 'Tiddische',
    postalCode: '38473'
  },
  {
    municipality: 'Tiefenbach',
    postalCode: '84184'
  },
  {
    municipality: 'Tiefenbach',
    postalCode: '94113'
  },
  {
    municipality: 'Tiefenbach',
    postalCode: '93464'
  },
  {
    municipality: 'Tiefenbach',
    postalCode: '55471'
  },
  {
    municipality: 'Tiefenbach',
    postalCode: '88422'
  },
  {
    municipality: 'Tiefenbronn',
    postalCode: '75233'
  },
  {
    municipality: 'Tiefenthal',
    postalCode: '55546'
  },
  {
    municipality: 'Tiefenthal',
    postalCode: '67311'
  },
  {
    municipality: 'Tielen',
    postalCode: '24803'
  },
  {
    municipality: 'Tielenhemme',
    postalCode: '25794'
  },
  {
    municipality: 'Timmaspe',
    postalCode: '24644'
  },
  {
    municipality: 'Timmendorfer Strand',
    postalCode: '23669'
  },
  {
    municipality: 'Tinningstedt',
    postalCode: '25917'
  },
  {
    municipality: 'Tirpersdorf',
    postalCode: '08606'
  },
  {
    municipality: 'Tirschenreuth',
    postalCode: '95643'
  },
  {
    municipality: 'Tissa',
    postalCode: '07646'
  },
  {
    municipality: 'Tiste',
    postalCode: '27419'
  },
  {
    municipality: 'Titisee-Neustadt',
    postalCode: '79822'
  },
  {
    municipality: 'Titting',
    postalCode: '85135'
  },
  {
    municipality: 'Tittling',
    postalCode: '94104'
  },
  {
    municipality: 'Tittmoning',
    postalCode: '84529'
  },
  {
    municipality: 'Titz',
    postalCode: '52445'
  },
  {
    municipality: 'Toddin',
    postalCode: '19230'
  },
  {
    municipality: 'Todenbüttel',
    postalCode: '24819'
  },
  {
    municipality: 'Todendorf',
    postalCode: '22965'
  },
  {
    municipality: 'Todenroth',
    postalCode: '55481'
  },
  {
    municipality: 'Todesfelde',
    postalCode: '23826'
  },
  {
    municipality: 'Todtenweis',
    postalCode: '86447'
  },
  {
    municipality: 'Todtmoos',
    postalCode: '79682'
  },
  {
    municipality: 'Todtnau',
    postalCode: '79674'
  },
  {
    municipality: 'Töging am Inn',
    postalCode: '84513'
  },
  {
    municipality: 'Tolk',
    postalCode: '24894'
  },
  {
    municipality: 'Tömmelsdorf',
    postalCode: '07819'
  },
  {
    municipality: 'Tönisvorst',
    postalCode: '47918'
  },
  {
    municipality: 'Tonna',
    postalCode: '99958'
  },
  {
    municipality: 'Tonndorf',
    postalCode: '99438'
  },
  {
    municipality: 'Tönning',
    postalCode: '25832'
  },
  {
    municipality: 'Töpen',
    postalCode: '95183'
  },
  {
    municipality: 'Topfstedt',
    postalCode: '99718'
  },
  {
    municipality: 'Toppenstedt',
    postalCode: '21442'
  },
  {
    municipality: 'Torgau',
    postalCode: '04860'
  },
  {
    municipality: 'Torgau',
    postalCode: '04861'
  },
  {
    municipality: 'Torgelow',
    postalCode: '17358'
  },
  {
    municipality: 'Torgelow am See',
    postalCode: '17192'
  },
  {
    municipality: 'Tornesch',
    postalCode: '25436'
  },
  {
    municipality: 'Tostedt',
    postalCode: '21255'
  },
  {
    municipality: 'Tosterglope',
    postalCode: '21371'
  },
  {
    municipality: 'Tottleben',
    postalCode: '99947'
  },
  {
    municipality: 'Traben-Trarbach',
    postalCode: '56841'
  },
  {
    municipality: 'Trabitz',
    postalCode: '92724'
  },
  {
    municipality: 'Train',
    postalCode: '93358'
  },
  {
    municipality: 'Traisen',
    postalCode: '55595'
  },
  {
    municipality: 'Traitsching',
    postalCode: '93455'
  },
  {
    municipality: 'Tramm',
    postalCode: '19089'
  },
  {
    municipality: 'Tramm',
    postalCode: '21516'
  },
  {
    municipality: 'Trappenkamp',
    postalCode: '24610'
  },
  {
    municipality: 'Trappstadt',
    postalCode: '97633'
  },
  {
    municipality: 'Trassem',
    postalCode: '54441'
  },
  {
    municipality: 'Trassenheide',
    postalCode: '17449'
  },
  {
    municipality: 'Traunreut',
    postalCode: '83301'
  },
  {
    municipality: 'Traunreut',
    postalCode: '83368'
  },
  {
    municipality: 'Traunreut',
    postalCode: '83371'
  },
  {
    municipality: 'Traunreut',
    postalCode: '83374'
  },
  {
    municipality: 'Traunstein',
    postalCode: '83278'
  },
  {
    municipality: 'Trausnitz',
    postalCode: '92555'
  },
  {
    municipality: 'Trautskirchen',
    postalCode: '90619'
  },
  {
    municipality: 'Travenbrück',
    postalCode: '23843'
  },
  {
    municipality: 'Travenhorst',
    postalCode: '23827'
  },
  {
    municipality: 'Traventhal',
    postalCode: '23795'
  },
  {
    municipality: 'Trebbin',
    postalCode: '14959'
  },
  {
    municipality: 'Trebel',
    postalCode: '29494'
  },
  {
    municipality: 'Treben',
    postalCode: '04617'
  },
  {
    municipality: 'Trebendorf - Trjebin',
    postalCode: '02959'
  },
  {
    municipality: 'Trebgast',
    postalCode: '95367'
  },
  {
    municipality: 'Trebra',
    postalCode: '99718'
  },
  {
    municipality: 'Trebsen/Mulde',
    postalCode: '04687'
  },
  {
    municipality: 'Trebur',
    postalCode: '65468'
  },
  {
    municipality: 'Trechtingshausen',
    postalCode: '55413'
  },
  {
    municipality: 'Treffelstein',
    postalCode: '93492'
  },
  {
    municipality: 'Treffurt',
    postalCode: '99830'
  },
  {
    municipality: 'Treia',
    postalCode: '24896'
  },
  {
    municipality: 'Treis-Karden',
    postalCode: '56253'
  },
  {
    municipality: 'Tremsbüttel',
    postalCode: '22967'
  },
  {
    municipality: 'Trendelburg',
    postalCode: '34388'
  },
  {
    municipality: 'Trennewurth',
    postalCode: '25693'
  },
  {
    municipality: 'Trent',
    postalCode: '18569'
  },
  {
    municipality: 'Treplin',
    postalCode: '15236'
  },
  {
    municipality: 'Treuchtlingen',
    postalCode: '91757'
  },
  {
    municipality: 'Treuen',
    postalCode: '08233'
  },
  {
    municipality: 'Treuenbrietzen',
    postalCode: '14929'
  },
  {
    municipality: 'Triberg im Schwarzwald',
    postalCode: '78098'
  },
  {
    municipality: 'Tribsees',
    postalCode: '18465'
  },
  {
    municipality: 'Triebel',
    postalCode: '08606'
  },
  {
    municipality: 'Triefenstein',
    postalCode: '97855'
  },
  {
    municipality: 'Trier',
    postalCode: '54290'
  },
  {
    municipality: 'Trier',
    postalCode: '54292'
  },
  {
    municipality: 'Trier',
    postalCode: '54293'
  },
  {
    municipality: 'Trier',
    postalCode: '54294'
  },
  {
    municipality: 'Trier',
    postalCode: '54295'
  },
  {
    municipality: 'Trier',
    postalCode: '54296'
  },
  {
    municipality: 'Trierscheid',
    postalCode: '53520'
  },
  {
    municipality: 'Trierweiler',
    postalCode: '54311'
  },
  {
    municipality: 'Triftern',
    postalCode: '84371'
  },
  {
    municipality: 'Triglitz',
    postalCode: '16949'
  },
  {
    municipality: 'Trimbs',
    postalCode: '56753'
  },
  {
    municipality: 'Trimport',
    postalCode: '54636'
  },
  {
    municipality: 'Trinwillershagen',
    postalCode: '18320'
  },
  {
    municipality: 'Trippstadt',
    postalCode: '67705'
  },
  {
    municipality: 'Triptis',
    postalCode: '07819'
  },
  {
    municipality: 'Trittau',
    postalCode: '22946'
  },
  {
    municipality: 'Trittenheim',
    postalCode: '54349'
  },
  {
    municipality: 'Tröbitz',
    postalCode: '03253'
  },
  {
    municipality: 'Tröbnitz',
    postalCode: '07646'
  },
  {
    municipality: 'Tröchtelborn',
    postalCode: '99869'
  },
  {
    municipality: 'Trochtelfingen',
    postalCode: '72818'
  },
  {
    municipality: 'Trockenborn-Wolfersdorf',
    postalCode: '07646'
  },
  {
    municipality: 'Trogen',
    postalCode: '95183'
  },
  {
    municipality: 'Troisdorf',
    postalCode: '53840'
  },
  {
    municipality: 'Troisdorf',
    postalCode: '53842'
  },
  {
    municipality: 'Troisdorf',
    postalCode: '53844'
  },
  {
    municipality: 'Trollenhagen',
    postalCode: '17039'
  },
  {
    municipality: 'Tröndel',
    postalCode: '24321'
  },
  {
    municipality: 'Trossin',
    postalCode: '04880'
  },
  {
    municipality: 'Trossingen',
    postalCode: '78647'
  },
  {
    municipality: 'Tröstau',
    postalCode: '95709'
  },
  {
    municipality: 'Trostberg',
    postalCode: '83308'
  },
  {
    municipality: 'Trulben',
    postalCode: '66957'
  },
  {
    municipality: 'Trunkelsberg',
    postalCode: '87779'
  },
  {
    municipality: 'Tschernitz',
    postalCode: '03130'
  },
  {
    municipality: 'Tschirn',
    postalCode: '96367'
  },
  {
    municipality: 'Tübingen',
    postalCode: '72070'
  },
  {
    municipality: 'Tübingen',
    postalCode: '72072'
  },
  {
    municipality: 'Tübingen',
    postalCode: '72074'
  },
  {
    municipality: 'Tübingen',
    postalCode: '72076'
  },
  {
    municipality: 'Tuchenbach',
    postalCode: '90587'
  },
  {
    municipality: 'Tülau',
    postalCode: '38474'
  },
  {
    municipality: 'Tümlauer Koog',
    postalCode: '25881'
  },
  {
    municipality: 'Tunau',
    postalCode: '79677'
  },
  {
    municipality: 'Tuningen',
    postalCode: '78609'
  },
  {
    municipality: 'Tuntenhausen',
    postalCode: '83104'
  },
  {
    municipality: 'Türkenfeld',
    postalCode: '82299'
  },
  {
    municipality: 'Türkheim',
    postalCode: '86842'
  },
  {
    municipality: 'Turnow-Preilack',
    postalCode: '03185'
  },
  {
    municipality: 'Tussenhausen',
    postalCode: '86874'
  },
  {
    municipality: 'Tüßling',
    postalCode: '84577'
  },
  {
    municipality: 'Tutow',
    postalCode: '17129'
  },
  {
    municipality: 'Tüttendorf',
    postalCode: '24214'
  },
  {
    municipality: 'Tüttleben',
    postalCode: '99869'
  },
  {
    municipality: 'Tuttlingen',
    postalCode: '78532'
  },
  {
    municipality: 'Tutzing',
    postalCode: '82327'
  },
  {
    municipality: 'Tützpatz',
    postalCode: '17091'
  },
  {
    municipality: 'Twedt',
    postalCode: '24894'
  },
  {
    municipality: 'Twist',
    postalCode: '49767'
  },
  {
    municipality: 'Twistetal',
    postalCode: '34477'
  },
  {
    municipality: 'Twistringen',
    postalCode: '27239'
  },
  {
    municipality: 'Tyrlaching',
    postalCode: '84558'
  },
  {
    municipality: 'Übach-Palenberg',
    postalCode: '52531'
  },
  {
    municipality: 'Übereisenbach',
    postalCode: '54689'
  },
  {
    municipality: 'Überherrn',
    postalCode: '66802'
  },
  {
    municipality: 'Überlingen',
    postalCode: '88662'
  },
  {
    municipality: 'Übersee',
    postalCode: '83236'
  },
  {
    municipality: 'Ubstadt-Weiher',
    postalCode: '76698'
  },
  {
    municipality: 'Uchte',
    postalCode: '31600'
  },
  {
    municipality: 'Üchtelhausen',
    postalCode: '97532'
  },
  {
    municipality: 'Uckerfelde',
    postalCode: '17291'
  },
  {
    municipality: 'Ückeritz',
    postalCode: '17459'
  },
  {
    municipality: 'Uckerland',
    postalCode: '17337'
  },
  {
    municipality: 'Udenheim',
    postalCode: '55288'
  },
  {
    municipality: 'Uder',
    postalCode: '37318'
  },
  {
    municipality: 'Üdersdorf',
    postalCode: '54552'
  },
  {
    municipality: 'Udestedt',
    postalCode: '99198'
  },
  {
    municipality: 'Udler',
    postalCode: '54552'
  },
  {
    municipality: 'Uebigau-Wahrenbrück',
    postalCode: '04895'
  },
  {
    municipality: 'Uebigau-Wahrenbrück',
    postalCode: '04924'
  },
  {
    municipality: 'Uebigau-Wahrenbrück',
    postalCode: '04938'
  },
  {
    municipality: 'Ueckermünde',
    postalCode: '17373'
  },
  {
    municipality: 'Uedem',
    postalCode: '47589'
  },
  {
    municipality: 'Uehlfeld',
    postalCode: '91486'
  },
  {
    municipality: 'Uehrde',
    postalCode: '38170'
  },
  {
    municipality: 'Uelitz',
    postalCode: '19077'
  },
  {
    municipality: 'Uelsby',
    postalCode: '24860'
  },
  {
    municipality: 'Uelsen',
    postalCode: '49843'
  },
  {
    municipality: 'Uelversheim',
    postalCode: '55278'
  },
  {
    municipality: 'Uelvesbüll',
    postalCode: '25889'
  },
  {
    municipality: 'Uelzen',
    postalCode: '29525'
  },
  {
    municipality: 'Uersfeld',
    postalCode: '56767'
  },
  {
    municipality: 'Ueß',
    postalCode: '56767'
  },
  {
    municipality: 'Uetersen',
    postalCode: '25436'
  },
  {
    municipality: 'Uettingen',
    postalCode: '97292'
  },
  {
    municipality: 'Uetze',
    postalCode: '31311'
  },
  {
    municipality: 'Uffenheim',
    postalCode: '97215'
  },
  {
    municipality: 'Uffing am Staffelsee',
    postalCode: '82449'
  },
  {
    municipality: 'Uhingen',
    postalCode: '73066'
  },
  {
    municipality: 'Uhldingen-Mühlhofen',
    postalCode: '88690'
  },
  {
    municipality: 'Uhler',
    postalCode: '56290'
  },
  {
    municipality: 'Ühlingen-Birkendorf',
    postalCode: '79777'
  },
  {
    municipality: 'Uhlstädt-Kirchhasel',
    postalCode: '07407'
  },
  {
    municipality: 'Ulm',
    postalCode: '89073'
  },
  {
    municipality: 'Ulm',
    postalCode: '89075'
  },
  {
    municipality: 'Ulm',
    postalCode: '89077'
  },
  {
    municipality: 'Ulm',
    postalCode: '89079'
  },
  {
    municipality: 'Ulm',
    postalCode: '89081'
  },
  {
    municipality: 'Ulm',
    postalCode: '89160'
  },
  {
    municipality: 'Ulmen',
    postalCode: '56766'
  },
  {
    municipality: 'Ulmet',
    postalCode: '66887'
  },
  {
    municipality: 'Ulrichstein',
    postalCode: '35327'
  },
  {
    municipality: 'Ulsnis',
    postalCode: '24897'
  },
  {
    municipality: 'Umkirch',
    postalCode: '79224'
  },
  {
    municipality: 'Ummanz',
    postalCode: '18569'
  },
  {
    municipality: 'Ummendorf',
    postalCode: '39365'
  },
  {
    municipality: 'Ummendorf',
    postalCode: '88444'
  },
  {
    municipality: 'Ummern',
    postalCode: '29369'
  },
  {
    municipality: 'Ummerstadt',
    postalCode: '98663'
  },
  {
    municipality: 'Umpferstedt',
    postalCode: '99441'
  },
  {
    municipality: 'Undeloh',
    postalCode: '21274'
  },
  {
    municipality: 'Undeloh',
    postalCode: '29640'
  },
  {
    municipality: 'Undenheim',
    postalCode: '55278'
  },
  {
    municipality: 'Ungerhausen',
    postalCode: '87781'
  },
  {
    municipality: 'Unkel',
    postalCode: '53572'
  },
  {
    municipality: 'Unkenbach',
    postalCode: '67823'
  },
  {
    municipality: 'Unlingen',
    postalCode: '88527'
  },
  {
    municipality: 'Unna',
    postalCode: '59423'
  },
  {
    municipality: 'Unna',
    postalCode: '59425'
  },
  {
    municipality: 'Unna',
    postalCode: '59427'
  },
  {
    municipality: 'Unnau',
    postalCode: '57648'
  },
  {
    municipality: 'Unsleben',
    postalCode: '97618'
  },
  {
    municipality: 'Unstrut-Hainich',
    postalCode: '99991'
  },
  {
    municipality: 'Unstruttal',
    postalCode: '99974'
  },
  {
    municipality: 'Unstruttal',
    postalCode: '99976'
  },
  {
    municipality: 'Unterammergau',
    postalCode: '82497'
  },
  {
    municipality: 'Unterbodnitz',
    postalCode: '07646'
  },
  {
    municipality: 'Unterbreizbach',
    postalCode: '36414'
  },
  {
    municipality: 'Unterdießen',
    postalCode: '86944'
  },
  {
    municipality: 'Unterdietfurt',
    postalCode: '84339'
  },
  {
    municipality: 'Unteregg',
    postalCode: '87782'
  },
  {
    municipality: 'Untereisesheim',
    postalCode: '74257'
  },
  {
    municipality: 'Unterensingen',
    postalCode: '72669'
  },
  {
    municipality: 'Unterföhring',
    postalCode: '85774'
  },
  {
    municipality: 'Untergriesbach',
    postalCode: '94107'
  },
  {
    municipality: 'Untergruppenbach',
    postalCode: '74199'
  },
  {
    municipality: 'Unterhaching',
    postalCode: '82008'
  },
  {
    municipality: 'Unterjeckenbach',
    postalCode: '67746'
  },
  {
    municipality: 'Unterkirnach',
    postalCode: '78089'
  },
  {
    municipality: 'Unterleinleiter',
    postalCode: '91364'
  },
  {
    municipality: 'Untermarchtal',
    postalCode: '89617'
  },
  {
    municipality: 'Untermaßfeld',
    postalCode: '98617'
  },
  {
    municipality: 'Untermeitingen',
    postalCode: '86836'
  },
  {
    municipality: 'Untermerzbach',
    postalCode: '96190'
  },
  {
    municipality: 'Untermünkheim',
    postalCode: '74547'
  },
  {
    municipality: 'Unterneukirchen',
    postalCode: '84579'
  },
  {
    municipality: 'Unterpleichfeld',
    postalCode: '97294'
  },
  {
    municipality: 'Unterreichenbach',
    postalCode: '75399'
  },
  {
    municipality: 'Unterreit',
    postalCode: '83567'
  },
  {
    municipality: 'Unterroth',
    postalCode: '89299'
  },
  {
    municipality: 'Unterschleißheim',
    postalCode: '85716'
  },
  {
    municipality: 'Unterschneidheim',
    postalCode: '73485'
  },
  {
    municipality: 'Unterschwaningen',
    postalCode: '91743'
  },
  {
    municipality: 'Untershausen',
    postalCode: '56412'
  },
  {
    municipality: 'Untersiemau',
    postalCode: '96253'
  },
  {
    municipality: 'Unterspreewald',
    postalCode: '15910'
  },
  {
    municipality: 'Unterstadion',
    postalCode: '89619'
  },
  {
    municipality: 'Untersteinach',
    postalCode: '95369'
  },
  {
    municipality: 'Unterthingau',
    postalCode: '87647'
  },
  {
    municipality: 'Unterwachingen',
    postalCode: '89597'
  },
  {
    municipality: 'Unterwaldhausen',
    postalCode: '88379'
  },
  {
    municipality: 'Unterweißbach',
    postalCode: '98744'
  },
  {
    municipality: 'Unterwellenborn',
    postalCode: '07333'
  },
  {
    municipality: 'Unterwössen',
    postalCode: '83246'
  },
  {
    municipality: 'Untrasried',
    postalCode: '87496'
  },
  {
    municipality: 'Unzenberg',
    postalCode: '55483'
  },
  {
    municipality: 'Upahl',
    postalCode: '23936'
  },
  {
    municipality: 'Upgant-Schott',
    postalCode: '26529'
  },
  {
    municipality: 'Uphusum',
    postalCode: '25923'
  },
  {
    municipality: 'Uplengen',
    postalCode: '26670'
  },
  {
    municipality: 'Uppershausen',
    postalCode: '54673'
  },
  {
    municipality: 'Urbach',
    postalCode: '73655'
  },
  {
    municipality: 'Urbach',
    postalCode: '73660'
  },
  {
    municipality: 'Urbach',
    postalCode: '56317'
  },
  {
    municipality: 'Urbach',
    postalCode: '99765'
  },
  {
    municipality: 'Urbar',
    postalCode: '56182'
  },
  {
    municipality: 'Urbar',
    postalCode: '55430'
  },
  {
    municipality: 'Urleben',
    postalCode: '99955'
  },
  {
    municipality: 'Urmersbach',
    postalCode: '56761'
  },
  {
    municipality: 'Urmitz',
    postalCode: '56220'
  },
  {
    municipality: 'Ursberg',
    postalCode: '86513'
  },
  {
    municipality: 'Urschmitt',
    postalCode: '56825'
  },
  {
    municipality: 'Ursensollen',
    postalCode: '92289'
  },
  {
    municipality: 'Urspringen',
    postalCode: '97857'
  },
  {
    municipality: 'Ürzig',
    postalCode: '54539'
  },
  {
    municipality: 'Usch',
    postalCode: '54655'
  },
  {
    municipality: 'Usedom',
    postalCode: '17406'
  },
  {
    municipality: 'Userin',
    postalCode: '17237'
  },
  {
    municipality: 'Usingen',
    postalCode: '61250'
  },
  {
    municipality: 'Uslar',
    postalCode: '37170'
  },
  {
    municipality: 'Ustersbach',
    postalCode: '86514'
  },
  {
    municipality: 'Utarp',
    postalCode: '26556'
  },
  {
    municipality: 'Utecht',
    postalCode: '19217'
  },
  {
    municipality: 'Utendorf',
    postalCode: '98617'
  },
  {
    municipality: 'Utersum',
    postalCode: '25938'
  },
  {
    municipality: 'Utscheid',
    postalCode: '54675'
  },
  {
    municipality: 'Uttenreuth',
    postalCode: '91080'
  },
  {
    municipality: 'Uttenweiler',
    postalCode: '88524'
  },
  {
    municipality: 'Üttfeld',
    postalCode: '54619'
  },
  {
    municipality: 'Utting am Ammersee',
    postalCode: '86919'
  },
  {
    municipality: 'Utzedel',
    postalCode: '17111'
  },
  {
    municipality: 'Utzenfeld',
    postalCode: '79694'
  },
  {
    municipality: 'Utzenhain',
    postalCode: '56291'
  },
  {
    municipality: 'Utzerath',
    postalCode: '54552'
  },
  {
    municipality: 'Üxheim',
    postalCode: '54579'
  },
  {
    municipality: 'Vaale',
    postalCode: '25572'
  },
  {
    municipality: 'Vaale',
    postalCode: '25594'
  },
  {
    municipality: 'Vaalermoor',
    postalCode: '25594'
  },
  {
    municipality: 'Vacha',
    postalCode: '36404'
  },
  {
    municipality: 'Vachdorf',
    postalCode: '98617'
  },
  {
    municipality: 'Vachendorf',
    postalCode: '83377'
  },
  {
    municipality: 'Vahlberg',
    postalCode: '38170'
  },
  {
    municipality: 'Vahlbruch',
    postalCode: '37647'
  },
  {
    municipality: 'Vahlde',
    postalCode: '27389'
  },
  {
    municipality: 'Vaihingen an der Enz',
    postalCode: '71665'
  },
  {
    municipality: 'Vallendar',
    postalCode: '56179'
  },
  {
    municipality: 'Valley',
    postalCode: '83626'
  },
  {
    municipality: 'Valwig',
    postalCode: '56812'
  },
  {
    municipality: 'Varel',
    postalCode: '26316'
  },
  {
    municipality: 'Varrel',
    postalCode: '27259'
  },
  {
    municipality: 'Vastorf',
    postalCode: '21397'
  },
  {
    municipality: 'Vaterstetten',
    postalCode: '85591'
  },
  {
    municipality: 'Vaterstetten',
    postalCode: '85598'
  },
  {
    municipality: 'Vaterstetten',
    postalCode: '85599'
  },
  {
    municipality: 'Vaterstetten',
    postalCode: '85622'
  },
  {
    municipality: 'Vaterstetten',
    postalCode: '85646'
  },
  {
    municipality: 'Vechelde',
    postalCode: '38159'
  },
  {
    municipality: 'Vechta',
    postalCode: '49377'
  },
  {
    municipality: 'Veelböken',
    postalCode: '19205'
  },
  {
    municipality: 'Veilsdorf',
    postalCode: '98669'
  },
  {
    municipality: 'Veitsbronn',
    postalCode: '90587'
  },
  {
    municipality: 'Veitshöchheim',
    postalCode: '97209'
  },
  {
    municipality: 'Veitsrodt',
    postalCode: '55758'
  },
  {
    municipality: 'Velbert',
    postalCode: '42549'
  },
  {
    municipality: 'Velbert',
    postalCode: '42551'
  },
  {
    municipality: 'Velbert',
    postalCode: '42553'
  },
  {
    municipality: 'Velbert',
    postalCode: '42555'
  },
  {
    municipality: 'Velburg',
    postalCode: '92355'
  },
  {
    municipality: 'Velden',
    postalCode: '84149'
  },
  {
    municipality: 'Velden',
    postalCode: '91235'
  },
  {
    municipality: 'Veldenz',
    postalCode: '54472'
  },
  {
    municipality: 'Velen',
    postalCode: '46342'
  },
  {
    municipality: 'Velgast',
    postalCode: '18469'
  },
  {
    municipality: 'Vellahn',
    postalCode: '19260'
  },
  {
    municipality: 'Vellberg',
    postalCode: '74541'
  },
  {
    municipality: 'Vellmar',
    postalCode: '34246'
  },
  {
    municipality: 'Velpke',
    postalCode: '38458'
  },
  {
    municipality: 'Velten',
    postalCode: '16727'
  },
  {
    municipality: 'Veltheim',
    postalCode: '38173'
  },
  {
    municipality: 'Vendersheim',
    postalCode: '55578'
  },
  {
    municipality: 'Venningen',
    postalCode: '67482'
  },
  {
    municipality: 'Ventschow',
    postalCode: '19417'
  },
  {
    municipality: 'Verchen',
    postalCode: '17111'
  },
  {
    municipality: 'Verden (Aller)',
    postalCode: '27283'
  },
  {
    municipality: 'Veringenstadt',
    postalCode: '72519'
  },
  {
    municipality: 'Verl',
    postalCode: '33415'
  },
  {
    municipality: 'Versmold',
    postalCode: '33775'
  },
  {
    municipality: 'Vestenbergsgreuth',
    postalCode: '91487'
  },
  {
    municipality: 'Vetschau/Spreewald',
    postalCode: '03226'
  },
  {
    municipality: 'Vettelschoß',
    postalCode: '53560'
  },
  {
    municipality: 'Vettweiß',
    postalCode: '52391'
  },
  {
    municipality: 'Viechtach',
    postalCode: '94234'
  },
  {
    municipality: 'Vielank',
    postalCode: '19303'
  },
  {
    municipality: 'Vielbach',
    postalCode: '56244'
  },
  {
    municipality: 'Vielitzsee',
    postalCode: '16835'
  },
  {
    municipality: 'Vierden',
    postalCode: '27419'
  },
  {
    municipality: 'Viereck',
    postalCode: '17309'
  },
  {
    municipality: 'Viereth-Trunstadt',
    postalCode: '96191'
  },
  {
    municipality: 'Vierherrenborn',
    postalCode: '54314'
  },
  {
    municipality: 'Vierhöfen',
    postalCode: '21444'
  },
  {
    municipality: 'Vierkirchen',
    postalCode: '85256'
  },
  {
    municipality: 'Vierkirchen',
    postalCode: '02894'
  },
  {
    municipality: 'Vierlinden',
    postalCode: '15306'
  },
  {
    municipality: 'Viernheim',
    postalCode: '68519'
  },
  {
    municipality: 'Viersen',
    postalCode: '41747'
  },
  {
    municipality: 'Viersen',
    postalCode: '41748'
  },
  {
    municipality: 'Viersen',
    postalCode: '41749'
  },
  {
    municipality: 'Viersen',
    postalCode: '41751'
  },
  {
    municipality: 'Vilgertshofen',
    postalCode: '86946'
  },
  {
    municipality: 'Villenbach',
    postalCode: '86637'
  },
  {
    municipality: 'Villingendorf',
    postalCode: '78667'
  },
  {
    municipality: 'Villingen-Schwenningen',
    postalCode: '78048'
  },
  {
    municipality: 'Villingen-Schwenningen',
    postalCode: '78050'
  },
  {
    municipality: 'Villingen-Schwenningen',
    postalCode: '78052'
  },
  {
    municipality: 'Villingen-Schwenningen',
    postalCode: '78054'
  },
  {
    municipality: 'Villingen-Schwenningen',
    postalCode: '78056'
  },
  {
    municipality: 'Villmar',
    postalCode: '65606'
  },
  {
    municipality: 'Vilsbiburg',
    postalCode: '84137'
  },
  {
    municipality: 'Vilseck',
    postalCode: '92249'
  },
  {
    municipality: 'Vilsheim',
    postalCode: '84186'
  },
  {
    municipality: 'Vilshofen an der Donau',
    postalCode: '94474'
  },
  {
    municipality: 'Vinningen',
    postalCode: '66957'
  },
  {
    municipality: 'Viöl',
    postalCode: '25884'
  },
  {
    municipality: 'Virneburg',
    postalCode: '56729'
  },
  {
    municipality: 'Visbek',
    postalCode: '49429'
  },
  {
    municipality: 'Visselhövede',
    postalCode: '27374'
  },
  {
    municipality: 'Vlotho',
    postalCode: '32602'
  },
  {
    municipality: 'Voerde (Niederrhein)',
    postalCode: '46562'
  },
  {
    municipality: 'Vogelsang',
    postalCode: '15890'
  },
  {
    municipality: 'Vogelsang-Warsin',
    postalCode: '17375'
  },
  {
    municipality: 'Vogelsberg',
    postalCode: '99610'
  },
  {
    municipality: 'Vögelsen',
    postalCode: '21360'
  },
  {
    municipality: 'Vogt',
    postalCode: '88267'
  },
  {
    municipality: 'Vogtareuth',
    postalCode: '83569'
  },
  {
    municipality: 'Vogtei',
    postalCode: '99986'
  },
  {
    municipality: 'Vogtsburg im Kaiserstuhl',
    postalCode: '79235'
  },
  {
    municipality: 'Vohburg an der Donau',
    postalCode: '85088'
  },
  {
    municipality: 'Vohenstrauß',
    postalCode: '92648'
  },
  {
    municipality: 'Vöhl',
    postalCode: '34516'
  },
  {
    municipality: 'Vöhrenbach',
    postalCode: '78147'
  },
  {
    municipality: 'Vöhringen',
    postalCode: '89269'
  },
  {
    municipality: 'Vöhringen',
    postalCode: '72189'
  },
  {
    municipality: 'Voigtsdorf',
    postalCode: '17349'
  },
  {
    municipality: 'Volkach',
    postalCode: '97332'
  },
  {
    municipality: 'Volkenschwand',
    postalCode: '84106'
  },
  {
    municipality: 'Volkerode',
    postalCode: '37308'
  },
  {
    municipality: 'Völkersweiler',
    postalCode: '76857'
  },
  {
    municipality: 'Volkertshausen',
    postalCode: '78269'
  },
  {
    municipality: 'Volkerzen',
    postalCode: '57612'
  },
  {
    municipality: 'Volkesfeld',
    postalCode: '56745'
  },
  {
    municipality: 'Völklingen',
    postalCode: '66333'
  },
  {
    municipality: 'Volkmannsdorf',
    postalCode: '07924'
  },
  {
    municipality: 'Volkmarsen',
    postalCode: '34471'
  },
  {
    municipality: 'Vollersode',
    postalCode: '27729'
  },
  {
    municipality: 'Vollersroda',
    postalCode: '99438'
  },
  {
    municipality: 'Vollerwiek',
    postalCode: '25836'
  },
  {
    municipality: 'Vollmersbach',
    postalCode: '55758'
  },
  {
    municipality: 'Vollmershain',
    postalCode: '04626'
  },
  {
    municipality: 'Vollmersweiler',
    postalCode: '76744'
  },
  {
    municipality: 'Vollrathsruhe',
    postalCode: '17194'
  },
  {
    municipality: 'Vollstedt',
    postalCode: '25821'
  },
  {
    municipality: 'Völpke',
    postalCode: '39393'
  },
  {
    municipality: 'Völschow',
    postalCode: '17129'
  },
  {
    municipality: 'Volsemenhusen',
    postalCode: '25693'
  },
  {
    municipality: 'Voltlage',
    postalCode: '49599'
  },
  {
    municipality: 'Volxheim',
    postalCode: '55546'
  },
  {
    municipality: 'Vorbach',
    postalCode: '95519'
  },
  {
    municipality: 'Vorbeck',
    postalCode: '18258'
  },
  {
    municipality: 'Vorderweidenthal',
    postalCode: '76889'
  },
  {
    municipality: 'Vordorf',
    postalCode: '38533'
  },
  {
    municipality: 'Vorra',
    postalCode: '91247'
  },
  {
    municipality: 'Vörstetten',
    postalCode: '79279'
  },
  {
    municipality: 'Vorwerk',
    postalCode: '27412'
  },
  {
    municipality: 'Vreden',
    postalCode: '48691'
  },
  {
    municipality: 'Vrees',
    postalCode: '49757'
  },
  {
    municipality: 'Waabs',
    postalCode: '24369'
  },
  {
    municipality: 'Waake',
    postalCode: '37136'
  },
  {
    municipality: 'Waakirchen',
    postalCode: '83666'
  },
  {
    municipality: 'Waal',
    postalCode: '86875'
  },
  {
    municipality: 'Wabern',
    postalCode: '34590'
  },
  {
    municipality: 'Wachau',
    postalCode: '01454'
  },
  {
    municipality: 'Wachenheim',
    postalCode: '67591'
  },
  {
    municipality: 'Wachenheim an der Weinstraße',
    postalCode: '67157'
  },
  {
    municipality: 'Wachenroth',
    postalCode: '96193'
  },
  {
    municipality: 'Wachstedt',
    postalCode: '37359'
  },
  {
    municipality: 'Wachtberg',
    postalCode: '53343'
  },
  {
    municipality: 'Wachtendonk',
    postalCode: '47669'
  },
  {
    municipality: 'Wächtersbach',
    postalCode: '63607'
  },
  {
    municipality: 'Wacken',
    postalCode: '25596'
  },
  {
    municipality: 'Wackerow',
    postalCode: '17498'
  },
  {
    municipality: 'Wackersberg',
    postalCode: '83646'
  },
  {
    municipality: 'Wackersdorf',
    postalCode: '92442'
  },
  {
    municipality: 'Waddeweitz',
    postalCode: '29496'
  },
  {
    municipality: 'Wadern',
    postalCode: '66687'
  },
  {
    municipality: 'Wadersloh',
    postalCode: '59329'
  },
  {
    municipality: 'Wadgassen',
    postalCode: '66787'
  },
  {
    municipality: 'Waffenbrunn',
    postalCode: '93494'
  },
  {
    municipality: 'Wagenfeld',
    postalCode: '49419'
  },
  {
    municipality: 'Wagenhausen',
    postalCode: '56826'
  },
  {
    municipality: 'Wagenhoff',
    postalCode: '38559'
  },
  {
    municipality: 'Wagersrott',
    postalCode: '24392'
  },
  {
    municipality: 'Waghäusel',
    postalCode: '68753'
  },
  {
    municipality: 'Waging am See',
    postalCode: '83329'
  },
  {
    municipality: 'Wahlbach',
    postalCode: '55494'
  },
  {
    municipality: 'Wahlenau',
    postalCode: '55491'
  },
  {
    municipality: 'Wahlhausen',
    postalCode: '37318'
  },
  {
    municipality: 'Wahlheim',
    postalCode: '55234'
  },
  {
    municipality: 'Wahlrod',
    postalCode: '57614'
  },
  {
    municipality: 'Wahlstedt',
    postalCode: '23812'
  },
  {
    municipality: 'Wahlstorf',
    postalCode: '24211'
  },
  {
    municipality: 'Wahnwegen',
    postalCode: '66909'
  },
  {
    municipality: 'Wahrenholz',
    postalCode: '29399'
  },
  {
    municipality: 'Waiblingen',
    postalCode: '71332'
  },
  {
    municipality: 'Waiblingen',
    postalCode: '71334'
  },
  {
    municipality: 'Waiblingen',
    postalCode: '71336'
  },
  {
    municipality: 'Waibstadt',
    postalCode: '74915'
  },
  {
    municipality: 'Waidhaus',
    postalCode: '92726'
  },
  {
    municipality: 'Waidhofen',
    postalCode: '86579'
  },
  {
    municipality: 'Waigandshain',
    postalCode: '56477'
  },
  {
    municipality: 'Waigolshausen',
    postalCode: '97534'
  },
  {
    municipality: 'Wain',
    postalCode: '88489'
  },
  {
    municipality: 'Wain',
    postalCode: '89165'
  },
  {
    municipality: 'Waischenfeld',
    postalCode: '91344'
  },
  {
    municipality: 'Wakendorf I',
    postalCode: '23845'
  },
  {
    municipality: 'Wakendorf II',
    postalCode: '24558'
  },
  {
    municipality: 'Walchum',
    postalCode: '26907'
  },
  {
    municipality: 'Wald',
    postalCode: '87616'
  },
  {
    municipality: 'Wald',
    postalCode: '93192'
  },
  {
    municipality: 'Wald',
    postalCode: '88639'
  },
  {
    municipality: 'Waldachtal',
    postalCode: '72178'
  },
  {
    municipality: 'Waldalgesheim',
    postalCode: '55425'
  },
  {
    municipality: 'Waldaschaff',
    postalCode: '63857'
  },
  {
    municipality: 'Waldböckelheim',
    postalCode: '55596'
  },
  {
    municipality: 'Waldbreitbach',
    postalCode: '56588'
  },
  {
    municipality: 'Waldbröl',
    postalCode: '51545'
  },
  {
    municipality: 'Waldbronn',
    postalCode: '76337'
  },
  {
    municipality: 'Waldbrunn',
    postalCode: '97295'
  },
  {
    municipality: 'Waldbrunn',
    postalCode: '65620'
  },
  {
    municipality: 'Waldbrunn',
    postalCode: '69429'
  },
  {
    municipality: 'Waldburg',
    postalCode: '88289'
  },
  {
    municipality: 'Waldbüttelbrunn',
    postalCode: '97297'
  },
  {
    municipality: 'Walddorfhäslach',
    postalCode: '72141'
  },
  {
    municipality: 'Waldeck',
    postalCode: '34513'
  },
  {
    municipality: 'Waldeck',
    postalCode: '07646'
  },
  {
    municipality: 'Waldems',
    postalCode: '65529'
  },
  {
    municipality: 'Waldenbuch',
    postalCode: '71111'
  },
  {
    municipality: 'Waldenburg',
    postalCode: '74638'
  },
  {
    municipality: 'Waldenburg',
    postalCode: '08396'
  },
  {
    municipality: 'Walderbach',
    postalCode: '93194'
  },
  {
    municipality: 'Waldershof',
    postalCode: '95679'
  },
  {
    municipality: 'Waldesch',
    postalCode: '56323'
  },
  {
    municipality: 'Waldfeucht',
    postalCode: '52525'
  },
  {
    municipality: 'Waldfischbach-Burgalben',
    postalCode: '67714'
  },
  {
    municipality: 'Waldgrehweiler',
    postalCode: '67822'
  },
  {
    municipality: 'Waldhambach',
    postalCode: '76857'
  },
  {
    municipality: 'Waldheim',
    postalCode: '04736'
  },
  {
    municipality: 'Waldhof-Falkenstein',
    postalCode: '54673'
  },
  {
    municipality: 'Waldhufen',
    postalCode: '02906'
  },
  {
    municipality: 'Waldkappel',
    postalCode: '37284'
  },
  {
    municipality: 'Waldkirch',
    postalCode: '79183'
  },
  {
    municipality: 'Waldkirchen',
    postalCode: '94065'
  },
  {
    municipality: 'Waldkraiburg',
    postalCode: '84478'
  },
  {
    municipality: 'Waldlaubersheim',
    postalCode: '55444'
  },
  {
    municipality: 'Waldleiningen',
    postalCode: '67693'
  },
  {
    municipality: 'Wald-Michelbach',
    postalCode: '69483'
  },
  {
    municipality: 'Waldmohr',
    postalCode: '66914'
  },
  {
    municipality: 'Waldmühlen',
    postalCode: '56479'
  },
  {
    municipality: 'Waldmünchen',
    postalCode: '93449'
  },
  {
    municipality: 'Waldorf',
    postalCode: '53498'
  },
  {
    municipality: 'Waldrach',
    postalCode: '54320'
  },
  {
    municipality: 'Waldrohrbach',
    postalCode: '76857'
  },
  {
    municipality: 'Waldsassen',
    postalCode: '95652'
  },
  {
    municipality: 'Waldsee',
    postalCode: '67165'
  },
  {
    municipality: 'Waldshut-Tiengen',
    postalCode: '79761'
  },
  {
    municipality: 'Waldsieversdorf',
    postalCode: '15377'
  },
  {
    municipality: 'Waldsolms',
    postalCode: '35647'
  },
  {
    municipality: 'Waldstetten',
    postalCode: '89367'
  },
  {
    municipality: 'Waldstetten',
    postalCode: '73550'
  },
  {
    municipality: 'Waldthurn',
    postalCode: '92727'
  },
  {
    municipality: 'Waldweiler',
    postalCode: '54429'
  },
  {
    municipality: 'Walhausen',
    postalCode: '56865'
  },
  {
    municipality: 'Walheim',
    postalCode: '74399'
  },
  {
    municipality: 'Walkendorf',
    postalCode: '17179'
  },
  {
    municipality: 'Walkenried',
    postalCode: '37445'
  },
  {
    municipality: 'Walkertshofen',
    postalCode: '86877'
  },
  {
    municipality: 'Walksfelde',
    postalCode: '23896'
  },
  {
    municipality: 'Walldorf',
    postalCode: '69190'
  },
  {
    municipality: 'Walldürn',
    postalCode: '63928'
  },
  {
    municipality: 'Walldürn',
    postalCode: '74731'
  },
  {
    municipality: 'Wallen',
    postalCode: '25788'
  },
  {
    municipality: 'Wallenborn',
    postalCode: '54570'
  },
  {
    municipality: 'Wallendorf',
    postalCode: '54675'
  },
  {
    municipality: 'Wallenfels',
    postalCode: '96346'
  },
  {
    municipality: 'Wallenhorst',
    postalCode: '49134'
  },
  {
    municipality: 'Wallerfangen',
    postalCode: '66798'
  },
  {
    municipality: 'Wallerfing',
    postalCode: '94574'
  },
  {
    municipality: 'Wallersdorf',
    postalCode: '94522'
  },
  {
    municipality: 'Wallersheim',
    postalCode: '54597'
  },
  {
    municipality: 'Wallerstein',
    postalCode: '86757'
  },
  {
    municipality: 'Wallertheim',
    postalCode: '55578'
  },
  {
    municipality: 'Wallgau',
    postalCode: '82499'
  },
  {
    municipality: 'Wallhalben',
    postalCode: '66917'
  },
  {
    municipality: 'Wallhausen',
    postalCode: '74599'
  },
  {
    municipality: 'Wallhausen',
    postalCode: '55595'
  },
  {
    municipality: 'Wallhausen',
    postalCode: '06528'
  },
  {
    municipality: 'Wallmenroth',
    postalCode: '57584'
  },
  {
    municipality: 'Wallmerod',
    postalCode: '56414'
  },
  {
    municipality: 'Wallsbüll',
    postalCode: '24980'
  },
  {
    municipality: 'Wallscheid',
    postalCode: '54531'
  },
  {
    municipality: 'Wallstawe',
    postalCode: '29413'
  },
  {
    municipality: 'Walluf',
    postalCode: '65396'
  },
  {
    municipality: 'Walow',
    postalCode: '17209'
  },
  {
    municipality: 'Walpernhain',
    postalCode: '07613'
  },
  {
    municipality: 'Walpertskirchen',
    postalCode: '85469'
  },
  {
    municipality: 'Walschleben',
    postalCode: '99189'
  },
  {
    municipality: 'Walsdorf',
    postalCode: '54578'
  },
  {
    municipality: 'Walsdorf',
    postalCode: '96194'
  },
  {
    municipality: 'Walshausen',
    postalCode: '66484'
  },
  {
    municipality: 'Walsheim',
    postalCode: '76833'
  },
  {
    municipality: 'Walsleben',
    postalCode: '16818'
  },
  {
    municipality: 'Walsrode',
    postalCode: '29664'
  },
  {
    municipality: 'Walsrode',
    postalCode: '29699'
  },
  {
    municipality: 'Waltenhausen',
    postalCode: '86480'
  },
  {
    municipality: 'Waltenhofen',
    postalCode: '87448'
  },
  {
    municipality: 'Walterschen',
    postalCode: '57632'
  },
  {
    municipality: 'Waltersdorf',
    postalCode: '07646'
  },
  {
    municipality: 'Waltershausen',
    postalCode: '99880'
  },
  {
    municipality: 'Walting',
    postalCode: '85137'
  },
  {
    municipality: 'Waltrop',
    postalCode: '45731'
  },
  {
    municipality: 'Walzbachtal',
    postalCode: '75045'
  },
  {
    municipality: 'Wanderup',
    postalCode: '24997'
  },
  {
    municipality: 'Wandlitz',
    postalCode: '16348'
  },
  {
    municipality: 'Wanfried',
    postalCode: '37281'
  },
  {
    municipality: 'Wang',
    postalCode: '85368'
  },
  {
    municipality: 'Wangelau',
    postalCode: '21483'
  },
  {
    municipality: 'Wangelnstedt',
    postalCode: '37627'
  },
  {
    municipality: 'Wangels',
    postalCode: '23758'
  },
  {
    municipality: 'Wangen',
    postalCode: '73117'
  },
  {
    municipality: 'Wangen im Allgäu',
    postalCode: '88239'
  },
  {
    municipality: 'Wangerland',
    postalCode: '26434'
  },
  {
    municipality: 'Wangerooge',
    postalCode: '26486'
  },
  {
    municipality: 'Wankendorf',
    postalCode: '24601'
  },
  {
    municipality: 'Wanna',
    postalCode: '21776'
  },
  {
    municipality: 'Wannweil',
    postalCode: '72827'
  },
  {
    municipality: 'Wanzleben-Börde',
    postalCode: '39164'
  },
  {
    municipality: 'Wapelfeld',
    postalCode: '24594'
  },
  {
    municipality: 'Warberg',
    postalCode: '38378'
  },
  {
    municipality: 'Warburg',
    postalCode: '34414'
  },
  {
    municipality: 'Wardenburg',
    postalCode: '26203'
  },
  {
    municipality: 'Warder',
    postalCode: '24646'
  },
  {
    municipality: 'Wardow',
    postalCode: '18299'
  },
  {
    municipality: 'Warendorf',
    postalCode: '48231'
  },
  {
    municipality: 'Waren (Müritz)',
    postalCode: '17192'
  },
  {
    municipality: 'Warin',
    postalCode: '19417'
  },
  {
    municipality: 'Warlitz',
    postalCode: '19230'
  },
  {
    municipality: 'Warlow',
    postalCode: '19288'
  },
  {
    municipality: 'Warmensteinach',
    postalCode: '95485'
  },
  {
    municipality: 'Warmsen',
    postalCode: '31606'
  },
  {
    municipality: 'Warmsroth',
    postalCode: '55442'
  },
  {
    municipality: 'Warnau',
    postalCode: '24250'
  },
  {
    municipality: 'Warngau',
    postalCode: '83627'
  },
  {
    municipality: 'Warnkenhagen',
    postalCode: '17168'
  },
  {
    municipality: 'Warnow',
    postalCode: '23936'
  },
  {
    municipality: 'Warnow',
    postalCode: '23948'
  },
  {
    municipality: 'Warnow',
    postalCode: '18249'
  },
  {
    municipality: 'Warpe',
    postalCode: '27333'
  },
  {
    municipality: 'Warrenzin',
    postalCode: '17111'
  },
  {
    municipality: 'Warringholz',
    postalCode: '25560'
  },
  {
    municipality: 'Warsow',
    postalCode: '19075'
  },
  {
    municipality: 'Warstein',
    postalCode: '59581'
  },
  {
    municipality: 'Wartenberg',
    postalCode: '36367'
  },
  {
    municipality: 'Wartenberg',
    postalCode: '85456'
  },
  {
    municipality: 'Wartenberg-Rohrbach',
    postalCode: '67681'
  },
  {
    municipality: 'Warthausen',
    postalCode: '88447'
  },
  {
    municipality: 'Wartmannsroth',
    postalCode: '97797'
  },
  {
    municipality: 'Warwerort',
    postalCode: '25761'
  },
  {
    municipality: 'Wasbek',
    postalCode: '24647'
  },
  {
    municipality: 'Wasbüttel',
    postalCode: '38553'
  },
  {
    municipality: 'Wäschenbeuren',
    postalCode: '73116'
  },
  {
    municipality: 'Wäschenbeuren',
    postalCode: '73547'
  },
  {
    municipality: 'Wasenbach',
    postalCode: '56370'
  },
  {
    municipality: 'Wassenach',
    postalCode: '56653'
  },
  {
    municipality: 'Wassenberg',
    postalCode: '41849'
  },
  {
    municipality: 'Wasserburg am Inn',
    postalCode: '83512'
  },
  {
    municipality: 'Wasserburg (Bodensee)',
    postalCode: '88142'
  },
  {
    municipality: 'Wasserliesch',
    postalCode: '54332'
  },
  {
    municipality: 'Wasserlosen',
    postalCode: '97535'
  },
  {
    municipality: 'Wasserthaleben',
    postalCode: '99718'
  },
  {
    municipality: 'Wassertrüdingen',
    postalCode: '91717'
  },
  {
    municipality: 'Wasungen',
    postalCode: '98634'
  },
  {
    municipality: 'Wathlingen',
    postalCode: '29339'
  },
  {
    municipality: 'Wattenbek',
    postalCode: '24582'
  },
  {
    municipality: 'Wattendorf',
    postalCode: '96196'
  },
  {
    municipality: 'Wattenheim',
    postalCode: '67319'
  },
  {
    municipality: 'Watzerath',
    postalCode: '54595'
  },
  {
    municipality: 'Wawern',
    postalCode: '54612'
  },
  {
    municipality: 'Wawern',
    postalCode: '54441'
  },
  {
    municipality: 'Waxweiler',
    postalCode: '54649'
  },
  {
    municipality: 'Wechingen',
    postalCode: '86759'
  },
  {
    municipality: 'Wechselburg',
    postalCode: '09306'
  },
  {
    municipality: 'Weddelbrook',
    postalCode: '24576'
  },
  {
    municipality: 'Weddingstedt',
    postalCode: '25795'
  },
  {
    municipality: 'Wedel',
    postalCode: '22880'
  },
  {
    municipality: 'Wedemark',
    postalCode: '30900'
  },
  {
    municipality: 'Wedendorfersee',
    postalCode: '19217'
  },
  {
    municipality: 'Weede',
    postalCode: '23795'
  },
  {
    municipality: 'Weener',
    postalCode: '26826'
  },
  {
    municipality: 'Wees',
    postalCode: '24999'
  },
  {
    municipality: 'Weesby',
    postalCode: '24994'
  },
  {
    municipality: 'Weeze',
    postalCode: '47652'
  },
  {
    municipality: 'Wefensleben',
    postalCode: '39365'
  },
  {
    municipality: 'Wegberg',
    postalCode: '41844'
  },
  {
    municipality: 'Wegeleben',
    postalCode: '38828'
  },
  {
    municipality: 'Wegscheid',
    postalCode: '94110'
  },
  {
    municipality: 'Wehingen',
    postalCode: '78564'
  },
  {
    municipality: 'Wehlen',
    postalCode: '01829'
  },
  {
    municipality: 'Wehnde',
    postalCode: '37339'
  },
  {
    municipality: 'Wehr',
    postalCode: '56653'
  },
  {
    municipality: 'Wehr',
    postalCode: '79664'
  },
  {
    municipality: 'Wehrbleck',
    postalCode: '27259'
  },
  {
    municipality: 'Wehrbleck',
    postalCode: '49453'
  },
  {
    municipality: 'Wehretal',
    postalCode: '37287'
  },
  {
    municipality: 'Wehrheim',
    postalCode: '61273'
  },
  {
    municipality: 'Wehringen',
    postalCode: '86517'
  },
  {
    municipality: 'Weibern',
    postalCode: '56745'
  },
  {
    municipality: 'Weibersbrunn',
    postalCode: '63879'
  },
  {
    municipality: 'Weichering',
    postalCode: '86706'
  },
  {
    municipality: 'Weichs',
    postalCode: '85258'
  },
  {
    municipality: 'Weida',
    postalCode: '07570'
  },
  {
    municipality: 'Weiden',
    postalCode: '55758'
  },
  {
    municipality: 'Weidenbach',
    postalCode: '91746'
  },
  {
    municipality: 'Weidenbach',
    postalCode: '56355'
  },
  {
    municipality: 'Weidenbach',
    postalCode: '54570'
  },
  {
    municipality: 'Weidenberg',
    postalCode: '95466'
  },
  {
    municipality: 'Weidenhahn',
    postalCode: '56244'
  },
  {
    municipality: 'Weiden in der Oberpfalz',
    postalCode: '92637'
  },
  {
    municipality: 'Weidenstetten',
    postalCode: '89197'
  },
  {
    municipality: 'Weidenthal',
    postalCode: '67475'
  },
  {
    municipality: 'Weidhausen b.Coburg',
    postalCode: '96279'
  },
  {
    municipality: 'Weiding',
    postalCode: '93495'
  },
  {
    municipality: 'Weiding',
    postalCode: '92557'
  },
  {
    municipality: 'Weidingen',
    postalCode: '54636'
  },
  {
    municipality: 'Weigendorf',
    postalCode: '91249'
  },
  {
    municipality: 'Weigenheim',
    postalCode: '97215'
  },
  {
    municipality: 'Weihenzell',
    postalCode: '91629'
  },
  {
    municipality: 'Weiherhammer',
    postalCode: '92700'
  },
  {
    municipality: 'Weiherhammer',
    postalCode: '92729'
  },
  {
    municipality: 'Weihmichl',
    postalCode: '84107'
  },
  {
    municipality: 'Weikersheim',
    postalCode: '97990'
  },
  {
    municipality: 'Weil',
    postalCode: '86947'
  },
  {
    municipality: 'Weil am Rhein',
    postalCode: '79576'
  },
  {
    municipality: 'Weilar',
    postalCode: '36457'
  },
  {
    municipality: 'Weilbach',
    postalCode: '63937'
  },
  {
    municipality: 'Weilburg',
    postalCode: '35781'
  },
  {
    municipality: 'Weil der Stadt',
    postalCode: '71263'
  },
  {
    municipality: 'Weilen unter den Rinnen',
    postalCode: '72367'
  },
  {
    municipality: 'Weiler',
    postalCode: '56729'
  },
  {
    municipality: 'Weiler',
    postalCode: '56825'
  },
  {
    municipality: 'Weilerbach',
    postalCode: '67685'
  },
  {
    municipality: 'Weiler bei Bingen',
    postalCode: '55413'
  },
  {
    municipality: 'Weiler bei Monzingen',
    postalCode: '55627'
  },
  {
    municipality: 'Weilersbach',
    postalCode: '91365'
  },
  {
    municipality: 'Weiler-Simmerberg',
    postalCode: '88171'
  },
  {
    municipality: 'Weilerswist',
    postalCode: '53919'
  },
  {
    municipality: 'Weilheim',
    postalCode: '79809'
  },
  {
    municipality: 'Weilheim an der Teck',
    postalCode: '73235'
  },
  {
    municipality: 'Weilheim in Oberbayern',
    postalCode: '82362'
  },
  {
    municipality: 'Weil im Schönbuch',
    postalCode: '71093'
  },
  {
    municipality: 'Weilmünster',
    postalCode: '35789'
  },
  {
    municipality: 'Weilrod',
    postalCode: '61276'
  },
  {
    municipality: 'Weiltingen',
    postalCode: '91744'
  },
  {
    municipality: 'Weimar',
    postalCode: '99423'
  },
  {
    municipality: 'Weimar',
    postalCode: '99425'
  },
  {
    municipality: 'Weimar',
    postalCode: '99427'
  },
  {
    municipality: 'Weimar',
    postalCode: '99428'
  },
  {
    municipality: 'Weimar (Lahn)',
    postalCode: '35096'
  },
  {
    municipality: 'Weinähr',
    postalCode: '56379'
  },
  {
    municipality: 'Weinbach',
    postalCode: '35796'
  },
  {
    municipality: 'Weinböhla',
    postalCode: '01689'
  },
  {
    municipality: 'Weingarten',
    postalCode: '76356'
  },
  {
    municipality: 'Weingarten',
    postalCode: '88250'
  },
  {
    municipality: 'Weingarten (Pfalz)',
    postalCode: '67366'
  },
  {
    municipality: 'Weinheim',
    postalCode: '69469'
  },
  {
    municipality: 'Weinolsheim',
    postalCode: '55278'
  },
  {
    municipality: 'Weinsberg',
    postalCode: '74189'
  },
  {
    municipality: 'Weinsheim',
    postalCode: '54595'
  },
  {
    municipality: 'Weinsheim',
    postalCode: '55595'
  },
  {
    municipality: 'Weinstadt',
    postalCode: '71384'
  },
  {
    municipality: 'Weira',
    postalCode: '07806'
  },
  {
    municipality: 'Weischlitz',
    postalCode: '08538'
  },
  {
    municipality: 'Weisel',
    postalCode: '56348'
  },
  {
    municipality: 'Weisen',
    postalCode: '19322'
  },
  {
    municipality: 'Weisenbach',
    postalCode: '76599'
  },
  {
    municipality: 'Weisendorf',
    postalCode: '91085'
  },
  {
    municipality: 'Weisenheim am Berg',
    postalCode: '67273'
  },
  {
    municipality: 'Weisenheim am Sand',
    postalCode: '67256'
  },
  {
    municipality: 'Weiskirchen',
    postalCode: '66709'
  },
  {
    municipality: 'Weismain',
    postalCode: '96260'
  },
  {
    municipality: 'Weissach',
    postalCode: '71287'
  },
  {
    municipality: 'Weissach im Tal',
    postalCode: '71554'
  },
  {
    municipality: 'Weißbach',
    postalCode: '74679'
  },
  {
    municipality: 'Weißbach',
    postalCode: '07646'
  },
  {
    municipality: 'Weißdorf',
    postalCode: '95237'
  },
  {
    municipality: 'Weißenberg - Wóspork',
    postalCode: '02627'
  },
  {
    municipality: 'Weißenborn',
    postalCode: '37299'
  },
  {
    municipality: 'Weißenborn',
    postalCode: '07639'
  },
  {
    municipality: 'Weißenborn/Erzgebirge',
    postalCode: '09600'
  },
  {
    municipality: 'Weißenbrunn',
    postalCode: '96369'
  },
  {
    municipality: 'Weißenburg i. Bay.',
    postalCode: '91781'
  },
  {
    municipality: 'Weißendorf',
    postalCode: '07950'
  },
  {
    municipality: 'Weißenfels',
    postalCode: '06667'
  },
  {
    municipality: 'Weißenfels',
    postalCode: '06688'
  },
  {
    municipality: 'Weißenhorn',
    postalCode: '89264'
  },
  {
    municipality: 'Weißenohe',
    postalCode: '91367'
  },
  {
    municipality: 'Weißensberg',
    postalCode: '88138'
  },
  {
    municipality: 'Weißensee',
    postalCode: '99631'
  },
  {
    municipality: 'Weißenstadt',
    postalCode: '95163'
  },
  {
    municipality: 'Weißenthurm',
    postalCode: '56575'
  },
  {
    municipality: 'Weißkeißel - Wuskidź',
    postalCode: '02957'
  },
  {
    municipality: 'Weißwasser/O.L. - Běła Woda',
    postalCode: '02943'
  },
  {
    municipality: 'Weisweil',
    postalCode: '79367'
  },
  {
    municipality: 'Weitefeld',
    postalCode: '57586'
  },
  {
    municipality: 'Weitendorf',
    postalCode: '19412'
  },
  {
    municipality: 'Weitenhagen',
    postalCode: '18461'
  },
  {
    municipality: 'Weitenhagen',
    postalCode: '17498'
  },
  {
    municipality: 'Weitersbach',
    postalCode: '55624'
  },
  {
    municipality: 'Weitersborn',
    postalCode: '55629'
  },
  {
    municipality: 'Weitersburg',
    postalCode: '56191'
  },
  {
    municipality: 'Weiterstadt',
    postalCode: '64331'
  },
  {
    municipality: 'Weitersweiler',
    postalCode: '67808'
  },
  {
    municipality: 'Weitnau',
    postalCode: '87480'
  },
  {
    municipality: 'Weitramsdorf',
    postalCode: '96479'
  },
  {
    municipality: 'Welcherath',
    postalCode: '53539'
  },
  {
    municipality: 'Welchweiler',
    postalCode: '66887'
  },
  {
    municipality: 'Welden',
    postalCode: '86465'
  },
  {
    municipality: 'Welgesheim',
    postalCode: '55576'
  },
  {
    municipality: 'Welkenbach',
    postalCode: '57644'
  },
  {
    municipality: 'Welle',
    postalCode: '21261'
  },
  {
    municipality: 'Wellen',
    postalCode: '54441'
  },
  {
    municipality: 'Wellendingen',
    postalCode: '78669'
  },
  {
    municipality: 'Wellheim',
    postalCode: '91809'
  },
  {
    municipality: 'Welling',
    postalCode: '56753'
  },
  {
    municipality: 'Welmbüttel',
    postalCode: '25782'
  },
  {
    municipality: 'Welschbillig',
    postalCode: '54298'
  },
  {
    municipality: 'Welschenbach',
    postalCode: '56729'
  },
  {
    municipality: 'Welschneudorf',
    postalCode: '56412'
  },
  {
    municipality: 'Welt',
    postalCode: '25836'
  },
  {
    municipality: 'Welterod',
    postalCode: '56357'
  },
  {
    municipality: 'Weltersburg',
    postalCode: '56459'
  },
  {
    municipality: 'Welver',
    postalCode: '59514'
  },
  {
    municipality: 'Welzheim',
    postalCode: '73553'
  },
  {
    municipality: 'Welzheim',
    postalCode: '73635'
  },
  {
    municipality: 'Welzheim',
    postalCode: '73642'
  },
  {
    municipality: 'Welzheim',
    postalCode: '73667'
  },
  {
    municipality: 'Welzow',
    postalCode: '03119'
  },
  {
    municipality: 'Wembach',
    postalCode: '79677'
  },
  {
    municipality: 'Wemding',
    postalCode: '86650'
  },
  {
    municipality: 'Wendeburg',
    postalCode: '38176'
  },
  {
    municipality: 'Wendelsheim',
    postalCode: '55234'
  },
  {
    municipality: 'Wendelstein',
    postalCode: '90530'
  },
  {
    municipality: 'Wenden',
    postalCode: '57482'
  },
  {
    municipality: 'Wendisch Baggendorf',
    postalCode: '18513'
  },
  {
    municipality: 'Wendisch Evern',
    postalCode: '21403'
  },
  {
    municipality: 'Wendisch Rietz',
    postalCode: '15864'
  },
  {
    municipality: 'Wendlingen am Neckar',
    postalCode: '73240'
  },
  {
    municipality: 'Wendorf',
    postalCode: '18442'
  },
  {
    municipality: 'Wendtorf',
    postalCode: '24235'
  },
  {
    municipality: 'Weng',
    postalCode: '84187'
  },
  {
    municipality: 'Wennbüttel',
    postalCode: '25767'
  },
  {
    municipality: 'Wennigsen (Deister)',
    postalCode: '30974'
  },
  {
    municipality: 'Wenningstedt-Braderup (Sylt)',
    postalCode: '25996'
  },
  {
    municipality: 'Wensin',
    postalCode: '23827'
  },
  {
    municipality: 'Wentorf',
    postalCode: '23898'
  },
  {
    municipality: 'Wentorf bei Hamburg',
    postalCode: '21465'
  },
  {
    municipality: 'Wenzenbach',
    postalCode: '93173'
  },
  {
    municipality: 'Wenzendorf',
    postalCode: '21279'
  },
  {
    municipality: 'Wenzlow',
    postalCode: '14778'
  },
  {
    municipality: 'Werbach',
    postalCode: '97956'
  },
  {
    municipality: 'Werben',
    postalCode: '03096'
  },
  {
    municipality: 'Werben (Elbe)',
    postalCode: '39539'
  },
  {
    municipality: 'Werben (Elbe)',
    postalCode: '39615'
  },
  {
    municipality: 'Werda',
    postalCode: '08223'
  },
  {
    municipality: 'Werdau',
    postalCode: '08412'
  },
  {
    municipality: 'Werder',
    postalCode: '19386'
  },
  {
    municipality: 'Werder',
    postalCode: '17089'
  },
  {
    municipality: 'Werder (Havel)',
    postalCode: '14542'
  },
  {
    municipality: 'Werdohl',
    postalCode: '58791'
  },
  {
    municipality: 'Werdum',
    postalCode: '26427'
  },
  {
    municipality: 'Werkhausen',
    postalCode: '57635'
  },
  {
    municipality: 'Werl',
    postalCode: '59457'
  },
  {
    municipality: 'Werlte',
    postalCode: '49757'
  },
  {
    municipality: 'Wermelskirchen',
    postalCode: '42929'
  },
  {
    municipality: 'Wermsdorf',
    postalCode: '04779'
  },
  {
    municipality: 'Wernau (Neckar)',
    postalCode: '73249'
  },
  {
    municipality: 'Wernberg-Köblitz',
    postalCode: '92533'
  },
  {
    municipality: 'Wernburg',
    postalCode: '07381'
  },
  {
    municipality: 'Werne',
    postalCode: '59368'
  },
  {
    municipality: 'Werneck',
    postalCode: '97440'
  },
  {
    municipality: 'Wernersberg',
    postalCode: '76857'
  },
  {
    municipality: 'Werneuchen',
    postalCode: '16356'
  },
  {
    municipality: 'Wernigerode',
    postalCode: '38855'
  },
  {
    municipality: 'Wernigerode',
    postalCode: '38875'
  },
  {
    municipality: 'Wernigerode',
    postalCode: '38879'
  },
  {
    municipality: 'Werningshausen',
    postalCode: '99634'
  },
  {
    municipality: 'Weroth',
    postalCode: '56414'
  },
  {
    municipality: 'Werpeloh',
    postalCode: '49751'
  },
  {
    municipality: 'Werra-Suhl-Tal',
    postalCode: '99837'
  },
  {
    municipality: 'Wershofen',
    postalCode: '53520'
  },
  {
    municipality: 'Wertach',
    postalCode: '87497'
  },
  {
    municipality: 'Wertheim',
    postalCode: '97877'
  },
  {
    municipality: 'Werther',
    postalCode: '33824'
  },
  {
    municipality: 'Werther',
    postalCode: '99735'
  },
  {
    municipality: 'Wertingen',
    postalCode: '86637'
  },
  {
    municipality: 'Wesel',
    postalCode: '46483'
  },
  {
    municipality: 'Wesel',
    postalCode: '46485'
  },
  {
    municipality: 'Wesel',
    postalCode: '46487'
  },
  {
    municipality: 'Weselberg',
    postalCode: '66919'
  },
  {
    municipality: 'Wesenberg',
    postalCode: '23858'
  },
  {
    municipality: 'Wesenberg',
    postalCode: '17255'
  },
  {
    municipality: 'Wesendorf',
    postalCode: '29392'
  },
  {
    municipality: 'Wesertal',
    postalCode: '34399'
  },
  {
    municipality: 'Wesselburen',
    postalCode: '25764'
  },
  {
    municipality: 'Wesselburener Deichhausen',
    postalCode: '25764'
  },
  {
    municipality: 'Wesselburenerkoog',
    postalCode: '25764'
  },
  {
    municipality: 'Wesseling',
    postalCode: '50389'
  },
  {
    municipality: 'Wesseln',
    postalCode: '25746'
  },
  {
    municipality: 'Weßling',
    postalCode: '82234'
  },
  {
    municipality: 'Wessobrunn',
    postalCode: '82405'
  },
  {
    municipality: 'Weste',
    postalCode: '29599'
  },
  {
    municipality: 'Westendorf',
    postalCode: '86707'
  },
  {
    municipality: 'Westendorf',
    postalCode: '87679'
  },
  {
    municipality: 'Westensee',
    postalCode: '24259'
  },
  {
    municipality: 'Westerau',
    postalCode: '23847'
  },
  {
    municipality: 'Westerborstel',
    postalCode: '25782'
  },
  {
    municipality: 'Westerburg',
    postalCode: '56457'
  },
  {
    municipality: 'Westerdeichstrich',
    postalCode: '25761'
  },
  {
    municipality: 'Westergellersen',
    postalCode: '21394'
  },
  {
    municipality: 'Westerheim',
    postalCode: '87784'
  },
  {
    municipality: 'Westerheim',
    postalCode: '72589'
  },
  {
    municipality: 'Westerhever',
    postalCode: '25881'
  },
  {
    municipality: 'Westerholt',
    postalCode: '26556'
  },
  {
    municipality: 'Westerholz',
    postalCode: '24977'
  },
  {
    municipality: 'Westerhorn',
    postalCode: '25364'
  },
  {
    municipality: 'Westerkappeln',
    postalCode: '49492'
  },
  {
    municipality: 'Westermoor',
    postalCode: '25597'
  },
  {
    municipality: 'Westerngrund',
    postalCode: '63825'
  },
  {
    municipality: 'Westernohe',
    postalCode: '56479'
  },
  {
    municipality: 'Wester-Ohrstedt',
    postalCode: '25885'
  },
  {
    municipality: 'Westerrade',
    postalCode: '23815'
  },
  {
    municipality: 'Westerrönfeld',
    postalCode: '24784'
  },
  {
    municipality: 'Westerstede',
    postalCode: '26655'
  },
  {
    municipality: 'Westerstetten',
    postalCode: '89198'
  },
  {
    municipality: 'Westertimke',
    postalCode: '27412'
  },
  {
    municipality: 'Westerwalsede',
    postalCode: '27386'
  },
  {
    municipality: 'Westgreußen',
    postalCode: '99718'
  },
  {
    municipality: 'Westhausen',
    postalCode: '73463'
  },
  {
    municipality: 'Westhausen',
    postalCode: '98663'
  },
  {
    municipality: 'Westheide',
    postalCode: '39343'
  },
  {
    municipality: 'Westheide',
    postalCode: '39345'
  },
  {
    municipality: 'Westheim',
    postalCode: '91747'
  },
  {
    municipality: 'Westheim',
    postalCode: '67368'
  },
  {
    municipality: 'Westhofen',
    postalCode: '67593'
  },
  {
    municipality: 'Westoverledingen',
    postalCode: '26810'
  },
  {
    municipality: 'Westre',
    postalCode: '25926'
  },
  {
    municipality: 'Wethau',
    postalCode: '06618'
  },
  {
    municipality: 'Wetschen',
    postalCode: '49453'
  },
  {
    municipality: 'Wettenberg',
    postalCode: '35435'
  },
  {
    municipality: 'Wetter',
    postalCode: '35083'
  },
  {
    municipality: 'Wetter (Ruhr)',
    postalCode: '58300'
  },
  {
    municipality: 'Wetterzeube',
    postalCode: '06722'
  },
  {
    municipality: 'Wettin-Löbejün',
    postalCode: '06193'
  },
  {
    municipality: 'Wettlingen',
    postalCode: '54646'
  },
  {
    municipality: 'Wettringen',
    postalCode: '48493'
  },
  {
    municipality: 'Wettringen',
    postalCode: '91631'
  },
  {
    municipality: 'Wettrup',
    postalCode: '49838'
  },
  {
    municipality: 'Wettstetten',
    postalCode: '85139'
  },
  {
    municipality: 'Wetzlar',
    postalCode: '35576'
  },
  {
    municipality: 'Wetzlar',
    postalCode: '35578'
  },
  {
    municipality: 'Wetzlar',
    postalCode: '35579'
  },
  {
    municipality: 'Wetzlar',
    postalCode: '35580'
  },
  {
    municipality: 'Wetzlar',
    postalCode: '35581'
  },
  {
    municipality: 'Wetzlar',
    postalCode: '35582'
  },
  {
    municipality: 'Wetzlar',
    postalCode: '35583'
  },
  {
    municipality: 'Wetzlar',
    postalCode: '35584'
  },
  {
    municipality: 'Wetzlar',
    postalCode: '35585'
  },
  {
    municipality: 'Wetzlar',
    postalCode: '35586'
  },
  {
    municipality: 'Wewelsfleth',
    postalCode: '25599'
  },
  {
    municipality: 'Weyarn',
    postalCode: '83629'
  },
  {
    municipality: 'Weyer',
    postalCode: '56357'
  },
  {
    municipality: 'Weyerbusch',
    postalCode: '57635'
  },
  {
    municipality: 'Weyhausen',
    postalCode: '38554'
  },
  {
    municipality: 'Weyhe',
    postalCode: '28844'
  },
  {
    municipality: 'Weyher in der Pfalz',
    postalCode: '76835'
  },
  {
    municipality: 'Wichmar',
    postalCode: '07774'
  },
  {
    municipality: 'Wickede (Ruhr)',
    postalCode: '58739'
  },
  {
    municipality: 'Wickenrodt',
    postalCode: '55758'
  },
  {
    municipality: 'Widdern',
    postalCode: '74259'
  },
  {
    municipality: 'Wiebelsheim',
    postalCode: '56291'
  },
  {
    municipality: 'Wieck a. Darß',
    postalCode: '18375'
  },
  {
    municipality: 'Wied',
    postalCode: '57629'
  },
  {
    municipality: 'Wiedemar',
    postalCode: '04509'
  },
  {
    municipality: 'Wieden',
    postalCode: '79695'
  },
  {
    municipality: 'Wiedenborstel',
    postalCode: '24613'
  },
  {
    municipality: 'Wiedensahl',
    postalCode: '31719'
  },
  {
    municipality: 'Wiedergeltingen',
    postalCode: '86879'
  },
  {
    municipality: 'Wiefelstede',
    postalCode: '26215'
  },
  {
    municipality: 'Wiegendorf',
    postalCode: '99510'
  },
  {
    municipality: 'Wiehl',
    postalCode: '51674'
  },
  {
    municipality: 'Wiek',
    postalCode: '18556'
  },
  {
    municipality: 'Wielen',
    postalCode: '49847'
  },
  {
    municipality: 'Wielenbach',
    postalCode: '82407'
  },
  {
    municipality: 'Wiemersdorf',
    postalCode: '24649'
  },
  {
    municipality: 'Wiemerstedt',
    postalCode: '25779'
  },
  {
    municipality: 'Wiendorf',
    postalCode: '18258'
  },
  {
    municipality: 'Wienhausen',
    postalCode: '29342'
  },
  {
    municipality: 'Wiernsheim',
    postalCode: '75446'
  },
  {
    municipality: 'Wierschem',
    postalCode: '56294'
  },
  {
    municipality: 'Wiersdorf',
    postalCode: '54636'
  },
  {
    municipality: 'Wiershop',
    postalCode: '21502'
  },
  {
    municipality: 'Wiesau',
    postalCode: '95676'
  },
  {
    municipality: 'Wiesbach',
    postalCode: '66894'
  },
  {
    municipality: 'Wiesbaden',
    postalCode: '55246'
  },
  {
    municipality: 'Wiesbaden',
    postalCode: '55252'
  },
  {
    municipality: 'Wiesbaden',
    postalCode: '65183'
  },
  {
    municipality: 'Wiesbaden',
    postalCode: '65185'
  },
  {
    municipality: 'Wiesbaden',
    postalCode: '65187'
  },
  {
    municipality: 'Wiesbaden',
    postalCode: '65189'
  },
  {
    municipality: 'Wiesbaden',
    postalCode: '65191'
  },
  {
    municipality: 'Wiesbaden',
    postalCode: '65193'
  },
  {
    municipality: 'Wiesbaden',
    postalCode: '65195'
  },
  {
    municipality: 'Wiesbaden',
    postalCode: '65197'
  },
  {
    municipality: 'Wiesbaden',
    postalCode: '65199'
  },
  {
    municipality: 'Wiesbaden',
    postalCode: '65201'
  },
  {
    municipality: 'Wiesbaden',
    postalCode: '65203'
  },
  {
    municipality: 'Wiesbaden',
    postalCode: '65205'
  },
  {
    municipality: 'Wiesbaden',
    postalCode: '65207'
  },
  {
    municipality: 'Wiesbaum',
    postalCode: '54578'
  },
  {
    municipality: 'Wiesemscheid',
    postalCode: '53534'
  },
  {
    municipality: 'Wiesen',
    postalCode: '63831'
  },
  {
    municipality: 'Wiesenau',
    postalCode: '15295'
  },
  {
    municipality: 'Wiesenaue',
    postalCode: '14662'
  },
  {
    municipality: 'Wiesenbach',
    postalCode: '69257'
  },
  {
    municipality: 'Wiesenbach',
    postalCode: '86519'
  },
  {
    municipality: 'Wiesenbronn',
    postalCode: '97355'
  },
  {
    municipality: 'Wiesenburg/Mark',
    postalCode: '14827'
  },
  {
    municipality: 'Wiesenfeld',
    postalCode: '37308'
  },
  {
    municipality: 'Wiesenfelden',
    postalCode: '94344'
  },
  {
    municipality: 'Wiesengrund',
    postalCode: '03149'
  },
  {
    municipality: 'Wiesensteig',
    postalCode: '73349'
  },
  {
    municipality: 'Wiesent',
    postalCode: '93109'
  },
  {
    municipality: 'Wiesenthal',
    postalCode: '36466'
  },
  {
    municipality: 'Wiesenthau',
    postalCode: '91369'
  },
  {
    municipality: 'Wiesentheid',
    postalCode: '97353'
  },
  {
    municipality: 'Wiesenttal',
    postalCode: '91346'
  },
  {
    municipality: 'Wieseth',
    postalCode: '91632'
  },
  {
    municipality: 'Wiesloch',
    postalCode: '69168'
  },
  {
    municipality: 'Wiesmoor',
    postalCode: '26639'
  },
  {
    municipality: 'Wiesthal',
    postalCode: '97859'
  },
  {
    municipality: 'Wiesweiler',
    postalCode: '67744'
  },
  {
    municipality: 'Wietmarschen',
    postalCode: '49835'
  },
  {
    municipality: 'Wietze',
    postalCode: '29323'
  },
  {
    municipality: 'Wietzen',
    postalCode: '31613'
  },
  {
    municipality: 'Wietzendorf',
    postalCode: '29649'
  },
  {
    municipality: 'Wiggensbach',
    postalCode: '87487'
  },
  {
    municipality: 'Wilburgstetten',
    postalCode: '91634'
  },
  {
    municipality: 'Wildau',
    postalCode: '15745'
  },
  {
    municipality: 'Wildberg',
    postalCode: '72218'
  },
  {
    municipality: 'Wildberg',
    postalCode: '17091'
  },
  {
    municipality: 'Wildeck',
    postalCode: '36208'
  },
  {
    municipality: 'Wildenberg',
    postalCode: '93359'
  },
  {
    municipality: 'Wildenfels',
    postalCode: '08134'
  },
  {
    municipality: 'Wildeshausen',
    postalCode: '27793'
  },
  {
    municipality: 'Wildflecken',
    postalCode: '97772'
  },
  {
    municipality: 'Wildpoldsried',
    postalCode: '87499'
  },
  {
    municipality: 'Wildsteig',
    postalCode: '82409'
  },
  {
    municipality: 'Wilgartswiesen',
    postalCode: '76848'
  },
  {
    municipality: 'Wilhelmsburg',
    postalCode: '17379'
  },
  {
    municipality: 'Wilhelmsdorf',
    postalCode: '91489'
  },
  {
    municipality: 'Wilhelmsdorf',
    postalCode: '07389'
  },
  {
    municipality: 'Wilhelmsdorf',
    postalCode: '88271'
  },
  {
    municipality: 'Wilhelmsfeld',
    postalCode: '69259'
  },
  {
    municipality: 'Wilhelmshaven',
    postalCode: '26382'
  },
  {
    municipality: 'Wilhelmshaven',
    postalCode: '26384'
  },
  {
    municipality: 'Wilhelmshaven',
    postalCode: '26386'
  },
  {
    municipality: 'Wilhelmshaven',
    postalCode: '26388'
  },
  {
    municipality: 'Wilhelmshaven',
    postalCode: '26389'
  },
  {
    municipality: 'Wilhelmsthal',
    postalCode: '96352'
  },
  {
    municipality: 'Wilhermsdorf',
    postalCode: '91452'
  },
  {
    municipality: 'Wilkau-Haßlau',
    postalCode: '08112'
  },
  {
    municipality: 'Willanzheim',
    postalCode: '97348'
  },
  {
    municipality: 'Willebadessen',
    postalCode: '34439'
  },
  {
    municipality: 'Willenscharen',
    postalCode: '24616'
  },
  {
    municipality: 'Willich',
    postalCode: '47877'
  },
  {
    municipality: 'Willingen',
    postalCode: '56479'
  },
  {
    municipality: 'Willingen (Upland)',
    postalCode: '34508'
  },
  {
    municipality: 'Willingshausen',
    postalCode: '34628'
  },
  {
    municipality: 'Willmars',
    postalCode: '97647'
  },
  {
    municipality: 'Willmenrod',
    postalCode: '56459'
  },
  {
    municipality: 'Willmering',
    postalCode: '93497'
  },
  {
    municipality: 'Willroth',
    postalCode: '56594'
  },
  {
    municipality: 'Willstätt',
    postalCode: '77731'
  },
  {
    municipality: 'Willwerscheid',
    postalCode: '54533'
  },
  {
    municipality: 'Wilnsdorf',
    postalCode: '57234'
  },
  {
    municipality: 'Wilsdruff',
    postalCode: '01723'
  },
  {
    municipality: 'Wilsdruff',
    postalCode: '01737'
  },
  {
    municipality: 'Wilsecker',
    postalCode: '54655'
  },
  {
    municipality: 'Wilstedt',
    postalCode: '27412'
  },
  {
    municipality: 'Wilster',
    postalCode: '25554'
  },
  {
    municipality: 'Wilsum',
    postalCode: '49849'
  },
  {
    municipality: 'Wilthen',
    postalCode: '02681'
  },
  {
    municipality: 'Wiltingen',
    postalCode: '54459'
  },
  {
    municipality: 'Wilzenberg-Hußweiler',
    postalCode: '55767'
  },
  {
    municipality: 'Wimbach',
    postalCode: '53518'
  },
  {
    municipality: 'Wimmelburg',
    postalCode: '06313'
  },
  {
    municipality: 'Wimsheim',
    postalCode: '71299'
  },
  {
    municipality: 'Wincheringen',
    postalCode: '54457'
  },
  {
    municipality: 'Windach',
    postalCode: '86949'
  },
  {
    municipality: 'Windberg',
    postalCode: '94336'
  },
  {
    municipality: 'Windbergen',
    postalCode: '25729'
  },
  {
    municipality: 'Windeby',
    postalCode: '24340'
  },
  {
    municipality: 'Windeck',
    postalCode: '51570'
  },
  {
    municipality: 'Windelsbach',
    postalCode: '91635'
  },
  {
    municipality: 'Winden',
    postalCode: '56379'
  },
  {
    municipality: 'Winden',
    postalCode: '76872'
  },
  {
    municipality: 'Winden im Elztal',
    postalCode: '79297'
  },
  {
    municipality: 'Windesheim',
    postalCode: '55452'
  },
  {
    municipality: 'Windhagen',
    postalCode: '53578'
  },
  {
    municipality: 'Windischeschenbach',
    postalCode: '92670'
  },
  {
    municipality: 'Windischleuba',
    postalCode: '04603'
  },
  {
    municipality: 'Windorf',
    postalCode: '94575'
  },
  {
    municipality: 'Windsbach',
    postalCode: '91575'
  },
  {
    municipality: 'Wingerode',
    postalCode: '37327'
  },
  {
    municipality: 'Wingst',
    postalCode: '21789'
  },
  {
    municipality: 'Winhöring',
    postalCode: '84543'
  },
  {
    municipality: 'Winkelbach',
    postalCode: '57644'
  },
  {
    municipality: 'Winkel (Eifel)',
    postalCode: '54558'
  },
  {
    municipality: 'Winkelhaid',
    postalCode: '90610'
  },
  {
    municipality: 'Winkelsett',
    postalCode: '27243'
  },
  {
    municipality: 'Winklarn',
    postalCode: '92559'
  },
  {
    municipality: 'Winnemark',
    postalCode: '24398'
  },
  {
    municipality: 'Winnen',
    postalCode: '56459'
  },
  {
    municipality: 'Winnenden',
    postalCode: '71364'
  },
  {
    municipality: 'Winnerath',
    postalCode: '53520'
  },
  {
    municipality: 'Winnert',
    postalCode: '25887'
  },
  {
    municipality: 'Winnigstedt',
    postalCode: '38170'
  },
  {
    municipality: 'Winningen',
    postalCode: '56333'
  },
  {
    municipality: 'Winnweiler',
    postalCode: '67722'
  },
  {
    municipality: 'Winringen',
    postalCode: '54614'
  },
  {
    municipality: 'Winseldorf',
    postalCode: '25551'
  },
  {
    municipality: 'Winsen',
    postalCode: '24568'
  },
  {
    municipality: 'Winsen (Aller)',
    postalCode: '29229'
  },
  {
    municipality: 'Winsen (Aller)',
    postalCode: '29308'
  },
  {
    municipality: 'Winsen (Luhe)',
    postalCode: '21423'
  },
  {
    municipality: 'Winterbach',
    postalCode: '73650'
  },
  {
    municipality: 'Winterbach',
    postalCode: '89368'
  },
  {
    municipality: 'Winterbach',
    postalCode: '55595'
  },
  {
    municipality: 'Winterbach (Pfalz)',
    postalCode: '66484'
  },
  {
    municipality: 'Winterberg',
    postalCode: '59955'
  },
  {
    municipality: 'Winterborn',
    postalCode: '67822'
  },
  {
    municipality: 'Winterburg',
    postalCode: '55595'
  },
  {
    municipality: 'Winterhausen',
    postalCode: '97286'
  },
  {
    municipality: 'Winterlingen',
    postalCode: '72474'
  },
  {
    municipality: 'Winterrieden',
    postalCode: '87785'
  },
  {
    municipality: 'Winterscheid',
    postalCode: '54608'
  },
  {
    municipality: 'Wintersheim',
    postalCode: '67587'
  },
  {
    municipality: 'Winterspelt',
    postalCode: '54616'
  },
  {
    municipality: 'Winterwerb',
    postalCode: '56355'
  },
  {
    municipality: 'Wintrich',
    postalCode: '54487'
  },
  {
    municipality: 'Winzer',
    postalCode: '94577'
  },
  {
    municipality: 'Wipfeld',
    postalCode: '97537'
  },
  {
    municipality: 'Wipperfürth',
    postalCode: '51688'
  },
  {
    municipality: 'Wippingen',
    postalCode: '26892'
  },
  {
    municipality: 'Wirdum',
    postalCode: '26529'
  },
  {
    municipality: 'Wirft',
    postalCode: '53534'
  },
  {
    municipality: 'Wirfus',
    postalCode: '56814'
  },
  {
    municipality: 'Wirges',
    postalCode: '56422'
  },
  {
    municipality: 'Wirsberg',
    postalCode: '95339'
  },
  {
    municipality: 'Wirscheid',
    postalCode: '56237'
  },
  {
    municipality: 'Wirschweiler',
    postalCode: '55758'
  },
  {
    municipality: 'Wisch',
    postalCode: '24217'
  },
  {
    municipality: 'Wisch',
    postalCode: '25876'
  },
  {
    municipality: 'Wischhafen',
    postalCode: '21737'
  },
  {
    municipality: 'Wismar',
    postalCode: '23966'
  },
  {
    municipality: 'Wismar',
    postalCode: '23968'
  },
  {
    municipality: 'Wismar',
    postalCode: '23970'
  },
  {
    municipality: 'Wissen',
    postalCode: '57537'
  },
  {
    municipality: 'Wißmannsdorf',
    postalCode: '54636'
  },
  {
    municipality: 'Wistedt',
    postalCode: '21255'
  },
  {
    municipality: 'Witsum',
    postalCode: '25938'
  },
  {
    municipality: 'Wittbek',
    postalCode: '25872'
  },
  {
    municipality: 'Wittdün auf Amrum',
    postalCode: '25946'
  },
  {
    municipality: 'Wittelshofen',
    postalCode: '91749'
  },
  {
    municipality: 'Witten',
    postalCode: '58452'
  },
  {
    municipality: 'Witten',
    postalCode: '58453'
  },
  {
    municipality: 'Witten',
    postalCode: '58454'
  },
  {
    municipality: 'Witten',
    postalCode: '58455'
  },
  {
    municipality: 'Witten',
    postalCode: '58456'
  },
  {
    municipality: 'Wittenbeck',
    postalCode: '18209'
  },
  {
    municipality: 'Wittenberg',
    postalCode: '06886'
  },
  {
    municipality: 'Wittenberg',
    postalCode: '06888'
  },
  {
    municipality: 'Wittenberg',
    postalCode: '06889'
  },
  {
    municipality: 'Wittenberge',
    postalCode: '19322'
  },
  {
    municipality: 'Wittenbergen',
    postalCode: '25548'
  },
  {
    municipality: 'Wittenborn',
    postalCode: '23829'
  },
  {
    municipality: 'Wittenburg',
    postalCode: '19243'
  },
  {
    municipality: 'Wittendörp',
    postalCode: '19243'
  },
  {
    municipality: 'Wittenförden',
    postalCode: '19073'
  },
  {
    municipality: 'Wittenhagen',
    postalCode: '18510'
  },
  {
    municipality: 'Witterda',
    postalCode: '99189'
  },
  {
    municipality: 'Wittgert',
    postalCode: '56237'
  },
  {
    municipality: 'Wittibreut',
    postalCode: '84384'
  },
  {
    municipality: 'Wittichenau - Kulow',
    postalCode: '02997'
  },
  {
    municipality: 'Wittighausen',
    postalCode: '97957'
  },
  {
    municipality: 'Wittingen',
    postalCode: '29378'
  },
  {
    municipality: 'Wittingen',
    postalCode: '29379'
  },
  {
    municipality: 'Wittislingen',
    postalCode: '89426'
  },
  {
    municipality: 'Wittlich',
    postalCode: '54516'
  },
  {
    municipality: 'Wittlingen',
    postalCode: '79599'
  },
  {
    municipality: 'Wittmar',
    postalCode: '38329'
  },
  {
    municipality: 'Wittmoldt',
    postalCode: '24306'
  },
  {
    municipality: 'Wittmund',
    postalCode: '26409'
  },
  {
    municipality: 'Wittnau',
    postalCode: '79299'
  },
  {
    municipality: 'Wittorf',
    postalCode: '21357'
  },
  {
    municipality: 'Wittstock/Dosse',
    postalCode: '16909'
  },
  {
    municipality: 'Witzeeze',
    postalCode: '21514'
  },
  {
    municipality: 'Witzenhausen',
    postalCode: '37213'
  },
  {
    municipality: 'Witzenhausen',
    postalCode: '37214'
  },
  {
    municipality: 'Witzenhausen',
    postalCode: '37215'
  },
  {
    municipality: 'Witzenhausen',
    postalCode: '37216'
  },
  {
    municipality: 'Witzenhausen',
    postalCode: '37217'
  },
  {
    municipality: 'Witzenhausen',
    postalCode: '37218'
  },
  {
    municipality: 'Witzhave',
    postalCode: '22969'
  },
  {
    municipality: 'Witzin',
    postalCode: '19406'
  },
  {
    municipality: 'Witzleben',
    postalCode: '99310'
  },
  {
    municipality: 'Witzmannsberg',
    postalCode: '94104'
  },
  {
    municipality: 'Witzwort',
    postalCode: '25889'
  },
  {
    municipality: 'Wöbbelin',
    postalCode: '19288'
  },
  {
    municipality: 'Wobbenbüll',
    postalCode: '25856'
  },
  {
    municipality: 'Woggersin',
    postalCode: '17039'
  },
  {
    municipality: 'Wohlde',
    postalCode: '24899'
  },
  {
    municipality: 'Wohltorf',
    postalCode: '21521'
  },
  {
    municipality: 'Wohnste',
    postalCode: '27419'
  },
  {
    municipality: 'Wohratal',
    postalCode: '35288'
  },
  {
    municipality: 'Wöhrden',
    postalCode: '25797'
  },
  {
    municipality: 'Wokuhl-Dabelow',
    postalCode: '17237'
  },
  {
    municipality: 'Wolde',
    postalCode: '17091'
  },
  {
    municipality: 'Woldegk',
    postalCode: '17348'
  },
  {
    municipality: 'Woldert',
    postalCode: '57614'
  },
  {
    municipality: 'Wolfach',
    postalCode: '77709'
  },
  {
    municipality: 'Wolfegg',
    postalCode: '88364'
  },
  {
    municipality: 'Wolfenbüttel',
    postalCode: '38300'
  },
  {
    municipality: 'Wolfenbüttel',
    postalCode: '38302'
  },
  {
    municipality: 'Wolfenbüttel',
    postalCode: '38304'
  },
  {
    municipality: 'Wölferlingen',
    postalCode: '56244'
  },
  {
    municipality: 'Wolfersdorf',
    postalCode: '85395'
  },
  {
    municipality: 'Wölfersheim',
    postalCode: '61200'
  },
  {
    municipality: 'Wolferstadt',
    postalCode: '86709'
  },
  {
    municipality: 'Wolfertschwenden',
    postalCode: '87787'
  },
  {
    municipality: 'Wolfhagen',
    postalCode: '34466'
  },
  {
    municipality: 'Wolframs-Eschenbach',
    postalCode: '91639'
  },
  {
    municipality: 'Wolfratshausen',
    postalCode: '82515'
  },
  {
    municipality: 'Wolfsburg',
    postalCode: '38440'
  },
  {
    municipality: 'Wolfsburg',
    postalCode: '38442'
  },
  {
    municipality: 'Wolfsburg',
    postalCode: '38444'
  },
  {
    municipality: 'Wolfsburg',
    postalCode: '38446'
  },
  {
    municipality: 'Wolfsburg',
    postalCode: '38448'
  },
  {
    municipality: 'Wolfschlugen',
    postalCode: '72649'
  },
  {
    municipality: 'Wolfsegg',
    postalCode: '93195'
  },
  {
    municipality: 'Wolfsheim',
    postalCode: '55578'
  },
  {
    municipality: 'Wolfstein',
    postalCode: '67752'
  },
  {
    municipality: 'Wolgast',
    postalCode: '17438'
  },
  {
    municipality: 'Wolken',
    postalCode: '56332'
  },
  {
    municipality: 'Wolkenstein',
    postalCode: '09429'
  },
  {
    municipality: 'Wollbach',
    postalCode: '97618'
  },
  {
    municipality: 'Wollbrandshausen',
    postalCode: '37434'
  },
  {
    municipality: 'Wollershausen',
    postalCode: '37434'
  },
  {
    municipality: 'Wollin',
    postalCode: '14778'
  },
  {
    municipality: 'Wollmerath',
    postalCode: '56826'
  },
  {
    municipality: 'Wöllstadt',
    postalCode: '61206'
  },
  {
    municipality: 'Wöllstein',
    postalCode: '55597'
  },
  {
    municipality: 'Wolmersdorf',
    postalCode: '25704'
  },
  {
    municipality: 'Wölmersen',
    postalCode: '57635'
  },
  {
    municipality: 'Wolmirsleben',
    postalCode: '39435'
  },
  {
    municipality: 'Wolmirstedt',
    postalCode: '39326'
  },
  {
    municipality: 'Wolnzach',
    postalCode: '85283'
  },
  {
    municipality: 'Wolpertshausen',
    postalCode: '74549'
  },
  {
    municipality: 'Wolpertswende',
    postalCode: '88284'
  },
  {
    municipality: 'Wölpinghausen',
    postalCode: '31556'
  },
  {
    municipality: 'Wolsdorf',
    postalCode: '38379'
  },
  {
    municipality: 'Wolsfeld',
    postalCode: '54636'
  },
  {
    municipality: 'Woltersdorf',
    postalCode: '15569'
  },
  {
    municipality: 'Woltersdorf',
    postalCode: '21516'
  },
  {
    municipality: 'Woltersdorf',
    postalCode: '29497'
  },
  {
    municipality: 'Womrath',
    postalCode: '55481'
  },
  {
    municipality: 'Wonfurt',
    postalCode: '97539'
  },
  {
    municipality: 'Wonneberg',
    postalCode: '83379'
  },
  {
    municipality: 'Wonsees',
    postalCode: '96197'
  },
  {
    municipality: 'Wonsheim',
    postalCode: '55599'
  },
  {
    municipality: 'Woppenroth',
    postalCode: '55490'
  },
  {
    municipality: 'Woringen',
    postalCode: '87789'
  },
  {
    municipality: 'Worms',
    postalCode: '67547'
  },
  {
    municipality: 'Worms',
    postalCode: '67549'
  },
  {
    municipality: 'Worms',
    postalCode: '67550'
  },
  {
    municipality: 'Worms',
    postalCode: '67551'
  },
  {
    municipality: 'Wörnersberg',
    postalCode: '72299'
  },
  {
    municipality: 'Wörnitz',
    postalCode: '91637'
  },
  {
    municipality: 'Worpswede',
    postalCode: '27726'
  },
  {
    municipality: 'Wörrstadt',
    postalCode: '55286'
  },
  {
    municipality: 'Wört',
    postalCode: '73499'
  },
  {
    municipality: 'Worth',
    postalCode: '21502'
  },
  {
    municipality: 'Wörth',
    postalCode: '85457'
  },
  {
    municipality: 'Wörth a.d. Isar',
    postalCode: '84109'
  },
  {
    municipality: 'Wörth am Main',
    postalCode: '63939'
  },
  {
    municipality: 'Wörth am Rhein',
    postalCode: '76744'
  },
  {
    municipality: 'Wörth an der Donau',
    postalCode: '93086'
  },
  {
    municipality: 'Wörthsee',
    postalCode: '82237'
  },
  {
    municipality: 'Wrangelsburg',
    postalCode: '17495'
  },
  {
    municipality: 'Wrestedt',
    postalCode: '29559'
  },
  {
    municipality: 'Wriedel',
    postalCode: '29565'
  },
  {
    municipality: 'Wriezen',
    postalCode: '16269'
  },
  {
    municipality: 'Wrist',
    postalCode: '25563'
  },
  {
    municipality: 'Wrixum',
    postalCode: '25938'
  },
  {
    municipality: 'Wrohm',
    postalCode: '25799'
  },
  {
    municipality: 'Wülfershausen an der Saale',
    postalCode: '97618'
  },
  {
    municipality: 'Wülfrath',
    postalCode: '42489'
  },
  {
    municipality: 'Wulfsen',
    postalCode: '21445'
  },
  {
    municipality: 'Wulfsmoor',
    postalCode: '25563'
  },
  {
    municipality: 'Wulften am Harz',
    postalCode: '37199'
  },
  {
    municipality: 'Wulkenzin',
    postalCode: '17039'
  },
  {
    municipality: 'Wülknitz',
    postalCode: '01609'
  },
  {
    municipality: 'Wundersleben',
    postalCode: '99610'
  },
  {
    municipality: 'Wünschendorf/Elster',
    postalCode: '07570'
  },
  {
    municipality: 'Wunsiedel',
    postalCode: '95632'
  },
  {
    municipality: 'Wunstorf',
    postalCode: '31515'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42103'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42105'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42107'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42109'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42111'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42113'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42115'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42117'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42119'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42275'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42277'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42279'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42281'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42283'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42285'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42287'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42289'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42327'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42329'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42349'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42369'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42389'
  },
  {
    municipality: 'Wuppertal',
    postalCode: '42399'
  },
  {
    municipality: 'Wurmannsquick',
    postalCode: '84329'
  },
  {
    municipality: 'Wurmberg',
    postalCode: '75449'
  },
  {
    municipality: 'Wurmlingen',
    postalCode: '78573'
  },
  {
    municipality: 'Wurmsham',
    postalCode: '84189'
  },
  {
    municipality: 'Würrich',
    postalCode: '56858'
  },
  {
    municipality: 'Würselen',
    postalCode: '52146'
  },
  {
    municipality: 'Wurster Nordseeküste',
    postalCode: '27639'
  },
  {
    municipality: 'Wurzbach',
    postalCode: '07343'
  },
  {
    municipality: 'Würzburg',
    postalCode: '97070'
  },
  {
    municipality: 'Würzburg',
    postalCode: '97072'
  },
  {
    municipality: 'Würzburg',
    postalCode: '97074'
  },
  {
    municipality: 'Würzburg',
    postalCode: '97076'
  },
  {
    municipality: 'Würzburg',
    postalCode: '97078'
  },
  {
    municipality: 'Würzburg',
    postalCode: '97080'
  },
  {
    municipality: 'Würzburg',
    postalCode: '97082'
  },
  {
    municipality: 'Würzburg',
    postalCode: '97084'
  },
  {
    municipality: 'Wurzen',
    postalCode: '04808'
  },
  {
    municipality: 'Würzweiler',
    postalCode: '67808'
  },
  {
    municipality: 'Wüschheim',
    postalCode: '55471'
  },
  {
    municipality: 'Wüstenrot',
    postalCode: '71543'
  },
  {
    municipality: 'Wusterhausen/Dosse',
    postalCode: '16845'
  },
  {
    municipality: 'Wusterhausen/Dosse',
    postalCode: '16866'
  },
  {
    municipality: 'Wusterhausen/Dosse',
    postalCode: '16868'
  },
  {
    municipality: 'Wusterhusen',
    postalCode: '17509'
  },
  {
    municipality: 'Wustermark',
    postalCode: '14641'
  },
  {
    municipality: 'Wusterwitz',
    postalCode: '14789'
  },
  {
    municipality: 'Wust-Fischbeck',
    postalCode: '39524'
  },
  {
    municipality: 'Wüstheuterode',
    postalCode: '37318'
  },
  {
    municipality: 'Wustrow',
    postalCode: '18347'
  },
  {
    municipality: 'Wustrow',
    postalCode: '17255'
  },
  {
    municipality: 'Wustrow',
    postalCode: '29462'
  },
  {
    municipality: 'Wutach',
    postalCode: '79879'
  },
  {
    municipality: 'Wutha-Farnroda',
    postalCode: '99848'
  },
  {
    municipality: 'Wutöschingen',
    postalCode: '79793'
  },
  {
    municipality: 'Wyhl',
    postalCode: '79369'
  },
  {
    municipality: 'Wyk auf Föhr',
    postalCode: '25938'
  },
  {
    municipality: 'Xanten',
    postalCode: '46509'
  },
  {
    municipality: 'Zaberfeld',
    postalCode: '74374'
  },
  {
    municipality: 'Zachenberg',
    postalCode: '94239'
  },
  {
    municipality: 'Zahna-Elster',
    postalCode: '06895'
  },
  {
    municipality: 'Zaisenhausen',
    postalCode: '75059'
  },
  {
    municipality: 'Zandt',
    postalCode: '93499'
  },
  {
    municipality: 'Zangberg',
    postalCode: '84539'
  },
  {
    municipality: 'Zapel',
    postalCode: '19089'
  },
  {
    municipality: 'Zapfendorf',
    postalCode: '96199'
  },
  {
    municipality: 'Zarnewanz',
    postalCode: '18195'
  },
  {
    municipality: 'Zarpen',
    postalCode: '23619'
  },
  {
    municipality: 'Zarrendorf',
    postalCode: '18510'
  },
  {
    municipality: 'Zarrentin am Schaalsee',
    postalCode: '19246'
  },
  {
    municipality: 'Zechin',
    postalCode: '15328'
  },
  {
    municipality: 'Zedlitz',
    postalCode: '07557'
  },
  {
    municipality: 'Zehdenick',
    postalCode: '16792'
  },
  {
    municipality: 'Zehna',
    postalCode: '18276'
  },
  {
    municipality: 'Zehnhausen bei Rennerod',
    postalCode: '56477'
  },
  {
    municipality: 'Zehnhausen bei Wallmerod',
    postalCode: '56414'
  },
  {
    municipality: 'Zehrental',
    postalCode: '39615'
  },
  {
    municipality: 'Zeil am Main',
    postalCode: '97475'
  },
  {
    municipality: 'Zeilarn',
    postalCode: '84367'
  },
  {
    municipality: 'Zeiskam',
    postalCode: '67378'
  },
  {
    municipality: 'Zeithain',
    postalCode: '01619'
  },
  {
    municipality: 'Zeitlarn',
    postalCode: '93197'
  },
  {
    municipality: 'Zeitlofs',
    postalCode: '97799'
  },
  {
    municipality: 'Zeitz',
    postalCode: '06711'
  },
  {
    municipality: 'Zeitz',
    postalCode: '06712'
  },
  {
    municipality: 'Zell',
    postalCode: '93199'
  },
  {
    municipality: 'Zella-Mehlis',
    postalCode: '98544'
  },
  {
    municipality: 'Zell am Harmersbach',
    postalCode: '77736'
  },
  {
    municipality: 'Zell am Main',
    postalCode: '97299'
  },
  {
    municipality: 'Zellertal',
    postalCode: '67308'
  },
  {
    municipality: 'Zell im Fichtelgebirge',
    postalCode: '95239'
  },
  {
    municipality: 'Zell im Wiesental',
    postalCode: '79669'
  },
  {
    municipality: 'Zellingen',
    postalCode: '97225'
  },
  {
    municipality: 'Zell (Mosel)',
    postalCode: '56856'
  },
  {
    municipality: 'Zell (Mosel)',
    postalCode: '56858'
  },
  {
    municipality: 'Zell (Mosel)',
    postalCode: '56859'
  },
  {
    municipality: 'Zell unter Aichelberg',
    postalCode: '73087'
  },
  {
    municipality: 'Zell unter Aichelberg',
    postalCode: '73119'
  },
  {
    municipality: 'Zeltingen-Rachtig',
    postalCode: '54492'
  },
  {
    municipality: 'Zeltingen-Rachtig',
    postalCode: '54539'
  },
  {
    municipality: 'Zemitz',
    postalCode: '17440'
  },
  {
    municipality: 'Zemmer',
    postalCode: '54313'
  },
  {
    municipality: 'Zempin',
    postalCode: '17459'
  },
  {
    municipality: 'Zendscheid',
    postalCode: '54655'
  },
  {
    municipality: 'Zenting',
    postalCode: '94579'
  },
  {
    municipality: 'Zepelin',
    postalCode: '18246'
  },
  {
    municipality: 'Zerbst/Anhalt',
    postalCode: '39261'
  },
  {
    municipality: 'Zerbst/Anhalt',
    postalCode: '39264'
  },
  {
    municipality: 'Zerf',
    postalCode: '54314'
  },
  {
    municipality: 'Zernien',
    postalCode: '29499'
  },
  {
    municipality: 'Zernitz-Lohm',
    postalCode: '16845'
  },
  {
    municipality: 'Zerrenthin',
    postalCode: '17309'
  },
  {
    municipality: 'Zeschdorf',
    postalCode: '15326'
  },
  {
    municipality: 'Zetel',
    postalCode: '26340'
  },
  {
    municipality: 'Zettemin',
    postalCode: '17153'
  },
  {
    municipality: 'Zettingen',
    postalCode: '56761'
  },
  {
    municipality: 'Zettlitz',
    postalCode: '09306'
  },
  {
    municipality: 'Zeulenroda-Triebes',
    postalCode: '07937'
  },
  {
    municipality: 'Zeulenroda-Triebes',
    postalCode: '07950'
  },
  {
    municipality: 'Zeuthen',
    postalCode: '15738'
  },
  {
    municipality: 'Zeven',
    postalCode: '27404'
  },
  {
    municipality: 'Zichow',
    postalCode: '16306'
  },
  {
    municipality: 'Zickhusen',
    postalCode: '19069'
  },
  {
    municipality: 'Ziegendorf',
    postalCode: '19372'
  },
  {
    municipality: 'Ziegenhain',
    postalCode: '57632'
  },
  {
    municipality: 'Ziegenrück',
    postalCode: '07924'
  },
  {
    municipality: 'Zielitz',
    postalCode: '39326'
  },
  {
    municipality: 'Ziemetshausen',
    postalCode: '86473'
  },
  {
    municipality: 'Zierenberg',
    postalCode: '34289'
  },
  {
    municipality: 'Zierow',
    postalCode: '23968'
  },
  {
    municipality: 'Ziertheim',
    postalCode: '89446'
  },
  {
    municipality: 'Zierzow',
    postalCode: '19300'
  },
  {
    municipality: 'Ziesar',
    postalCode: '14793'
  },
  {
    municipality: 'Ziesendorf',
    postalCode: '18059'
  },
  {
    municipality: 'Ziethen',
    postalCode: '16247'
  },
  {
    municipality: 'Ziethen',
    postalCode: '17390'
  },
  {
    municipality: 'Ziethen',
    postalCode: '23911'
  },
  {
    municipality: 'Zilshausen',
    postalCode: '56288'
  },
  {
    municipality: 'Ziltendorf',
    postalCode: '15295'
  },
  {
    municipality: 'Zimmern',
    postalCode: '07778'
  },
  {
    municipality: 'Zimmern ob Rottweil',
    postalCode: '78652'
  },
  {
    municipality: 'Zimmern ob Rottweil',
    postalCode: '78658'
  },
  {
    municipality: 'Zimmernsupra',
    postalCode: '99100'
  },
  {
    municipality: 'Zimmern unter der Burg',
    postalCode: '72369'
  },
  {
    municipality: 'Zimmerschied',
    postalCode: '56379'
  },
  {
    municipality: 'Zingst',
    postalCode: '18374'
  },
  {
    municipality: 'Zinnowitz',
    postalCode: '17454'
  },
  {
    municipality: 'Zirchow',
    postalCode: '17419'
  },
  {
    municipality: 'Zirkow',
    postalCode: '18528'
  },
  {
    municipality: 'Zirndorf',
    postalCode: '90513'
  },
  {
    municipality: 'Zirzow',
    postalCode: '17039'
  },
  {
    municipality: 'Zislow',
    postalCode: '17209'
  },
  {
    municipality: 'Zittau',
    postalCode: '02763'
  },
  {
    municipality: 'Zittau',
    postalCode: '02788'
  },
  {
    municipality: 'Zölkow',
    postalCode: '19374'
  },
  {
    municipality: 'Zolling',
    postalCode: '85406'
  },
  {
    municipality: 'Zöllnitz',
    postalCode: '07751'
  },
  {
    municipality: 'Zörbig',
    postalCode: '06780'
  },
  {
    municipality: 'Zorneding',
    postalCode: '85604'
  },
  {
    municipality: 'Zornheim',
    postalCode: '55270'
  },
  {
    municipality: 'Zöschingen',
    postalCode: '89447'
  },
  {
    municipality: 'Zossen',
    postalCode: '15806'
  },
  {
    municipality: 'Zotzenheim',
    postalCode: '55576'
  },
  {
    municipality: 'Zschaitz-Ottewig',
    postalCode: '04720'
  },
  {
    municipality: 'Zschepplin',
    postalCode: '04838'
  },
  {
    municipality: 'Zschopau',
    postalCode: '09405'
  },
  {
    municipality: 'Zschopau',
    postalCode: '09434'
  },
  {
    municipality: 'Zschorlau',
    postalCode: '08321'
  },
  {
    municipality: 'Zülow',
    postalCode: '19073'
  },
  {
    municipality: 'Zülpich',
    postalCode: '53909'
  },
  {
    municipality: 'Zurow',
    postalCode: '23992'
  },
  {
    municipality: 'Zusamaltheim',
    postalCode: '86637'
  },
  {
    municipality: 'Züsch',
    postalCode: '54422'
  },
  {
    municipality: 'Zusmarshausen',
    postalCode: '86441'
  },
  {
    municipality: 'Züsow',
    postalCode: '23992'
  },
  {
    municipality: 'Züssow',
    postalCode: '17495'
  },
  {
    municipality: 'Zuzenhausen',
    postalCode: '74939'
  },
  {
    municipality: 'Zweibrücken',
    postalCode: '66482'
  },
  {
    municipality: 'Zweifelscheid',
    postalCode: '54673'
  },
  {
    municipality: 'Zweiflingen',
    postalCode: '74639'
  },
  {
    municipality: 'Zwenkau',
    postalCode: '04442'
  },
  {
    municipality: 'Zwickau',
    postalCode: '08056'
  },
  {
    municipality: 'Zwickau',
    postalCode: '08058'
  },
  {
    municipality: 'Zwickau',
    postalCode: '08060'
  },
  {
    municipality: 'Zwickau',
    postalCode: '08062'
  },
  {
    municipality: 'Zwickau',
    postalCode: '08064'
  },
  {
    municipality: 'Zwickau',
    postalCode: '08066'
  },
  {
    municipality: 'Zwiefalten',
    postalCode: '88529'
  },
  {
    municipality: 'Zwiesel',
    postalCode: '94227'
  },
  {
    municipality: 'Zwingenberg',
    postalCode: '69439'
  },
  {
    municipality: 'Zwingenberg',
    postalCode: '64673'
  },
  {
    municipality: 'Zwönitz',
    postalCode: '08297'
  }
];
